
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireae23"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireae23"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ecd4d", function(module, exports) {

$parcel$export(module.exports, "compile", () => $a55c527d369bf9c1$export$ef7acd7185315e22);
/**
* vue v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ parcelRequire("eeJ70");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{};
$parcel$exportWildcard(module.exports, $eeJ70);

});
parcelRegister("eeJ70", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $a5d55dc64ccb07cf$export$be58926105124dd4);
$parcel$export(module.exports, "vShow", () => $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "useCssVars", () => $a5d55dc64ccb07cf$export$ef28b76f07940108);
$parcel$export(module.exports, "defineCustomElement", () => $a5d55dc64ccb07cf$export$a00e2346eabbdbef);
$parcel$export(module.exports, "VueElement", () => $a5d55dc64ccb07cf$export$b337c1a55163dbe3);
$parcel$export(module.exports, "defineSSRCustomElement", () => $a5d55dc64ccb07cf$export$6debb2e68f212638);
$parcel$export(module.exports, "hydrate", () => $a5d55dc64ccb07cf$export$fa8d919ba61d84db);
$parcel$export(module.exports, "render", () => $a5d55dc64ccb07cf$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "useCssModule", () => $a5d55dc64ccb07cf$export$9300d5b90d56e3d1);
$parcel$export(module.exports, "TransitionGroup", () => $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelCheckbox", () => $a5d55dc64ccb07cf$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelRadio", () => $a5d55dc64ccb07cf$export$b4356c59b38b7aa9);
$parcel$export(module.exports, "vModelSelect", () => $a5d55dc64ccb07cf$export$87d227567b51ca39);
$parcel$export(module.exports, "vModelDynamic", () => $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5);
$parcel$export(module.exports, "withModifiers", () => $a5d55dc64ccb07cf$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $a5d55dc64ccb07cf$export$f691a8759658f782);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
$parcel$export(module.exports, "createSSRApp", () => $a5d55dc64ccb07cf$export$35800275c0037383);
$parcel$export(module.exports, "initDirectivesForSSR", () => $a5d55dc64ccb07cf$export$800b28255aa678d9);
/**
* @vue/runtime-dom v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
var $01W3b = parcelRequire("01W3b");

var $4YcVI = parcelRequire("4YcVI");
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : namespace === "mathml" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$mathmlNS, tag) : $a5d55dc64ccb07cf$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content;
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = Symbol("_vtc");
const $a5d55dc64ccb07cf$export$be58926105124dd4 = (props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots);
$a5d55dc64ccb07cf$export$be58926105124dd4.displayName = "Transition";
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = $a5d55dc64ccb07cf$export$be58926105124dd4.props = /* @__PURE__ */ (0, $4YcVI.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $4YcVI.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $4YcVI.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $4YcVI.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            $a5d55dc64ccb07cf$var$forceReflow();
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $4YcVI.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $4YcVI.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow() {
    return document.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOriginalDisplay = Symbol("_vod");
const $a5d55dc64ccb07cf$var$vShowHidden = Symbol("_vsh");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] : "none";
    el[$a5d55dc64ccb07cf$var$vShowHidden] = !value;
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$CSS_VAR_TEXT = Symbol("");
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watchPostEffect)(setVars);
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT] = cssText;
    }
}
const $a5d55dc64ccb07cf$var$displayRE = /(^|;)\s*display\s*:/;
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $4YcVI.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $4YcVI.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $a5d55dc64ccb07cf$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $a5d55dc64ccb07cf$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($a5d55dc64ccb07cf$var$vShowOriginalDisplay in el) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$a5d55dc64ccb07cf$var$vShowHidden]) style.display = "none";
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $4YcVI.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $4YcVI.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8XWQX.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $4YcVI.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $4YcVI.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $4YcVI.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $4YcVI.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    if ($a5d55dc64ccb07cf$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $4YcVI.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $TusQn.callWithAsyncErrorHandling)($a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$sanitizeEventValue(value, propName) {
    if ((0, $4YcVI.isFunction)(value) || (0, $4YcVI.isArray)(value)) return value;
    (0, $TusQn.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $4YcVI.NOOP;
}
function $a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, value) {
    if ((0, $4YcVI.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $a5d55dc64ccb07cf$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $a5d55dc64ccb07cf$var$patchProp = (el, key, prevValue, nextValue, namespace, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $4YcVI.isOn)(key)) {
        if (!(0, $4YcVI.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $4YcVI.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $4YcVI.isString)(value)) return false;
    return key in el;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $TusQn.defineComponent)(options);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, $a5d55dc64ccb07cf$export$fa8d919ba61d84db);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._ob = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        if (this._ob) {
            this._ob.disconnect();
            this._ob = null;
        }
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $4YcVI.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $4YcVI.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $4YcVI.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $4YcVI.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $4YcVI.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.hasAttribute(key) ? this.getAttribute(key) : void 0;
        const camelKey = (0, $4YcVI.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $4YcVI.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $4YcVI.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $4YcVI.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $4YcVI.hyphenate)(key));
            }
        }
    }
    _update() {
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $4YcVI.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $4YcVI.hyphenate)(event) !== event) dispatch((0, $4YcVI.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $4YcVI.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $4YcVI.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $4YcVI.EMPTY_OBJ;
        return mod;
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $4YcVI.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $a5d55dc64ccb07cf$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
};
const $a5d55dc64ccb07cf$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $a5d55dc64ccb07cf$var$removeMode($a5d55dc64ccb07cf$var$TransitionGroupImpl.props);
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $4YcVI.isArray)(fn) ? (value)=>(0, $4YcVI.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = Symbol("_assign");
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $4YcVI.looseToNumber)(domValue);
            el[$a5d55dc64ccb07cf$var$assignKey](domValue);
        });
        if (trim) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $4YcVI.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $4YcVI.isArray)(modelValue)) {
                const index = (0, $4YcVI.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $4YcVI.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $4YcVI.isArray)(value)) el.checked = (0, $4YcVI.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $4YcVI.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $4YcVI.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $4YcVI.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $4YcVI.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $4YcVI.isSet)(value);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $4YcVI.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el[$a5d55dc64ccb07cf$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $TusQn.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value, modifiers: { number: number } }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value, modifiers: { number: number } }) {
        if (!el._assigning) $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value, number) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $4YcVI.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $4YcVI.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $4YcVI.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $4YcVI.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $4YcVI.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $4YcVI.isArray)(value)) {
            if (vnode.props && (0, $4YcVI.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $4YcVI.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $4YcVI.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $4YcVI.extend)({
    patchProp: $a5d55dc64ccb07cf$var$patchProp
}, $a5d55dc64ccb07cf$var$nodeOps);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $4YcVI.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
    };
    return app;
};
function $a5d55dc64ccb07cf$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $4YcVI.isHTMLTag)(tag) || (0, $4YcVI.isSVGTag)(tag) || (0, $4YcVI.isMathMLTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $4YcVI.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};
$parcel$exportWildcard(module.exports, $TusQn);

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "callWithErrorHandling", () => $0a6cc4ba868319ae$export$b22fcaf88446e9bf);
$parcel$export(module.exports, "assertNumber", () => $0a6cc4ba868319ae$export$dfbcecb440255e4a);
$parcel$export(module.exports, "ErrorCodes", () => $0a6cc4ba868319ae$export$10e8e1cf990558d7);
$parcel$export(module.exports, "handleError", () => $0a6cc4ba868319ae$export$d3da1ecaf1206c58);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $0a6cc4ba868319ae$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Text", () => $0a6cc4ba868319ae$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Comment", () => $0a6cc4ba868319ae$export$4d299b491347818a);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "pushScopeId", () => $0a6cc4ba868319ae$export$ac020265ca2cc4cd);
$parcel$export(module.exports, "popScopeId", () => $0a6cc4ba868319ae$export$f2dc6805dc11834e);
$parcel$export(module.exports, "withScopeId", () => $0a6cc4ba868319ae$export$15ba313e13f3dd04);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "setBlockTracking", () => $0a6cc4ba868319ae$export$c20bee82f26f1e27);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "cloneVNode", () => $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a);
$parcel$export(module.exports, "isVNode", () => $0a6cc4ba868319ae$export$3868d13f8734ae81);
$parcel$export(module.exports, "resolveComponent", () => $0a6cc4ba868319ae$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $0a6cc4ba868319ae$export$b44c564a05ca975);
$parcel$export(module.exports, "resolveDirective", () => $0a6cc4ba868319ae$export$a1989e995cd481be);
$parcel$export(module.exports, "Suspense", () => $0a6cc4ba868319ae$export$74bf444e3cd11ea5);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "ssrContextKey", () => $0a6cc4ba868319ae$export$f2549a27e18acf2d);
$parcel$export(module.exports, "useSSRContext", () => $0a6cc4ba868319ae$export$6b1c54dc4befcda);
$parcel$export(module.exports, "inject", () => $0a6cc4ba868319ae$export$a976684a0efeb93f);
$parcel$export(module.exports, "watchEffect", () => $0a6cc4ba868319ae$export$ede35fc0e5500309);
$parcel$export(module.exports, "watchPostEffect", () => $0a6cc4ba868319ae$export$b7f27ea67102d543);
$parcel$export(module.exports, "watchSyncEffect", () => $0a6cc4ba868319ae$export$2035654f31b0e555);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $0a6cc4ba868319ae$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "defineAsyncComponent", () => $0a6cc4ba868319ae$export$d75d499b4c16cf21);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "KeepAlive", () => $0a6cc4ba868319ae$export$70eb8a58709972df);
$parcel$export(module.exports, "onActivated", () => $0a6cc4ba868319ae$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $0a6cc4ba868319ae$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeMount", () => $0a6cc4ba868319ae$export$23b7aeb0d671f804);
$parcel$export(module.exports, "onBeforeUpdate", () => $0a6cc4ba868319ae$export$ab91988a13872e4c);
$parcel$export(module.exports, "onServerPrefetch", () => $0a6cc4ba868319ae$export$ebf0c601f267bceb);
$parcel$export(module.exports, "onRenderTriggered", () => $0a6cc4ba868319ae$export$898295a813d662eb);
$parcel$export(module.exports, "onRenderTracked", () => $0a6cc4ba868319ae$export$2b41f4235363e921);
$parcel$export(module.exports, "onErrorCaptured", () => $0a6cc4ba868319ae$export$6a3a15856e50ad19);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "createSlots", () => $0a6cc4ba868319ae$export$85738f8fcd0a5430);
$parcel$export(module.exports, "renderSlot", () => $0a6cc4ba868319ae$export$4abee4c34694ada1);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "toHandlers", () => $0a6cc4ba868319ae$export$2fb94ff667a6a1a);
$parcel$export(module.exports, "defineProps", () => $0a6cc4ba868319ae$export$80b33eababae110e);
$parcel$export(module.exports, "defineEmits", () => $0a6cc4ba868319ae$export$51ecece22fc17ddc);
$parcel$export(module.exports, "defineExpose", () => $0a6cc4ba868319ae$export$da25b65ca24b518a);
$parcel$export(module.exports, "defineOptions", () => $0a6cc4ba868319ae$export$77e79129327f3d0d);
$parcel$export(module.exports, "defineSlots", () => $0a6cc4ba868319ae$export$1b3acd4bb805b712);
$parcel$export(module.exports, "defineModel", () => $0a6cc4ba868319ae$export$acd55aa037e791bb);
$parcel$export(module.exports, "withDefaults", () => $0a6cc4ba868319ae$export$4df9c0969a9e0160);
$parcel$export(module.exports, "useSlots", () => $0a6cc4ba868319ae$export$9203a8e84125433c);
$parcel$export(module.exports, "useAttrs", () => $0a6cc4ba868319ae$export$75e29435042cd2ea);
$parcel$export(module.exports, "mergeDefaults", () => $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f);
$parcel$export(module.exports, "mergeModels", () => $0a6cc4ba868319ae$export$ad4f724f587e6828);
$parcel$export(module.exports, "createPropsRestProxy", () => $0a6cc4ba868319ae$export$7c343e855c563faa);
$parcel$export(module.exports, "withAsyncContext", () => $0a6cc4ba868319ae$export$d6d6f7369f1fb104);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $0a6cc4ba868319ae$export$abe1e183e22e10ad);
$parcel$export(module.exports, "version", () => $0a6cc4ba868319ae$export$83d89fbfd8236492);
$parcel$export(module.exports, "hasInjectionContext", () => $0a6cc4ba868319ae$export$caf6761f24fc571a);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "Teleport", () => $0a6cc4ba868319ae$export$76d55a0304a371f4);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "transformVNodeArgs", () => $0a6cc4ba868319ae$export$83beccd3afeeb809);
$parcel$export(module.exports, "guardReactiveProps", () => $0a6cc4ba868319ae$export$1f1be0e0e384d7d2);
$parcel$export(module.exports, "mergeProps", () => $0a6cc4ba868319ae$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createStaticVNode", () => $0a6cc4ba868319ae$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "registerRuntimeCompiler", () => $0a6cc4ba868319ae$export$667bb5a67822b941);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "useModel", () => $0a6cc4ba868319ae$export$fb78bd113157f1a1);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "withMemo", () => $0a6cc4ba868319ae$export$2a6d714a4d738ae);
$parcel$export(module.exports, "isMemoSame", () => $0a6cc4ba868319ae$export$bf525184d622787c);
$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "ErrorTypeStrings", () => $0a6cc4ba868319ae$export$795e0ad4a0e2ed30);
$parcel$export(module.exports, "devtools", () => $0a6cc4ba868319ae$export$6922d3b3a607469e);
$parcel$export(module.exports, "setDevtoolsHook", () => $0a6cc4ba868319ae$export$b0c258b32c26c785);
$parcel$export(module.exports, "ssrUtils", () => $0a6cc4ba868319ae$export$a9679033567b336d);
$parcel$export(module.exports, "resolveFilter", () => $0a6cc4ba868319ae$export$83cf26e06ea620e1);
$parcel$export(module.exports, "compatUtils", () => $0a6cc4ba868319ae$export$dc678eddf276286e);
$parcel$export(module.exports, "DeprecationTypes", () => $0a6cc4ba868319ae$export$22072a82865312f6);
$parcel$export(module.exports, "EffectScope", () => (parcelRequire("01W3b")).EffectScope);
$parcel$export(module.exports, "ReactiveEffect", () => (parcelRequire("01W3b")).ReactiveEffect);
$parcel$export(module.exports, "TrackOpTypes", () => (parcelRequire("01W3b")).TrackOpTypes);
$parcel$export(module.exports, "TriggerOpTypes", () => (parcelRequire("01W3b")).TriggerOpTypes);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "effect", () => (parcelRequire("01W3b")).effect);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "isProxy", () => (parcelRequire("01W3b")).isProxy);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("01W3b")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "isShallow", () => (parcelRequire("01W3b")).isShallow);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "proxyRefs", () => (parcelRequire("01W3b")).proxyRefs);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowReadonly", () => (parcelRequire("01W3b")).shallowReadonly);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "stop", () => (parcelRequire("01W3b")).stop);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "toValue", () => (parcelRequire("01W3b")).toValue);
$parcel$export(module.exports, "triggerRef", () => (parcelRequire("01W3b")).triggerRef);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8XWQX")).camelize);
$parcel$export(module.exports, "capitalize", () => (parcelRequire("8XWQX")).capitalize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8XWQX")).normalizeClass);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("8XWQX")).normalizeProps);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8XWQX")).normalizeStyle);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8XWQX")).toDisplayString);
$parcel$export(module.exports, "toHandlerKey", () => (parcelRequire("8XWQX")).toHandlerKey);
/**
* @vue/runtime-core v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $01W3b = parcelRequire("01W3b");

var $8XWQX = parcelRequire("8XWQX");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
function $0a6cc4ba868319ae$var$warn$1(msg, ...args) {
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8XWQX.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8XWQX.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0a6cc4ba868319ae$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER"
};
const $0a6cc4ba868319ae$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://github.com/vuejs/core ."
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8XWQX.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8XWQX.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $8XWQX.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $01W3b.resetTracking)();
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $0a6cc4ba868319ae$var$isFlushing = false;
let $0a6cc4ba868319ae$var$isFlushPending = false;
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = 0;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.pre) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!$0a6cc4ba868319ae$var$queue.length || !$0a6cc4ba868319ae$var$queue.includes(job, $0a6cc4ba868319ae$var$isFlushing && job.allowRecurse ? $0a6cc4ba868319ae$var$flushIndex + 1 : $0a6cc4ba868319ae$var$flushIndex)) {
        if (job.id == null) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(job.id), 0, job);
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$isFlushing && !$0a6cc4ba868319ae$var$isFlushPending) {
        $0a6cc4ba868319ae$var$isFlushPending = true;
        $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
    }
}
function $0a6cc4ba868319ae$var$invalidateJob(job) {
    const i = $0a6cc4ba868319ae$var$queue.indexOf(job);
    if (i > $0a6cc4ba868319ae$var$flushIndex) $0a6cc4ba868319ae$var$queue.splice(i, 1);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8XWQX.isArray)(cb)) {
        if (!$0a6cc4ba868319ae$var$activePostFlushCbs || !$0a6cc4ba868319ae$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $0a6cc4ba868319ae$var$postFlushIndex + 1 : $0a6cc4ba868319ae$var$postFlushIndex)) $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
    } else $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(...cb);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(instance, seen, i = $0a6cc4ba868319ae$var$isFlushing ? $0a6cc4ba868319ae$var$flushIndex + 1 : 0) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.pre) {
            if (instance && cb.id !== instance.uid) continue;
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ].sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            $0a6cc4ba868319ae$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++)$0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex]();
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $0a6cc4ba868319ae$var$comparator = (a, b)=>{
    const diff = $0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    $0a6cc4ba868319ae$var$isFlushPending = false;
    $0a6cc4ba868319ae$var$isFlushing = true;
    $0a6cc4ba868319ae$var$queue.sort($0a6cc4ba868319ae$var$comparator);
    const check = (0, $8XWQX.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && job.active !== false) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $0a6cc4ba868319ae$var$flushIndex = 0;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$isFlushing = false;
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        instance.effect.dirty = true;
        instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        if (!$0a6cc4ba868319ae$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $0a6cc4ba868319ae$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) {
            instance.parent.effect.dirty = true;
            $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
        } else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        for (const instance of instances)$0a6cc4ba868319ae$var$hmrDirtyComponents.delete($0a6cc4ba868319ae$var$normalizeClassComponent(instance.type));
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8XWQX.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$var$devtools$1;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$var$devtools$1) $0a6cc4ba868319ae$var$devtools$1.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$var$devtools$1 = hook;
    if ($0a6cc4ba868319ae$var$devtools$1) {
        $0a6cc4ba868319ae$var$devtools$1.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$var$devtools$1.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$var$devtools$1 && typeof $0a6cc4ba868319ae$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$var$devtools$1.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8XWQX.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $8XWQX.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $8XWQX.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $8XWQX.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8XWQX.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8XWQX.toHandlerKey)((0, $8XWQX.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8XWQX.toHandlerKey)((0, $8XWQX.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8XWQX.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8XWQX.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8XWQX.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8XWQX.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8XWQX.extend)(normalized, raw);
    if ((0, $8XWQX.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8XWQX.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $8XWQX.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8XWQX.hasOwn)(options, (0, $8XWQX.hyphenate)(key)) || (0, $8XWQX.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8XWQX.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8XWQX.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8XWQX.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8XWQX.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8XWQX.camelize)(name) || selfName === (0, $8XWQX.capitalize)((0, $8XWQX.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8XWQX.camelize)(name)] || registry[(0, $8XWQX.capitalize)((0, $8XWQX.camelize)(name))]);
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
let $0a6cc4ba868319ae$var$suspenseId = 0;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    create: $0a6cc4ba868319ae$var$createSuspenseBoundary,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8XWQX.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8XWQX.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0a6cc4ba868319ae$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) !== suspense.hiddenContainer) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized);
                if (placeholder) remove(placeholder);
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8XWQX.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8XWQX.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8XWQX.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE = {};
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, once: once, onTrack: onTrack, onTrigger: onTrigger } = (0, $8XWQX.EMPTY_OBJ)) {
    if (cb && once) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            unwatch();
        };
    }
    const warnInvalidSource = (s)=>{
        $0a6cc4ba868319ae$var$warn$1(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    const reactiveGetter = (source2)=>deep === true ? source2 : // for deep: false, only traverse root-level properties
        $0a6cc4ba868319ae$var$traverse(source2, deep === false ? 1 : void 0);
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $01W3b.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $01W3b.isShallow)(source);
    } else if ((0, $01W3b.isReactive)(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $8XWQX.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $01W3b.isReactive)(s) || (0, $01W3b.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $01W3b.isRef)(s)) return s.value;
                else if ((0, $01W3b.isReactive)(s)) return reactiveGetter(s);
                else if ((0, $8XWQX.isFunction)(s)) return $0a6cc4ba868319ae$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $8XWQX.isFunction)(source)) {
        if (cb) getter = ()=>$0a6cc4ba868319ae$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (cleanup) cleanup();
            return $0a6cc4ba868319ae$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $8XWQX.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$0a6cc4ba868319ae$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, 4);
            cleanup = effect.onStop = void 0;
        };
    };
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        onCleanup = (0, $8XWQX.NOOP);
        if (!cb) getter();
        else if (immediate) $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $8XWQX.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE) : $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active || !effect.dirty) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $8XWQX.hasChanged)(v1, oldValue[i])) : (0, $8XWQX.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $0a6cc4ba868319ae$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $0a6cc4ba868319ae$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
    }
    const effect = new (0, $01W3b.ReactiveEffect)(getter, (0, $8XWQX.NOOP), scheduler);
    const scope = (0, $01W3b.getCurrentScope)();
    const unwatch = ()=>{
        effect.stop();
        if (scope) (0, $8XWQX.remove)(scope.effects, effect);
    };
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $0a6cc4ba868319ae$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8XWQX.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8XWQX.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $0a6cc4ba868319ae$var$traverse(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $8XWQX.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ((0, $01W3b.isRef)(value)) $0a6cc4ba868319ae$var$traverse(value.value, depth, seen);
    else if ((0, $8XWQX.isArray)(value)) for(let i = 0; i < value.length; i++)$0a6cc4ba868319ae$var$traverse(value[i], depth, seen);
    else if ((0, $8XWQX.isSet)(value) || (0, $8XWQX.isMap)(value)) value.forEach((v1)=>{
        $0a6cc4ba868319ae$var$traverse(v1, depth, seen);
    });
    else if ((0, $8XWQX.isPlainObject)(value)) for(const key in value)$0a6cc4ba868319ae$var$traverse(value[key], depth, seen);
    return value;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8XWQX.isBuiltInDirective)(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getExposeProxy($0a6cc4ba868319ae$var$currentRenderingInstance) || $0a6cc4ba868319ae$var$currentRenderingInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8XWQX.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8XWQX.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $0a6cc4ba868319ae$var$traverse(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
const $0a6cc4ba868319ae$var$leaveCbKey = Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getKeepAliveChild(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $0a6cc4ba868319ae$var$getKeepAliveChild(oldChild);
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && !$0a6cc4ba868319ae$var$isSameVNodeType(innerChild, oldInnerChild)) {
                const leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) {
                            instance.effect.dirty = true;
                            instance.update();
                        }
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8XWQX.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]) leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getKeepAliveChild(vnode) {
    if (!$0a6cc4ba868319ae$var$isKeepAlive(vnode)) return vnode;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $8XWQX.isFunction)(children.default)) return children.default();
    }
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $0a6cc4ba868319ae$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8XWQX.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8XWQX.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8XWQX.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) {
                    instance.parent.effect.dirty = true;
                    $0a6cc4ba868319ae$var$queueJob(instance.parent.update);
                }
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8XWQX.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8XWQX.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8XWQX.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8XWQX.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8XWQX.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8XWQX.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $01W3b.pauseTracking)();
            const reset = $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") && $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $8XWQX.isArray)(source) || (0, $8XWQX.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8XWQX.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8XWQX.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.isCE || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
    const rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8XWQX.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getExposeProxy(i) || i.proxy;
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8XWQX.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            i.effect.dirty = true;
            $0a6cc4ba868319ae$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8XWQX.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8XWQX.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8XWQX.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $8XWQX.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $01W3b.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8XWQX.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $8XWQX.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $8XWQX.hasOwn)(normalizedProps, key) || (0, $8XWQX.hasOwn)(ctx, key) || (0, $8XWQX.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8XWQX.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8XWQX.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8XWQX.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8XWQX.isGloballyAllowed)(key);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8XWQX.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8XWQX.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8XWQX.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext().slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext().attrs;
}
function $0a6cc4ba868319ae$var$getContext() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8XWQX.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8XWQX.isArray)(opt) || (0, $8XWQX.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8XWQX.isArray)(a) && (0, $8XWQX.isArray)(b)) return a.concat(b);
    return (0, $8XWQX.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if ((0, $8XWQX.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$0a6cc4ba868319ae$var$setCurrentInstance(ctx)
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8XWQX.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8XWQX.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8XWQX.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8XWQX.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8XWQX.NOOP);
        const set = !(0, $8XWQX.isFunction)(opt) && (0, $8XWQX.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8XWQX.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8XWQX.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8XWQX.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8XWQX.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8XWQX.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8XWQX.NOOP)) {
    if ((0, $8XWQX.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8XWQX.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8XWQX.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8XWQX.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8XWQX.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8XWQX.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8XWQX.isObject)(raw)) {
        if ((0, $8XWQX.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8XWQX.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8XWQX.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8XWQX.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8XWQX.extend)((0, $8XWQX.isFunction)(to) ? to.call(this, this) : to, (0, $8XWQX.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8XWQX.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8XWQX.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8XWQX.isArray)(to) && (0, $8XWQX.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8XWQX.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8XWQX.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8XWQX.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8XWQX.isFunction)(rootComponent)) rootComponent = (0, $8XWQX.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8XWQX.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8XWQX.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8XWQX.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0a6cc4ba868319ae$var$currentApp;
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if (!$0a6cc4ba868319ae$var$currentInstance) ;
    else {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $0a6cc4ba868319ae$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8XWQX.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentApp);
}
const $0a6cc4ba868319ae$var$internalObjectProto = {};
const $0a6cc4ba868319ae$var$createInternalObject = ()=>Object.create($0a6cc4ba868319ae$var$internalObjectProto);
const $0a6cc4ba868319ae$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0a6cc4ba868319ae$var$internalObjectProto;
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0a6cc4ba868319ae$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $8XWQX.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8XWQX.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8XWQX.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8XWQX.hyphenate)(key)) === key || !(0, $8XWQX.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8XWQX.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance.attrs, "set", "");
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8XWQX.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $8XWQX.hasOwn)(options, camelKey = (0, $8XWQX.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8XWQX.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8XWQX.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8XWQX.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8XWQX.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $8XWQX.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8XWQX.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8XWQX.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8XWQX.isObject)(comp)) cache.set(comp, (0, $8XWQX.EMPTY_ARR));
        return 0, $8XWQX.EMPTY_ARR;
    }
    if ((0, $8XWQX.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8XWQX.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8XWQX.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8XWQX.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8XWQX.isArray)(opt) || (0, $8XWQX.isFunction)(opt) ? {
                type: opt
            } : (0, $8XWQX.extend)({}, opt);
            if (prop) {
                const booleanIndex = $0a6cc4ba868319ae$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $0a6cc4ba868319ae$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $8XWQX.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8XWQX.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $8XWQX.isReservedProp)(key)) return true;
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0a6cc4ba868319ae$var$isSameType(a, b) {
    return $0a6cc4ba868319ae$var$getType(a) === $0a6cc4ba868319ae$var$getType(b);
}
function $0a6cc4ba868319ae$var$getTypeIndex(type, expectedTypes) {
    if ((0, $8XWQX.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$0a6cc4ba868319ae$var$isSameType(t, type));
    else if ((0, $8XWQX.isFunction)(expectedTypes)) return $0a6cc4ba868319ae$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !(0, $8XWQX.hasOwn)(rawProps, key) && !(0, $8XWQX.hasOwn)(rawProps, (0, $8XWQX.hyphenate)(key)));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8XWQX.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$var$warn$1($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0a6cc4ba868319ae$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8XWQX.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8XWQX.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8XWQX.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8XWQX.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8XWQX.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && !$0a6cc4ba868319ae$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8XWQX.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8XWQX.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children)=>{
    const slots = instance.slots = $0a6cc4ba868319ae$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            (0, $8XWQX.extend)(slots, children);
            (0, $8XWQX.def)(slots, "_", type, true);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
    } else if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8XWQX.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $8XWQX.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8XWQX.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8XWQX.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8XWQX.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $8XWQX.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $8XWQX.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $8XWQX.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8XWQX.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $8XWQX.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $8XWQX.isArray)(existing) && (0, $8XWQX.remove)(existing, refValue);
                    else {
                        if (!(0, $8XWQX.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $8XWQX.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $8XWQX.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $0a6cc4ba868319ae$var$hasMismatch = false;
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0a6cc4ba868319ae$var$getContainerType = (container)=>{
    if ($0a6cc4ba868319ae$var$isSVGContainer(container)) return "svg";
    if ($0a6cc4ba868319ae$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $0a6cc4ba868319ae$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($0a6cc4ba868319ae$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            if (!("__vnode" in node)) Object.defineProperty(node, "__vnode", {
                value: vnode,
                enumerable: false
            });
            if (!("__vueParentComponent" in node)) Object.defineProperty(node, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $0a6cc4ba868319ae$var$hasMismatch = true;
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), optimized);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $0a6cc4ba868319ae$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $0a6cc4ba868319ae$var$hasMismatch = true;
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) for(const key in props){
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0a6cc4ba868319ae$var$hasMismatch = true;
                    if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $8XWQX.isOn)(key) && !(0, $8XWQX.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                    key[0] === ".") patchProp(el, key, null, props[key], void 0, void 0, parentComponent);
                }
                else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $0a6cc4ba868319ae$var$hasMismatch = true;
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                    $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                    hasWarned = true;
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $0a6cc4ba868319ae$var$hasMismatch = true;
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 /* TEXT */  ? `(text)` : $0a6cc4ba868319ae$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 /* ELEMENT */  && node.tagName.toLowerCase() === "template";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $0a6cc4ba868319ae$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    var _a;
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $8XWQX.normalizeClass)(clientValue);
        if (!$0a6cc4ba868319ae$var$isSetEqual($0a6cc4ba868319ae$var$toClassSet(actual || ""), $0a6cc4ba868319ae$var$toClassSet(expected))) mismatchType = mismatchKey = `class`;
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $8XWQX.isString)(clientValue) ? clientValue : (0, $8XWQX.stringifyStyle)((0, $8XWQX.normalizeStyle)(clientValue));
        const actualMap = $0a6cc4ba868319ae$var$toStyleMap(actual);
        const expectedMap = $0a6cc4ba868319ae$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        const root = instance == null ? void 0 : instance.subTree;
        if (vnode === root || (root == null ? void 0 : root.type) === $0a6cc4ba868319ae$export$ffb0004e005737fa && root.children.includes(vnode)) {
            const cssVars = (_a = instance == null ? void 0 : instance.getCssVars) == null ? void 0 : _a.call(instance);
            for(const key2 in cssVars)expectedMap.set(`--${key2}`, String(cssVars[key2]));
        }
        if (!$0a6cc4ba868319ae$var$isMapEqual(actualMap, expectedMap)) mismatchType = mismatchKey = "style";
    } else if (el instanceof SVGElement && (0, $8XWQX.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $8XWQX.isBooleanAttr)(key) || (0, $8XWQX.isKnownHtmlAttr)(key))) {
        if ((0, $8XWQX.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $8XWQX.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $8XWQX.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = `attribute`;
            mismatchKey = key;
        }
    }
    if (mismatchType) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${mismatchType} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0a6cc4ba868319ae$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0a6cc4ba868319ae$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key == null ? void 0 : key.trim();
        value = value == null ? void 0 : value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0a6cc4ba868319ae$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(`<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8XWQX.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8XWQX.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $8XWQX.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8XWQX.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8XWQX.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8XWQX.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8XWQX.EMPTY_OBJ);
        const newProps = n2.props || (0, $8XWQX.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8XWQX.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8XWQX.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $8XWQX.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $0a6cc4ba868319ae$var$invalidateJob(instance.update);
                instance.effect.dirty = true;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8XWQX.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8XWQX.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn, (0, $8XWQX.NOOP), ()=>$0a6cc4ba868319ae$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>{
            if (effect.dirty) effect.run();
        };
        update.id = instance.uid;
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8XWQX.EMPTY_ARR);
        c2 = c2 || (0, $8XWQX.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8XWQX.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $8XWQX.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        if (!isFlushing) {
            isFlushing = true;
            $0a6cc4ba868319ae$var$flushPreFlushCbs();
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            isFlushing = false;
        }
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8XWQX.isArray)(ch1) && (0, $8XWQX.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8XWQX.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$0a6cc4ba868319ae$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node && node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8XWQX.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8XWQX.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8XWQX.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8XWQX.isString)(children) ? 8 : 16;
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8XWQX.isString)(klass)) props.class = (0, $8XWQX.normalizeClass)(klass);
        if ((0, $8XWQX.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8XWQX.isArray)(style)) style = (0, $8XWQX.extend)({}, style);
            props.style = (0, $8XWQX.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8XWQX.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8XWQX.isObject)(type) ? 4 : (0, $8XWQX.isFunction)(type) ? 2 : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$isInternalObject(props) ? (0, $8XWQX.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8XWQX.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) cloned.transition = transition.clone(cloned);
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8XWQX.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8XWQX.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8XWQX.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0a6cc4ba868319ae$var$isInternalObject(children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8XWQX.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8XWQX.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8XWQX.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8XWQX.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8XWQX.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8XWQX.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8XWQX.EMPTY_OBJ),
        data: (0, $8XWQX.EMPTY_OBJ),
        props: (0, $8XWQX.EMPTY_OBJ),
        attrs: (0, $8XWQX.EMPTY_OBJ),
        slots: (0, $8XWQX.EMPTY_OBJ),
        refs: (0, $8XWQX.EMPTY_OBJ),
        setupState: (0, $8XWQX.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$setInSSRSetupState;
{
    const g = (0, $8XWQX.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0a6cc4ba868319ae$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$currentInstance = v1);
    $0a6cc4ba868319ae$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$isInSSRComponentSetup = v1);
}const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    const prev = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0a6cc4ba868319ae$var$internalSetCurrentInstance(prev);
    };
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8XWQX.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || isNativeTag(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false) {
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $01W3b.resetTracking)();
        reset();
        if ((0, $8XWQX.isPromise)(setupResult)) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8XWQX.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8XWQX.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8XWQX.extend)((0, $8XWQX.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8XWQX.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            reset();
        }
    }
}
const $0a6cc4ba868319ae$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $01W3b.track)(target, "get", "");
        return target[key];
    }
};
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $0a6cc4ba868319ae$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])(\w)/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8XWQX.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8XWQX.isFunction)(value) && "__vccOpts" in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
    return c;
};
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options = (0, $8XWQX.EMPTY_OBJ)) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const camelizedName = (0, $8XWQX.camelize)(name);
    const hyphenatedName = (0, $8XWQX.hyphenate)(name);
    const res = (0, $01W3b.customRef)((track, trigger)=>{
        let localValue;
        $0a6cc4ba868319ae$export$2035654f31b0e555(()=>{
            const propValue = props[name];
            if ((0, $8XWQX.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps)) && (0, $8XWQX.hasChanged)(value, localValue)) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, options.set ? options.set(value) : value);
            }
        };
    });
    const modifierKey = name === "modelValue" ? "modelModifiers" : `${name}Modifiers`;
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? props[modifierKey] || {} : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $8XWQX.isObject)(propsOrChildren) && !(0, $8XWQX.isArray)(propsOrChildren)) {
            if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8XWQX.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8XWQX.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8XWQX.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8XWQX.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8XWQX.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8XWQX.isArray)(opts) && opts.includes(key) || (0, $8XWQX.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $01W3b.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8XWQX.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.4.27";
const $0a6cc4ba868319ae$export$c106dd0671a0fc2d = (0, $8XWQX.NOOP);
const $0a6cc4ba868319ae$export$795e0ad4a0e2ed30 = $0a6cc4ba868319ae$var$ErrorTypeStrings$1;
const $0a6cc4ba868319ae$export$6922d3b3a607469e = $0a6cc4ba868319ae$var$devtools$1;
const $0a6cc4ba868319ae$export$b0c258b32c26c785 = $0a6cc4ba868319ae$var$setDevtoolsHook$1;
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;
const $0a6cc4ba868319ae$export$22072a82865312f6 = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $005d1fb7704e278c$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $005d1fb7704e278c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $005d1fb7704e278c$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "effect", () => $005d1fb7704e278c$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "stop", () => $005d1fb7704e278c$export$fa6813432f753b0d);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "readonly", () => $005d1fb7704e278c$export$6ec456bd5b7b3c51);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "isReadonly", () => $005d1fb7704e278c$export$92d09b48637741e7);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "shallowReadonly", () => $005d1fb7704e278c$export$7c4b5f2b50f09f6b);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "triggerRef", () => $005d1fb7704e278c$export$f402f86588575ccc);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "toValue", () => $005d1fb7704e278c$export$30bdcc2218aa9458);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $005d1fb7704e278c$export$2e9533675e5e70e0);
$parcel$export(module.exports, "toRef", () => $005d1fb7704e278c$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "TrackOpTypes", () => $005d1fb7704e278c$export$2ac2bd0a56e04551);
$parcel$export(module.exports, "TriggerOpTypes", () => $005d1fb7704e278c$export$1e8941c92696a26);
/**
* @vue/reactivity v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $lL4wb = parcelRequire("lL4wb");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $005d1fb7704e278c$var$activeEffectScope;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $005d1fb7704e278c$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $005d1fb7704e278c$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$var$recordEffectScope(effect, scope = $005d1fb7704e278c$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
let $005d1fb7704e278c$var$activeEffect;
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn, trigger, scheduler, scope){
        this.fn = fn;
        this.trigger = trigger;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        /**
     * @internal
     */ this._dirtyLevel = 4;
        /**
     * @internal
     */ this._trackId = 0;
        /**
     * @internal
     */ this._runnings = 0;
        /**
     * @internal
     */ this._shouldSchedule = false;
        /**
     * @internal
     */ this._depsLength = 0;
        $005d1fb7704e278c$var$recordEffectScope(this, scope);
    }
    get dirty() {
        if (this._dirtyLevel === 2 || this._dirtyLevel === 3) {
            this._dirtyLevel = 1;
            $005d1fb7704e278c$export$938a971395fef855();
            for(let i = 0; i < this._depsLength; i++){
                const dep = this.deps[i];
                if (dep.computed) {
                    $005d1fb7704e278c$var$triggerComputed(dep.computed);
                    if (this._dirtyLevel >= 4) break;
                }
            }
            if (this._dirtyLevel === 1) this._dirtyLevel = 0;
            $005d1fb7704e278c$export$c39176b1babaa8b8();
        }
        return this._dirtyLevel >= 4;
    }
    set dirty(v) {
        this._dirtyLevel = v ? 4 : 0;
    }
    run() {
        this._dirtyLevel = 0;
        if (!this.active) return this.fn();
        let lastShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        let lastEffect = $005d1fb7704e278c$var$activeEffect;
        try {
            $005d1fb7704e278c$var$shouldTrack = true;
            $005d1fb7704e278c$var$activeEffect = this;
            this._runnings++;
            $005d1fb7704e278c$var$preCleanupEffect(this);
            return this.fn();
        } finally{
            $005d1fb7704e278c$var$postCleanupEffect(this);
            this._runnings--;
            $005d1fb7704e278c$var$activeEffect = lastEffect;
            $005d1fb7704e278c$var$shouldTrack = lastShouldTrack;
        }
    }
    stop() {
        if (this.active) {
            $005d1fb7704e278c$var$preCleanupEffect(this);
            $005d1fb7704e278c$var$postCleanupEffect(this);
            this.onStop && this.onStop();
            this.active = false;
        }
    }
}
function $005d1fb7704e278c$var$triggerComputed(computed) {
    return computed.value;
}
function $005d1fb7704e278c$var$preCleanupEffect(effect2) {
    effect2._trackId++;
    effect2._depsLength = 0;
}
function $005d1fb7704e278c$var$postCleanupEffect(effect2) {
    if (effect2.deps.length > effect2._depsLength) {
        for(let i = effect2._depsLength; i < effect2.deps.length; i++)$005d1fb7704e278c$var$cleanupDepEffect(effect2.deps[i], effect2);
        effect2.deps.length = effect2._depsLength;
    }
}
function $005d1fb7704e278c$var$cleanupDepEffect(dep, effect2) {
    const trackId = dep.get(effect2);
    if (trackId !== void 0 && effect2._trackId !== trackId) {
        dep.delete(effect2);
        if (dep.size === 0) dep.cleanup();
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const _effect = new $005d1fb7704e278c$export$28352bb4dd362521(fn, (0, $lL4wb.NOOP), ()=>{
        if (_effect.dirty) _effect.run();
    });
    if (options) {
        (0, $lL4wb.extend)(_effect, options);
        if (options.scope) $005d1fb7704e278c$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
let $005d1fb7704e278c$var$pauseScheduleStack = 0;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$262a949f95482a17() {
    $005d1fb7704e278c$var$pauseScheduleStack++;
}
function $005d1fb7704e278c$export$3539fa10306ef581() {
    $005d1fb7704e278c$var$pauseScheduleStack--;
    while(!$005d1fb7704e278c$var$pauseScheduleStack && $005d1fb7704e278c$var$queueEffectSchedulers.length)$005d1fb7704e278c$var$queueEffectSchedulers.shift()();
}
function $005d1fb7704e278c$var$trackEffect(effect2, dep, debuggerEventExtraInfo) {
    var _a;
    if (dep.get(effect2) !== effect2._trackId) {
        dep.set(effect2, effect2._trackId);
        const oldDep = effect2.deps[effect2._depsLength];
        if (oldDep !== dep) {
            if (oldDep) $005d1fb7704e278c$var$cleanupDepEffect(oldDep, effect2);
            effect2.deps[effect2._depsLength++] = dep;
        } else effect2._depsLength++;
    }
}
const $005d1fb7704e278c$var$queueEffectSchedulers = [];
function $005d1fb7704e278c$var$triggerEffects(dep, dirtyLevel, debuggerEventExtraInfo) {
    var _a;
    $005d1fb7704e278c$export$262a949f95482a17();
    for (const effect2 of dep.keys()){
        let tracking;
        if (effect2._dirtyLevel < dirtyLevel && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2._shouldSchedule || (effect2._shouldSchedule = effect2._dirtyLevel === 0);
            effect2._dirtyLevel = dirtyLevel;
        }
        if (effect2._shouldSchedule && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2.trigger();
            if ((!effect2._runnings || effect2.allowRecurse) && effect2._dirtyLevel !== 2) {
                effect2._shouldSchedule = false;
                if (effect2.scheduler) $005d1fb7704e278c$var$queueEffectSchedulers.push(effect2.scheduler);
            }
        }
    }
    $005d1fb7704e278c$export$3539fa10306ef581();
}
const $005d1fb7704e278c$var$createDep = (cleanup, computed)=>{
    const dep = /* @__PURE__ */ new Map();
    dep.cleanup = cleanup;
    dep.computed = computed;
    return dep;
};
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = Symbol("");
const $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY = Symbol("");
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $005d1fb7704e278c$var$createDep(()=>depsMap.delete(key)));
        $005d1fb7704e278c$var$trackEffect($005d1fb7704e278c$var$activeEffect, dep, void 0);
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $lL4wb.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || !(0, $lL4wb.isSymbol)(key2) && key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $lL4wb.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $lL4wb.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $lL4wb.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $lL4wb.isArray)(target)) {
                    deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    if ((0, $lL4wb.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $lL4wb.isMap)(target)) deps.push(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                break;
        }
    }
    $005d1fb7704e278c$export$262a949f95482a17();
    for (const dep of deps)if (dep) $005d1fb7704e278c$var$triggerEffects(dep, 4, void 0);
    $005d1fb7704e278c$export$3539fa10306ef581();
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(object);
    return depsMap && depsMap.get(key);
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $lL4wb.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $lL4wb.isSymbol)));
const $005d1fb7704e278c$var$arrayInstrumentations = /* @__PURE__ */ $005d1fb7704e278c$var$createArrayInstrumentations();
function $005d1fb7704e278c$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$005d1fb7704e278c$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($005d1fb7704e278c$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $005d1fb7704e278c$export$938a971395fef855();
            $005d1fb7704e278c$export$262a949f95482a17();
            const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $005d1fb7704e278c$export$3539fa10306ef581();
            $005d1fb7704e278c$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    if (!(0, $lL4wb.isSymbol)(key)) key = String(key);
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : isShallow2 ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the reciever is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $lL4wb.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $lL4wb.hasOwn)($005d1fb7704e278c$var$arrayInstrumentations, key)) return Reflect.get($005d1fb7704e278c$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $lL4wb.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $lL4wb.isIntegerKey)(key) ? res : res.value;
        if ((0, $lL4wb.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $005d1fb7704e278c$export$92d09b48637741e7(oldValue);
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $lL4wb.isArray)(target) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $lL4wb.isArray)(target) && (0, $lL4wb.isIntegerKey)(key) ? Number(key) < target.length : (0, $lL4wb.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $lL4wb.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $lL4wb.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $lL4wb.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $lL4wb.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $lL4wb.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $005d1fb7704e278c$var$getProto(rawTarget);
    const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $005d1fb7704e278c$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $lL4wb.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
        $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $005d1fb7704e278c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $005d1fb7704e278c$var$add(value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const proto = $005d1fb7704e278c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $005d1fb7704e278c$var$set(key, value) {
    value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $lL4wb.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $005d1fb7704e278c$var$deleteEntry(key) {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $005d1fb7704e278c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $005d1fb7704e278c$var$clear() {
    const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $005d1fb7704e278c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $lL4wb.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $005d1fb7704e278c$var$toShallow : isReadonly ? $005d1fb7704e278c$var$toReadonly : $005d1fb7704e278c$var$toReactive;
        !isReadonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$var$MAP_KEY_ITERATE_KEY : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, false, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this);
        },
        has: $005d1fb7704e278c$var$has,
        add: $005d1fb7704e278c$var$add,
        set: $005d1fb7704e278c$var$set,
        delete: $005d1fb7704e278c$var$deleteEntry,
        clear: $005d1fb7704e278c$var$clear,
        forEach: $005d1fb7704e278c$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear"),
        forEach: $005d1fb7704e278c$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $005d1fb7704e278c$var$get(this, key, true, true);
        },
        get size () {
            return $005d1fb7704e278c$var$size(this, true);
        },
        has (key) {
            return $005d1fb7704e278c$var$has.call(this, key, true);
        },
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear"),
        forEach: $005d1fb7704e278c$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $005d1fb7704e278c$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$005d1fb7704e278c$var$mutableInstrumentations, $005d1fb7704e278c$var$readonlyInstrumentations, $005d1fb7704e278c$var$shallowInstrumentations, $005d1fb7704e278c$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentations();
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $005d1fb7704e278c$var$shallowReadonlyInstrumentations : $005d1fb7704e278c$var$shallowInstrumentations : isReadonly ? $005d1fb7704e278c$var$readonlyInstrumentations : $005d1fb7704e278c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $lL4wb.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $lL4wb.toRawType)(target);
        $005d1fb7704e278c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $005d1fb7704e278c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $005d1fb7704e278c$var$targetTypeMap((0, $lL4wb.toRawType)(value));
}
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $lL4wb.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $005d1fb7704e278c$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(value)) return $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    if (Object.isExtensible(value)) (0, $lL4wb.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$var$toReactive = (value)=>(0, $lL4wb.isObject)(value) ? $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$var$toReadonly = (value)=>(0, $lL4wb.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
const $005d1fb7704e278c$var$COMPUTED_SIDE_EFFECT_WARN = `Computed is still dirty after getter evaluation, likely because a computed is mutating its own dependency in its getter. State mutations in computed getters should be avoided.  Check the docs for more details: https://vuejs.org/guide/essentials/computed.html#getters-should-be-side-effect-free`;
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this.getter = getter;
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this.effect = new $005d1fb7704e278c$export$28352bb4dd362521(()=>getter(this._value), ()=>$005d1fb7704e278c$var$triggerRefValue(this, this.effect._dirtyLevel === 2 ? 2 : 3));
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
        if ((!self._cacheable || self.effect.dirty) && (0, $lL4wb.hasChanged)(self._value, self._value = self.effect.run())) $005d1fb7704e278c$var$triggerRefValue(self, 4);
        $005d1fb7704e278c$var$trackRefValue(self);
        if (self.effect._dirtyLevel >= 2) $005d1fb7704e278c$var$triggerRefValue(self, 2);
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
    // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
    get _dirty() {
        return this.effect.dirty;
    }
    set _dirty(v) {
        this.effect.dirty = v;
    }
}
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $lL4wb.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $lL4wb.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
function $005d1fb7704e278c$var$trackRefValue(ref2) {
    var _a;
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeEffect) {
        ref2 = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref2);
        $005d1fb7704e278c$var$trackEffect($005d1fb7704e278c$var$activeEffect, (_a = ref2.dep) != null ? _a : ref2.dep = $005d1fb7704e278c$var$createDep(()=>ref2.dep = void 0, ref2 instanceof $005d1fb7704e278c$var$ComputedRefImpl ? ref2 : void 0), void 0);
    }
}
function $005d1fb7704e278c$var$triggerRefValue(ref2, dirtyLevel = 4, newVal) {
    ref2 = $005d1fb7704e278c$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $005d1fb7704e278c$var$triggerEffects(dep, dirtyLevel, void 0);
}
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $005d1fb7704e278c$var$toReactive(value);
    }
    get value() {
        $005d1fb7704e278c$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $005d1fb7704e278c$export$7f3fe6025abfa26e(newVal) || $005d1fb7704e278c$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $005d1fb7704e278c$export$ab18938b9fc5f28e(newVal);
        if ((0, $lL4wb.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $005d1fb7704e278c$var$toReactive(newVal);
            $005d1fb7704e278c$var$triggerRefValue(this, 4, newVal);
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    $005d1fb7704e278c$var$triggerRefValue(ref2, 4, void 0);
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $lL4wb.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$005d1fb7704e278c$var$trackRefValue(this), ()=>$005d1fb7704e278c$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $lL4wb.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive($005d1fb7704e278c$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $lL4wb.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $lL4wb.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $005d1fb7704e278c$export$4f9f5282de18fc69(val) ? val : new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
const $005d1fb7704e278c$export$483264c4ec4c46ce = $005d1fb7704e278c$export$2983e091f1a1e8e2;
const $005d1fb7704e278c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $005d1fb7704e278c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $005d1fb7704e278c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw"
};

});
parcelRegister("lL4wb", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $fd717df9cc568609$export$b41394a5437791c8);
$parcel$export(module.exports, "NOOP", () => $fd717df9cc568609$export$5702a91a6f42969f);
$parcel$export(module.exports, "extend", () => $fd717df9cc568609$export$8b58be045bf06082);
$parcel$export(module.exports, "hasOwn", () => $fd717df9cc568609$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $fd717df9cc568609$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $fd717df9cc568609$export$5c90113a285f2241);
$parcel$export(module.exports, "isFunction", () => $fd717df9cc568609$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isSymbol", () => $fd717df9cc568609$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $fd717df9cc568609$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "toRawType", () => $fd717df9cc568609$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isIntegerKey", () => $fd717df9cc568609$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "hasChanged", () => $fd717df9cc568609$export$f619eb8b89076d23);
$parcel$export(module.exports, "def", () => $fd717df9cc568609$export$8afb76124cf08683);
/**
* @vue/shared v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $fd717df9cc568609$export$b41394a5437791c8(str, expectsLowerCase) {
    const set = new Set(str.split(","));
    return expectsLowerCase ? (val)=>set.has(val.toLowerCase()) : (val)=>set.has(val);
}
const $fd717df9cc568609$export$cf583d23ab39677c = {};
const $fd717df9cc568609$export$6bd8558f433f1cc1 = [];
const $fd717df9cc568609$export$5702a91a6f42969f = ()=>{};
const $fd717df9cc568609$export$c01351c0af048e39 = ()=>false;
const $fd717df9cc568609$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $fd717df9cc568609$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $fd717df9cc568609$export$8b58be045bf06082 = Object.assign;
const $fd717df9cc568609$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $fd717df9cc568609$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $fd717df9cc568609$export$b5a638e9b3fff9f3 = (val, key)=>$fd717df9cc568609$var$hasOwnProperty.call(val, key);
const $fd717df9cc568609$export$43bee75e5e14138e = Array.isArray;
const $fd717df9cc568609$export$5c90113a285f2241 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object Map]";
const $fd717df9cc568609$export$6750766a7c7ec627 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object Set]";
const $fd717df9cc568609$export$871608497c498473 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object Date]";
const $fd717df9cc568609$export$49841c62b9eff15 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object RegExp]";
const $fd717df9cc568609$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $fd717df9cc568609$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $fd717df9cc568609$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $fd717df9cc568609$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $fd717df9cc568609$export$4369c812aac99591 = (val)=>{
    return ($fd717df9cc568609$export$a6cdc56e425d0d0a(val) || $fd717df9cc568609$export$f6e2535fb5126e54(val)) && $fd717df9cc568609$export$f6e2535fb5126e54(val.then) && $fd717df9cc568609$export$f6e2535fb5126e54(val.catch);
};
const $fd717df9cc568609$export$830c053460e5ddf6 = Object.prototype.toString;
const $fd717df9cc568609$export$1dccc787cc36538b = (value)=>$fd717df9cc568609$export$830c053460e5ddf6.call(value);
const $fd717df9cc568609$export$5ad0a3c360b8fbb5 = (value)=>{
    return $fd717df9cc568609$export$1dccc787cc36538b(value).slice(8, -1);
};
const $fd717df9cc568609$export$53b83ca8eaab0383 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object Object]";
const $fd717df9cc568609$export$e2a2b93446ec9fe = (key)=>$fd717df9cc568609$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $fd717df9cc568609$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $fd717df9cc568609$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $fd717df9cc568609$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $fd717df9cc568609$var$camelizeRE = /-(\w)/g;
const $fd717df9cc568609$export$161d051f5dd25de7 = $fd717df9cc568609$var$cacheStringFunction((str)=>{
    return str.replace($fd717df9cc568609$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $fd717df9cc568609$var$hyphenateRE = /\B([A-Z])/g;
const $fd717df9cc568609$export$6e6a0a3676c4b8bb = $fd717df9cc568609$var$cacheStringFunction((str)=>str.replace($fd717df9cc568609$var$hyphenateRE, "-$1").toLowerCase());
const $fd717df9cc568609$export$9a00dee1beb8f576 = $fd717df9cc568609$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $fd717df9cc568609$export$8c022799eeaaefcd = $fd717df9cc568609$var$cacheStringFunction((str)=>{
    const s = str ? `on${$fd717df9cc568609$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $fd717df9cc568609$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $fd717df9cc568609$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $fd717df9cc568609$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $fd717df9cc568609$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $fd717df9cc568609$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $fd717df9cc568609$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $fd717df9cc568609$var$_globalThis;
const $fd717df9cc568609$export$ff5f2eeb11fc7e14 = ()=>{
    return $fd717df9cc568609$var$_globalThis || ($fd717df9cc568609$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $fd717df9cc568609$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $fd717df9cc568609$export$53d5e12f9a1d3cde(name) {
    return $fd717df9cc568609$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $fd717df9cc568609$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $fd717df9cc568609$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $fd717df9cc568609$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $fd717df9cc568609$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $fd717df9cc568609$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $fd717df9cc568609$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
const $fd717df9cc568609$export$f73b8c13b7f97ebf = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$GLOBALS_ALLOWED);
const $fd717df9cc568609$export$d6571a1911e4f27e = $fd717df9cc568609$export$f73b8c13b7f97ebf;
const $fd717df9cc568609$var$range = 2;
function $fd717df9cc568609$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $fd717df9cc568609$var$range; j <= i + $fd717df9cc568609$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $fd717df9cc568609$export$8756898546458274(value) {
    if ($fd717df9cc568609$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $fd717df9cc568609$export$844ec244b1367d54(item) ? $fd717df9cc568609$export$76a205ce979d066a(item) : $fd717df9cc568609$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($fd717df9cc568609$export$844ec244b1367d54(value) || $fd717df9cc568609$export$a6cdc56e425d0d0a(value)) return value;
}
const $fd717df9cc568609$var$listDelimiterRE = /;(?![^(]*\))/g;
const $fd717df9cc568609$var$propertyDelimiterRE = /:([^]+)/;
const $fd717df9cc568609$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $fd717df9cc568609$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($fd717df9cc568609$var$styleCommentRE, "").split($fd717df9cc568609$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($fd717df9cc568609$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $fd717df9cc568609$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $fd717df9cc568609$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        if ($fd717df9cc568609$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $fd717df9cc568609$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $fd717df9cc568609$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($fd717df9cc568609$export$844ec244b1367d54(value)) res = value;
    else if ($fd717df9cc568609$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $fd717df9cc568609$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($fd717df9cc568609$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $fd717df9cc568609$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$fd717df9cc568609$export$844ec244b1367d54(klass)) props.class = $fd717df9cc568609$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $fd717df9cc568609$export$8756898546458274(style);
    return props;
}
const $fd717df9cc568609$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $fd717df9cc568609$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $fd717df9cc568609$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $fd717df9cc568609$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $fd717df9cc568609$export$1ccf854a0984f890 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$HTML_TAGS);
const $fd717df9cc568609$export$6328ce7565ea1049 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$SVG_TAGS);
const $fd717df9cc568609$export$4a46ca4c5be17b20 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$MATH_TAGS);
const $fd717df9cc568609$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$VOID_TAGS);
const $fd717df9cc568609$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $fd717df9cc568609$export$d186f5eb2e810715 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$specialBooleanAttrs);
const $fd717df9cc568609$export$f763ba3b84e9cd8c = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $fd717df9cc568609$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $fd717df9cc568609$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $fd717df9cc568609$var$attrValidationCache = {};
function $fd717df9cc568609$export$d55ef77660f30d12(name) {
    if ($fd717df9cc568609$var$attrValidationCache.hasOwnProperty(name)) return $fd717df9cc568609$var$attrValidationCache[name];
    const isUnsafe = $fd717df9cc568609$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $fd717df9cc568609$var$attrValidationCache[name] = !isUnsafe;
}
const $fd717df9cc568609$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $fd717df9cc568609$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $fd717df9cc568609$export$80da416f43933831 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $fd717df9cc568609$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $fd717df9cc568609$var$escapeRE = /["'&<>]/;
function $fd717df9cc568609$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $fd717df9cc568609$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $fd717df9cc568609$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $fd717df9cc568609$export$7b105034a53bde5f(src) {
    return src.replace($fd717df9cc568609$var$commentStripRE, "");
}
function $fd717df9cc568609$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $fd717df9cc568609$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $fd717df9cc568609$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $fd717df9cc568609$export$871608497c498473(a);
    let bValidType = $fd717df9cc568609$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $fd717df9cc568609$export$a244864fd9645c7f(a);
    bValidType = $fd717df9cc568609$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $fd717df9cc568609$export$43bee75e5e14138e(a);
    bValidType = $fd717df9cc568609$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $fd717df9cc568609$var$looseCompareArrays(a, b) : false;
    aValidType = $fd717df9cc568609$export$a6cdc56e425d0d0a(a);
    bValidType = $fd717df9cc568609$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$fd717df9cc568609$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $fd717df9cc568609$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$fd717df9cc568609$export$ae8015769846262c(item, val));
}
const $fd717df9cc568609$export$b5b1545233b45293 = (val)=>{
    return $fd717df9cc568609$export$844ec244b1367d54(val) ? val : val == null ? "" : $fd717df9cc568609$export$43bee75e5e14138e(val) || $fd717df9cc568609$export$a6cdc56e425d0d0a(val) && (val.toString === $fd717df9cc568609$export$830c053460e5ddf6 || !$fd717df9cc568609$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $fd717df9cc568609$var$replacer, 2) : String(val);
};
const $fd717df9cc568609$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $fd717df9cc568609$var$replacer(_key, val.value);
    else if ($fd717df9cc568609$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$fd717df9cc568609$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($fd717df9cc568609$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$fd717df9cc568609$var$stringifySymbol(v))
    };
    else if ($fd717df9cc568609$export$a244864fd9645c7f(val)) return $fd717df9cc568609$var$stringifySymbol(val);
    else if ($fd717df9cc568609$export$a6cdc56e425d0d0a(val) && !$fd717df9cc568609$export$43bee75e5e14138e(val) && !$fd717df9cc568609$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $fd717df9cc568609$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $fd717df9cc568609$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});


parcelRegister("8XWQX", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $68717c6dc3e7acb0$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $68717c6dc3e7acb0$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $68717c6dc3e7acb0$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $68717c6dc3e7acb0$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $68717c6dc3e7acb0$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $68717c6dc3e7acb0$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $68717c6dc3e7acb0$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $68717c6dc3e7acb0$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $68717c6dc3e7acb0$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $68717c6dc3e7acb0$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $68717c6dc3e7acb0$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $68717c6dc3e7acb0$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $68717c6dc3e7acb0$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $68717c6dc3e7acb0$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $68717c6dc3e7acb0$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $68717c6dc3e7acb0$export$844ec244b1367d54);
$parcel$export(module.exports, "isObject", () => $68717c6dc3e7acb0$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $68717c6dc3e7acb0$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $68717c6dc3e7acb0$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $68717c6dc3e7acb0$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isReservedProp", () => $68717c6dc3e7acb0$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $68717c6dc3e7acb0$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $68717c6dc3e7acb0$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $68717c6dc3e7acb0$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $68717c6dc3e7acb0$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $68717c6dc3e7acb0$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $68717c6dc3e7acb0$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $68717c6dc3e7acb0$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $68717c6dc3e7acb0$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $68717c6dc3e7acb0$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $68717c6dc3e7acb0$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $68717c6dc3e7acb0$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $68717c6dc3e7acb0$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $68717c6dc3e7acb0$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $68717c6dc3e7acb0$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $68717c6dc3e7acb0$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "normalizeProps", () => $68717c6dc3e7acb0$export$601abcd8103db5e4);
$parcel$export(module.exports, "isBooleanAttr", () => $68717c6dc3e7acb0$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $68717c6dc3e7acb0$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $68717c6dc3e7acb0$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $68717c6dc3e7acb0$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $68717c6dc3e7acb0$export$921dd2acf0d386a3);
$parcel$export(module.exports, "toDisplayString", () => $68717c6dc3e7acb0$export$b5b1545233b45293);
/**
* @vue/shared v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $68717c6dc3e7acb0$export$b41394a5437791c8(str, expectsLowerCase) {
    const set = new Set(str.split(","));
    return expectsLowerCase ? (val)=>set.has(val.toLowerCase()) : (val)=>set.has(val);
}
const $68717c6dc3e7acb0$export$cf583d23ab39677c = {};
const $68717c6dc3e7acb0$export$6bd8558f433f1cc1 = [];
const $68717c6dc3e7acb0$export$5702a91a6f42969f = ()=>{};
const $68717c6dc3e7acb0$export$c01351c0af048e39 = ()=>false;
const $68717c6dc3e7acb0$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $68717c6dc3e7acb0$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $68717c6dc3e7acb0$export$8b58be045bf06082 = Object.assign;
const $68717c6dc3e7acb0$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $68717c6dc3e7acb0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $68717c6dc3e7acb0$export$b5a638e9b3fff9f3 = (val, key)=>$68717c6dc3e7acb0$var$hasOwnProperty.call(val, key);
const $68717c6dc3e7acb0$export$43bee75e5e14138e = Array.isArray;
const $68717c6dc3e7acb0$export$5c90113a285f2241 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object Map]";
const $68717c6dc3e7acb0$export$6750766a7c7ec627 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object Set]";
const $68717c6dc3e7acb0$export$871608497c498473 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object Date]";
const $68717c6dc3e7acb0$export$49841c62b9eff15 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object RegExp]";
const $68717c6dc3e7acb0$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $68717c6dc3e7acb0$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $68717c6dc3e7acb0$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $68717c6dc3e7acb0$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $68717c6dc3e7acb0$export$4369c812aac99591 = (val)=>{
    return ($68717c6dc3e7acb0$export$a6cdc56e425d0d0a(val) || $68717c6dc3e7acb0$export$f6e2535fb5126e54(val)) && $68717c6dc3e7acb0$export$f6e2535fb5126e54(val.then) && $68717c6dc3e7acb0$export$f6e2535fb5126e54(val.catch);
};
const $68717c6dc3e7acb0$export$830c053460e5ddf6 = Object.prototype.toString;
const $68717c6dc3e7acb0$export$1dccc787cc36538b = (value)=>$68717c6dc3e7acb0$export$830c053460e5ddf6.call(value);
const $68717c6dc3e7acb0$export$5ad0a3c360b8fbb5 = (value)=>{
    return $68717c6dc3e7acb0$export$1dccc787cc36538b(value).slice(8, -1);
};
const $68717c6dc3e7acb0$export$53b83ca8eaab0383 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object Object]";
const $68717c6dc3e7acb0$export$e2a2b93446ec9fe = (key)=>$68717c6dc3e7acb0$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $68717c6dc3e7acb0$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $68717c6dc3e7acb0$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $68717c6dc3e7acb0$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $68717c6dc3e7acb0$var$camelizeRE = /-(\w)/g;
const $68717c6dc3e7acb0$export$161d051f5dd25de7 = $68717c6dc3e7acb0$var$cacheStringFunction((str)=>{
    return str.replace($68717c6dc3e7acb0$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $68717c6dc3e7acb0$var$hyphenateRE = /\B([A-Z])/g;
const $68717c6dc3e7acb0$export$6e6a0a3676c4b8bb = $68717c6dc3e7acb0$var$cacheStringFunction((str)=>str.replace($68717c6dc3e7acb0$var$hyphenateRE, "-$1").toLowerCase());
const $68717c6dc3e7acb0$export$9a00dee1beb8f576 = $68717c6dc3e7acb0$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $68717c6dc3e7acb0$export$8c022799eeaaefcd = $68717c6dc3e7acb0$var$cacheStringFunction((str)=>{
    const s = str ? `on${$68717c6dc3e7acb0$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $68717c6dc3e7acb0$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $68717c6dc3e7acb0$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $68717c6dc3e7acb0$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $68717c6dc3e7acb0$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $68717c6dc3e7acb0$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $68717c6dc3e7acb0$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $68717c6dc3e7acb0$var$_globalThis;
const $68717c6dc3e7acb0$export$ff5f2eeb11fc7e14 = ()=>{
    return $68717c6dc3e7acb0$var$_globalThis || ($68717c6dc3e7acb0$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $68717c6dc3e7acb0$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $68717c6dc3e7acb0$export$53d5e12f9a1d3cde(name) {
    return $68717c6dc3e7acb0$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $68717c6dc3e7acb0$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $68717c6dc3e7acb0$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $68717c6dc3e7acb0$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $68717c6dc3e7acb0$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $68717c6dc3e7acb0$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $68717c6dc3e7acb0$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
const $68717c6dc3e7acb0$export$f73b8c13b7f97ebf = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$GLOBALS_ALLOWED);
const $68717c6dc3e7acb0$export$d6571a1911e4f27e = $68717c6dc3e7acb0$export$f73b8c13b7f97ebf;
const $68717c6dc3e7acb0$var$range = 2;
function $68717c6dc3e7acb0$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $68717c6dc3e7acb0$var$range; j <= i + $68717c6dc3e7acb0$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $68717c6dc3e7acb0$export$8756898546458274(value) {
    if ($68717c6dc3e7acb0$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $68717c6dc3e7acb0$export$844ec244b1367d54(item) ? $68717c6dc3e7acb0$export$76a205ce979d066a(item) : $68717c6dc3e7acb0$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($68717c6dc3e7acb0$export$844ec244b1367d54(value) || $68717c6dc3e7acb0$export$a6cdc56e425d0d0a(value)) return value;
}
const $68717c6dc3e7acb0$var$listDelimiterRE = /;(?![^(]*\))/g;
const $68717c6dc3e7acb0$var$propertyDelimiterRE = /:([^]+)/;
const $68717c6dc3e7acb0$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $68717c6dc3e7acb0$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($68717c6dc3e7acb0$var$styleCommentRE, "").split($68717c6dc3e7acb0$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($68717c6dc3e7acb0$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $68717c6dc3e7acb0$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $68717c6dc3e7acb0$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        if ($68717c6dc3e7acb0$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $68717c6dc3e7acb0$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $68717c6dc3e7acb0$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($68717c6dc3e7acb0$export$844ec244b1367d54(value)) res = value;
    else if ($68717c6dc3e7acb0$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $68717c6dc3e7acb0$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($68717c6dc3e7acb0$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $68717c6dc3e7acb0$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$68717c6dc3e7acb0$export$844ec244b1367d54(klass)) props.class = $68717c6dc3e7acb0$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $68717c6dc3e7acb0$export$8756898546458274(style);
    return props;
}
const $68717c6dc3e7acb0$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $68717c6dc3e7acb0$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $68717c6dc3e7acb0$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $68717c6dc3e7acb0$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $68717c6dc3e7acb0$export$1ccf854a0984f890 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$HTML_TAGS);
const $68717c6dc3e7acb0$export$6328ce7565ea1049 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$SVG_TAGS);
const $68717c6dc3e7acb0$export$4a46ca4c5be17b20 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$MATH_TAGS);
const $68717c6dc3e7acb0$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$VOID_TAGS);
const $68717c6dc3e7acb0$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $68717c6dc3e7acb0$export$d186f5eb2e810715 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$specialBooleanAttrs);
const $68717c6dc3e7acb0$export$f763ba3b84e9cd8c = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $68717c6dc3e7acb0$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $68717c6dc3e7acb0$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $68717c6dc3e7acb0$var$attrValidationCache = {};
function $68717c6dc3e7acb0$export$d55ef77660f30d12(name) {
    if ($68717c6dc3e7acb0$var$attrValidationCache.hasOwnProperty(name)) return $68717c6dc3e7acb0$var$attrValidationCache[name];
    const isUnsafe = $68717c6dc3e7acb0$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $68717c6dc3e7acb0$var$attrValidationCache[name] = !isUnsafe;
}
const $68717c6dc3e7acb0$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $68717c6dc3e7acb0$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $68717c6dc3e7acb0$export$80da416f43933831 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $68717c6dc3e7acb0$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $68717c6dc3e7acb0$var$escapeRE = /["'&<>]/;
function $68717c6dc3e7acb0$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $68717c6dc3e7acb0$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $68717c6dc3e7acb0$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $68717c6dc3e7acb0$export$7b105034a53bde5f(src) {
    return src.replace($68717c6dc3e7acb0$var$commentStripRE, "");
}
function $68717c6dc3e7acb0$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $68717c6dc3e7acb0$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $68717c6dc3e7acb0$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $68717c6dc3e7acb0$export$871608497c498473(a);
    let bValidType = $68717c6dc3e7acb0$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $68717c6dc3e7acb0$export$a244864fd9645c7f(a);
    bValidType = $68717c6dc3e7acb0$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $68717c6dc3e7acb0$export$43bee75e5e14138e(a);
    bValidType = $68717c6dc3e7acb0$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $68717c6dc3e7acb0$var$looseCompareArrays(a, b) : false;
    aValidType = $68717c6dc3e7acb0$export$a6cdc56e425d0d0a(a);
    bValidType = $68717c6dc3e7acb0$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$68717c6dc3e7acb0$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $68717c6dc3e7acb0$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$68717c6dc3e7acb0$export$ae8015769846262c(item, val));
}
const $68717c6dc3e7acb0$export$b5b1545233b45293 = (val)=>{
    return $68717c6dc3e7acb0$export$844ec244b1367d54(val) ? val : val == null ? "" : $68717c6dc3e7acb0$export$43bee75e5e14138e(val) || $68717c6dc3e7acb0$export$a6cdc56e425d0d0a(val) && (val.toString === $68717c6dc3e7acb0$export$830c053460e5ddf6 || !$68717c6dc3e7acb0$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $68717c6dc3e7acb0$var$replacer, 2) : String(val);
};
const $68717c6dc3e7acb0$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $68717c6dc3e7acb0$var$replacer(_key, val.value);
    else if ($68717c6dc3e7acb0$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$68717c6dc3e7acb0$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($68717c6dc3e7acb0$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$68717c6dc3e7acb0$var$stringifySymbol(v))
    };
    else if ($68717c6dc3e7acb0$export$a244864fd9645c7f(val)) return $68717c6dc3e7acb0$var$stringifySymbol(val);
    else if ($68717c6dc3e7acb0$export$a6cdc56e425d0d0a(val) && !$68717c6dc3e7acb0$export$43bee75e5e14138e(val) && !$68717c6dc3e7acb0$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $68717c6dc3e7acb0$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $68717c6dc3e7acb0$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});


parcelRegister("4YcVI", function(module, exports) {

$parcel$export(module.exports, "EMPTY_OBJ", () => $39e6cba439e3586f$export$cf583d23ab39677c);
$parcel$export(module.exports, "NOOP", () => $39e6cba439e3586f$export$5702a91a6f42969f);
$parcel$export(module.exports, "isOn", () => $39e6cba439e3586f$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $39e6cba439e3586f$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $39e6cba439e3586f$export$8b58be045bf06082);
$parcel$export(module.exports, "isArray", () => $39e6cba439e3586f$export$43bee75e5e14138e);
$parcel$export(module.exports, "isSet", () => $39e6cba439e3586f$export$6750766a7c7ec627);
$parcel$export(module.exports, "isFunction", () => $39e6cba439e3586f$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $39e6cba439e3586f$export$844ec244b1367d54);
$parcel$export(module.exports, "isObject", () => $39e6cba439e3586f$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "camelize", () => $39e6cba439e3586f$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $39e6cba439e3586f$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $39e6cba439e3586f$export$9a00dee1beb8f576);
$parcel$export(module.exports, "invokeArrayFns", () => $39e6cba439e3586f$export$39951422d618a9d3);
$parcel$export(module.exports, "looseToNumber", () => $39e6cba439e3586f$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $39e6cba439e3586f$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "isHTMLTag", () => $39e6cba439e3586f$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $39e6cba439e3586f$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $39e6cba439e3586f$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $39e6cba439e3586f$export$d186f5eb2e810715);
$parcel$export(module.exports, "includeBooleanAttr", () => $39e6cba439e3586f$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "looseEqual", () => $39e6cba439e3586f$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $39e6cba439e3586f$export$42912a80cedb8bd4);
/**
* @vue/shared v3.4.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $39e6cba439e3586f$export$b41394a5437791c8(str, expectsLowerCase) {
    const set = new Set(str.split(","));
    return expectsLowerCase ? (val)=>set.has(val.toLowerCase()) : (val)=>set.has(val);
}
const $39e6cba439e3586f$export$cf583d23ab39677c = {};
const $39e6cba439e3586f$export$6bd8558f433f1cc1 = [];
const $39e6cba439e3586f$export$5702a91a6f42969f = ()=>{};
const $39e6cba439e3586f$export$c01351c0af048e39 = ()=>false;
const $39e6cba439e3586f$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $39e6cba439e3586f$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $39e6cba439e3586f$export$8b58be045bf06082 = Object.assign;
const $39e6cba439e3586f$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $39e6cba439e3586f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $39e6cba439e3586f$export$b5a638e9b3fff9f3 = (val, key)=>$39e6cba439e3586f$var$hasOwnProperty.call(val, key);
const $39e6cba439e3586f$export$43bee75e5e14138e = Array.isArray;
const $39e6cba439e3586f$export$5c90113a285f2241 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object Map]";
const $39e6cba439e3586f$export$6750766a7c7ec627 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object Set]";
const $39e6cba439e3586f$export$871608497c498473 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object Date]";
const $39e6cba439e3586f$export$49841c62b9eff15 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object RegExp]";
const $39e6cba439e3586f$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $39e6cba439e3586f$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $39e6cba439e3586f$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $39e6cba439e3586f$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $39e6cba439e3586f$export$4369c812aac99591 = (val)=>{
    return ($39e6cba439e3586f$export$a6cdc56e425d0d0a(val) || $39e6cba439e3586f$export$f6e2535fb5126e54(val)) && $39e6cba439e3586f$export$f6e2535fb5126e54(val.then) && $39e6cba439e3586f$export$f6e2535fb5126e54(val.catch);
};
const $39e6cba439e3586f$export$830c053460e5ddf6 = Object.prototype.toString;
const $39e6cba439e3586f$export$1dccc787cc36538b = (value)=>$39e6cba439e3586f$export$830c053460e5ddf6.call(value);
const $39e6cba439e3586f$export$5ad0a3c360b8fbb5 = (value)=>{
    return $39e6cba439e3586f$export$1dccc787cc36538b(value).slice(8, -1);
};
const $39e6cba439e3586f$export$53b83ca8eaab0383 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object Object]";
const $39e6cba439e3586f$export$e2a2b93446ec9fe = (key)=>$39e6cba439e3586f$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $39e6cba439e3586f$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $39e6cba439e3586f$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $39e6cba439e3586f$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $39e6cba439e3586f$var$camelizeRE = /-(\w)/g;
const $39e6cba439e3586f$export$161d051f5dd25de7 = $39e6cba439e3586f$var$cacheStringFunction((str)=>{
    return str.replace($39e6cba439e3586f$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $39e6cba439e3586f$var$hyphenateRE = /\B([A-Z])/g;
const $39e6cba439e3586f$export$6e6a0a3676c4b8bb = $39e6cba439e3586f$var$cacheStringFunction((str)=>str.replace($39e6cba439e3586f$var$hyphenateRE, "-$1").toLowerCase());
const $39e6cba439e3586f$export$9a00dee1beb8f576 = $39e6cba439e3586f$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $39e6cba439e3586f$export$8c022799eeaaefcd = $39e6cba439e3586f$var$cacheStringFunction((str)=>{
    const s = str ? `on${$39e6cba439e3586f$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $39e6cba439e3586f$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $39e6cba439e3586f$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $39e6cba439e3586f$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $39e6cba439e3586f$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $39e6cba439e3586f$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $39e6cba439e3586f$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $39e6cba439e3586f$var$_globalThis;
const $39e6cba439e3586f$export$ff5f2eeb11fc7e14 = ()=>{
    return $39e6cba439e3586f$var$_globalThis || ($39e6cba439e3586f$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $39e6cba439e3586f$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $39e6cba439e3586f$export$53d5e12f9a1d3cde(name) {
    return $39e6cba439e3586f$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $39e6cba439e3586f$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $39e6cba439e3586f$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $39e6cba439e3586f$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $39e6cba439e3586f$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $39e6cba439e3586f$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $39e6cba439e3586f$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
const $39e6cba439e3586f$export$f73b8c13b7f97ebf = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$GLOBALS_ALLOWED);
const $39e6cba439e3586f$export$d6571a1911e4f27e = $39e6cba439e3586f$export$f73b8c13b7f97ebf;
const $39e6cba439e3586f$var$range = 2;
function $39e6cba439e3586f$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $39e6cba439e3586f$var$range; j <= i + $39e6cba439e3586f$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $39e6cba439e3586f$export$8756898546458274(value) {
    if ($39e6cba439e3586f$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $39e6cba439e3586f$export$844ec244b1367d54(item) ? $39e6cba439e3586f$export$76a205ce979d066a(item) : $39e6cba439e3586f$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($39e6cba439e3586f$export$844ec244b1367d54(value) || $39e6cba439e3586f$export$a6cdc56e425d0d0a(value)) return value;
}
const $39e6cba439e3586f$var$listDelimiterRE = /;(?![^(]*\))/g;
const $39e6cba439e3586f$var$propertyDelimiterRE = /:([^]+)/;
const $39e6cba439e3586f$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $39e6cba439e3586f$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($39e6cba439e3586f$var$styleCommentRE, "").split($39e6cba439e3586f$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($39e6cba439e3586f$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $39e6cba439e3586f$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $39e6cba439e3586f$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        if ($39e6cba439e3586f$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $39e6cba439e3586f$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $39e6cba439e3586f$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($39e6cba439e3586f$export$844ec244b1367d54(value)) res = value;
    else if ($39e6cba439e3586f$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $39e6cba439e3586f$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($39e6cba439e3586f$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $39e6cba439e3586f$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$39e6cba439e3586f$export$844ec244b1367d54(klass)) props.class = $39e6cba439e3586f$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $39e6cba439e3586f$export$8756898546458274(style);
    return props;
}
const $39e6cba439e3586f$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $39e6cba439e3586f$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $39e6cba439e3586f$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $39e6cba439e3586f$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $39e6cba439e3586f$export$1ccf854a0984f890 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$HTML_TAGS);
const $39e6cba439e3586f$export$6328ce7565ea1049 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$SVG_TAGS);
const $39e6cba439e3586f$export$4a46ca4c5be17b20 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$MATH_TAGS);
const $39e6cba439e3586f$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$VOID_TAGS);
const $39e6cba439e3586f$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $39e6cba439e3586f$export$d186f5eb2e810715 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$specialBooleanAttrs);
const $39e6cba439e3586f$export$f763ba3b84e9cd8c = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $39e6cba439e3586f$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $39e6cba439e3586f$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $39e6cba439e3586f$var$attrValidationCache = {};
function $39e6cba439e3586f$export$d55ef77660f30d12(name) {
    if ($39e6cba439e3586f$var$attrValidationCache.hasOwnProperty(name)) return $39e6cba439e3586f$var$attrValidationCache[name];
    const isUnsafe = $39e6cba439e3586f$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $39e6cba439e3586f$var$attrValidationCache[name] = !isUnsafe;
}
const $39e6cba439e3586f$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $39e6cba439e3586f$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $39e6cba439e3586f$export$80da416f43933831 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $39e6cba439e3586f$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $39e6cba439e3586f$var$escapeRE = /["'&<>]/;
function $39e6cba439e3586f$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $39e6cba439e3586f$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $39e6cba439e3586f$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $39e6cba439e3586f$export$7b105034a53bde5f(src) {
    return src.replace($39e6cba439e3586f$var$commentStripRE, "");
}
function $39e6cba439e3586f$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $39e6cba439e3586f$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $39e6cba439e3586f$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $39e6cba439e3586f$export$871608497c498473(a);
    let bValidType = $39e6cba439e3586f$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $39e6cba439e3586f$export$a244864fd9645c7f(a);
    bValidType = $39e6cba439e3586f$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $39e6cba439e3586f$export$43bee75e5e14138e(a);
    bValidType = $39e6cba439e3586f$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $39e6cba439e3586f$var$looseCompareArrays(a, b) : false;
    aValidType = $39e6cba439e3586f$export$a6cdc56e425d0d0a(a);
    bValidType = $39e6cba439e3586f$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$39e6cba439e3586f$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $39e6cba439e3586f$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$39e6cba439e3586f$export$ae8015769846262c(item, val));
}
const $39e6cba439e3586f$export$b5b1545233b45293 = (val)=>{
    return $39e6cba439e3586f$export$844ec244b1367d54(val) ? val : val == null ? "" : $39e6cba439e3586f$export$43bee75e5e14138e(val) || $39e6cba439e3586f$export$a6cdc56e425d0d0a(val) && (val.toString === $39e6cba439e3586f$export$830c053460e5ddf6 || !$39e6cba439e3586f$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $39e6cba439e3586f$var$replacer, 2) : String(val);
};
const $39e6cba439e3586f$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $39e6cba439e3586f$var$replacer(_key, val.value);
    else if ($39e6cba439e3586f$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$39e6cba439e3586f$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($39e6cba439e3586f$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$39e6cba439e3586f$var$stringifySymbol(v))
    };
    else if ($39e6cba439e3586f$export$a244864fd9645c7f(val)) return $39e6cba439e3586f$var$stringifySymbol(val);
    else if ($39e6cba439e3586f$export$a6cdc56e425d0d0a(val) && !$39e6cba439e3586f$export$43bee75e5e14138e(val) && !$39e6cba439e3586f$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $39e6cba439e3586f$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $39e6cba439e3586f$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});



parcelRegister("boZNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $84d1df06ca739753$export$2e2bcd8739ae039);

var $73mM4 = parcelRequire("73mM4");
var $84d1df06ca739753$export$2e2bcd8739ae039 = {
    name: "App",
    components: {
        RouterView: $73mM4.RouterView
    }
};

});
parcelRegister("73mM4", function(module, exports) {

$parcel$export(module.exports, "createWebHashHistory", () => $a809ac530d32f081$export$542bc3a76486c94d);
$parcel$export(module.exports, "RouterLink", () => $a809ac530d32f081$export$fce709ebdac448ed);
$parcel$export(module.exports, "RouterView", () => $a809ac530d32f081$export$d941f00e9b9a537);
$parcel$export(module.exports, "createRouter", () => $a809ac530d32f081$export$baddd0131ee8c05b);
/*!
  * vue-router v4.4.5
  * (c) 2024 Eduardo San Martin Morote
  * @license MIT
  */ parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $j6G8F = parcelRequire("j6G8F");
const $a809ac530d32f081$var$isBrowser = typeof document !== "undefined";
/**
 * Allows differentiating lazy components from functional components and vue-class-component
 * @internal
 *
 * @param component
 */ function $a809ac530d32f081$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
function $a809ac530d32f081$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module" || // support CF with dynamic imports that do not
    // add the Module string tag
    obj.default && $a809ac530d32f081$var$isRouteComponent(obj.default);
}
const $a809ac530d32f081$var$assign = Object.assign;
function $a809ac530d32f081$var$applyToParams(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $a809ac530d32f081$var$isArray(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $a809ac530d32f081$var$noop = ()=>{};
/**
 * Typesafe alternative to Array.isArray
 * https://github.com/microsoft/TypeScript/pull/48228
 */ const $a809ac530d32f081$var$isArray = Array.isArray;
function $a809ac530d32f081$var$warn(msg) {
    // avoid using ...args as it breaks in older Edge builds
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
/**
 * Encoding Rules (␣ = Space)
 * - Path: ␣ " < > # ? { }
 * - Query: ␣ " < > # & =
 * - Hash: ␣ " < > `
 *
 * On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
 * defines some extra characters to be encoded. Most browsers do not encode them
 * in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
 * also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
 * plus `-._~`. This extra safety should be applied to query by patching the
 * string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
 * should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
 * into a `/` if directly typed in. The _backtick_ (`````) should also be
 * encoded everywhere because some browsers like FF encode it when directly
 * written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
 */ // const EXTRA_RESERVED_RE = /[!'()*]/g
// const encodeReservedReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
const $a809ac530d32f081$var$HASH_RE = /#/g; // %23
const $a809ac530d32f081$var$AMPERSAND_RE = /&/g; // %26
const $a809ac530d32f081$var$SLASH_RE = /\//g; // %2F
const $a809ac530d32f081$var$EQUAL_RE = /=/g; // %3D
const $a809ac530d32f081$var$IM_RE = /\?/g; // %3F
const $a809ac530d32f081$var$PLUS_RE = /\+/g; // %2B
/**
 * NOTE: It's not clear to me if we should encode the + symbol in queries, it
 * seems to be less flexible than not doing so and I can't find out the legacy
 * systems requiring this for regular requests like text/html. In the standard,
 * the encoding of the plus character is only mentioned for
 * application/x-www-form-urlencoded
 * (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
 * leave the plus character as is in queries. To be more flexible, we allow the
 * plus character on the query, but it can also be manually encoded by the user.
 *
 * Resources:
 * - https://url.spec.whatwg.org/#urlencoded-parsing
 * - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
 */ const $a809ac530d32f081$var$ENC_BRACKET_OPEN_RE = /%5B/g; // [
const $a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE = /%5D/g; // ]
const $a809ac530d32f081$var$ENC_CARET_RE = /%5E/g; // ^
const $a809ac530d32f081$var$ENC_BACKTICK_RE = /%60/g; // `
const $a809ac530d32f081$var$ENC_CURLY_OPEN_RE = /%7B/g; // {
const $a809ac530d32f081$var$ENC_PIPE_RE = /%7C/g; // |
const $a809ac530d32f081$var$ENC_CURLY_CLOSE_RE = /%7D/g; // }
const $a809ac530d32f081$var$ENC_SPACE_RE = /%20/g; // }
/**
 * Encode characters that need to be encoded on the path, search and hash
 * sections of the URL.
 *
 * @internal
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$commonEncode(text) {
    return encodeURI("" + text).replace($a809ac530d32f081$var$ENC_PIPE_RE, "|").replace($a809ac530d32f081$var$ENC_BRACKET_OPEN_RE, "[").replace($a809ac530d32f081$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
 * Encode characters that need to be encoded on the hash section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeHash(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, "{").replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, "}").replace($a809ac530d32f081$var$ENC_CARET_RE, "^");
}
/**
 * Encode characters that need to be encoded query values on the query
 * section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeQueryValue(text) {
    return $a809ac530d32f081$var$commonEncode(text)// Encode the space as +, encode the + to differentiate it from the space
    .replace($a809ac530d32f081$var$PLUS_RE, "%2B").replace($a809ac530d32f081$var$ENC_SPACE_RE, "+").replace($a809ac530d32f081$var$HASH_RE, "%23").replace($a809ac530d32f081$var$AMPERSAND_RE, "%26").replace($a809ac530d32f081$var$ENC_BACKTICK_RE, "`").replace($a809ac530d32f081$var$ENC_CURLY_OPEN_RE, "{").replace($a809ac530d32f081$var$ENC_CURLY_CLOSE_RE, "}").replace($a809ac530d32f081$var$ENC_CARET_RE, "^");
}
/**
 * Like `encodeQueryValue` but also encodes the `=` character.
 *
 * @param text - string to encode
 */ function $a809ac530d32f081$var$encodeQueryKey(text) {
    return $a809ac530d32f081$var$encodeQueryValue(text).replace($a809ac530d32f081$var$EQUAL_RE, "%3D");
}
/**
 * Encode characters that need to be encoded on the path section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodePath(text) {
    return $a809ac530d32f081$var$commonEncode(text).replace($a809ac530d32f081$var$HASH_RE, "%23").replace($a809ac530d32f081$var$IM_RE, "%3F");
}
/**
 * Encode characters that need to be encoded on the path section of the URL as a
 * param. This function encodes everything {@link encodePath} does plus the
 * slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
 * string instead.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $a809ac530d32f081$var$encodeParam(text) {
    return text == null ? "" : $a809ac530d32f081$var$encodePath(text).replace($a809ac530d32f081$var$SLASH_RE, "%2F");
}
/**
 * Decode text using `decodeURIComponent`. Returns the original text if it
 * fails.
 *
 * @param text - string to decode
 * @returns decoded string
 */ function $a809ac530d32f081$var$decode(text) {
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
const $a809ac530d32f081$var$TRAILING_SLASH_RE = /\/$/;
const $a809ac530d32f081$var$removeTrailingSlash = (path)=>path.replace($a809ac530d32f081$var$TRAILING_SLASH_RE, "");
/**
 * Transforms a URI into a normalized history location
 *
 * @param parseQuery
 * @param location - URI to normalize
 * @param currentLocation - current absolute location. Allows resolving relative
 * paths. Must start with `/`. Defaults to `/`
 * @returns a normalized history location
 */ function $a809ac530d32f081$var$parseURL(parseQuery, location1, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    // Could use URL and URLSearchParams but IE 11 doesn't support it
    // TODO: move to new URL()
    const hashPos = location1.indexOf("#");
    let searchPos = location1.indexOf("?");
    // the hash appears before the search, so it's not part of the search string
    if (hashPos < searchPos && hashPos >= 0) searchPos = -1;
    if (searchPos > -1) {
        path = location1.slice(0, searchPos);
        searchString = location1.slice(searchPos + 1, hashPos > -1 ? hashPos : location1.length);
        query = parseQuery(searchString);
    }
    if (hashPos > -1) {
        path = path || location1.slice(0, hashPos);
        // keep the # character
        hash = location1.slice(hashPos, location1.length);
    }
    // no search and no query
    path = $a809ac530d32f081$var$resolveRelativePath(path != null ? path : location1, currentLocation);
    // empty path means a relative query or hash `?foo=f`, `#thing`
    return {
        fullPath: path + (searchString && "?") + searchString + hash,
        path: path,
        query: query,
        hash: $a809ac530d32f081$var$decode(hash)
    };
}
/**
 * Stringifies a URL object
 *
 * @param stringifyQuery
 * @param location
 */ function $a809ac530d32f081$var$stringifyURL(stringifyQuery, location1) {
    const query = location1.query ? stringifyQuery(location1.query) : "";
    return location1.path + (query && "?") + query + (location1.hash || "");
}
/**
 * Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
 *
 * @param pathname - location.pathname
 * @param base - base to strip off
 */ function $a809ac530d32f081$var$stripBase(pathname, base) {
    // no base or base is not found at the beginning
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
 * Checks if two RouteLocation are equal. This means that both locations are
 * pointing towards the same {@link RouteRecord} and that all `params`, `query`
 * parameters and `hash` are the same
 *
 * @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
 * @param a - first {@link RouteLocation}
 * @param b - second {@link RouteLocation}
 */ function $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $a809ac530d32f081$var$isSameRouteRecord(a.matched[aLastIndex], b.matched[bLastIndex]) && $a809ac530d32f081$var$isSameRouteLocationParams(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
 * Check if two `RouteRecords` are equal. Takes into account aliases: they are
 * considered equal to the `RouteRecord` they are aliasing.
 *
 * @param a - first {@link RouteRecord}
 * @param b - second {@link RouteRecord}
 */ function $a809ac530d32f081$var$isSameRouteRecord(a, b) {
    // since the original record has an undefined value for aliasOf
    // but all aliases point to the original record, this will always compare
    // the original record
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $a809ac530d32f081$var$isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (!$a809ac530d32f081$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    }
    return true;
}
function $a809ac530d32f081$var$isSameRouteLocationParamsValue(a, b) {
    return $a809ac530d32f081$var$isArray(a) ? $a809ac530d32f081$var$isEquivalentArray(a, b) : $a809ac530d32f081$var$isArray(b) ? $a809ac530d32f081$var$isEquivalentArray(b, a) : a === b;
}
/**
 * Check if two arrays are the same or if an array with one single entry is the
 * same as another primitive value. Used to check query and parameters
 *
 * @param a - array of values
 * @param b - array of values or a single value
 */ function $a809ac530d32f081$var$isEquivalentArray(a, b) {
    return $a809ac530d32f081$var$isArray(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
 * Resolves a relative path that starts with `.`.
 *
 * @param to - path location we are resolving
 * @param from - currentLocation.path, should start with `/`
 */ function $a809ac530d32f081$var$resolveRelativePath(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    // make . and ./ the same (../ === .., ../../ === ../..)
    // this is the same behavior as new URL()
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        // we stay on the same position
        if (segment === ".") continue;
        // go up in the from array
        if (segment === "..") // we can't go below zero, but we still need to increment toPosition
        {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition).join("/");
}
/**
 * Initial route location where the router is. Can be used in navigation guards
 * to differentiate the initial navigation.
 *
 * @example
 * ```js
 * import { START_LOCATION } from 'vue-router'
 *
 * router.beforeEach((to, from) => {
 *   if (from === START_LOCATION) {
 *     // initial navigation
 *   }
 * })
 * ```
 */ const $a809ac530d32f081$export$e44be9a9779c480b = {
    path: "/",
    // TODO: could we use a symbol in the future?
    name: undefined,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: undefined
};
var $a809ac530d32f081$var$NavigationType;
(function(NavigationType) {
    NavigationType["pop"] = "pop";
    NavigationType["push"] = "push";
})($a809ac530d32f081$var$NavigationType || ($a809ac530d32f081$var$NavigationType = {}));
var $a809ac530d32f081$var$NavigationDirection;
(function(NavigationDirection) {
    NavigationDirection["back"] = "back";
    NavigationDirection["forward"] = "forward";
    NavigationDirection["unknown"] = "";
})($a809ac530d32f081$var$NavigationDirection || ($a809ac530d32f081$var$NavigationDirection = {}));
/**
 * Starting location for Histories
 */ const $a809ac530d32f081$var$START = "";
// Generic utils
/**
 * Normalizes a base by removing any trailing slash and reading the base tag if
 * present.
 *
 * @param base - base to normalize
 */ function $a809ac530d32f081$var$normalizeBase(base) {
    if (!base) {
        if ($a809ac530d32f081$var$isBrowser) {
            // respect <base> tag
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            // strip full URL origin
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    // ensure leading slash when it was removed by the regex above avoid leading
    // slash with hash because the file could be read from the disk like file://
    // and the leading slash would cause problems
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    // remove the trailing slash so all other method can just do `base + fullPath`
    // to build an href
    return $a809ac530d32f081$var$removeTrailingSlash(base);
}
// remove any character before the hash
const $a809ac530d32f081$var$BEFORE_HASH_RE = /^[^#]+#/;
function $a809ac530d32f081$var$createHref(base, location1) {
    return base.replace($a809ac530d32f081$var$BEFORE_HASH_RE, "#") + location1;
}
function $a809ac530d32f081$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $a809ac530d32f081$var$computeScrollPosition = ()=>({
        left: window.scrollX,
        top: window.scrollY
    });
function $a809ac530d32f081$var$scrollToPosition(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $a809ac530d32f081$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $a809ac530d32f081$var$getScrollKey(path, delta) {
    const position = history.state ? history.state.position - delta : -1;
    return position + path;
}
const $a809ac530d32f081$var$scrollPositions = new Map();
function $a809ac530d32f081$var$saveScrollPosition(key, scrollPosition) {
    $a809ac530d32f081$var$scrollPositions.set(key, scrollPosition);
}
function $a809ac530d32f081$var$getSavedScrollPosition(key) {
    const scroll = $a809ac530d32f081$var$scrollPositions.get(key);
    // consume it so it's not used again
    $a809ac530d32f081$var$scrollPositions.delete(key);
    return scroll;
}
// TODO: RFC about how to save scroll position
/**
 * ScrollBehavior instance used by the router to compute and restore the scroll
 * position when navigating.
 */ // export interface ScrollHandler<ScrollPositionEntry extends HistoryStateValue, ScrollPosition extends ScrollPositionEntry> {
//   // returns a scroll position that can be saved in history
//   compute(): ScrollPositionEntry
//   // can take an extended ScrollPositionEntry
//   scroll(position: ScrollPosition): void
// }
// export const scrollHandler: ScrollHandler<ScrollPosition> = {
//   compute: computeScroll,
//   scroll: scrollToPosition,
// }
let $a809ac530d32f081$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
 * Creates a normalized history location from a window.location object
 * @param base - The base path
 * @param location - The window.location object
 */ function $a809ac530d32f081$var$createCurrentLocation(base, location1) {
    const { pathname: pathname, search: search, hash: hash } = location1;
    // allows hash bases like #, /#, #/, #!, #!/, /#!/, or even /folder#end
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        // prepend the starting slash to hash so the url starts with /#
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return $a809ac530d32f081$var$stripBase(pathFromHash, "");
    }
    const path = $a809ac530d32f081$var$stripBase(pathname, base);
    return path + search + hash;
}
function $a809ac530d32f081$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    // TODO: should it be a stack? a Dict. Check if the popstate listener
    // can trigger twice
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $a809ac530d32f081$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            // ignore the popstate and reset the pauseState
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        // Here we could also revert the navigation by calling history.go(-delta)
        // this listener will have to be adapted to not trigger again and to wait for the url
        // to be updated before triggering the listeners. Some kind of validation function would also
        // need to be passed to the listeners so the navigation can be accepted
        // call all listeners
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: $a809ac530d32f081$var$NavigationType.pop,
                direction: delta ? delta > 0 ? $a809ac530d32f081$var$NavigationDirection.forward : $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        // set up the listener and prepare teardown callbacks
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        const { history: history1 } = window;
        if (!history1.state) return;
        history1.replaceState($a809ac530d32f081$var$assign({}, history1.state, {
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        }), "");
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("beforeunload", beforeUnloadListener);
    }
    // set up the listeners and prepare teardown callbacks
    window.addEventListener("popstate", popStateHandler);
    // TODO: could we use 'pagehide' or 'visibilitychange' instead?
    // https://developer.chrome.com/blog/page-lifecycle-api/
    window.addEventListener("beforeunload", beforeUnloadListener, {
        passive: true
    });
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
 * Creates a state object
 */ function $a809ac530d32f081$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? $a809ac530d32f081$var$computeScrollPosition() : null
    };
}
function $a809ac530d32f081$var$useHistoryStateNavigation(base) {
    const { history: history1, location: location1 } = window;
    // private variables
    const currentLocation = {
        value: $a809ac530d32f081$var$createCurrentLocation(base, location1)
    };
    const historyState = {
        value: history1.state
    };
    // build current history entry as this is a fresh navigation
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        // the length is off by one, we need to decrease it
        position: history1.length - 1,
        replaced: true,
        // don't add a scroll as the user may have an anchor, and we want
        // scrollBehavior to be triggered without a saved position
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
         * if a base tag is provided, and we are on a normal domain, we have to
         * respect the provided `base` attribute because pushState() will use it and
         * potentially erase anything before the `#` like at
         * https://github.com/vuejs/router/issues/685 where a base of
         * `/folder/#` but a base of `/` would erase the `/folder/` section. If
         * there is no host, the `<base>` tag makes no sense and if there isn't a
         * base tag we can just use everything after the `#`.
         */ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $a809ac530d32f081$var$createBaseLocation() + base + to;
        try {
            // BROWSER QUIRK
            // NOTE: Safari throws a SecurityError when calling this function 100 times in 30 seconds
            history1[replace ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            // Force the navigation, this also resets the call count
            location1[replace ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        const state = $a809ac530d32f081$var$assign({}, history1.state, $a809ac530d32f081$var$buildState(historyState.value.back, // keep back and forward entries but override current position
        to, historyState.value.forward, true), data, {
            position: historyState.value.position
        });
        changeLocation(to, state, true);
        currentLocation.value = to;
    }
    function push(to, data) {
        // Add to current entry the information of where we are going
        // as well as saving the current position
        const currentState = $a809ac530d32f081$var$assign({}, // use current history state to gracefully handle a wrong call to
        // history.replaceState
        // https://github.com/vuejs/router/issues/366
        historyState.value, history1.state, {
            forward: to,
            scroll: $a809ac530d32f081$var$computeScrollPosition()
        });
        changeLocation(currentState.current, currentState, true);
        const state = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data);
        changeLocation(to, state, false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
 * Creates an HTML5 history. Most common history for single page applications.
 *
 * @param base -
 */ function $a809ac530d32f081$export$7b4942f78e7b8a49(base) {
    base = $a809ac530d32f081$var$normalizeBase(base);
    const historyNavigation = $a809ac530d32f081$var$useHistoryStateNavigation(base);
    const historyListeners = $a809ac530d32f081$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = $a809ac530d32f081$var$assign({
        // it's overridden right after
        location: "",
        base: base,
        go: go,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
/**
 * Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
 * It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
 *
 * @param base - Base applied to all urls, defaults to '/'
 * @returns a history object that can be passed to the router constructor
 */ function $a809ac530d32f081$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        $a809ac530d32f081$var$START
    ];
    let position = 0;
    base = $a809ac530d32f081$var$normalizeBase(base);
    function setLocation(location1) {
        position++;
        if (position !== queue.length) // we are in the middle, we remove everything from here in the queue
        queue.splice(position);
        queue.push(location1);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: $a809ac530d32f081$var$NavigationType.pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        // rewritten by Object.defineProperty
        location: $a809ac530d32f081$var$START,
        // TODO: should be kept in queue
        state: {},
        base: base,
        createHref: $a809ac530d32f081$var$createHref.bind(null, base),
        replace (to) {
            // remove current entry and decrement position
            queue.splice(position--, 1);
            setLocation(to);
        },
        push (to, data) {
            setLocation(to);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                $a809ac530d32f081$var$START
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = // we are considering delta === 0 going forward, but in abstract mode
            // using 0 for the delta doesn't make sense like it does in html5 where
            // it reloads the page
            delta < 0 ? $a809ac530d32f081$var$NavigationDirection.back : $a809ac530d32f081$var$NavigationDirection.forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position]
    });
    return routerHistory;
}
/**
 * Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
 * handle any URL is not possible.
 *
 * @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
 * in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
 * calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
 * after the `#`).
 *
 * @example
 * ```js
 * // at https://example.com/folder
 * createWebHashHistory() // gives a url of `https://example.com/folder#`
 * createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
 * // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
 * createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
 * // you should avoid doing this because it changes the original url and breaks copying urls
 * createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
 *
 * // at file:///usr/etc/folder/index.html
 * // for locations with no `host`, the base is ignored
 * createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
 * ```
 */ function $a809ac530d32f081$export$542bc3a76486c94d(base) {
    // Make sure this implementation is fine in terms of encoding, specially for IE11
    // for `file://`, directly use the pathname and ignore the base
    // location.pathname contains an initial `/` even at the root: `https://example.com`
    base = location.host ? base || location.pathname + location.search : "";
    // allow the user to provide a `#` in the middle: `/base/#/app`
    if (!base.includes("#")) base += "#";
    return $a809ac530d32f081$export$7b4942f78e7b8a49(base);
}
function $a809ac530d32f081$var$isRouteLocation(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $a809ac530d32f081$var$isRouteName(name) {
    return typeof name === "string" || typeof name === "symbol";
}
const $a809ac530d32f081$var$NavigationFailureSymbol = Symbol("");
/**
 * Enumeration with all possible types for navigation failures. Can be passed to
 * {@link isNavigationFailure} to check for specific failures.
 */ var $a809ac530d32f081$export$35710516f95d6a57;
(function(NavigationFailureType) {
    /**
     * An aborted navigation is a navigation that failed because a navigation
     * guard returned `false` or called `next(false)`
     */ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
     * A cancelled navigation is a navigation that failed because a more recent
     * navigation finished started (not necessarily finished).
     */ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
     * A duplicated navigation is a navigation that failed because it was
     * initiated while already being at the exact same location.
     */ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
})($a809ac530d32f081$export$35710516f95d6a57 || ($a809ac530d32f081$export$35710516f95d6a57 = {}));
// DEV only debug messages
const $a809ac530d32f081$var$ErrorTypeMessages = {
    [1 /* ErrorTypes.MATCHER_NOT_FOUND */ ] ({ location: location1, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location1)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$a809ac530d32f081$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [4 /* ErrorTypes.NAVIGATION_ABORTED */ ] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [8 /* ErrorTypes.NAVIGATION_CANCELLED */ ] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [16 /* ErrorTypes.NAVIGATION_DUPLICATED */ ] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
 * Creates a typed NavigationFailure object.
 * @internal
 * @param type - NavigationFailureType
 * @param params - { from, to }
 */ function $a809ac530d32f081$var$createRouterError(type, params) {
    return $a809ac530d32f081$var$assign(new Error(), {
        type: type,
        [$a809ac530d32f081$var$NavigationFailureSymbol]: true
    }, params);
}
function $a809ac530d32f081$export$873de56207a30e5a(error, type) {
    return error instanceof Error && $a809ac530d32f081$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $a809ac530d32f081$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $a809ac530d32f081$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if (to.path != null) return to.path;
    const location1 = {};
    for (const key of $a809ac530d32f081$var$propertiesToLog)if (key in to) location1[key] = to[key];
    return JSON.stringify(location1, null, 2);
}
// default pattern for a param: non-greedy everything but /
const $a809ac530d32f081$var$BASE_PARAM_PATTERN = "[^/]+?";
const $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
// Special Regex characters that must be escaped in static tokens
const $a809ac530d32f081$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
 * Creates a path parser from an array of Segments (a segment is an array of Tokens)
 *
 * @param segments - array of segments returned by tokenizePath
 * @param extraOptions - optional options for the regexp
 * @returns a PathParser
 */ function $a809ac530d32f081$var$tokensToParser(segments, extraOptions) {
    const options = $a809ac530d32f081$var$assign({}, $a809ac530d32f081$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    // the amount of scores is the same as the length of segments except for the root segment "/"
    const score = [];
    // the regexp as a string
    let pattern = options.start ? "^" : "";
    // extracted keys
    const keys = [];
    for (const segment of segments){
        // the root segment needs special treatment
        const segmentScores = segment.length ? [] : [
            90 /* PathScore.Root */ 
        ];
        // allow trailing slash
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            // resets the score if we are inside a sub-segment /:a-other-:b
            let subSegmentScore = 40 /* PathScore.Segment */  + (options.sensitive ? 0.25 /* PathScore.BonusCaseSensitive */  : 0);
            if (token.type === 0 /* TokenType.Static */ ) {
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($a809ac530d32f081$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += 40 /* PathScore.Static */ ;
            } else if (token.type === 1 /* TokenType.Param */ ) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re = regexp ? regexp : $a809ac530d32f081$var$BASE_PARAM_PATTERN;
                // the user provided a custom regexp /:id(\\d+)
                if (re !== $a809ac530d32f081$var$BASE_PARAM_PATTERN) {
                    subSegmentScore += 10 /* PathScore.BonusCustomRegExp */ ;
                    // make sure the regexp is valid before using it
                    try {
                        new RegExp(`(${re})`);
                    } catch (err) {
                        throw new Error(`Invalid custom RegExp for param "${value}" (${re}): ` + err.message);
                    }
                }
                // when we repeat we must take care of the repeating leading slash
                let subPattern = repeatable ? `((?:${re})(?:/(?:${re}))*)` : `(${re})`;
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) subPattern = // avoid an optional / if there are more segments e.g. /:p?-static
                // or /:p?-:p2
                optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += 20 /* PathScore.Dynamic */ ;
                if (optional) subSegmentScore += -8 /* PathScore.BonusOptional */ ;
                if (repeatable) subSegmentScore += -20 /* PathScore.BonusRepeatable */ ;
                if (re === ".*") subSegmentScore += -50 /* PathScore.BonusWildcard */ ;
            }
            segmentScores.push(subSegmentScore);
        }
        // an empty array like /home/ -> [[{home}], []]
        // if (!segment.length) pattern += '/'
        score.push(segmentScores);
    }
    // only apply the strict bonus to the last score
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += 0.7000000000000001 /* PathScore.BonusStrict */ ;
    }
    // TODO: dev only warn double trailing slash
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        // for optional parameters to allow to be empty
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment){
                if (token.type === 0 /* TokenType.Static */ ) path += token.value;
                else if (token.type === 1 /* TokenType.Param */ ) {
                    const { value: value, repeatable: repeatable, optional: optional } = token;
                    const param = value in params ? params[value] : "";
                    if ($a809ac530d32f081$var$isArray(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                    const text = $a809ac530d32f081$var$isArray(param) ? param.join("/") : param;
                    if (!text) {
                        if (optional) // if we have more than one optional param like /:a?-static we don't need to care about the optional param
                        {
                            if (segment.length < 2) {
                                // remove the last slash as we could be at the end
                                if (path.endsWith("/")) path = path.slice(0, -1);
                                else avoidDuplicatedSlash = true;
                            }
                        } else throw new Error(`Missing required param "${value}"`);
                    }
                    path += text;
                }
            }
        }
        // avoid empty path when we have multiple optional params
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
 * Compares an array of numbers as used in PathParser.score and returns a
 * number. This function can be used to `sort` an array
 *
 * @param a - first array of numbers
 * @param b - second array of numbers
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 * should be sorted first
 */ function $a809ac530d32f081$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        // only keep going if diff === 0
        if (diff) return diff;
        i++;
    }
    // if the last subsegment was Static, the shorter segments should be sorted first
    // otherwise sort the longest segment first
    if (a.length < b.length) return a.length === 1 && a[0] === 80 /* PathScore.Segment */  ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 /* PathScore.Segment */  ? 1 : -1;
    return 0;
}
/**
 * Compare function that can be used with `sort` to sort an array of PathParser
 *
 * @param a - first PathParser
 * @param b - second PathParser
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 */ function $a809ac530d32f081$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $a809ac530d32f081$var$compareScoreArray(aScore[i], bScore[i]);
        // do not return if both are equal
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($a809ac530d32f081$var$isLastScoreNegative(aScore)) return 1;
        if ($a809ac530d32f081$var$isLastScoreNegative(bScore)) return -1;
    }
    // if a and b share the same score entries but b has more, sort b first
    return bScore.length - aScore.length;
// this is the ternary version
// return aScore.length < bScore.length
//   ? 1
//   : aScore.length > bScore.length
//   ? -1
//   : 0
}
/**
 * This allows detecting splats at the end of a path: /home/:id(.*)*
 *
 * @param score - score to check
 * @returns true if the last entry is negative
 */ function $a809ac530d32f081$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $a809ac530d32f081$var$ROOT_TOKEN = {
    type: 0 /* TokenType.Static */ ,
    value: ""
};
const $a809ac530d32f081$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
// After some profiling, the cache seems to be unnecessary because tokenizePath
// (the slowest part of adding a route) is very fast
// const tokenCache = new Map<string, Token[][]>()
function $a809ac530d32f081$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $a809ac530d32f081$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Invalid path "${path}"`);
    // if (tokenCache.has(path)) return tokenCache.get(path)!
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = 0 /* TokenizerState.Static */ ;
    let previousState = state;
    const tokens = [];
    // the segment will always be valid because we get into the initial state
    // with the leading /
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    // index on the path
    let i = 0;
    // char at index
    let char;
    // buffer of the value read
    let buffer = "";
    // custom regexp for a param
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0 /* TokenizerState.Static */ ) segment.push({
            type: 0 /* TokenType.Static */ ,
            value: buffer
        });
        else if (state === 1 /* TokenizerState.Param */  || state === 2 /* TokenizerState.ParamRegExp */  || state === 3 /* TokenizerState.ParamRegExpEnd */ ) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: 1 /* TokenType.Param */ ,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== 2 /* TokenizerState.ParamRegExp */ ) {
            previousState = state;
            state = 4 /* TokenizerState.EscapeNext */ ;
            continue;
        }
        switch(state){
            case 0 /* TokenizerState.Static */ :
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = 1 /* TokenizerState.Param */ ;
                } else addCharToBuffer();
                break;
            case 4 /* TokenizerState.EscapeNext */ :
                addCharToBuffer();
                state = previousState;
                break;
            case 1 /* TokenizerState.Param */ :
                if (char === "(") state = 2 /* TokenizerState.ParamRegExp */ ;
                else if ($a809ac530d32f081$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0 /* TokenizerState.Static */ ;
                    // go back one character if we were not modifying
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case 2 /* TokenizerState.ParamRegExp */ :
                // TODO: is it worth handling nested regexp? like :p(?:prefix_([^/]+)_suffix)
                // it already works by escaping the closing )
                // https://paths.esm.dev/?p=AAMeJbiAwQEcDKbAoAAkP60PG2R6QAvgNaA6AFACM2ABuQBB#
                // is this really something people need since you can also write
                // /prefix_:p()_suffix
                if (char === ")") {
                    // handle the escaped )
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = 3 /* TokenizerState.ParamRegExpEnd */ ;
                } else customRe += char;
                break;
            case 3 /* TokenizerState.ParamRegExpEnd */ :
                // same as finalizing a param
                consumeBuffer();
                state = 0 /* TokenizerState.Static */ ;
                // go back one character if we were not modifying
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === 2 /* TokenizerState.ParamRegExp */ ) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    // tokenCache.set(path, tokens)
    return tokens;
}
function $a809ac530d32f081$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $a809ac530d32f081$var$tokensToParser($a809ac530d32f081$var$tokenizePath(record.path), options);
    const matcher = $a809ac530d32f081$var$assign(parser, {
        record: record,
        parent: parent,
        // these needs to be populated by the parent
        children: [],
        alias: []
    });
    if (parent) // both are aliases or both are not aliases
    // we don't want to mix them because the order is used when
    // passing originalRecord in Matcher.addRoute
    {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
/**
 * Creates a Router Matcher.
 *
 * @internal
 * @param routes - array of initial routes
 * @param globalOptions - global route options
 */ function $a809ac530d32f081$export$36302c85fdcc95a8(routes, globalOptions) {
    // normalized ordered array of matchers
    const matchers = [];
    const matcherMap = new Map();
    globalOptions = $a809ac530d32f081$var$mergeOptions({
        strict: false,
        end: true,
        sensitive: false
    }, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        // used later on to remove by name
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $a809ac530d32f081$var$normalizeRouteRecord(record);
        // we might be the child of an alias
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = $a809ac530d32f081$var$mergeOptions(globalOptions, record);
        // generate an array of records to correctly handle aliases
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push(// we need to normalize again to ensure the `mods` property
            // being non enumerable
            $a809ac530d32f081$var$normalizeRouteRecord($a809ac530d32f081$var$assign({}, mainNormalizedRecord, {
                // this allows us to hold a copy of the `components` option
                // so that async components cache is hold on the original record
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                // we might be the child of an alias
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            })));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            // Build up the path for nested routes if the child isn't an absolute
            // route. Only add the / delimiter if the child path isn't empty and if the
            // parent path doesn't have a trailing slash
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            // create the object beforehand, so it can be passed to children
            matcher = $a809ac530d32f081$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            // if we are an alias we must tell the original record that we exist,
            // so we can be removed
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                // otherwise, the first record is the original and others are aliases
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                // remove the route if named and only for the top record (avoid in nested calls)
                // this works because the original record is the first one
                if (isRootAdd && record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            // Avoid adding a record that doesn't display anything. This allows passing through records without a component to
            // not be reached and pass through the catch all route
            if ($a809ac530d32f081$var$isMatchable(matcher)) insertMatcher(matcher);
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            // if there was no original record, then the first one was not an alias and all
            // other aliases (if any) need to reference this record when adding children
            originalRecord = originalRecord || matcher;
        // TODO: add normalized records for more flexibility
        // if (parent && isAliasRecord(originalRecord)) {
        //   parent.children.push(originalRecord)
        // }
        }
        return originalMatcher ? ()=>{
            // since other matchers are aliases, they should be removed by the original matcher
            removeRoute(originalMatcher);
        } : $a809ac530d32f081$var$noop;
    }
    function removeRoute(matcherRef) {
        if ($a809ac530d32f081$var$isRouteName(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        const index = $a809ac530d32f081$var$findInsertionIndex(matcher, matchers);
        matchers.splice(index, 0, matcher);
        // only add the original record to the name map
        if (matcher.record.name && !$a809ac530d32f081$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1
            });
            name = matcher.record.name;
            params = $a809ac530d32f081$var$assign(// paramsFromLocation is a new object
            $a809ac530d32f081$var$paramsFromLocation(currentLocation.params, // only keep params that exist in the resolved location
            // only keep optional params coming from a parent record
            matcher.keys.filter((k)=>!k.optional).concat(matcher.parent ? matcher.parent.keys.filter((k)=>k.optional) : []).map((k)=>k.name)), // discard any existing params in the current location that do not exist here
            // #1497 this ensures better active/exact matching
            location1.params && $a809ac530d32f081$var$paramsFromLocation(location1.params, matcher.keys.map((k)=>k.name)));
            // throws if cannot be stringified
            path = matcher.stringify(params);
        } else if (location1.path != null) {
            // no need to resolve the path with the matcher as it was provided
            // this also allows the user to control the encoding
            path = location1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            // matcher should have a value after the loop
            if (matcher) {
                // we know the matcher works because we tested the regexp
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        // location is a relative path
        } else {
            // match by name or path of current route
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw $a809ac530d32f081$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            // since we are navigating to the same location, we don't need to pick the
            // params like when `name` is provided
            params = $a809ac530d32f081$var$assign({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            // reversed order so parents are at the beginning
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $a809ac530d32f081$var$mergeMetaFields(matched)
        };
    }
    // add initial routes
    routes.forEach((route)=>addRoute(route));
    function clearRoutes() {
        matchers.length = 0;
        matcherMap.clear();
    }
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        clearRoutes: clearRoutes,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
function $a809ac530d32f081$var$paramsFromLocation(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
 * Normalizes a RouteRecordRaw. Creates a copy
 *
 * @param record
 * @returns the normalized version
 */ function $a809ac530d32f081$var$normalizeRouteRecord(record) {
    const normalized = {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: record.aliasOf,
        beforeEnter: record.beforeEnter,
        props: $a809ac530d32f081$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: new Set(),
        updateGuards: new Set(),
        enterCallbacks: {},
        // must be declared afterwards
        // mods: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
    // mods contain modules and shouldn't be copied,
    // logged or anything. It's just used for internal
    // advanced use cases like data loaders
    Object.defineProperty(normalized, "mods", {
        value: {}
    });
    return normalized;
}
/**
 * Normalize the optional `props` in a record to always be an object similar to
 * components. Also accept a boolean for components.
 * @param record
 */ function $a809ac530d32f081$var$normalizeRecordProps(record) {
    const propsObject = {};
    // props does not exist on redirect records, but we can set false directly
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else // NOTE: we could also allow a function to be applied to every component.
    // Would need user feedback for use cases
    for(const name in record.components)propsObject[name] = typeof props === "object" ? props[name] : props;
    return propsObject;
}
/**
 * Checks if a record or any of its parent is an alias
 * @param record
 */ function $a809ac530d32f081$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
 * Merge meta fields of an array of records
 *
 * @param matched - array of matched records
 */ function $a809ac530d32f081$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>$a809ac530d32f081$var$assign(meta, record.meta), {});
}
function $a809ac530d32f081$var$mergeOptions(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
function $a809ac530d32f081$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
 * Check if a path and its alias have the same required params
 *
 * @param a - original record
 * @param b - alias record
 */ function $a809ac530d32f081$var$checkSameParams(a, b) {
    for (const key of a.keys){
        if (!key.optional && !b.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
    for (const key of b.keys){
        if (!key.optional && !a.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
}
/**
 * A route with a name and a child with an empty path without a name should warn when adding the route
 *
 * @param mainNormalizedRecord - RouteRecordNormalized
 * @param parent - RouteRecordMatcher
 */ function $a809ac530d32f081$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) $a809ac530d32f081$var$warn(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $a809ac530d32f081$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys){
        if (!record.keys.find($a809ac530d32f081$var$isSameParam.bind(null, key))) return $a809ac530d32f081$var$warn(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
    }
}
/**
 * Performs a binary search to find the correct insertion index for a new matcher.
 *
 * Matchers are primarily sorted by their score. If scores are tied then we also consider parent/child relationships,
 * with descendants coming before ancestors. If there's still a tie, new routes are inserted after existing routes.
 *
 * @param matcher - new matcher to be inserted
 * @param matchers - existing matchers
 */ function $a809ac530d32f081$var$findInsertionIndex(matcher, matchers) {
    // First phase: binary search based on score
    let lower = 0;
    let upper = matchers.length;
    while(lower !== upper){
        const mid = lower + upper >> 1;
        const sortOrder = $a809ac530d32f081$var$comparePathParserScore(matcher, matchers[mid]);
        if (sortOrder < 0) upper = mid;
        else lower = mid + 1;
    }
    // Second phase: check for an ancestor with the same score
    const insertionAncestor = $a809ac530d32f081$var$getInsertionAncestor(matcher);
    if (insertionAncestor) upper = matchers.lastIndexOf(insertionAncestor, upper - 1);
    return upper;
}
function $a809ac530d32f081$var$getInsertionAncestor(matcher) {
    let ancestor = matcher;
    while(ancestor = ancestor.parent){
        if ($a809ac530d32f081$var$isMatchable(ancestor) && $a809ac530d32f081$var$comparePathParserScore(matcher, ancestor) === 0) return ancestor;
    }
    return;
}
/**
 * Checks if a matcher can be reachable. This means if it's possible to reach it as a route. For example, routes without
 * a component, or name, or redirect, are just used to group other routes.
 * @param matcher
 * @param matcher.record record of the matcher
 * @returns
 */ function $a809ac530d32f081$var$isMatchable({ record: record }) {
    return !!(record.name || record.components && Object.keys(record.components).length || record.redirect);
}
/**
 * Transforms a queryString into a {@link LocationQuery} object. Accept both, a
 * version with the leading `?` and without Should work as URLSearchParams

 * @internal
 *
 * @param search - search string to parse
 * @returns a query object
 */ function $a809ac530d32f081$export$1e8473eaf75b0d10(search) {
    const query = {};
    // avoid creating an object with an empty key and empty value
    // because of split('&')
    if (search === "" || search === "?") return query;
    const hasLeadingIM = search[0] === "?";
    const searchParams = (hasLeadingIM ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        // pre decode the + into space
        const searchParam = searchParams[i].replace($a809ac530d32f081$var$PLUS_RE, " ");
        // allow the = character
        const eqPos = searchParam.indexOf("=");
        const key = $a809ac530d32f081$var$decode(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $a809ac530d32f081$var$decode(searchParam.slice(eqPos + 1));
        if (key in query) {
            // an extra variable for ts types
            let currentValue = query[key];
            if (!$a809ac530d32f081$var$isArray(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
 * Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
 * doesn't prepend a `?`
 *
 * @internal
 *
 * @param query - query object to stringify
 * @returns string version of the query without the leading `?`
 */ function $a809ac530d32f081$export$d33b45a8f796a30(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $a809ac530d32f081$var$encodeQueryKey(key);
        if (value == null) {
            // only null adds the value
            if (value !== undefined) search += (search.length ? "&" : "") + key;
            continue;
        }
        // keep null values
        const values = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v && $a809ac530d32f081$var$encodeQueryValue(v)) : [
            value && $a809ac530d32f081$var$encodeQueryValue(value)
        ];
        values.forEach((value)=>{
            // skip undefined values in arrays as if they were not present
            // smaller code than using filter
            if (value !== undefined) {
                // only append & with non-empty search
                search += (search.length ? "&" : "") + key;
                if (value != null) search += "=" + value;
            }
        });
    }
    return search;
}
/**
 * Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
 * numbers into strings, removing keys with an undefined value and replacing
 * undefined with null in arrays
 *
 * @param query - query object to normalize
 * @returns a normalized query object
 */ function $a809ac530d32f081$var$normalizeQuery(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== undefined) normalizedQuery[key] = $a809ac530d32f081$var$isArray(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
/**
 * RouteRecord being rendered by the closest ancestor Router View. Used for
 * `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
 * Location Matched
 *
 * @internal
 */ const $a809ac530d32f081$export$7f4879db1558672d = Symbol("");
/**
 * Allows overriding the router view depth to control which component in
 * `matched` is rendered. rvd stands for Router View Depth
 *
 * @internal
 */ const $a809ac530d32f081$export$9b3825c34ca1427a = Symbol("");
/**
 * Allows overriding the router instance returned by `useRouter` in tests. r
 * stands for router
 *
 * @internal
 */ const $a809ac530d32f081$export$b6c0da8b9dae491f = Symbol("");
/**
 * Allows overriding the current route returned by `useRoute` in tests. rl
 * stands for route location
 *
 * @internal
 */ const $a809ac530d32f081$export$3aca783e9a3e6e9e = Symbol("");
/**
 * Allows overriding the current route used by router-view. Internally this is
 * used when the `route` prop is passed.
 *
 * @internal
 */ const $a809ac530d32f081$export$54c8124bead129f8 = Symbol("");
/**
 * Create a list of callbacks that can be reset. Used to create before and after navigation guards list
 */ function $a809ac530d32f081$var$useCallbacks() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
function $a809ac530d32f081$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $TusQn.onUnmounted)(removeFromList);
    (0, $TusQn.onDeactivated)(removeFromList);
    (0, $TusQn.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
 * Add a navigation guard that triggers whenever the component for the current
 * location is about to be left. Similar to {@link beforeRouteLeave} but can be
 * used in any component. The guard is removed when the component is unmounted.
 *
 * @param leaveGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$d7fcdd004b009a9e(leaveGuard) {
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $a809ac530d32f081$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
 * Add a navigation guard that triggers whenever the current location is about
 * to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
 * component. The guard is removed when the component is unmounted.
 *
 * @param updateGuard - {@link NavigationGuard}
 */ function $a809ac530d32f081$export$46b4cb99461f4cc7(updateGuard) {
    const activeRecord = (0, $TusQn.inject)($a809ac530d32f081$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $a809ac530d32f081$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    // keep a reference to the enterCallbackArray to prevent pushing callbacks if a new navigation took place
    const enterCallbackArray = record && // name is defined if record is because of the function overload
    (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($a809ac530d32f081$var$createRouterError(4 /* ErrorTypes.NAVIGATION_ABORTED */ , {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($a809ac530d32f081$var$isRouteLocation(valid)) reject($a809ac530d32f081$var$createRouterError(2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ , {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && // since enterCallbackArray is truthy, both record and name also are
                    record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            // wrapping with Promise.resolve allows it to work with both async and sync guards
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, next));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $a809ac530d32f081$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $a809ac530d32f081$var$warn(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        // @ts-expect-error: we put it in the original one because it's easier to check
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $a809ac530d32f081$var$extractComponentsGuards(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        // skip update and leave guards if the route component is not mounted
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($a809ac530d32f081$var$isRouteComponent(rawComponent)) {
            // __vccOpts is added by vue-class-component and contain the regular options
            const options = rawComponent.__vccOpts || rawComponent;
            const guard = options[guardType];
            guard && guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext));
        } else {
            // start requesting the chunk already
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) throw new Error(`Couldn't resolve component "${name}" at "${record.path}"`);
                    const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                    // keep the resolved module for plugins like data loaders
                    record.mods[name] = resolved;
                    // replace the function with the resolved component
                    // cannot be null or undefined because we went into the for loop
                    record.components[name] = resolvedComponent;
                    // __vccOpts is added by vue-class-component and contain the regular options
                    const options = resolvedComponent.__vccOpts || resolvedComponent;
                    const guard = options[guardType];
                    return guard && $a809ac530d32f081$var$guardToPromiseFn(guard, to, from, record, name, runWithContext)();
                }));
        }
    }
    return guards;
}
/**
 * Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
 *
 * @param route - resolved route to load
 */ function $a809ac530d32f081$export$d092a02cbf0deea7(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $a809ac530d32f081$var$isESModule(resolved) ? resolved.default : resolved;
                // keep the resolved module for plugins like data loaders
                record.mods[name] = resolved;
                // replace the function with the resolved component
                // cannot be null or undefined because we went into the for loop
                record.components[name] = resolvedComponent;
                return;
            }));
            return promises;
        }, [])))).then(()=>route);
}
// TODO: we could allow currentRoute as a prop to expose `isActive` and
// `isExactActive` behavior should go through an RFC
/**
 * Returns the internal behavior of a {@link RouterLink} without the rendering part.
 *
 * @param props - a `to` location and an optional `replace` flag
 */ function $a809ac530d32f081$export$dcf14c9974fe2767(props) {
    const router = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
    const currentRoute = (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
    let hasPrevious = false;
    let previousTo = null;
    const route = (0, $TusQn.computed)(()=>{
        const to = (0, $01W3b.unref)(props.to);
        return router.resolve(to);
    });
    const activeRecordIndex = (0, $TusQn.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, routeMatched));
        if (index > -1) return index;
        // possible parent record
        const parentRecordPath = $a809ac530d32f081$var$getOriginalPath(matched[length - 2]);
        return(// we are dealing with nested routes
        length > 1 && // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        $a809ac530d32f081$var$getOriginalPath(routeMatched) === parentRecordPath && // avoid comparing the child with its parent
        currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex($a809ac530d32f081$var$isSameRouteRecord.bind(null, matched[length - 2])) : index);
    });
    const isActive = (0, $TusQn.computed)(()=>activeRecordIndex.value > -1 && $a809ac530d32f081$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $TusQn.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && $a809ac530d32f081$var$isSameRouteLocationParams(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($a809ac530d32f081$var$guardEvent(e)) return router[(0, $01W3b.unref)(props.replace) ? "replace" : "push"]((0, $01W3b.unref)(props.to)).catch($a809ac530d32f081$var$noop);
        return Promise.resolve();
    }
    // devtools only
    if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser) {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value,
                error: null
            };
            // @ts-expect-error: this is internal
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            // @ts-expect-error: this is internal
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $TusQn.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
                linkContextDevtools.error = $a809ac530d32f081$var$isRouteLocation((0, $01W3b.unref)(props.to)) ? null : 'Invalid "to" value';
            }, {
                flush: "post"
            });
        }
    }
    /**
     * NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
     */ return {
        route: route,
        href: (0, $TusQn.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
const $a809ac530d32f081$var$RouterLinkImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        }
    },
    useLink: $a809ac530d32f081$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $01W3b.reactive)($a809ac530d32f081$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
        const elClass = (0, $TusQn.computed)(()=>({
                [$a809ac530d32f081$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                // [getLinkClass(
                //   props.inactiveClass,
                //   options.linkInactiveClass,
                //   'router-link-inactive'
                // )]: !link.isExactActive,
                [$a809ac530d32f081$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && slots.default(link);
            return props.custom ? children : (0, $TusQn.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                // this would override user added attrs but Vue will still add
                // the listener, so we end up triggering both
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to render a link that triggers a navigation on click.
 */ const $a809ac530d32f081$export$fce709ebdac448ed = $a809ac530d32f081$var$RouterLinkImpl;
function $a809ac530d32f081$var$guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented) return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) return;
    // don't redirect if `target="_blank"`
    // @ts-expect-error getAttribute does exist
    if (e.currentTarget && e.currentTarget.getAttribute) {
        // @ts-expect-error getAttribute exists
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $a809ac530d32f081$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else {
            if (!$a809ac530d32f081$var$isArray(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value !== outerValue[i])) return false;
        }
    }
    return true;
}
/**
 * Get the original path value of a record by following its aliasOf
 * @param record
 */ function $a809ac530d32f081$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
 * Utility class to get the active class based on defaults.
 * @param propClass
 * @param globalClass
 * @param defaultClass
 */ const $a809ac530d32f081$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
const $a809ac530d32f081$var$RouterViewImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    name: "RouterView",
    // #674 we manually inherit them
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    // Better compat for @vue/compat users
    // https://github.com/vuejs/router/issues/1315
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $TusQn.inject)($a809ac530d32f081$export$54c8124bead129f8);
        const routeToDisplay = (0, $TusQn.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $TusQn.inject)($a809ac530d32f081$export$9b3825c34ca1427a, 0);
        // The depth changes based on empty components option, which allows passthrough routes e.g. routes with children
        // that are used to reuse the `path` property
        const depth = (0, $TusQn.computed)(()=>{
            let initialDepth = (0, $01W3b.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $TusQn.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $TusQn.provide)($a809ac530d32f081$export$9b3825c34ca1427a, (0, $TusQn.computed)(()=>depth.value + 1));
        (0, $TusQn.provide)($a809ac530d32f081$export$7f4879db1558672d, matchedRouteRef);
        (0, $TusQn.provide)($a809ac530d32f081$export$54c8124bead129f8, routeToDisplay);
        const viewRef = (0, $01W3b.ref)();
        // watch at the same time the component instance, the route record we are
        // rendering, and the name
        (0, $TusQn.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            // copy reused instances
            if (to) {
                // this will update the instance for new instances as well as reused
                // instances when navigating to a new route
                to.instances[name] = instance;
                // the component instance is reused for a different route or name, so
                // we copy any saved update or leave guards. With async setup, the
                // mounting component will mount before the matchedRoute changes,
                // making instance === oldInstance, so we check if guards have been
                // added before. This works because we remove guards when
                // unmounting/deactivating components
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            // trigger beforeRouteEnter next callbacks
            if (instance && to && // if there is no instance but to and from are the same this might be
            // the first visit
            (!from || !$a809ac530d32f081$var$isSameRouteRecord(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            // we need the value at the time we render because when we unmount, we
            // navigated to a different location so the value is different
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            // props from route configuration
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                // remove the instance reference to prevent leak
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $TusQn.h)(ViewComponent, $a809ac530d32f081$var$assign({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser && component.ref) {
                // TODO: can display if it's an alias, its props
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                const internalInstances = $a809ac530d32f081$var$isArray(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ];
                internalInstances.forEach((instance)=>{
                    // @ts-expect-error
                    instance.__vrv_devtools = info;
                });
            }
            return(// pass the vnode to the slot as a prop.
            // h and <component :is="..."> both accept vnodes
            $a809ac530d32f081$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component);
        };
    }
});
function $a809ac530d32f081$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to display the current route the user is at.
 */ const $a809ac530d32f081$export$d941f00e9b9a537 = $a809ac530d32f081$var$RouterViewImpl;
// warn against deprecated usage with <transition> & <keep-alive>
// due to functional component being no longer eager in Vue 3
function $a809ac530d32f081$var$warnDeprecatedUsage() {
    const instance = (0, $TusQn.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        $a809ac530d32f081$var$warn(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.\n` + `Use slot props instead:\n\n` + `<router-view v-slot="{ Component }">\n` + `  <${comp}>\n` + `    <component :is="Component" />\n` + `  </${comp}>\n` + `</router-view>`);
    }
}
/**
 * Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
 *
 * @param routeLocation - routeLocation to format
 * @param tooltip - optional tooltip
 * @returns a copy of the routeLocation
 */ function $a809ac530d32f081$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $a809ac530d32f081$var$assign({}, routeLocation, {
        // remove variables that can contain vue instances
        matched: routeLocation.matched.map((matched)=>$a809ac530d32f081$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $a809ac530d32f081$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
// to support multiple router instances
let $a809ac530d32f081$var$routerId = 0;
function $a809ac530d32f081$var$addDevtools(app, router, matcher) {
    // Take over router.beforeEach and afterEach
    // make sure we are not registering the devtool twice
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    // increment to support multiple router instances
    const id = $a809ac530d32f081$var$routerId++;
    (0, $j6G8F.setupDevtoolsPlugin)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") console.warn("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        // display state added by the router
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $a809ac530d32f081$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        // mark router-link as active and display tags on router views
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $a809ac530d32f081$var$PINK_500
                });
            }
            // if multiple useLink are used
            if ($a809ac530d32f081$var$isArray(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let label = devtoolsData.route.path;
                    let backgroundColor = $a809ac530d32f081$var$ORANGE_400;
                    let tooltip = "";
                    let textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $a809ac530d32f081$var$RED_100;
                        textColor = $a809ac530d32f081$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $a809ac530d32f081$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $a809ac530d32f081$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $TusQn.watch)(router.currentRoute, ()=>{
            // refresh active state
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 0x40a8c4
        });
        // const errorsLayerId = 'router:errors'
        // api.addTimelineLayer({
        //   id: errorsLayerId,
        //   label: 'Router Errors',
        //   color: 0xea5455,
        // })
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        // attached to `meta` and used to group events
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay("beforeEach"),
                from: $a809ac530d32f081$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $a809ac530d32f081$var$formatRouteLocation(to, "Target location")
            };
            // Used to group navigations together, hide from devtools
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $a809ac530d32f081$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $a809ac530d32f081$var$formatDisplay("\u274C");
            } else data.status = $a809ac530d32f081$var$formatDisplay("\u2705");
            // we set here to have the right order
            data.from = $a809ac530d32f081$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $a809ac530d32f081$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
         * Inspector of Existing routes
         */ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            // the routes view isn't active
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            // children routes will appear as nested
            let routes = matcher.getRoutes().filter((route)=>!route.parent || // these routes have a parent with no component which will not appear in the view
                // therefore we still need to include them
                !route.parent.record.components);
            // reset match state to false
            routes.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
            // apply a match state if there is a payload
            if (payload.filter) routes = routes.filter((route)=>// save matches state based on the payload
                $a809ac530d32f081$var$isRouteMatching(route, payload.filter.toLowerCase()));
            // mark active routes
            routes.forEach((route)=>$a809ac530d32f081$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($a809ac530d32f081$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
         * Display information about the currently selected route record
         */ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const routes = matcher.getRoutes();
                const route = routes.find((route)=>route.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $a809ac530d32f081$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $a809ac530d32f081$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$a809ac530d32f081$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
 * Extracted from tailwind palette
 */ const $a809ac530d32f081$var$PINK_500 = 0xec4899;
const $a809ac530d32f081$var$BLUE_600 = 0x2563eb;
const $a809ac530d32f081$var$LIME_500 = 0x84cc16;
const $a809ac530d32f081$var$CYAN_400 = 0x22d3ee;
const $a809ac530d32f081$var$ORANGE_400 = 0xfb923c;
// const GRAY_100 = 0xf4f4f5
const $a809ac530d32f081$var$DARK = 0x666666;
const $a809ac530d32f081$var$RED_100 = 0xfee2e2;
const $a809ac530d32f081$var$RED_700 = 0xb91c1c;
function $a809ac530d32f081$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $a809ac530d32f081$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 0xffffff,
        backgroundColor: $a809ac530d32f081$var$DARK
    });
    // add an id to be able to select it. Using the `path` is not possible because
    // empty path children would collide with their parents
    let id = record.__vd_id;
    if (id == null) {
        id = String($a809ac530d32f081$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($a809ac530d32f081$var$formatRouteRecordForInspector)
    };
}
//  incremental id for route records and inspector state
let $a809ac530d32f081$var$routeRecordId = 0;
const $a809ac530d32f081$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $a809ac530d32f081$var$markRouteRecordActive(route, currentRoute) {
    // no route will be active if matched is empty
    // reset the matching state
    const isExactActive = currentRoute.matched.length && $a809ac530d32f081$var$isSameRouteRecord(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$a809ac530d32f081$var$isSameRouteRecord(match, route.record));
    route.children.forEach((childRoute)=>$a809ac530d32f081$var$markRouteRecordActive(childRoute, currentRoute));
}
function $a809ac530d32f081$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($a809ac530d32f081$var$resetMatchStateOnRouteRecord);
}
function $a809ac530d32f081$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($a809ac530d32f081$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    // use a regexp without $ at the end to match nested routes better
    const nonEndingRE = new RegExp(found[1].replace(/\$$/, ""), found[2]);
    if (nonEndingRE.test(filter)) {
        // mark children as matches
        route.children.forEach((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
        // exception case: `/`
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        // hide the / route
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $a809ac530d32f081$var$decode(path);
    // also allow partial matching on the path
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$a809ac530d32f081$var$isRouteMatching(child, filter));
}
function $a809ac530d32f081$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) // @ts-expect-error
    ret[key] = obj[key];
    return ret;
}
/**
 * Creates a Router instance that can be used by a Vue app.
 *
 * @param options - {@link RouterOptions}
 */ function $a809ac530d32f081$export$baddd0131ee8c05b(options) {
    const matcher = $a809ac530d32f081$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || $a809ac530d32f081$export$1e8473eaf75b0d10;
    const stringifyQuery$1 = options.stringifyQuery || $a809ac530d32f081$export$d33b45a8f796a30;
    const routerHistory = options.history;
    const beforeGuards = $a809ac530d32f081$var$useCallbacks();
    const beforeResolveGuards = $a809ac530d32f081$var$useCallbacks();
    const afterGuards = $a809ac530d32f081$var$useCallbacks();
    const currentRoute = (0, $01W3b.shallowRef)($a809ac530d32f081$export$e44be9a9779c480b);
    let pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
    // leave the scrollRestoration if no scrollBehavior is provided
    if ($a809ac530d32f081$var$isBrowser && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = $a809ac530d32f081$var$applyToParams.bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$encodeParam);
    const decodeParams = // @ts-expect-error: intentionally avoid the type check
    $a809ac530d32f081$var$applyToParams.bind(null, $a809ac530d32f081$var$decode);
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ($a809ac530d32f081$var$isRouteName(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        // const resolve: Router['resolve'] = (rawLocation: RouteLocationRaw, currentLocation) => {
        // const objectLocation = routerLocationAsObject(rawLocation)
        // we create a copy to modify it later
        currentLocation = $a809ac530d32f081$var$assign({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href = routerHistory.createHref(locationNormalized.fullPath);
            // locationNormalized is always a new object
            return $a809ac530d32f081$var$assign(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                hash: $a809ac530d32f081$var$decode(locationNormalized.hash),
                redirectedFrom: undefined,
                href: href
            });
        }
        let matcherLocation;
        // path could be relative in object as well
        if (rawLocation.path != null) matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
            path: $a809ac530d32f081$var$parseURL(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            // remove any nullish param
            const targetParams = $a809ac530d32f081$var$assign({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            // pass encoded values to the matcher, so it can produce encoded path and fullPath
            matcherLocation = $a809ac530d32f081$var$assign({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            // current location params are decoded, we need to encode them in case the
            // matcher merges the params
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        // the matcher might have merged current location params, so
        // we need to run the decoding again
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = $a809ac530d32f081$var$stringifyURL(stringifyQuery$1, $a809ac530d32f081$var$assign({}, rawLocation, {
            hash: $a809ac530d32f081$var$encodeHash(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return $a809ac530d32f081$var$assign({
            fullPath: fullPath,
            hash: // keep the hash encoded so fullPath is effectively path + encodedQuery +
            // hash
            hash,
            query: // if the user is using a custom query lib like qs, we might have
            // nested objects, so we keep the query as is, meaning it can contain
            // numbers at `$route.query`, but at the point, the user will have to
            // use their own type anyway.
            // https://github.com/vuejs/router/issues/328#issuecomment-649481567
            stringifyQuery$1 === $a809ac530d32f081$export$d33b45a8f796a30 ? $a809ac530d32f081$var$normalizeQuery(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: undefined,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? $a809ac530d32f081$var$parseURL(parseQuery$1, to, currentRoute.value.path) : $a809ac530d32f081$var$assign({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return $a809ac530d32f081$var$createRouterError(8 /* ErrorTypes.NAVIGATION_CANCELLED */ , {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push($a809ac530d32f081$var$assign(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                // @ts-expect-error: force empty params when a string is passed to let
                // the router parse them again
                newTargetLocation.params = {};
            }
            return $a809ac530d32f081$var$assign({
                query: to.query,
                hash: to.hash,
                // avoid transferring params if the redirect has a path
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        // to could be a string where `replace` is a function
        const replace = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation);
        if (shouldRedirect) return pushWithRedirect($a809ac530d32f081$var$assign(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? $a809ac530d32f081$var$assign({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace
        }), // keep original redirectedFrom if it exists
        redirectedFrom || targetLocation);
        // if it was a redirect we already called `pushWithRedirect` above
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && $a809ac530d32f081$var$isSameRouteLocation(stringifyQuery$1, from, targetLocation)) {
            failure = $a809ac530d32f081$var$createRouterError(16 /* ErrorTypes.NAVIGATION_DUPLICATED */ , {
                to: toLocation,
                from: from
            });
            // trigger scroll to allow scrolling to the same anchor
            handleScroll(from, from, // this is a push, the only way for it to be triggered from a
            // history.listen is with a redirect, which makes it become a push
            true, // This cannot be the first navigation because the initial location
            // cannot be manually navigated to
            false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>$a809ac530d32f081$export$873de56207a30e5a(error) ? $a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ) ? error : markAsReady(error) // also returns the error
             : triggerError(error, toLocation, from)).then((failure)=>{
            if (failure) {
                if ($a809ac530d32f081$export$873de56207a30e5a(failure, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) return pushWithRedirect(// keep options
                $a809ac530d32f081$var$assign({
                    replace: // preserve an existing replacement but allow the redirect to override it
                    replace
                }, locationAsObject(failure.to), {
                    state: typeof failure.to === "object" ? $a809ac530d32f081$var$assign({}, data, failure.to.state) : data,
                    force: force
                }), // preserve the original redirectedFrom if any
                redirectedFrom || toLocation);
            } else // if we fail we don't finalize the navigation
            failure = finalizeNavigation(toLocation, from, true, replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
     * Helper to reject and skip all navigation guards if a new navigation happened
     * @param to
     * @param from
     */ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        // support Vue < 3.3
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    // TODO: refactor the whole before guards by internally using router.beforeEach
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = $a809ac530d32f081$var$extractChangingRecords(to, from);
        // all components here have been resolved once because we are leaving
        guards = $a809ac530d32f081$var$extractComponentsGuards(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        // leavingRecords is already reversed
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        // run the queue of per route beforeRouteLeave guards
        return runGuardQueue(guards).then(()=>{
            // check global guards beforeEach
            guards = [];
            for (const guard of beforeGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            // check in components beforeRouteUpdate
            guards = $a809ac530d32f081$var$extractComponentsGuards(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check the route beforeEnter
            guards = [];
            for (const record of enteringRecords)// do not trigger beforeEnter on reused views
            if (record.beforeEnter) {
                if ($a809ac530d32f081$var$isArray(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push($a809ac530d32f081$var$guardToPromiseFn(beforeEnter, to, from));
                else guards.push($a809ac530d32f081$var$guardToPromiseFn(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // NOTE: at this point to.matched is normalized and does not contain any () => Promise<Component>
            // clear existing enterCallbacks, these are added by extractComponentsGuards
            to.matched.forEach((record)=>record.enterCallbacks = {});
            // check in-component beforeRouteEnter
            guards = $a809ac530d32f081$var$extractComponentsGuards(enteringRecords, "beforeRouteEnter", to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check global guards beforeResolve
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push($a809ac530d32f081$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        })// catch any navigation canceled
        .catch((err)=>$a809ac530d32f081$export$873de56207a30e5a(err, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ ) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        // navigation is confirmed, call afterGuards
        // TODO: wrap with error handlers
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
     * - Cleans up any navigation guards
     * - Changes the url if necessary
     * - Calls the scrollBehavior
     */ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        // a more recent navigation took place
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        // only consider as push if it's not the first navigation
        const isFirstNavigation = from === $a809ac530d32f081$export$e44be9a9779c480b;
        const state = !$a809ac530d32f081$var$isBrowser ? {} : history.state;
        // change URL only if the user did a push/replace and if it's not the initial navigation because
        // it's just reflecting the url
        if (isPush) {
            // on the initial navigation, we want to reuse the scroll position from
            // history state if it exists
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, $a809ac530d32f081$var$assign({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        // accept current navigation
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    // attach listener to history to trigger navigations
    function setupListeners() {
        // avoid setting up listeners twice due to an invalid first navigation
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            // cannot be a redirect route because it was in history
            const toLocation = resolve(to);
            // due to dynamic routing, and to hash history with manual navigation
            // (manually changing the url or calling history.hash = '#/somewhere'),
            // there could be a redirect record in history
            const shouldRedirect = handleRedirectRecord(toLocation);
            if (shouldRedirect) {
                pushWithRedirect($a809ac530d32f081$var$assign(shouldRedirect, {
                    replace: true
                }), toLocation).catch($a809ac530d32f081$var$noop);
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            // TODO: should be moved to web history?
            if ($a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$saveScrollPosition($a809ac530d32f081$var$getScrollKey(from.fullPath, info.delta), $a809ac530d32f081$var$computeScrollPosition());
            navigate(toLocation, from).catch((error)=>{
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 12 /* ErrorTypes.NAVIGATION_CANCELLED */ )) return error;
                if ($a809ac530d32f081$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) {
                    // Here we could call if (info.delta) routerHistory.go(-info.delta,
                    // false) but this is bug prone as we have no way to wait the
                    // navigation to be finished before calling pushWithRedirect. Using
                    // a setTimeout of 16ms seems to work but there is no guarantee for
                    // it to work on every browser. So instead we do not restore the
                    // history entry and trigger a new navigation as requested by the
                    // navigation guard.
                    // the error is already handled by router.push we just want to avoid
                    // logging the error
                    pushWithRedirect(error.to, toLocation).then((failure)=>{
                        // manual change in hash history #916 ending up in the URL not
                        // changing, but it was changed by the manual url change, so we
                        // need to manually change it ourselves
                        if ($a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ ) && !info.delta && info.type === $a809ac530d32f081$var$NavigationType.pop) routerHistory.go(-1, false);
                    }).catch($a809ac530d32f081$var$noop);
                    // avoid the then branch
                    return Promise.reject();
                }
                // do not restore history on unknown direction
                if (info.delta) routerHistory.go(-info.delta, false);
                // unrecognized error, transfer to the global handler
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(// after navigation, all matched components are resolved
                toLocation, from, false);
                // revert the navigation
                if (failure) {
                    if (info.delta && // a new navigation has been triggered, so we do not want to revert, that will change the current history
                    // entry while a different route is displayed
                    !$a809ac530d32f081$export$873de56207a30e5a(failure, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ )) routerHistory.go(-info.delta, false);
                    else if (info.type === $a809ac530d32f081$var$NavigationType.pop && $a809ac530d32f081$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ )) // manual change in hash history #916
                    // it's like a push but lacks the information of the direction
                    routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            })// avoid warnings in the console about uncaught rejections, they are logged by triggerErrors
            .catch($a809ac530d32f081$var$noop);
        });
    }
    // Initialization and Errors
    let readyHandlers = $a809ac530d32f081$var$useCallbacks();
    let errorListeners = $a809ac530d32f081$var$useCallbacks();
    let ready;
    /**
     * Trigger errorListeners added via onError and throws the error as well
     *
     * @param error - error to throw
     * @param to - location we were navigating to when the error happened
     * @param from - location we were navigating from when the error happened
     * @returns the error as a rejected promise
     */ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        // reject the error no matter there were error listeners or not
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== $a809ac530d32f081$export$e44be9a9779c480b) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            // still not ready if an error happened
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve, reject])=>err ? reject(err) : resolve());
            readyHandlers.reset();
        }
        return err;
    }
    // Scroll behavior
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!$a809ac530d32f081$var$isBrowser || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && $a809ac530d32f081$var$getSavedScrollPosition($a809ac530d32f081$var$getScrollKey(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $TusQn.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && $a809ac530d32f081$var$scrollToPosition(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        clearRoutes: matcher.clearRoutes,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            const router = this;
            app.component("RouterLink", $a809ac530d32f081$export$fce709ebdac448ed);
            app.component("RouterView", $a809ac530d32f081$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $01W3b.unref)(currentRoute)
            });
            // this initial navigation is only necessary on client, on server it doesn't
            // make sense because it will create an extra unnecessary navigation and could
            // lead to problems
            if ($a809ac530d32f081$var$isBrowser && // used for the initial navigation client side to avoid pushing
            // multiple times when the router is used in multiple apps
            !started && currentRoute.value === $a809ac530d32f081$export$e44be9a9779c480b) {
                // see above
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in $a809ac530d32f081$export$e44be9a9779c480b)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide($a809ac530d32f081$export$b6c0da8b9dae491f, router);
            app.provide($a809ac530d32f081$export$3aca783e9a3e6e9e, (0, $01W3b.shallowReactive)(reactiveRoute));
            app.provide($a809ac530d32f081$export$54c8124bead129f8, currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                // the router is not attached to an app anymore
                if (installedApps.size < 1) {
                    // invalidate the current navigation
                    pendingLocation = $a809ac530d32f081$export$e44be9a9779c480b;
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = $a809ac530d32f081$export$e44be9a9779c480b;
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            // TODO: this probably needs to be updated so it can be used by vue-termui
            if (__VUE_PROD_DEVTOOLS__ && $a809ac530d32f081$var$isBrowser) $a809ac530d32f081$var$addDevtools(app, router, matcher);
        }
    };
    // TODO: type this as NavigationGuardReturn or similar instead of any
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
function $a809ac530d32f081$var$extractChangingRecords(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) // the type doesn't matter because we are comparing per reference
        {
            if (!from.matched.find((record)=>$a809ac530d32f081$var$isSameRouteRecord(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
/**
 * Returns the router instance. Equivalent to using `$router` inside
 * templates.
 */ function $a809ac530d32f081$export$9a302a45f65d0572() {
    return (0, $TusQn.inject)($a809ac530d32f081$export$b6c0da8b9dae491f);
}
/**
 * Returns the current route location. Equivalent to using `$route` inside
 * templates.
 */ function $a809ac530d32f081$export$3f79f0b98112cf57(_name) {
    return (0, $TusQn.inject)($a809ac530d32f081$export$3aca783e9a3e6e9e);
}

});
parcelRegister("j6G8F", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", () => $de8f43bece76d38a$export$63b9a9bba9f20f3e);

var $jiSSU = parcelRequire("jiSSU");

var $7mHjb = parcelRequire("7mHjb");

var $83xTH = parcelRequire("83xTH");



function $de8f43bece76d38a$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $jiSSU.getTarget)();
    const hook = (0, $jiSSU.getDevtoolsGlobalHook)();
    const enableProxy = (0, $jiSSU.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $7mHjb.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $83xTH.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRegister("jiSSU", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", () => $e0da45b668fffb6e$export$5a2d366b2d9f38f6);
$parcel$export(module.exports, "getTarget", () => $e0da45b668fffb6e$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isProxyAvailable", () => $e0da45b668fffb6e$export$bc32a04c49ed7464);
function $e0da45b668fffb6e$export$5a2d366b2d9f38f6() {
    return $e0da45b668fffb6e$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $e0da45b668fffb6e$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : {};
}
const $e0da45b668fffb6e$export$bc32a04c49ed7464 = typeof Proxy === "function";

});

parcelRegister("7mHjb", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", () => $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df);
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", () => $55cc2ea2e53f2ca6$export$a0897f44accbe922);
const $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df = "devtools-plugin:setup";
const $55cc2ea2e53f2ca6$export$a0897f44accbe922 = "plugin:settings:set";

});

parcelRegister("83xTH", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", () => $5dd8e5d828be8ae1$export$5728f3776e9b2ac1);

var $7mHjb = parcelRequire("7mHjb");

var $2QQ8V = parcelRequire("2QQ8V");
class $5dd8e5d828be8ae1$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $2QQ8V.now)();
            }
        };
        if (hook) hook.on((0, $7mHjb.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === "on") return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRegister("2QQ8V", function(module, exports) {

$parcel$export(module.exports, "now", () => $2138e2947b5f69c4$export$461939dd4422153);
let $2138e2947b5f69c4$var$supported;
let $2138e2947b5f69c4$var$perf;
function $2138e2947b5f69c4$export$70d26280bc1ca547() {
    var _a;
    if ($2138e2947b5f69c4$var$supported !== undefined) return $2138e2947b5f69c4$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = window.performance;
    } else if (typeof globalThis !== "undefined" && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = globalThis.perf_hooks.performance;
    } else $2138e2947b5f69c4$var$supported = false;
    return $2138e2947b5f69c4$var$supported;
}
function $2138e2947b5f69c4$export$461939dd4422153() {
    return $2138e2947b5f69c4$export$70d26280bc1ca547() ? $2138e2947b5f69c4$var$perf.now() : Date.now();
}

});





parcelRegister("3NNX1", function(module, exports) {

$parcel$export(module.exports, "render", () => $2c4cb1eb429dee56$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $2c4cb1eb429dee56$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterView = (0, $TusQn.resolveComponent)("RouterView");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_RouterView, {
        class: "container"
    });
}

});

parcelRegister("1rrBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cdb945e864b702$export$2e2bcd8739ae039);
let $10cdb945e864b702$var$NOOP = ()=>{};
var $10cdb945e864b702$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("96vUA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6a0d6d9cac0c9d09$export$2e2bcd8739ae039);

var $ajjle = parcelRequire("ajjle");
var $6a0d6d9cac0c9d09$export$2e2bcd8739ae039 = {
    name: "HomePage",
    components: {
        Page: $ajjle.default
    }
};

});
parcelRegister("ajjle", function(module, exports) {

$parcel$export(module.exports, "default", () => $781aae89af11f27e$export$2e2bcd8739ae039);
let $781aae89af11f27e$var$script;




let $781aae89af11f27e$var$initialize = ()=>{
    $781aae89af11f27e$var$script = (parcelRequire("heZod"));
    if ($781aae89af11f27e$var$script.__esModule) $781aae89af11f27e$var$script = $781aae89af11f27e$var$script.default;
    $781aae89af11f27e$var$script.render = (parcelRequire("2SHkk")).render;
    $781aae89af11f27e$var$script.__cssModules = {};
    (parcelRequire("lh9pp")).default($781aae89af11f27e$var$script);
    $781aae89af11f27e$var$script.__scopeId = "data-v-ef896c";
    $781aae89af11f27e$var$script.__file = "Page.vue";
};
$781aae89af11f27e$var$initialize();
var $781aae89af11f27e$export$2e2bcd8739ae039 = $781aae89af11f27e$var$script;

});
parcelRegister("heZod", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c8d35d2c75a5ceeb$export$2e2bcd8739ae039);
var $c8d35d2c75a5ceeb$export$2e2bcd8739ae039 = {
    name: "Page"
};

});

parcelRegister("2SHkk", function(module, exports) {

$parcel$export(module.exports, "render", () => $21923bb9d95ed9c8$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $21923bb9d95ed9c8$var$_hoisted_1 = {
    class: "page"
};
function $21923bb9d95ed9c8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("main", $21923bb9d95ed9c8$var$_hoisted_1, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
    ]);
}

});

parcelRegister("lh9pp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d27be89417a373$export$2e2bcd8739ae039);
let $f7d27be89417a373$var$NOOP = ()=>{};
var $f7d27be89417a373$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("dYItq", function(module, exports) {

$parcel$export(module.exports, "render", () => $a2d3608377c15247$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $a2d3608377c15247$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Page = (0, $TusQn.resolveComponent)("Page");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_Page, {
        class: "page--home"
    });
}

});

parcelRegister("577Tp", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b93ba82c1e5ce72$export$2e2bcd8739ae039);
let $3b93ba82c1e5ce72$var$NOOP = ()=>{};
var $3b93ba82c1e5ce72$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("1BvCm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $12b1c5c1faa62475$export$2e2bcd8739ae039);

var $ajjle = parcelRequire("ajjle");

var $7vIxa = parcelRequire("7vIxa");

var $1H5o3 = parcelRequire("1H5o3");
var $12b1c5c1faa62475$export$2e2bcd8739ae039 = {
    name: "Explore",
    components: {
        Page: $ajjle.default,
        Searcher: $7vIxa.default,
        Snapshot: $1H5o3.default
    },
    data () {
        return {
            skins: [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {} /* , Add */ 
            ]
        };
    },
    methods: {
        onSearch (skins) {
            this.skins = skins;
        }
    }
};

});
parcelRegister("7vIxa", function(module, exports) {

$parcel$export(module.exports, "default", () => $577df93041211dbe$export$2e2bcd8739ae039);
let $577df93041211dbe$var$script;




let $577df93041211dbe$var$initialize = ()=>{
    $577df93041211dbe$var$script = (parcelRequire("eWEqm"));
    if ($577df93041211dbe$var$script.__esModule) $577df93041211dbe$var$script = $577df93041211dbe$var$script.default;
    $577df93041211dbe$var$script.render = (parcelRequire("5r3Jk")).render;
    $577df93041211dbe$var$script.__cssModules = {};
    (parcelRequire("5Ctie")).default($577df93041211dbe$var$script);
    $577df93041211dbe$var$script.__scopeId = "data-v-fb46c6";
    $577df93041211dbe$var$script.__file = "Searcher.vue";
};
$577df93041211dbe$var$initialize();
var $577df93041211dbe$export$2e2bcd8739ae039 = $577df93041211dbe$var$script;

});
parcelRegister("eWEqm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ae15d6dbaa348342$export$2e2bcd8739ae039);
/* eslint-disable no-underscore-dangle */ 
var $cX88K = parcelRequire("cX88K");

var $dknP9 = parcelRequire("dknP9");
class $ae15d6dbaa348342$var$SessionFilter {
    constructor(name, label, defaultValue = false){
        this.field = `session-${name}`;
        this._name = name;
        this._label = label || "undefined";
        this.defaultValue = defaultValue;
        this.load(defaultValue);
    }
    name() {
        return this._name;
    }
    label() {
        return this._label;
    }
    set(value) {
        sessionStorage.setItem(this.field, value);
        return value;
    }
    load(defaultValue) {
        if (sessionStorage) this.value = defaultValue;
        else this.value = sessionStorage.getItem(this.field) || this.defaultValue;
    }
    get() {
        this.load(this.defaultValue); // cast to boolean
        if (this.value === "true") this.value = true;
        if (this.value === "false") this.value = false;
        return this.value;
    }
} // Should be persistent for page refreshes but not new tabs
const $ae15d6dbaa348342$var$allFilters = [
    [
        "filterMightBreak",
        "Without deprecation warnings"
    ],
    [
        "filterMaintained",
        "Status:Maintained"
    ],
    [
        "filterDependencies",
        "Without dependencies"
    ],
    [
        "filterCompatible",
        "Compatible with latest MediaWiki"
    ],
    [
        "filterStable",
        "Status: Stable"
    ],
    [
        "filterResponsive",
        "Mobile friendly"
    ],
    [
        "filterMustache",
        "Uses modern skin framework"
    ],
    [
        "filterInvert",
        "Invert all filters"
    ]
].map((args)=>new $ae15d6dbaa348342$var$SessionFilter(args[0], args[1]));
const $ae15d6dbaa348342$var$query = new $ae15d6dbaa348342$var$SessionFilter("query", "Search query", "");
var $ae15d6dbaa348342$export$2e2bcd8739ae039 = {
    name: "Searcher",
    components: {
        CustomCheckbox: $dknP9.default
    },
    props: {
        filter: {
            type: String,
            default: ""
        },
        // Additional key to filter name against
        filterKey: {
            type: String,
            default: ""
        },
        showNoResultsMessage: {
            type: Boolean,
            default: true
        }
    },
    data () {
        let key;
        const filters = {};
        (this.filter || "").split(":").forEach((str, i)=>{
            if (i % 2 === 0) key = str;
            else filters[key] = str;
        });
        const data = {
            author: filters.author,
            license: filters.license,
            showFilters: false,
            fetched: false,
            skins: [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {}
            ],
            filteredSkins: [],
            availableFilters: $ae15d6dbaa348342$var$allFilters,
            activeFilters: {},
            query: filters.author ? filters.query : $ae15d6dbaa348342$var$query.get()
        };
        $ae15d6dbaa348342$var$allFilters.forEach((filter)=>{
            data.activeFilters[filter.name()] = filter.get();
        });
        return data;
    },
    computed: {
        showReset () {
            const activeFilters = this.activeFilters;
            return activeFilters.filterKey || activeFilters.filterMightBreak || activeFilters.filterMaintained || activeFilters.filterDependencies || activeFilters.filterCompatible || activeFilters.filterStable || this.author || this.query;
        },
        mwUrlEdit () {
            return `https://www.mediawiki.org/w/index.php?action=edit&preload=Template%3ASkin%2FSample&title=Skin%3A${this.query}&venoscript=1`;
        },
        hasNoResults () {
            return this.fetched && this.filteredSkins.length === 0 && this.showNoResultsMessage;
        }
    },
    methods: {
        resetAll () {
            this.query = $ae15d6dbaa348342$var$query.set("");
            this.availableFilters.forEach((filter)=>{
                filter.set(false);
                this.activeFilters[filter.name()] = false;
            });
            this.filteredSkins = this.skins;
            this.$router.push({
                path: "/explore"
            });
        },
        toggleFilters () {
            this.showFilters = !this.showFilters;
        },
        search () {
            const q = this.query;
            const invert = this.activeFilters.filterInvert;
            const filterFn = (skin)=>{
                const tags = skin.tag || [];
                if (!q && this.author && !(skin.author || []).includes(this.author)) return false;
                if (!q && this.license && (skin["license-name"] || "") !== this.license) return false;
                if (this.filterKey && skin.key !== this.filterKey) return false;
                if (this.activeFilters.filterMightBreak && (skin.mightBreak || tags.includes("deprecation-warnings"))) return false;
                if (this.activeFilters.filterMaintained && skin.unmaintained) return false;
                if (this.activeFilters.filterStable && (skin.experimental || skin.beta || skin.unmaintained)) return false;
                if (this.activeFilters.filterDependencies && skin.hasDependencies) return false;
                if (this.activeFilters.filterCompatible && (!skin.compatible || tags.includes("render-error"))) return false;
                if (this.activeFilters.filterResponsive && !tags.includes("responsive")) return false;
                if (this.activeFilters.filterMustache && !tags.includes("mustache")) return false;
                if (!q) return true;
                return skin.name && skin.name.toLowerCase().indexOf(q.toLowerCase()) > -1;
            };
            const invertFilterFn = (skin)=>!filterFn(skin);
            const result = this.skins.filter(invert ? invertFilterFn : filterFn);
            this.filteredSkins = result;
        },
        onToggleActiveFilter (filter) {
            const newValue = !filter.get();
            filter.set(newValue);
            this.activeFilters[filter.name()] = newValue;
            this.search();
            this.activeFilters = Object.assign({}, this.activeFilters);
        },
        setQuery (ev) {
            this.author = null;
            this.license = null;
            this.query = ev.target.value;
            $ae15d6dbaa348342$var$query.set(this.query);
            this.search();
            this.$emit("input", ev);
            this.$router.replace(`/explore/query:${this.query}`);
        }
    },
    updated () {
        this.$emit("search", this.filteredSkins);
    },
    mounted () {
        const sortByPageViewsStableDesc = (p, p2)=>{
            if (p.score === p2.score) return p.pageviews > p2.pageviews ? -1 : 1;
            else return p.score > p2.score ? -1 : 1;
        };
        this.$emit("search", this.skins);
        (0, $cX88K.default).fetchSkins().then((skins)=>{
            this.fetched = true;
            const sortedSkins = skins.skins.sort(sortByPageViewsStableDesc);
            this.skins = sortedSkins;
            this.search();
        });
    }
};

});
parcelRegister("cX88K", function(module, exports) {

$parcel$export(module.exports, "default", () => $96e14f2a7c3555e4$export$2e2bcd8739ae039);

var $7Yi7V = parcelRequire("7Yi7V");
const $96e14f2a7c3555e4$var$skins = {};
const $96e14f2a7c3555e4$var$cacheForFetches = {};
function $96e14f2a7c3555e4$var$cachedJSONFetch(url) {
    if ($96e14f2a7c3555e4$var$cacheForFetches[url]) return $96e14f2a7c3555e4$var$cacheForFetches[url];
    else {
        $96e14f2a7c3555e4$var$cacheForFetches[url] = fetch(url).then((r)=>r.json());
        return $96e14f2a7c3555e4$var$cachedJSONFetch(url);
    }
}
function $96e14f2a7c3555e4$var$getSkinJSON(title, isAnon) {
    return fetch(`${(0, $7Yi7V.HOST)}/wiki/${title}?useskin=skinjson&testuser=${isAnon ? 0 : 1}`).then((r)=>r.json());
}
function $96e14f2a7c3555e4$var$getDemoEnabledSkins() {
    return $96e14f2a7c3555e4$var$cachedJSONFetch(`${(0, $7Yi7V.HOST)}w/rest.php/v1/skins`).then((data)=>{
        Object.keys(data.skins).forEach((key)=>{
            data.skins[key].author = (data.skins[key].author || [
                "unknown"
            ]).map((author)=>{
                if (author.indexOf("[") === 0) {
                    if (author.indexOf("|") > -1) return author.split("|")[1].replace("]]", "");
                    else return author.split(" ").slice(1).join(" ").replace("]", "");
                } else return author;
            });
        });
        return data.skins;
    });
}
function $96e14f2a7c3555e4$var$getSkinKeyFromName(name) {
    let key = name.replace(/[ !]/g, "").toLowerCase().replace(/\//, "-");
    if ((0, $7Yi7V.SKIN_KEY_SPECIAL_CASES)[key]) key = (0, $7Yi7V.SKIN_KEY_SPECIAL_CASES)[key];
    return key;
}
/**
 * @param {string} category
 * @param {Object} installedSkins mapping skin keys to info
 * @param {string} [gcmcontinue]
 * @param {Array} [pages]
 * @return {Promise}
 */ function $96e14f2a7c3555e4$var$queryMediaWikiSkins(category, installedSkins, gcmcontinue = "", pages = []) {
    const compatible = Object.keys(installedSkins);
    // clcategory is used to check if the skin is in "CATEGORY_ADDITIONAL_REQUIREMENTS"
    // cllimit set at 50 the maximum value for page images.
    const MAX = 50;
    const url = `https://www.mediawiki.org
/w/api.php?action=query
&format=json&origin=*&prop=pageviews%7Cpageimages%7Ccategories&formatversion=2&origin=*
&clcategories=${0, $7Yi7V.CATEGORY_ADDITIONAL_REQUIREMENTS}%7C${0, $7Yi7V.CATEGORY_REQUIRE_MODIFICATION}%7C${0, $7Yi7V.CATEGORY_INCOMPATIBLE_WITH_MEDIAWIKI_MASTER}
&cllimit=${MAX}
&piprop=thumbnail&pithumbsize=500&pilimit=${MAX}
&pvipmetric=pageviews&pvipdays=60
&generator=categorymembers&gcmlimit=${MAX}&gcmtitle=${encodeURIComponent(category)}&gcmnamespace=106
&${gcmcontinue}`.replace(/\n/g, "");
    return $96e14f2a7c3555e4$var$cachedJSONFetch(url).then((r)=>{
        if (r) {
            if (r.query && r.query.pages) {
                const newPages = r.query.pages;
                pages = pages.concat(newPages.map((p)=>{
                    const pv = p.pageviews || {};
                    const name = p.title.split(":")[1];
                    const key = $96e14f2a7c3555e4$var$getSkinKeyFromName(name);
                    const src = p.thumbnail ? p.thumbnail.source : undefined;
                    const isCompatible = compatible.includes(key);
                    const categoryTitles = (p.categories || []).map((c)=>c.title.replace(/ /g, "_"));
                    const hasDependencies = categoryTitles.includes((0, $7Yi7V.CATEGORY_ADDITIONAL_REQUIREMENTS));
                    const requiresModification = categoryTitles.includes((0, $7Yi7V.CATEGORY_REQUIRE_MODIFICATION));
                    const mightBreak = categoryTitles.includes((0, $7Yi7V.CATEGORY_INCOMPATIBLE_WITH_MEDIAWIKI_MASTER));
                    const experimental = (0, $7Yi7V.CATEGORY_EXPERIMENTAL_SKINS) === category;
                    const beta = (0, $7Yi7V.CATEGORY_BETA_SKINS) === category;
                    const unmaintained = (0, $7Yi7V.CATEGORY_UNMAINTAINED_SKINS) === category;
                    const score = ()=>{
                        let s = 0;
                        if (mightBreak) s--;
                        if (src) s++;
                        if (isCompatible) s++;
                        else s--;
                        if (!hasDependencies) s++;
                        else if (!requiresModification) s++;
                        else s--;
                        if (beta) s--;
                        if (unmaintained) s -= 100;
                        if (!experimental) s++;
                        return s;
                    };
                    return Object.assign(p, {
                        key: key,
                        src: src,
                        name: name,
                        experimental: experimental,
                        compatible: isCompatible,
                        beta: beta,
                        mightBreak: mightBreak,
                        unmaintained: unmaintained,
                        requiresModification: requiresModification,
                        hasDependencies: hasDependencies || requiresModification,
                        stable: true,
                        score: score(),
                        pageviews: Object.keys(pv).map((pvkey)=>pv[pvkey]).reduce((count, total = 0)=>total + count, 0)
                    }, installedSkins[key] || {});
                }).filter((p)=>{
                    const isSkinVariant = p.title.indexOf("/") > -1;
                    const skinKey = p.title.toLowerCase().replace(/\//, "-").replace("skin:", "");
                    return isSkinVariant ? compatible.indexOf(skinKey) > -1 : p.title.indexOf("Skin:") > -1 && p.title !== "Skin:Example";
                }));
            }
            if (r.continue) {
                const continueKey = Object.keys(r.continue).map((key)=>`${key}=${r.continue[key]}`).join("&");
                return $96e14f2a7c3555e4$var$queryMediaWikiSkins(category, installedSkins, continueKey, pages);
            } else return pages;
        }
    });
}
/**
 * @param {Object} compatible skin keys mapped to info
 * @return {Promise}
 */ function $96e14f2a7c3555e4$var$queryMediaWikiAllSkins(compatible) {
    return Promise.all([
        $96e14f2a7c3555e4$var$queryMediaWikiSkins((0, $7Yi7V.CATEGORY_SKINS), compatible),
        $96e14f2a7c3555e4$var$queryMediaWikiSkins((0, $7Yi7V.CATEGORY_BETA_SKINS), compatible),
        $96e14f2a7c3555e4$var$queryMediaWikiSkins((0, $7Yi7V.CATEGORY_EXPERIMENTAL_SKINS), compatible)
    ]).then((...args)=>args[0].length > 1 ? args[0][0].concat.apply(args[0][0], args[0].slice(1)) : args[0][0]);
}
function $96e14f2a7c3555e4$var$getSkinIndexRemote() {
    if (Object.keys($96e14f2a7c3555e4$var$skins) > 0) return Promise.resolve($96e14f2a7c3555e4$var$skins);
    return $96e14f2a7c3555e4$var$getDemoEnabledSkins().then((compatible)=>$96e14f2a7c3555e4$var$queryMediaWikiAllSkins(compatible));
}
function $96e14f2a7c3555e4$var$populateSkinIndexAfter(skinPages) {
    skinPages.forEach((skin)=>{
        const isVariant = skin.name.indexOf("/") > -1;
        const parentSkin = isVariant ? skin.name.split("/")[0] : null;
        $96e14f2a7c3555e4$var$skins[skin.key] = Object.assign(skin, {
            parentSkinUrl: isVariant ? `https://mediawiki.org/wiki/Skin:${parentSkin}` : null,
            parentSkinKey: isVariant ? $96e14f2a7c3555e4$var$getSkinKeyFromName(parentSkin) : null,
            isVariant: isVariant
        });
    });
    // with skins fully populated run again.
    Object.keys($96e14f2a7c3555e4$var$skins).forEach((skinKey)=>{
        const skin = $96e14f2a7c3555e4$var$skins[skinKey];
        if (skin.isVariant) {
            const parentSkin = $96e14f2a7c3555e4$var$skins[skin.parentSkinKey];
            // Copy across these keys.
            if (parentSkin) [
                "src",
                "compatible",
                "unmaintained",
                "experimental",
                "stable",
                "beta",
                "hasDependencies",
                "mightBreak",
                "score"
            ].forEach((copyKey)=>{
                $96e14f2a7c3555e4$var$skins[skinKey][copyKey] = parentSkin[copyKey];
            });
        }
    });
    return $96e14f2a7c3555e4$var$skins;
}
function $96e14f2a7c3555e4$var$cleanMwHTML(str) {
    return str.replace(// &lt;tvar name=1&gt;...&lt;/tvar&gt;
    /&lt;tvar name=[^&]*&gt;([^&]*)&lt;\/tvar&gt;/, "$1").replace(/(&lt;\/translate&gt;|&lt;translate&gt;)/gi, "").replace(// external link tvars
    /\[&lt;tvar\|[^&]*&gt;[^&]*&lt;\/&gt; ([^\]]*)\]/g, "$1").replace(// [[&lt;tvar name=3&gt;Special:MyLanguage/Manual:Skins&lt;/tvar&gt;|skin]]
    /\[\[&lt;tvar name=[^&]*&gt;[^&]*&lt;\/tvar&gt;\|([^\]]*)\]\]/g, "$1").replace(// standard link tvars
    /\[\[&lt;tvar\|[^&]*&gt;[^&]*&lt;\/&gt;\|([^\]]*)\]\]/g, "$1").replace(/&lt;tvar\|[^&]*&gt;([^&]*)&lt;\/&gt;/g, "$1").replace(// [[ ]]
    /\[\[[^&]*&lt;\/&gt;\|([^\]]*)\]\]*/g, "$1").replace(// &lt;tvar name=1&gt;<b>Lakeus</b>&lt;/tvar&gt;
    /&lt;tvar name=[^&]*&gt;([^&]*)&lt;\/tvar&gt;/, "$1");
}
function $96e14f2a7c3555e4$var$getSkinIndex() {
    return new Promise((resolve)=>{
        $96e14f2a7c3555e4$var$cachedJSONFetch("/data/index.json").then((r)=>{
            resolve(r);
        }, ()=>{
            $96e14f2a7c3555e4$var$getSkinIndexRemote().then((json)=>resolve(json));
        });
    }).then((r)=>$96e14f2a7c3555e4$var$populateSkinIndexAfter(r));
}
function $96e14f2a7c3555e4$var$fetchSkinInfo(key) {
    return $96e14f2a7c3555e4$var$getSkinIndex().then((compatibleSkins)=>{
        const isCompatible = compatibleSkins[key] && compatibleSkins[key].compatible;
        const skin = $96e14f2a7c3555e4$var$skins[key] || false;
        if (!skin) return Promise.reject();
        const title = `Skin%3A${skin.name}`;
        const revisionsQuery = "rvdir=newer&rvlimit=1&rvprop=timestamp";
        return Promise.all([
            // https://www.mediawiki.org/wiki/Special:ApiSandbox#action=query&format=json&prop=categories%7Cextracts%7Cextlinks&titles=Skin%3AMinerva_Neue&redirects=1&formatversion=2&cllimit=max&exsentences=3&exlimit=max&exintro=1&explaintext=1&ellimit=max
            $96e14f2a7c3555e4$var$cachedJSONFetch(`https://www.mediawiki.org/w/api.php?action=query&format=json&${revisionsQuery}&prop=revisions%7Ccategories%7Cextlinks&redirects=1&formatversion=2&cllimit=max&origin=*&titles=${title}`),
            $96e14f2a7c3555e4$var$cachedJSONFetch(`https://www.mediawiki.org/w/api.php?action=parse&format=json&origin=*&page=${title}&section=0`)
        ]).then((responseObjects)=>{
            const result = responseObjects[0];
            const template = document.createElement("template");
            const doc = template.content;
            const parsedResult = responseObjects[1].parse;
            const html = parsedResult.text["*"];
            template.innerHTML = $96e14f2a7c3555e4$var$cleanMwHTML(html);
            const firstP = doc.querySelectorAll(".mw-parser-output > p")[0];
            const links = [];
            let summary, created, stable, categories;
            try {
                const p = result.query.pages;
                const info = p[0];
                summary = firstP ? firstP.textContent : "No skin information available";
                categories = (p.categories || []).map((c)=>c.title);
                links.push({
                    text: "View on mediawiki.org",
                    href: info.title ? `https://mediawiki.org/wiki/${info.title}` : ""
                });
                const firstRevision = info.revisions[0];
                if (skin.parentSkinUrl) links.push({
                    text: "View parent skin on MediaWiki.org",
                    href: skin.parentSkinUrl
                });
                created = firstRevision ? firstRevision.timestamp : null;
                const extlinks = (info.extlinks || []).concat(parsedResult.iwlinks || []).map((link)=>link.url);
                extlinks.forEach((url)=>{
                    if (url.match(/github\.com/) && url.match(/\.git/)) links.push({
                        text: "View on github",
                        href: url
                    });
                    if (url.match(/gerrit\.wikimedia.org\/g\//) && !url.match(/(log\/master)/)) links.push({
                        text: "View on gerrit",
                        href: url
                    });
                    if (url.match(/kde\.org/)) links.push({
                        text: "View on kde",
                        href: url
                    });
                    if (url.match(/gitlab\.com/) && url.match(/\.git/)) links.push({
                        text: "View on gitlab",
                        href: url
                    });
                    if (url.match(/bitbucket.org\//) && url.match(/\.git/)) links.push({
                        text: "View on bitbucket",
                        href: url
                    });
                    if (url.match(/sourceforge.net\//) && !url.match(/download/)) links.push({
                        text: "View on sourceforge",
                        href: url
                    });
                });
            } catch (e) {}
            return Object.assign({
                links: links,
                created: created,
                isCompatible: isCompatible,
                summary: summary,
                stable: stable,
                categories: categories
            }, skin);
        });
    });
}
function $96e14f2a7c3555e4$var$fetchSkinsRemote() {
    return $96e14f2a7c3555e4$var$getSkinIndex().then(()=>({
            skins: Object.keys($96e14f2a7c3555e4$var$skins).map((key)=>Object.assign({}, $96e14f2a7c3555e4$var$skins[key]))
        }));
}
function $96e14f2a7c3555e4$var$fetchSkins() {
    return new Promise((resolve)=>{
        $96e14f2a7c3555e4$var$cachedJSONFetch("/data/skins.json").then((r)=>{
            resolve(r);
        }, ()=>{
            $96e14f2a7c3555e4$var$fetchSkinsRemote().then((json)=>resolve(json));
        });
    });
}
var $96e14f2a7c3555e4$export$2e2bcd8739ae039 = {
    getSkinIndexRemote: $96e14f2a7c3555e4$var$getSkinIndexRemote,
    fetchSkinsRemote: $96e14f2a7c3555e4$var$fetchSkinsRemote,
    getSkinKeyFromName: $96e14f2a7c3555e4$var$getSkinKeyFromName,
    getSkinJSON: $96e14f2a7c3555e4$var$getSkinJSON,
    fetchSkinInfo: $96e14f2a7c3555e4$var$fetchSkinInfo,
    fetchSkins: $96e14f2a7c3555e4$var$fetchSkins
};

});
parcelRegister("7Yi7V", function(module, exports) {

$parcel$export(module.exports, "HOST", () => $5cdc329eeebd56d0$export$81153c938cace9a5);
$parcel$export(module.exports, "TEST_ARTICLES", () => $5cdc329eeebd56d0$export$4f0f9c2a6c1a8fc);
$parcel$export(module.exports, "CATEGORY_SKINS", () => $5cdc329eeebd56d0$export$7a7747b1f4531109);
$parcel$export(module.exports, "CATEGORY_BETA_SKINS", () => $5cdc329eeebd56d0$export$c7264e4bb2edb9e4);
$parcel$export(module.exports, "CATEGORY_UNMAINTAINED_SKINS", () => $5cdc329eeebd56d0$export$9026fc43d5cdd499);
$parcel$export(module.exports, "CATEGORY_EXPERIMENTAL_SKINS", () => $5cdc329eeebd56d0$export$e7ed48b363c8ec4d);
$parcel$export(module.exports, "CATEGORY_ADDITIONAL_REQUIREMENTS", () => $5cdc329eeebd56d0$export$101b41292968d1c);
$parcel$export(module.exports, "CATEGORY_REQUIRE_MODIFICATION", () => $5cdc329eeebd56d0$export$7000979aba4b0546);
$parcel$export(module.exports, "CATEGORY_INCOMPATIBLE_WITH_MEDIAWIKI_MASTER", () => $5cdc329eeebd56d0$export$2fd857069f69d4c4);
$parcel$export(module.exports, "DEFAULT_SKIN_IMAGE", () => $5cdc329eeebd56d0$export$2edcd28e65c8909);
$parcel$export(module.exports, "SKIN_KEY_SPECIAL_CASES", () => $5cdc329eeebd56d0$export$b778ec1a6150aff);
$parcel$export(module.exports, "LESS_RENDER_OPTIONS", () => $5cdc329eeebd56d0$export$19fa5b2c0851f269);
const $5cdc329eeebd56d0$export$81153c938cace9a5 = "https://skins-demo.wmflabs.org/";
const $5cdc329eeebd56d0$export$4f0f9c2a6c1a8fc = [
    {
        title: "MediaWiki",
        name: "MediaWiki"
    },
    {
        title: "Help:Sample_page",
        name: "Sample page"
    },
    {
        title: "Ipsum_Lorem",
        name: "Ipsum Lorem"
    },
    {
        title: "Rube Goldberg machine",
        name: "Rube Goldberg machine"
    }
];
const $5cdc329eeebd56d0$export$7a7747b1f4531109 = "Category:Stable_skins";
const $5cdc329eeebd56d0$export$c7264e4bb2edb9e4 = "Category:Beta_status_skins";
const $5cdc329eeebd56d0$export$9026fc43d5cdd499 = "Category:Unmaintained_skins";
const $5cdc329eeebd56d0$export$e7ed48b363c8ec4d = "Category:Experimental_skins";
const $5cdc329eeebd56d0$export$101b41292968d1c = "Category:Skins_that_have_additional_setup_requirements";
const $5cdc329eeebd56d0$export$7000979aba4b0546 = "Category:Skins_which_require_code_modification";
const $5cdc329eeebd56d0$export$2fd857069f69d4c4 = "Category:Skins_using_deprecated_features";
const $5cdc329eeebd56d0$export$2edcd28e65c8909 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII= ";
const $5cdc329eeebd56d0$export$b778ec1a6150aff = {
    minervaneue: "minerva",
    2018: "s2018",
    bluelib: "bluelib-royalblue",
    scratchwikiskin: "scratchwikiskin2"
};
const $5cdc329eeebd56d0$export$281ea434bd78bcaa = {
    "z-index-stacking-1": "1",
    "min-width-breakpoint-mobile": "320px",
    "min-width-breakpoint-tablet": "720px",
    "min-width-breakpoint-desktop": "1000px"
};
const $5cdc329eeebd56d0$export$19fa5b2c0851f269 = {
    strictUnits: true,
    globalVars: $5cdc329eeebd56d0$export$281ea434bd78bcaa
};

});


parcelRegister("dknP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3f9f984dd35b6a$export$2e2bcd8739ae039);
let $9b3f9f984dd35b6a$var$script;




let $9b3f9f984dd35b6a$var$initialize = ()=>{
    $9b3f9f984dd35b6a$var$script = (parcelRequire("1Wdy5"));
    if ($9b3f9f984dd35b6a$var$script.__esModule) $9b3f9f984dd35b6a$var$script = $9b3f9f984dd35b6a$var$script.default;
    $9b3f9f984dd35b6a$var$script.render = (parcelRequire("3wxQ0")).render;
    $9b3f9f984dd35b6a$var$script.__cssModules = {};
    (parcelRequire("dMktM")).default($9b3f9f984dd35b6a$var$script);
    $9b3f9f984dd35b6a$var$script.__scopeId = "data-v-b9925e";
    $9b3f9f984dd35b6a$var$script.__file = "CustomCheckbox.vue";
};
$9b3f9f984dd35b6a$var$initialize();
var $9b3f9f984dd35b6a$export$2e2bcd8739ae039 = $9b3f9f984dd35b6a$var$script;

});
parcelRegister("1Wdy5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1695b7bcb56bc694$export$2e2bcd8739ae039);
var $1695b7bcb56bc694$export$2e2bcd8739ae039 = {
    name: "CustomCheckbox",
    props: {
        name: {
            type: String,
            required: true
        },
        checked: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        changeEvent (ev) {
            this.$emit("change", ev);
        },
        inputEvent (ev) {
            this.$emit("input", ev);
        }
    }
};

});

parcelRegister("3wxQ0", function(module, exports) {

$parcel$export(module.exports, "render", () => $290e9bbafae9e580$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $290e9bbafae9e580$var$_hoisted_1 = {
    class: "custom-checkbox"
};
const $290e9bbafae9e580$var$_hoisted_2 = [
    "name",
    "checked"
];
const $290e9bbafae9e580$var$_hoisted_3 = [
    "for"
];
function $290e9bbafae9e580$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $290e9bbafae9e580$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("input", {
            type: "checkbox",
            name: $props.name,
            checked: $props.checked,
            onChange: _cache[0] || (_cache[0] = (...args)=>$options.changeEvent.stopPropagation && $options.changeEvent.stopPropagation(...args)),
            onInput: _cache[1] || (_cache[1] = (...args)=>$options.inputEvent && $options.inputEvent(...args))
        }, null, 40, $290e9bbafae9e580$var$_hoisted_2),
        (0, $TusQn.createElementVNode)("label", {
            for: $props.name
        }, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ], 8, $290e9bbafae9e580$var$_hoisted_3)
    ]);
}

});

parcelRegister("dMktM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a07fa4d12e2afb6c$export$2e2bcd8739ae039);
let $a07fa4d12e2afb6c$var$NOOP = ()=>{};
var $a07fa4d12e2afb6c$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("5r3Jk", function(module, exports) {

$parcel$export(module.exports, "render", () => $3f525e167d8d5d46$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
const $3f525e167d8d5d46$var$_hoisted_1 = {
    class: "searcher"
};
const $3f525e167d8d5d46$var$_hoisted_2 = [
    "value"
];
const $3f525e167d8d5d46$var$_hoisted_3 = {
    key: 0,
    class: "searcher__filter-list"
};
const $3f525e167d8d5d46$var$_hoisted_4 = {
    class: "filter-title"
};
const $3f525e167d8d5d46$var$_hoisted_5 = {
    key: 0
};
const $3f525e167d8d5d46$var$_hoisted_6 = {
    key: 1
};
const $3f525e167d8d5d46$var$_hoisted_7 = [
    "href"
];
function $3f525e167d8d5d46$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CustomCheckbox = (0, $TusQn.resolveComponent)("CustomCheckbox");
    const _directive_focus = (0, $TusQn.resolveDirective)("focus");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $3f525e167d8d5d46$var$_hoisted_1, [
        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
            class: "search__input",
            placeholder: "Find skin",
            value: _ctx.query,
            onInput: _cache[0] || (_cache[0] = (...args)=>$options.setQuery && $options.setQuery(...args))
        }, null, 40, $3f525e167d8d5d46$var$_hoisted_2), [
            [
                _directive_focus
            ]
        ]),
        (0, $TusQn.createElementVNode)("button", {
            class: "searcher__filter-btn",
            onClick: _cache[1] || (_cache[1] = (...args)=>$options.toggleFilters && $options.toggleFilters(...args))
        }, " Filters "),
        _ctx.showFilters ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $3f525e167d8d5d46$var$_hoisted_3, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.availableFilters, (f, i)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    key: f.name + i,
                    class: "searcher__filter-item"
                }, [
                    (0, $TusQn.createVNode)(_component_CustomCheckbox, {
                        checked: _ctx.activeFilters[f.name()],
                        name: "search_release",
                        onChange: ($event)=>$options.onToggleActiveFilter(f)
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(f.label()), 1)
                            ]),
                        _: 2
                    }, 1032, [
                        "checked",
                        "onChange"
                    ])
                ]);
            }), 128))
        ])) : (0, $TusQn.createCommentVNode)("", true),
        (0, $TusQn.createElementVNode)("p", $3f525e167d8d5d46$var$_hoisted_4, [
            _ctx.fetched ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $3f525e167d8d5d46$var$_hoisted_5, "Showing " + (0, $8XWQX.toDisplayString)(_ctx.filteredSkins.length) + " / " + (0, $8XWQX.toDisplayString)(_ctx.skins.length) + " skins.", 1)) : (0, $TusQn.createCommentVNode)("", true),
            $options.showReset ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                key: 1,
                class: "reset",
                onClick: _cache[2] || (_cache[2] = (...args)=>$options.resetAll && $options.resetAll(...args))
            }, "Show all skins")) : (0, $TusQn.createCommentVNode)("", true),
            _cache[3] || (_cache[3] = (0, $TusQn.createTextVNode)(" \xa0 "))
        ]),
        $options.hasNoResults ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $3f525e167d8d5d46$var$_hoisted_6, [
            _cache[5] || (_cache[5] = (0, $TusQn.createElementVNode)("div", {
                class: "no-results-sad-face"
            }, " \uD83D\uDE1E ", -1)),
            _cache[6] || (_cache[6] = (0, $TusQn.createElementVNode)("p", null, "No skins match that name.", -1)),
            _cache[7] || (_cache[7] = (0, $TusQn.createElementVNode)("p", null, [
                (0, $TusQn.createTextVNode)(" If the skin exists it may not be compatible with the latest MediaWiki version and be "),
                (0, $TusQn.createElementVNode)("a", {
                    href: "https://www.mediawiki.org/wiki/Category:Unstable_skins"
                }, "marked as unstable"),
                (0, $TusQn.createTextVNode)(". ")
            ], -1)),
            (0, $TusQn.createElementVNode)("p", null, [
                _cache[4] || (_cache[4] = (0, $TusQn.createTextVNode)("You can ")),
                (0, $TusQn.createElementVNode)("a", {
                    href: $options.mwUrlEdit
                }, "add this skin to MediaWiki.org", 8, $3f525e167d8d5d46$var$_hoisted_7)
            ])
        ])) : (0, $TusQn.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("5Ctie", function(module, exports) {

$parcel$export(module.exports, "default", () => $4177395c0188d519$export$2e2bcd8739ae039);
let $4177395c0188d519$var$NOOP = ()=>{};
var $4177395c0188d519$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("1H5o3", function(module, exports) {

$parcel$export(module.exports, "default", () => $13bdfc5b3494669d$export$2e2bcd8739ae039);
let $13bdfc5b3494669d$var$script;




let $13bdfc5b3494669d$var$initialize = ()=>{
    $13bdfc5b3494669d$var$script = (parcelRequire("21XbB"));
    if ($13bdfc5b3494669d$var$script.__esModule) $13bdfc5b3494669d$var$script = $13bdfc5b3494669d$var$script.default;
    $13bdfc5b3494669d$var$script.render = (parcelRequire("7TawJ")).render;
    $13bdfc5b3494669d$var$script.__cssModules = {};
    (parcelRequire("iRKmr")).default($13bdfc5b3494669d$var$script);
    $13bdfc5b3494669d$var$script.__scopeId = "data-v-1680ea";
    $13bdfc5b3494669d$var$script.__file = "Snapshot.vue";
};
$13bdfc5b3494669d$var$initialize();
var $13bdfc5b3494669d$export$2e2bcd8739ae039 = $13bdfc5b3494669d$var$script;

});
parcelRegister("21XbB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $17a995e587d6e87f$export$2e2bcd8739ae039);

var $73mM4 = parcelRequire("73mM4");

var $7Yi7V = parcelRequire("7Yi7V");
var $17a995e587d6e87f$export$2e2bcd8739ae039 = {
    name: "Snapshot",
    components: {
        RouterLink: $73mM4.RouterLink
    },
    props: {
        highlight: {
            type: Boolean,
            default: false
        },
        displayTitle: {
            type: Boolean,
            default: true
        },
        skinkey: {
            type: String,
            default: ""
        },
        unmaintained: {
            type: Boolean,
            default: false
        },
        compatible: {
            type: Boolean,
            default: true
        },
        beta: {
            type: Boolean
        },
        experimental: {
            type: Boolean
        },
        mightBreak: {
            type: Boolean
        },
        hasDependencies: {
            type: Boolean
        },
        stable: {
            type: Boolean,
            default: true
        },
        name: {
            type: String,
            default: "\u2800"
        },
        url: {
            type: String,
            default: ""
        },
        src: {
            type: String,
            default: (0, $7Yi7V.DEFAULT_SKIN_IMAGE)
        }
    },
    computed: {
        snapshotClass () {
            return {
                "snapshot--highlight": this.highlight,
                "snapshot--unstable": !this.stable || !this.compatible,
                "snapshot--unmaintained": this.unmaintained,
                snapshot: true
            };
        },
        routerUrl () {
            return this.url ? this.url : this.skinkey ? `/skin/${this.skinkey}` : "";
        },
        alt () {
            return `screenshot of ${this.name}`;
        }
    }
};

});

parcelRegister("7TawJ", function(module, exports) {

$parcel$export(module.exports, "render", () => $5be5d5e0ea4f6cab$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
const $5be5d5e0ea4f6cab$var$_hoisted_1 = {
    key: 0
};
const $5be5d5e0ea4f6cab$var$_hoisted_2 = {
    key: 0,
    title: "Requires additional setup."
};
const $5be5d5e0ea4f6cab$var$_hoisted_3 = {
    key: 1,
    title: "Skin is marked as beta."
};
const $5be5d5e0ea4f6cab$var$_hoisted_4 = {
    key: 2,
    title: "Skin is marked as experimental."
};
const $5be5d5e0ea4f6cab$var$_hoisted_5 = {
    key: 3,
    title: "Might break in future MediaWiki versions"
};
const $5be5d5e0ea4f6cab$var$_hoisted_6 = {
    key: 4,
    title: "No preview available."
};
const $5be5d5e0ea4f6cab$var$_hoisted_7 = [
    "src",
    "alt"
];
function $5be5d5e0ea4f6cab$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $TusQn.resolveComponent)("router-link");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)($options.snapshotClass)
    }, [
        (0, $TusQn.createVNode)(_component_router_link, {
            to: $options.routerUrl
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    $props.displayTitle ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("h3", $5be5d5e0ea4f6cab$var$_hoisted_1, [
                        (0, $TusQn.createElementVNode)("span", null, (0, $8XWQX.toDisplayString)($props.name), 1),
                        $props.hasDependencies ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("abbr", $5be5d5e0ea4f6cab$var$_hoisted_2, "\u2699\uFE0F")) : (0, $TusQn.createCommentVNode)("", true),
                        $props.beta ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("abbr", $5be5d5e0ea4f6cab$var$_hoisted_3, "\u03B2")) : (0, $TusQn.createCommentVNode)("", true),
                        $props.experimental ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("abbr", $5be5d5e0ea4f6cab$var$_hoisted_4, "\uD83E\uDDEA")) : (0, $TusQn.createCommentVNode)("", true),
                        $props.mightBreak ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("abbr", $5be5d5e0ea4f6cab$var$_hoisted_5, "\u26A1")) : (0, $TusQn.createCommentVNode)("", true),
                        !$props.compatible ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("abbr", $5be5d5e0ea4f6cab$var$_hoisted_6, "\u26A0\uFE0F")) : (0, $TusQn.createCommentVNode)("", true)
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    (0, $TusQn.createElementVNode)("img", {
                        width: "320",
                        height: "200",
                        src: $props.src,
                        alt: $options.alt
                    }, null, 8, $5be5d5e0ea4f6cab$var$_hoisted_7)
                ]),
            _: 1
        }, 8, [
            "to"
        ])
    ], 2);
}

});

parcelRegister("iRKmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbc1238cd949d0a4$export$2e2bcd8739ae039);
let $dbc1238cd949d0a4$var$NOOP = ()=>{};
var $dbc1238cd949d0a4$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("jA4pj", function(module, exports) {

$parcel$export(module.exports, "render", () => $e414cc528b02d4e3$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $e414cc528b02d4e3$var$_hoisted_1 = {
    class: "page__showcase"
};
function $e414cc528b02d4e3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Searcher = (0, $TusQn.resolveComponent)("Searcher");
    const _component_Snapshot = (0, $TusQn.resolveComponent)("Snapshot");
    const _component_Page = (0, $TusQn.resolveComponent)("Page");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_Page, {
        class: "page--explore"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createVNode)(_component_Searcher, {
                    class: "page__header",
                    filter: _ctx.$route.params.filter,
                    "filter-key": _ctx.$route.params.key,
                    onSearch: $options.onSearch
                }, null, 8, [
                    "filter",
                    "filter-key",
                    "onSearch"
                ]),
                (0, $TusQn.createElementVNode)("div", $e414cc528b02d4e3$var$_hoisted_1, [
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.skins, (skin)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_Snapshot, {
                            key: skin.key,
                            highlight: $data.skins.length === 1,
                            stable: skin.stable,
                            compatible: skin.compatible,
                            unmaintained: skin.unmaintained,
                            beta: skin.beta,
                            "might-break": skin.mightBreak,
                            experimental: skin.experimental,
                            "has-dependencies": skin.hasDependencies,
                            skinkey: skin.key,
                            name: skin.name,
                            src: skin.src
                        }, null, 8, [
                            "highlight",
                            "stable",
                            "compatible",
                            "unmaintained",
                            "beta",
                            "might-break",
                            "experimental",
                            "has-dependencies",
                            "skinkey",
                            "name",
                            "src"
                        ]);
                    }), 128))
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("c1JPG", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c1921703dd56121$export$2e2bcd8739ae039);
let $8c1921703dd56121$var$NOOP = ()=>{};
var $8c1921703dd56121$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("brdT8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $853cfd4270c90be5$export$2e2bcd8739ae039);

var $cX88K = parcelRequire("cX88K");

var $bDOkW = parcelRequire("bDOkW");

var $ajjle = parcelRequire("ajjle");

var $9Sqco = parcelRequire("9Sqco");

var $7vIxa = parcelRequire("7vIxa");

var $73mM4 = parcelRequire("73mM4");
var $853cfd4270c90be5$export$2e2bcd8739ae039 = {
    name: "Skin",
    components: {
        RouterLink: $73mM4.RouterLink,
        PreviewLauncher: $bDOkW.default,
        SkinWarnings: $9Sqco.default,
        Searcher: $7vIxa.default,
        Page: $ajjle.default
    },
    data () {
        return {
            infoIsLoaded: false,
            unmaintained: true,
            mightBreak: false,
            stable: true,
            preview: true,
            compatible: true,
            skinkey: this.$route.params.key,
            name: this.$route.params.key.replace(/[^⠀]/g, "\u2800") + "\u2800",
            links: [],
            created: "",
            license: "",
            authors: [],
            beta: false,
            hasDependencies: false,
            experimental: false,
            src: "",
            summary: ""
        };
    },
    computed: {
        srcLarge () {
            return this.src.replace("400px", "960px");
        },
        showWarnings () {
            if (!this.infoIsLoaded) return false;
            return !this.stable || this.experimental || !this.compatible || this.mightBreak || this.hasDependencies || this.beta || this.unmaintained;
        },
        mwUrl () {
            return this.name ? `https://mediawiki.org/wiki/Skin:${this.name}` : "";
        }
    },
    methods: {
        onSearch () {
            this.$router.push("/explore");
        }
    },
    mounted: function() {
        if (this.$el.clientWidth < 768) this.preview = false;
        (0, $cX88K.default).fetchSkinInfo(this.$route.params.key).then((skin)=>{
            this.name = skin.name;
            if (skin.src) this.src = skin.src;
            this.preview = this.preview && skin.isCompatible;
            this.authors = (skin.author || []).filter((a)=>a !== "...");
            this.summary = skin.summary;
            this.stable = skin.stable;
            this.license = skin["license-name"];
            this.beta = skin.beta;
            this.unmaintained = skin.unmaintained;
            this.hasDependencies = skin.hasDependencies;
            this.mightBreak = skin.mightBreak;
            this.experimental = skin.experimental;
            this.links = skin.links;
            this.created = new Date(skin.created).getFullYear();
            this.infoIsLoaded = true;
        }, ()=>{
            this.$router.replace({
                path: "/404"
            });
        });
    }
};

});
parcelRegister("bDOkW", function(module, exports) {

$parcel$export(module.exports, "default", () => $879a620e98cb0639$export$2e2bcd8739ae039);
let $879a620e98cb0639$var$script;




let $879a620e98cb0639$var$initialize = ()=>{
    $879a620e98cb0639$var$script = (parcelRequire("c0463"));
    if ($879a620e98cb0639$var$script.__esModule) $879a620e98cb0639$var$script = $879a620e98cb0639$var$script.default;
    $879a620e98cb0639$var$script.render = (parcelRequire("1idr2")).render;
    $879a620e98cb0639$var$script.__cssModules = {};
    (parcelRequire("6vGg8")).default($879a620e98cb0639$var$script);
    $879a620e98cb0639$var$script.__scopeId = "data-v-ad4cd2";
    $879a620e98cb0639$var$script.__file = "PreviewLauncher.vue";
};
$879a620e98cb0639$var$initialize();
var $879a620e98cb0639$export$2e2bcd8739ae039 = $879a620e98cb0639$var$script;

});
parcelRegister("c0463", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8bc8a99b98af700c$export$2e2bcd8739ae039);

var $7Yi7V = parcelRequire("7Yi7V");

var $dyhyS = parcelRequire("dyhyS");

var $gf7Lp = parcelRequire("gf7Lp");
var $8bc8a99b98af700c$export$2e2bcd8739ae039 = {
    name: "PreviewLauncher",
    components: {
        Preview: $gf7Lp.default,
        NoPreview: $dyhyS.default
    },
    props: {
        maintained: {
            type: Boolean,
            required: true
        },
        available: {
            type: Boolean,
            required: true
        },
        skinkey: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        src: {
            type: String,
            default: (0, $7Yi7V.DEFAULT_SKIN_IMAGE)
        }
    },
    data () {
        return {
            language: "en",
            testArticle: (0, $7Yi7V.TEST_ARTICLES)[0].title,
            previewInactive: true
        };
    },
    computed: {
        href () {
            return this.available ? `${0, $7Yi7V.HOST}/wiki/${this.testArticle}?useformat=desktop&uselang=${this.language}&useskin=${this.skinkey}` : undefined;
        },
        previewScreenshotClass () {
            return {
                screenshot: true,
                "screenshot--disabled": !this.available
            };
        }
    },
    methods: {
        activatePreview () {
            if (this.available) this.previewInactive = false;
        },
        changeLanguage (language) {
            this.language = language;
        },
        changeArticle (a) {
            this.testArticle = a;
        }
    }
};

});
parcelRegister("dyhyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $028bcec0b8ba2540$export$2e2bcd8739ae039);
let $028bcec0b8ba2540$var$script;




let $028bcec0b8ba2540$var$initialize = ()=>{
    $028bcec0b8ba2540$var$script = (parcelRequire("3ln8x"));
    if ($028bcec0b8ba2540$var$script.__esModule) $028bcec0b8ba2540$var$script = $028bcec0b8ba2540$var$script.default;
    $028bcec0b8ba2540$var$script.render = (parcelRequire("bCK2r")).render;
    $028bcec0b8ba2540$var$script.__cssModules = {};
    (parcelRequire("hTZSl")).default($028bcec0b8ba2540$var$script);
    $028bcec0b8ba2540$var$script.__scopeId = "data-v-5b1c25";
    $028bcec0b8ba2540$var$script.__file = "NoPreview.vue";
};
$028bcec0b8ba2540$var$initialize();
var $028bcec0b8ba2540$export$2e2bcd8739ae039 = $028bcec0b8ba2540$var$script;

});
parcelRegister("3ln8x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $26f547b83c326714$export$2e2bcd8739ae039);

var $bfN9d = parcelRequire("bfN9d");
var $26f547b83c326714$export$2e2bcd8739ae039 = {
    name: "NoPreviewAvailable",
    computed: {
        dead () {
            return 0, (/*@__PURE__*/$parcel$interopDefault($bfN9d));
        }
    }
};

});
parcelRegister("bfN9d", function(module, exports) {
module.exports = new URL("unmaintained.684100d8.svg", import.meta.url).toString();

});


parcelRegister("bCK2r", function(module, exports) {

$parcel$export(module.exports, "render", () => $8766f49b57852469$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $8766f49b57852469$var$_hoisted_1 = {
    class: "unmaintained-skin no-preview"
};
const $8766f49b57852469$var$_hoisted_2 = [
    "src"
];
function $8766f49b57852469$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $8766f49b57852469$var$_hoisted_1, [
        (0, $TusQn.createElementVNode)("img", {
            src: $options.dead,
            alt: "unmaintained skin"
        }, null, 8, $8766f49b57852469$var$_hoisted_2),
        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
    ]);
}

});

parcelRegister("hTZSl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d08791e3e47d599b$export$2e2bcd8739ae039);
let $d08791e3e47d599b$var$NOOP = ()=>{};
var $d08791e3e47d599b$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("gf7Lp", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd3411bc4b7342d2$export$2e2bcd8739ae039);
let $bd3411bc4b7342d2$var$script;




let $bd3411bc4b7342d2$var$initialize = ()=>{
    $bd3411bc4b7342d2$var$script = (parcelRequire("aOTUK"));
    if ($bd3411bc4b7342d2$var$script.__esModule) $bd3411bc4b7342d2$var$script = $bd3411bc4b7342d2$var$script.default;
    $bd3411bc4b7342d2$var$script.render = (parcelRequire("lM4F3")).render;
    $bd3411bc4b7342d2$var$script.__cssModules = {};
    (parcelRequire("70POm")).default($bd3411bc4b7342d2$var$script);
    $bd3411bc4b7342d2$var$script.__scopeId = "data-v-7b4fad";
    $bd3411bc4b7342d2$var$script.__file = "Preview.vue";
};
$bd3411bc4b7342d2$var$initialize();
var $bd3411bc4b7342d2$export$2e2bcd8739ae039 = $bd3411bc4b7342d2$var$script;

});
parcelRegister("aOTUK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7e09f24d7fbe0da4$export$2e2bcd8739ae039);

var $21Z6U = parcelRequire("21Z6U");

var $cLZby = parcelRequire("cLZby");

var $8tnW6 = parcelRequire("8tnW6");

var $dknP9 = parcelRequire("dknP9");
var $7e09f24d7fbe0da4$export$2e2bcd8739ae039 = {
    name: "Preview",
    components: {
        ArticleChanger: $21Z6U.default,
        CustomSelect: $8tnW6.default,
        CustomCheckbox: $dknP9.default,
        WarningBox: $cLZby.default
    },
    props: {
        showAnon: {
            type: Boolean,
            default: false
        },
        anonDefault: {
            type: Boolean,
            default: false
        },
        language: {
            type: String,
            default: "en"
        },
        name: {
            type: String,
            default: "Skin"
        },
        html: {
            type: String,
            default: ""
        },
        href: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            windowWidth: 0,
            window: null,
            anon: this.anonDefault,
            medium: !!localStorage.getItem("medium")
        };
    },
    computed: {
        createIssue () {
            return `https://github.com/jdlrobson/skins.wmflabs.org/issues/new?assignees=&labels=&template=enable-preview-for-${this.name}-on-skins-wmflabs-org.md&title=Please+enable+my+skin+for+live+preview+option`;
        },
        iframeStyle () {
            const offset = (this.windowWidth - 768) / 2;
            switch(this.medium){
                case "m":
                case "t":
                    return "";
                default:
                    // center
                    return `translate: ${offset}px;`;
            }
        },
        iframeClass () {
            switch(this.medium){
                case "m":
                    return "iframe--mobile";
                case "t":
                    return "iframe--tablet";
                default:
                    return "iframe--desktop";
            }
        },
        w () {
            // These must be synced with the LESS variables defined in stylesheet.
            switch(this.medium){
                case "m":
                    return 360;
                // Following have a 0.5 scale transform
                case "t":
                    return 768;
                default:
                    return 1800;
            }
        },
        h () {
            // These must be synced with the LESS variables defined in stylesheet.
            switch(this.medium){
                case "m":
                    return 740;
                case "t":
                    return 1024;
                default:
                    return 1024;
            }
        },
        enabled () {
            return this.href || this.html;
        }
    },
    methods: {
        changeAnon (ev) {
            this.$emit("changeAnon", ev.target.checked);
        },
        changeArticle (title) {
            this.$emit("changeArticle", title);
        },
        openNewWindow (ev) {
            if (!ev.target.getAttribute("href")) {
                ev.preventDefault();
                if (!this.window || this.window.closed) this.window = open("preview.html", "");
                this.window.document.write(this.html);
            }
        },
        changeLanguage (ev) {
            this.$emit("changeLanguage", ev.target.value);
        },
        changeMedium: function(ev) {
            const medium = ev.target.value;
            this.medium = medium;
            localStorage.setItem("medium", medium);
        },
        refresh () {
            const iframe = this.$refs.iframe;
            const html = this.html;
            if (iframe && html) {
                let doc;
                if (iframe.contentDocument) doc = iframe.contentDocument;
                else if (iframe.contentWindow) doc = iframe.contentWindow.document;
                else doc = iframe.document;
                doc.open("");
                doc.writeln(html);
                doc.close();
            }
            if (this.window) this.window.document.documentElement.innerHTML = html;
        }
    },
    mounted () {
        this.refresh();
        this.windowWidth = this.$el.clientWidth;
    },
    updated () {
        this.refresh();
    }
};

});
parcelRegister("21Z6U", function(module, exports) {

$parcel$export(module.exports, "default", () => $17ab1409cd7b6016$export$2e2bcd8739ae039);
let $17ab1409cd7b6016$var$script;



let $17ab1409cd7b6016$var$initialize = ()=>{
    $17ab1409cd7b6016$var$script = (parcelRequire("6Wckk"));
    if ($17ab1409cd7b6016$var$script.__esModule) $17ab1409cd7b6016$var$script = $17ab1409cd7b6016$var$script.default;
    $17ab1409cd7b6016$var$script.render = (parcelRequire("26nXZ")).render;
    (parcelRequire("4cawb")).default($17ab1409cd7b6016$var$script);
    $17ab1409cd7b6016$var$script.__scopeId = "data-v-75000c";
    $17ab1409cd7b6016$var$script.__file = "ArticleChanger.vue";
};
$17ab1409cd7b6016$var$initialize();
var $17ab1409cd7b6016$export$2e2bcd8739ae039 = $17ab1409cd7b6016$var$script;

});
parcelRegister("6Wckk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $50d1b8b91ccd2741$export$2e2bcd8739ae039);

var $7Yi7V = parcelRequire("7Yi7V");

var $8tnW6 = parcelRequire("8tnW6");
var $50d1b8b91ccd2741$export$2e2bcd8739ae039 = {
    name: "ArticleChanger",
    components: {
        CustomSelect: $8tnW6.default
    },
    data () {
        return {
            articles: (0, $7Yi7V.TEST_ARTICLES),
            testArticle: (0, $7Yi7V.TEST_ARTICLES)[0]
        };
    },
    methods: {
        changeArticle: function(ev) {
            this.testArticle = ev.target.value;
            this.$emit("changeArticle", this.testArticle);
        }
    }
};

});
parcelRegister("8tnW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $62b39963765b24c2$export$2e2bcd8739ae039);
let $62b39963765b24c2$var$script;




let $62b39963765b24c2$var$initialize = ()=>{
    $62b39963765b24c2$var$script = (parcelRequire("7EYHy"));
    if ($62b39963765b24c2$var$script.__esModule) $62b39963765b24c2$var$script = $62b39963765b24c2$var$script.default;
    $62b39963765b24c2$var$script.render = (parcelRequire("5MZmC")).render;
    $62b39963765b24c2$var$script.__cssModules = {};
    (parcelRequire("3EZZ8")).default($62b39963765b24c2$var$script);
    $62b39963765b24c2$var$script.__scopeId = "data-v-13fb36";
    $62b39963765b24c2$var$script.__file = "CustomSelect.vue";
};
$62b39963765b24c2$var$initialize();
var $62b39963765b24c2$export$2e2bcd8739ae039 = $62b39963765b24c2$var$script;

});
parcelRegister("7EYHy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $593b5ae56f11d1c2$export$2e2bcd8739ae039);
var $593b5ae56f11d1c2$export$2e2bcd8739ae039 = {
    name: "CustomSelect"
};

});

parcelRegister("5MZmC", function(module, exports) {

$parcel$export(module.exports, "render", () => $437109070f7256d2$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $437109070f7256d2$var$_hoisted_1 = {
    class: "custom-select"
};
function $437109070f7256d2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $437109070f7256d2$var$_hoisted_1, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
    ]);
}

});

parcelRegister("3EZZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aa5307150887e1b$export$2e2bcd8739ae039);
let $2aa5307150887e1b$var$NOOP = ()=>{};
var $2aa5307150887e1b$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("26nXZ", function(module, exports) {

$parcel$export(module.exports, "render", () => $187ebb8c6d54d04a$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
const $187ebb8c6d54d04a$var$_hoisted_1 = {
    class: "article-changer"
};
const $187ebb8c6d54d04a$var$_hoisted_2 = [
    "value"
];
function $187ebb8c6d54d04a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CustomSelect = (0, $TusQn.resolveComponent)("CustomSelect");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $187ebb8c6d54d04a$var$_hoisted_1, [
        _cache[1] || (_cache[1] = (0, $TusQn.createElementVNode)("label", {
            for: "article-title"
        }, "article: ", -1)),
        (0, $TusQn.createVNode)(_component_CustomSelect, null, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createElementVNode)("select", {
                        name: "article-title",
                        onChange: _cache[0] || (_cache[0] = (...args)=>$options.changeArticle && $options.changeArticle(...args))
                    }, [
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.articles, (a, i)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("option", {
                                key: i,
                                value: a.title
                            }, (0, $8XWQX.toDisplayString)(a.name), 9, $187ebb8c6d54d04a$var$_hoisted_2);
                        }), 128))
                    ], 32)
                ]),
            _: 1
        })
    ]);
}

});

parcelRegister("4cawb", function(module, exports) {

$parcel$export(module.exports, "default", () => $30e07116cf695686$export$2e2bcd8739ae039);
let $30e07116cf695686$var$NOOP = ()=>{};
var $30e07116cf695686$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("cLZby", function(module, exports) {

$parcel$export(module.exports, "default", () => $94c955f4c9bbb369$export$2e2bcd8739ae039);
let $94c955f4c9bbb369$var$script;




let $94c955f4c9bbb369$var$initialize = ()=>{
    $94c955f4c9bbb369$var$script = (parcelRequire("4YFNG"));
    if ($94c955f4c9bbb369$var$script.__esModule) $94c955f4c9bbb369$var$script = $94c955f4c9bbb369$var$script.default;
    $94c955f4c9bbb369$var$script.render = (parcelRequire("i2C70")).render;
    $94c955f4c9bbb369$var$script.__cssModules = {};
    (parcelRequire("cJG7K")).default($94c955f4c9bbb369$var$script);
    $94c955f4c9bbb369$var$script.__scopeId = "data-v-a241a8";
    $94c955f4c9bbb369$var$script.__file = "WarningBox.vue";
};
$94c955f4c9bbb369$var$initialize();
var $94c955f4c9bbb369$export$2e2bcd8739ae039 = $94c955f4c9bbb369$var$script;

});
parcelRegister("4YFNG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $39fd30b6169d8376$export$2e2bcd8739ae039);
var $39fd30b6169d8376$export$2e2bcd8739ae039 = {
    name: "WarningBox",
    components: {}
};

});

parcelRegister("i2C70", function(module, exports) {

$parcel$export(module.exports, "render", () => $d225fa282a3cf3ee$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $d225fa282a3cf3ee$var$_hoisted_1 = {
    class: "warning"
};
function $d225fa282a3cf3ee$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $d225fa282a3cf3ee$var$_hoisted_1, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
    ]);
}

});

parcelRegister("cJG7K", function(module, exports) {

$parcel$export(module.exports, "default", () => $945a5cef74fc8b64$export$2e2bcd8739ae039);
let $945a5cef74fc8b64$var$NOOP = ()=>{};
var $945a5cef74fc8b64$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("lM4F3", function(module, exports) {

$parcel$export(module.exports, "render", () => $fda1b24181d06ee0$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
const $fda1b24181d06ee0$var$_hoisted_1 = {
    class: "preview"
};
const $fda1b24181d06ee0$var$_hoisted_2 = {
    key: 0,
    class: "preview__area"
};
const $fda1b24181d06ee0$var$_hoisted_3 = [
    "href"
];
const $fda1b24181d06ee0$var$_hoisted_4 = [
    "src",
    "width",
    "height"
];
const $fda1b24181d06ee0$var$_hoisted_5 = {
    key: 1,
    class: "preview__area preview__area--unavailable"
};
const $fda1b24181d06ee0$var$_hoisted_6 = [
    "href"
];
const $fda1b24181d06ee0$var$_hoisted_7 = {
    class: "preview__panel"
};
const $fda1b24181d06ee0$var$_hoisted_8 = {
    class: "medium-selector"
};
const $fda1b24181d06ee0$var$_hoisted_9 = {
    class: "loggedin-selector"
};
function $fda1b24181d06ee0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_WarningBox = (0, $TusQn.resolveComponent)("WarningBox");
    const _component_ArticleChanger = (0, $TusQn.resolveComponent)("ArticleChanger");
    const _component_CustomSelect = (0, $TusQn.resolveComponent)("CustomSelect");
    const _component_CustomCheckbox = (0, $TusQn.resolveComponent)("CustomCheckbox");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $fda1b24181d06ee0$var$_hoisted_1, [
        $options.enabled ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $fda1b24181d06ee0$var$_hoisted_2, [
            (0, $TusQn.createElementVNode)("a", {
                href: $props.href,
                class: "link--new-window",
                target: "_blank",
                onClick: _cache[0] || (_cache[0] = (...args)=>$options.openNewWindow && $options.openNewWindow(...args))
            }, " View in new window ", 8, $fda1b24181d06ee0$var$_hoisted_3),
            (0, $TusQn.createElementVNode)("iframe", {
                ref: "iframe",
                sandbox: "allow-same-origin allow-scripts",
                class: (0, $8XWQX.normalizeClass)($options.iframeClass),
                style: (0, $8XWQX.normalizeStyle)($options.iframeStyle),
                src: $props.href,
                width: $options.w,
                height: $options.h
            }, null, 14, $fda1b24181d06ee0$var$_hoisted_4)
        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $fda1b24181d06ee0$var$_hoisted_5, " Preview unavailable. ")),
        !$options.enabled ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_WarningBox, {
            key: 2
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    _cache[3] || (_cache[3] = (0, $TusQn.createTextVNode)(" If you are the maintainer of the skin you can request preview is enabled by creating an ")),
                    (0, $TusQn.createElementVNode)("a", {
                        target: "_blank",
                        href: $options.createIssue
                    }, "issue", 8, $fda1b24181d06ee0$var$_hoisted_6),
                    _cache[4] || (_cache[4] = (0, $TusQn.createTextVNode)(". "))
                ]),
            _: 1
        })) : (0, $TusQn.createCommentVNode)("", true),
        (0, $TusQn.createElementVNode)("div", $fda1b24181d06ee0$var$_hoisted_7, [
            (0, $TusQn.createVNode)(_component_ArticleChanger, {
                onChangeArticle: $options.changeArticle
            }, null, 8, [
                "onChangeArticle"
            ]),
            (0, $TusQn.createElementVNode)("div", $fda1b24181d06ee0$var$_hoisted_8, [
                (0, $TusQn.createVNode)(_component_CustomSelect, null, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createElementVNode)("select", {
                                onChange: _cache[1] || (_cache[1] = (...args)=>$options.changeMedium && $options.changeMedium(...args))
                            }, _cache[5] || (_cache[5] = [
                                (0, $TusQn.createElementVNode)("option", {
                                    value: "d"
                                }, " desktop ", -1),
                                (0, $TusQn.createElementVNode)("option", {
                                    value: "t"
                                }, " tablet ", -1),
                                (0, $TusQn.createElementVNode)("option", {
                                    value: "m"
                                }, " mobile ", -1)
                            ]), 32)
                        ]),
                    _: 1
                }),
                $props.language ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_CustomSelect, {
                    key: 0
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createElementVNode)("select", {
                                onChange: _cache[2] || (_cache[2] = (...args)=>$options.changeLanguage && $options.changeLanguage(...args))
                            }, _cache[6] || (_cache[6] = [
                                (0, $TusQn.createElementVNode)("option", {
                                    value: "en"
                                }, " English ", -1),
                                (0, $TusQn.createElementVNode)("option", {
                                    value: "he"
                                }, " \u05E2\u05D1\u05E8\u05D9\u05EA ", -1),
                                (0, $TusQn.createElementVNode)("option", {
                                    value: "zh"
                                }, " \u4E2D\u6587 ", -1)
                            ]), 32)
                        ]),
                    _: 1
                })) : (0, $TusQn.createCommentVNode)("", true)
            ]),
            (0, $TusQn.createElementVNode)("div", $fda1b24181d06ee0$var$_hoisted_9, [
                $props.showAnon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_CustomCheckbox, {
                    key: 0,
                    checked: $data.anon,
                    name: "anon",
                    onInput: $options.changeAnon
                }, {
                    default: (0, $TusQn.withCtx)(()=>_cache[7] || (_cache[7] = [
                            (0, $TusQn.createTextVNode)(" Anonymous ")
                        ])),
                    _: 1
                }, 8, [
                    "checked",
                    "onInput"
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ])
        ])
    ]);
}

});

parcelRegister("70POm", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b0b9223f2052d9$export$2e2bcd8739ae039);
let $51b0b9223f2052d9$var$NOOP = ()=>{};
var $51b0b9223f2052d9$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("1idr2", function(module, exports) {

$parcel$export(module.exports, "render", () => $0f11e4d7463b69a3$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
const $0f11e4d7463b69a3$var$_hoisted_1 = {
    class: "preview-launcher"
};
const $0f11e4d7463b69a3$var$_hoisted_2 = [
    "src"
];
const $0f11e4d7463b69a3$var$_hoisted_3 = {
    key: 0
};
const $0f11e4d7463b69a3$var$_hoisted_4 = {
    key: 1
};
function $0f11e4d7463b69a3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_NoPreview = (0, $TusQn.resolveComponent)("NoPreview");
    const _component_Preview = (0, $TusQn.resolveComponent)("Preview");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $0f11e4d7463b69a3$var$_hoisted_1, [
        $data.previewInactive ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
            key: 0,
            class: (0, $8XWQX.normalizeClass)($options.previewScreenshotClass),
            onClick: _cache[0] || (_cache[0] = (...args)=>$options.activatePreview && $options.activatePreview(...args))
        }, [
            (0, $TusQn.createElementVNode)("img", {
                src: $props.src
            }, null, 8, $0f11e4d7463b69a3$var$_hoisted_2),
            !$props.available ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_NoPreview, {
                key: 0
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        !$props.available ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $0f11e4d7463b69a3$var$_hoisted_3, " Preview unavailable ")) : (0, $TusQn.createCommentVNode)("", true),
                        !$props.maintained ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $0f11e4d7463b69a3$var$_hoisted_4, _cache[1] || (_cache[1] = [
                            (0, $TusQn.createTextVNode)(" This skin appears to be "),
                            (0, $TusQn.createElementVNode)("strong", null, "unmaintained", -1)
                        ]))) : (0, $TusQn.createCommentVNode)("", true)
                    ]),
                _: 1
            })) : (0, $TusQn.createCommentVNode)("", true)
        ], 2)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_Preview, {
            key: 1,
            href: $options.href,
            name: $props.name,
            language: "en",
            onChangeLanguage: $options.changeLanguage,
            onChangeArticle: $options.changeArticle
        }, null, 8, [
            "href",
            "name",
            "onChangeLanguage",
            "onChangeArticle"
        ]))
    ]);
}

});

parcelRegister("6vGg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bd66b22a60828dd$export$2e2bcd8739ae039);
let $4bd66b22a60828dd$var$NOOP = ()=>{};
var $4bd66b22a60828dd$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("9Sqco", function(module, exports) {

$parcel$export(module.exports, "default", () => $730d7ac3805c0d25$export$2e2bcd8739ae039);
let $730d7ac3805c0d25$var$script;



let $730d7ac3805c0d25$var$initialize = ()=>{
    $730d7ac3805c0d25$var$script = (parcelRequire("ifNW5"));
    if ($730d7ac3805c0d25$var$script.__esModule) $730d7ac3805c0d25$var$script = $730d7ac3805c0d25$var$script.default;
    $730d7ac3805c0d25$var$script.render = (parcelRequire("9m4E7")).render;
    (parcelRequire("cmrpE")).default($730d7ac3805c0d25$var$script);
    $730d7ac3805c0d25$var$script.__scopeId = "data-v-fc78aa";
    $730d7ac3805c0d25$var$script.__file = "SkinWarnings.vue";
};
$730d7ac3805c0d25$var$initialize();
var $730d7ac3805c0d25$export$2e2bcd8739ae039 = $730d7ac3805c0d25$var$script;

});
parcelRegister("ifNW5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d4a05cee4b4f71bd$export$2e2bcd8739ae039);

var $7Yi7V = parcelRequire("7Yi7V");

var $cLZby = parcelRequire("cLZby");
var $d4a05cee4b4f71bd$export$2e2bcd8739ae039 = {
    name: "SkinWarnings",
    components: {
        WarningBox: $cLZby.default
    },
    props: {
        additionalSetupMessage: {
            default: `Warning: An editor has marked this skin with [[Category:${(0, $7Yi7V.CATEGORY_ADDITIONAL_REQUIREMENTS)}]] to indicate that this skin requires additional setup.
`
        },
        mightBreakMessage: {
            type: String,
            default: `Warning: This skin has been flagged with [[Category:${(0, $7Yi7V.CATEGORY_INCOMPATIBLE_WITH_MEDIAWIKI_MASTER)}]] to indicate this it may
break in future MediaWiki versions without prompt action.
`
        },
        beta: {
            type: Boolean,
            required: true
        },
        experimental: {
            type: Boolean,
            required: true
        },
        hasDependencies: {
            type: Boolean,
            required: true
        },
        mightBreak: {
            type: Boolean,
            required: true
        },
        compatible: {
            type: Boolean,
            required: true
        },
        unmaintained: {
            type: Boolean,
            required: true
        },
        url: {
            type: String,
            required: true
        }
    }
};

});

parcelRegister("9m4E7", function(module, exports) {

$parcel$export(module.exports, "render", () => $6cf9c5c34af09769$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
const $6cf9c5c34af09769$var$_hoisted_1 = {
    key: 0
};
const $6cf9c5c34af09769$var$_hoisted_2 = {
    key: 1
};
const $6cf9c5c34af09769$var$_hoisted_3 = {
    key: 2
};
const $6cf9c5c34af09769$var$_hoisted_4 = {
    key: 3
};
const $6cf9c5c34af09769$var$_hoisted_5 = {
    key: 4
};
const $6cf9c5c34af09769$var$_hoisted_6 = {
    key: 5
};
const $6cf9c5c34af09769$var$_hoisted_7 = [
    "href"
];
const $6cf9c5c34af09769$var$_hoisted_8 = [
    "href"
];
function $6cf9c5c34af09769$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_WarningBox = (0, $TusQn.resolveComponent)("WarningBox");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_WarningBox, {
        class: "warningbox"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                $props.beta ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $6cf9c5c34af09769$var$_hoisted_1, "Warning: This skin is marked as beta.")) : (0, $TusQn.createCommentVNode)("", true),
                $props.experimental ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $6cf9c5c34af09769$var$_hoisted_2, " Warning: This skin has been marked as experimental. ")) : (0, $TusQn.createCommentVNode)("", true),
                $props.hasDependencies ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $6cf9c5c34af09769$var$_hoisted_3, (0, $8XWQX.toDisplayString)($props.additionalSetupMessage), 1)) : (0, $TusQn.createCommentVNode)("", true),
                $props.mightBreak ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $6cf9c5c34af09769$var$_hoisted_4, (0, $8XWQX.toDisplayString)($props.mightBreakMessage), 1)) : (0, $TusQn.createCommentVNode)("", true),
                !$props.compatible ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $6cf9c5c34af09769$var$_hoisted_5, " Warning: This skin does not work with the latest MediaWiki release. ")) : (0, $TusQn.createCommentVNode)("", true),
                $props.unmaintained ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $6cf9c5c34af09769$var$_hoisted_6, [
                    _cache[0] || (_cache[0] = (0, $TusQn.createTextVNode)(" Warning: This skin is not maintained. It is likely incompatible with the current MediaWiki branch.")),
                    _cache[1] || (_cache[1] = (0, $TusQn.createElementVNode)("br", null, null, -1)),
                    _cache[2] || (_cache[2] = (0, $TusQn.createElementVNode)("br", null, null, -1)),
                    _cache[3] || (_cache[3] = (0, $TusQn.createTextVNode)(" Please ")),
                    (0, $TusQn.createElementVNode)("a", {
                        href: _ctx.mwUrl
                    }, "review the skin's page", 8, $6cf9c5c34af09769$var$_hoisted_7),
                    _cache[4] || (_cache[4] = (0, $TusQn.createTextVNode)(" on MediaWiki.org for the problem with this skin which will be described in the status field: ")),
                    _cache[5] || (_cache[5] = (0, $TusQn.createElementVNode)("pre", null, "|status      = unmaintained <!-- explanation --> ", -1)),
                    _cache[6] || (_cache[6] = (0, $TusQn.createTextVNode)(" If you are the skin author, please address the problem described. If you are capable, you may want to fork this skin, and become it's maintainer. If you do this, please update the repository URL on ")),
                    (0, $TusQn.createElementVNode)("a", {
                        href: $props.url
                    }, "MediaWiki.org", 8, $6cf9c5c34af09769$var$_hoisted_8),
                    _cache[7] || (_cache[7] = (0, $TusQn.createTextVNode)(". "))
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ]),
        _: 1
    });
}

});

parcelRegister("cmrpE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ffccdb1c09a719f$export$2e2bcd8739ae039);
let $8ffccdb1c09a719f$var$NOOP = ()=>{};
var $8ffccdb1c09a719f$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("jr1Yt", function(module, exports) {

$parcel$export(module.exports, "render", () => $e2621201c47223f4$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
const $e2621201c47223f4$var$_hoisted_1 = {
    class: "content"
};
const $e2621201c47223f4$var$_hoisted_2 = {
    key: 1
};
const $e2621201c47223f4$var$_hoisted_3 = {
    key: 2
};
const $e2621201c47223f4$var$_hoisted_4 = {
    key: 3
};
const $e2621201c47223f4$var$_hoisted_5 = {
    key: 4
};
const $e2621201c47223f4$var$_hoisted_6 = {
    key: 6
};
const $e2621201c47223f4$var$_hoisted_7 = [
    "href"
];
function $e2621201c47223f4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Searcher = (0, $TusQn.resolveComponent)("Searcher");
    const _component_PreviewLauncher = (0, $TusQn.resolveComponent)("PreviewLauncher");
    const _component_RouterLink = (0, $TusQn.resolveComponent)("RouterLink");
    const _component_SkinWarnings = (0, $TusQn.resolveComponent)("SkinWarnings");
    const _component_Page = (0, $TusQn.resolveComponent)("Page");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_Page, {
        class: "page--skin"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createVNode)(_component_Searcher, {
                    "filter-key": $data.skinkey,
                    "show-no-results-message": false,
                    onInput: $options.onSearch
                }, null, 8, [
                    "filter-key",
                    "onInput"
                ]),
                (0, $TusQn.createElementVNode)("div", $e2621201c47223f4$var$_hoisted_1, [
                    (0, $TusQn.createElementVNode)("h2", null, (0, $8XWQX.toDisplayString)($data.name), 1),
                    $data.infoIsLoaded ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_PreviewLauncher, {
                        key: 0,
                        src: $options.srcLarge,
                        skinkey: $data.skinkey,
                        name: $data.name,
                        maintained: !$data.unmaintained,
                        available: $data.preview
                    }, null, 8, [
                        "src",
                        "skinkey",
                        "name",
                        "maintained",
                        "available"
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    (0, $TusQn.createElementVNode)("p", null, [
                        _cache[1] || (_cache[1] = (0, $TusQn.createTextVNode)(" by ")),
                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.authors, (author, i)=>{
                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                key: "author-" + i
                            }, [
                                (0, $TusQn.createVNode)(_component_RouterLink, {
                                    to: "/explore/author:" + author
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(author), 1)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "to"
                                ]),
                                _cache[0] || (_cache[0] = (0, $TusQn.createTextVNode)("\xa0"))
                            ]);
                        }), 128))
                    ]),
                    $data.license ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $e2621201c47223f4$var$_hoisted_2, [
                        _cache[2] || (_cache[2] = (0, $TusQn.createTextVNode)(" Licensed under ")),
                        (0, $TusQn.createVNode)(_component_RouterLink, {
                            to: `/explore/license:${$data.license}`
                        }, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createElementVNode)("strong", null, (0, $8XWQX.toDisplayString)($data.license), 1)
                                ]),
                            _: 1
                        }, 8, [
                            "to"
                        ])
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    $data.created ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $e2621201c47223f4$var$_hoisted_3, " Published to MediaWiki.org on " + (0, $8XWQX.toDisplayString)($data.created), 1)) : (0, $TusQn.createCommentVNode)("", true),
                    $data.infoIsLoaded ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("h3", $e2621201c47223f4$var$_hoisted_4, " About: ")) : (0, $TusQn.createCommentVNode)("", true),
                    $data.infoIsLoaded ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $e2621201c47223f4$var$_hoisted_5, (0, $8XWQX.toDisplayString)($data.summary), 1)) : (0, $TusQn.createCommentVNode)("", true),
                    $options.showWarnings ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_SkinWarnings, {
                        key: 5,
                        url: $options.mwUrl,
                        beta: $data.beta,
                        experimental: $data.experimental,
                        unmaintained: $data.unmaintained,
                        "has-dependencies": $data.hasDependencies,
                        "might-break": $data.mightBreak,
                        compatible: $data.compatible
                    }, null, 8, [
                        "url",
                        "beta",
                        "experimental",
                        "unmaintained",
                        "has-dependencies",
                        "might-break",
                        "compatible"
                    ])) : (0, $TusQn.createCommentVNode)("", true),
                    $data.infoIsLoaded ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("h3", $e2621201c47223f4$var$_hoisted_6, " View: ")) : (0, $TusQn.createCommentVNode)("", true),
                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($data.links, (link, i)=>{
                        return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                            key: i,
                            class: "skinLink",
                            target: "_blank",
                            href: link.href
                        }, (0, $8XWQX.toDisplayString)(link.text), 9, $e2621201c47223f4$var$_hoisted_7);
                    }), 128))
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("gMD6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $c37f7597049dd44b$export$2e2bcd8739ae039);
let $c37f7597049dd44b$var$NOOP = ()=>{};
var $c37f7597049dd44b$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("a5F10", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $01e5535a07741e01$export$2e2bcd8739ae039);

var $73mM4 = parcelRequire("73mM4");

var $ajjle = parcelRequire("ajjle");
var $01e5535a07741e01$export$2e2bcd8739ae039 = {
    name: "NotFound",
    components: {
        RouterLink: $73mM4.RouterLink,
        Page: $ajjle.default
    }
};

});

parcelRegister("at2xZ", function(module, exports) {

$parcel$export(module.exports, "render", () => $79ee96a4927946f8$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $79ee96a4927946f8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $TusQn.resolveComponent)("router-link");
    const _component_Page = (0, $TusQn.resolveComponent)("Page");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_Page, {
        class: "page--404"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                _cache[1] || (_cache[1] = (0, $TusQn.createElementVNode)("h2", null, "Page not found", -1)),
                (0, $TusQn.createVNode)(_component_router_link, {
                    class: "breadcrumb",
                    to: "/"
                }, {
                    default: (0, $TusQn.withCtx)(()=>_cache[0] || (_cache[0] = [
                            (0, $TusQn.createTextVNode)(" Explore other skins ")
                        ])),
                    _: 1
                })
            ]),
        _: 1
    });
}

});

parcelRegister("iFUMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d98818f02d83cf91$export$2e2bcd8739ae039);
let $d98818f02d83cf91$var$NOOP = ()=>{};
var $d98818f02d83cf91$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("aTkuF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7edef00e202f8845$export$2e2bcd8739ae039);
/* eslint-disable vue/no-undef-properties */ /* global less */ 
var $iPUx5 = parcelRequire("iPUx5");

var $eZefG = parcelRequire("eZefG");

var $cX88K = parcelRequire("cX88K");

var $7Yi7V = parcelRequire("7Yi7V");

var $ifgZ7 = parcelRequire("ifgZ7");

var $9yj3W = parcelRequire("9yj3W");

var $2s757 = parcelRequire("2s757");

var $gf7Lp = parcelRequire("gf7Lp");

var $iNhHq = parcelRequire("iNhHq");

var $jn472 = parcelRequire("jn472");

var $ajjle = parcelRequire("ajjle");
parcelRequire("kjyEk");

var $73mM4 = parcelRequire("73mM4");

var $6ZWSX = parcelRequire("6ZWSX");
var $7edef00e202f8845$require$Buffer = $6ZWSX.Buffer;
const $7edef00e202f8845$var$tokens = $7edef00e202f8845$require$Buffer.from("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", "base64").toString();
const $7edef00e202f8845$var$assets = (0, $eZefG.buildDefaultAssets)();
const $7edef00e202f8845$var$DEFAULT_SKIN_MUSTACHE = $7edef00e202f8845$var$assets.mustache;
const $7edef00e202f8845$var$DEFAULT_SKIN_LESS = $7edef00e202f8845$var$assets.less;
const $7edef00e202f8845$var$LANGUAGES = {
    "msg-otherlanguages": "Read in another language"
};
const $7edef00e202f8845$var$DEFAULT_HTML = "<!DOCTYPE HTML><html><body>Loading preview...</body></html>";
const $7edef00e202f8845$var$generateStylesheetLESS = ()=>`/* Styles */
${$7edef00e202f8845$var$DEFAULT_SKIN_LESS}
`;
const $7edef00e202f8845$var$DEFAULT_SKIN_PROPS = {
    html: $7edef00e202f8845$var$DEFAULT_HTML,
    anon: true,
    variables: (0, $eZefG.getLessVarsRaw)(),
    less: $7edef00e202f8845$var$generateStylesheetLESS(),
    js: `/* scripts can go here */
`,
    mustache: $7edef00e202f8845$var$DEFAULT_SKIN_MUSTACHE
}; /**
    * Clears all import statements from the string.
    * I couldn't work out how to setup print.less locally...
    *
    * @param {string} str
    * @return {string}
    */ 
const $7edef00e202f8845$var$clearImports = (str)=>str.replace(/@import ["'][^"']*["'];/g, "");
function $7edef00e202f8845$var$getCached() {
    const props = {};
    Object.keys($7edef00e202f8845$var$DEFAULT_SKIN_PROPS).forEach((key)=>{
        let val = localStorage.getItem(`add-${key}`);
        if (val === "true") val = true;
        else if (val === "false") val = false;
        props[key] = val !== null ? val : $7edef00e202f8845$var$DEFAULT_SKIN_PROPS[key];
    });
    if (!props.skinname) props.skinname = (0, $iNhHq.default)();
    return props;
}
var $7edef00e202f8845$export$2e2bcd8739ae039 = {
    name: "Add",
    components: {
        CdxTab: $iPUx5.CdxTab,
        CdxTabs: $iPUx5.CdxTabs,
        RouterLink: $73mM4.RouterLink,
        Btn: $2s757.default,
        Page: $ajjle.default,
        JsonViewer: (/*@__PURE__*/$parcel$interopDefault($jn472)),
        Preview: $gf7Lp.default,
        ColorChart: $9yj3W.default
    },
    data () {
        return Object.assign($7edef00e202f8845$var$getCached(), {
            templateDataReq: {},
            tabsData: [
                {
                    name: "html",
                    label: "HTML ( Mustache )",
                    heading: "Sand cat"
                },
                {
                    name: "css",
                    label: "CSS",
                    heading: "View source for Sand cat"
                },
                {
                    name: "js",
                    label: "JS",
                    heading: "Sand cat: Revision history"
                }
            ],
            pending: null,
            variables: $7edef00e202f8845$var$DEFAULT_SKIN_PROPS.variables,
            json: "",
            css: "",
            // will be derived from less data value.
            title: (0, $7Yi7V.TEST_ARTICLES)[0].title
        });
    },
    computed: {
        colorChart () {
            return Object.keys(this.variables).filter((key)=>this.variables[key].indexOf("#") === 0).map((key)=>({
                    key: key,
                    color: this.variables[key]
                }));
        }
    },
    methods: {
        toggleColor (name) {
            this.variables = Object.assign(this.variables, {
                [name]: (0, $eZefG.randomColor)()
            });
            this.generatePreview();
        },
        updateJSON () {
            (0, $cX88K.default).getSkinJSON(this.title, this.anon).then((json)=>{
                this.json = json;
            });
        },
        changeAnon (isAnon) {
            this.anon = isAnon;
            localStorage.setItem("add-anon", isAnon);
            this.generatePreview();
            this.updateJSON();
        },
        reset () {
            const confirm = window.confirm(`Reset the skin (${this.skinname}) you are currently working on? All changes will be lost!`);
            if (confirm) {
                Object.keys($7edef00e202f8845$var$DEFAULT_SKIN_PROPS).forEach((key)=>{
                    localStorage.removeItem(`add-${key}`);
                    this[key] = $7edef00e202f8845$var$DEFAULT_SKIN_PROPS[key];
                }); // random stylesheet each time.
                this.newTheme();
                this.less = $7edef00e202f8845$var$generateStylesheetLESS();
                this.js = $7edef00e202f8845$var$DEFAULT_SKIN_PROPS.js;
                this.startingLess = this.less;
                this.generatePreview();
            }
        },
        newName (ev) {
            this.skinname = (0, $iNhHq.default)(); // unfocus to reset animation.
            setTimeout(()=>{
                this.generatePreview();
                ev.target.blur();
            }, 500);
            localStorage.setItem("add-skinname", this.skinname);
        },
        newTheme () {
            this.variables = Object.assign({}, (0, $eZefG.getLessVarsRaw)());
            this.generatePreview();
        },
        updateName (ev) {
            this.skinname = ev.target.value;
            localStorage.setItem("add-skinname", this.skinname);
        },
        download () {
            (0, $eZefG.buildSkin)(this.skinname, this.mustache, this.less, this.js, this.variables);
        },
        changeArticle (title) {
            this.title = title;
            this.generatePreview();
            this.updateJSON();
        },
        updateCSS (ev) {
            this.less = ev.target.value;
            this.generatePreview();
            localStorage.setItem("add-less", this.less);
        },
        updateJS (ev) {
            this.js = ev.target.value;
            this.generatePreview();
            localStorage.setItem("add-js", this.js);
        },
        updateMustache (ev) {
            this.mustache = ev.target.value;
            this.generatePreview();
            localStorage.setItem("add-mustache", this.mustache);
        },
        getUrl (title) {
            return `${0, $7Yi7V.HOST}/wiki/${title}?useskin=skinjson&testuser=${this.anon ? "0" : "1"}`;
        },
        getTemplateData (title) {
            const url = this.getUrl(title);
            if (!this.templateDataReq[url]) this.templateDataReq[url] = fetch(url, {
                mode: "cors"
            }).then((r)=>r.json()).then((json)=>{
                const msgs = {};
                (0, $eZefG.messages)({}).forEach((key)=>{
                    const templateKey = "msg-" + key;
                    if (!json[templateKey]) msgs[templateKey] = `{{${key}}}`;
                });
                return Object.assign({}, json, msgs, $7edef00e202f8845$var$LANGUAGES);
            });
            return this.templateDataReq[url];
        },
        generatePreview () {
            if (this.pending) clearTimeout(this.pending);
            this.html = $7edef00e202f8845$var$DEFAULT_HTML;
            this.pending = setTimeout(()=>{
                let css; // eslint-disable-next-line no-useless-escape
                const js = "<script>" + this.js + "</script>";
                const imports = (0, $eZefG.getLESSFromTemplate)(this.mustache);
                const lessVars = $7edef00e202f8845$var$tokens + "\n" + (0, $eZefG.getLessVarsCode)(this.variables);
                less.render(`${lessVars}${$7edef00e202f8845$var$clearImports(this.less)}${imports}`, (0, $7Yi7V.LESS_RENDER_OPTIONS)).then((compiledLess)=>{
                    css = compiledLess.css;
                    return this.getTemplateData(this.title);
                }, (err)=>{
                    css = ""; // eslint-disable-next-line no-console
                    console.log(`Error in LESS:\n ${err.message}`, err);
                    return this.getTemplateData(this.title);
                }).then((data)=>{
                    const OVERRIDES = {
                        "msg-sitetitle": `Skin:${this.skinname}`,
                        "msg-tagline": "A new MediaWiki skin is born",
                        "html-subtitle": `<a target="_blank" href="${this.getUrl(this.title)}">View as JSON format</a>.`
                    };
                    this.html = `<!DOCTYPE HTML>
                <html>
                <head>
                  ${0, $eZefG.JQUERY}
                  <style type="text/css">${(0, $eZefG.getResourceLoaderSkinModuleStylesFromStylesheet)(css)}</style>
                  <link rel="stylesheet" href="${0, $7Yi7V.HOST}/w/load.php?lang=en&modules=ext.cite.styles%7Cext.echo.styles.badge%7Cext.math.styles%7Cext.wikihiero%7Cmediawiki.page.gallery.styles%7Cmediawiki.ui.icon%7Cmediawiki.ui.button%7Coojs-ui.styles.icons-alerts&only=styles">
                  <style type="text/css">${css}</style>
                </head>
                <body>${(0, $ifgZ7.render)(this.mustache, Object.assign({}, data, OVERRIDES), (0, $eZefG.PARTIALS))}
                ${js}${0, $eZefG.SCRIPTS}
                </body></html>`;
                });
            }, 300);
        }
    },
    mounted () {
        this.generatePreview();
        this.updateJSON();
    }
};

});
parcelRegister("iPUx5", function(module, exports) {

$parcel$export(module.exports, "CdxTab", () => $db68d79c4ce005fe$export$b9548060c0a710bb);
$parcel$export(module.exports, "CdxTabs", () => $db68d79c4ce005fe$export$a83e2c3a89339f7f);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
var $8XWQX = parcelRequire("8XWQX");
var $eeJ70 = parcelRequire("eeJ70");
var $db68d79c4ce005fe$var$__defProp = Object.defineProperty;
var $db68d79c4ce005fe$var$__defProps = Object.defineProperties;
var $db68d79c4ce005fe$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $db68d79c4ce005fe$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $db68d79c4ce005fe$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $db68d79c4ce005fe$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $db68d79c4ce005fe$var$__defNormalProp = (obj, key, value)=>key in obj ? $db68d79c4ce005fe$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $db68d79c4ce005fe$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($db68d79c4ce005fe$var$__hasOwnProp.call(b, prop)) $db68d79c4ce005fe$var$__defNormalProp(a, prop, b[prop]);
    if ($db68d79c4ce005fe$var$__getOwnPropSymbols) {
        for (var prop of $db68d79c4ce005fe$var$__getOwnPropSymbols(b))if ($db68d79c4ce005fe$var$__propIsEnum.call(b, prop)) $db68d79c4ce005fe$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $db68d79c4ce005fe$var$__spreadProps = (a, b)=>$db68d79c4ce005fe$var$__defProps(a, $db68d79c4ce005fe$var$__getOwnPropDescs(b));
var $db68d79c4ce005fe$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($db68d79c4ce005fe$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $db68d79c4ce005fe$var$__getOwnPropSymbols) {
        for (var prop of $db68d79c4ce005fe$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $db68d79c4ce005fe$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $db68d79c4ce005fe$var$__publicField = (obj, key, value)=>{
    $db68d79c4ce005fe$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
var $db68d79c4ce005fe$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
const $db68d79c4ce005fe$var$g = '<path d="M11.53 2.3A1.85 1.85 0 0010 1.21 1.85 1.85 0 008.48 2.3L.36 16.36C-.48 17.81.21 19 1.88 19h16.24c1.67 0 2.36-1.19 1.52-2.64zM11 16H9v-2h2zm0-4H9V6h2z"/>', $db68d79c4ce005fe$var$q = '<path d="M12.43 14.34A5 5 0 0110 15a5 5 0 113.95-2L17 16.09V3a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 001.45-.63z"/><circle cx="10" cy="10" r="3"/>', $db68d79c4ce005fe$var$s1 = '<path d="M7 14.17 2.83 10l-1.41 1.41L7 17 19 5l-1.41-1.42z"/>', $db68d79c4ce005fe$var$n1 = '<path d="M10 0a10 10 0 1010 10A10 10 0 0010 0m5.66 14.24-1.41 1.41L10 11.41l-4.24 4.25-1.42-1.42L8.59 10 4.34 5.76l1.42-1.42L10 8.59l4.24-4.24 1.41 1.41L11.41 10z"/>', $db68d79c4ce005fe$var$d1 = '<path d="m4.34 2.93 12.73 12.73-1.41 1.41L2.93 4.35z"/><path d="M17.07 4.34 4.34 17.07l-1.41-1.41L15.66 2.93z"/>', $db68d79c4ce005fe$var$g1 = '<path d="M10 15 2 5h16z"/>', $db68d79c4ce005fe$var$k1 = '<path d="M13.728 1H6.272L1 6.272v7.456L6.272 19h7.456L19 13.728V6.272zM11 15H9v-2h2zm0-4H9V5h2z"/>', $db68d79c4ce005fe$var$F1 = '<path d="m17.5 4.75-7.5 7.5-7.5-7.5L1 6.25l9 9 9-9z"/>', $db68d79c4ce005fe$var$t0 = '<path d="M19 3H1v14h18zM3 14l3.5-4.5 2.5 3L12.5 8l4.5 6z"/><path d="M19 5H1V3h18zm0 12H1v-2h18z"/>', $db68d79c4ce005fe$var$p = '<path d="M8 19a1 1 0 001 1h2a1 1 0 001-1v-1H8zm9-12a7 7 0 10-12 4.9S7 14 7 15v1a1 1 0 001 1h4a1 1 0 001-1v-1c0-1 2-3.1 2-3.1A7 7 0 0017 7"/>', $db68d79c4ce005fe$var$e0 = '<path d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0M9 5h2v2H9zm0 4h2v6H9z"/>', $db68d79c4ce005fe$var$z2 = '<path d="M3 1h2v18H3zm13.5 1.5L15 1l-9 9 9 9 1.5-1.5L9 10z"/>', $db68d79c4ce005fe$var$i2 = '<path d="M15 1h2v18h-2zM3.5 2.5 11 10l-7.5 7.5L5 19l9-9-9-9z"/>', $db68d79c4ce005fe$var$V2 = '<path d="M7 1 5.6 2.5 13 10l-7.4 7.5L7 19l9-9z"/>', $db68d79c4ce005fe$var$b2 = '<path d="m4 10 9 9 1.4-1.5L7 10l7.4-7.5L13 1z"/>', $db68d79c4ce005fe$var$J2 = '<path d="M12.2 13.6a7 7 0 111.4-1.4l5.4 5.4-1.4 1.4zM3 8a5 5 0 1010 0A5 5 0 003 8"/>', $db68d79c4ce005fe$var$h5 = '<path d="M10 0 3 8h14zm0 18-7-8h14z"/>', $db68d79c4ce005fe$var$M5 = '<path d="M10 20a10 10 0 010-20 10 10 0 110 20m-2-5 9-8.5L15.5 5 8 12 4.5 8.5 3 10z"/>', $db68d79c4ce005fe$var$G5 = '<path d="m10 5 8 10H2z"/>', $db68d79c4ce005fe$var$M3 = $db68d79c4ce005fe$var$g, $db68d79c4ce005fe$var$S3 = $db68d79c4ce005fe$var$q, $db68d79c4ce005fe$var$K3 = $db68d79c4ce005fe$var$s1, $db68d79c4ce005fe$var$Y3 = $db68d79c4ce005fe$var$n1, $db68d79c4ce005fe$var$X3 = $db68d79c4ce005fe$var$d1, $db68d79c4ce005fe$var$l4 = $db68d79c4ce005fe$var$g1, $db68d79c4ce005fe$var$i4 = $db68d79c4ce005fe$var$k1, $db68d79c4ce005fe$var$m4 = $db68d79c4ce005fe$var$F1, $db68d79c4ce005fe$var$P4 = $db68d79c4ce005fe$var$t0, $db68d79c4ce005fe$var$Y4 = {
    langCodeMap: {
        ar: $db68d79c4ce005fe$var$p
    },
    default: $db68d79c4ce005fe$var$e0
}, $db68d79c4ce005fe$var$P6 = {
    ltr: $db68d79c4ce005fe$var$z2,
    shouldFlip: true
}, $db68d79c4ce005fe$var$N6 = {
    ltr: $db68d79c4ce005fe$var$i2,
    shouldFlip: true
}, $db68d79c4ce005fe$var$j6 = {
    ltr: $db68d79c4ce005fe$var$V2,
    shouldFlip: true
}, $db68d79c4ce005fe$var$d7 = {
    ltr: $db68d79c4ce005fe$var$b2,
    shouldFlip: true
}, $db68d79c4ce005fe$var$A7 = $db68d79c4ce005fe$var$J2, $db68d79c4ce005fe$var$T7 = $db68d79c4ce005fe$var$h5, $db68d79c4ce005fe$var$O7 = $db68d79c4ce005fe$var$M5, $db68d79c4ce005fe$var$x8 = $db68d79c4ce005fe$var$G5;
function $db68d79c4ce005fe$var$N8(c, s, h) {
    if (typeof c == "string" || "path" in c) return c;
    if ("shouldFlip" in c) return c.ltr;
    if ("rtl" in c) return h === "rtl" ? c.rtl : c.ltr;
    const n = s in c.langCodeMap ? c.langCodeMap[s] : c.default;
    return typeof n == "string" || "path" in n ? n : n.ltr;
}
function $db68d79c4ce005fe$var$O8(c, s) {
    if (typeof c == "string") return false;
    if ("langCodeMap" in c) {
        const h = s in c.langCodeMap ? c.langCodeMap[s] : c.default;
        if (typeof h == "string") return false;
        c = h;
    }
    if ("shouldFlipExceptions" in c && Array.isArray(c.shouldFlipExceptions)) {
        const h = c.shouldFlipExceptions.indexOf(s);
        return h === void 0 || h === -1;
    }
    return "shouldFlip" in c ? c.shouldFlip : false;
}
function $db68d79c4ce005fe$export$b64edd098c9cdbaf(root) {
    const computedDir = (0, $01W3b.ref)(null);
    (0, $TusQn.onMounted)(()=>{
        const dir = window.getComputedStyle(root.value).direction;
        computedDir.value = dir === "ltr" || dir === "rtl" ? dir : null;
    });
    return computedDir;
}
function $db68d79c4ce005fe$export$fafaa3135f296aba(root) {
    const computedLang = (0, $01W3b.ref)("");
    (0, $TusQn.onMounted)(()=>{
        let ancestor = root.value;
        while(ancestor && ancestor.lang === "")ancestor = ancestor.parentElement;
        computedLang.value = ancestor ? ancestor.lang : null;
    });
    return computedLang;
}
function $db68d79c4ce005fe$var$makeStringTypeValidator(allowedValues) {
    return (s)=>typeof s === "string" && allowedValues.indexOf(s) !== -1;
}
const $db68d79c4ce005fe$var$LibraryPrefix = "cdx";
const $db68d79c4ce005fe$var$ButtonActions = [
    "default",
    "progressive",
    "destructive"
];
const $db68d79c4ce005fe$var$ButtonWeights = [
    "normal",
    "primary",
    "quiet"
];
const $db68d79c4ce005fe$var$ButtonSizes = [
    "medium",
    "large"
];
const $db68d79c4ce005fe$var$IconSizes = [
    "x-small",
    "small",
    "medium"
];
const $db68d79c4ce005fe$var$StatusTypes = [
    "notice",
    "warning",
    "error",
    "success"
];
const $db68d79c4ce005fe$var$statusTypeValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$StatusTypes);
const $db68d79c4ce005fe$var$TextInputTypes = [
    "text",
    "search",
    "number",
    "email",
    "month",
    "password",
    "tel",
    "url",
    "week",
    "date",
    "datetime-local",
    "time"
];
const $db68d79c4ce005fe$var$ValidationStatusTypes = [
    "default",
    "warning",
    "error",
    "success"
];
const $db68d79c4ce005fe$var$TableTextAlignments = [
    "start",
    "center",
    "end",
    // Numbers should be aligned to the right in all reading directionalities.
    "number"
];
const $db68d79c4ce005fe$var$DebounceInterval = 120;
const $db68d79c4ce005fe$var$PendingDelay = 500;
const $db68d79c4ce005fe$var$MenuFooterValue = "cdx-menu-footer-item";
const $db68d79c4ce005fe$var$TabsKey = Symbol("CdxTabs");
const $db68d79c4ce005fe$var$ActiveTabKey = Symbol("CdxActiveTab");
const $db68d79c4ce005fe$var$AllowArbitraryKey = Symbol("CdxAllowArbitrary");
const $db68d79c4ce005fe$var$FieldInputIdKey = Symbol("CdxFieldInputId");
const $db68d79c4ce005fe$var$FieldDescriptionIdKey = Symbol("CdxFieldDescriptionId");
const $db68d79c4ce005fe$var$FieldStatusKey = Symbol("CdxFieldStatus");
const $db68d79c4ce005fe$var$DisabledKey = Symbol("CdxDisabled");
const $db68d79c4ce005fe$var$NoInvertClass = "".concat($db68d79c4ce005fe$var$LibraryPrefix, "-no-invert");
const $db68d79c4ce005fe$export$6bc4af29e8294dab = Symbol("CdxTableRowIdentifier");
const $db68d79c4ce005fe$var$TablePaginationPositions = [
    "top",
    "bottom",
    "both"
];
const $db68d79c4ce005fe$var$iconSizeValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$IconSizes);
const $db68d79c4ce005fe$var$_sfc_main$y = (0, $TusQn.defineComponent)({
    name: "CdxIcon",
    props: {
        /** The SVG path or an object containing that path plus other data. */ icon: {
            type: [
                String,
                Object
            ],
            required: true
        },
        /**
     * Accessible label for the icon. If not included, the icon will be hidden from screen
     * readers via `aria-hidden="true"`. Browsers also display this label as a tooltip when the
     * user hovers over the icon. Note that this label is not rendered as visible text next
     * to the icon.
     */ iconLabel: {
            type: String,
            default: ""
        },
        /**
     * Explicitly set the language code to use for the icon. See
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/lang.
     * Defaults to the lang attribute of the nearest ancestor at mount time.
     */ lang: {
            type: String,
            default: null
        },
        /**
     * Explicitly set the direction to use for the icon. See
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/dir.
     * Defaults to the computed direction at mount time.
     */ dir: {
            type: String,
            default: null
        },
        /**
     * Specify icon size by choosing one of several pre-defined size
     * options. See the type documentation for supported size options.
     * The `medium` size is used by default if no size prop is provided.
     */ size: {
            type: String,
            default: "medium",
            validator: $db68d79c4ce005fe$var$iconSizeValidator
        }
    },
    setup (props) {
        const rootElement = (0, $01W3b.ref)();
        const computedDir = $db68d79c4ce005fe$export$b64edd098c9cdbaf(rootElement);
        const computedLang = $db68d79c4ce005fe$export$fafaa3135f296aba(rootElement);
        const overriddenDir = (0, $TusQn.computed)(()=>{
            var _a;
            return (_a = props.dir) != null ? _a : computedDir.value;
        });
        const overriddenLang = (0, $TusQn.computed)(()=>{
            var _a;
            return (_a = props.lang) != null ? _a : computedLang.value;
        });
        const rootClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-icon--flipped": overriddenDir.value === "rtl" && overriddenLang.value !== null && $db68d79c4ce005fe$var$O8(props.icon, overriddenLang.value),
                ["cdx-icon--".concat(props.size)]: true
            };
        });
        const resolvedIcon = (0, $TusQn.computed)(()=>{
            var _a, _b;
            return $db68d79c4ce005fe$var$N8(props.icon, (_a = overriddenLang.value) != null ? _a : "", (_b = overriddenDir.value) != null ? _b : "ltr");
        });
        const iconSvg = (0, $TusQn.computed)(()=>typeof resolvedIcon.value === "string" ? resolvedIcon.value : "");
        const iconPath = (0, $TusQn.computed)(()=>typeof resolvedIcon.value !== "string" ? resolvedIcon.value.path : "");
        return {
            rootElement: rootElement,
            rootClasses: rootClasses,
            iconSvg: iconSvg,
            iconPath: iconPath
        };
    }
});
const $db68d79c4ce005fe$var$_export_sfc = (sfc, props)=>{
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props)target[key] = val;
    return target;
};
const $db68d79c4ce005fe$var$_hoisted_1$v = [
    "aria-hidden"
];
const $db68d79c4ce005fe$var$_hoisted_2$m = {
    key: 0
};
const $db68d79c4ce005fe$var$_hoisted_3$e = [
    "innerHTML"
];
const $db68d79c4ce005fe$var$_hoisted_4$9 = [
    "d"
];
function $db68d79c4ce005fe$var$_sfc_render$y(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
        ref: "rootElement",
        class: (0, $8XWQX.normalizeClass)([
            "cdx-icon",
            _ctx.rootClasses
        ])
    }, [
        ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            "aria-hidden": _ctx.iconLabel ? void 0 : true
        }, [
            _ctx.iconLabel ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("title", $db68d79c4ce005fe$var$_hoisted_2$m, (0, $8XWQX.toDisplayString)(_ctx.iconLabel), 1)) : (0, $TusQn.createCommentVNode)("v-if", true),
            _ctx.iconSvg ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("g", {
                key: 1,
                innerHTML: _ctx.iconSvg
            }, null, 8, $db68d79c4ce005fe$var$_hoisted_3$e)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("path", {
                key: 2,
                d: _ctx.iconPath
            }, null, 8, $db68d79c4ce005fe$var$_hoisted_4$9))
        ], 8, $db68d79c4ce005fe$var$_hoisted_1$v))
    ], 2);
}
const $db68d79c4ce005fe$export$675126b72043484a = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$y, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$y
    ]
]);
function $db68d79c4ce005fe$var$flattenSlotContents(slotContents) {
    const flattened = [];
    for (const node of slotContents){
        if (// HTML tag
        typeof node.type === "string" || // Component
        typeof node.type === "object") flattened.push(node);
        else if (node.type !== (0, $TusQn.Comment)) {
            if (typeof node.children === "string" && node.children.trim() !== "") flattened.push(node.children);
            else if (Array.isArray(node.children)) flattened.push(...$db68d79c4ce005fe$var$flattenSlotContents(node.children));
        }
    }
    return flattened;
}
function $db68d79c4ce005fe$var$isComponentVNode(node, componentName) {
    if (typeof node.type === "object" && "name" in node.type) {
        if (componentName !== void 0) return node.type.name === componentName;
        return true;
    }
    return false;
}
function $db68d79c4ce005fe$var$isTagVNode(node, tagName) {
    if (typeof node.type === "string") return node.type === tagName.toLowerCase();
    return false;
}
function $db68d79c4ce005fe$export$57535e89d59a174(slot) {
    const slotContents = typeof slot === "function" ? slot() : slot;
    return slotContents ? $db68d79c4ce005fe$var$flattenSlotContents(slotContents) : [];
}
function $db68d79c4ce005fe$export$3f97d07ad730ccf0(shouldWarn, message) {
    if (shouldWarn()) {
        (0, $TusQn.warn)(message);
        return;
    }
    const stop = (0, $TusQn.watch)(shouldWarn, (newValue)=>{
        if (newValue) {
            (0, $TusQn.warn)(message);
            stop();
        }
    });
}
function $db68d79c4ce005fe$var$useIconOnlyButton(slot, attrs, componentName) {
    const isIconOnly = (0, $TusQn.computed)(()=>{
        const slotContents = $db68d79c4ce005fe$export$57535e89d59a174(slot);
        if (slotContents.length !== 1) return false;
        const soleNode = slotContents[0];
        if (typeof soleNode === "object" && ($db68d79c4ce005fe$var$isComponentVNode(soleNode, "CdxIcon") || $db68d79c4ce005fe$var$isTagVNode(soleNode, "svg"))) return true;
        return false;
    });
    $db68d79c4ce005fe$export$3f97d07ad730ccf0(()=>isIconOnly.value && !attrs["aria-label"] && !attrs["aria-hidden"], "".concat(componentName, ": Icon-only buttons require one of the following attributes: aria-label or aria-hidden. See documentation at https://doc.wikimedia.org/codex/latest/components/demos/button.html#icon-only-button"));
    return isIconOnly;
}
const $db68d79c4ce005fe$var$buttonActionValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ButtonActions);
const $db68d79c4ce005fe$var$buttonWeightValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ButtonWeights);
const $db68d79c4ce005fe$var$buttonSizeValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ButtonSizes);
const $db68d79c4ce005fe$var$_sfc_main$x = (0, $TusQn.defineComponent)({
    name: "CdxButton",
    props: {
        /**
     * The kind of action that will be taken on click.
     *
     * @values 'default', 'progressive', 'destructive'
     */ action: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$buttonActionValidator
        },
        /**
     * Visual prominence of the button.
     *
     * @values 'normal', 'primary', 'quiet'
     */ weight: {
            type: String,
            default: "normal",
            validator: $db68d79c4ce005fe$var$buttonWeightValidator
        },
        /**
     * Button size.
     *
     * Most buttons should use the default medium size. In rare cases the large size should
     * be used, for example to make icon-only buttons larger on touchscreens.
     *
     * @values 'medium', 'large'
     */ size: {
            type: String,
            default: "medium",
            validator: $db68d79c4ce005fe$var$buttonSizeValidator
        }
    },
    emits: [
        "click"
    ],
    setup (props, { emit: emit, slots: slots, attrs: attrs }) {
        const button = (0, $01W3b.ref)();
        const isIconOnly = $db68d79c4ce005fe$var$useIconOnlyButton(slots.default, attrs, "CdxButton");
        const isActive = (0, $01W3b.ref)(false);
        const rootClasses = (0, $TusQn.computed)(()=>({
                ["cdx-button--action-".concat(props.action)]: true,
                ["cdx-button--weight-".concat(props.weight)]: true,
                ["cdx-button--size-".concat(props.size)]: true,
                "cdx-button--framed": props.weight !== "quiet",
                "cdx-button--icon-only": isIconOnly.value,
                "cdx-button--is-active": isActive.value
            }));
        const onClick = (event)=>{
            emit("click", event);
        };
        const setActive = (active)=>{
            isActive.value = active;
        };
        function onKeyDown() {
            setActive(true);
        }
        function onKeyUp() {
            var _a;
            setActive(false);
            (_a = button.value) == null || _a.click();
        }
        return {
            button: button,
            rootClasses: rootClasses,
            onClick: onClick,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        };
    }
});
function $db68d79c4ce005fe$var$_sfc_render$x(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
        ref: "button",
        class: (0, $8XWQX.normalizeClass)([
            "cdx-button",
            _ctx.rootClasses
        ]),
        onKeydown: _cache[0] || (_cache[0] = (0, $eeJ70.withKeys)((0, $eeJ70.withModifiers)((...args)=>_ctx.onKeyDown && _ctx.onKeyDown(...args), [
            "prevent"
        ]), [
            "space",
            "enter"
        ])),
        onKeyup: _cache[1] || (_cache[1] = (0, $eeJ70.withKeys)((...args)=>_ctx.onKeyUp && _ctx.onKeyUp(...args), [
            "space",
            "enter"
        ])),
        onClick: _cache[2] || (_cache[2] = (...args)=>_ctx.onClick && _ctx.onClick(...args))
    }, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
    ], 34);
}
const $db68d79c4ce005fe$export$3318068e43c65fe8 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$x, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$x
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$w = (0, $TusQn.defineComponent)({
    name: "CdxAccordion",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    props: {
        /**
     * Forces the accordion to show the action icon.
     *
     * @values 'true', 'false'
     */ actionAlwaysVisible: {
            type: Boolean,
            default: false
        },
        /**
     * The icon that will be displayed on the right side of the accordion header when expanded.
     *
     */ actionIcon: {
            type: [
                String,
                Object
            ],
            default: null
        },
        /**
     * Label for the action button. If an action icon is being used, then a label for that icon
     * should be provided for ARIA support.
     */ actionButtonLabel: {
            type: String,
            default: ""
        },
        /**
     * The heading level of the accordion title.
     *
     * @values 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
     */ headingLevel: {
            type: String,
            default: "h3"
        }
    },
    emits: [
        /**
     * When the action button is clicked.
     *
     */ "action-button-click"
    ],
    setup (props, { attrs: attrs, emit: emit }) {
        const isExpanded = (0, $01W3b.ref)("open" in attrs);
        const emitActionButtonClick = ()=>{
            emit("action-button-click");
        };
        const onToggle = (e)=>{
            isExpanded.value = e.newState === "open";
        };
        const shouldShowActionButton = (0, $TusQn.computed)(()=>{
            return props.actionIcon && (isExpanded.value || props.actionAlwaysVisible);
        });
        const rootClasses = (0, $TusQn.computed)(()=>({
                "cdx-accordion--has-icon": shouldShowActionButton.value
            }));
        return {
            emitActionButtonClick: emitActionButtonClick,
            rootClasses: rootClasses,
            shouldShowActionButton: shouldShowActionButton,
            onToggle: onToggle
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$u = {
    class: "cdx-accordion__header__title"
};
const $db68d79c4ce005fe$var$_hoisted_2$l = {
    class: "cdx-accordion__header__description"
};
function $db68d79c4ce005fe$var$_sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("details", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-accordion",
            _ctx.rootClasses
        ]),
        onToggle: _cache[1] || (_cache[1] = (...args)=>_ctx.onToggle && _ctx.onToggle(...args))
    }, [
        (0, $TusQn.createElementVNode)("summary", null, [
            ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(_ctx.headingLevel), {
                class: "cdx-accordion__header"
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_1$u, [
                            (0, $TusQn.renderSlot)(_ctx.$slots, "title")
                        ]),
                        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2$l, [
                            (0, $TusQn.renderSlot)(_ctx.$slots, "description")
                        ])
                    ]),
                _: 3
            })),
            _ctx.shouldShowActionButton ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                key: 0,
                class: "cdx-accordion__action",
                "aria-label": _ctx.actionButtonLabel,
                type: "button",
                weight: "quiet",
                onClick: (0, $eeJ70.withModifiers)(_ctx.emitActionButtonClick, [
                    "stop"
                ])
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_cdx_icon, {
                            icon: _ctx.actionIcon,
                            "icon-label": _ctx.actionButtonLabel,
                            size: "medium"
                        }, null, 8, [
                            "icon",
                            "icon-label"
                        ])
                    ]),
                _: 1
            }, 8, [
                "aria-label",
                "onClick"
            ])) : (0, $TusQn.createCommentVNode)("v-if", true)
        ]),
        (0, $TusQn.createElementVNode)("div", {
            class: "cdx-accordion__content",
            onClick: _cache[0] || (_cache[0] = (0, $eeJ70.withModifiers)(()=>{}, [
                "stop"
            ]))
        }, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ])
    ], 34);
}
const $db68d79c4ce005fe$export$62c6a40b05a2ad3 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$w, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$w
    ]
]);
function $db68d79c4ce005fe$var$getButtonLabel(button) {
    if (button.label === void 0) return button.value;
    if (button.label === null) return "";
    return button.label;
}
function $db68d79c4ce005fe$var$useButtonGroupKeyboardNav(buttonsProp) {
    const rootElement = (0, $01W3b.ref)();
    const focusedButtonIndex = (0, $01W3b.ref)();
    const buttonRefs = (0, $01W3b.ref)(/* @__PURE__ */ new Map());
    const currentDirection = $db68d79c4ce005fe$export$b64edd098c9cdbaf(rootElement);
    function assignTemplateRef(templateRef, index) {
        const button = templateRef;
        if (button) buttonRefs.value.set(index, button);
    }
    function onFocus(index) {
        focusedButtonIndex.value = index;
    }
    function onBlur() {
        focusedButtonIndex.value = void 0;
    }
    function focusNonDisabled(index, increment) {
        var _a;
        const newIndex = index + increment;
        const targetButton = buttonsProp.value[newIndex];
        if (targetButton) {
            if (targetButton.disabled) focusNonDisabled(newIndex, increment);
            else {
                const buttonElement = (_a = buttonRefs.value.get(newIndex)) == null ? void 0 : _a.$el;
                buttonElement == null || buttonElement.focus();
            }
        }
    }
    function next() {
        var _a;
        focusNonDisabled((_a = focusedButtonIndex.value) != null ? _a : -1, 1);
    }
    function prev() {
        var _a;
        focusNonDisabled((_a = focusedButtonIndex.value) != null ? _a : buttonsProp.value.length, -1);
    }
    function moveRight() {
        if (currentDirection.value === "rtl") prev();
        else next();
    }
    function moveLeft() {
        if (currentDirection.value === "rtl") next();
        else prev();
    }
    function onKeydown(e) {
        switch(e.key){
            case "ArrowRight":
                e.preventDefault();
                moveRight();
                break;
            case "ArrowLeft":
                e.preventDefault();
                moveLeft();
                break;
            case "ArrowDown":
                e.preventDefault();
                next();
                break;
            case "ArrowUp":
                e.preventDefault();
                prev();
                break;
        }
    }
    return {
        rootElement: rootElement,
        assignTemplateRef: assignTemplateRef,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeydown: onKeydown
    };
}
const $db68d79c4ce005fe$var$_sfc_main$v = (0, $TusQn.defineComponent)({
    name: "CdxButtonGroup",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    props: {
        /**
     * Objects describing the buttons in the group. See the ButtonGroupItem type.
     */ buttons: {
            type: Array,
            required: true,
            validator: (value)=>Array.isArray(value) && value.length >= 1
        },
        /**
     * Whether the entire group is disabled.
     *
     * If this is set to true, all buttons in the group are disabled. Buttons can also be
     * disabled individually by setting their `disabled` property to true.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * Emitted when a button is clicked
     *
     * @property {string | number} value The `value` property of the button that was clicked
     */ "click"
    ],
    setup (props) {
        const { rootElement: rootElement, assignTemplateRef: assignTemplateRef, onFocus: onFocus, onBlur: onBlur, onKeydown: onKeydown } = $db68d79c4ce005fe$var$useButtonGroupKeyboardNav((0, $01W3b.toRef)(props, "buttons"));
        return {
            rootElement: rootElement,
            assignTemplateRef: assignTemplateRef,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeydown: onKeydown,
            getButtonLabel: $db68d79c4ce005fe$var$getButtonLabel
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$t = {
    ref: "rootElement",
    class: "cdx-button-group"
};
function $db68d79c4ce005fe$var$_sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_1$t, [
        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.buttons, (button, index)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                key: button.value,
                ref_for: true,
                ref: (ref2)=>_ctx.assignTemplateRef(ref2, index),
                disabled: button.disabled || _ctx.disabled,
                "aria-label": button.ariaLabel,
                onClick: ($event)=>_ctx.$emit("click", button.value),
                onFocus: ($event)=>_ctx.onFocus(index),
                onBlur: _ctx.onBlur,
                onKeydown: _ctx.onKeydown
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.renderSlot)(_ctx.$slots, "default", {
                            button: button
                        }, ()=>[
                                button.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                                    key: 0,
                                    icon: button.icon
                                }, null, 8, [
                                    "icon"
                                ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                (0, $TusQn.createTextVNode)(" " + (0, $8XWQX.toDisplayString)(_ctx.getButtonLabel(button)), 1)
                            ])
                    ]),
                _: 2
            }, 1032, [
                "disabled",
                "aria-label",
                "onClick",
                "onFocus",
                "onBlur",
                "onKeydown"
            ]);
        }), 128))
    ], 512);
}
const $db68d79c4ce005fe$export$745f4a73ccbccffb = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$v, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$v
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$u = (0, $TusQn.defineComponent)({
    name: "CdxThumbnail",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    props: {
        /**
     * Thumbnail data.
     */ thumbnail: {
            type: [
                Object,
                null
            ],
            default: null
        },
        /**
     * Thumbnail placeholder icon.
     */ placeholderIcon: {
            type: [
                String,
                Object
            ],
            default: $db68d79c4ce005fe$var$P4
        }
    },
    setup: (props)=>{
        const thumbnailLoaded = (0, $01W3b.ref)(false);
        const thumbnailStyle = (0, $01W3b.ref)({});
        const preloadThumbnail = (url)=>{
            const escapedUrl = url.replace(/([\\"\n])/g, "\\$1");
            const image = new Image();
            image.onload = ()=>{
                thumbnailStyle.value = {
                    backgroundImage: 'url("'.concat(escapedUrl, '")')
                };
                thumbnailLoaded.value = true;
            };
            image.onerror = ()=>{
                thumbnailLoaded.value = false;
            };
            image.src = escapedUrl;
        };
        (0, $TusQn.onMounted)(()=>{
            var _a;
            if ((_a = props.thumbnail) == null ? void 0 : _a.url) preloadThumbnail(props.thumbnail.url);
        });
        return {
            thumbnailStyle: thumbnailStyle,
            thumbnailLoaded: thumbnailLoaded,
            NoInvertClass: $db68d79c4ce005fe$var$NoInvertClass
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$s = {
    class: "cdx-thumbnail"
};
const $db68d79c4ce005fe$var$_hoisted_2$k = {
    key: 0,
    class: "cdx-thumbnail__placeholder"
};
function $db68d79c4ce005fe$var$_sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_1$s, [
        !_ctx.thumbnailLoaded ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_2$k, [
            (0, $TusQn.createVNode)(_component_cdx_icon, {
                icon: _ctx.placeholderIcon,
                class: "cdx-thumbnail__placeholder__icon--vue"
            }, null, 8, [
                "icon"
            ])
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        (0, $TusQn.createVNode)((0, $eeJ70.Transition), {
            name: "cdx-thumbnail__image"
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    _ctx.thumbnailLoaded ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                        key: 0,
                        style: (0, $8XWQX.normalizeStyle)(_ctx.thumbnailStyle),
                        class: (0, $8XWQX.normalizeClass)([
                            _ctx.NoInvertClass,
                            "cdx-thumbnail__image"
                        ])
                    }, null, 6)) : (0, $TusQn.createCommentVNode)("v-if", true)
                ]),
            _: 1
        })
    ]);
}
const $db68d79c4ce005fe$export$9fe12e22779707e = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$u, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$u
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$t = (0, $TusQn.defineComponent)({
    name: "CdxCard",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxThumbnail: $db68d79c4ce005fe$export$9fe12e22779707e
    },
    props: {
        /**
     * If provided, the Card will be a link to this URL.
     */ url: {
            type: String,
            default: ""
        },
        /**
     * Icon displayed at the start of the Card.
     */ icon: {
            type: [
                String,
                Object
            ],
            default: ""
        },
        /**
     * Thumbnail image data for the Card.
     */ thumbnail: {
            type: [
                Object,
                null
            ],
            default: null
        },
        /**
     * Option to force a thumbnail layout.
     *
     * When set to `true`, the Card will display a Thumbnail. If a `thumbnail` prop was also
     * provided, the thumbnail image will display. Otherwise, a placeholder icon will display.
     *
     * This is useful when displaying groups of Cards when some of the cards have thumbnail
     * images but some do not. `forceThumbnail` will provide a consistent layout for that group.
     *
     * Note that this prop is not needed to display a thumbnail image: if the `thumbnail` prop
     * is provided, it will display. This prop is only needed to enable the display of the
     * thumbnail placeholder icon when the `thumbnail` prop is not provided.
     */ forceThumbnail: {
            type: Boolean,
            default: false
        },
        /**
     * Optional custom icon for the placeholder shown when `forceThumbnail` is true but no
     * thumbnail is provided.
     *
     * Defaults to the default placeholder icon set in the Thumbnail component.
     */ customPlaceholderIcon: {
            type: [
                String,
                Object
            ],
            default: void 0
        }
    },
    setup (props) {
        const isLink = (0, $TusQn.computed)(()=>!!props.url);
        const contentTag = (0, $TusQn.computed)(()=>isLink.value ? "a" : "span");
        const cardLink = (0, $TusQn.computed)(()=>isLink.value ? props.url : void 0);
        return {
            isLink: isLink,
            contentTag: contentTag,
            cardLink: cardLink
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$r = {
    class: "cdx-card__text"
};
const $db68d79c4ce005fe$var$_hoisted_2$j = {
    class: "cdx-card__text__title"
};
const $db68d79c4ce005fe$var$_hoisted_3$d = {
    key: 0,
    class: "cdx-card__text__description"
};
const $db68d79c4ce005fe$var$_hoisted_4$8 = {
    key: 1,
    class: "cdx-card__text__supporting-text"
};
function $db68d79c4ce005fe$var$_sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_thumbnail = (0, $TusQn.resolveComponent)("cdx-thumbnail");
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(_ctx.contentTag), {
        href: _ctx.cardLink,
        class: (0, $8XWQX.normalizeClass)([
            "cdx-card",
            {
                "cdx-card--is-link": _ctx.isLink,
                // Include dynamic classes in the template so that $slots is reactive.
                "cdx-card--title-only": !_ctx.$slots.description && !_ctx.$slots["supporting-text"]
            }
        ])
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                _ctx.thumbnail || _ctx.forceThumbnail ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_thumbnail, {
                    key: 0,
                    thumbnail: _ctx.thumbnail,
                    "placeholder-icon": _ctx.customPlaceholderIcon,
                    class: "cdx-card__thumbnail"
                }, null, 8, [
                    "thumbnail",
                    "placeholder-icon"
                ])) : _ctx.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                    key: 1,
                    icon: _ctx.icon,
                    class: "cdx-card__icon"
                }, null, 8, [
                    "icon"
                ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_1$r, [
                    (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2$j, [
                        (0, $TusQn.renderSlot)(_ctx.$slots, "title")
                    ]),
                    _ctx.$slots.description ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_3$d, [
                        (0, $TusQn.renderSlot)(_ctx.$slots, "description")
                    ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                    _ctx.$slots["supporting-text"] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_4$8, [
                        (0, $TusQn.renderSlot)(_ctx.$slots, "supporting-text")
                    ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                ])
            ]),
        _: 3
    }, 8, [
        "href",
        "class"
    ]);
}
const $db68d79c4ce005fe$export$41b8f1d4b20997da = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$t, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$t
    ]
]);
function $db68d79c4ce005fe$export$231a0ffa6150ca75(disabledProp) {
    const providedDisabled = (0, $TusQn.inject)($db68d79c4ce005fe$var$DisabledKey, (0, $01W3b.ref)(false));
    return (0, $TusQn.computed)(()=>providedDisabled.value || disabledProp.value);
}
function $db68d79c4ce005fe$export$2a5cf560aeeed52d(disabledProp, statusProp, idAttr) {
    const computedDisabled = $db68d79c4ce005fe$export$231a0ffa6150ca75(disabledProp);
    const providedStatus = (0, $TusQn.inject)($db68d79c4ce005fe$var$FieldStatusKey, (0, $01W3b.ref)("default"));
    const computedStatus = (0, $TusQn.computed)(()=>{
        if ((statusProp == null ? void 0 : statusProp.value) && statusProp.value !== "default") return statusProp.value;
        return providedStatus.value;
    });
    const providedId = (0, $TusQn.inject)($db68d79c4ce005fe$var$FieldInputIdKey, void 0);
    const computedInputId = (0, $TusQn.computed)(()=>{
        var _a;
        return (_a = providedId == null ? void 0 : providedId.value) != null ? _a : idAttr;
    });
    return {
        computedDisabled: computedDisabled,
        computedStatus: computedStatus,
        computedInputId: computedInputId
    };
}
function $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses = (0, $TusQn.computed)(()=>({}))) {
    const rootClasses = (0, $TusQn.computed)(()=>{
        const classRecord = $db68d79c4ce005fe$var$__objRest(internalClasses.value, []);
        if (attrs.class) {
            const providedClasses = attrs.class.split(" ");
            providedClasses.forEach((className)=>{
                classRecord[className] = true;
            });
        }
        return classRecord;
    });
    const rootStyle = (0, $TusQn.computed)(()=>{
        if ("style" in attrs) return attrs.style;
        return void 0;
    });
    const otherAttrs = (0, $TusQn.computed)(()=>{
        const _a = attrs, { class: _ignoredClass, style: _ignoredStyle } = _a, attrsCopy = $db68d79c4ce005fe$var$__objRest(_a, [
            "class",
            "style"
        ]);
        return attrsCopy;
    });
    return {
        rootClasses: rootClasses,
        rootStyle: rootStyle,
        otherAttrs: otherAttrs
    };
}
function $db68d79c4ce005fe$export$3f3caade1c12f8c9(messageKey, defaultValue, params = []) {
    const providedI18nFunc = (0, $TusQn.inject)("CdxI18nFunction", void 0);
    return (0, $TusQn.computed)(()=>{
        const unwrappedParams = params.map((p2)=>typeof p2 === "function" ? p2() : p2.value);
        const fromProvidedFunc = providedI18nFunc == null ? void 0 : providedI18nFunc(messageKey, ...unwrappedParams);
        if (fromProvidedFunc !== void 0 && fromProvidedFunc !== null) return fromProvidedFunc;
        return typeof defaultValue === "function" ? defaultValue(...unwrappedParams) : defaultValue;
    });
}
function $db68d79c4ce005fe$var$useI18nWithOverride(override, messageKey, defaultValue, params = []) {
    const translatedMessage = $db68d79c4ce005fe$export$3f3caade1c12f8c9(messageKey, defaultValue, params);
    return (0, $TusQn.computed)(()=>override.value || translatedMessage.value);
}
const $db68d79c4ce005fe$var$_sfc_main$s = (0, $TusQn.defineComponent)({
    name: "CdxLabel",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    /**
   * We want the label or legend to inherit attributes, not the root element.
   */ inheritAttrs: false,
    props: {
        /**
     * Icon before the label text.
     *
     * Do not use this if including a start icon within the input component.
     */ icon: {
            type: [
                String,
                Object
            ],
            default: null
        },
        /**
     * Whether the field is optional.
     *
     * This will add a flag next to the label indicating that the field is optional.
     */ optional: {
            type: Boolean,
            default: false
        },
        // DEPRECATED: set default to '(optional)' (T368444).
        /**
     * Text to indicate that the field is optional.
     *
     * Omit this prop to use the default value, "(optional)".
     */ optionalFlag: {
            type: String,
            default: ""
        },
        /**
     * Whether the label should be visually hidden.
     */ visuallyHidden: {
            type: Boolean,
            default: false
        },
        /**
     * Whether this component should output a `<legend>` element.
     *
     * Always set this to true when this component is used inside a `<fieldset>` element. Do not
     * set it to true otherwise.
     */ isLegend: {
            type: Boolean,
            default: false
        },
        /**
     * The ID of the input/control this label is for.
     *
     * Will be added as the `for` attribute of the `<label>`. Not needed for `<legend>`.
     */ inputId: {
            type: String,
            default: ""
        },
        /**
     * The ID of the description element.
     *
     * This ID can be used for the `aria-describedby` attribute of the input.
     */ descriptionId: {
            type: String,
            default: ""
        },
        /**
     * Whether this label is for a disabled field or input.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    setup (props, { attrs: attrs }) {
        const { computedDisabled: computedDisabled } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"));
        const internalClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-label--visually-hidden": props.visuallyHidden,
                "cdx-label--disabled": computedDisabled.value
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        const translatedOptionalFlag = $db68d79c4ce005fe$var$useI18nWithOverride((0, $01W3b.toRef)(props, "optionalFlag"), "cdx-label-optional-flag", "(optional)");
        return {
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            translatedOptionalFlag: translatedOptionalFlag
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$q = [
    "for"
];
const $db68d79c4ce005fe$var$_hoisted_2$i = {
    class: "cdx-label__label__text"
};
const $db68d79c4ce005fe$var$_hoisted_3$c = {
    key: 1,
    class: "cdx-label__label__optional-flag"
};
const $db68d79c4ce005fe$var$_hoisted_4$7 = [
    "id"
];
const $db68d79c4ce005fe$var$_hoisted_5$7 = {
    class: "cdx-label__label"
};
const $db68d79c4ce005fe$var$_hoisted_6$6 = {
    class: "cdx-label__label__text"
};
const $db68d79c4ce005fe$var$_hoisted_7$2 = {
    key: 1,
    class: "cdx-label__label__optional-flag"
};
const $db68d79c4ce005fe$var$_hoisted_8$1 = {
    key: 0,
    class: "cdx-label__description"
};
function $db68d79c4ce005fe$var$_sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    return !_ctx.isLegend ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        key: 0,
        class: (0, $8XWQX.normalizeClass)([
            "cdx-label",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createElementVNode)("label", (0, $TusQn.mergeProps)({
            class: "cdx-label__label",
            for: _ctx.inputId ? _ctx.inputId : void 0
        }, _ctx.otherAttrs), [
            _ctx.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                key: 0,
                icon: _ctx.icon,
                class: "cdx-label__label__icon"
            }, null, 8, [
                "icon"
            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
            (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2$i, [
                (0, $TusQn.renderSlot)(_ctx.$slots, "default")
            ]),
            _ctx.optionalFlag || _ctx.optional ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_3$c, (0, $8XWQX.toDisplayString)(" ") + " " + (0, $8XWQX.toDisplayString)(_ctx.translatedOptionalFlag), 1)) : (0, $TusQn.createCommentVNode)("v-if", true)
        ], 16, $db68d79c4ce005fe$var$_hoisted_1$q),
        _ctx.$slots.description && _ctx.$slots.description().length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
            key: 0,
            id: _ctx.descriptionId || void 0,
            class: "cdx-label__description"
        }, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "description")
        ], 8, $db68d79c4ce005fe$var$_hoisted_4$7)) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 6)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("legend", (0, $TusQn.mergeProps)({
        key: 1,
        class: [
            "cdx-label",
            _ctx.rootClasses
        ],
        style: _ctx.rootStyle
    }, _ctx.otherAttrs), [
        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_5$7, [
            _ctx.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                key: 0,
                icon: _ctx.icon,
                class: "cdx-label__label__icon"
            }, null, 8, [
                "icon"
            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
            (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_6$6, [
                (0, $TusQn.renderSlot)(_ctx.$slots, "default")
            ]),
            _ctx.optionalFlag || _ctx.optional ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_7$2, (0, $8XWQX.toDisplayString)(" ") + " " + (0, $8XWQX.toDisplayString)(_ctx.translatedOptionalFlag), 1)) : (0, $TusQn.createCommentVNode)("v-if", true)
        ]),
        _ctx.$slots.description && _ctx.$slots.description().length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_8$1, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "description")
        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 16));
}
const $db68d79c4ce005fe$export$fd351ab562a06a13 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$s, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$s
    ]
]);
function $db68d79c4ce005fe$var$useLabelChecker(slot, attrs, componentName) {
    $db68d79c4ce005fe$export$3f97d07ad730ccf0(()=>$db68d79c4ce005fe$export$57535e89d59a174(slot).length === 0 && !(attrs == null ? void 0 : attrs["aria-label"]) && !(attrs == null ? void 0 : attrs["aria-labelledby"]), "".concat(componentName, ": Inputs must have an associated label. Provide one of the following:\n - A label via the appropriate slot\n - An `aria-label` attribute set to the label text\n - An `aria-labelledby` attribute set to the ID of the label element"));
}
function $db68d79c4ce005fe$export$c9be858be225e6de(modelValueRef, emit, eventName) {
    return (0, $TusQn.computed)({
        get: ()=>modelValueRef.value,
        set: (value)=>// If eventName is undefined, then 'update:modelValue' must be a valid EventName,
            // but TypeScript's type analysis isn't clever enough to realize that
            emit(eventName || "update:modelValue", value)
    });
}
let $db68d79c4ce005fe$var$counter = 0;
function $db68d79c4ce005fe$export$6217842283d27b52(identifier) {
    var _a;
    const vm = (0, $TusQn.getCurrentInstance)();
    const externalId = (_a = vm == null ? void 0 : vm.props.id) != null ? _a : vm == null ? void 0 : vm.attrs.id;
    if (identifier) return "".concat($db68d79c4ce005fe$var$LibraryPrefix, "-").concat(identifier, "-").concat($db68d79c4ce005fe$var$counter++);
    else if (externalId) return "".concat($db68d79c4ce005fe$var$LibraryPrefix, "-").concat(externalId, "-").concat($db68d79c4ce005fe$var$counter++);
    else return "".concat($db68d79c4ce005fe$var$LibraryPrefix, "-").concat($db68d79c4ce005fe$var$counter++);
}
const $db68d79c4ce005fe$var$statusValidator$a = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$r = (0, $TusQn.defineComponent)({
    name: "CdxCheckbox",
    components: {
        CdxLabel: $db68d79c4ce005fe$export$fd351ab562a06a13
    },
    props: {
        /**
     * Value of the checkbox or checkbox group.
     *
     * Provided by `v-model` binding in the parent component.
     */ modelValue: {
            type: [
                Boolean,
                Array
            ],
            default: false
        },
        /**
     * HTML "value" attribute to assign to the input.
     *
     * Required for input groups.
     */ inputValue: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: false
        },
        /**
     * HTML "name" attribute to assign to the input.
     */ name: {
            type: String,
            default: null
        },
        /**
     * Whether the disabled attribute should be added to the input.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the indeterminate visual state should be displayed.
     *
     * This is unrelated to the value provided by `v-model`, and the indeterminate visual state
     * will override the checked or unchecked visual state.
     */ indeterminate: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the component should display inline.
     *
     * By default, `display: block` is set and a margin exists between
     * sibling components, for a stacked layout.
     */ inline: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the label should be visually hidden.
     *
     * When true, the label will remain accessible to assistive technology.
     */ hideLabel: {
            type: Boolean,
            default: false
        },
        /**
     * Validation status of the Checkbox.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$a
        }
    },
    emits: [
        /**
     * Emitted when modelValue changes.
     *
     * @property {boolean | string[] | number[]} modelValue The new model value
     */ "update:modelValue"
    ],
    setup (props, { emit: emit, slots: slots, attrs: attrs }) {
        var _a;
        $db68d79c4ce005fe$var$useLabelChecker((_a = slots.default) == null ? void 0 : _a.call(slots), attrs, "CdxCheckbox");
        const { computedDisabled: computedDisabled, computedStatus: computedStatus } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"));
        const rootClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-checkbox--inline": props.inline,
                ["cdx-checkbox--status-".concat(computedStatus.value)]: true
            };
        });
        const customInputClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-checkbox__custom-input--inline": props.inline
            };
        });
        const input = (0, $01W3b.ref)();
        const checkboxId = $db68d79c4ce005fe$export$6217842283d27b52("checkbox");
        const descriptionId = $db68d79c4ce005fe$export$6217842283d27b52("description");
        const wrappedModel = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "modelValue"), emit);
        return {
            rootClasses: rootClasses,
            computedDisabled: computedDisabled,
            input: input,
            checkboxId: checkboxId,
            descriptionId: descriptionId,
            wrappedModel: wrappedModel,
            customInputClasses: customInputClasses
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$p = {
    class: "cdx-checkbox__wrapper"
};
const $db68d79c4ce005fe$var$_hoisted_2$h = [
    "id",
    "aria-describedby",
    "value",
    "name",
    "disabled",
    ".indeterminate"
];
const $db68d79c4ce005fe$var$_hoisted_3$b = /* @__PURE__ */ (0, $TusQn.createElementVNode)("span", {
    class: "cdx-checkbox__icon"
}, null, -1);
function $db68d79c4ce005fe$var$_sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_label = (0, $TusQn.resolveComponent)("cdx-label");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-checkbox",
            _ctx.rootClasses
        ])
    }, [
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$p, [
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                id: _ctx.checkboxId,
                ref: "input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.wrappedModel = $event),
                class: "cdx-checkbox__input",
                type: "checkbox",
                "aria-describedby": _ctx.$slots.description && _ctx.$slots.description().length > 0 ? _ctx.descriptionId : void 0,
                value: _ctx.inputValue,
                name: _ctx.name,
                disabled: _ctx.computedDisabled,
                ".indeterminate": _ctx.indeterminate
            }, null, 40, $db68d79c4ce005fe$var$_hoisted_2$h), [
                [
                    (0, $eeJ70.vModelCheckbox),
                    _ctx.wrappedModel
                ]
            ]),
            $db68d79c4ce005fe$var$_hoisted_3$b,
            _ctx.$slots.default && _ctx.$slots.default().length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_label, {
                key: 0,
                class: "cdx-checkbox__label",
                "input-id": _ctx.checkboxId,
                "description-id": _ctx.$slots.description && _ctx.$slots.description().length > 0 ? _ctx.descriptionId : void 0,
                disabled: _ctx.computedDisabled,
                "visually-hidden": _ctx.hideLabel
            }, (0, $TusQn.createSlots)({
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                    ]),
                _: 2
            }, [
                _ctx.$slots.description && _ctx.$slots.description().length > 0 ? {
                    name: "description",
                    fn: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.renderSlot)(_ctx.$slots, "description")
                        ]),
                    key: "0"
                } : void 0
            ]), 1032, [
                "input-id",
                "description-id",
                "disabled",
                "visually-hidden"
            ])) : (0, $TusQn.createCommentVNode)("v-if", true)
        ]),
        _ctx.$slots["custom-input"] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
            key: 0,
            class: (0, $8XWQX.normalizeClass)([
                "cdx-checkbox__custom-input",
                _ctx.customInputClasses
            ])
        }, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "custom-input")
        ], 2)) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 2);
}
const $db68d79c4ce005fe$export$10933eadb08a15a2 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$r, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$r
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$q = (0, $TusQn.defineComponent)({
    name: "CdxInputChip",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    props: {
        /**
     * Custom icon.
     */ icon: {
            type: [
                String,
                Object
            ],
            default: null
        },
        /**
     * Whether the input chip can be removed.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    expose: [
        "focus"
    ],
    emits: [
        /**
     * Emitted when a chip is removed by the user.
     *
     * @property {'button'|'Backspace'|'Delete'} method How the chip was removed
     */ "remove-chip",
        /**
     * Emitted when a chip is clicked by the user.
     */ "click-chip",
        /**
     * Emitted when the user presses the left arrow key.
     */ "arrow-left",
        /**
     * Emitted when the user presses the right arrow key.
     */ "arrow-right"
    ],
    setup (props, { emit: emit }) {
        const rootElement = (0, $01W3b.ref)();
        const rootClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-input-chip--disabled": props.disabled
            };
        });
        const ariaDescription = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-input-chip-aria-description", "Press Enter to edit or Delete to remove");
        function onKeydown(e) {
            var _a;
            switch(e.key){
                case "Enter":
                    emit("click-chip");
                    e.preventDefault();
                    e.stopPropagation();
                    break;
                case "Escape":
                    (_a = rootElement.value) == null || _a.blur();
                    e.preventDefault();
                    e.stopPropagation();
                    break;
                case "Backspace":
                case "Delete":
                    emit("remove-chip", e.key);
                    e.preventDefault();
                    e.stopPropagation();
                    break;
                case "ArrowLeft":
                    emit("arrow-left");
                    e.preventDefault();
                    e.stopPropagation();
                    break;
                case "ArrowRight":
                    emit("arrow-right");
                    e.preventDefault();
                    e.stopPropagation();
                    break;
            }
        }
        return {
            rootElement: rootElement,
            rootClasses: rootClasses,
            ariaDescription: ariaDescription,
            onKeydown: onKeydown,
            cdxIconClose: $db68d79c4ce005fe$var$X3
        };
    },
    methods: {
        /**
     * Focus the chip.
     *
     * @public
     */ focus () {
            this.$refs.rootElement.focus();
        }
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$o = [
    "aria-description"
];
const $db68d79c4ce005fe$var$_hoisted_2$g = {
    class: "cdx-input-chip__text"
};
function $db68d79c4ce005fe$var$_sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        ref: "rootElement",
        class: (0, $8XWQX.normalizeClass)([
            "cdx-input-chip",
            _ctx.rootClasses
        ]),
        tabindex: "0",
        role: "option",
        "aria-description": _ctx.ariaDescription,
        onKeydown: _cache[1] || (_cache[1] = (...args)=>_ctx.onKeydown && _ctx.onKeydown(...args)),
        onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("click-chip"))
    }, [
        _ctx.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
            key: 0,
            icon: _ctx.icon,
            size: "small"
        }, null, 8, [
            "icon"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2$g, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ]),
        (0, $TusQn.createVNode)(_component_cdx_button, {
            class: "cdx-input-chip__button",
            weight: "quiet",
            tabindex: "-1",
            "aria-hidden": "true",
            disabled: _ctx.disabled,
            onClick: _cache[0] || (_cache[0] = (0, $eeJ70.withModifiers)(($event)=>_ctx.$emit("remove-chip", "button"), [
                "stop"
            ]))
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createVNode)(_component_cdx_icon, {
                        icon: _ctx.cdxIconClose,
                        size: "x-small"
                    }, null, 8, [
                        "icon"
                    ])
                ]),
            _: 1
        }, 8, [
            "disabled"
        ])
    ], 42, $db68d79c4ce005fe$var$_hoisted_1$o);
}
const $db68d79c4ce005fe$var$CdxInputChip = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$q, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$q
    ]
]);
function $db68d79c4ce005fe$var$useOptionalModelWrapper(internalValueRef, modelValueRef, emit, eventName) {
    return (0, $TusQn.computed)({
        get: ()=>{
            var _a;
            return (_a = modelValueRef.value) != null ? _a : internalValueRef.value;
        },
        set: (value)=>{
            if (modelValueRef.value !== null) emit(eventName || "update:modelValue", value);
            else internalValueRef.value = value;
        }
    });
}
const $db68d79c4ce005fe$var$statusValidator$9 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$p = (0, $TusQn.defineComponent)({
    name: "CdxChipInput",
    components: {
        CdxInputChip: $db68d79c4ce005fe$var$CdxInputChip
    },
    /**
   * We want the input to inherit attributes, not the root element.
   */ inheritAttrs: false,
    props: {
        /**
     * Current chips present in the input.
     *
     * Provided by `v-model` binding in the parent component.
     */ inputChips: {
            type: Array,
            required: true
        },
        /**
     * Current value of the text input. This prop is optional and should only be used if you
     * need to keep track of the text input value for some reason (e.g. for validation).
     *
     * Optionally provided by `v-model:input-value` binding in the parent component.
     */ inputValue: {
            type: [
                String,
                Number
            ],
            default: null
        },
        /**
     * Whether the text input should appear below the set of input chips.
     *
     * By default, the input chips are inline with the input.
     */ separateInput: {
            type: Boolean,
            default: false
        },
        /**
     * `status` attribute of the input.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$9
        },
        /**
     * Validation function for chip text. If it returns false, the chip will not be added and
     * the error status will be set.
     */ chipValidator: {
            type: Function,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            default: (value)=>true
        },
        /**
     * Whether the input is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * When the input chips change.
     *
     * @property {ChipInputItem[]} inputChips The new set of inputChips
     */ "update:input-chips",
        /**
     * When the input value changes. Only emitted if the inputValue prop is provided.
     *
     * @property {string | number} inputValue The new input value
     */ "update:input-value"
    ],
    setup (props, { emit: emit, attrs: attrs }) {
        const rootElement = (0, $01W3b.ref)();
        const chipsContainer = (0, $01W3b.ref)();
        const separateInputWrapper = (0, $01W3b.ref)();
        const statusMessageContent = (0, $01W3b.ref)("");
        const computedDirection = $db68d79c4ce005fe$export$b64edd098c9cdbaf(rootElement);
        const input = (0, $01W3b.ref)();
        const allowArbitrary = (0, $TusQn.inject)($db68d79c4ce005fe$var$AllowArbitraryKey, (0, $01W3b.ref)(true));
        const internalInputValue = (0, $01W3b.ref)("");
        const computedInputValue = $db68d79c4ce005fe$var$useOptionalModelWrapper(internalInputValue, (0, $01W3b.toRef)(props, "inputValue"), emit, "update:input-value");
        const validatedStatus = (0, $01W3b.ref)("default");
        const internalStatus = (0, $TusQn.computed)(()=>{
            if (validatedStatus.value === "error" || props.status === "error") return "error";
            return "default";
        });
        const { computedDisabled: computedDisabled, computedStatus: computedStatus } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), internalStatus);
        const isFocused = (0, $01W3b.ref)(false);
        const internalClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-chip-input--has-separate-input": props.separateInput,
                ["cdx-chip-input--status-".concat(computedStatus.value)]: true,
                // We need focused and disabled classes on the root element, which contains the
                // chips and the input, since it is styled to look like the input.
                "cdx-chip-input--focused": isFocused.value,
                "cdx-chip-input--disabled": computedDisabled.value
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        const chipRefs = [];
        const currentChipToRemove = (0, $01W3b.ref)(null);
        const computedChipToRemove = (0, $TusQn.computed)(()=>currentChipToRemove.value ? currentChipToRemove.value.value : "");
        const chipAddedMessage = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-chip-input-chip-added", (x)=>"Chip ".concat(x, " was added."), [
            computedInputValue
        ]);
        const chipRemovedMessage = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-chip-input-chip-removed", (x)=>"Chip ".concat(x, " was removed."), [
            computedChipToRemove
        ]);
        function assignChipTemplateRef(chip, index) {
            if (chip !== null) chipRefs[index] = chip;
        }
        const focusInput = ()=>{
            input.value.focus();
        };
        function addChip() {
            if (// If the input value is the same as a chip's value, or...
            !!props.inputChips.find((chip)=>chip.value === computedInputValue.value) || // ...validation fails, set status to error.
            !props.chipValidator(computedInputValue.value)) validatedStatus.value = "error";
            else if (computedInputValue.value.toString().length > 0) {
                statusMessageContent.value = chipAddedMessage.value;
                emit("update:input-chips", props.inputChips.concat({
                    value: computedInputValue.value
                }));
                computedInputValue.value = "";
            }
        }
        function removeChip(chipToRemove) {
            emit("update:input-chips", props.inputChips.filter((chip)=>chip.value !== chipToRemove.value));
        }
        function moveChipFocus(direction, startIndex) {
            const resolvedDirection = // -1 for prev (left in LTR, right in RTL), +1 for next (right in LTR, left in RTL)
            computedDirection.value === "ltr" && direction === "left" || computedDirection.value === "rtl" && direction === "right" ? -1 : 1;
            const newIndex = startIndex + resolvedDirection;
            if (newIndex < 0) return;
            if (newIndex >= props.inputChips.length) {
                focusInput();
                return;
            }
            chipRefs[newIndex].focus();
        }
        function handleChipClick(clickedChip) {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                var _a;
                addChip();
                yield (0, $TusQn.nextTick)();
                removeChip(clickedChip);
                computedInputValue.value = (_a = clickedChip.label) != null ? _a : clickedChip.value;
                focusInput();
            });
        }
        function handleChipRemove(chipToRemove, index, method) {
            currentChipToRemove.value = chipToRemove;
            statusMessageContent.value = chipRemovedMessage.value;
            if (method === "button") focusInput();
            else if (method === "Backspace") {
                const newIndex = index === 0 ? 1 : index - 1;
                if (newIndex < props.inputChips.length) chipRefs[newIndex].focus();
                else focusInput();
            } else if (method === "Delete") {
                const newIndex = index + 1;
                if (newIndex < props.inputChips.length) chipRefs[newIndex].focus();
                else focusInput();
            }
            removeChip(chipToRemove);
        }
        function onInputKeydown(e) {
            var _a, _b;
            const prevArrow = computedDirection.value === "rtl" ? "ArrowRight" : "ArrowLeft";
            switch(e.key){
                case "Enter":
                    if (computedInputValue.value.toString().length > 0 && allowArbitrary.value) {
                        addChip();
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                    }
                    break;
                case "Escape":
                    (_a = input.value) == null || _a.blur();
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                case "Backspace":
                case prevArrow:
                    if (((_b = input.value) == null ? void 0 : _b.selectionStart) === 0 && input.value.selectionEnd === 0 && props.inputChips.length > 0) {
                        chipRefs[props.inputChips.length - 1].focus();
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                    }
                    break;
            }
        }
        function onInputFocus() {
            isFocused.value = true;
        }
        function onInputBlur() {
            isFocused.value = false;
        }
        function onFocusOut(e) {
            var _a;
            if (!((_a = rootElement.value) == null ? void 0 : _a.contains(e.relatedTarget)) && allowArbitrary.value) addChip();
        }
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "inputChips"), (newVal)=>{
            const matchingChip = newVal.find((chip)=>chip.value === computedInputValue.value);
            validatedStatus.value = matchingChip ? "error" : "default";
        });
        (0, $TusQn.watch)(computedInputValue, ()=>{
            if (validatedStatus.value === "error") validatedStatus.value = "default";
        });
        return {
            rootElement: rootElement,
            chipsContainer: chipsContainer,
            separateInputWrapper: separateInputWrapper,
            input: input,
            computedInputValue: computedInputValue,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            assignChipTemplateRef: assignChipTemplateRef,
            handleChipClick: handleChipClick,
            handleChipRemove: handleChipRemove,
            moveChipFocus: moveChipFocus,
            onInputKeydown: onInputKeydown,
            focusInput: focusInput,
            onInputFocus: onInputFocus,
            onInputBlur: onInputBlur,
            onFocusOut: onFocusOut,
            computedDisabled: computedDisabled,
            statusMessageContent: statusMessageContent
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$n = {
    ref: "chipsContainer",
    class: "cdx-chip-input__chips",
    role: "listbox",
    "aria-orientation": "horizontal"
};
const $db68d79c4ce005fe$var$_hoisted_2$f = [
    "disabled"
];
const $db68d79c4ce005fe$var$_hoisted_3$a = {
    key: 0,
    ref: "separateInputWrapper",
    class: "cdx-chip-input__separate-input"
};
const $db68d79c4ce005fe$var$_hoisted_4$6 = [
    "disabled"
];
const $db68d79c4ce005fe$var$_hoisted_5$6 = {
    class: "cdx-chip-input__aria-status",
    role: "status",
    "aria-live": "polite"
};
function $db68d79c4ce005fe$var$_sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_input_chip = (0, $TusQn.resolveComponent)("cdx-input-chip");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        ref: "rootElement",
        class: (0, $8XWQX.normalizeClass)([
            "cdx-chip-input",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle),
        onClick: _cache[8] || (_cache[8] = (...args)=>_ctx.focusInput && _ctx.focusInput(...args)),
        onFocusout: _cache[9] || (_cache[9] = (...args)=>_ctx.onFocusOut && _ctx.onFocusOut(...args))
    }, [
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$n, [
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.inputChips, (chip, index)=>{
                return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_input_chip, {
                    key: chip.value,
                    ref_for: true,
                    ref: (ref2)=>_ctx.assignChipTemplateRef(ref2, index),
                    class: "cdx-chip-input__item",
                    icon: chip.icon,
                    disabled: _ctx.computedDisabled,
                    onClickChip: ($event)=>_ctx.handleChipClick(chip),
                    onRemoveChip: (method)=>_ctx.handleChipRemove(chip, index, method),
                    onArrowLeft: ($event)=>_ctx.moveChipFocus("left", index),
                    onArrowRight: ($event)=>_ctx.moveChipFocus("right", index)
                }, {
                    default: (0, $TusQn.withCtx)(()=>{
                        var _a;
                        return [
                            (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)((_a = chip.label) != null ? _a : chip.value), 1)
                        ];
                    }),
                    _: 2
                }, 1032, [
                    "icon",
                    "disabled",
                    "onClickChip",
                    "onRemoveChip",
                    "onArrowLeft",
                    "onArrowRight"
                ]);
            }), 128)),
            !_ctx.separateInput ? (0, $TusQn.withDirectives)(((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("input", (0, $TusQn.mergeProps)({
                key: 0,
                ref: "input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedInputValue = $event),
                class: "cdx-chip-input__input",
                disabled: _ctx.computedDisabled
            }, _ctx.otherAttrs, {
                onBlur: _cache[1] || (_cache[1] = (...args)=>_ctx.onInputBlur && _ctx.onInputBlur(...args)),
                onFocus: _cache[2] || (_cache[2] = (...args)=>_ctx.onInputFocus && _ctx.onInputFocus(...args)),
                onKeydown: _cache[3] || (_cache[3] = (...args)=>_ctx.onInputKeydown && _ctx.onInputKeydown(...args))
            }), null, 16, $db68d79c4ce005fe$var$_hoisted_2$f)), [
                [
                    (0, $eeJ70.vModelDynamic),
                    _ctx.computedInputValue
                ]
            ]) : (0, $TusQn.createCommentVNode)("v-if", true)
        ], 512),
        _ctx.separateInput ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_3$a, [
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)({
                ref: "input",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>_ctx.computedInputValue = $event),
                class: "cdx-chip-input__input",
                disabled: _ctx.computedDisabled
            }, _ctx.otherAttrs, {
                onBlur: _cache[5] || (_cache[5] = (...args)=>_ctx.onInputBlur && _ctx.onInputBlur(...args)),
                onFocus: _cache[6] || (_cache[6] = (...args)=>_ctx.onInputFocus && _ctx.onInputFocus(...args)),
                onKeydown: _cache[7] || (_cache[7] = (...args)=>_ctx.onInputKeydown && _ctx.onInputKeydown(...args))
            }), null, 16, $db68d79c4ce005fe$var$_hoisted_4$6), [
                [
                    (0, $eeJ70.vModelDynamic),
                    _ctx.computedInputValue
                ]
            ])
        ], 512)) : (0, $TusQn.createCommentVNode)("v-if", true),
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_5$6, (0, $8XWQX.toDisplayString)(_ctx.statusMessageContent), 1)
    ], 38);
}
const $db68d79c4ce005fe$export$942cd80f467f680f = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$p, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$p
    ]
]);
function $db68d79c4ce005fe$var$regExpEscape(value) {
    return value.replace(/([\\{}()|.?*+\-^$[\]])/g, "\\$1");
}
const $db68d79c4ce005fe$var$COMBINING_MARK = "[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]";
function $db68d79c4ce005fe$var$splitStringAtMatch(query, title) {
    if (!query) return [
        title,
        "",
        ""
    ];
    const sanitizedQuery = $db68d79c4ce005fe$var$regExpEscape(query);
    const match = new RegExp(// Per https://www.regular-expressions.info/unicode.html, "any code point that is not a
    // combining mark can be followed by any number of combining marks." See also the
    // discussion in https://phabricator.wikimedia.org/T35242.
    sanitizedQuery + $db68d79c4ce005fe$var$COMBINING_MARK + "*", "i").exec(title);
    if (!match || match.index === void 0) return [
        title,
        "",
        ""
    ];
    const matchStartIndex = match.index;
    const matchEndIndex = matchStartIndex + match[0].length;
    const highlightedTitle = title.slice(matchStartIndex, matchEndIndex);
    const beforeHighlight = title.slice(0, matchStartIndex);
    const afterHighlight = title.slice(matchEndIndex, title.length);
    return [
        beforeHighlight,
        highlightedTitle,
        afterHighlight
    ];
}
const $db68d79c4ce005fe$export$8b1d1907b037443c = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    regExpEscape: $db68d79c4ce005fe$var$regExpEscape,
    splitStringAtMatch: $db68d79c4ce005fe$var$splitStringAtMatch
}, Symbol.toStringTag, {
    value: "Module"
}));
const $db68d79c4ce005fe$var$_sfc_main$o = (0, $TusQn.defineComponent)({
    name: "CdxSearchResultTitle",
    props: {
        /**
     * Title text.
     */ title: {
            type: String,
            required: true
        },
        /**
     * The current search query.
     */ searchQuery: {
            type: String,
            default: ""
        }
    },
    setup: (props)=>{
        const titleChunks = (0, $TusQn.computed)(()=>$db68d79c4ce005fe$var$splitStringAtMatch(props.searchQuery, String(props.title)));
        return {
            titleChunks: titleChunks
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$m = {
    class: "cdx-search-result-title"
};
const $db68d79c4ce005fe$var$_hoisted_2$e = {
    class: "cdx-search-result-title__match"
};
function $db68d79c4ce005fe$var$_sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_1$m, [
        (0, $TusQn.createElementVNode)("bdi", null, [
            (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.titleChunks[0]), 1),
            (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2$e, (0, $8XWQX.toDisplayString)(_ctx.titleChunks[1]), 1),
            (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.titleChunks[2]), 1)
        ])
    ]);
}
const $db68d79c4ce005fe$export$87f2877f2a5e5480 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$o, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$o
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$n = (0, $TusQn.defineComponent)({
    name: "CdxMenuItem",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxThumbnail: $db68d79c4ce005fe$export$9fe12e22779707e,
        CdxSearchResultTitle: $db68d79c4ce005fe$export$87f2877f2a5e5480
    },
    props: {
        /**
     * ID for HTML `id` attribute.
     */ id: {
            type: String,
            required: true
        },
        /**
     * The value provided to the parent menu component when this menu item is selected.
     */ value: {
            type: [
                String,
                Number
            ],
            required: true
        },
        /**
     * Whether the menu item is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Whether this menu item is selected.
     */ selected: {
            type: Boolean,
            default: false
        },
        /**
     * Whether this menu item is being pressed.
     */ active: {
            type: Boolean,
            default: false
        },
        /**
     * Whether this menu item is visually highlighted due to hover or keyboard navigation.
     */ highlighted: {
            type: Boolean,
            default: false
        },
        /**
     * Label for the menu item. If this isn't provided, the value will be displayed instead.
     */ label: {
            type: String,
            default: ""
        },
        /**
     * Text that matches current search query. Only used for search results and will be
     * displayed after the label.
     */ match: {
            type: String,
            default: ""
        },
        /**
     * Text that supports the label. Supporting text will appear next to the label in a more
     * subtle color.
     */ supportingText: {
            type: String,
            default: ""
        },
        /**
     * URL for the menu item. If provided, the content of the menu item will be wrapped in an
     * anchor tag.
     */ url: {
            type: String,
            default: ""
        },
        /**
     * Icon for the menu item.
     */ icon: {
            type: [
                String,
                Object
            ],
            default: ""
        },
        /**
     * Whether a thumbnail (or a placeholder icon) should be displayed.
     */ showThumbnail: {
            type: Boolean,
            default: false
        },
        /**
     * Thumbnail for the menu item.
     */ thumbnail: {
            type: [
                Object,
                null
            ],
            default: null
        },
        /**
     * Description of the menu item.
     */ description: {
            type: [
                String,
                null
            ],
            default: ""
        },
        /**
     * The search query to be highlighted within the menu item's title.
     */ searchQuery: {
            type: String,
            default: ""
        },
        /**
     * Whether to bold menu item labels.
     */ boldLabel: {
            type: Boolean,
            default: false
        },
        /**
     * Whether to hide description text overflow via an ellipsis.
     */ hideDescriptionOverflow: {
            type: Boolean,
            default: false
        },
        /**
     * Optional language codes for label, match, supporting text, and description.
     *
     * If included, that language code will be added as a `lang` attribute to the element
     * wrapping that text node.
     * @default {}
     */ language: {
            type: Object,
            default: ()=>{
                return {};
            }
        },
        /**
     * MenuItems inside a MenuButton can also support an "action" prop
     */ action: {
            type: String,
            default: "default"
        },
        /**
     * Whether this menu is in multiselect mode.
     */ multiselect: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * Emitted when the menu item becomes selected, active or highlighted in response to
     * user interaction. Handled in the Menu component.
     *
     * @property {MenuState} menuState State to change
     * @property {boolean} setState Whether to set that state to this menu item
     */ "change"
    ],
    setup: (props, { emit: emit })=>{
        const onMouseMove = ()=>{
            if (!props.highlighted) emit("change", "highlighted", true);
        };
        const onMouseLeave = ()=>{
            emit("change", "highlighted", false);
        };
        const onMouseDown = (e)=>{
            if (e.button === 0) emit("change", "active", true);
        };
        const onClick = ()=>{
            emit("change", "selected", true);
        };
        const highlightQuery = (0, $TusQn.computed)(()=>props.searchQuery.length > 0);
        const rootClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-menu-item--selected": props.selected,
                // Only show the active visual state when the menu item is both active and
                // highlighted. This means, on mousedown -> mouseleave, the menu item is still
                // technically tracked by the menu as active, but will not appear active to the
                // user. This also means in the case of mousedown -> mouseleave -> mouseenter, the
                // menu item will appear active again, and on click (releasing the mouse button),
                // the item will be selected.
                "cdx-menu-item--active": props.active && props.highlighted,
                "cdx-menu-item--highlighted": props.highlighted,
                "cdx-menu-item--destructive": props.action && props.action === "destructive",
                "cdx-menu-item--enabled": !props.disabled,
                "cdx-menu-item--disabled": props.disabled,
                "cdx-menu-item--highlight-query": highlightQuery.value,
                "cdx-menu-item--bold-label": props.boldLabel,
                "cdx-menu-item--has-description": !!props.description,
                "cdx-menu-item--hide-description-overflow": props.hideDescriptionOverflow
            };
        });
        const contentTag = (0, $TusQn.computed)(()=>props.url ? "a" : "span");
        const title = (0, $TusQn.computed)(()=>props.label || String(props.value));
        return {
            onMouseMove: onMouseMove,
            onMouseLeave: onMouseLeave,
            onMouseDown: onMouseDown,
            onClick: onClick,
            highlightQuery: highlightQuery,
            rootClasses: rootClasses,
            contentTag: contentTag,
            title: title,
            cdxIconCheck: $db68d79c4ce005fe$var$K3
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$l = [
    "id",
    "aria-disabled",
    "aria-selected",
    "aria-checked"
];
const $db68d79c4ce005fe$var$_hoisted_2$d = {
    class: "cdx-menu-item__text"
};
const $db68d79c4ce005fe$var$_hoisted_3$9 = [
    "lang"
];
const $db68d79c4ce005fe$var$_hoisted_4$5 = [
    "lang"
];
const $db68d79c4ce005fe$var$_hoisted_5$5 = [
    "lang"
];
const $db68d79c4ce005fe$var$_hoisted_6$5 = [
    "lang"
];
function $db68d79c4ce005fe$var$_sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_thumbnail = (0, $TusQn.resolveComponent)("cdx-thumbnail");
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_search_result_title = (0, $TusQn.resolveComponent)("cdx-search-result-title");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", {
        id: _ctx.id,
        role: "option",
        class: (0, $8XWQX.normalizeClass)([
            "cdx-menu-item",
            _ctx.rootClasses
        ]),
        "aria-disabled": _ctx.disabled,
        "aria-selected": _ctx.selected && !_ctx.multiselect ? true : void 0,
        "aria-checked": _ctx.selected && _ctx.multiselect ? true : void 0,
        onMousemove: _cache[0] || (_cache[0] = (...args)=>_ctx.onMouseMove && _ctx.onMouseMove(...args)),
        onMouseleave: _cache[1] || (_cache[1] = (...args)=>_ctx.onMouseLeave && _ctx.onMouseLeave(...args)),
        onMousedown: _cache[2] || (_cache[2] = (0, $eeJ70.withModifiers)((...args)=>_ctx.onMouseDown && _ctx.onMouseDown(...args), [
            "prevent"
        ])),
        onClick: _cache[3] || (_cache[3] = (...args)=>_ctx.onClick && _ctx.onClick(...args))
    }, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(_ctx.contentTag), {
                    href: _ctx.url ? _ctx.url : void 0,
                    class: "cdx-menu-item__content"
                }, {
                    default: (0, $TusQn.withCtx)(()=>{
                        var _a, _b, _c, _d, _e, _f;
                        return [
                            _ctx.showThumbnail ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_thumbnail, {
                                key: 0,
                                thumbnail: _ctx.thumbnail,
                                class: "cdx-menu-item__thumbnail"
                            }, null, 8, [
                                "thumbnail"
                            ])) : _ctx.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                                key: 1,
                                icon: _ctx.icon,
                                class: "cdx-menu-item__icon"
                            }, null, 8, [
                                "icon"
                            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                            (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2$d, [
                                _ctx.highlightQuery ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_search_result_title, {
                                    key: 0,
                                    title: _ctx.title,
                                    "search-query": _ctx.searchQuery,
                                    lang: (_a = _ctx.language) == null ? void 0 : _a.label
                                }, null, 8, [
                                    "title",
                                    "search-query",
                                    "lang"
                                ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                    key: 1,
                                    class: "cdx-menu-item__text__label",
                                    lang: (_b = _ctx.language) == null ? void 0 : _b.label
                                }, [
                                    (0, $TusQn.createElementVNode)("bdi", null, (0, $8XWQX.toDisplayString)(_ctx.title), 1)
                                ], 8, $db68d79c4ce005fe$var$_hoisted_3$9)),
                                _ctx.match ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 2
                                }, [
                                    (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(" ") + " "),
                                    _ctx.highlightQuery ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_search_result_title, {
                                        key: 0,
                                        title: _ctx.match,
                                        "search-query": _ctx.searchQuery,
                                        lang: (_c = _ctx.language) == null ? void 0 : _c.match
                                    }, null, 8, [
                                        "title",
                                        "search-query",
                                        "lang"
                                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                        key: 1,
                                        class: "cdx-menu-item__text__match",
                                        lang: (_d = _ctx.language) == null ? void 0 : _d.match
                                    }, [
                                        (0, $TusQn.createElementVNode)("bdi", null, (0, $8XWQX.toDisplayString)(_ctx.match), 1)
                                    ], 8, $db68d79c4ce005fe$var$_hoisted_4$5))
                                ], 64)) : (0, $TusQn.createCommentVNode)("v-if", true),
                                _ctx.supportingText ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                    key: 3
                                }, [
                                    (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(" ") + " "),
                                    (0, $TusQn.createElementVNode)("span", {
                                        class: "cdx-menu-item__text__supporting-text",
                                        lang: (_e = _ctx.language) == null ? void 0 : _e.supportingText
                                    }, [
                                        (0, $TusQn.createElementVNode)("bdi", null, (0, $8XWQX.toDisplayString)(_ctx.supportingText), 1)
                                    ], 8, $db68d79c4ce005fe$var$_hoisted_5$5)
                                ], 64)) : (0, $TusQn.createCommentVNode)("v-if", true),
                                _ctx.description ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                                    key: 4,
                                    class: "cdx-menu-item__text__description",
                                    lang: (_f = _ctx.language) == null ? void 0 : _f.description
                                }, [
                                    (0, $TusQn.createElementVNode)("bdi", null, (0, $8XWQX.toDisplayString)(_ctx.description), 1)
                                ], 8, $db68d79c4ce005fe$var$_hoisted_6$5)) : (0, $TusQn.createCommentVNode)("v-if", true)
                            ]),
                            _ctx.multiselect && _ctx.selected ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                                key: 2,
                                icon: _ctx.cdxIconCheck,
                                size: "small",
                                class: "cdx-menu-item__selected-icon"
                            }, null, 8, [
                                "icon"
                            ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                        ];
                    }),
                    _: 1
                }, 8, [
                    "href"
                ]))
            ])
    ], 42, $db68d79c4ce005fe$var$_hoisted_1$l);
}
const $db68d79c4ce005fe$export$546b4271d17a9cd5 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$n, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$n
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$m = (0, $TusQn.defineComponent)({
    name: "CdxProgressBar",
    props: {
        /**
     * Whether this is the smaller, inline variant.
     */ inline: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the progress bar is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    setup (props, { attrs: attrs }) {
        $db68d79c4ce005fe$export$3f97d07ad730ccf0(()=>!props.inline && !attrs["aria-label"] && !attrs["aria-hidden"], "CdxProgressBar: Progress bars require one of the following attribute, aria-label or aria-hidden. See documentation on https://doc.wikimedia.org/codex/latest/components/demos/progressbar.html");
        const rootClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-progress-bar--block": !props.inline,
                "cdx-progress-bar--inline": props.inline,
                "cdx-progress-bar--enabled": !props.disabled,
                "cdx-progress-bar--disabled": props.disabled
            };
        });
        const computedAriaHidden = (0, $TusQn.computed)(()=>{
            return props.inline ? "true" : void 0;
        });
        return {
            rootClasses: rootClasses,
            computedAriaHidden: computedAriaHidden
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$k = [
    "aria-hidden",
    "aria-disabled"
];
const $db68d79c4ce005fe$var$_hoisted_2$c = /* @__PURE__ */ (0, $TusQn.createElementVNode)("div", {
    class: "cdx-progress-bar__bar"
}, null, -1);
const $db68d79c4ce005fe$var$_hoisted_3$8 = [
    $db68d79c4ce005fe$var$_hoisted_2$c
];
function $db68d79c4ce005fe$var$_sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-progress-bar",
            _ctx.rootClasses
        ]),
        role: "progressbar",
        "aria-hidden": _ctx.computedAriaHidden,
        "aria-disabled": _ctx.disabled
    }, $db68d79c4ce005fe$var$_hoisted_3$8, 10, $db68d79c4ce005fe$var$_hoisted_1$k);
}
const $db68d79c4ce005fe$export$f9f679f84bac7c0c = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$m, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$m
    ]
]);
function $db68d79c4ce005fe$export$a7395f9832c00176(templateRef, observerOptions) {
    const intersectionRef = (0, $01W3b.ref)(false);
    let mounted = false;
    if (typeof window !== "object") return intersectionRef;
    if (!("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype)) return intersectionRef;
    const observer = new window.IntersectionObserver((entries)=>{
        const entry = entries[0];
        if (entry) intersectionRef.value = entry.isIntersecting;
    }, observerOptions);
    (0, $TusQn.onMounted)(()=>{
        mounted = true;
        if (templateRef.value) observer.observe(templateRef.value);
    });
    (0, $TusQn.onUnmounted)(()=>{
        mounted = false;
        observer.disconnect();
    });
    (0, $TusQn.watch)(templateRef, (newElement)=>{
        if (!mounted) return;
        observer.disconnect();
        intersectionRef.value = false;
        if (newElement) observer.observe(newElement);
    });
    return intersectionRef;
}
function $db68d79c4ce005fe$var$selectedIsArray(selected) {
    return selected !== null && Array.isArray(selected);
}
const $db68d79c4ce005fe$var$_sfc_main$l = (0, $TusQn.defineComponent)({
    name: "CdxMenu",
    components: {
        CdxMenuItem: $db68d79c4ce005fe$export$546b4271d17a9cd5,
        CdxProgressBar: $db68d79c4ce005fe$export$f9f679f84bac7c0c
    },
    /**
   * Attributes, besides class and style, will be passed to the <ul> element.
   */ inheritAttrs: false,
    props: {
        /** Menu items. See the MenuItemData type. */ menuItems: {
            type: Array,
            required: true
        },
        /**
     * Interactive footer item.
     *
     * This is a special menu item which is pinned to the bottom of the menu. When scrolling is
     * enabled within the menu, the footer item will always be visible at the bottom of the
     * menu. When scrolling is not enabled, the footer item will simply appear as the last menu
     * item.
     *
     * The footer item is selectable, like other menu items.
     */ footer: {
            type: Object,
            default: null
        },
        /**
     * Value(s) of the selected menu item(s). A single value for single-select, or an array of
     * values for multi-select.
     *
     * Must be bound with `v-model:selected`.
     *
     * The property should be initialized to `null` (for single-select) or an empty array (for
     * multi-select) rather than using a falsy value.
     */ selected: {
            // eslint-disable-next-line max-len
            type: [
                String,
                Number,
                Array,
                null
            ],
            required: true
        },
        /**
     * Whether the menu is expanded. Must be bound with `v-model:expanded`.
     */ expanded: {
            type: Boolean,
            required: true
        },
        /**
     * Whether to display pending state indicators. Meant to indicate that new menu items are
     * being fetched or computed.
     *
     * When true, the menu will expand if not already expanded, and an inline progress bar will
     * display. If there are no menu items yet, a message can be displayed in the `pending`
     * slot, e.g. "Loading results".
     */ showPending: {
            type: Boolean,
            default: false
        },
        /**
     * Limit the number of menu items to display before scrolling.
     *
     * Setting this prop to anything falsy will show all menu items.
     *
     * By default, all menu items are shown.
     */ visibleItemLimit: {
            type: Number,
            default: null
        },
        /**
     * Whether menu item thumbnails (or a placeholder icon) should be displayed.
     */ showThumbnail: {
            type: Boolean,
            default: false
        },
        /**
     * Whether to bold menu item labels.
     */ boldLabel: {
            type: Boolean,
            default: false
        },
        /**
     * Whether to hide description text overflow via an ellipsis.
     */ hideDescriptionOverflow: {
            type: Boolean,
            default: false
        },
        /**
     * The search query to be highlighted within the menu items' titles.
     */ searchQuery: {
            type: String,
            default: ""
        },
        /**
     * Whether to show the `no-results` slot content.
     *
     * The Menu component automatically shows this slot when there is content in the
     * `no-results` slot and there are zero menu items. However, some components may need to
     * customize this behavior, e.g. to show the slot even when there is at least one menu item.
     * This prop can be used to override the default Menu behavior.
     *
     * Possible values:
     * `null` (default): the `no-results` slot will display only if there are zero menu items.
     * `true`: the `no-results` slot will display, regardless of number of menu items.
     * `false`: the `no-results` slot will not display, regardless of number of menu items.
     */ showNoResultsSlot: {
            type: Boolean,
            default: null
        }
    },
    emits: [
        // Don't remove the spaces in the "string | number | null" type below; removing these
        // spaces causes the documentation to render the type as "union" instead.
        // Keep property descriptions on a single line or they will get cut off.
        /**
     * When the selected menu item changes.
     *
     * Property will be a single value or `null` in single-select mode, or an array of values or
     * an empty array in multiselect mode.
     *
     * @property {MenuItemValue | MenuItemValue[] | null} selectedValue selected value or values
     */ "update:selected",
        /**
     * When the menu opens or closes.
     *
     * @property {boolean} newValue The new expanded state (true for open, false for closed)
     */ "update:expanded",
        /**
     * When a menu item is clicked.
     *
     * Typically, components with menus will respond to the selected value change, but
     * occasionally, a component might want to react specifically when a menu item is clicked.
     *
     * @property {MenuItemDataWithId} menuItem The menu item that was clicked
     */ "menu-item-click",
        /**
     * When a menu item is highlighted via keyboard navigation.
     *
     * @property {MenuItemDataWithId} highlightedMenuItem The menu item
     * was highlighted
     */ "menu-item-keyboard-navigation",
        /**
     * When the user scrolls towards the bottom of the menu.
     *
     * If it is possible to add or load more menu items, then now would be a good moment
     * so that the user can experience infinite scrolling.
     */ "load-more"
    ],
    expose: [
        "isExpanded",
        "clearActive",
        "getHighlightedMenuItem",
        "getHighlightedViaKeyboard",
        "delegateKeyNavigation"
    ],
    setup (props, { emit: emit, slots: slots, attrs: attrs }) {
        const computedMenuItems = (0, $TusQn.computed)(()=>{
            const menuItemsWithFooter = props.footer && props.menuItems ? [
                ...props.menuItems,
                props.footer
            ] : props.menuItems;
            return menuItemsWithFooter.map((menuItem)=>$db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, menuItem), {
                    id: $db68d79c4ce005fe$export$6217842283d27b52("menu-item")
                }));
        });
        const computedShowNoResultsSlot = (0, $TusQn.computed)(()=>{
            if (!slots["no-results"]) return false;
            if (props.showNoResultsSlot !== null) return props.showNoResultsSlot;
            return computedMenuItems.value.length === 0;
        });
        const highlightedMenuItem = (0, $01W3b.ref)(null);
        const highlightedViaKeyboard = (0, $01W3b.ref)(false);
        const activeMenuItem = (0, $01W3b.ref)(null);
        const ariaRelevant = "additions removals";
        let keyBuffer = "";
        let keyBufferTimeout = null;
        function clearKeyBuffer() {
            keyBuffer = "";
            if (keyBufferTimeout !== null) {
                clearTimeout(keyBufferTimeout);
                keyBufferTimeout = null;
            }
        }
        function resetKeyBufferTimeout() {
            if (keyBufferTimeout !== null) clearTimeout(keyBufferTimeout);
            keyBufferTimeout = setTimeout(clearKeyBuffer, 1500);
        }
        function findFirstSelectedMenuItem() {
            var _a;
            return (_a = computedMenuItems.value.find((menuItem)=>$db68d79c4ce005fe$var$selectedIsArray(props.selected) ? props.selected.indexOf(menuItem.value) !== -1 : menuItem.value === props.selected)) != null ? _a : null;
        }
        const isMultiselect = (0, $TusQn.computed)(()=>$db68d79c4ce005fe$var$selectedIsArray(props.selected));
        function isItemSelected(value) {
            return $db68d79c4ce005fe$var$selectedIsArray(props.selected) ? props.selected.indexOf(value) !== -1 : value === props.selected;
        }
        function updateSelected(value) {
            if ($db68d79c4ce005fe$var$selectedIsArray(props.selected)) {
                const newSelected = props.selected.indexOf(value) === -1 ? props.selected.concat(value) : props.selected.filter((item)=>item !== value);
                emit("update:selected", newSelected);
            } else emit("update:selected", value);
        }
        function handleMenuItemChange(menuState, menuItem) {
            if (menuItem && menuItem.disabled) return;
            switch(menuState){
                case "selected":
                    if (menuItem) updateSelected(menuItem.value);
                    if (!isMultiselect.value) emit("update:expanded", false);
                    activeMenuItem.value = null;
                    break;
                case "highlighted":
                    highlightedMenuItem.value = menuItem != null ? menuItem : null;
                    highlightedViaKeyboard.value = false;
                    break;
                case "highlightedViaKeyboard":
                    highlightedMenuItem.value = menuItem != null ? menuItem : null;
                    highlightedViaKeyboard.value = true;
                    break;
                case "active":
                    activeMenuItem.value = menuItem != null ? menuItem : null;
                    break;
            }
        }
        const highlightedMenuItemIndex = (0, $TusQn.computed)(()=>{
            if (highlightedMenuItem.value === null) return;
            return computedMenuItems.value.findIndex((menuItem)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                menuItem.value === highlightedMenuItem.value.value);
        });
        function handleHighlightViaKeyboard(newHighlightedMenuItem) {
            if (!newHighlightedMenuItem) return;
            handleMenuItemChange("highlightedViaKeyboard", newHighlightedMenuItem);
            emit("menu-item-keyboard-navigation", newHighlightedMenuItem);
        }
        function highlightPrev(highlightedIndex) {
            var _a;
            const findPrevEnabled = (startIndex)=>{
                for(let index = startIndex - 1; index >= 0; index--){
                    if (!computedMenuItems.value[index].disabled) return computedMenuItems.value[index];
                }
            };
            highlightedIndex = highlightedIndex != null ? highlightedIndex : computedMenuItems.value.length;
            const prev = (_a = findPrevEnabled(highlightedIndex)) != null ? _a : findPrevEnabled(computedMenuItems.value.length);
            handleHighlightViaKeyboard(prev);
        }
        function highlightNext(highlightedIndex) {
            var _a;
            const findNextEnabled = (startIndex)=>computedMenuItems.value.find((item, index)=>!item.disabled && index > startIndex);
            highlightedIndex = highlightedIndex != null ? highlightedIndex : -1;
            const next = (_a = findNextEnabled(highlightedIndex)) != null ? _a : findNextEnabled(-1);
            handleHighlightViaKeyboard(next);
        }
        function handleCharacterNavigation(e) {
            if (e.key === "Clear") {
                clearKeyBuffer();
                return true;
            }
            if (e.key === "Backspace") {
                keyBuffer = keyBuffer.slice(0, -1);
                resetKeyBufferTimeout();
                return true;
            }
            if (e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey) {
                if (!props.expanded) emit("update:expanded", true);
                if (e.key === " " && keyBuffer.length < 1) return false;
                keyBuffer += e.key.toLowerCase();
                const isRepeatedCharacter = keyBuffer.length > 1 && keyBuffer.split("").every((char)=>char === keyBuffer[0]);
                let itemsToMatch = computedMenuItems.value;
                let stringToMatch = keyBuffer;
                if (isRepeatedCharacter && highlightedMenuItemIndex.value !== void 0) {
                    itemsToMatch = itemsToMatch.slice(highlightedMenuItemIndex.value + 1).concat(itemsToMatch.slice(0, highlightedMenuItemIndex.value));
                    stringToMatch = keyBuffer[0];
                }
                const matchingItem = itemsToMatch.find((item)=>{
                    var _a;
                    return !item.disabled && String((_a = item.label) != null ? _a : item.value).toLowerCase().startsWith(stringToMatch);
                });
                if (matchingItem) {
                    handleMenuItemChange("highlightedViaKeyboard", matchingItem);
                    maybeScrollIntoView();
                }
                resetKeyBufferTimeout();
                return true;
            }
            return false;
        }
        function handleKeyNavigation(e, { prevent: prevent = true, characterNavigation: characterNavigation = false } = {}) {
            if (characterNavigation) {
                if (handleCharacterNavigation(e)) {
                    e.preventDefault();
                    return true;
                }
                clearKeyBuffer();
            }
            function maybePrevent() {
                if (prevent) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
            switch(e.key){
                case "Enter":
                case " ":
                    maybePrevent();
                    if (props.expanded) {
                        if (highlightedMenuItem.value && highlightedViaKeyboard.value) updateSelected(highlightedMenuItem.value.value);
                        if (!isMultiselect.value) emit("update:expanded", false);
                    } else emit("update:expanded", true);
                    return true;
                case "Tab":
                    if (props.expanded) {
                        if (highlightedMenuItem.value && highlightedViaKeyboard.value && !isMultiselect.value) {
                            updateSelected(highlightedMenuItem.value.value);
                            emit("update:expanded", false);
                        }
                    }
                    return true;
                case "ArrowUp":
                    maybePrevent();
                    if (props.expanded) {
                        if (highlightedMenuItem.value === null) handleMenuItemChange("highlightedViaKeyboard", findFirstSelectedMenuItem());
                        highlightPrev(highlightedMenuItemIndex.value);
                    } else emit("update:expanded", true);
                    maybeScrollIntoView();
                    return true;
                case "ArrowDown":
                    maybePrevent();
                    if (props.expanded) {
                        if (highlightedMenuItem.value === null) handleMenuItemChange("highlightedViaKeyboard", findFirstSelectedMenuItem());
                        highlightNext(highlightedMenuItemIndex.value);
                    } else emit("update:expanded", true);
                    maybeScrollIntoView();
                    return true;
                case "Home":
                    maybePrevent();
                    if (props.expanded) {
                        if (highlightedMenuItem.value === null) handleMenuItemChange("highlightedViaKeyboard", findFirstSelectedMenuItem());
                        highlightNext();
                    } else emit("update:expanded", true);
                    maybeScrollIntoView();
                    return true;
                case "End":
                    maybePrevent();
                    if (props.expanded) {
                        if (highlightedMenuItem.value === null) handleMenuItemChange("highlightedViaKeyboard", findFirstSelectedMenuItem());
                        highlightPrev();
                    } else emit("update:expanded", true);
                    maybeScrollIntoView();
                    return true;
                case "Escape":
                    maybePrevent();
                    emit("update:expanded", false);
                    return true;
                default:
                    return false;
            }
        }
        function onMouseUp() {
            handleMenuItemChange("active", null);
        }
        const menuItemElements = [];
        const loadMoreTriggerElement = (0, $01W3b.ref)(void 0);
        const isTriggerVisible = $db68d79c4ce005fe$export$a7395f9832c00176(loadMoreTriggerElement, {
            threshold: 0.8
        });
        (0, $TusQn.watch)(isTriggerVisible, (value)=>{
            if (value) emit("load-more");
        });
        function assignTemplateRef(templateRef, index) {
            if (templateRef) {
                menuItemElements[index] = templateRef.$el;
                const visibleItemLimit = props.visibleItemLimit;
                if (!visibleItemLimit || props.menuItems.length < visibleItemLimit) return;
                const loadMoreThreshold = Math.min(visibleItemLimit, Math.max(2, Math.floor(0.2 * props.menuItems.length)));
                if (index === props.menuItems.length - loadMoreThreshold) loadMoreTriggerElement.value = templateRef.$el;
            }
        }
        const menuListbox = (0, $01W3b.ref)();
        function maybeScrollIntoView() {
            const isListboxScrollable = menuListbox.value && menuListbox.value.scrollHeight > menuListbox.value.clientHeight;
            if (highlightedMenuItemIndex.value === void 0 || !isListboxScrollable) return;
            const scrollIndex = highlightedMenuItemIndex.value >= 0 ? highlightedMenuItemIndex.value : 0;
            menuItemElements[scrollIndex].scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
        }
        const maxMenuHeight = (0, $01W3b.ref)(null);
        const footerHeight = (0, $01W3b.ref)(null);
        function resizeMenu() {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                yield (0, $TusQn.nextTick)();
                updateFooterHeight();
                updateMaxMenuHeight();
                yield (0, $TusQn.nextTick)();
                maybeScrollIntoView();
            });
        }
        function updateFooterHeight() {
            if (props.footer) {
                const footerElement = menuItemElements[menuItemElements.length - 1];
                footerHeight.value = footerElement.scrollHeight;
            } else footerHeight.value = null;
        }
        function updateMaxMenuHeight() {
            if (!props.visibleItemLimit || menuItemElements.length <= props.visibleItemLimit) {
                maxMenuHeight.value = null;
                return;
            }
            const firstMenuItemTop = menuItemElements[0].getBoundingClientRect().top;
            const firstHiddenMenuItemTop = menuItemElements[props.visibleItemLimit].getBoundingClientRect().top;
            maxMenuHeight.value = firstHiddenMenuItemTop - firstMenuItemTop + 2;
        }
        (0, $TusQn.onMounted)(()=>{
            document.addEventListener("mouseup", onMouseUp);
        });
        (0, $TusQn.onUnmounted)(()=>{
            document.removeEventListener("mouseup", onMouseUp);
        });
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "expanded"), (newVal)=>$db68d79c4ce005fe$var$__async(this, null, function*() {
                if (newVal) {
                    const selectedMenuItem = findFirstSelectedMenuItem();
                    if (selectedMenuItem && !highlightedMenuItem.value) handleMenuItemChange("highlighted", selectedMenuItem);
                    yield resizeMenu();
                } else handleMenuItemChange("highlighted", null);
            }));
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "menuItems"), (newPropMenuItems)=>$db68d79c4ce005fe$var$__async(this, null, function*() {
                if (newPropMenuItems.length < menuItemElements.length) menuItemElements.length = newPropMenuItems.length;
                if (props.expanded) yield resizeMenu();
            }), {
            deep: true
        });
        const listBoxStyle = (0, $TusQn.computed)(()=>{
            return {
                "max-height": maxMenuHeight.value ? "".concat(maxMenuHeight.value, "px") : void 0,
                "margin-bottom": footerHeight.value ? "".concat(footerHeight.value, "px") : void 0
            };
        });
        const internalClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-menu--has-footer": !!props.footer
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        return {
            listBoxStyle: listBoxStyle,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            assignTemplateRef: assignTemplateRef,
            computedMenuItems: computedMenuItems,
            computedShowNoResultsSlot: computedShowNoResultsSlot,
            highlightedMenuItem: highlightedMenuItem,
            highlightedViaKeyboard: highlightedViaKeyboard,
            activeMenuItem: activeMenuItem,
            handleMenuItemChange: handleMenuItemChange,
            handleKeyNavigation: handleKeyNavigation,
            ariaRelevant: ariaRelevant,
            isMultiselect: isMultiselect,
            isItemSelected: isItemSelected,
            menuListbox: menuListbox
        };
    },
    // Public methods
    // These must be in the methods block, not in the setup function, otherwise their documentation
    // won't be picked up by vue-docgen
    methods: {
        /**
     * Returns whether the menu is expanded.
     *
     * @return {boolean}
     */ isExpanded () {
            return this.expanded;
        },
        /**
     * Get the highlighted menu item, if any.
     *
     * The parent component should set `aria-activedescendant` to the `.id` property of the
     * object returned by this method. If this method returns null, `aria-activedescendant`
     * should not be set.
     *
     * @public
     * @return {MenuItemDataWithId|null} The highlighted menu item,
     *   or null if no item is highlighted or if the menu is closed.
     */ getHighlightedMenuItem () {
            return this.expanded ? this.highlightedMenuItem : null;
        },
        /**
     * Get whether the last highlighted item was highlighted via the keyboard.
     *
     * @public
     * @return {boolean} Whether the last highlighted menu item was highlighted via keyboard.
     */ getHighlightedViaKeyboard () {
            return this.highlightedViaKeyboard;
        },
        /**
     * Ensure no menu item is active. This unsets the active item if there is one.
     *
     * @public
     */ clearActive () {
            this.handleMenuItemChange("active", null);
        },
        /**
     * Handles all necessary keyboard navigation.
     *
     * The parent component should listen for keydown events on its focusable element,
     * and pass those events to this method. Events for arrow keys, tab and enter are handled
     * by this method. If a different key was pressed, this method will return false to indicate
     * that it didn't handle the event.
     *
     * @public
     * @param event {KeyboardEvent} Keydown event object
     * @param options
     * @param options.prevent {boolean} If false, do not call e.preventDefault() or
     *   e.stopPropagation()
     * @param options.characterNavigation {boolean}
     * @return Whether the event was handled
     */ delegateKeyNavigation (event, { prevent: prevent = true, characterNavigation: characterNavigation = false } = {}) {
            return this.handleKeyNavigation(event, {
                prevent: prevent,
                characterNavigation: characterNavigation
            });
        }
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$j = [
    "aria-live",
    "aria-relevant",
    "aria-multiselectable"
];
const $db68d79c4ce005fe$var$_hoisted_2$b = {
    key: 0,
    class: "cdx-menu__pending cdx-menu-item"
};
const $db68d79c4ce005fe$var$_hoisted_3$7 = {
    key: 1,
    class: "cdx-menu__no-results cdx-menu-item",
    role: "option"
};
function $db68d79c4ce005fe$var$_sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_menu_item = (0, $TusQn.resolveComponent)("cdx-menu-item");
    const _component_cdx_progress_bar = (0, $TusQn.resolveComponent)("cdx-progress-bar");
    return (0, $TusQn.withDirectives)(((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-menu",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createElementVNode)("ul", (0, $TusQn.mergeProps)({
            ref: "menuListbox",
            class: "cdx-menu__listbox",
            role: "listbox",
            style: _ctx.listBoxStyle,
            "aria-live": _ctx.showPending ? "polite" : void 0,
            "aria-relevant": _ctx.showPending ? _ctx.ariaRelevant : void 0,
            "aria-multiselectable": _ctx.isMultiselect ? true : void 0
        }, _ctx.otherAttrs), [
            _ctx.showPending && _ctx.computedMenuItems.length === 0 && _ctx.$slots.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $db68d79c4ce005fe$var$_hoisted_2$b, [
                (0, $TusQn.renderSlot)(_ctx.$slots, "pending")
            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
            _ctx.computedShowNoResultsSlot ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("li", $db68d79c4ce005fe$var$_hoisted_3$7, [
                (0, $TusQn.renderSlot)(_ctx.$slots, "no-results")
            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.computedMenuItems, (menuItem, index)=>{
                var _a, _b;
                return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_menu_item, (0, $TusQn.mergeProps)({
                    key: menuItem.value,
                    ref_for: true,
                    ref: (ref2)=>_ctx.assignTemplateRef(ref2, index)
                }, menuItem, {
                    selected: _ctx.isItemSelected(menuItem.value),
                    active: menuItem.value === ((_a = _ctx.activeMenuItem) == null ? void 0 : _a.value),
                    highlighted: menuItem.value === ((_b = _ctx.highlightedMenuItem) == null ? void 0 : _b.value),
                    "show-thumbnail": _ctx.showThumbnail,
                    "bold-label": _ctx.boldLabel,
                    "hide-description-overflow": _ctx.hideDescriptionOverflow,
                    "search-query": _ctx.searchQuery,
                    multiselect: _ctx.isMultiselect,
                    onChange: (menuState, setState)=>_ctx.handleMenuItemChange(menuState, setState ? menuItem : null),
                    onClick: ($event)=>_ctx.$emit("menu-item-click", menuItem)
                }), {
                    default: (0, $TusQn.withCtx)(()=>{
                        var _a2, _b2;
                        return [
                            (0, $TusQn.renderSlot)(_ctx.$slots, "default", {
                                menuItem: menuItem,
                                active: menuItem.value === ((_a2 = _ctx.activeMenuItem) == null ? void 0 : _a2.value) && menuItem.value === ((_b2 = _ctx.highlightedMenuItem) == null ? void 0 : _b2.value)
                            })
                        ];
                    }),
                    _: 2
                }, 1040, [
                    "selected",
                    "active",
                    "highlighted",
                    "show-thumbnail",
                    "bold-label",
                    "hide-description-overflow",
                    "search-query",
                    "multiselect",
                    "onChange",
                    "onClick"
                ]);
            }), 128)),
            _ctx.showPending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_progress_bar, {
                key: 2,
                class: "cdx-menu__progress-bar",
                inline: true
            })) : (0, $TusQn.createCommentVNode)("v-if", true)
        ], 16, $db68d79c4ce005fe$var$_hoisted_1$j)
    ], 6)), [
        [
            (0, $eeJ70.vShow),
            _ctx.expanded
        ]
    ]);
}
const $db68d79c4ce005fe$export$a33433a93a74f3ad = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$l, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$l
    ]
]);
const $db68d79c4ce005fe$var$textInputTypeValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$TextInputTypes);
const $db68d79c4ce005fe$var$statusValidator$8 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$k = (0, $TusQn.defineComponent)({
    name: "CdxTextInput",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    /**
   * We want the input to inherit attributes, not the root element.
   */ inheritAttrs: false,
    expose: [
        "focus",
        "blur"
    ],
    props: {
        /**
     * Current value of the input.
     *
     * Provided by `v-model` binding in the parent component.
     */ modelValue: {
            type: [
                String,
                Number
            ],
            default: ""
        },
        /**
     * `type` attribute of the input.
     *
     * @values 'text', 'search', 'number', 'email', 'password', 'tel', 'url',
     * 'week', 'month', 'date', 'datetime-local', 'time'
     */ inputType: {
            type: String,
            default: "text",
            validator: $db68d79c4ce005fe$var$textInputTypeValidator
        },
        /**
     * `status` attribute of the input.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$8
        },
        /**
     * Whether the input is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * An icon at the start of the input element. Similar to a `::before` pseudo-element.
     */ startIcon: {
            type: [
                String,
                Object
            ],
            default: void 0
        },
        /**
     * An icon at the end of the input element. Similar to an `::after` pseudo-element.
     */ endIcon: {
            type: [
                String,
                Object
            ],
            default: void 0
        },
        /**
     * Add a clear button at the end of the input element.
     *
     * When the clear button is pressed, the input's value is set to an empty string.
     * The clear button is displayed when input text is present.
     */ clearable: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * When the input value changes
     *
     * @property {string | number} modelValue The new model value
     */ "update:modelValue",
        /**
     * When the user presses a key.
     *
     * This event is not emitted when the user presses the Home or End key (T314728),
     * but is emitted for Ctrl/Cmd+Home and Ctrl/Cmd+End.
     *
     * @property {KeyboardEvent}
     */ "keydown",
        /**
     * When the input value changes via direct use of the input
     *
     * @property {InputEvent} event
     */ "input",
        /**
     * When an input value change is committed by the user (e.g. on blur)
     *
     * @property {Event} event
     */ "change",
        /**
     * When the input comes into focus
     *
     * @property {FocusEvent} event
     */ "focus",
        /**
     * When the input loses focus
     *
     * @property {FocusEvent} event
     */ "blur",
        /**
     * When the input value is cleared through the use of the clear button
     *
     * @property {MouseEvent} event
     */ "clear"
    ],
    setup (props, { emit: emit, attrs: attrs }) {
        const idAttribute = attrs.id;
        const { computedDisabled: computedDisabled, computedStatus: computedStatus, computedInputId: computedInputId } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"), idAttribute);
        const descriptionId = (0, $TusQn.inject)($db68d79c4ce005fe$var$FieldDescriptionIdKey, void 0);
        const wrappedModel = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "modelValue"), emit);
        const isClearable = (0, $TusQn.computed)(()=>{
            return props.clearable && !!wrappedModel.value && !computedDisabled.value;
        });
        const internalClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-text-input--has-start-icon": !!props.startIcon,
                "cdx-text-input--has-end-icon": !!props.endIcon,
                "cdx-text-input--clearable": isClearable.value,
                ["cdx-text-input--status-".concat(computedStatus.value)]: true
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        const otherAttrsMinusId = (0, $TusQn.computed)(()=>{
            const _a = otherAttrs.value, { id: id } = _a, everythingElse = $db68d79c4ce005fe$var$__objRest(_a, [
                "id"
            ]);
            return everythingElse;
        });
        const inputClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-text-input__input--has-value": !!wrappedModel.value
            };
        });
        const onClear = (event)=>{
            wrappedModel.value = "";
            emit("clear", event);
        };
        const onKeydown = (event)=>{
            if ((event.key === "Home" || event.key === "End") && !event.ctrlKey && !event.metaKey) return;
            emit("keydown", event);
        };
        const onInput = (event)=>{
            emit("input", event);
        };
        const onChange = (event)=>{
            emit("change", event);
        };
        const onFocus = (event)=>{
            emit("focus", event);
        };
        const onBlur = (event)=>{
            emit("blur", event);
        };
        return {
            computedInputId: computedInputId,
            descriptionId: descriptionId,
            wrappedModel: wrappedModel,
            isClearable: isClearable,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrsMinusId: otherAttrsMinusId,
            inputClasses: inputClasses,
            computedDisabled: computedDisabled,
            onClear: onClear,
            onInput: onInput,
            onChange: onChange,
            onKeydown: onKeydown,
            onFocus: onFocus,
            onBlur: onBlur,
            cdxIconClear: $db68d79c4ce005fe$var$Y3
        };
    },
    // Public methods
    // These must be in the methods block, not in the setup function, otherwise their documentation
    // won't be picked up by vue-docgen
    methods: {
        /**
     * Focus the component's input element.
     *
     * @public
     */ focus () {
            const input = this.$refs.input;
            input.focus();
        },
        /**
     * Blur the component's input element.
     *
     * @public
     */ blur () {
            const input = this.$refs.input;
            input.blur();
        }
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$i = [
    "id",
    "type",
    "aria-describedby",
    "disabled"
];
function $db68d79c4ce005fe$var$_sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-text-input",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)({
            id: _ctx.computedInputId,
            ref: "input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.wrappedModel = $event),
            class: [
                "cdx-text-input__input",
                _ctx.inputClasses
            ]
        }, _ctx.otherAttrsMinusId, {
            type: _ctx.inputType,
            "aria-describedby": _ctx.descriptionId,
            disabled: _ctx.computedDisabled,
            size: "1",
            onInput: _cache[1] || (_cache[1] = (...args)=>_ctx.onInput && _ctx.onInput(...args)),
            onChange: _cache[2] || (_cache[2] = (...args)=>_ctx.onChange && _ctx.onChange(...args)),
            onFocus: _cache[3] || (_cache[3] = (...args)=>_ctx.onFocus && _ctx.onFocus(...args)),
            onBlur: _cache[4] || (_cache[4] = (...args)=>_ctx.onBlur && _ctx.onBlur(...args)),
            onKeydown: _cache[5] || (_cache[5] = (...args)=>_ctx.onKeydown && _ctx.onKeydown(...args))
        }), null, 16, $db68d79c4ce005fe$var$_hoisted_1$i), [
            [
                (0, $eeJ70.vModelDynamic),
                _ctx.wrappedModel
            ]
        ]),
        _ctx.startIcon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
            key: 0,
            icon: _ctx.startIcon,
            class: "cdx-text-input__icon-vue cdx-text-input__start-icon"
        }, null, 8, [
            "icon"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        _ctx.endIcon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
            key: 1,
            icon: _ctx.endIcon,
            class: "cdx-text-input__icon-vue cdx-text-input__end-icon"
        }, null, 8, [
            "icon"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        _ctx.isClearable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
            key: 2,
            icon: _ctx.cdxIconClear,
            class: "cdx-text-input__icon-vue cdx-text-input__clear-icon",
            onMousedown: _cache[6] || (_cache[6] = (0, $eeJ70.withModifiers)(()=>{}, [
                "prevent"
            ])),
            onClick: _ctx.onClear
        }, null, 8, [
            "icon",
            "onClick"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 6);
}
const $db68d79c4ce005fe$export$edf7ede3ce8aed68 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$k, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$k
    ]
]);
const $db68d79c4ce005fe$var$sides = [
    "top",
    "right",
    "bottom",
    "left"
];
const $db68d79c4ce005fe$var$min = Math.min;
const $db68d79c4ce005fe$var$max = Math.max;
const $db68d79c4ce005fe$var$round = Math.round;
const $db68d79c4ce005fe$var$floor = Math.floor;
const $db68d79c4ce005fe$var$createCoords = (v)=>({
        x: v,
        y: v
    });
const $db68d79c4ce005fe$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $db68d79c4ce005fe$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $db68d79c4ce005fe$var$clamp(start, value, end) {
    return $db68d79c4ce005fe$var$max(start, $db68d79c4ce005fe$var$min(value, end));
}
function $db68d79c4ce005fe$var$evaluate(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $db68d79c4ce005fe$var$getSide(placement) {
    return placement.split("-")[0];
}
function $db68d79c4ce005fe$var$getAlignment(placement) {
    return placement.split("-")[1];
}
function $db68d79c4ce005fe$var$getOppositeAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function $db68d79c4ce005fe$var$getAxisLength(axis) {
    return axis === "y" ? "height" : "width";
}
function $db68d79c4ce005fe$var$getSideAxis(placement) {
    return [
        "top",
        "bottom"
    ].includes($db68d79c4ce005fe$var$getSide(placement)) ? "y" : "x";
}
function $db68d79c4ce005fe$var$getAlignmentAxis(placement) {
    return $db68d79c4ce005fe$var$getOppositeAxis($db68d79c4ce005fe$var$getSideAxis(placement));
}
function $db68d79c4ce005fe$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $db68d79c4ce005fe$var$getAlignment(placement);
    const alignmentAxis = $db68d79c4ce005fe$var$getAlignmentAxis(placement);
    const length = $db68d79c4ce005fe$var$getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $db68d79c4ce005fe$var$getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $db68d79c4ce005fe$var$getOppositePlacement(mainAlignmentSide)
    ];
}
function $db68d79c4ce005fe$var$getExpandedPlacements(placement) {
    const oppositePlacement = $db68d79c4ce005fe$var$getOppositePlacement(placement);
    return [
        $db68d79c4ce005fe$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $db68d79c4ce005fe$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function $db68d79c4ce005fe$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>$db68d79c4ce005fe$var$oppositeAlignmentMap[alignment]);
}
function $db68d79c4ce005fe$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $db68d79c4ce005fe$var$getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = $db68d79c4ce005fe$var$getAlignment(placement);
    let list = $db68d79c4ce005fe$var$getSideList($db68d79c4ce005fe$var$getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($db68d79c4ce005fe$var$getOppositeAlignmentPlacement));
    }
    return list;
}
function $db68d79c4ce005fe$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$db68d79c4ce005fe$var$oppositeSideMap[side]);
}
function $db68d79c4ce005fe$var$expandPaddingObject(padding) {
    return $db68d79c4ce005fe$var$__spreadValues({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $db68d79c4ce005fe$var$getPaddingObject(padding) {
    return typeof padding !== "number" ? $db68d79c4ce005fe$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $db68d79c4ce005fe$var$rectToClientRect(rect) {
    return $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, rect), {
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}
function $db68d79c4ce005fe$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = $db68d79c4ce005fe$var$getSideAxis(placement);
    const alignmentAxis = $db68d79c4ce005fe$var$getAlignmentAxis(placement);
    const alignLength = $db68d79c4ce005fe$var$getAxisLength(alignmentAxis);
    const side = $db68d79c4ce005fe$var$getSide(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($db68d79c4ce005fe$var$getAlignment(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
const $db68d79c4ce005fe$var$computePosition$1 = (reference, floating, config)=>$db68d79c4ce005fe$var$__async(void 0, null, function*() {
        const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform2 } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(floating);
        let rects = yield platform2.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $db68d79c4ce005fe$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = yield fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform2,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, middlewareData), {
                [name]: $db68d79c4ce005fe$var$__spreadValues($db68d79c4ce005fe$var$__spreadValues({}, middlewareData[name]), data)
            });
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === "object") {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? yield platform2.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $db68d79c4ce005fe$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    });
function $db68d79c4ce005fe$var$detectOverflow(state, options) {
    return $db68d79c4ce005fe$var$__async(this, null, function*() {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform2, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = $db68d79c4ce005fe$var$evaluate(options, state);
        const paddingObject = $db68d79c4ce005fe$var$getPaddingObject(padding);
        const altContext = elementContext === "floating" ? "reference" : "floating";
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = $db68d79c4ce005fe$var$rectToClientRect((yield platform2.getClippingRect({
            element: ((_await$platform$isEle = yield platform2.isElement == null ? void 0 : platform2.isElement(element)) != null ? _await$platform$isEle : true) ? element : element.contextElement || (yield platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        })));
        const rect = elementContext === "floating" ? $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, rects.floating), {
            x: x,
            y: y
        }) : rects.reference;
        const offsetParent = yield platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating);
        const offsetScale = (yield platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? (yield platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = $db68d79c4ce005fe$var$rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? yield platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    });
}
const $db68d79c4ce005fe$var$flip$1 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        fn (state) {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform2, elements: elements } = state;
                const _a2 = $db68d79c4ce005fe$var$evaluate(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true } = _a2, detectOverflowOptions = $db68d79c4ce005fe$var$__objRest(_a2, [
                    "mainAxis",
                    "crossAxis",
                    "fallbackPlacements",
                    "fallbackStrategy",
                    "fallbackAxisSideDirection",
                    "flipAlignment"
                ]);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = $db68d79c4ce005fe$var$getSide(placement);
                const isBasePlacement = $db68d79c4ce005fe$var$getSide(initialPlacement) === initialPlacement;
                const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating);
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    $db68d79c4ce005fe$var$getOppositePlacement(initialPlacement)
                ] : $db68d79c4ce005fe$var$getExpandedPlacements(initialPlacement));
                if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...$db68d79c4ce005fe$var$getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = yield $db68d79c4ce005fe$var$detectOverflow(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides2 = $db68d79c4ce005fe$var$getAlignmentSides(placement, rects, rtl);
                    overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side2)=>side2 <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case "bestFit":
                            {
                                var _overflowsData$map$so;
                                const placement2 = (_overflowsData$map$so = overflowsData.map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow2)=>overflow2 > 0).reduce((acc, overflow2)=>acc + overflow2, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                                if (placement2) resetPlacement = placement2;
                                break;
                            }
                        case "initialPlacement":
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            });
        }
    };
};
function $db68d79c4ce005fe$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $db68d79c4ce005fe$var$isAnySideFullyClipped(overflow) {
    return $db68d79c4ce005fe$var$sides.some((side)=>overflow[side] >= 0);
}
const $db68d79c4ce005fe$var$hide$1 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        fn (state) {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                const { rects: rects } = state;
                const _a2 = $db68d79c4ce005fe$var$evaluate(options, state), { strategy: strategy = "referenceHidden" } = _a2, detectOverflowOptions = $db68d79c4ce005fe$var$__objRest(_a2, [
                    "strategy"
                ]);
                switch(strategy){
                    case "referenceHidden":
                        {
                            const overflow = yield $db68d79c4ce005fe$var$detectOverflow(state, $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, detectOverflowOptions), {
                                elementContext: "reference"
                            }));
                            const offsets = $db68d79c4ce005fe$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $db68d79c4ce005fe$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case "escaped":
                        {
                            const overflow = yield $db68d79c4ce005fe$var$detectOverflow(state, $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, detectOverflowOptions), {
                                altBoundary: true
                            }));
                            const offsets = $db68d79c4ce005fe$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $db68d79c4ce005fe$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            });
        }
    };
};
function $db68d79c4ce005fe$var$convertValueToCoords(state, options) {
    return $db68d79c4ce005fe$var$__async(this, null, function*() {
        const { placement: placement, platform: platform2, elements: elements } = state;
        const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating);
        const side = $db68d79c4ce005fe$var$getSide(placement);
        const alignment = $db68d79c4ce005fe$var$getAlignment(placement);
        const isVertical = $db68d79c4ce005fe$var$getSideAxis(placement) === "y";
        const mainAxisMulti = [
            "left",
            "top"
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = $db68d79c4ce005fe$var$evaluate(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : $db68d79c4ce005fe$var$__spreadValues({
            mainAxis: 0,
            crossAxis: 0,
            alignmentAxis: null
        }, rawValue);
        if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    });
}
const $db68d79c4ce005fe$var$offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        fn (state) {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = yield $db68d79c4ce005fe$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, diffCoords), {
                        placement: placement
                    })
                };
            });
        }
    };
};
const $db68d79c4ce005fe$var$shift$1 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        fn (state) {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                const { x: x, y: y, placement: placement } = state;
                const _a2 = $db68d79c4ce005fe$var$evaluate(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x2, y: y2 } = _ref;
                        return {
                            x: x2,
                            y: y2
                        };
                    }
                } } = _a2, detectOverflowOptions = $db68d79c4ce005fe$var$__objRest(_a2, [
                    "mainAxis",
                    "crossAxis",
                    "limiter"
                ]);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = yield $db68d79c4ce005fe$var$detectOverflow(state, detectOverflowOptions);
                const crossAxis = $db68d79c4ce005fe$var$getSideAxis($db68d79c4ce005fe$var$getSide(placement));
                const mainAxis = $db68d79c4ce005fe$var$getOppositeAxis(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === "y" ? "top" : "left";
                    const maxSide = mainAxis === "y" ? "bottom" : "right";
                    const min2 = mainAxisCoord + overflow[minSide];
                    const max2 = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = $db68d79c4ce005fe$var$clamp(min2, mainAxisCoord, max2);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === "y" ? "top" : "left";
                    const maxSide = crossAxis === "y" ? "bottom" : "right";
                    const min2 = crossAxisCoord + overflow[minSide];
                    const max2 = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = $db68d79c4ce005fe$var$clamp(min2, crossAxisCoord, max2);
                }
                const limitedCoords = limiter.fn($db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, state), {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                }));
                return $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, limitedCoords), {
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y
                    }
                });
            });
        }
    };
};
const $db68d79c4ce005fe$var$size$1 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        fn (state) {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                const { placement: placement, rects: rects, platform: platform2, elements: elements } = state;
                const _a2 = $db68d79c4ce005fe$var$evaluate(options, state), { apply: apply = ()=>{} } = _a2, detectOverflowOptions = $db68d79c4ce005fe$var$__objRest(_a2, [
                    "apply"
                ]);
                const overflow = yield $db68d79c4ce005fe$var$detectOverflow(state, detectOverflowOptions);
                const side = $db68d79c4ce005fe$var$getSide(placement);
                const alignment = $db68d79c4ce005fe$var$getAlignment(placement);
                const isYAxis = $db68d79c4ce005fe$var$getSideAxis(placement) === "y";
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === "top" || side === "bottom") {
                    heightSide = side;
                    widthSide = alignment === ((yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
                } else {
                    widthSide = side;
                    heightSide = alignment === "end" ? "top" : "bottom";
                }
                const overflowAvailableHeight = height - overflow[heightSide];
                const overflowAvailableWidth = width - overflow[widthSide];
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if (isYAxis) {
                    const maximumClippingWidth = width - overflow.left - overflow.right;
                    availableWidth = alignment || noShift ? $db68d79c4ce005fe$var$min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
                } else {
                    const maximumClippingHeight = height - overflow.top - overflow.bottom;
                    availableHeight = alignment || noShift ? $db68d79c4ce005fe$var$min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
                }
                if (noShift && !alignment) {
                    const xMin = $db68d79c4ce005fe$var$max(overflow.left, 0);
                    const xMax = $db68d79c4ce005fe$var$max(overflow.right, 0);
                    const yMin = $db68d79c4ce005fe$var$max(overflow.top, 0);
                    const yMax = $db68d79c4ce005fe$var$max(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : $db68d79c4ce005fe$var$max(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : $db68d79c4ce005fe$var$max(overflow.top, overflow.bottom));
                }
                yield apply($db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, state), {
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                }));
                const nextDimensions = yield platform2.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            });
        }
    };
};
function $db68d79c4ce005fe$var$getNodeName(node) {
    if ($db68d79c4ce005fe$var$isNode(node)) return (node.nodeName || "").toLowerCase();
    return "#document";
}
function $db68d79c4ce005fe$var$getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $db68d79c4ce005fe$var$getDocumentElement(node) {
    var _ref;
    return (_ref = ($db68d79c4ce005fe$var$isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $db68d79c4ce005fe$var$isNode(value) {
    return value instanceof Node || value instanceof $db68d79c4ce005fe$var$getWindow(value).Node;
}
function $db68d79c4ce005fe$var$isElement(value) {
    return value instanceof Element || value instanceof $db68d79c4ce005fe$var$getWindow(value).Element;
}
function $db68d79c4ce005fe$var$isHTMLElement(value) {
    return value instanceof HTMLElement || value instanceof $db68d79c4ce005fe$var$getWindow(value).HTMLElement;
}
function $db68d79c4ce005fe$var$isShadowRoot(value) {
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $db68d79c4ce005fe$var$getWindow(value).ShadowRoot;
}
function $db68d79c4ce005fe$var$isOverflowElement(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $db68d79c4ce005fe$var$getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $db68d79c4ce005fe$var$isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($db68d79c4ce005fe$var$getNodeName(element));
}
function $db68d79c4ce005fe$var$isContainingBlock(element) {
    const webkit = $db68d79c4ce005fe$var$isWebKit();
    const css = $db68d79c4ce005fe$var$getComputedStyle(element);
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $db68d79c4ce005fe$var$getContainingBlock(element) {
    let currentNode = $db68d79c4ce005fe$var$getParentNode(element);
    while($db68d79c4ce005fe$var$isHTMLElement(currentNode) && !$db68d79c4ce005fe$var$isLastTraversableNode(currentNode)){
        if ($db68d79c4ce005fe$var$isContainingBlock(currentNode)) return currentNode;
        else currentNode = $db68d79c4ce005fe$var$getParentNode(currentNode);
    }
    return null;
}
function $db68d79c4ce005fe$var$isWebKit() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $db68d79c4ce005fe$var$isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($db68d79c4ce005fe$var$getNodeName(node));
}
function $db68d79c4ce005fe$var$getComputedStyle(element) {
    return $db68d79c4ce005fe$var$getWindow(element).getComputedStyle(element);
}
function $db68d79c4ce005fe$var$getNodeScroll(element) {
    if ($db68d79c4ce005fe$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $db68d79c4ce005fe$var$getParentNode(node) {
    if ($db68d79c4ce005fe$var$getNodeName(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $db68d79c4ce005fe$var$isShadowRoot(node) && node.host || // Fallback.
    $db68d79c4ce005fe$var$getDocumentElement(node);
    return $db68d79c4ce005fe$var$isShadowRoot(result) ? result.host : result;
}
function $db68d79c4ce005fe$var$getNearestOverflowAncestor(node) {
    const parentNode = $db68d79c4ce005fe$var$getParentNode(node);
    if ($db68d79c4ce005fe$var$isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($db68d79c4ce005fe$var$isHTMLElement(parentNode) && $db68d79c4ce005fe$var$isOverflowElement(parentNode)) return parentNode;
    return $db68d79c4ce005fe$var$getNearestOverflowAncestor(parentNode);
}
function $db68d79c4ce005fe$var$getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $db68d79c4ce005fe$var$getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $db68d79c4ce005fe$var$getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $db68d79c4ce005fe$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $db68d79c4ce005fe$var$getOverflowAncestors(win.frameElement) : []);
    return list.concat(scrollableAncestor, $db68d79c4ce005fe$var$getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function $db68d79c4ce005fe$var$getCssDimensions(element) {
    const css = $db68d79c4ce005fe$var$getComputedStyle(element);
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = $db68d79c4ce005fe$var$isHTMLElement(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = $db68d79c4ce005fe$var$round(width) !== offsetWidth || $db68d79c4ce005fe$var$round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $db68d79c4ce005fe$var$unwrapElement$2(element) {
    return !$db68d79c4ce005fe$var$isElement(element) ? element.contextElement : element;
}
function $db68d79c4ce005fe$var$getScale(element) {
    const domElement = $db68d79c4ce005fe$var$unwrapElement$2(element);
    if (!$db68d79c4ce005fe$var$isHTMLElement(domElement)) return $db68d79c4ce005fe$var$createCoords(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $db68d79c4ce005fe$var$getCssDimensions(domElement);
    let x = ($ ? $db68d79c4ce005fe$var$round(rect.width) : rect.width) / width;
    let y = ($ ? $db68d79c4ce005fe$var$round(rect.height) : rect.height) / height;
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $db68d79c4ce005fe$var$noOffsets = /* @__PURE__ */ $db68d79c4ce005fe$var$createCoords(0);
function $db68d79c4ce005fe$var$getVisualOffsets(element) {
    const win = $db68d79c4ce005fe$var$getWindow(element);
    if (!$db68d79c4ce005fe$var$isWebKit() || !win.visualViewport) return $db68d79c4ce005fe$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $db68d79c4ce005fe$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== $db68d79c4ce005fe$var$getWindow(element)) return false;
    return isFixed;
}
function $db68d79c4ce005fe$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $db68d79c4ce005fe$var$unwrapElement$2(element);
    let scale = $db68d79c4ce005fe$var$createCoords(1);
    if (includeScale) {
        if (offsetParent) {
            if ($db68d79c4ce005fe$var$isElement(offsetParent)) scale = $db68d79c4ce005fe$var$getScale(offsetParent);
        } else scale = $db68d79c4ce005fe$var$getScale(element);
    }
    const visualOffsets = $db68d79c4ce005fe$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $db68d79c4ce005fe$var$getVisualOffsets(domElement) : $db68d79c4ce005fe$var$createCoords(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = $db68d79c4ce005fe$var$getWindow(domElement);
        const offsetWin = offsetParent && $db68d79c4ce005fe$var$isElement(offsetParent) ? $db68d79c4ce005fe$var$getWindow(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $db68d79c4ce005fe$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = $db68d79c4ce005fe$var$getComputedStyle(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = $db68d79c4ce005fe$var$getWindow(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return $db68d79c4ce005fe$var$rectToClientRect({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $db68d79c4ce005fe$var$topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function $db68d79c4ce005fe$var$isTopLayer(floating) {
    return $db68d79c4ce005fe$var$topLayerSelectors.some((selector)=>{
        try {
            return floating.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $db68d79c4ce005fe$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = $db68d79c4ce005fe$var$getDocumentElement(offsetParent);
    const topLayer = elements ? $db68d79c4ce005fe$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = $db68d79c4ce005fe$var$createCoords(1);
    const offsets = $db68d79c4ce005fe$var$createCoords(0);
    const isOffsetParentAnElement = $db68d79c4ce005fe$var$isHTMLElement(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ($db68d79c4ce005fe$var$getNodeName(offsetParent) !== "body" || $db68d79c4ce005fe$var$isOverflowElement(documentElement)) scroll = $db68d79c4ce005fe$var$getNodeScroll(offsetParent);
        if ($db68d79c4ce005fe$var$isHTMLElement(offsetParent)) {
            const offsetRect = $db68d79c4ce005fe$var$getBoundingClientRect(offsetParent);
            scale = $db68d79c4ce005fe$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $db68d79c4ce005fe$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $db68d79c4ce005fe$var$getWindowScrollBarX(element) {
    return $db68d79c4ce005fe$var$getBoundingClientRect($db68d79c4ce005fe$var$getDocumentElement(element)).left + $db68d79c4ce005fe$var$getNodeScroll(element).scrollLeft;
}
function $db68d79c4ce005fe$var$getDocumentRect(element) {
    const html = $db68d79c4ce005fe$var$getDocumentElement(element);
    const scroll = $db68d79c4ce005fe$var$getNodeScroll(element);
    const body = element.ownerDocument.body;
    const width = $db68d79c4ce005fe$var$max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = $db68d79c4ce005fe$var$max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $db68d79c4ce005fe$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ($db68d79c4ce005fe$var$getComputedStyle(body).direction === "rtl") x += $db68d79c4ce005fe$var$max(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $db68d79c4ce005fe$var$getViewportRect(element, strategy) {
    const win = $db68d79c4ce005fe$var$getWindow(element);
    const html = $db68d79c4ce005fe$var$getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = $db68d79c4ce005fe$var$isWebKit();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $db68d79c4ce005fe$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $db68d79c4ce005fe$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $db68d79c4ce005fe$var$isHTMLElement(element) ? $db68d79c4ce005fe$var$getScale(element) : $db68d79c4ce005fe$var$createCoords(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $db68d79c4ce005fe$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $db68d79c4ce005fe$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $db68d79c4ce005fe$var$getDocumentRect($db68d79c4ce005fe$var$getDocumentElement(element));
    else if ($db68d79c4ce005fe$var$isElement(clippingAncestor)) rect = $db68d79c4ce005fe$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $db68d79c4ce005fe$var$getVisualOffsets(element);
        rect = $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, clippingAncestor), {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        });
    }
    return $db68d79c4ce005fe$var$rectToClientRect(rect);
}
function $db68d79c4ce005fe$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = $db68d79c4ce005fe$var$getParentNode(element);
    if (parentNode === stopNode || !$db68d79c4ce005fe$var$isElement(parentNode) || $db68d79c4ce005fe$var$isLastTraversableNode(parentNode)) return false;
    return $db68d79c4ce005fe$var$getComputedStyle(parentNode).position === "fixed" || $db68d79c4ce005fe$var$hasFixedPositionAncestor(parentNode, stopNode);
}
function $db68d79c4ce005fe$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = $db68d79c4ce005fe$var$getOverflowAncestors(element, [], false).filter((el)=>$db68d79c4ce005fe$var$isElement(el) && $db68d79c4ce005fe$var$getNodeName(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = $db68d79c4ce005fe$var$getComputedStyle(element).position === "fixed";
    let currentNode = elementIsFixed ? $db68d79c4ce005fe$var$getParentNode(element) : element;
    while($db68d79c4ce005fe$var$isElement(currentNode) && !$db68d79c4ce005fe$var$isLastTraversableNode(currentNode)){
        const computedStyle = $db68d79c4ce005fe$var$getComputedStyle(currentNode);
        const currentNodeIsContaining = $db68d79c4ce005fe$var$isContainingBlock(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || $db68d79c4ce005fe$var$isOverflowElement(currentNode) && !currentNodeIsContaining && $db68d79c4ce005fe$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
        else currentContainingBlockComputedStyle = computedStyle;
        currentNode = $db68d79c4ce005fe$var$getParentNode(currentNode);
    }
    cache.set(element, result);
    return result;
}
function $db68d79c4ce005fe$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $db68d79c4ce005fe$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $db68d79c4ce005fe$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $db68d79c4ce005fe$var$max(rect.top, accRect.top);
        accRect.right = $db68d79c4ce005fe$var$min(rect.right, accRect.right);
        accRect.bottom = $db68d79c4ce005fe$var$min(rect.bottom, accRect.bottom);
        accRect.left = $db68d79c4ce005fe$var$max(rect.left, accRect.left);
        return accRect;
    }, $db68d79c4ce005fe$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $db68d79c4ce005fe$var$getDimensions(element) {
    const { width: width, height: height } = $db68d79c4ce005fe$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $db68d79c4ce005fe$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = $db68d79c4ce005fe$var$isHTMLElement(offsetParent);
    const documentElement = $db68d79c4ce005fe$var$getDocumentElement(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $db68d79c4ce005fe$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = $db68d79c4ce005fe$var$createCoords(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ($db68d79c4ce005fe$var$getNodeName(offsetParent) !== "body" || $db68d79c4ce005fe$var$isOverflowElement(documentElement)) scroll = $db68d79c4ce005fe$var$getNodeScroll(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $db68d79c4ce005fe$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $db68d79c4ce005fe$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $db68d79c4ce005fe$var$getTrueOffsetParent(element, polyfill) {
    if (!$db68d79c4ce005fe$var$isHTMLElement(element) || $db68d79c4ce005fe$var$getComputedStyle(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
function $db68d79c4ce005fe$var$getOffsetParent(element, polyfill) {
    const window2 = $db68d79c4ce005fe$var$getWindow(element);
    if (!$db68d79c4ce005fe$var$isHTMLElement(element) || $db68d79c4ce005fe$var$isTopLayer(element)) return window2;
    let offsetParent = $db68d79c4ce005fe$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && $db68d79c4ce005fe$var$isTableElement(offsetParent) && $db68d79c4ce005fe$var$getComputedStyle(offsetParent).position === "static")offsetParent = $db68d79c4ce005fe$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ($db68d79c4ce005fe$var$getNodeName(offsetParent) === "html" || $db68d79c4ce005fe$var$getNodeName(offsetParent) === "body" && $db68d79c4ce005fe$var$getComputedStyle(offsetParent).position === "static" && !$db68d79c4ce005fe$var$isContainingBlock(offsetParent))) return window2;
    return offsetParent || $db68d79c4ce005fe$var$getContainingBlock(element) || window2;
}
const $db68d79c4ce005fe$var$getElementRects = function(data) {
    return $db68d79c4ce005fe$var$__async(this, null, function*() {
        const getOffsetParentFn = this.getOffsetParent || $db68d79c4ce005fe$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        return {
            reference: $db68d79c4ce005fe$var$getRectRelativeToOffsetParent(data.reference, (yield getOffsetParentFn(data.floating)), data.strategy),
            floating: $db68d79c4ce005fe$var$__spreadValues({
                x: 0,
                y: 0
            }, (yield getDimensionsFn(data.floating)))
        };
    });
};
function $db68d79c4ce005fe$var$isRTL(element) {
    return $db68d79c4ce005fe$var$getComputedStyle(element).direction === "rtl";
}
const $db68d79c4ce005fe$var$platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $db68d79c4ce005fe$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $db68d79c4ce005fe$var$getDocumentElement,
    getClippingRect: $db68d79c4ce005fe$var$getClippingRect,
    getOffsetParent: $db68d79c4ce005fe$var$getOffsetParent,
    getElementRects: $db68d79c4ce005fe$var$getElementRects,
    getClientRects: $db68d79c4ce005fe$var$getClientRects,
    getDimensions: $db68d79c4ce005fe$var$getDimensions,
    getScale: $db68d79c4ce005fe$var$getScale,
    isElement: $db68d79c4ce005fe$var$isElement,
    isRTL: $db68d79c4ce005fe$var$isRTL
};
function $db68d79c4ce005fe$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = $db68d79c4ce005fe$var$getDocumentElement(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = $db68d79c4ce005fe$var$floor(top);
        const insetRight = $db68d79c4ce005fe$var$floor(root.clientWidth - (left + width));
        const insetBottom = $db68d79c4ce005fe$var$floor(root.clientHeight - (top + height));
        const insetLeft = $db68d79c4ce005fe$var$floor(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: $db68d79c4ce005fe$var$max(0, $db68d79c4ce005fe$var$min(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        try {
            io = new IntersectionObserver(handleObserve, $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
function $db68d79c4ce005fe$var$autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $db68d79c4ce005fe$var$unwrapElement$2(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? $db68d79c4ce005fe$var$getOverflowAncestors(referenceEl) : [],
        ...$db68d79c4ce005fe$var$getOverflowAncestors(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $db68d79c4ce005fe$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $db68d79c4ce005fe$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $db68d79c4ce005fe$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
const $db68d79c4ce005fe$var$shift = $db68d79c4ce005fe$var$shift$1;
const $db68d79c4ce005fe$var$flip = $db68d79c4ce005fe$var$flip$1;
const $db68d79c4ce005fe$var$size = $db68d79c4ce005fe$var$size$1;
const $db68d79c4ce005fe$var$hide = $db68d79c4ce005fe$var$hide$1;
const $db68d79c4ce005fe$var$computePosition = (reference, floating, options)=>{
    const cache = /* @__PURE__ */ new Map();
    const mergedOptions = $db68d79c4ce005fe$var$__spreadValues({
        platform: $db68d79c4ce005fe$var$platform
    }, options);
    const platformWithCache = $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, mergedOptions.platform), {
        _c: cache
    });
    return $db68d79c4ce005fe$var$computePosition$1(reference, floating, $db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, mergedOptions), {
        platform: platformWithCache
    }));
};
function $db68d79c4ce005fe$var$isComponentPublicInstance(target) {
    return target != null && typeof target === "object" && "$el" in target;
}
function $db68d79c4ce005fe$var$unwrapElement$1(target) {
    if ($db68d79c4ce005fe$var$isComponentPublicInstance(target)) {
        const element = target.$el;
        return $db68d79c4ce005fe$var$isNode(element) && $db68d79c4ce005fe$var$getNodeName(element) === "#comment" ? null : element;
    }
    return target;
}
function $db68d79c4ce005fe$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $db68d79c4ce005fe$var$roundByDPR(element, value) {
    const dpr = $db68d79c4ce005fe$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $db68d79c4ce005fe$var$useFloating(reference, floating, options) {
    if (options === void 0) options = {};
    const whileElementsMountedOption = options.whileElementsMounted;
    const openOption = (0, $TusQn.computed)(()=>{
        var _unref;
        return (_unref = (0, $01W3b.unref)(options.open)) != null ? _unref : true;
    });
    const middlewareOption = (0, $TusQn.computed)(()=>(0, $01W3b.unref)(options.middleware));
    const placementOption = (0, $TusQn.computed)(()=>{
        var _unref2;
        return (_unref2 = (0, $01W3b.unref)(options.placement)) != null ? _unref2 : "bottom";
    });
    const strategyOption = (0, $TusQn.computed)(()=>{
        var _unref3;
        return (_unref3 = (0, $01W3b.unref)(options.strategy)) != null ? _unref3 : "absolute";
    });
    const transformOption = (0, $TusQn.computed)(()=>{
        var _unref4;
        return (_unref4 = (0, $01W3b.unref)(options.transform)) != null ? _unref4 : true;
    });
    const referenceElement = (0, $TusQn.computed)(()=>$db68d79c4ce005fe$var$unwrapElement$1(reference.value));
    const floatingElement = (0, $TusQn.computed)(()=>$db68d79c4ce005fe$var$unwrapElement$1(floating.value));
    const x = (0, $01W3b.ref)(0);
    const y = (0, $01W3b.ref)(0);
    const strategy = (0, $01W3b.ref)(strategyOption.value);
    const placement = (0, $01W3b.ref)(placementOption.value);
    const middlewareData = (0, $01W3b.shallowRef)({});
    const isPositioned = (0, $01W3b.ref)(false);
    const floatingStyles = (0, $TusQn.computed)(()=>{
        const initialStyles = {
            position: strategy.value,
            left: "0",
            top: "0"
        };
        if (!floatingElement.value) return initialStyles;
        const xVal = $db68d79c4ce005fe$var$roundByDPR(floatingElement.value, x.value);
        const yVal = $db68d79c4ce005fe$var$roundByDPR(floatingElement.value, y.value);
        if (transformOption.value) return $db68d79c4ce005fe$var$__spreadValues($db68d79c4ce005fe$var$__spreadProps($db68d79c4ce005fe$var$__spreadValues({}, initialStyles), {
            transform: "translate(" + xVal + "px, " + yVal + "px)"
        }), $db68d79c4ce005fe$var$getDPR(floatingElement.value) >= 1.5 && {
            willChange: "transform"
        });
        return {
            position: strategy.value,
            left: xVal + "px",
            top: yVal + "px"
        };
    });
    let whileElementsMountedCleanup;
    function update() {
        if (referenceElement.value == null || floatingElement.value == null) return;
        $db68d79c4ce005fe$var$computePosition(referenceElement.value, floatingElement.value, {
            middleware: middlewareOption.value,
            placement: placementOption.value,
            strategy: strategyOption.value
        }).then((position)=>{
            x.value = position.x;
            y.value = position.y;
            strategy.value = position.strategy;
            placement.value = position.placement;
            middlewareData.value = position.middlewareData;
            isPositioned.value = true;
        });
    }
    function cleanup() {
        if (typeof whileElementsMountedCleanup === "function") {
            whileElementsMountedCleanup();
            whileElementsMountedCleanup = void 0;
        }
    }
    function attach() {
        cleanup();
        if (whileElementsMountedOption === void 0) {
            update();
            return;
        }
        if (referenceElement.value != null && floatingElement.value != null) {
            whileElementsMountedCleanup = whileElementsMountedOption(referenceElement.value, floatingElement.value, update);
            return;
        }
    }
    function reset() {
        if (!openOption.value) isPositioned.value = false;
    }
    (0, $TusQn.watch)([
        middlewareOption,
        placementOption,
        strategyOption
    ], update, {
        flush: "sync"
    });
    (0, $TusQn.watch)([
        referenceElement,
        floatingElement
    ], attach, {
        flush: "sync"
    });
    (0, $TusQn.watch)(openOption, reset, {
        flush: "sync"
    });
    if ((0, $01W3b.getCurrentScope)()) (0, $01W3b.onScopeDispose)(cleanup);
    return {
        x: (0, $01W3b.shallowReadonly)(x),
        y: (0, $01W3b.shallowReadonly)(y),
        strategy: (0, $01W3b.shallowReadonly)(strategy),
        placement: (0, $01W3b.shallowReadonly)(placement),
        middlewareData: (0, $01W3b.shallowReadonly)(middlewareData),
        isPositioned: (0, $01W3b.shallowReadonly)(isPositioned),
        floatingStyles: floatingStyles,
        update: update
    };
}
function $db68d79c4ce005fe$var$unwrapElement(element) {
    return element && "$el" in element ? element.$el : element;
}
const $db68d79c4ce005fe$var$clipPadding = 16;
const $db68d79c4ce005fe$var$minClipHeight = 128;
function $db68d79c4ce005fe$export$ebb1680baab55ef5(referenceElement, menu, opt) {
    var _a;
    const menuIsExpanded = ()=>{
        var _a2;
        return (_a2 = menu.value) == null ? void 0 : _a2.isExpanded();
    };
    const middleware = [
        $db68d79c4ce005fe$var$offset(opt == null ? void 0 : opt.offset),
        $db68d79c4ce005fe$var$size({
            // Don't size the menu to take up exactly all of the available height, because that
            // makes it look like it's cut off. Instead, leave 16px of free space between the bottom
            // of the menu and the bottom edge of the viewport / scrollable container.
            padding: $db68d79c4ce005fe$var$clipPadding,
            apply ({ rects: rects, elements: elements, availableHeight: availableHeight, availableWidth: availableWidth }) {
                Object.assign(elements.floating.style, {
                    // Optionally use all available width
                    // Else, set the width of the menu to match the width of the triggering element.
                    // This is needed in Dialogs, when the menu's position is set relative to
                    // the dialog, not the triggering element.
                    width: "".concat((opt == null ? void 0 : opt.useAvailableWidth) ? availableWidth : rects.reference.width, "px"),
                    // Set the max-height to the available height, to prevent the menu from
                    // extending past the edge of the viewport or scrollable container. But don't
                    // allow the menu to be shrunk to less than 128px; this is necessary to make
                    // the flip() call below work.
                    maxHeight: "".concat(Math.max($db68d79c4ce005fe$var$minClipHeight, availableHeight), "px")
                });
            }
        }),
        // If there is not enough space to put the menu below the triggering element, put it above
        // it instead. Because of the maxHeight logic above, this happens when there is less than
        // 128px available below the triggering element.
        $db68d79c4ce005fe$var$flip({
            // Apply the same padding here as in size(), otherwise the gap between the bottom of
            // the menu and the bottom edge of the viewport is allowed to shrink to zero before the
            // menu flips.
            padding: $db68d79c4ce005fe$var$clipPadding
        }),
        // Hide the menu when it has escaped the reference element's clipping context (e.g. the menu
        // is opened down and you scroll up until the reference element just starts to leave the
        // container).
        $db68d79c4ce005fe$var$hide({
            strategy: "escaped"
        }),
        // Hide the menu when the reference element is fully hidden (e.g. the menu is opened down
        // and you scroll down until the whole reference element is gone).
        $db68d79c4ce005fe$var$hide()
    ];
    const { floatingStyles: floatingStyles, placement: placement, middlewareData: middlewareData, update: update } = $db68d79c4ce005fe$var$useFloating(referenceElement, menu, {
        middleware: middleware,
        placement: (_a = opt == null ? void 0 : opt.placement) != null ? _a : "bottom"
    });
    const menuVisibility = (0, $TusQn.computed)(()=>{
        var _a2, _b;
        const isHidden = !menuIsExpanded() || !!((_a2 = middlewareData.value.hide) == null ? void 0 : _a2.escaped) || ((_b = middlewareData.value.hide) == null ? void 0 : _b.referenceHidden);
        return isHidden ? "hidden" : "visible";
    });
    (0, $TusQn.watch)([
        floatingStyles,
        menuVisibility,
        placement
    ], ([newStyles, newVisibility, newPlacement])=>{
        var _a2, _b, _c, _d, _e;
        Object.assign((_b = (_a2 = menu.value) == null ? void 0 : _a2.$el.style) != null ? _b : {}, {
            visibility: newVisibility,
            position: newStyles.position,
            top: "".concat(newStyles.top, "px"),
            // `left: 0` is set in the Menu component, which gets transformed to `right: 0` for
            // RTL. For this component, we must unset `right: 0`, because the transform value
            // is relative to the left side of the screen regardless of reading direction.
            right: "unset",
            // Set `left` value to ensure the menu is translated relative to the left side of
            // the screen, which is what FloatingUI expects when it calculates the translate-x
            // value for both LTR and RTL.
            left: "".concat(newStyles.left, "px"),
            // If menuWidth is specified, transform shifts negative, for now ignore that
            transform: (_c = newStyles.transform) != null ? _c : "none",
            // Zero out border-radius on the corners of the menu where it touches the reference
            // element. Which corners these are depends on whether the menu is flipped
            borderTopLeftRadius: newPlacement === "bottom" && newVisibility === "visible" ? "0" : "",
            borderTopRightRadius: newPlacement === "bottom" && newVisibility === "visible" ? "0" : "",
            borderBottomLeftRadius: newPlacement === "top" && newVisibility === "visible" ? "0" : "",
            borderBottomRightRadius: newPlacement === "top" && newVisibility === "visible" ? "0" : ""
        });
        Object.assign((_e = (_d = $db68d79c4ce005fe$var$unwrapElement(referenceElement.value)) == null ? void 0 : _d.style) != null ? _e : {}, {
            // Zero out border-radius on the corners of the reference element where it touches
            // the menu. Which corners these are depends on whether the menu is flipped
            borderTopLeftRadius: newPlacement === "top" && newVisibility === "visible" ? "0" : "",
            borderTopRightRadius: newPlacement === "top" && newVisibility === "visible" ? "0" : "",
            borderBottomLeftRadius: newPlacement === "bottom" && newVisibility === "visible" ? "0" : "",
            borderBottomRightRadius: newPlacement === "bottom" && newVisibility === "visible" ? "0" : ""
        });
    });
    let cleanupAutoUpdate = null;
    (0, $TusQn.watch)(menuIsExpanded, (newExpanded)=>{
        var _a2;
        if (newExpanded) cleanupAutoUpdate = $db68d79c4ce005fe$var$autoUpdate(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        referenceElement.value && "$el" in referenceElement.value ? referenceElement.value.$el : referenceElement, // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        (_a2 = menu.value) == null ? void 0 : _a2.$el, update);
        else if (cleanupAutoUpdate) {
            cleanupAutoUpdate();
            cleanupAutoUpdate = null;
        }
    });
}
const $db68d79c4ce005fe$var$statusValidator$7 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$j = (0, $TusQn.defineComponent)({
    name: "CdxCombobox",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxMenu: $db68d79c4ce005fe$export$a33433a93a74f3ad,
        CdxTextInput: $db68d79c4ce005fe$export$edf7ede3ce8aed68
    },
    /**
   * Attributes applied to this component by a parent will be applied
   * to the TextInput child component rather than the root element.
   */ inheritAttrs: false,
    props: {
        /**
     * Menu items. See the MenuItemData type.
     */ menuItems: {
            type: Array,
            required: true
        },
        /**
     * Value of the current selection.
     *
     * Must be bound with `v-model:selected`.
     */ selected: {
            type: [
                String,
                Number
            ],
            required: true
        },
        /**
     * Whether the dropdown is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Configuration for various menu features. All properties default to false.
     *
     * See the MenuConfig type.
     * @default {}
     */ menuConfig: {
            type: Object,
            default: ()=>{
                return {};
            }
        },
        /**
     * `status` property of the TextInput component
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$7
        }
    },
    emits: [
        /**
     * When the selected value changes.
     *
     * @property {string | number} selected The new selected value
     */ "update:selected",
        /**
     * When the user scrolls towards the bottom of the menu.
     *
     * If it is possible to add or load more menu items, then now would be a good moment
     * so that the user can experience infinite scrolling.
     */ "load-more",
        /**
     * When the input value changes via direct use of the input
     *
     * @property {InputEvent} event
     */ "input",
        /**
     * When an input value change is committed by the user (e.g. on blur)
     *
     * @property {Event} event
     */ "change",
        /**
     * When the input comes into focus
     *
     * @property {FocusEvent} event
     */ "focus",
        /**
     * When the input loses focus
     *
     * @property {FocusEvent} event
     */ "blur"
    ],
    setup (props, { emit: emit, attrs: attrs, slots: slots }) {
        const input = (0, $01W3b.ref)();
        const inputWrapper = (0, $01W3b.ref)();
        const menu = (0, $01W3b.ref)();
        const menuId = $db68d79c4ce005fe$export$6217842283d27b52("combobox");
        const selectedProp = (0, $01W3b.toRef)(props, "selected");
        const modelWrapper = $db68d79c4ce005fe$export$c9be858be225e6de(selectedProp, emit, "update:selected");
        const expanded = (0, $01W3b.ref)(false);
        const expanderClicked = (0, $01W3b.ref)(false);
        const highlightedId = (0, $TusQn.computed)(()=>{
            var _a, _b;
            return (_b = (_a = menu.value) == null ? void 0 : _a.getHighlightedMenuItem()) == null ? void 0 : _b.id;
        });
        const { computedDisabled: computedDisabled, computedStatus: computedStatus } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"));
        const internalClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-combobox--expanded": expanded.value,
                "cdx-combobox--disabled": computedDisabled.value
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        function onInputFocus(event) {
            if (expanderClicked.value && expanded.value) expanded.value = false;
            else if (props.menuItems.length > 0 || slots["no-results"]) expanded.value = true;
            emit("focus", event);
        }
        function onInputBlur(event) {
            expanded.value = expanderClicked.value && expanded.value;
            emit("blur", event);
        }
        function onButtonMousedown() {
            if (computedDisabled.value) return;
            expanderClicked.value = true;
        }
        function onButtonClick() {
            var _a;
            if (computedDisabled.value) return;
            (_a = input.value) == null || _a.focus();
        }
        function onKeydown(e) {
            if (!menu.value || computedDisabled.value || props.menuItems.length === 0 || e.key === " ") return;
            menu.value.delegateKeyNavigation(e);
        }
        $db68d79c4ce005fe$export$ebb1680baab55ef5(input, menu);
        (0, $TusQn.watch)(expanded, ()=>{
            expanderClicked.value = false;
        });
        return {
            input: input,
            inputWrapper: inputWrapper,
            menu: menu,
            menuId: menuId,
            modelWrapper: modelWrapper,
            expanded: expanded,
            highlightedId: highlightedId,
            computedDisabled: computedDisabled,
            computedStatus: computedStatus,
            onInputFocus: onInputFocus,
            onInputBlur: onInputBlur,
            onKeydown: onKeydown,
            onButtonClick: onButtonClick,
            onButtonMousedown: onButtonMousedown,
            cdxIconExpand: $db68d79c4ce005fe$var$m4,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$h = {
    ref: "inputWrapper",
    class: "cdx-combobox__input-wrapper"
};
function $db68d79c4ce005fe$var$_sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_text_input = (0, $TusQn.resolveComponent)("cdx-text-input");
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    const _component_cdx_menu = (0, $TusQn.resolveComponent)("cdx-menu");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-combobox",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$h, [
            (0, $TusQn.createVNode)(_component_cdx_text_input, (0, $TusQn.mergeProps)({
                ref: "input",
                modelValue: _ctx.modelWrapper,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.modelWrapper = $event)
            }, _ctx.otherAttrs, {
                class: "cdx-combobox__input",
                "aria-activedescendant": _ctx.highlightedId,
                "aria-expanded": _ctx.expanded,
                "aria-controls": _ctx.menuId,
                disabled: _ctx.computedDisabled,
                status: _ctx.computedStatus,
                autocomplete: "off",
                role: "combobox",
                onKeydown: _ctx.onKeydown,
                onInput: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("input", $event)),
                onChange: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("change", $event)),
                onFocus: _ctx.onInputFocus,
                onBlur: _ctx.onInputBlur
            }), null, 16, [
                "modelValue",
                "aria-activedescendant",
                "aria-expanded",
                "aria-controls",
                "disabled",
                "status",
                "onKeydown",
                "onFocus",
                "onBlur"
            ]),
            (0, $TusQn.createVNode)(_component_cdx_button, {
                class: "cdx-combobox__expand-button",
                "aria-hidden": "true",
                disabled: _ctx.computedDisabled,
                tabindex: "-1",
                type: "button",
                onMousedown: _ctx.onButtonMousedown,
                onClick: _ctx.onButtonClick
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_cdx_icon, {
                            class: "cdx-combobox__expand-icon",
                            icon: _ctx.cdxIconExpand
                        }, null, 8, [
                            "icon"
                        ])
                    ]),
                _: 1
            }, 8, [
                "disabled",
                "onMousedown",
                "onClick"
            ])
        ], 512),
        (0, $TusQn.createVNode)(_component_cdx_menu, (0, $TusQn.mergeProps)({
            id: _ctx.menuId,
            ref: "menu",
            selected: _ctx.modelWrapper,
            "onUpdate:selected": _cache[3] || (_cache[3] = ($event)=>_ctx.modelWrapper = $event),
            expanded: _ctx.expanded,
            "onUpdate:expanded": _cache[4] || (_cache[4] = ($event)=>_ctx.expanded = $event),
            "menu-items": _ctx.menuItems
        }, _ctx.menuConfig, {
            onLoadMore: _cache[5] || (_cache[5] = ($event)=>_ctx.$emit("load-more"))
        }), {
            default: (0, $TusQn.withCtx)(({ menuItem: menuItem })=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "menu-item", {
                        menuItem: menuItem
                    })
                ]),
            "no-results": (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "no-results")
                ]),
            _: 3
        }, 16, [
            "id",
            "selected",
            "expanded",
            "menu-items"
        ])
    ], 6);
}
const $db68d79c4ce005fe$export$583459ee9b921b7f = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$j, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$j
    ]
]);
function $db68d79c4ce005fe$export$683480f191c0e3ea(templateRef) {
    const currentDimensions = (0, $01W3b.ref)({
        width: void 0,
        height: void 0
    });
    if (typeof window !== "object" || !("ResizeObserver" in window) || !("ResizeObserverEntry" in window)) return currentDimensions;
    const observer = new window.ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry) currentDimensions.value = {
            width: entry.borderBoxSize[0].inlineSize,
            height: entry.borderBoxSize[0].blockSize
        };
    });
    let mounted = false;
    (0, $TusQn.onMounted)(()=>{
        mounted = true;
        if (templateRef.value) observer.observe(templateRef.value);
    });
    (0, $TusQn.onUnmounted)(()=>{
        mounted = false;
        observer.disconnect();
    });
    (0, $TusQn.watch)(templateRef, (newElement)=>{
        if (!mounted) return;
        observer.disconnect();
        currentDimensions.value = {
            width: void 0,
            height: void 0
        };
        if (newElement) observer.observe(newElement);
    });
    return currentDimensions;
}
const $db68d79c4ce005fe$var$_sfc_main$i = (0, $TusQn.defineComponent)({
    name: "CdxDialog",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    inheritAttrs: false,
    props: {
        /**
     * Whether the dialog is visible. Should be provided via a v-model:open
     * binding in the parent scope.
     */ open: {
            type: Boolean,
            default: false
        },
        /**
     * Title for the dialog header. Used for ARIA purposes even if no
     * visible header element is displayed.
     */ title: {
            type: String,
            required: true
        },
        /**
     * Optional subtitle for the dialog.
     */ subtitle: {
            type: String,
            required: false,
            default: null
        },
        /**
     * Whether the dialog header should hide the title & subtitle
     */ hideTitle: {
            type: Boolean,
            default: false
        },
        /**
     * Add an icon-only close button to the dialog header.
     */ useCloseButton: {
            type: Boolean,
            default: false
        },
        // DEPRECATED: Set default to 'Close' (T368444)
        /**
     * Visually-hidden label text for the icon-only close button in the header.
     *
     * Omit this prop to use the default value, "Close".
     */ closeButtonLabel: {
            type: String,
            default: ""
        },
        /**
     * Primary user action. This will display a primary button with the specified action
     * (progressive or destructive).
     */ primaryAction: {
            type: Object,
            default: null
        },
        /**
     * Default user action. This will display a normal button.
     */ defaultAction: {
            type: Object,
            default: null
        },
        /**
     * Whether action buttons should be vertically stacked and 100% width.
     */ stackedActions: {
            type: Boolean,
            default: false
        },
        /**
     * Selector or DOM element identifying the container the dialog should
     * be rendered in. The dialog will be `<teleport>`ed to this element.
     * An ID selector is recommended, e.g. `#foo-bar`, but providing an
     * actual element is also supported.
     *
     * If this prop is not set, and the parent or one of its ancestors
     * provides a teleport target using `provide( 'CdxTeleportTarget',
     * '#foo-bar' )`, the provided target will be used. If there is no
     * provided target, the dialog will be teleported to the end of the
     * `<body>` element.
     */ target: {
            type: String,
            default: null
        },
        /**
     * Whether to disable the use of teleport and render the Dialog in its
     * original location in the document. If this is true, the `target` prop
     * is ignored.
     */ renderInPlace: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * When the open/close state changes, e.g. when the close button is clicked.
     *
     * @property {boolean} newValue The new open/close state (true for open, false for closed)
     */ "update:open",
        /**
     * When the primary action button is clicked.
     */ "primary",
        /**
     * When the default action button is clicked.
     */ "default"
    ],
    setup (props, { emit: emit }) {
        const labelId = $db68d79c4ce005fe$export$6217842283d27b52("dialog-label");
        const backdrop = (0, $01W3b.ref)();
        const dialogElement = (0, $01W3b.ref)();
        const dialogBody = (0, $01W3b.ref)();
        const focusHolder = (0, $01W3b.ref)();
        const focusTrapStart = (0, $01W3b.ref)();
        const focusTrapEnd = (0, $01W3b.ref)();
        let previouslyFocused = null;
        const useCloseButtonOrLabel = (0, $TusQn.computed)(()=>props.useCloseButton || props.closeButtonLabel.length > 0);
        const translatedCloseButtonLabel = $db68d79c4ce005fe$var$useI18nWithOverride((0, $01W3b.toRef)(props, "closeButtonLabel"), "cdx-dialog-close-button-label", "Close");
        const showHeader = (0, $TusQn.computed)(()=>!props.hideTitle || useCloseButtonOrLabel.value);
        const showFooterActions = (0, $TusQn.computed)(()=>!!props.primaryAction || !!props.defaultAction);
        const bodyDimensions = $db68d79c4ce005fe$export$683480f191c0e3ea(dialogBody);
        const currentBodyHeight = (0, $TusQn.computed)(()=>{
            var _a;
            return (_a = bodyDimensions.value.height) != null ? _a : 0;
        });
        const showDividers = (0, $01W3b.ref)(false);
        const rootClasses = (0, $TusQn.computed)(()=>({
                "cdx-dialog--vertical-actions": props.stackedActions,
                "cdx-dialog--horizontal-actions": !props.stackedActions,
                "cdx-dialog--dividers": showDividers.value
            }));
        const providedTarget = (0, $TusQn.inject)("CdxTeleportTarget", void 0);
        const computedTarget = (0, $TusQn.computed)(()=>{
            var _a, _b;
            return (_b = (_a = props.target) != null ? _a : providedTarget) != null ? _b : "body";
        });
        const scrollWidth = (0, $01W3b.ref)(0);
        function close() {
            emit("update:open", false);
        }
        function focusFirst() {
            focusFirstFocusableElement(dialogElement.value);
        }
        function focusLast() {
            focusFirstFocusableElement(dialogElement.value, true);
        }
        function focusFirstFocusableElement(container, backwards = false) {
            let candidates = Array.from(container.querySelectorAll('\n					input, select, textarea, button, object, a, area,\n					[contenteditable], [tabindex]:not([tabindex^="-"])\n				'));
            if (backwards) candidates = candidates.reverse();
            for (const candidate of candidates){
                candidate.focus();
                if (document.activeElement === candidate) return true;
            }
            return false;
        }
        let ariaHiddenElements = [];
        let inertElements = [];
        function setAriaHiddenAndInert() {
            let element = backdrop.value;
            while(element.parentElement && element.nodeName !== "BODY"){
                for (const sibling of Array.from(element.parentElement.children)){
                    if (sibling === element || sibling.nodeName === "SCRIPT") continue;
                    if (!sibling.hasAttribute("aria-hidden")) {
                        sibling.setAttribute("aria-hidden", "true");
                        ariaHiddenElements.push(sibling);
                    }
                    if (!sibling.hasAttribute("inert")) {
                        sibling.setAttribute("inert", "");
                        inertElements.push(sibling);
                    }
                }
                element = element.parentElement;
            }
        }
        function unsetAriaHiddenAndInert() {
            for (const element of ariaHiddenElements)element.removeAttribute("aria-hidden");
            for (const element of inertElements)element.removeAttribute("inert");
            ariaHiddenElements = [];
            inertElements = [];
        }
        function onDialogOpen() {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                var _a;
                yield (0, $TusQn.nextTick)();
                scrollWidth.value = window.innerWidth - document.documentElement.clientWidth;
                document.documentElement.style.setProperty("margin-right", "".concat(scrollWidth.value, "px"));
                document.body.classList.add("cdx-dialog-open");
                setAriaHiddenAndInert();
                previouslyFocused = document.activeElement;
                if (!focusFirstFocusableElement(dialogBody.value)) (_a = focusHolder.value) == null || _a.focus();
            });
        }
        function onDialogClose() {
            document.body.classList.remove("cdx-dialog-open");
            document.documentElement.style.removeProperty("margin-right");
            unsetAriaHiddenAndInert();
            if (previouslyFocused instanceof HTMLElement && document.contains(previouslyFocused)) {
                previouslyFocused.focus();
                previouslyFocused = null;
            }
        }
        (0, $TusQn.onMounted)(()=>{
            if (props.open) onDialogOpen();
        });
        (0, $TusQn.onUnmounted)(()=>{
            if (props.open) onDialogClose();
        });
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "open"), (opened)=>{
            if (opened) onDialogOpen();
            else onDialogClose();
        });
        (0, $TusQn.watch)(currentBodyHeight, ()=>{
            if (dialogBody.value) showDividers.value = dialogBody.value.clientHeight < dialogBody.value.scrollHeight;
        });
        return {
            close: close,
            cdxIconClose: $db68d79c4ce005fe$var$X3,
            labelId: labelId,
            rootClasses: rootClasses,
            backdrop: backdrop,
            dialogElement: dialogElement,
            focusTrapStart: focusTrapStart,
            focusTrapEnd: focusTrapEnd,
            focusFirst: focusFirst,
            focusLast: focusLast,
            dialogBody: dialogBody,
            focusHolder: focusHolder,
            showHeader: showHeader,
            showFooterActions: showFooterActions,
            useCloseButtonOrLabel: useCloseButtonOrLabel,
            translatedCloseButtonLabel: translatedCloseButtonLabel,
            computedTarget: computedTarget
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$g = [
    "aria-label",
    "aria-labelledby"
];
const $db68d79c4ce005fe$var$_hoisted_2$a = {
    key: 0,
    class: "cdx-dialog__header__title-group"
};
const $db68d79c4ce005fe$var$_hoisted_3$6 = [
    "id"
];
const $db68d79c4ce005fe$var$_hoisted_4$4 = {
    key: 0,
    class: "cdx-dialog__header__subtitle"
};
const $db68d79c4ce005fe$var$_hoisted_5$4 = {
    ref: "focusHolder",
    class: "cdx-dialog-focus-trap",
    tabindex: "-1"
};
const $db68d79c4ce005fe$var$_hoisted_6$4 = {
    key: 0,
    class: "cdx-dialog__footer__text"
};
const $db68d79c4ce005fe$var$_hoisted_7$1 = {
    key: 1,
    class: "cdx-dialog__footer__actions"
};
function $db68d79c4ce005fe$var$_sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.Teleport), {
        to: _ctx.computedTarget,
        disabled: _ctx.renderInPlace
    }, [
        (0, $TusQn.createVNode)((0, $eeJ70.Transition), {
            name: "cdx-dialog-fade",
            appear: ""
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    _ctx.open ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                        key: 0,
                        ref: "backdrop",
                        class: "cdx-dialog-backdrop",
                        onClick: _cache[5] || (_cache[5] = (...args)=>_ctx.close && _ctx.close(...args)),
                        onKeyup: _cache[6] || (_cache[6] = (0, $eeJ70.withKeys)((...args)=>_ctx.close && _ctx.close(...args), [
                            "escape"
                        ]))
                    }, [
                        (0, $TusQn.createElementVNode)("div", {
                            ref: "focusTrapStart",
                            tabindex: "0",
                            onFocus: _cache[0] || (_cache[0] = (...args)=>_ctx.focusLast && _ctx.focusLast(...args))
                        }, null, 544),
                        (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                            ref: "dialogElement",
                            class: [
                                "cdx-dialog",
                                _ctx.rootClasses
                            ],
                            role: "dialog"
                        }, _ctx.$attrs, {
                            "aria-label": _ctx.$slots.header || _ctx.hideTitle ? _ctx.title : void 0,
                            "aria-labelledby": !_ctx.$slots.header && !_ctx.hideTitle ? _ctx.labelId : void 0,
                            "aria-modal": "true",
                            onClick: _cache[3] || (_cache[3] = (0, $eeJ70.withModifiers)(()=>{}, [
                                "stop"
                            ]))
                        }), [
                            _ctx.showHeader || _ctx.$slots.header ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("header", {
                                key: 0,
                                class: (0, $8XWQX.normalizeClass)([
                                    "cdx-dialog__header",
                                    {
                                        "cdx-dialog__header--default": !_ctx.$slots.header
                                    }
                                ])
                            }, [
                                (0, $TusQn.renderSlot)(_ctx.$slots, "header", {}, ()=>[
                                        !_ctx.hideTitle ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_2$a, [
                                            (0, $TusQn.createElementVNode)("h2", {
                                                id: _ctx.labelId,
                                                class: "cdx-dialog__header__title"
                                            }, (0, $8XWQX.toDisplayString)(_ctx.title), 9, $db68d79c4ce005fe$var$_hoisted_3$6),
                                            _ctx.subtitle ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $db68d79c4ce005fe$var$_hoisted_4$4, (0, $8XWQX.toDisplayString)(_ctx.subtitle), 1)) : (0, $TusQn.createCommentVNode)("v-if", true)
                                        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                        _ctx.useCloseButtonOrLabel ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                                            key: 1,
                                            class: "cdx-dialog__header__close-button",
                                            weight: "quiet",
                                            type: "button",
                                            "aria-label": _ctx.translatedCloseButtonLabel,
                                            onClick: _ctx.close
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createVNode)(_component_cdx_icon, {
                                                        icon: _ctx.cdxIconClose
                                                    }, null, 8, [
                                                        "icon"
                                                    ])
                                                ]),
                                            _: 1
                                        }, 8, [
                                            "aria-label",
                                            "onClick"
                                        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                                    ])
                            ], 2)) : (0, $TusQn.createCommentVNode)("v-if", true),
                            (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_5$4, null, 512),
                            (0, $TusQn.createElementVNode)("div", {
                                ref: "dialogBody",
                                class: (0, $8XWQX.normalizeClass)([
                                    "cdx-dialog__body",
                                    {
                                        "cdx-dialog__body--no-header": !(_ctx.showHeader || _ctx.$slots.header),
                                        "cdx-dialog__body--no-footer": !(_ctx.showFooterActions || _ctx.$slots.footer || _ctx.$slots["footer-text"])
                                    }
                                ])
                            }, [
                                (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                            ], 2),
                            _ctx.showFooterActions || _ctx.$slots.footer || _ctx.$slots["footer-text"] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("footer", {
                                key: 1,
                                class: (0, $8XWQX.normalizeClass)([
                                    "cdx-dialog__footer",
                                    {
                                        "cdx-dialog__footer--default": !_ctx.$slots.footer
                                    }
                                ])
                            }, [
                                (0, $TusQn.renderSlot)(_ctx.$slots, "footer", {}, ()=>[
                                        _ctx.$slots["footer-text"] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", $db68d79c4ce005fe$var$_hoisted_6$4, [
                                            (0, $TusQn.renderSlot)(_ctx.$slots, "footer-text")
                                        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                        _ctx.showFooterActions ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_7$1, [
                                            _ctx.primaryAction ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                                                key: 0,
                                                class: "cdx-dialog__footer__primary-action",
                                                weight: "primary",
                                                action: _ctx.primaryAction.actionType,
                                                disabled: _ctx.primaryAction.disabled,
                                                onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("primary"))
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.primaryAction.label), 1)
                                                    ]),
                                                _: 1
                                            }, 8, [
                                                "action",
                                                "disabled"
                                            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                            _ctx.defaultAction ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                                                key: 1,
                                                class: "cdx-dialog__footer__default-action",
                                                disabled: _ctx.defaultAction.disabled,
                                                onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("default"))
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.defaultAction.label), 1)
                                                    ]),
                                                _: 1
                                            }, 8, [
                                                "disabled"
                                            ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                                        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                                    ])
                            ], 2)) : (0, $TusQn.createCommentVNode)("v-if", true)
                        ], 16, $db68d79c4ce005fe$var$_hoisted_1$g),
                        (0, $TusQn.createElementVNode)("div", {
                            ref: "focusTrapEnd",
                            tabindex: "0",
                            onFocus: _cache[4] || (_cache[4] = (...args)=>_ctx.focusFirst && _ctx.focusFirst(...args))
                        }, null, 544)
                    ], 544)) : (0, $TusQn.createCommentVNode)("v-if", true)
                ]),
            _: 3
        })
    ], 8, [
        "to",
        "disabled"
    ]);
}
const $db68d79c4ce005fe$export$47ed18c984f34b4c = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$i, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$i
    ]
]);
const $db68d79c4ce005fe$var$iconMap$2 = {
    notice: $db68d79c4ce005fe$var$Y4,
    error: $db68d79c4ce005fe$var$i4,
    warning: $db68d79c4ce005fe$var$M3,
    success: $db68d79c4ce005fe$var$O7
};
const $db68d79c4ce005fe$var$_sfc_main$h = (0, $TusQn.defineComponent)({
    name: "CdxMessage",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    props: {
        /**
     * Status type of Message.
     *
     * @values 'notice', 'warning', 'error', 'success'
     */ type: {
            type: String,
            default: "notice",
            validator: $db68d79c4ce005fe$var$statusTypeValidator
        },
        /**
     * Whether this message follows the inline design (no padding, background color, or border).
     */ inline: {
            type: Boolean,
            default: false
        },
        /**
     * Custom message icon. Only allowed for notice messages.
     */ icon: {
            type: [
                String,
                Object
            ],
            default: null
        },
        /**
     * Whether the message should fade in. Should be used for messages that are dynamically
     * displayed, not present on page load.
     */ fadeIn: {
            type: Boolean,
            default: false
        },
        /**
     * Allow the message to be dismissed by the user. Adds an icon-only dismiss button.
     */ allowUserDismiss: {
            type: Boolean,
            default: false
        },
        // DEPRECATED: set default to 'Close' (T368444).
        /**
     * Visually-hidden label text for the dismiss button for user-dismissable messages.
     *
     * Omit this prop to use the default value, "Close".
     */ dismissButtonLabel: {
            type: String,
            default: ""
        },
        /**
     * Enable automatic dismissal of message after a period of time.
     *
     * This prop can be set to `true` to use the default display time of 4000 milliseconds. To
     * customize the display time, set this prop to a number of milliseconds.
     *
     * Error messages cannot be automatically dismissed. If the `type` prop is set to `error`,
     * this prop will be ignored.
     *
     * TODO: consider adding a stricter validator to set limits on this. If the time is too
     * short, the message may not be readable. If the time is too long, the message probably
     * shouldn't be auto-dismissed.
     */ autoDismiss: {
            type: [
                Boolean,
                Number
            ],
            default: false,
            validator: (value)=>typeof value === "boolean" || typeof value === "number" && value > 0
        }
    },
    emits: [
        /**
     * Emitted when the message is dismissed by the user via the dismiss button.
     */ "user-dismissed",
        /**
     * Emitted when the message is automatically dismissed after the display time.
     */ "auto-dismissed"
    ],
    setup (props, { emit: emit }) {
        const dismissed = (0, $01W3b.ref)(false);
        const userDismissable = (0, $TusQn.computed)(()=>props.inline === false && // DEPRECATED: require use of new prop allowUserDismiss (T368444).
            (props.dismissButtonLabel.length > 0 || props.allowUserDismiss));
        const translatedDismissButtonLabel = $db68d79c4ce005fe$var$useI18nWithOverride((0, $01W3b.toRef)(props, "dismissButtonLabel"), "cdx-message-dismiss-button-label", "Close");
        const displayTime = (0, $TusQn.computed)(()=>{
            if (props.autoDismiss === false || props.type === "error") return false;
            else if (props.autoDismiss === true) return 4e3;
            return props.autoDismiss;
        });
        const rootClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-message--inline": props.inline,
                "cdx-message--block": !props.inline,
                "cdx-message--user-dismissable": userDismissable.value,
                ["cdx-message--".concat(props.type)]: true
            };
        });
        const computedIcon = (0, $TusQn.computed)(()=>props.icon && props.type === "notice" ? props.icon : $db68d79c4ce005fe$var$iconMap$2[props.type]);
        const leaveActiveClass = (0, $01W3b.ref)("");
        function onDismiss(eventName) {
            if (dismissed.value) return;
            leaveActiveClass.value = eventName === "user-dismissed" ? "cdx-message-leave-active-user" : "cdx-message-leave-active-system";
            dismissed.value = true;
            emit(eventName);
        }
        (0, $TusQn.onMounted)(()=>{
            if (props.type === "error" && props.autoDismiss !== false) (0, $TusQn.warn)('CdxMessage: Message with type="error" cannot use auto-dismiss');
            else if (displayTime.value) setTimeout(()=>onDismiss("auto-dismissed"), displayTime.value);
        });
        return {
            dismissed: dismissed,
            userDismissable: userDismissable,
            translatedDismissButtonLabel: translatedDismissButtonLabel,
            rootClasses: rootClasses,
            leaveActiveClass: leaveActiveClass,
            computedIcon: computedIcon,
            onDismiss: onDismiss,
            cdxIconClose: $db68d79c4ce005fe$var$X3
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$f = [
    "aria-live",
    "role"
];
const $db68d79c4ce005fe$var$_hoisted_2$9 = {
    class: "cdx-message__content"
};
function $db68d79c4ce005fe$var$_sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
        name: "cdx-message",
        appear: _ctx.fadeIn,
        "leave-active-class": _ctx.leaveActiveClass
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                !_ctx.dismissed ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                    key: 0,
                    class: (0, $8XWQX.normalizeClass)([
                        "cdx-message",
                        _ctx.rootClasses
                    ]),
                    "aria-live": _ctx.type !== "error" ? "polite" : void 0,
                    role: _ctx.type === "error" ? "alert" : void 0
                }, [
                    (0, $TusQn.createVNode)(_component_cdx_icon, {
                        class: "cdx-message__icon--vue",
                        icon: _ctx.computedIcon
                    }, null, 8, [
                        "icon"
                    ]),
                    (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_2$9, [
                        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                    ]),
                    _ctx.userDismissable ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
                        key: 0,
                        class: "cdx-message__dismiss-button",
                        weight: "quiet",
                        type: "button",
                        "aria-label": _ctx.translatedDismissButtonLabel,
                        onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.onDismiss("user-dismissed"))
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_cdx_icon, {
                                    icon: _ctx.cdxIconClose
                                }, null, 8, [
                                    "icon"
                                ])
                            ]),
                        _: 1
                    }, 8, [
                        "aria-label"
                    ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                ], 10, $db68d79c4ce005fe$var$_hoisted_1$f)) : (0, $TusQn.createCommentVNode)("v-if", true)
            ]),
        _: 3
    }, 8, [
        "appear",
        "leave-active-class"
    ]);
}
const $db68d79c4ce005fe$export$cebd7a56cc7f747 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$h, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$h
    ]
]);
const $db68d79c4ce005fe$var$statusValidator$6 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$g = (0, $TusQn.defineComponent)({
    name: "CdxField",
    components: {
        CdxLabel: $db68d79c4ce005fe$export$fd351ab562a06a13,
        CdxMessage: $db68d79c4ce005fe$export$cebd7a56cc7f747
    },
    props: {
        /**
     * Icon before the label text.
     *
     * Do not use this if including a start icon within the input component.
     */ labelIcon: {
            type: [
                String,
                Object
            ],
            default: ""
        },
        /**
     * Whether the field is optional.
     *
     * This will add a flag next to the label indicating that the field is optional.
     */ optional: {
            type: Boolean,
            default: false
        },
        // DEPRECATED: set default to '(optional)' (T368444).
        /**
     * Text to indicate that the field is optional.
     *
     * Omit this prop to use the default value, "(optional)".
     */ optionalFlag: {
            type: String,
            default: ""
        },
        /**
     * Whether the label should be visually hidden.
     *
     * Note that this will also hide the description.
     */ hideLabel: {
            type: Boolean,
            default: false
        },
        /**
     * Whether this field contains a group of inputs.
     *
     * When true, this outputs a `<fieldset>` element with a semantic `<legend>`. When false,
     * it outputs a `<div>` with a semantic `<label>`.
     */ isFieldset: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the entire field is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * `status` attribute of the input. This also determines which validation message is shown.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$6
        },
        /**
     * Message text keyed on validation status type.
     * @default {}
     */ messages: {
            type: Object,
            default: ()=>{
                return {};
            }
        }
    },
    setup (props, { slots: slots }) {
        const { disabled: disabled, status: status, isFieldset: isFieldset } = (0, $01W3b.toRefs)(props);
        const computedDisabled = $db68d79c4ce005fe$export$231a0ffa6150ca75(disabled);
        const rootClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-field--disabled": computedDisabled.value,
                "cdx-field--is-fieldset": isFieldset.value
            };
        });
        const labelId = $db68d79c4ce005fe$export$6217842283d27b52("label");
        const descriptionId = $db68d79c4ce005fe$export$6217842283d27b52("description");
        const inputId = $db68d79c4ce005fe$export$6217842283d27b52("input");
        const computedInputId = (0, $TusQn.computed)(()=>!isFieldset.value ? inputId : void 0);
        (0, $TusQn.provide)($db68d79c4ce005fe$var$FieldInputIdKey, computedInputId);
        const computedDescriptionId = (0, $TusQn.computed)(()=>!isFieldset.value && slots.description ? descriptionId : void 0);
        (0, $TusQn.provide)($db68d79c4ce005fe$var$FieldDescriptionIdKey, computedDescriptionId);
        (0, $TusQn.provide)($db68d79c4ce005fe$var$DisabledKey, computedDisabled);
        (0, $TusQn.provide)($db68d79c4ce005fe$var$FieldStatusKey, status);
        const validationMessage = (0, $TusQn.computed)(()=>props.status !== "default" && props.status in props.messages ? props.messages[props.status] : "");
        const validationMessageType = (0, $TusQn.computed)(()=>props.status === "default" ? "notice" : props.status);
        return {
            rootClasses: rootClasses,
            computedDisabled: computedDisabled,
            labelId: labelId,
            descriptionId: descriptionId,
            inputId: inputId,
            validationMessage: validationMessage,
            validationMessageType: validationMessageType
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$e = {
    class: "cdx-field__control"
};
const $db68d79c4ce005fe$var$_hoisted_2$8 = {
    class: "cdx-field__help-text"
};
const $db68d79c4ce005fe$var$_hoisted_3$5 = {
    key: 0,
    class: "cdx-field__validation-message"
};
function $db68d79c4ce005fe$var$_sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_label = (0, $TusQn.resolveComponent)("cdx-label");
    const _component_cdx_message = (0, $TusQn.resolveComponent)("cdx-message");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(_ctx.isFieldset ? "fieldset" : "div"), {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-field",
            _ctx.rootClasses
        ]),
        "aria-disabled": !_ctx.isFieldset && _ctx.computedDisabled ? true : void 0,
        disabled: _ctx.isFieldset && _ctx.computedDisabled ? true : void 0
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createVNode)(_component_cdx_label, {
                    id: _ctx.labelId,
                    icon: _ctx.labelIcon,
                    "visually-hidden": _ctx.hideLabel,
                    optional: _ctx.optional,
                    "optional-flag": _ctx.optionalFlag,
                    "input-id": _ctx.inputId,
                    "description-id": _ctx.descriptionId,
                    disabled: _ctx.computedDisabled,
                    "is-legend": _ctx.isFieldset
                }, (0, $TusQn.createSlots)({
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.renderSlot)(_ctx.$slots, "label")
                        ]),
                    _: 2
                }, [
                    _ctx.$slots.description && _ctx.$slots.description().length > 0 ? {
                        name: "description",
                        fn: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.renderSlot)(_ctx.$slots, "description")
                            ]),
                        key: "0"
                    } : void 0
                ]), 1032, [
                    "id",
                    "icon",
                    "visually-hidden",
                    "optional",
                    "optional-flag",
                    "input-id",
                    "description-id",
                    "disabled",
                    "is-legend"
                ]),
                (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$e, [
                    (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                ]),
                (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_2$8, [
                    (0, $TusQn.renderSlot)(_ctx.$slots, "help-text")
                ]),
                !_ctx.computedDisabled && _ctx.validationMessage ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_3$5, [
                    (0, $TusQn.createVNode)(_component_cdx_message, {
                        type: _ctx.validationMessageType,
                        inline: true
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.validationMessage), 1)
                            ]),
                        _: 1
                    }, 8, [
                        "type"
                    ])
                ])) : (0, $TusQn.createCommentVNode)("v-if", true)
            ]),
        _: 3
    }, 8, [
        "class",
        "aria-disabled",
        "disabled"
    ]);
}
const $db68d79c4ce005fe$export$efade408a7e046bf = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$g, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$g
    ]
]);
const $db68d79c4ce005fe$var$iconMap$1 = {
    error: $db68d79c4ce005fe$var$i4,
    warning: $db68d79c4ce005fe$var$M3,
    success: $db68d79c4ce005fe$var$O7
};
const $db68d79c4ce005fe$var$_sfc_main$f = (0, $TusQn.defineComponent)({
    name: "CdxInfoChip",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    props: {
        /**
     * Status type.
     *
     * @values 'notice', 'warning', 'error', 'success'
     */ status: {
            type: String,
            default: "notice",
            validator: $db68d79c4ce005fe$var$statusTypeValidator
        },
        /**
     * Custom icon to use for "notice" chips. Chips with other status types
     * (warning, etc) do not allow custom icons and will ignore this option.
     */ icon: {
            type: [
                String,
                Object
            ],
            default: null
        }
    },
    setup (props) {
        const iconClass = (0, $TusQn.computed)(()=>{
            return {
                ["cdx-info-chip__icon--".concat(props.status)]: true
            };
        });
        const computedIcon = (0, $TusQn.computed)(()=>props.status === "notice" ? props.icon : $db68d79c4ce005fe$var$iconMap$1[props.status]);
        return {
            iconClass: iconClass,
            computedIcon: computedIcon
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$d = {
    class: "cdx-info-chip"
};
const $db68d79c4ce005fe$var$_hoisted_2$7 = {
    class: "cdx-info-chip--text"
};
function $db68d79c4ce005fe$var$_sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_1$d, [
        _ctx.computedIcon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
            key: 0,
            class: (0, $8XWQX.normalizeClass)([
                "cdx-info-chip__icon",
                _ctx.iconClass
            ]),
            icon: _ctx.computedIcon
        }, null, 8, [
            "class",
            "icon"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2$7, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ])
    ]);
}
const $db68d79c4ce005fe$export$488fdba6da31f9c3 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$f, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$f
    ]
]);
const $db68d79c4ce005fe$var$statusValidator$5 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$e = (0, $TusQn.defineComponent)({
    name: "CdxLookup",
    components: {
        CdxMenu: $db68d79c4ce005fe$export$a33433a93a74f3ad,
        CdxTextInput: $db68d79c4ce005fe$export$edf7ede3ce8aed68
    },
    /**
   * We want the input to inherit attributes, not the root element.
   */ inheritAttrs: false,
    props: {
        /**
     * Value of the current selection.
     *
     * Must be bound with `v-model:selected`.
     *
     * The property should be initialized to `null` rather than using a falsy value.
     */ selected: {
            type: [
                String,
                Number,
                null
            ],
            required: true
        },
        /**
     * Menu items.
     */ menuItems: {
            type: Array,
            required: true
        },
        /**
     * Current value of the input. This prop is optional and should only be used if you need to
     * keep track of the input value for some reason (e.g. to set an initial value).
     *
     * Optionally provided by `v-model:input-value` binding in the parent component.
     */ inputValue: {
            type: [
                String,
                Number
            ],
            default: null
        },
        // DEPRECATED: Remove (T373532).
        /**
     * Initial value of the text input. Non-reactive.
     *
     * @deprecated Use `inputValue` instead.
     */ initialInputValue: {
            type: [
                String,
                Number
            ],
            default: "",
            validator: (value)=>{
                if (value) console.warn("CdxLookup: prop initialInputValue is deprecated. Use inputValue instead.");
                return true;
            }
        },
        /**
     * Whether the entire component is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Configuration for various menu features. All properties default to false.
     *
     * See the MenuConfig type.
     * @default {}
     */ menuConfig: {
            type: Object,
            default: ()=>{
                return {};
            }
        },
        /**
     * `status` property of the TextInput component
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$5
        }
    },
    emits: [
        /**
     * When the selected value changes.
     *
     * @property {string | number | null} selected The new selected value
     */ "update:selected",
        /**
     * When the input value changes. Only emitted if the inputValue prop is provided.
     *
     * @property {string | number} inputValue The new input value
     */ "update:input-value",
        /**
     * When the user scrolls towards the bottom of the menu.
     *
     * If it is possible to add or load more menu items, then now would be a good moment
     * so that the user can experience infinite scrolling.
     */ "load-more",
        /**
     * When the text input value changes.
     *
     * @property {string | number} value The new value
     */ "input",
        /**
     * When an input value change is committed by the user (e.g. on blur)
     *
     * @property {Event} event
     */ "change",
        /**
     * When the input comes into focus
     *
     * @property {FocusEvent} event
     */ "focus",
        /**
     * When the input loses focus
     *
     * @property {FocusEvent} event
     */ "blur"
    ],
    setup: (props, { emit: emit, attrs: attrs, slots: slots })=>{
        const rootElement = (0, $01W3b.ref)();
        const textInput = (0, $01W3b.ref)();
        const menu = (0, $01W3b.ref)();
        const menuId = $db68d79c4ce005fe$export$6217842283d27b52("lookup-menu");
        const pending = (0, $01W3b.ref)(false);
        const expanded = (0, $01W3b.ref)(false);
        const isActive = (0, $01W3b.ref)(false);
        const initialMenuItems = (0, $01W3b.ref)(props.menuItems);
        const { computedDisabled: computedDisabled, computedStatus: computedStatus } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"));
        const selectedProp = (0, $01W3b.toRef)(props, "selected");
        const modelWrapper = $db68d79c4ce005fe$export$c9be858be225e6de(selectedProp, emit, "update:selected");
        const selectedMenuItem = (0, $TusQn.computed)(()=>props.menuItems.find((item)=>item.value === props.selected));
        const highlightedId = (0, $TusQn.computed)(()=>{
            var _a, _b;
            return (_b = (_a = menu.value) == null ? void 0 : _a.getHighlightedMenuItem()) == null ? void 0 : _b.id;
        });
        const internalInputValue = (0, $01W3b.ref)(props.initialInputValue);
        const computedInputValue = $db68d79c4ce005fe$var$useOptionalModelWrapper(internalInputValue, (0, $01W3b.toRef)(props, "inputValue"), emit, "update:input-value");
        const internalClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-lookup--disabled": computedDisabled.value,
                "cdx-lookup--pending": pending.value
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        function onUpdateInput(newVal) {
            if (selectedMenuItem.value) {
                if (selectedMenuItem.value.label !== newVal && selectedMenuItem.value.value !== newVal) modelWrapper.value = null;
            } else if (props.selected !== null && props.selected !== newVal) modelWrapper.value = null;
            if (newVal === "" && initialMenuItems.value.length === 0) {
                expanded.value = false;
                pending.value = false;
            } else pending.value = true;
            emit("input", newVal);
        }
        function onInputFocus(event) {
            isActive.value = true;
            const hasInput = computedInputValue.value !== null && computedInputValue.value !== "";
            const hasMenuItems = !!(props.menuItems.length > 0 || slots["no-results"]);
            if (hasMenuItems && (hasInput || initialMenuItems.value.length > 0)) expanded.value = true;
            emit("focus", event);
        }
        function onInputBlur(event) {
            isActive.value = false;
            expanded.value = false;
            emit("blur", event);
        }
        function onKeydown(e) {
            if (!menu.value || computedDisabled.value || props.menuItems.length === 0 && !slots["no-results"] || e.key === " ") return;
            menu.value.delegateKeyNavigation(e);
        }
        $db68d79c4ce005fe$export$ebb1680baab55ef5(textInput, menu);
        (0, $TusQn.watch)(selectedProp, (newVal)=>{
            var _a;
            if (newVal !== null) {
                const selectedValue = selectedMenuItem.value ? (_a = selectedMenuItem.value.label) != null ? _a : selectedMenuItem.value.value : "";
                if (computedInputValue.value !== selectedValue) {
                    computedInputValue.value = selectedValue;
                    emit("input", computedInputValue.value);
                }
            }
        });
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "menuItems"), (newVal)=>{
            if (// Only show the menu if we were in the pending state (meaning this menuItems change
            // was in response to user input) and the menu is still focused
            isActive.value && pending.value && // Show the menu if there are either menu items or no-results content to show
            (newVal.length > 0 || slots["no-results"])) expanded.value = true;
            if (newVal.length === 0 && !slots["no-results"]) expanded.value = false;
            pending.value = false;
        });
        return {
            rootElement: rootElement,
            textInput: textInput,
            menu: menu,
            menuId: menuId,
            highlightedId: highlightedId,
            computedInputValue: computedInputValue,
            modelWrapper: modelWrapper,
            expanded: expanded,
            computedDisabled: computedDisabled,
            computedStatus: computedStatus,
            onInputBlur: onInputBlur,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            onUpdateInput: onUpdateInput,
            onInputFocus: onInputFocus,
            onKeydown: onKeydown
        };
    }
});
function $db68d79c4ce005fe$var$_sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_text_input = (0, $TusQn.resolveComponent)("cdx-text-input");
    const _component_cdx_menu = (0, $TusQn.resolveComponent)("cdx-menu");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        ref: "rootElement",
        class: (0, $8XWQX.normalizeClass)([
            "cdx-lookup",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createVNode)(_component_cdx_text_input, (0, $TusQn.mergeProps)({
            ref: "textInput",
            modelValue: _ctx.computedInputValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedInputValue = $event)
        }, _ctx.otherAttrs, {
            class: "cdx-lookup__input",
            role: "combobox",
            autocomplete: "off",
            "aria-autocomplete": "list",
            "aria-controls": _ctx.menuId,
            "aria-expanded": _ctx.expanded,
            "aria-activedescendant": _ctx.highlightedId,
            disabled: _ctx.computedDisabled,
            status: _ctx.computedStatus,
            "onUpdate:modelValue": _ctx.onUpdateInput,
            onChange: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("change", $event)),
            onFocus: _ctx.onInputFocus,
            onBlur: _ctx.onInputBlur,
            onKeydown: _ctx.onKeydown
        }), null, 16, [
            "modelValue",
            "aria-controls",
            "aria-expanded",
            "aria-activedescendant",
            "disabled",
            "status",
            "onUpdate:modelValue",
            "onFocus",
            "onBlur",
            "onKeydown"
        ]),
        (0, $TusQn.createVNode)(_component_cdx_menu, (0, $TusQn.mergeProps)({
            id: _ctx.menuId,
            ref: "menu",
            selected: _ctx.modelWrapper,
            "onUpdate:selected": _cache[2] || (_cache[2] = ($event)=>_ctx.modelWrapper = $event),
            expanded: _ctx.expanded,
            "onUpdate:expanded": _cache[3] || (_cache[3] = ($event)=>_ctx.expanded = $event),
            "menu-items": _ctx.menuItems
        }, _ctx.menuConfig, {
            onLoadMore: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("load-more"))
        }), {
            default: (0, $TusQn.withCtx)(({ menuItem: menuItem })=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "menu-item", {
                        menuItem: menuItem
                    })
                ]),
            "no-results": (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "no-results")
                ]),
            _: 3
        }, 16, [
            "id",
            "selected",
            "expanded",
            "menu-items"
        ])
    ], 6);
}
const $db68d79c4ce005fe$export$7e170b6706eda8a5 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$e, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$e
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$d = (0, $TusQn.defineComponent)({
    name: "CdxToggleButton",
    props: {
        /**
     * Whether the button should be set to "on" (true) or "off" (false).
     *
     * Provided by `v-model` binding in the parent component.
     */ modelValue: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the disabled attribute should be added to the button, which prevents
     * it from being clicked.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the toggle button should be "quiet", which renders more minimally.
     */ quiet: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * Emitted when modelValue changes (i.e. when the state is toggled)
     *
     * @property {boolean} modelValue The new model value
     */ "update:modelValue"
    ],
    setup (props, { emit: emit, slots: slots, attrs: attrs }) {
        const isIconOnly = $db68d79c4ce005fe$var$useIconOnlyButton(slots.default, attrs, "CdxToggleButton");
        const isActive = (0, $01W3b.ref)(false);
        const rootClasses = (0, $TusQn.computed)(()=>({
                // Quiet means frameless among other things
                "cdx-toggle-button--quiet": props.quiet,
                "cdx-toggle-button--framed": !props.quiet,
                // Provide --toggled-off too so that we can simplify selectors
                "cdx-toggle-button--toggled-on": props.modelValue,
                "cdx-toggle-button--toggled-off": !props.modelValue,
                "cdx-toggle-button--icon-only": isIconOnly.value,
                "cdx-toggle-button--is-active": isActive.value
            }));
        const onClick = ()=>{
            emit("update:modelValue", !props.modelValue);
        };
        const setActive = (active)=>{
            isActive.value = active;
        };
        function onKeyDown() {
            setActive(true);
        }
        function onKeyUp() {
            setActive(false);
            onClick();
        }
        return {
            rootClasses: rootClasses,
            onClick: onClick,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$c = [
    "aria-pressed",
    "disabled"
];
function $db68d79c4ce005fe$var$_sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-toggle-button",
            _ctx.rootClasses
        ]),
        "aria-pressed": _ctx.modelValue,
        disabled: _ctx.disabled,
        onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.onClick && _ctx.onClick(...args)),
        onKeydown: _cache[1] || (_cache[1] = (0, $eeJ70.withKeys)((0, $eeJ70.withModifiers)((...args)=>_ctx.onKeyDown && _ctx.onKeyDown(...args), [
            "prevent"
        ]), [
            "space",
            "enter"
        ])),
        onKeyup: _cache[2] || (_cache[2] = (0, $eeJ70.withKeys)((...args)=>_ctx.onKeyUp && _ctx.onKeyUp(...args), [
            "space",
            "enter"
        ]))
    }, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
    ], 42, $db68d79c4ce005fe$var$_hoisted_1$c);
}
const $db68d79c4ce005fe$export$e302ca96e16828af = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$d, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$d
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$c = (0, $TusQn.defineComponent)({
    name: "CdxMenuButton",
    components: {
        CdxToggleButton: $db68d79c4ce005fe$export$e302ca96e16828af,
        CdxMenu: $db68d79c4ce005fe$export$a33433a93a74f3ad
    },
    inheritAttrs: false,
    props: {
        /**
     * Value of the current selection.
     *
     * Must be bound with `v-model:selected`.
     */ selected: {
            type: [
                String,
                Number,
                null
            ],
            required: true
        },
        /**
     * Menu items. See the MenuItemData type.
     */ menuItems: {
            type: Array,
            required: true
        },
        /**
     * Configuration for various menu features. All properties default to false.
     *
     * See the MenuConfig type.
     * @default {}
     */ menuConfig: {
            type: Object,
            default: ()=>{
                return {};
            }
        },
        /**
     * Whether the dropdown is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * When the selected value changes.
     *
     * @property {string | number} selected The new selected value
     */ "update:selected"
    ],
    setup (props, { emit: emit, attrs: attrs }) {
        const menu = (0, $01W3b.ref)();
        const toggle = (0, $01W3b.ref)();
        const selectedProp = (0, $01W3b.toRef)(props, "selected");
        const modelWrapper = $db68d79c4ce005fe$export$c9be858be225e6de(selectedProp, emit, "update:selected");
        const expanded = (0, $01W3b.ref)(false);
        const toggleId = $db68d79c4ce005fe$export$6217842283d27b52("menuToggle");
        const menuId = $db68d79c4ce005fe$export$6217842283d27b52("menu");
        const { computedDisabled: computedDisabled } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"));
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs);
        function onKeydown(e) {
            if (!menu.value || computedDisabled.value || props.menuItems.length === 0 || e.key === " ") return;
            menu.value.delegateKeyNavigation(e);
        }
        $db68d79c4ce005fe$export$ebb1680baab55ef5(toggle, menu, {
            useAvailableWidth: true,
            placement: "bottom-start",
            offset: 4
        });
        return {
            computedDisabled: computedDisabled,
            expanded: expanded,
            menu: menu,
            menuId: menuId,
            modelWrapper: modelWrapper,
            onKeydown: onKeydown,
            toggle: toggle,
            toggleId: toggleId,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$b = {
    class: "cdx-menu-button__menu-wrapper"
};
function $db68d79c4ce005fe$var$_sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_toggle_button = (0, $TusQn.resolveComponent)("cdx-toggle-button");
    const _component_cdx_menu = (0, $TusQn.resolveComponent)("cdx-menu");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-menu-button",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createVNode)(_component_cdx_toggle_button, (0, $TusQn.mergeProps)({
            id: _ctx.toggleId,
            ref: "toggle"
        }, _ctx.otherAttrs, {
            modelValue: _ctx.expanded,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.expanded = $event),
            disabled: _ctx.computedDisabled,
            quiet: "",
            "aria-haspopup": "menu",
            "aria-controls": _ctx.menuId,
            "aria-expanded": _ctx.expanded,
            onBlur: _cache[1] || (_cache[1] = ($event)=>_ctx.expanded = false),
            onKeydown: _ctx.onKeydown
        }), {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                ]),
            _: 3
        }, 16, [
            "id",
            "modelValue",
            "disabled",
            "aria-controls",
            "aria-expanded",
            "onKeydown"
        ]),
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$b, [
            (0, $TusQn.createVNode)(_component_cdx_menu, (0, $TusQn.mergeProps)({
                id: _ctx.menuId,
                ref: "menu",
                selected: _ctx.modelWrapper,
                "onUpdate:selected": _cache[2] || (_cache[2] = ($event)=>_ctx.modelWrapper = $event),
                expanded: _ctx.expanded,
                "onUpdate:expanded": _cache[3] || (_cache[3] = ($event)=>_ctx.expanded = $event),
                "menu-items": _ctx.menuItems
            }, _ctx.menuConfig, {
                role: "menu",
                "aria-labelledby": _ctx.toggleId
            }), null, 16, [
                "id",
                "selected",
                "expanded",
                "menu-items",
                "aria-labelledby"
            ])
        ])
    ], 6);
}
const $db68d79c4ce005fe$export$89add103f07d42fd = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$c, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$c
    ]
]);
const $db68d79c4ce005fe$var$statusValidator$4 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$b = (0, $TusQn.defineComponent)({
    name: "CdxMultiselectLookup",
    components: {
        CdxChipInput: $db68d79c4ce005fe$export$942cd80f467f680f,
        CdxMenu: $db68d79c4ce005fe$export$a33433a93a74f3ad
    },
    props: {
        /**
     * Current chips present in the input.
     *
     * Must be bound with `v-model:input-chips`. Initialize to an empty array if there are no
     * initial selections. If there are, initialize to an array of input chips matching those
     * selections.
     */ inputChips: {
            type: Array,
            required: true
        },
        /**
     * Value(s) of the current selection(s).
     *
     * Must be bound with `v-model:selected`. Initialize to an empty array if there are no
     * initial selections.
     */ selected: {
            type: [
                Array
            ],
            required: true
        },
        /**
     * Menu items.
     *
     * Initialize to an empty array if there are no initial menu items.
     */ menuItems: {
            type: Array,
            required: true
        },
        /**
     * Current value of the text input. This prop is optional and should only be used if you
     * need to keep track of the text input value for some reason (e.g. for validation).
     *
     * Optionally provided by `v-model:input-value` binding in the parent component.
     */ inputValue: {
            type: [
                String,
                Number
            ],
            default: null
        },
        /**
     * Whether the text input should appear below the set of input chips.
     *
     * By default, the input chips are inline with the input.
     */ separateInput: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the entire component is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * `status` attribute of the input.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$4
        },
        /**
     * Configuration for various menu features. All properties default to false.
     *
     * See the MenuConfig type.
     * @default {}
     */ menuConfig: {
            type: Object,
            default: ()=>{
                return {};
            }
        }
    },
    emits: [
        /**
     * When the input chips change.
     *
     * @property {ChipInputItem[]} inputChips The new set of inputChips
     */ "update:input-chips",
        /**
     * When the selected value changes.
     *
     * @property {MenuItemValue[]} selected The new set of selected values
     */ "update:selected",
        /**
     * When the input value changes. Only emitted if the inputValue prop is provided.
     *
     * This event is emitted both when the user changes the input and when the input is changed
     * or cleared automatically (e.g. on selection).
     *
     * @property {string | number} inputValue The new input value
     */ "update:input-value",
        /**
     * When the user scrolls towards the bottom of the menu.
     *
     * If it is possible to add or load more menu items, then now would be a good moment
     * so that the user can experience infinite scrolling.
     */ "load-more",
        /**
     * When the user changes the value of the input. Not emitted when the input is changed
     * automatically (e.g. on selection).
     *
     * @property {string | number} value The new value
     */ "input",
        /**
     * When an input value change is committed by the user (e.g. on blur)
     *
     * @property {Event} event
     */ "change",
        /**
     * When the input comes into focus
     *
     * @property {FocusEvent} event
     */ "focus",
        /**
     * When the input loses focus
     *
     * @property {FocusEvent} event
     */ "blur"
    ],
    setup: (props, { emit: emit, attrs: attrs, slots: slots })=>{
        const chipInput = (0, $01W3b.ref)();
        const menu = (0, $01W3b.ref)();
        const menuId = $db68d79c4ce005fe$export$6217842283d27b52("multiselect-lookup-menu");
        const highlightedId = (0, $TusQn.computed)(()=>{
            var _a, _b;
            return (_b = (_a = menu.value) == null ? void 0 : _a.getHighlightedMenuItem()) == null ? void 0 : _b.id;
        });
        const pending = (0, $01W3b.ref)(false);
        const expanded = (0, $01W3b.ref)(false);
        const isActive = (0, $01W3b.ref)(false);
        (0, $TusQn.provide)($db68d79c4ce005fe$var$AllowArbitraryKey, (0, $01W3b.ref)(false));
        const { computedDisabled: computedDisabled, computedStatus: computedStatus } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"));
        const internalClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-multiselect-lookup--disabled": computedDisabled.value,
                "cdx-multiselect-lookup--pending": pending.value
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        $db68d79c4ce005fe$export$ebb1680baab55ef5(chipInput, menu);
        const selectedWrapper = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "selected"), emit, "update:selected");
        const inputChipsWrapper = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "inputChips"), emit, "update:input-chips");
        const internalInputValue = (0, $01W3b.ref)("");
        const computedInputValue = $db68d79c4ce005fe$var$useOptionalModelWrapper(internalInputValue, (0, $01W3b.toRef)(props, "inputValue"), emit, "update:input-value");
        const showNoResults = (0, $TusQn.computed)(()=>computedInputValue.value.toString().length > 0 && slots["no-results"]);
        function onUpdateInputValue(newVal) {
            return $db68d79c4ce005fe$var$__async(this, null, function*() {
                yield (0, $TusQn.nextTick)();
                pending.value = newVal !== null && newVal !== "";
                emit("input", newVal);
            });
        }
        function onInputFocus(event) {
            isActive.value = true;
            if (props.menuItems.length > 0 || showNoResults.value) expanded.value = true;
            emit("focus", event);
        }
        function onInputBlur(event) {
            isActive.value = false;
            expanded.value = false;
            emit("blur", event);
        }
        function onKeydown(e) {
            if (!menu.value || computedDisabled.value || props.menuItems.length === 0 && !showNoResults.value || e.key === " ") return;
            menu.value.delegateKeyNavigation(e);
        }
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "selected"), (newVal)=>{
            const newSelections = newVal.filter((selection)=>inputChipsWrapper.value.find((chip)=>selection === chip.value) === void 0);
            if (newSelections.length > 0) {
                newSelections.forEach((newSelection)=>{
                    const newMenuItem = props.menuItems.find((menuItem)=>menuItem.value === newSelection);
                    if (newMenuItem) inputChipsWrapper.value.push(newMenuItem);
                });
                computedInputValue.value = "";
                emit("input", "");
            }
            inputChipsWrapper.value = inputChipsWrapper.value.filter((chip)=>{
                return newVal.find((selection)=>chip.value === selection) !== void 0;
            });
        });
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "inputChips"), (newVal)=>{
            if (newVal.length < selectedWrapper.value.length) selectedWrapper.value = newVal.map((chip)=>chip.value);
        });
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "menuItems"), (newVal)=>{
            if (newVal.length === 0 && !showNoResults.value) expanded.value = false;
            else if (isActive.value && pending.value) expanded.value = true;
            pending.value = false;
        });
        return {
            chipInput: chipInput,
            menu: menu,
            menuId: menuId,
            highlightedId: highlightedId,
            expanded: expanded,
            computedDisabled: computedDisabled,
            computedStatus: computedStatus,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            selectedWrapper: selectedWrapper,
            inputChipsWrapper: inputChipsWrapper,
            computedInputValue: computedInputValue,
            onUpdateInputValue: onUpdateInputValue,
            onInputBlur: onInputBlur,
            onInputFocus: onInputFocus,
            onKeydown: onKeydown
        };
    }
});
function $db68d79c4ce005fe$var$_sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_chip_input = (0, $TusQn.resolveComponent)("cdx-chip-input");
    const _component_cdx_menu = (0, $TusQn.resolveComponent)("cdx-menu");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-multiselect-lookup",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createVNode)(_component_cdx_chip_input, (0, $TusQn.mergeProps)({
            ref: "chipInput",
            "input-chips": _ctx.inputChipsWrapper,
            "onUpdate:inputChips": _cache[0] || (_cache[0] = ($event)=>_ctx.inputChipsWrapper = $event),
            "input-value": _ctx.computedInputValue,
            "onUpdate:inputValue": _cache[1] || (_cache[1] = ($event)=>_ctx.computedInputValue = $event)
        }, _ctx.otherAttrs, {
            class: "cdx-multiselect-lookup__chip-input",
            role: "combobox",
            autocomplete: "off",
            "aria-autocomplete": "list",
            "aria-controls": _ctx.menuId,
            "aria-expanded": _ctx.expanded,
            "aria-activedescendant": _ctx.highlightedId,
            "separate-input": _ctx.separateInput,
            disabled: _ctx.computedDisabled,
            status: _ctx.computedStatus,
            "disallow-arbitrary": true,
            "onUpdate:inputValue": _ctx.onUpdateInputValue,
            onFocus: _ctx.onInputFocus,
            onBlur: _ctx.onInputBlur,
            onKeydown: _ctx.onKeydown
        }), null, 16, [
            "input-chips",
            "input-value",
            "aria-controls",
            "aria-expanded",
            "aria-activedescendant",
            "separate-input",
            "disabled",
            "status",
            "onUpdate:inputValue",
            "onFocus",
            "onBlur",
            "onKeydown"
        ]),
        (0, $TusQn.createVNode)(_component_cdx_menu, (0, $TusQn.mergeProps)({
            id: _ctx.menuId,
            ref: "menu",
            selected: _ctx.selectedWrapper,
            "onUpdate:selected": _cache[2] || (_cache[2] = ($event)=>_ctx.selectedWrapper = $event),
            expanded: _ctx.expanded,
            "onUpdate:expanded": _cache[3] || (_cache[3] = ($event)=>_ctx.expanded = $event),
            "menu-items": _ctx.menuItems
        }, _ctx.menuConfig, {
            onLoadMore: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("load-more"))
        }), {
            default: (0, $TusQn.withCtx)(({ menuItem: menuItem })=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "menu-item", {
                        menuItem: menuItem
                    })
                ]),
            "no-results": (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "no-results")
                ]),
            _: 3
        }, 16, [
            "id",
            "selected",
            "expanded",
            "menu-items"
        ])
    ], 6);
}
const $db68d79c4ce005fe$export$c989905f222b55d0 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$b, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$b
    ]
]);
const $db68d79c4ce005fe$var$statusValidator$3 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$a = (0, $TusQn.defineComponent)({
    name: "CdxRadio",
    components: {
        CdxLabel: $db68d79c4ce005fe$export$fd351ab562a06a13
    },
    props: {
        /**
     * Value of the currently selected radio.
     *
     * Provided by `v-model` binding in the parent component.
     */ modelValue: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: ""
        },
        /**
     * HTML "value" attribute to assign to the input.
     *
     * Required for input groups.
     */ inputValue: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: false
        },
        /**
     * HTML "name" attribute to assign to the input.
     */ name: {
            type: String,
            required: true
        },
        /**
     * Whether the disabled attribute should be added to the input.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the component should display inline.
     *
     * By default, `display: block` is set and a margin exists between
     * sibling components, for a stacked layout.
     */ inline: {
            type: Boolean,
            default: false
        },
        /**
     * Validation status of the Radio.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$3
        }
    },
    emits: [
        /**
     * Emitted when modelValue changes.
     *
     * @property {string | number | boolean} modelValue The new model value
     */ "update:modelValue"
    ],
    setup (props, { emit: emit, slots: slots, attrs: attrs }) {
        var _a;
        $db68d79c4ce005fe$var$useLabelChecker((_a = slots.default) == null ? void 0 : _a.call(slots), attrs, "CdxRadio");
        const { computedDisabled: computedDisabled, computedStatus: computedStatus } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"));
        const rootClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-radio--inline": props.inline,
                ["cdx-radio--status-".concat(computedStatus.value)]: true
            };
        });
        const customInputClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-radio__custom-input--inline": props.inline
            };
        });
        const input = (0, $01W3b.ref)();
        const radioId = $db68d79c4ce005fe$export$6217842283d27b52("radio");
        const descriptionId = $db68d79c4ce005fe$export$6217842283d27b52("description");
        const focusInput = ()=>{
            input.value.focus();
        };
        const wrappedModel = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "modelValue"), emit);
        return {
            rootClasses: rootClasses,
            computedDisabled: computedDisabled,
            input: input,
            radioId: radioId,
            descriptionId: descriptionId,
            focusInput: focusInput,
            wrappedModel: wrappedModel,
            customInputClasses: customInputClasses
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$a = {
    class: "cdx-radio__wrapper"
};
const $db68d79c4ce005fe$var$_hoisted_2$6 = [
    "id",
    "aria-describedby",
    "name",
    "value",
    "disabled"
];
const $db68d79c4ce005fe$var$_hoisted_3$4 = /* @__PURE__ */ (0, $TusQn.createElementVNode)("span", {
    class: "cdx-radio__icon"
}, null, -1);
function $db68d79c4ce005fe$var$_sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_label = (0, $TusQn.resolveComponent)("cdx-label");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-radio",
            _ctx.rootClasses
        ])
    }, [
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$a, [
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                id: _ctx.radioId,
                ref: "input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.wrappedModel = $event),
                class: "cdx-radio__input",
                type: "radio",
                "aria-describedby": _ctx.$slots.description && _ctx.$slots.description().length > 0 ? _ctx.descriptionId : void 0,
                name: _ctx.name,
                value: _ctx.inputValue,
                disabled: _ctx.computedDisabled
            }, null, 8, $db68d79c4ce005fe$var$_hoisted_2$6), [
                [
                    (0, $eeJ70.vModelRadio),
                    _ctx.wrappedModel
                ]
            ]),
            $db68d79c4ce005fe$var$_hoisted_3$4,
            _ctx.$slots.default && _ctx.$slots.default().length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_label, {
                key: 0,
                class: "cdx-radio__label",
                "input-id": _ctx.radioId,
                "description-id": _ctx.$slots.description && _ctx.$slots.description().length > 0 ? _ctx.descriptionId : void 0,
                disabled: _ctx.computedDisabled,
                onClick: _ctx.focusInput
            }, (0, $TusQn.createSlots)({
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                    ]),
                _: 2
            }, [
                _ctx.$slots.description && _ctx.$slots.description().length > 0 ? {
                    name: "description",
                    fn: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.renderSlot)(_ctx.$slots, "description")
                        ]),
                    key: "0"
                } : void 0
            ]), 1032, [
                "input-id",
                "description-id",
                "disabled",
                "onClick"
            ])) : (0, $TusQn.createCommentVNode)("v-if", true)
        ]),
        _ctx.$slots["custom-input"] ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
            key: 0,
            class: (0, $8XWQX.normalizeClass)([
                "cdx-radio__custom-input",
                _ctx.customInputClasses
            ])
        }, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "custom-input")
        ], 2)) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 2);
}
const $db68d79c4ce005fe$export$27f3c4ce4bd91ba9 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$a, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$a
    ]
]);
const $db68d79c4ce005fe$var$statusValidator$2 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$9 = (0, $TusQn.defineComponent)({
    name: "CdxSearchInput",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxTextInput: $db68d79c4ce005fe$export$edf7ede3ce8aed68
    },
    /**
   * Attributes, besides class, will be passed to the TextInput's input element.
   */ inheritAttrs: false,
    props: {
        /**
     * Value of the search input, provided by `v-model` binding in the parent component.
     */ modelValue: {
            type: [
                String,
                Number
            ],
            default: ""
        },
        /**
     *
     * Whether to display the search button.
     */ useButton: {
            type: Boolean,
            default: false
        },
        // DEPRECATED: set default to 'Search' (T368444).
        /**
     * Search button text.
     *
     * Omit this prop to use the default value, "Search".
     */ buttonLabel: {
            type: String,
            default: ""
        },
        /**
     * Whether the search input is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * `status` property of the TextInput component
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$2
        }
    },
    emits: [
        /**
     * When the input value changes
     *
     * @property {string | number} value The new value
     */ "update:modelValue",
        /**
     * When the submit button is clicked.
     *
     * @property {string | number} value The current input
     */ "submit-click",
        /**
     * When the input value changes via direct use of the input
     *
     * @property {InputEvent} event
     */ "input",
        /**
     * When an input value change is committed by the user (e.g. on blur)
     *
     * @property {Event} event
     */ "change",
        /**
     * When the input comes into focus
     *
     * @property {FocusEvent} event
     */ "focus",
        /**
     * When the input loses focus
     *
     * @property {FocusEvent} event
     */ "blur"
    ],
    setup (props, { emit: emit, attrs: attrs }) {
        const wrappedModel = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "modelValue"), emit);
        const { computedDisabled: computedDisabled } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"));
        const internalClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-search-input--has-end-button": !!props.buttonLabel || props.useButton
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        const translatedSearchButtonLabel = $db68d79c4ce005fe$var$useI18nWithOverride((0, $01W3b.toRef)(props, "buttonLabel"), "cdx-search-input-search-button-label", // Allow custom button label via props or fallback to a default English string.
        "Search");
        const useButtonOrLabel = (0, $TusQn.computed)(()=>props.useButton || props.buttonLabel.length > 0);
        const handleSubmit = ()=>{
            emit("submit-click", wrappedModel.value);
        };
        return {
            wrappedModel: wrappedModel,
            computedDisabled: computedDisabled,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            handleSubmit: handleSubmit,
            searchIcon: $db68d79c4ce005fe$var$A7,
            translatedSearchButtonLabel: translatedSearchButtonLabel,
            useButtonOrLabel: useButtonOrLabel
        };
    },
    methods: {
        /**
     * Focus the component's input element.
     *
     * @public
     */ focus () {
            const textInput = this.$refs.textInput;
            textInput.focus();
        }
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$9 = {
    class: "cdx-search-input__input-wrapper"
};
function $db68d79c4ce005fe$var$_sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_text_input = (0, $TusQn.resolveComponent)("cdx-text-input");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-search-input",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$9, [
            (0, $TusQn.createVNode)(_component_cdx_text_input, (0, $TusQn.mergeProps)({
                ref: "textInput",
                modelValue: _ctx.wrappedModel,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.wrappedModel = $event),
                class: "cdx-search-input__text-input",
                "input-type": "search",
                "start-icon": _ctx.searchIcon,
                disabled: _ctx.computedDisabled,
                status: _ctx.status
            }, _ctx.otherAttrs, {
                onKeydown: (0, $eeJ70.withKeys)(_ctx.handleSubmit, [
                    "enter"
                ]),
                onInput: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("input", $event)),
                onChange: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("change", $event)),
                onFocus: _cache[3] || (_cache[3] = ($event)=>_ctx.$emit("focus", $event)),
                onBlur: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("blur", $event))
            }), null, 16, [
                "modelValue",
                "start-icon",
                "disabled",
                "status",
                "onKeydown"
            ]),
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ]),
        _ctx.useButtonOrLabel ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_button, {
            key: 0,
            class: "cdx-search-input__end-button",
            disabled: _ctx.computedDisabled,
            onClick: _ctx.handleSubmit
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.translatedSearchButtonLabel), 1)
                ]),
            _: 1
        }, 8, [
            "disabled",
            "onClick"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 6);
}
const $db68d79c4ce005fe$export$4d07ca0116afbc71 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$9, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$9
    ]
]);
const $db68d79c4ce005fe$var$statusValidator$1 = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$8 = (0, $TusQn.defineComponent)({
    name: "CdxSelect",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxMenu: $db68d79c4ce005fe$export$a33433a93a74f3ad
    },
    /**
   * We want the select handle to inherit attributes, not the root element.
   */ inheritAttrs: false,
    props: {
        /**
     * Menu items. See the MenuItemData type.
     */ menuItems: {
            type: Array,
            required: true
        },
        /**
     * Value of the current selection.
     *
     * Must be bound with `v-model:selected`.
     *
     * The property should be initialized to `null` rather than using a falsy value.
     */ selected: {
            type: [
                String,
                Number,
                null
            ],
            required: true
        },
        /**
     * Label to display when no selection has been made.
     */ defaultLabel: {
            type: String,
            default: ""
        },
        /**
     * Whether the dropdown is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Configuration for various menu features. All properties default to false.
     *
     * See the MenuConfig type.
     * @default {}
     */ menuConfig: {
            type: Object,
            default: ()=>{
                return {};
            }
        },
        /**
     * An icon at the start of the select element
     * displayed when no selection has been made.
     */ defaultIcon: {
            type: [
                String,
                Object
            ],
            default: void 0
        },
        /**
     * `status` attribute of the input.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator$1
        }
    },
    emits: [
        /**
     * When the selection value changes.
     *
     * @property {string | number | null} modelValue The new model value
     */ "update:selected",
        /**
     * When the user scrolls towards the bottom of the menu.
     *
     * If it is possible to add or load more menu items, then now would be a good moment
     * so that the user can experience infinite scrolling.
     */ "load-more"
    ],
    setup (props, { emit: emit, attrs: attrs }) {
        const handle = (0, $01W3b.ref)();
        const menu = (0, $01W3b.ref)();
        const descriptionId = (0, $TusQn.inject)($db68d79c4ce005fe$var$FieldDescriptionIdKey, void 0);
        const menuId = $db68d79c4ce005fe$export$6217842283d27b52("select-menu");
        const expanded = (0, $01W3b.ref)(false);
        const handleId = attrs.id || $db68d79c4ce005fe$export$6217842283d27b52("select-handle");
        const { computedDisabled: computedDisabled, computedStatus: computedStatus, computedInputId: computedHandleId } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"), handleId);
        const modelWrapper = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "selected"), emit, "update:selected");
        const selectedMenuItem = (0, $TusQn.computed)(()=>props.menuItems.find((menuItem)=>menuItem.value === props.selected));
        const currentLabel = (0, $TusQn.computed)(()=>{
            var _a;
            return selectedMenuItem.value ? (_a = selectedMenuItem.value.label) != null ? _a : selectedMenuItem.value.value : props.defaultLabel;
        });
        const startIcon = (0, $TusQn.computed)(()=>{
            var _a;
            if (props.defaultIcon && !selectedMenuItem.value) return props.defaultIcon;
            else if ((_a = selectedMenuItem.value) == null ? void 0 : _a.icon) return selectedMenuItem.value.icon;
            return void 0;
        });
        const internalClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-select-vue--enabled": !computedDisabled.value,
                "cdx-select-vue--disabled": computedDisabled.value,
                "cdx-select-vue--expanded": expanded.value,
                "cdx-select-vue--value-selected": !!selectedMenuItem.value,
                "cdx-select-vue--no-selections": !selectedMenuItem.value,
                "cdx-select-vue--has-start-icon": !!startIcon.value,
                ["cdx-select-vue--status-".concat(computedStatus.value)]: true
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        const otherAttrsMinusId = (0, $TusQn.computed)(()=>{
            const _a = otherAttrs.value, { id: id } = _a, everythingElse = $db68d79c4ce005fe$var$__objRest(_a, [
                "id"
            ]);
            return everythingElse;
        });
        const highlightedId = (0, $TusQn.computed)(()=>{
            var _a, _b;
            return (_b = (_a = menu.value) == null ? void 0 : _a.getHighlightedMenuItem()) == null ? void 0 : _b.id;
        });
        function onBlur() {
            expanded.value = false;
        }
        function onClick() {
            var _a;
            if (computedDisabled.value) return;
            expanded.value = !expanded.value;
            (_a = handle.value) == null || _a.focus();
        }
        function onKeydown(e) {
            var _a;
            if (computedDisabled.value) return;
            (_a = menu.value) == null || _a.delegateKeyNavigation(e, {
                characterNavigation: true
            });
        }
        $db68d79c4ce005fe$export$ebb1680baab55ef5(handle, menu);
        return {
            handle: handle,
            menu: menu,
            computedHandleId: computedHandleId,
            descriptionId: descriptionId,
            menuId: menuId,
            modelWrapper: modelWrapper,
            selectedMenuItem: selectedMenuItem,
            highlightedId: highlightedId,
            expanded: expanded,
            computedDisabled: computedDisabled,
            onBlur: onBlur,
            currentLabel: currentLabel,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrsMinusId: otherAttrsMinusId,
            onClick: onClick,
            onKeydown: onKeydown,
            startIcon: startIcon,
            cdxIconExpand: $db68d79c4ce005fe$var$m4
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$8 = [
    "aria-disabled"
];
const $db68d79c4ce005fe$var$_hoisted_2$5 = [
    "id",
    "aria-controls",
    "aria-activedescendant",
    "aria-expanded",
    "aria-describedby"
];
function $db68d79c4ce005fe$var$_sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_menu = (0, $TusQn.resolveComponent)("cdx-menu");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-select-vue",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle),
        "aria-disabled": _ctx.computedDisabled
    }, [
        (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
            id: _ctx.computedHandleId,
            ref: "handle",
            class: "cdx-select-vue__handle"
        }, _ctx.otherAttrsMinusId, {
            tabindex: "0",
            role: "combobox",
            "aria-controls": _ctx.menuId,
            "aria-activedescendant": _ctx.highlightedId,
            "aria-expanded": _ctx.expanded,
            "aria-describedby": _ctx.descriptionId,
            onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.onClick && _ctx.onClick(...args)),
            onBlur: _cache[1] || (_cache[1] = (...args)=>_ctx.onBlur && _ctx.onBlur(...args)),
            onKeydown: _cache[2] || (_cache[2] = (...args)=>_ctx.onKeydown && _ctx.onKeydown(...args))
        }), [
            (0, $TusQn.renderSlot)(_ctx.$slots, "label", {
                selectedMenuItem: _ctx.selectedMenuItem,
                defaultLabel: _ctx.defaultLabel
            }, ()=>[
                    (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.currentLabel), 1)
                ]),
            _ctx.startIcon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                key: 0,
                icon: _ctx.startIcon,
                class: "cdx-select-vue__start-icon"
            }, null, 8, [
                "icon"
            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
            (0, $TusQn.createVNode)(_component_cdx_icon, {
                icon: _ctx.cdxIconExpand,
                class: "cdx-select-vue__indicator"
            }, null, 8, [
                "icon"
            ])
        ], 16, $db68d79c4ce005fe$var$_hoisted_2$5),
        (0, $TusQn.createVNode)(_component_cdx_menu, (0, $TusQn.mergeProps)({
            id: _ctx.menuId,
            ref: "menu",
            selected: _ctx.modelWrapper,
            "onUpdate:selected": _cache[3] || (_cache[3] = ($event)=>_ctx.modelWrapper = $event),
            expanded: _ctx.expanded,
            "onUpdate:expanded": _cache[4] || (_cache[4] = ($event)=>_ctx.expanded = $event),
            "menu-items": _ctx.menuItems
        }, _ctx.menuConfig, {
            onLoadMore: _cache[5] || (_cache[5] = ($event)=>_ctx.$emit("load-more"))
        }), {
            default: (0, $TusQn.withCtx)(({ menuItem: menuItem })=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "menu-item", {
                        menuItem: menuItem
                    })
                ]),
            _: 3
        }, 16, [
            "id",
            "selected",
            "expanded",
            "menu-items"
        ])
    ], 14, $db68d79c4ce005fe$var$_hoisted_1$8);
}
const $db68d79c4ce005fe$export$fd5153ff27ffff7b = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$8, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$8
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$7 = (0, $TusQn.defineComponent)({
    name: "CdxTablePager",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxSelect: $db68d79c4ce005fe$export$fd5153ff27ffff7b
    },
    props: {
        paginationSizeOptions: {
            type: Array,
            required: true
        },
        itemsPerPage: {
            type: Number,
            required: true
        },
        nextDisabled: {
            type: Boolean,
            default: false
        },
        prevDisabled: {
            type: Boolean,
            default: false
        },
        lastDisabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * When the items per page option changes
     *
     * @property {number} itemsPerPage the number of items to display
     */ "update:itemsPerPage",
        /**
     * Emitted when the user requests the first page of data
     */ "first",
        /**
     * Emitted when the user requests the last page of data
     */ "last",
        /**
     * Emitted when the user requests the next page of data
     */ "next",
        /**
     * Emitted when the user requests the previous page of data
     */ "prev"
    ],
    setup (props, { emit: emit }) {
        const wrappedItemsPerPage = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "itemsPerPage"), emit, "update:itemsPerPage");
        const defaultItemsPerPageLabel = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pager-items-per-page-default", "Results per page");
        const currentItemsPerPageLabel = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pager-items-per-page-current", (current)=>"".concat(current, " rows"), [
            wrappedItemsPerPage
        ]);
        const btnLabelFirst = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pager-button-first-page", "First page");
        const btnLabelNext = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pager-button-next-page", "Next page");
        const btnLabelPrev = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pager-button-prev-page", "Previous page");
        const btnLabelLast = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pager-button-last-page", "Last page");
        return {
            defaultItemsPerPageLabel: defaultItemsPerPageLabel,
            currentItemsPerPageLabel: currentItemsPerPageLabel,
            btnLabelFirst: btnLabelFirst,
            btnLabelNext: btnLabelNext,
            btnLabelPrev: btnLabelPrev,
            btnLabelLast: btnLabelLast,
            wrappedItemsPerPage: wrappedItemsPerPage,
            cdxIconPrevious: $db68d79c4ce005fe$var$d7,
            cdxIconNext: $db68d79c4ce005fe$var$j6,
            cdxIconMoveFirst: $db68d79c4ce005fe$var$P6,
            cdxIconMoveLast: $db68d79c4ce005fe$var$N6
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$7 = {
    class: "cdx-table-pager"
};
const $db68d79c4ce005fe$var$_hoisted_2$4 = {
    class: "cdx-table-pager__start"
};
const $db68d79c4ce005fe$var$_hoisted_3$3 = {
    key: 0
};
const $db68d79c4ce005fe$var$_hoisted_4$3 = {
    key: 1
};
const $db68d79c4ce005fe$var$_hoisted_5$3 = {
    class: "cdx-table-pager__center"
};
const $db68d79c4ce005fe$var$_hoisted_6$3 = {
    class: "cdx-table-pager__end"
};
function $db68d79c4ce005fe$var$_sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_select = (0, $TusQn.resolveComponent)("cdx-select");
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_1$7, [
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_2$4, [
            (0, $TusQn.createVNode)(_component_cdx_select, {
                selected: _ctx.wrappedItemsPerPage,
                "onUpdate:selected": _cache[0] || (_cache[0] = ($event)=>_ctx.wrappedItemsPerPage = $event),
                "default-label": _ctx.defaultItemsPerPageLabel,
                "menu-items": _ctx.paginationSizeOptions
            }, {
                label: (0, $TusQn.withCtx)(({ selectedMenuItem: selectedMenuItem, defaultLabel: defaultLabel })=>[
                        selectedMenuItem ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_3$3, [
                            (0, $TusQn.createElementVNode)("span", null, (0, $8XWQX.toDisplayString)(_ctx.currentItemsPerPageLabel), 1)
                        ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $db68d79c4ce005fe$var$_hoisted_4$3, (0, $8XWQX.toDisplayString)(defaultLabel), 1))
                    ]),
                _: 1
            }, 8, [
                "selected",
                "default-label",
                "menu-items"
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_5$3, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ]),
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_6$3, [
            (0, $TusQn.createVNode)(_component_cdx_button, {
                disabled: _ctx.prevDisabled,
                class: "cdx-table-pager__button-first",
                weight: "quiet",
                "aria-label": _ctx.btnLabelFirst,
                onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("first"))
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_cdx_icon, {
                            icon: _ctx.cdxIconMoveFirst
                        }, null, 8, [
                            "icon"
                        ])
                    ]),
                _: 1
            }, 8, [
                "disabled",
                "aria-label"
            ]),
            (0, $TusQn.createVNode)(_component_cdx_button, {
                disabled: _ctx.prevDisabled,
                class: "cdx-table-pager__button-prev",
                weight: "quiet",
                "aria-label": _ctx.btnLabelPrev,
                onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("prev"))
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_cdx_icon, {
                            icon: _ctx.cdxIconPrevious
                        }, null, 8, [
                            "icon"
                        ])
                    ]),
                _: 1
            }, 8, [
                "disabled",
                "aria-label"
            ]),
            (0, $TusQn.createVNode)(_component_cdx_button, {
                disabled: _ctx.nextDisabled,
                class: "cdx-table-pager__button-next",
                weight: "quiet",
                "aria-label": _ctx.btnLabelNext,
                onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.$emit("next"))
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_cdx_icon, {
                            icon: _ctx.cdxIconNext
                        }, null, 8, [
                            "icon"
                        ])
                    ]),
                _: 1
            }, 8, [
                "disabled",
                "aria-label"
            ]),
            (0, $TusQn.createVNode)(_component_cdx_button, {
                disabled: _ctx.nextDisabled || _ctx.lastDisabled,
                class: "cdx-table-pager__button-last",
                weight: "quiet",
                "aria-label": _ctx.btnLabelLast,
                onClick: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("last"))
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_cdx_icon, {
                            icon: _ctx.cdxIconMoveLast
                        }, null, 8, [
                            "icon"
                        ])
                    ]),
                _: 1
            }, 8, [
                "disabled",
                "aria-label"
            ])
        ])
    ]);
}
const $db68d79c4ce005fe$var$CdxTablePager = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$7, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$7
    ]
]);
const $db68d79c4ce005fe$var$tableTextAlignmentsValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$TableTextAlignments);
const $db68d79c4ce005fe$var$paginationPositionValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$TablePaginationPositions);
const $db68d79c4ce005fe$var$iconMap = {
    none: $db68d79c4ce005fe$var$T7,
    asc: $db68d79c4ce005fe$var$x8,
    desc: $db68d79c4ce005fe$var$l4
};
const $db68d79c4ce005fe$var$sortDirectionMap = {
    none: "none",
    asc: "ascending",
    desc: "descending"
};
const $db68d79c4ce005fe$var$_sfc_main$6 = (0, $TusQn.defineComponent)({
    name: "CdxTable",
    components: {
        CdxCheckbox: $db68d79c4ce005fe$export$10933eadb08a15a2,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxTablePager: $db68d79c4ce005fe$var$CdxTablePager,
        CdxProgressBar: $db68d79c4ce005fe$export$f9f679f84bac7c0c
    },
    props: {
        /**
     * Table caption.
     *
     * Required to support users of assistive technology, but can be visually hidden.
     */ caption: {
            type: String,
            required: true
        },
        /**
     * Whether to visually hide the caption.
     */ hideCaption: {
            type: Boolean,
            default: false
        },
        /**
     * Column definitions.
     *
     * @default []
     */ columns: {
            type: Array,
            default: ()=>[],
            validator: (value)=>{
                const ids = value.map((column)=>column.id);
                const hasUniqueIds = new Set(ids).size === ids.length;
                if (!hasUniqueIds) {
                    console.warn('Each column in the "columns" prop of CdxTable must have a unique "id".');
                    return false;
                }
                return true;
            }
        },
        /**
     * Table data.
     *
     * An array of objects, with each object representing the data for a table row. Item keys
     * should align with column IDs, as defined in the `columns` prop.
     *
     * @default []
     */ data: {
            type: Array,
            default: ()=>[],
            validator: (value, props)=>{
                if (!Array.isArray(props.columns) || props.columns.length === 0 || value.length === 0) return true;
                const hasSort = props.columns.some((column)=>"allowSort" in column);
                const rowsHaveIds = value.every((row)=>$db68d79c4ce005fe$export$6bc4af29e8294dab in row);
                if (hasSort && props.useRowSelection && !rowsHaveIds) {
                    console.warn('For CdxTables with sorting and row selection, each row in the "data" prop must have a "TableRowIdentifier".');
                    return false;
                }
                return true;
            }
        },
        /**
     * Whether to use `<th>` for the first cell in each row.
     */ useRowHeaders: {
            type: Boolean,
            default: false
        },
        /**
     * Whether vertical borders separating columns should be rendered.
     */ showVerticalBorders: {
            type: Boolean,
            default: false
        },
        /**
     * Whether to enable row selection.
     */ useRowSelection: {
            type: Boolean,
            default: false
        },
        /**
     * An array of selected row indices. Must be bound with `v-model:selected-rows`.
     *
     * If sorting is also enabled, this will be an array of TableRowIdentifiers.
     *
     * @default []
     */ selectedRows: {
            type: Array,
            default: ()=>[]
        },
        /**
     * Definition of sort order. Column(s) can be sorted ascending, descending, or not sorted.
     * To display data unsorted initially, set to an empty object initially.
     * Must be bound with v-model:sort
     *
     * @default {}
     */ sort: {
            type: Object,
            default: ()=>({})
        },
        /**
     * Whether the table is waiting for data to be fetched.
     */ pending: {
            type: Boolean,
            default: false
        },
        /**
     * Whether to enable pagination.
     */ paginate: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the table is paginating through remote data. Setting this to
     * "true" will cause the table to emit events indicating that more data
     * should be loaded when the user navigates between pages.
     */ serverPagination: {
            type: Boolean,
            default: false
        },
        /**
     * The total number of rows/results available on the server that the
     * user can access via pagination. Providing this value will make for
     * a better user experience when navigating through pages of remote
     * data, but it is not required.
     */ totalRows: {
            type: Number,
            default: NaN
        },
        /**
     * Where the pagination controls should appear relative to the table body.
     */ paginationPosition: {
            type: String,
            default: "bottom",
            validator: $db68d79c4ce005fe$var$paginationPositionValidator
        },
        /**
     * Pre-defined options for how may rows should be displayed per page.
     * The value of these menu items must be a number.
     *
     * @default [ { value: 10 }, { value: 20 }, { value: 50 } ]
     */ paginationSizeOptions: {
            type: Array,
            default: ()=>[
                    {
                        value: 10
                    },
                    {
                        value: 20
                    },
                    {
                        value: 50
                    }
                ],
            validator: (value)=>{
                const hasNumberValue = (item)=>typeof item.value === "number";
                if (value.every(hasNumberValue)) return true;
                else {
                    console.warn('"value" property of all menu items in PaginationOptions must be a number.');
                    return false;
                }
            }
        },
        /**
     * The default number of rows to show per page. For basic pagination,
     * this will default to the value of the first of the pagination options
     * if not provided. For server-side pagination, this will default to
     * the initial number of rows if no default is provided.
     *
     * @default paginationSizeOptions[ 0 ].value
     */ paginationSizeDefault: {
            type: Number,
            default: (rawProps)=>{
                if (rawProps.paginate && rawProps.serverPagination) return rawProps.data.length;
                else return rawProps.paginationSizeOptions[0].value;
            }
        }
    },
    emits: [
        /**
     * When the selected row(s) changes.
     *
     * @property {string[]} selectedRows The new selected rows.
     */ "update:selectedRows",
        /**
     * When the sort order changes emit an event to update the sort order.
     *
     * @property {Object} sort The new sort order.
     */ "update:sort",
        /**
     * When the user requests another page of data from the server.
     *
     * @property {number} offset Index of the first visible row on the new page.
     * @property {number} rows Number of rows to display.
     *
     */ "load-more",
        /**
     * When the user requests the last page of data from the server.
     *
     * @property {number} rows Number of rows to display.
     */ "last"
    ],
    setup (props, { emit: emit }) {
        const offset2 = (0, $01W3b.ref)(0);
        const pageSize = (0, $01W3b.ref)(props.paginationSizeDefault);
        const dataForDisplay = (0, $TusQn.computed)(()=>{
            if (props.serverPagination && props.paginate) return props.data;
            else if (props.paginate) return props.data.slice(offset2.value, pageSize.value + offset2.value);
            else return props.data;
        });
        const totalCount = (0, $TusQn.computed)(()=>{
            var _a;
            if (props.serverPagination) return (_a = props.totalRows) != null ? _a : NaN;
            else return props.data.length;
        });
        const indeterminate = (0, $TusQn.computed)(()=>isNaN(totalCount.value));
        const currentCount = (0, $TusQn.computed)(()=>dataForDisplay.value.length);
        const firstOrdinal = (0, $TusQn.computed)(()=>offset2.value + 1);
        const lastOrdinal = (0, $TusQn.computed)(()=>offset2.value + currentCount.value);
        const lastDisabled = (0, $TusQn.computed)(()=>indeterminate.value);
        const prevDisabled = (0, $TusQn.computed)(()=>offset2.value <= 0);
        const nextDisabled = (0, $TusQn.computed)(()=>{
            if (indeterminate.value) return currentCount.value < pageSize.value;
            else return offset2.value + pageSize.value >= totalCount.value;
        });
        const paginationStatusMessageDeterminateShort = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pagination-status-message-determinate-short", (x, y, z)=>"".concat(x, "\u2013").concat(y, " of ").concat(z), [
            firstOrdinal,
            lastOrdinal,
            totalCount
        ]);
        const paginationStatusMessageDeterminateLong = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pagination-status-message-determinate-long", (x, y, z)=>"Showing results ".concat(x, "\u2013").concat(y, " of ").concat(z), [
            firstOrdinal,
            lastOrdinal,
            totalCount
        ]);
        const paginationStatusMessageIndeterminateShort = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pagination-status-message-indeterminate-short", (x, y)=>"".concat(x, "\u2013").concat(y, " of many"), [
            firstOrdinal,
            lastOrdinal
        ]);
        const paginationStatusMessageIndeterminateLong = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pagination-status-message-indeterminate-long", (x, y)=>"Showing results ".concat(x, "\u2013").concat(y, " of many"), [
            firstOrdinal,
            lastOrdinal
        ]);
        const paginationStatusMessageIndeterminateFinal = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pagination-status-message-indeterminate-final", (x)=>"Showing the last ".concat(x, " results"), [
            currentCount
        ]);
        const paginationStatusMessagePending = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-pagination-status-message-pending", "Loading results...");
        const paginationStatusMessageShort = (0, $TusQn.computed)(()=>{
            if (props.pending) return paginationStatusMessagePending.value;
            else if (indeterminate.value && nextDisabled.value) return paginationStatusMessageIndeterminateFinal.value;
            else if (indeterminate.value) return paginationStatusMessageIndeterminateShort.value;
            else return paginationStatusMessageDeterminateShort.value;
        });
        const paginationStatusMessageLong = (0, $TusQn.computed)(()=>{
            if (props.pending) return paginationStatusMessagePending.value;
            else if (indeterminate.value && nextDisabled.value) return paginationStatusMessageIndeterminateFinal.value;
            else if (indeterminate.value) return paginationStatusMessageIndeterminateLong.value;
            else return paginationStatusMessageDeterminateLong.value;
        });
        function onNext() {
            offset2.value += pageSize.value;
            if (props.serverPagination) emit("load-more", offset2.value, pageSize.value);
        }
        function onPrev() {
            if (offset2.value - pageSize.value < 1) onFirst();
            else {
                offset2.value -= pageSize.value;
                if (props.serverPagination) emit("load-more", offset2.value, pageSize.value);
            }
        }
        function onFirst() {
            offset2.value = 0;
            if (props.serverPagination) emit("load-more", offset2.value, pageSize.value);
        }
        function onLast() {
            if (totalCount.value % pageSize.value === 0) {
                offset2.value = totalCount.value - pageSize.value;
                emit("load-more", offset2.value, pageSize.value);
            } else {
                offset2.value = Math.floor(totalCount.value / pageSize.value) * pageSize.value;
                emit("load-more", offset2.value, pageSize.value);
            }
        }
        (0, $TusQn.watch)(pageSize, (newPageSize)=>{
            if (props.serverPagination) emit("load-more", offset2.value, newPageSize);
        });
        const wrappedSelectedRows = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "selectedRows"), emit, "update:selectedRows");
        const selectAll = (0, $01W3b.ref)(totalCount.value === wrappedSelectedRows.value.length);
        const selectAllIndeterminate = (0, $01W3b.ref)(false);
        const activeSortColumn = (0, $TusQn.computed)(()=>{
            return Object.keys(props.sort)[0];
        });
        const hasSortableColumns = (0, $TusQn.computed)(()=>{
            return props.columns.some((column)=>column.allowSort);
        });
        const tableClasses = (0, $TusQn.computed)(()=>{
            var _a;
            const useFixedLayout = (_a = props.columns) == null ? void 0 : _a.some((column)=>"width" in column || "minWidth" in column);
            return {
                "cdx-table__table--layout-fixed": useFixedLayout,
                "cdx-table__table--borders-vertical": props.showVerticalBorders
            };
        });
        const translatedSortCaption = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-sort-caption", (caption)=>"".concat(caption, ", column headers with buttons are sortable."), [
            (0, $01W3b.toRef)(props, "caption")
        ]);
        const translatedSelectRowLabel = (rowIndex, totalRows)=>$db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-select-row-label", (row, total)=>"Select row ".concat(row, " of ").concat(total), [
                ()=>rowIndex,
                ()=>totalRows
            ]).value;
        const translatedSelectAllLabel = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-table-select-all-label", "Select all rows");
        function getRowKey(row, index) {
            return $db68d79c4ce005fe$export$6bc4af29e8294dab in row ? row[$db68d79c4ce005fe$export$6bc4af29e8294dab] : index;
        }
        function getRowClass(row, rowIndex) {
            const rowKey = getRowKey(row, rowIndex);
            return {
                "cdx-table__row--selected": wrappedSelectedRows.value.indexOf(rowKey) !== -1
            };
        }
        function getRowHeaderScope(columnId) {
            const firstColumn = props.columns[0].id;
            if (props.useRowHeaders === true && columnId === firstColumn) return "row";
        }
        function getCellElement(columnId) {
            const firstColumn = props.columns[0].id;
            if (props.useRowHeaders && columnId === firstColumn) return "th";
            return "td";
        }
        function getCellClass(column, hasSort = false) {
            if ("textAlign" in column && !$db68d79c4ce005fe$var$tableTextAlignmentsValidator(column.textAlign)) {
                console.warn("Invalid value for TableColumn textAlign property.");
                return void 0;
            }
            return {
                // Don't assign a class for the default value 'start'. Instead, we'll set
                // text-align: left on the td and th elements.
                ["cdx-table__table__cell--align-".concat(column.textAlign)]: "textAlign" in column && column.textAlign !== "start",
                "cdx-table__table__cell--has-sort": hasSort
            };
        }
        function getCellStyle(column) {
            const styles = {};
            if ("width" in column) styles.width = column.width;
            if ("minWidth" in column) styles.minWidth = column.minWidth;
            return styles;
        }
        function handleRowSelection(newSelectedRows) {
            if (totalCount.value === newSelectedRows.length) {
                selectAll.value = true;
                selectAllIndeterminate.value = false;
                return;
            }
            selectAll.value = false;
            if (totalCount.value > newSelectedRows.length) selectAllIndeterminate.value = true;
            if (newSelectedRows.length === 0) selectAllIndeterminate.value = false;
        }
        function handleSelectAll(newValue) {
            selectAllIndeterminate.value = false;
            if (newValue) wrappedSelectedRows.value = props.data.map((row, rowIndex)=>getRowKey(row, rowIndex));
            else wrappedSelectedRows.value = [];
        }
        function handleSort(columnId) {
            var _a;
            const currentSortOrder = (_a = props.sort[columnId]) != null ? _a : "none";
            let newSortOrder = "asc";
            if (currentSortOrder === "asc") newSortOrder = "desc";
            if (currentSortOrder === "desc") newSortOrder = "none";
            emit("update:sort", {
                [columnId]: newSortOrder
            });
        }
        function getSortIcon(columnId) {
            var _a;
            const currentSortOrder = (_a = props.sort[columnId]) != null ? _a : "none";
            return $db68d79c4ce005fe$var$iconMap[currentSortOrder];
        }
        function getSortOrder(columnId, hasSort = false) {
            var _a;
            if (hasSort) {
                const currentSortOrder = (_a = props.sort[columnId]) != null ? _a : "none";
                return currentSortOrder === "none" ? void 0 : $db68d79c4ce005fe$var$sortDirectionMap[currentSortOrder];
            }
        }
        return {
            dataForDisplay: // pagination
            dataForDisplay,
            pageSize: pageSize,
            onNext: onNext,
            onPrev: onPrev,
            onFirst: onFirst,
            onLast: onLast,
            nextDisabled: nextDisabled,
            prevDisabled: prevDisabled,
            lastDisabled: lastDisabled,
            paginationStatusMessageShort: paginationStatusMessageShort,
            paginationStatusMessageLong: paginationStatusMessageLong,
            wrappedSelectedRows: // Row selection constants.
            wrappedSelectedRows,
            selectAll: selectAll,
            selectAllIndeterminate: selectAllIndeterminate,
            activeSortColumn: // Sorting constants.
            activeSortColumn,
            hasSortableColumns: hasSortableColumns,
            tableClasses: // Template helpers.
            tableClasses,
            getRowKey: getRowKey,
            getRowClass: getRowClass,
            getRowHeaderScope: getRowHeaderScope,
            getCellElement: getCellElement,
            getCellClass: getCellClass,
            getCellStyle: getCellStyle,
            handleRowSelection: // Row selection methods.
            handleRowSelection,
            handleSelectAll: handleSelectAll,
            handleSort: // Sorting methods.
            handleSort,
            getSortIcon: getSortIcon,
            getSortOrder: getSortOrder,
            translatedSortCaption: // i18n
            translatedSortCaption,
            translatedSelectRowLabel: translatedSelectRowLabel,
            translatedSelectAllLabel: translatedSelectAllLabel
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$6 = {
    class: "cdx-table",
    tabindex: "0"
};
const $db68d79c4ce005fe$var$_hoisted_2$3 = {
    key: 0,
    class: "cdx-table__header"
};
const $db68d79c4ce005fe$var$_hoisted_3$2 = [
    "aria-hidden"
];
const $db68d79c4ce005fe$var$_hoisted_4$2 = {
    class: "cdx-table__header__content"
};
const $db68d79c4ce005fe$var$_hoisted_5$2 = {
    class: "cdx-table__pagination-status--long"
};
const $db68d79c4ce005fe$var$_hoisted_6$2 = {
    class: "cdx-table__pagination-status--short"
};
const $db68d79c4ce005fe$var$_hoisted_7 = {
    class: "cdx-table__table-wrapper"
};
const $db68d79c4ce005fe$var$_hoisted_8 = {
    key: 0
};
const $db68d79c4ce005fe$var$_hoisted_9 = {
    key: 0,
    class: "cdx-table__table__select-rows"
};
const $db68d79c4ce005fe$var$_hoisted_10 = [
    "aria-sort"
];
const $db68d79c4ce005fe$var$_hoisted_11 = [
    "aria-selected",
    "onClick"
];
const $db68d79c4ce005fe$var$_hoisted_12 = {
    class: "cdx-table__table__sort-label"
};
const $db68d79c4ce005fe$var$_hoisted_13 = {
    key: 0
};
const $db68d79c4ce005fe$var$_hoisted_14 = {
    key: 0
};
const $db68d79c4ce005fe$var$_hoisted_15 = {
    key: 1
};
const $db68d79c4ce005fe$var$_hoisted_16 = {
    class: "cdx-table__table__empty-state"
};
const $db68d79c4ce005fe$var$_hoisted_17 = {
    class: "cdx-table__table__empty-state-content"
};
const $db68d79c4ce005fe$var$_hoisted_18 = {
    class: "cdx-table__pagination-status--long"
};
const $db68d79c4ce005fe$var$_hoisted_19 = {
    class: "cdx-table__pagination-status--short"
};
const $db68d79c4ce005fe$var$_hoisted_20 = {
    key: 3,
    class: "cdx-table__footer"
};
function $db68d79c4ce005fe$var$_sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_table_pager = (0, $TusQn.resolveComponent)("cdx-table-pager");
    const _component_cdx_checkbox = (0, $TusQn.resolveComponent)("cdx-checkbox");
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_progress_bar = (0, $TusQn.resolveComponent)("cdx-progress-bar");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_1$6, [
        !_ctx.hideCaption || _ctx.$slots.header && _ctx.$slots.header().length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_2$3, [
            (0, $TusQn.createElementVNode)("div", {
                class: "cdx-table__header__caption",
                "aria-hidden": _ctx.$slots.header && _ctx.$slots.header().length > 0 ? void 0 : true
            }, [
                !_ctx.hideCaption ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                    key: 0
                }, [
                    (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.caption), 1)
                ], 64)) : (0, $TusQn.createCommentVNode)("v-if", true)
            ], 8, $db68d79c4ce005fe$var$_hoisted_3$2),
            (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_4$2, [
                (0, $TusQn.renderSlot)(_ctx.$slots, "header")
            ])
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        _ctx.paginate && (_ctx.paginationPosition === "top" || _ctx.paginationPosition === "both") ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_table_pager, {
            key: 1,
            "items-per-page": _ctx.pageSize,
            "onUpdate:itemsPerPage": _cache[0] || (_cache[0] = ($event)=>_ctx.pageSize = $event),
            class: "cdx-table__pagination--top",
            "pagination-size-options": _ctx.paginationSizeOptions,
            "prev-disabled": _ctx.prevDisabled,
            "next-disabled": _ctx.nextDisabled,
            "last-disabled": _ctx.lastDisabled,
            onNext: _ctx.onNext,
            onPrev: _ctx.onPrev,
            onFirst: _ctx.onFirst,
            onLast: _ctx.onLast
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_5$2, (0, $8XWQX.toDisplayString)(_ctx.paginationStatusMessageLong), 1),
                    (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_6$2, (0, $8XWQX.toDisplayString)(_ctx.paginationStatusMessageShort), 1)
                ]),
            _: 1
        }, 8, [
            "items-per-page",
            "pagination-size-options",
            "prev-disabled",
            "next-disabled",
            "last-disabled",
            "onNext",
            "onPrev",
            "onFirst",
            "onLast"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_7, [
            (0, $TusQn.createElementVNode)("table", {
                class: (0, $8XWQX.normalizeClass)([
                    "cdx-table__table",
                    _ctx.tableClasses
                ])
            }, [
                (0, $TusQn.createElementVNode)("caption", null, [
                    !_ctx.hasSortableColumns ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 0
                    }, [
                        (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.caption), 1)
                    ], 64)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                        key: 1
                    }, [
                        (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.translatedSortCaption), 1)
                    ], 64))
                ]),
                (0, $TusQn.renderSlot)(_ctx.$slots, "thead", {}, ()=>[
                        _ctx.columns.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("thead", $db68d79c4ce005fe$var$_hoisted_8, [
                            (0, $TusQn.createElementVNode)("tr", null, [
                                _ctx.useRowSelection ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("th", $db68d79c4ce005fe$var$_hoisted_9, [
                                    (0, $TusQn.createVNode)(_component_cdx_checkbox, {
                                        modelValue: _ctx.selectAll,
                                        "onUpdate:modelValue": [
                                            _cache[1] || (_cache[1] = ($event)=>_ctx.selectAll = $event),
                                            _ctx.handleSelectAll
                                        ],
                                        "hide-label": true,
                                        indeterminate: _ctx.selectAllIndeterminate
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.translatedSelectAllLabel), 1)
                                            ]),
                                        _: 1
                                    }, 8, [
                                        "modelValue",
                                        "indeterminate",
                                        "onUpdate:modelValue"
                                    ])
                                ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.columns, (column)=>{
                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("th", {
                                        key: column.id,
                                        scope: "col",
                                        class: (0, $8XWQX.normalizeClass)(_ctx.getCellClass(column, column.allowSort)),
                                        "aria-sort": _ctx.getSortOrder(column.id, column.allowSort),
                                        style: (0, $8XWQX.normalizeStyle)(_ctx.getCellStyle(column))
                                    }, [
                                        column.allowSort ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                                            key: 0,
                                            "aria-selected": column.id === _ctx.activeSortColumn,
                                            class: "cdx-table__table__sort-button",
                                            onClick: ($event)=>_ctx.handleSort(column.id)
                                        }, [
                                            (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_12, (0, $8XWQX.toDisplayString)(column.label), 1),
                                            (0, $TusQn.createVNode)(_component_cdx_icon, {
                                                icon: _ctx.getSortIcon(column.id),
                                                size: "small",
                                                class: "cdx-table__table__sort-icon",
                                                "aria-hidden": "true"
                                            }, null, 8, [
                                                "icon"
                                            ])
                                        ], 8, $db68d79c4ce005fe$var$_hoisted_11)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                            key: 1
                                        }, [
                                            (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(column.label), 1)
                                        ], 64))
                                    ], 14, $db68d79c4ce005fe$var$_hoisted_10);
                                }), 128))
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                    ]),
                _ctx.pending ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_progress_bar, {
                    key: 0,
                    inline: true,
                    class: "cdx-table__pending-indicator"
                })) : (0, $TusQn.createCommentVNode)("v-if", true),
                (0, $TusQn.renderSlot)(_ctx.$slots, "tbody", {}, ()=>[
                        _ctx.dataForDisplay.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $db68d79c4ce005fe$var$_hoisted_13, [
                            ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.dataForDisplay, (row, rowIndex)=>{
                                return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tr", {
                                    key: _ctx.getRowKey(row, rowIndex),
                                    class: (0, $8XWQX.normalizeClass)(_ctx.getRowClass(row, rowIndex))
                                }, [
                                    _ctx.useRowSelection ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("td", $db68d79c4ce005fe$var$_hoisted_14, [
                                        (0, $TusQn.createVNode)(_component_cdx_checkbox, {
                                            modelValue: _ctx.wrappedSelectedRows,
                                            "onUpdate:modelValue": [
                                                _cache[2] || (_cache[2] = ($event)=>_ctx.wrappedSelectedRows = $event),
                                                _ctx.handleRowSelection
                                            ],
                                            "input-value": _ctx.getRowKey(row, rowIndex),
                                            "hide-label": true
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(_ctx.translatedSelectRowLabel(rowIndex + 1, _ctx.dataForDisplay.length)), 1)
                                                ]),
                                            _: 2
                                        }, 1032, [
                                            "modelValue",
                                            "input-value",
                                            "onUpdate:modelValue"
                                        ])
                                    ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.columns, (column)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(_ctx.getCellElement(column.id)), {
                                            key: column.id,
                                            scope: _ctx.getRowHeaderScope(column.id),
                                            class: (0, $8XWQX.normalizeClass)(_ctx.getCellClass(column))
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.renderSlot)(_ctx.$slots, "item-" + column.id, {
                                                        item: row[column.id],
                                                        row: row
                                                    }, ()=>[
                                                            (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(row[column.id]), 1)
                                                        ])
                                                ]),
                                            _: 2
                                        }, 1032, [
                                            "scope",
                                            "class"
                                        ]);
                                    }), 128))
                                ], 2);
                            }), 128))
                        ])) : _ctx.$slots["empty-state"] && _ctx.$slots["empty-state"]().length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("tbody", $db68d79c4ce005fe$var$_hoisted_15, [
                            (0, $TusQn.createElementVNode)("tr", $db68d79c4ce005fe$var$_hoisted_16, [
                                (0, $TusQn.createElementVNode)("td", $db68d79c4ce005fe$var$_hoisted_17, [
                                    (0, $TusQn.renderSlot)(_ctx.$slots, "empty-state")
                                ])
                            ])
                        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                    ]),
                (0, $TusQn.renderSlot)(_ctx.$slots, "tfoot")
            ], 2)
        ]),
        _ctx.paginate && (_ctx.paginationPosition === "bottom" || _ctx.paginationPosition === "both") ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_table_pager, {
            key: 2,
            "items-per-page": _ctx.pageSize,
            "onUpdate:itemsPerPage": _cache[3] || (_cache[3] = ($event)=>_ctx.pageSize = $event),
            class: "cdx-table__pagination--bottom",
            "pagination-size-options": _ctx.paginationSizeOptions,
            "prev-disabled": _ctx.prevDisabled,
            "next-disabled": _ctx.nextDisabled,
            "last-disabled": _ctx.lastDisabled,
            onNext: _ctx.onNext,
            onPrev: _ctx.onPrev,
            onFirst: _ctx.onFirst,
            onLast: _ctx.onLast
        }, {
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_18, (0, $8XWQX.toDisplayString)(_ctx.paginationStatusMessageLong), 1),
                    (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_19, (0, $8XWQX.toDisplayString)(_ctx.paginationStatusMessageShort), 1)
                ]),
            _: 1
        }, 8, [
            "items-per-page",
            "pagination-size-options",
            "prev-disabled",
            "next-disabled",
            "last-disabled",
            "onNext",
            "onPrev",
            "onFirst",
            "onLast"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        _ctx.$slots.footer && _ctx.$slots.footer().length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_20, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "footer")
        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
    ]);
}
const $db68d79c4ce005fe$export$fa4e6546674df247 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$6, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$6
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$5 = (0, $TusQn.defineComponent)({
    name: "CdxTab",
    /**
   * The "label" and "disabled" props are referenced by the parent Tabs
   * component during the generation of a list of labels.
   */ props: {
        /**
     * String name of the tab, used for programmatic selection. Each Tab
     * inside a layout must have a unique name. This prop will also be
     * used as the tab label if no "label" prop is provided.
     */ name: {
            type: String,
            required: true
        },
        /**
     * Label that corresponds to this Tab in the Tabs component's header.
     * Lengthy labels will be truncated.
     */ // eslint-disable-next-line vue/no-unused-properties
        label: {
            type: String,
            default: ""
        },
        /**
     * Whether or not the tab is disabled. Disabled tabs cannot be accessed
     * via label clicks or keyboard navigation.
     */ // eslint-disable-next-line vue/no-unused-properties
        disabled: {
            type: Boolean,
            default: false
        }
    },
    setup (props) {
        var _a;
        const tabsData = (0, $TusQn.inject)($db68d79c4ce005fe$var$TabsKey);
        const activeTab = (0, $TusQn.inject)($db68d79c4ce005fe$var$ActiveTabKey);
        if (!tabsData || !activeTab) throw new Error("Tab component must be used inside a Tabs component");
        const tab = (_a = tabsData.value.get(props.name)) != null ? _a : {};
        const isActive = (0, $TusQn.computed)(()=>props.name === activeTab.value);
        return {
            tab: tab,
            isActive: isActive
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$5 = [
    "id",
    "aria-hidden",
    "aria-labelledby"
];
function $db68d79c4ce005fe$var$_sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.withDirectives)(((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("section", {
        id: _ctx.tab.id,
        "aria-hidden": !_ctx.isActive ? true : void 0,
        "aria-labelledby": "".concat(_ctx.tab.id, "-label"),
        class: "cdx-tab",
        role: "tabpanel",
        tabindex: "-1"
    }, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
    ], 8, $db68d79c4ce005fe$var$_hoisted_1$5)), [
        [
            (0, $eeJ70.vShow),
            _ctx.isActive
        ]
    ]);
}
const $db68d79c4ce005fe$export$b9548060c0a710bb = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$5, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$5
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$4 = (0, $TusQn.defineComponent)({
    name: "CdxTabs",
    components: {
        CdxButton: $db68d79c4ce005fe$export$3318068e43c65fe8,
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    props: {
        /**
     * The `name` of the currently active Tab in the layout.
     *
     * This prop is optional; if it is provided, it should be bound
     * using a `v-model:active` directive in the parent component.
     * Two-way binding the active tab is only necessary if some tab
     * other than the first should be active as soon as the component
     * renders (such as in cases where the active tab is bound to URL
     * params). If this prop is not provided, then the first tab will
     * be active by default. Regardless, the active tab can be changed
     * normally by user interaction (clicking on tab headings) or by
     * using the exposed methods "select", "next", and "prev".
     */ active: {
            type: String,
            default: null
        },
        /**
     * Whether or not the component should be displayed in a framed
     * visual style.
     */ framed: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * Emitted whenever the active tab changes, assuming that an `active`
     * prop has been provided in the parent.
     *
     * @property {string} active The `name` of the current active tab
     */ "update:active"
    ],
    /**
   * Some methods are exposed to allow for programmatic selection of
   * the active tab from outside of the component.
   */ expose: [
        "select",
        "next",
        "prev"
    ],
    setup (props, { slots: slots, emit: emit }) {
        const rootElement = (0, $01W3b.ref)();
        const tabListElement = (0, $01W3b.ref)();
        const prevScroller = (0, $01W3b.ref)();
        const nextScroller = (0, $01W3b.ref)();
        const currentDirection = $db68d79c4ce005fe$export$b64edd098c9cdbaf(rootElement);
        const childTabNodes = (0, $TusQn.computed)(()=>{
            const slotContents = $db68d79c4ce005fe$export$57535e89d59a174(slots.default);
            if (!slotContents.every((node)=>typeof node === "object" && $db68d79c4ce005fe$var$isComponentVNode(node, $db68d79c4ce005fe$export$b9548060c0a710bb.name))) throw new Error("Slot content may only contain CdxTab components");
            if (slotContents.length === 0) throw new Error("Slot content cannot be empty");
            return slotContents;
        });
        const tabsData = (0, $TusQn.computed)(()=>{
            return childTabNodes.value.reduce((map, item)=>{
                var _a;
                if (((_a = item.props) == null ? void 0 : _a.name) && typeof item.props.name === "string") {
                    if (map.get(item.props.name)) throw new Error("Tab names must be unique");
                    map.set(item.props.name, {
                        name: item.props.name,
                        id: $db68d79c4ce005fe$export$6217842283d27b52(item.props.name),
                        label: item.props.label || item.props.name,
                        disabled: item.props.disabled
                    });
                }
                return map;
            }, /* @__PURE__ */ new Map());
        });
        const internalRefForActiveTab = (0, $01W3b.ref)(Array.from(tabsData.value.keys())[0]);
        const activeTab = $db68d79c4ce005fe$var$useOptionalModelWrapper(internalRefForActiveTab, (0, $01W3b.toRef)(props, "active"), emit, "update:active");
        const tabNames = (0, $TusQn.computed)(()=>Array.from(tabsData.value.keys()));
        const activeTabIndex = (0, $TusQn.computed)(()=>tabNames.value.indexOf(activeTab.value));
        const activeTabId = (0, $TusQn.computed)(()=>{
            var _a;
            return (_a = tabsData.value.get(activeTab.value)) == null ? void 0 : _a.id;
        });
        (0, $TusQn.provide)($db68d79c4ce005fe$var$ActiveTabKey, activeTab);
        (0, $TusQn.provide)($db68d79c4ce005fe$var$TabsKey, tabsData);
        const tabButtonRefs = (0, $01W3b.ref)(/* @__PURE__ */ new Map());
        const firstTabLabel = (0, $01W3b.ref)();
        const lastTabLabel = (0, $01W3b.ref)();
        const firstLabelVisible = $db68d79c4ce005fe$export$a7395f9832c00176(firstTabLabel, {
            threshold: 0.95
        });
        const lastLabelVisible = $db68d79c4ce005fe$export$a7395f9832c00176(lastTabLabel, {
            threshold: 0.95
        });
        function assignTemplateRefForTabButton(templateRef, index) {
            const el = templateRef;
            if (el) {
                tabButtonRefs.value.set(index, el);
                if (index === 0) firstTabLabel.value = el;
                else if (index === tabNames.value.length - 1) lastTabLabel.value = el;
            }
        }
        const rootClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-tabs--framed": props.framed,
                "cdx-tabs--quiet": !props.framed
            };
        });
        function focusActiveTab() {
            var _a;
            (_a = tabButtonRefs.value.get(activeTabIndex.value)) == null || _a.focus();
        }
        function getScrollDistance(tabLabel) {
            if (!tabListElement.value || !prevScroller.value || !nextScroller.value) return 0;
            const leftScroller = currentDirection.value === "rtl" ? nextScroller.value : prevScroller.value;
            const rightScroller = currentDirection.value === "rtl" ? prevScroller.value : nextScroller.value;
            const labelLeft = tabLabel.offsetLeft;
            const labelRight = labelLeft + tabLabel.clientWidth;
            const visibleLeft = tabListElement.value.scrollLeft + leftScroller.clientWidth;
            const visibleRight = tabListElement.value.scrollLeft + tabListElement.value.clientWidth - rightScroller.clientWidth;
            if (labelLeft < visibleLeft) return labelLeft - visibleLeft;
            if (labelRight > visibleRight) return labelRight - visibleRight;
            return 0;
        }
        function scrollTabs(logicalDirection) {
            if (!tabListElement.value || !prevScroller.value || !nextScroller.value) return;
            const scrollDirection = logicalDirection === "next" && currentDirection.value === "ltr" || logicalDirection === "prev" && currentDirection.value === "rtl" ? 1 : -1;
            let scrollDistance = 0;
            let tabLabel = logicalDirection === "next" ? tabListElement.value.firstElementChild : tabListElement.value.lastElementChild;
            while(tabLabel){
                const nextTabLabel = logicalDirection === "next" ? tabLabel.nextElementSibling : tabLabel.previousElementSibling;
                scrollDistance = getScrollDistance(tabLabel);
                if (Math.sign(scrollDistance) === scrollDirection) {
                    if (nextTabLabel && Math.abs(scrollDistance) < 0.25 * tabListElement.value.clientWidth) scrollDistance = getScrollDistance(nextTabLabel);
                    break;
                }
                tabLabel = nextTabLabel;
            }
            tabListElement.value.scrollBy({
                left: scrollDistance,
                behavior: "smooth"
            });
            focusActiveTab();
        }
        (0, $TusQn.watch)(activeTab, ()=>{
            if (activeTabId.value === void 0 || !tabListElement.value || !prevScroller.value || !nextScroller.value) return;
            const activeTabLabel = document.getElementById("".concat(activeTabId.value, "-label"));
            if (!activeTabLabel) return;
            tabListElement.value.scrollBy({
                left: getScrollDistance(activeTabLabel),
                behavior: "smooth"
            });
        });
        return {
            activeTab: activeTab,
            activeTabIndex: activeTabIndex,
            activeTabId: activeTabId,
            currentDirection: currentDirection,
            rootElement: rootElement,
            tabListElement: tabListElement,
            prevScroller: prevScroller,
            nextScroller: nextScroller,
            rootClasses: rootClasses,
            tabNames: tabNames,
            tabsData: tabsData,
            firstLabelVisible: firstLabelVisible,
            lastLabelVisible: lastLabelVisible,
            assignTemplateRefForTabButton: assignTemplateRefForTabButton,
            scrollTabs: scrollTabs,
            focusActiveTab: focusActiveTab,
            cdxIconPrevious: $db68d79c4ce005fe$var$d7,
            cdxIconNext: $db68d79c4ce005fe$var$j6
        };
    },
    /**
   * Some non-public methods are defined here rather than in setup because
   * they support public methods (which *must* be defined using the Options
   * API in order to show up in documentation), or are thematically related
   * (such as key handlers).
   */ methods: {
        /**
     * Programmatically select a tab based on its "name" prop
     *
     * @param {string} tabName The name of the tab to select
     * @param {boolean} setFocus Whether or not to also set focus to the new tab
     * @public
     */ select (tabName, setFocus) {
            const target = this.tabsData.get(tabName);
            if (target && !(target == null ? void 0 : target.disabled)) {
                this.activeTab = tabName;
                if (setFocus) (0, $TusQn.nextTick)(()=>{
                    this.focusActiveTab();
                });
            }
        },
        /**
     * Used to select next or previous tab in the sequence, skipping
     * over any tabs that are disabled. The provided increment should
     * be either 1 (to move forward) or -1 (to move backwards)
     *
     * @param index
     * @param increment
     * @param setFocus
     */ selectNonDisabled (index, increment, setFocus) {
            const target = this.tabsData.get(this.tabNames[index + increment]);
            if (target) {
                if (target.disabled) this.selectNonDisabled(index + increment, increment, setFocus);
                else this.select(target.name, setFocus);
            }
        },
        /**
     * Set the next tab to active, if one exists
     *
     * @param {boolean} setFocus
     * @public
     */ next (setFocus) {
            this.selectNonDisabled(this.activeTabIndex, 1, setFocus);
        },
        /**
     * Set the previous tab to active, if one exists
     *
     * @param {boolean} setFocus
     * @public
     */ prev (setFocus) {
            this.selectNonDisabled(this.activeTabIndex, -1, setFocus);
        },
        /**
     * Handle left arrow key navigation (based on LTR/RTL direction)
     */ onLeftArrowKeypress () {
            if (this.currentDirection === "rtl") this.next(true);
            else this.prev(true);
        },
        /**
     * Handle right arrow key navigation (based on LTR/RTL direction)
     */ onRightArrowKeypress () {
            if (this.currentDirection === "rtl") this.prev(true);
            else this.next(true);
        },
        /**
     * Handle down arrow key navigation by moving focus to the contents
     * of the currently active tab
     */ onDownArrowKeypress () {
            var _a;
            if (this.activeTabId) (_a = document.getElementById(this.activeTabId)) == null || _a.focus();
        }
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$4 = {
    class: "cdx-tabs__header"
};
const $db68d79c4ce005fe$var$_hoisted_2$2 = {
    ref: "prevScroller",
    class: "cdx-tabs__prev-scroller"
};
const $db68d79c4ce005fe$var$_hoisted_3$1 = {
    ref: "tabListElement",
    class: "cdx-tabs__list",
    role: "tablist"
};
const $db68d79c4ce005fe$var$_hoisted_4$1 = [
    "id",
    "disabled",
    "aria-controls",
    "aria-selected",
    "tabindex",
    "onClick",
    "onKeyup"
];
const $db68d79c4ce005fe$var$_hoisted_5$1 = {
    ref: "nextScroller",
    class: "cdx-tabs__next-scroller"
};
const $db68d79c4ce005fe$var$_hoisted_6$1 = {
    class: "cdx-tabs__content"
};
function $db68d79c4ce005fe$var$_sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_button = (0, $TusQn.resolveComponent)("cdx-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        ref: "rootElement",
        class: (0, $8XWQX.normalizeClass)([
            "cdx-tabs",
            _ctx.rootClasses
        ])
    }, [
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_1$4, [
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_2$2, [
                (0, $TusQn.createVNode)(_component_cdx_button, {
                    class: "cdx-tabs__scroll-button",
                    weight: "quiet",
                    type: "button",
                    tabindex: "-1",
                    "aria-hidden": true,
                    onMousedown: _cache[0] || (_cache[0] = (0, $eeJ70.withModifiers)(()=>{}, [
                        "prevent"
                    ])),
                    onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.scrollTabs("prev"))
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_cdx_icon, {
                                icon: _ctx.cdxIconPrevious
                            }, null, 8, [
                                "icon"
                            ])
                        ]),
                    _: 1
                })
            ], 512), [
                [
                    (0, $eeJ70.vShow),
                    !_ctx.firstLabelVisible
                ]
            ]),
            (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_3$1, [
                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.tabsData.values(), (tab, index)=>{
                    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
                        id: "".concat(tab.id, "-label"),
                        key: index,
                        ref_for: true,
                        ref: (ref2)=>_ctx.assignTemplateRefForTabButton(ref2, index),
                        disabled: tab.disabled ? true : void 0,
                        "aria-controls": tab.id,
                        "aria-selected": tab.name === _ctx.activeTab,
                        tabindex: tab.name === _ctx.activeTab ? void 0 : -1,
                        class: "cdx-tabs__list__item",
                        role: "tab",
                        onClick: (0, $eeJ70.withModifiers)(($event)=>_ctx.select(tab.name), [
                            "prevent"
                        ]),
                        onKeyup: (0, $eeJ70.withKeys)(($event)=>_ctx.select(tab.name), [
                            "enter"
                        ]),
                        onKeydown: [
                            _cache[2] || (_cache[2] = (0, $eeJ70.withKeys)((0, $eeJ70.withModifiers)((...args)=>_ctx.onRightArrowKeypress && _ctx.onRightArrowKeypress(...args), [
                                "prevent"
                            ]), [
                                "right"
                            ])),
                            _cache[3] || (_cache[3] = (0, $eeJ70.withKeys)((0, $eeJ70.withModifiers)((...args)=>_ctx.onDownArrowKeypress && _ctx.onDownArrowKeypress(...args), [
                                "prevent"
                            ]), [
                                "down"
                            ])),
                            _cache[4] || (_cache[4] = (0, $eeJ70.withKeys)((0, $eeJ70.withModifiers)((...args)=>_ctx.onLeftArrowKeypress && _ctx.onLeftArrowKeypress(...args), [
                                "prevent"
                            ]), [
                                "left"
                            ]))
                        ]
                    }, [
                        (0, $TusQn.createElementVNode)("span", null, (0, $8XWQX.toDisplayString)(tab.label), 1)
                    ], 40, $db68d79c4ce005fe$var$_hoisted_4$1);
                }), 128))
            ], 512),
            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_5$1, [
                (0, $TusQn.createVNode)(_component_cdx_button, {
                    class: "cdx-tabs__scroll-button",
                    weight: "quiet",
                    type: "button",
                    tabindex: "-1",
                    "aria-hidden": true,
                    onMousedown: _cache[5] || (_cache[5] = (0, $eeJ70.withModifiers)(()=>{}, [
                        "prevent"
                    ])),
                    onClick: _cache[6] || (_cache[6] = ($event)=>_ctx.scrollTabs("next"))
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_cdx_icon, {
                                icon: _ctx.cdxIconNext
                            }, null, 8, [
                                "icon"
                            ])
                        ]),
                    _: 1
                })
            ], 512), [
                [
                    (0, $eeJ70.vShow),
                    !_ctx.lastLabelVisible
                ]
            ])
        ]),
        (0, $TusQn.createElementVNode)("div", $db68d79c4ce005fe$var$_hoisted_6$1, [
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ])
    ], 2);
}
const $db68d79c4ce005fe$export$a83e2c3a89339f7f = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$4, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$4
    ]
]);
const $db68d79c4ce005fe$var$statusValidator = $db68d79c4ce005fe$var$makeStringTypeValidator($db68d79c4ce005fe$var$ValidationStatusTypes);
const $db68d79c4ce005fe$var$_sfc_main$3 = (0, $TusQn.defineComponent)({
    name: "CdxTextArea",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a
    },
    inheritAttrs: false,
    props: {
        /**
     * Current value of the textarea.
     *
     * Provided by `v-model` binding in the parent component.
     */ modelValue: {
            type: String,
            default: ""
        },
        /**
     * `status` attribute of the textarea.
     */ status: {
            type: String,
            default: "default",
            validator: $db68d79c4ce005fe$var$statusValidator
        },
        /**
     * Whether the textarea is disabled.
     */ disabled: {
            type: Boolean,
            default: false
        },
        /**
     * Describes whether the textarea grows vertically to show all text.
     *
     * When autosize is true, the textarea automatically grows in height (vertically).
     * The height of the textarea expands while the user types in the textarea.
     * The content inside the textarea is visible and there's no scroll.
     *
     * @values true, false
     */ autosize: {
            type: Boolean,
            default: false
        },
        /**
     * An icon at the start of the textarea element. Similar to a `::before` pseudo-element.
     */ startIcon: {
            type: [
                String,
                Object
            ],
            default: void 0
        },
        /**
     * An icon at the end of the textarea element. Similar to an `::after` pseudo-element.
     */ endIcon: {
            type: [
                String,
                Object
            ],
            default: void 0
        }
    },
    emits: [
        /**
     * When the textarea value changes.
     *
     * @property {string} modelValue The new model value
     */ "update:modelValue"
    ],
    setup (props, { attrs: attrs, emit: emit }) {
        const wrappedModel = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "modelValue"), emit);
        const idAttribute = attrs.id;
        const { computedDisabled: computedDisabled, computedStatus: computedStatus, computedInputId: computedInputId } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"), (0, $01W3b.toRef)(props, "status"), idAttribute);
        const descriptionId = (0, $TusQn.inject)($db68d79c4ce005fe$var$FieldDescriptionIdKey, void 0);
        const textareaClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-text-area__textarea--has-value": !!wrappedModel.value,
                "cdx-text-area__textarea--is-autosize": props.autosize
            };
        });
        const internalClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-text-area--status-default": computedStatus.value === "default",
                "cdx-text-area--status-error": computedStatus.value === "error",
                "cdx-text-area--has-start-icon": !!props.startIcon,
                "cdx-text-area--has-end-icon": !!props.endIcon
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        const otherAttrsMinusId = (0, $TusQn.computed)(()=>{
            const _a = otherAttrs.value, { id: id } = _a, everythingElse = $db68d79c4ce005fe$var$__objRest(_a, [
                "id"
            ]);
            return everythingElse;
        });
        const textarea = (0, $01W3b.ref)();
        function onInput() {
            if (textarea.value && props.autosize) {
                textarea.value.style.height = "auto";
                textarea.value.style.height = "".concat(textarea.value.scrollHeight, "px");
            }
        }
        return {
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            wrappedModel: wrappedModel,
            computedDisabled: computedDisabled,
            computedInputId: computedInputId,
            descriptionId: descriptionId,
            textareaClasses: textareaClasses,
            otherAttrsMinusId: otherAttrsMinusId,
            textarea: textarea,
            onInput: onInput
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$3 = [
    "id",
    "aria-describedby",
    "disabled"
];
function $db68d79c4ce005fe$var$_sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-text-area",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("textarea", (0, $TusQn.mergeProps)({
            id: _ctx.computedInputId,
            ref: "textarea"
        }, _ctx.otherAttrsMinusId, {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.wrappedModel = $event),
            class: [
                _ctx.textareaClasses,
                "cdx-text-area__textarea"
            ],
            "aria-describedby": _ctx.descriptionId,
            disabled: _ctx.computedDisabled,
            onInput: _cache[1] || (_cache[1] = (...args)=>_ctx.onInput && _ctx.onInput(...args))
        }), null, 16, $db68d79c4ce005fe$var$_hoisted_1$3), [
            [
                (0, $eeJ70.vModelText),
                _ctx.wrappedModel
            ]
        ]),
        _ctx.startIcon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
            key: 0,
            icon: _ctx.startIcon,
            class: "cdx-text-area__icon-vue cdx-text-area__start-icon"
        }, null, 8, [
            "icon"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true),
        _ctx.endIcon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
            key: 1,
            icon: _ctx.endIcon,
            class: "cdx-text-area__icon-vue cdx-text-area__end-icon"
        }, null, 8, [
            "icon"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 6);
}
const $db68d79c4ce005fe$export$7d16ed33844943b8 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$3, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$3
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$2 = (0, $TusQn.defineComponent)({
    name: "CdxToggleButtonGroup",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxToggleButton: $db68d79c4ce005fe$export$e302ca96e16828af
    },
    props: {
        /**
     * Buttons to display. See the ButtonGroupItem type.
     */ buttons: {
            type: Array,
            required: true,
            validator: (value)=>Array.isArray(value) && value.length >= 1
        },
        /**
     * Selected value, or array of selected values.
     *
     * If this is a string or number, the button whose value equals that string or number is
     * selected, and only a single selection is allowed. If this is an array, the buttons whose
     * values equal any of the values in the array are selected, and multiple selections are
     * allowed. To select none of the buttons initially, set this to `null`
     * (for single-selection groups) or to `[]` (for multi-selection groups).
     *
     * Must be bound with `v-model`.
     */ modelValue: {
            type: [
                String,
                Number,
                null,
                Array
            ],
            required: true
        },
        /**
     * Whether the entire group is disabled.
     *
     * If this is set to true, all buttons in the group are disabled. Buttons can also be
     * disabled individually by setting their `disabled` property to true.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * Emitted when modelValue changes.
     *
     * @property {string | number | ( string | number )[]} modelValue The new model value
     */ "update:modelValue"
    ],
    setup (props, { emit: emit }) {
        const { rootElement: rootElement, assignTemplateRef: assignTemplateRef, onFocus: onFocus, onBlur: onBlur, onKeydown: onKeydown } = $db68d79c4ce005fe$var$useButtonGroupKeyboardNav((0, $01W3b.toRef)(props, "buttons"));
        function isSelected(button) {
            if (Array.isArray(props.modelValue)) return props.modelValue.indexOf(button.value) !== -1;
            else if (props.modelValue !== null) return props.modelValue === button.value;
            return false;
        }
        function onUpdate(button, nowSelected) {
            if (Array.isArray(props.modelValue)) {
                const wasSelected = props.modelValue.indexOf(button.value) !== -1;
                if (nowSelected && !wasSelected) emit("update:modelValue", props.modelValue.concat(button.value));
                else if (!nowSelected && wasSelected) emit("update:modelValue", props.modelValue.filter((v)=>v !== button.value));
            } else if (nowSelected && props.modelValue !== button.value) emit("update:modelValue", button.value);
        }
        return {
            rootElement: rootElement,
            assignTemplateRef: assignTemplateRef,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeydown: onKeydown,
            getButtonLabel: $db68d79c4ce005fe$var$getButtonLabel,
            isSelected: isSelected,
            onUpdate: onUpdate
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$2 = {
    ref: "rootElement",
    class: "cdx-toggle-button-group"
};
function $db68d79c4ce005fe$var$_sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_toggle_button = (0, $TusQn.resolveComponent)("cdx-toggle-button");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $db68d79c4ce005fe$var$_hoisted_1$2, [
        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.buttons, (button, index)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_toggle_button, {
                key: button.value,
                ref_for: true,
                ref: (ref2)=>_ctx.assignTemplateRef(ref2, index),
                "model-value": _ctx.isSelected(button),
                disabled: button.disabled || _ctx.disabled,
                "aria-label": button.ariaLabel,
                "onUpdate:modelValue": ($event)=>_ctx.onUpdate(button, $event),
                onFocus: ($event)=>_ctx.onFocus(index),
                onBlur: _ctx.onBlur,
                onKeydown: _ctx.onKeydown
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.renderSlot)(_ctx.$slots, "default", {
                            button: button,
                            selected: _ctx.isSelected(button)
                        }, ()=>[
                                button.icon ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_icon, {
                                    key: 0,
                                    icon: button.icon
                                }, null, 8, [
                                    "icon"
                                ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                                (0, $TusQn.createTextVNode)(" " + (0, $8XWQX.toDisplayString)(_ctx.getButtonLabel(button)), 1)
                            ])
                    ]),
                _: 2
            }, 1032, [
                "model-value",
                "disabled",
                "aria-label",
                "onUpdate:modelValue",
                "onFocus",
                "onBlur",
                "onKeydown"
            ]);
        }), 128))
    ], 512);
}
const $db68d79c4ce005fe$export$97d7169b3dc35473 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$2, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$2
    ]
]);
const $db68d79c4ce005fe$var$_sfc_main$1 = (0, $TusQn.defineComponent)({
    name: "CdxToggleSwitch",
    components: {
        CdxLabel: $db68d79c4ce005fe$export$fd351ab562a06a13
    },
    /**
   * The input element will inherit attributes, not the root element.
   */ inheritAttrs: false,
    props: {
        /**
     * Current value of the toggle switch or toggle switch group.
     *
     * Provided by `v-model` binding in the parent component.
     */ modelValue: {
            type: [
                Boolean,
                Array
            ],
            default: false
        },
        /**
     * HTML "value" attribute to assign to the input element.
     *
     * Required for groups of ToggleSwitches. Can be omitted for single true/false switches.
     */ inputValue: {
            type: [
                String,
                Number,
                Boolean
            ],
            default: false
        },
        /**
     * Whether to align the switch to the end of the container.
     *
     * Useful for ToggleSwitch groups, where each switch should be aligned regardless of
     * label length.
     */ alignSwitch: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the label should be visually hidden.
     *
     * Note that this will also hide the description.
     */ hideLabel: {
            type: Boolean,
            default: false
        },
        /**
     * Whether the disabled attribute should be added to the input.
     */ disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        /**
     * Emitted when modelValue changes.
     *
     * @property {boolean} modelValue The new model value
     */ "update:modelValue"
    ],
    setup (props, { emit: emit, slots: slots, attrs: attrs }) {
        var _a;
        $db68d79c4ce005fe$var$useLabelChecker((_a = slots.default) == null ? void 0 : _a.call(slots), attrs, "CdxToggleSwitch");
        const input = (0, $01W3b.ref)();
        const inputId = $db68d79c4ce005fe$export$6217842283d27b52("toggle-switch");
        const descriptionId = $db68d79c4ce005fe$export$6217842283d27b52("description");
        const internalClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-toggle-switch--align-switch": props.alignSwitch
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        const { computedDisabled: computedDisabled } = $db68d79c4ce005fe$export$2a5cf560aeeed52d((0, $01W3b.toRef)(props, "disabled"));
        const wrappedModel = $db68d79c4ce005fe$export$c9be858be225e6de((0, $01W3b.toRef)(props, "modelValue"), emit);
        const clickInput = ()=>{
            input.value.click();
        };
        return {
            input: input,
            inputId: inputId,
            descriptionId: descriptionId,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            computedDisabled: computedDisabled,
            wrappedModel: wrappedModel,
            clickInput: clickInput
        };
    }
});
const $db68d79c4ce005fe$var$_hoisted_1$1 = [
    "id",
    "aria-describedby",
    "value",
    "disabled"
];
const $db68d79c4ce005fe$var$_hoisted_2$1 = /* @__PURE__ */ (0, $TusQn.createElementVNode)("span", {
    class: "cdx-toggle-switch__switch"
}, [
    /* @__PURE__ */ (0, $TusQn.createElementVNode)("span", {
        class: "cdx-toggle-switch__switch__grip"
    })
], -1);
function $db68d79c4ce005fe$var$_sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_label = (0, $TusQn.resolveComponent)("cdx-label");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-toggle-switch",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)({
            id: _ctx.inputId,
            ref: "input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.wrappedModel = $event),
            class: "cdx-toggle-switch__input",
            type: "checkbox",
            role: "switch",
            "aria-describedby": _ctx.$slots.description && _ctx.$slots.description().length > 0 ? _ctx.descriptionId : void 0,
            value: _ctx.inputValue,
            disabled: _ctx.computedDisabled
        }, _ctx.otherAttrs, {
            onKeydown: _cache[1] || (_cache[1] = (0, $eeJ70.withKeys)((0, $eeJ70.withModifiers)((...args)=>_ctx.clickInput && _ctx.clickInput(...args), [
                "prevent"
            ]), [
                "enter"
            ]))
        }), null, 16, $db68d79c4ce005fe$var$_hoisted_1$1), [
            [
                (0, $eeJ70.vModelCheckbox),
                _ctx.wrappedModel
            ]
        ]),
        $db68d79c4ce005fe$var$_hoisted_2$1,
        _ctx.$slots.default && _ctx.$slots.default().length ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_cdx_label, {
            key: 0,
            class: "cdx-toggle-switch__label",
            "input-id": _ctx.inputId,
            "description-id": _ctx.$slots.description && _ctx.$slots.description().length > 0 ? _ctx.descriptionId : void 0,
            "visually-hidden": _ctx.hideLabel,
            disabled: _ctx.computedDisabled
        }, (0, $TusQn.createSlots)({
            default: (0, $TusQn.withCtx)(()=>[
                    (0, $TusQn.renderSlot)(_ctx.$slots, "default")
                ]),
            _: 2
        }, [
            _ctx.$slots.description && _ctx.$slots.description().length > 0 ? {
                name: "description",
                fn: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.renderSlot)(_ctx.$slots, "description")
                    ]),
                key: "0"
            } : void 0
        ]), 1032, [
            "input-id",
            "description-id",
            "visually-hidden",
            "disabled"
        ])) : (0, $TusQn.createCommentVNode)("v-if", true)
    ], 6);
}
const $db68d79c4ce005fe$export$47bd8c36709c3277 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main$1, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render$1
    ]
]);
class $db68d79c4ce005fe$var$Tooltip {
    constructor(referenceElement, options){
        $db68d79c4ce005fe$var$__publicField(this, "referenceElement");
        $db68d79c4ce005fe$var$__publicField(this, "tooltipElement");
        $db68d79c4ce005fe$var$__publicField(this, "textContent");
        $db68d79c4ce005fe$var$__publicField(this, "placement");
        $db68d79c4ce005fe$var$__publicField(this, "autoUpdateCleanup");
        $db68d79c4ce005fe$var$__publicField(this, "referenceElementHandlers");
        $db68d79c4ce005fe$var$__publicField(this, "tooltipElementHandlers");
        $db68d79c4ce005fe$var$__publicField(this, "escapeHandler");
        $db68d79c4ce005fe$var$__publicField(this, "timeoutId");
        var _a, _b;
        const doc = referenceElement.ownerDocument;
        const tooltipId = $db68d79c4ce005fe$export$6217842283d27b52("tooltip");
        this.referenceElement = referenceElement;
        this.textContent = options.textContent;
        this.placement = (_a = options.placement) != null ? _a : "bottom";
        this.timeoutId = null;
        this.tooltipElement = doc.createElement("div");
        this.tooltipElement.classList.add("cdx-tooltip");
        this.tooltipElement.role = "tooltip";
        this.tooltipElement.id = tooltipId;
        this.referenceElement.setAttribute("aria-describedby", tooltipId);
        this.tooltipElement.textContent = this.textContent;
        (_b = this.referenceElement.parentElement) == null || _b.appendChild(this.tooltipElement);
        this.referenceElementHandlers = {};
        this.referenceElementHandlers.mouseenter = this.show.bind(this);
        this.referenceElementHandlers.mouseleave = this.hideAfterDelay.bind(this);
        this.referenceElementHandlers.focus = this.show.bind(this);
        this.referenceElementHandlers.blur = this.hide.bind(this);
        this.tooltipElementHandlers = {};
        this.tooltipElementHandlers.mouseenter = this.show.bind(this);
        this.tooltipElementHandlers.mouseleave = this.hideAfterDelay.bind(this);
        this.escapeHandler = this.onKeyup.bind(this);
        this.addEventListeners();
        this.autoUpdateCleanup = $db68d79c4ce005fe$var$autoUpdate(this.referenceElement, this.tooltipElement, ()=>this.update());
    }
    isVisible() {
        return this.tooltipElement.style.display === "block";
    }
    show() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
        this.tooltipElement.style.display = "block";
        this.tooltipElement.ownerDocument.addEventListener("keyup", this.escapeHandler);
    }
    hide() {
        this.tooltipElement.style.display = "none";
        this.tooltipElement.ownerDocument.removeEventListener("keyup", this.escapeHandler);
    }
    hideAfterDelay() {
        this.timeoutId = setTimeout(this.hide.bind(this), 250);
    }
    onKeyup(event) {
        if (event.key === "Escape" && this.isVisible()) this.hide();
    }
    addEventListeners() {
        Object.keys(this.referenceElementHandlers).forEach((k)=>{
            this.referenceElement.addEventListener(k, this.referenceElementHandlers[k]);
        });
        Object.keys(this.tooltipElementHandlers).forEach((k)=>{
            this.tooltipElement.addEventListener(k, this.tooltipElementHandlers[k]);
        });
    }
    removeEventListeners() {
        Object.keys(this.referenceElementHandlers).forEach((k)=>{
            this.referenceElement.removeEventListener(k, this.referenceElementHandlers[k]);
        });
        Object.keys(this.tooltipElementHandlers).forEach((k)=>{
            this.tooltipElement.removeEventListener(k, this.tooltipElementHandlers[k]);
        });
    }
    update() {
        $db68d79c4ce005fe$var$computePosition(this.referenceElement, this.tooltipElement, {
            placement: this.placement,
            middleware: [
                $db68d79c4ce005fe$var$offset(4),
                $db68d79c4ce005fe$var$flip(),
                $db68d79c4ce005fe$var$shift(),
                $db68d79c4ce005fe$var$hide()
            ]
        }).then(({ x: x, y: y, middlewareData: middlewareData })=>{
            var _a, _b, _c;
            const finalPlacement = (_b = (_a = middlewareData.offset) == null ? void 0 : _a.placement) != null ? _b : this.placement;
            const opposites = {
                left: "right",
                "left-start": "right",
                "left-end": "right",
                top: "bottom",
                "top-start": "bottom",
                "top-end": "bottom",
                bottom: "top",
                "bottom-start": "top",
                "bottom-end": "top",
                right: "left",
                "right-start": "left",
                "right-end": "left"
            };
            Object.assign(this.tooltipElement.style, {
                left: "".concat(x, "px"),
                top: "".concat(y, "px"),
                visibility: ((_c = middlewareData.hide) == null ? void 0 : _c.referenceHidden) ? "hidden" : "visible",
                transformOrigin: opposites[finalPlacement]
            });
        });
    }
    remove() {
        this.tooltipElement.remove();
        this.autoUpdateCleanup();
        this.removeEventListeners();
    }
}
const $db68d79c4ce005fe$export$e00d4f6eba63ec7d = {
    mounted (el, { value: value, arg: arg }) {
        el.tooltip = new $db68d79c4ce005fe$var$Tooltip(el, {
            textContent: String(value),
            placement: arg
        });
    },
    beforeUnmount (el) {
        if (el.tooltip) el.tooltip.remove();
    }
};
const $db68d79c4ce005fe$var$_sfc_main = (0, $TusQn.defineComponent)({
    name: "CdxTypeaheadSearch",
    components: {
        CdxIcon: $db68d79c4ce005fe$export$675126b72043484a,
        CdxMenu: $db68d79c4ce005fe$export$a33433a93a74f3ad,
        CdxSearchInput: $db68d79c4ce005fe$export$4d07ca0116afbc71
    },
    /**
   * Attributes, besides class, will be passed to the TextInput's input element.
   */ inheritAttrs: false,
    props: {
        /**
     * ID attribute for the form.
     */ id: {
            type: String,
            required: true
        },
        /**
     * Action attribute for form.
     */ formAction: {
            type: String,
            required: true
        },
        /**
     * List of search results. See the SearchResult type.
     */ searchResults: {
            type: Array,
            required: true
        },
        /**
     *
     * Whether to display a submit button.
     */ useButton: {
            type: Boolean,
            default: false
        },
        // DEPRECATED: set default to 'Search' (T368444).
        /**
     * Custom label for the submit button.
     *
     * Omit this prop to use the default value, "Search".
     */ buttonLabel: {
            type: String,
            default: ""
        },
        /**
     * Initial value for the text input.
     *
     * Triggers an initial `input` event on mount.
     */ initialInputValue: {
            type: String,
            default: ""
        },
        /**
     * Link for the final menu item.
     *
     * This will typically be a link to the search page for the current search query.
     */ searchFooterUrl: {
            type: String,
            default: ""
        },
        /**
     * Time interval for debouncing input events, in ms.
     */ debounceInterval: {
            type: Number,
            default: $db68d79c4ce005fe$var$DebounceInterval
        },
        /**
     * Whether the search query should be highlighted within a search result's title.
     */ highlightQuery: {
            type: Boolean,
            default: false
        },
        /**
     * Whether to show search results' thumbnails (or a placeholder icon).
     */ showThumbnail: {
            type: Boolean,
            default: false
        },
        /**
     * Contract the width of the input when unfocused and expand the width of
     * the input when focused to accommodate the extra width of the thumbnails.
     *
     * This prop is ignored if showThumbnail is false.
     */ autoExpandWidth: {
            type: Boolean,
            default: false
        },
        /**
     * Limit the number of menu items to display before scrolling.
     *
     * Setting this prop to anything falsy will show all menu items.
     *
     * By default, all menu items are shown.
     */ visibleItemLimit: {
            type: Number,
            default: null
        }
    },
    emits: [
        /**
     * When the text input value changes. Debounced by default.
     *
     * @property {string} value The new input value
     */ "input",
        /**
     * When a search result is selected.
     *
     * @property {SearchResultClickEvent} event Data for the selected result
     */ "search-result-click",
        /**
     * When the form is submitted.
     *
     * @property {SearchResultClickEvent} event Data for the selected result
     */ "submit",
        /**
     * When the user scrolls towards the bottom of the menu.
     *
     * If it is possible to add or load more menu items, then now would be a good moment
     * so that the user can experience infinite scrolling.
     */ "load-more"
    ],
    setup (props, { attrs: attrs, emit: emit, slots: slots }) {
        const form = (0, $01W3b.ref)();
        const menu = (0, $01W3b.ref)();
        const menuId = $db68d79c4ce005fe$export$6217842283d27b52("typeahead-search-menu");
        const translatedSearchResultsLabel = $db68d79c4ce005fe$export$3f3caade1c12f8c9("cdx-typeahead-search-search-results-label", "Search results");
        const expanded = (0, $01W3b.ref)(false);
        const pending = (0, $01W3b.ref)(false);
        const showPending = (0, $01W3b.ref)(false);
        const isActive = (0, $01W3b.ref)(false);
        const inputValue = (0, $01W3b.ref)(props.initialInputValue);
        const searchQuery = (0, $01W3b.ref)("");
        const highlightedId = (0, $TusQn.computed)(()=>{
            var _a, _b;
            return (_b = (_a = menu.value) == null ? void 0 : _a.getHighlightedMenuItem()) == null ? void 0 : _b.id;
        });
        const selection = (0, $01W3b.ref)(null);
        const menuMessageClass = (0, $TusQn.computed)(()=>({
                "cdx-typeahead-search__menu-message--has-thumbnail": props.showThumbnail
            }));
        const selectedResult = (0, $TusQn.computed)(()=>props.searchResults.find((searchResult)=>searchResult.value === selection.value));
        const footer = (0, $TusQn.computed)(()=>props.searchFooterUrl ? {
                value: $db68d79c4ce005fe$var$MenuFooterValue,
                url: props.searchFooterUrl
            } : void 0);
        const internalClasses = (0, $TusQn.computed)(()=>{
            return {
                "cdx-typeahead-search--show-thumbnail": props.showThumbnail,
                "cdx-typeahead-search--expanded": expanded.value,
                "cdx-typeahead-search--auto-expand-width": props.showThumbnail && props.autoExpandWidth
            };
        });
        const { rootClasses: rootClasses, rootStyle: rootStyle, otherAttrs: otherAttrs } = $db68d79c4ce005fe$export$5f29e82e953f6f41(attrs, internalClasses);
        function asSearchResult(menuItem) {
            return menuItem;
        }
        const menuConfig = (0, $TusQn.computed)(()=>{
            return {
                visibleItemLimit: props.visibleItemLimit,
                showThumbnail: props.showThumbnail,
                // In case search queries aren't highlighted, default to a bold label.
                boldLabel: true,
                hideDescriptionOverflow: true
            };
        });
        let debounceId;
        let pendingDelayId;
        function onUpdateInputValue(newVal, immediate = false) {
            if (selectedResult.value && selectedResult.value.label !== newVal && selectedResult.value.value !== newVal) selection.value = null;
            if (pendingDelayId !== void 0) {
                clearTimeout(pendingDelayId);
                pendingDelayId = void 0;
            }
            if (newVal === "") expanded.value = false;
            else {
                pending.value = true;
                if (slots["search-results-pending"]) pendingDelayId = setTimeout(()=>{
                    if (isActive.value) expanded.value = true;
                    showPending.value = true;
                }, $db68d79c4ce005fe$var$PendingDelay);
            }
            if (debounceId !== void 0) {
                clearTimeout(debounceId);
                debounceId = void 0;
            }
            const handleUpdateInputValue = ()=>{
                emit("input", newVal);
            };
            if (immediate) handleUpdateInputValue();
            else debounceId = setTimeout(()=>{
                handleUpdateInputValue();
            }, props.debounceInterval);
        }
        function onUpdateMenuSelection(newVal) {
            var _a;
            if (newVal === $db68d79c4ce005fe$var$MenuFooterValue) {
                selection.value = null;
                inputValue.value = searchQuery.value;
                return;
            }
            selection.value = newVal;
            if (newVal !== null) inputValue.value = selectedResult.value ? (_a = selectedResult.value.label) != null ? _a : String(selectedResult.value.value) : "";
        }
        function onFocus() {
            isActive.value = true;
            if (searchQuery.value || showPending.value) expanded.value = true;
        }
        function onBlur() {
            isActive.value = false;
            expanded.value = false;
        }
        function onSearchResultClick(searchResult) {
            const _a = searchResult, { id: id } = _a, resultWithoutId = $db68d79c4ce005fe$var$__objRest(_a, [
                "id"
            ]);
            if (resultWithoutId.value === $db68d79c4ce005fe$var$MenuFooterValue) {
                emit("search-result-click", {
                    searchResult: null,
                    index: props.searchResults.length,
                    numberOfResults: props.searchResults.length
                });
                return;
            }
            emitSearchResultClick(resultWithoutId);
        }
        function emitSearchResultClick(searchResult) {
            const searchResultClickEvent = {
                searchResult: searchResult,
                index: props.searchResults.findIndex((r)=>r.value === searchResult.value),
                numberOfResults: props.searchResults.length
            };
            emit("search-result-click", searchResultClickEvent);
        }
        function onSearchResultKeyboardNavigation(searchResult) {
            var _a;
            if (searchResult.value === $db68d79c4ce005fe$var$MenuFooterValue) {
                inputValue.value = searchQuery.value;
                return;
            }
            inputValue.value = searchResult.value ? (_a = searchResult.label) != null ? _a : String(searchResult.value) : "";
        }
        function onSearchFooterClick(footerMenuItem) {
            var _a;
            expanded.value = false;
            (_a = menu.value) == null || _a.clearActive();
            onSearchResultClick(footerMenuItem);
        }
        function onSubmit(e) {
            if (selectedResult.value) {
                emitSearchResultClick(selectedResult.value);
                e.stopPropagation();
                window.location.assign(selectedResult.value.url);
                e.preventDefault();
            } else {
                const submitEvent = {
                    searchResult: null,
                    index: -1,
                    numberOfResults: props.searchResults.length
                };
                emit("submit", submitEvent);
            }
        }
        function onKeydown(e) {
            if (!menu.value || !searchQuery.value || e.key === " ") return;
            const highlightedResult = menu.value.getHighlightedMenuItem();
            const resultHighlightedViaKeyboard = menu.value.getHighlightedViaKeyboard();
            switch(e.key){
                case "Enter":
                    if (highlightedResult) {
                        if (highlightedResult.value === $db68d79c4ce005fe$var$MenuFooterValue && resultHighlightedViaKeyboard) window.location.assign(props.searchFooterUrl);
                        else menu.value.delegateKeyNavigation(e, {
                            prevent: false
                        });
                    }
                    expanded.value = false;
                    break;
                case "Tab":
                    expanded.value = false;
                    break;
                default:
                    menu.value.delegateKeyNavigation(e);
                    break;
            }
        }
        (0, $TusQn.onMounted)(()=>{
            if (props.initialInputValue) onUpdateInputValue(props.initialInputValue, true);
        });
        (0, $TusQn.watch)((0, $01W3b.toRef)(props, "searchResults"), ()=>{
            searchQuery.value = inputValue.value.trim();
            if (isActive.value && pending.value && searchQuery.value.length > 0) expanded.value = true;
            if (pendingDelayId !== void 0) {
                clearTimeout(pendingDelayId);
                pendingDelayId = void 0;
            }
            pending.value = false;
            showPending.value = false;
        });
        return {
            form: form,
            menu: menu,
            menuId: menuId,
            highlightedId: highlightedId,
            selection: selection,
            menuMessageClass: menuMessageClass,
            footer: footer,
            asSearchResult: asSearchResult,
            inputValue: inputValue,
            searchQuery: searchQuery,
            expanded: expanded,
            showPending: showPending,
            rootClasses: rootClasses,
            rootStyle: rootStyle,
            otherAttrs: otherAttrs,
            menuConfig: menuConfig,
            onUpdateInputValue: onUpdateInputValue,
            onUpdateMenuSelection: onUpdateMenuSelection,
            onFocus: onFocus,
            onBlur: onBlur,
            onSearchResultClick: onSearchResultClick,
            onSearchResultKeyboardNavigation: onSearchResultKeyboardNavigation,
            onSearchFooterClick: onSearchFooterClick,
            onSubmit: onSubmit,
            onKeydown: onKeydown,
            MenuFooterValue: $db68d79c4ce005fe$var$MenuFooterValue,
            articleIcon: $db68d79c4ce005fe$var$S3,
            translatedSearchResultsLabel: translatedSearchResultsLabel
        };
    },
    methods: {
        /**
     * Focus the component's input element.
     *
     * @public
     */ focus () {
            const searchInput = this.$refs.searchInput;
            searchInput.focus();
        }
    }
});
const $db68d79c4ce005fe$var$_hoisted_1 = [
    "id",
    "action"
];
const $db68d79c4ce005fe$var$_hoisted_2 = {
    class: "cdx-typeahead-search__menu-message__text"
};
const $db68d79c4ce005fe$var$_hoisted_3 = {
    class: "cdx-typeahead-search__menu-message__text"
};
const $db68d79c4ce005fe$var$_hoisted_4 = [
    "href",
    "onClickCapture"
];
const $db68d79c4ce005fe$var$_hoisted_5 = {
    class: "cdx-menu-item__text cdx-typeahead-search__search-footer__text"
};
const $db68d79c4ce005fe$var$_hoisted_6 = {
    class: "cdx-typeahead-search__search-footer__query"
};
function $db68d79c4ce005fe$var$_sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_cdx_icon = (0, $TusQn.resolveComponent)("cdx-icon");
    const _component_cdx_menu = (0, $TusQn.resolveComponent)("cdx-menu");
    const _component_cdx_search_input = (0, $TusQn.resolveComponent)("cdx-search-input");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
        class: (0, $8XWQX.normalizeClass)([
            "cdx-typeahead-search",
            _ctx.rootClasses
        ]),
        style: (0, $8XWQX.normalizeStyle)(_ctx.rootStyle)
    }, [
        (0, $TusQn.createElementVNode)("form", {
            id: _ctx.id,
            ref: "form",
            class: "cdx-typeahead-search__form",
            action: _ctx.formAction,
            onSubmit: _cache[4] || (_cache[4] = (...args)=>_ctx.onSubmit && _ctx.onSubmit(...args))
        }, [
            (0, $TusQn.createVNode)(_component_cdx_search_input, (0, $TusQn.mergeProps)({
                ref: "searchInput",
                modelValue: _ctx.inputValue,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>_ctx.inputValue = $event),
                "button-label": _ctx.buttonLabel,
                "use-button": _ctx.useButton
            }, _ctx.otherAttrs, {
                class: "cdx-typeahead-search__input",
                name: "search",
                role: "combobox",
                autocomplete: "off",
                "aria-autocomplete": "list",
                "aria-controls": _ctx.menuId,
                "aria-expanded": _ctx.expanded,
                "aria-activedescendant": _ctx.highlightedId,
                "onUpdate:modelValue": _ctx.onUpdateInputValue,
                onFocus: _ctx.onFocus,
                onBlur: _ctx.onBlur,
                onKeydown: _ctx.onKeydown
            }), {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.createVNode)(_component_cdx_menu, (0, $TusQn.mergeProps)({
                            id: _ctx.menuId,
                            ref: "menu",
                            expanded: _ctx.expanded,
                            "onUpdate:expanded": _cache[0] || (_cache[0] = ($event)=>_ctx.expanded = $event),
                            class: "cdx-typeahead-search__menu",
                            "show-pending": _ctx.showPending,
                            selected: _ctx.selection,
                            "menu-items": _ctx.searchResults,
                            footer: _ctx.footer,
                            "search-query": _ctx.highlightQuery ? _ctx.searchQuery : "",
                            "show-no-results-slot": _ctx.searchQuery.length > 0 && _ctx.searchResults.length === 0 && _ctx.$slots["search-no-results-text"] && _ctx.$slots["search-no-results-text"]().length > 0
                        }, _ctx.menuConfig, {
                            "aria-label": _ctx.translatedSearchResultsLabel,
                            "onUpdate:selected": _ctx.onUpdateMenuSelection,
                            onMenuItemClick: _cache[1] || (_cache[1] = (menuItem)=>_ctx.onSearchResultClick(_ctx.asSearchResult(menuItem))),
                            onMenuItemKeyboardNavigation: _ctx.onSearchResultKeyboardNavigation,
                            onLoadMore: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("load-more"))
                        }), {
                            pending: (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createElementVNode)("div", {
                                        class: (0, $8XWQX.normalizeClass)([
                                            "cdx-menu-item__content cdx-typeahead-search__menu-message",
                                            _ctx.menuMessageClass
                                        ])
                                    }, [
                                        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_2, [
                                            (0, $TusQn.renderSlot)(_ctx.$slots, "search-results-pending")
                                        ])
                                    ], 2)
                                ]),
                            "no-results": (0, $TusQn.withCtx)(()=>[
                                    (0, $TusQn.createElementVNode)("div", {
                                        class: (0, $8XWQX.normalizeClass)([
                                            "cdx-menu-item__content cdx-typeahead-search__menu-message",
                                            _ctx.menuMessageClass
                                        ])
                                    }, [
                                        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_3, [
                                            (0, $TusQn.renderSlot)(_ctx.$slots, "search-no-results-text")
                                        ])
                                    ], 2)
                                ]),
                            default: (0, $TusQn.withCtx)(({ menuItem: menuItem, active: active })=>[
                                    menuItem.value === _ctx.MenuFooterValue ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("a", {
                                        key: 0,
                                        class: (0, $8XWQX.normalizeClass)([
                                            "cdx-menu-item__content cdx-typeahead-search__search-footer",
                                            {
                                                "cdx-typeahead-search__search-footer__active": active
                                            }
                                        ]),
                                        href: _ctx.asSearchResult(menuItem).url,
                                        onClickCapture: (0, $eeJ70.withModifiers)(($event)=>_ctx.onSearchFooterClick(_ctx.asSearchResult(menuItem)), [
                                            "stop"
                                        ])
                                    }, [
                                        (0, $TusQn.createVNode)(_component_cdx_icon, {
                                            class: "cdx-menu-item__thumbnail cdx-typeahead-search__search-footer__icon",
                                            icon: _ctx.articleIcon
                                        }, null, 8, [
                                            "icon"
                                        ]),
                                        (0, $TusQn.createElementVNode)("span", $db68d79c4ce005fe$var$_hoisted_5, [
                                            (0, $TusQn.renderSlot)(_ctx.$slots, "search-footer-text", {
                                                searchQuery: _ctx.searchQuery
                                            }, ()=>[
                                                    (0, $TusQn.createElementVNode)("strong", $db68d79c4ce005fe$var$_hoisted_6, (0, $8XWQX.toDisplayString)(_ctx.searchQuery), 1)
                                                ])
                                        ])
                                    ], 42, $db68d79c4ce005fe$var$_hoisted_4)) : (0, $TusQn.createCommentVNode)("v-if", true)
                                ]),
                            _: 3
                        }, 16, [
                            "id",
                            "expanded",
                            "show-pending",
                            "selected",
                            "menu-items",
                            "footer",
                            "search-query",
                            "show-no-results-slot",
                            "aria-label",
                            "onUpdate:selected",
                            "onMenuItemKeyboardNavigation"
                        ])
                    ]),
                _: 3
            }, 16, [
                "modelValue",
                "button-label",
                "use-button",
                "aria-controls",
                "aria-expanded",
                "aria-activedescendant",
                "onUpdate:modelValue",
                "onFocus",
                "onBlur",
                "onKeydown"
            ]),
            (0, $TusQn.renderSlot)(_ctx.$slots, "default")
        ], 40, $db68d79c4ce005fe$var$_hoisted_1)
    ], 6);
}
const $db68d79c4ce005fe$export$c806659652d42b0 = /* @__PURE__ */ $db68d79c4ce005fe$var$_export_sfc($db68d79c4ce005fe$var$_sfc_main, [
    [
        "render",
        $db68d79c4ce005fe$var$_sfc_render
    ]
]);

});

parcelRegister("eZefG", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $ae91d1555267d922$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ae91d1555267d922$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $ae91d1555267d922$var$utf8$5 = {};
var $ae91d1555267d922$var$utils$r = {};
var $ae91d1555267d922$var$support$5 = {};
var $ae91d1555267d922$var$nodestream;
var $ae91d1555267d922$var$blob;
$ae91d1555267d922$var$support$5.base64 = true;
$ae91d1555267d922$var$support$5.array = true;
$ae91d1555267d922$var$support$5.string = true;
$ae91d1555267d922$var$support$5.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
$ae91d1555267d922$var$support$5.nodebuffer = typeof $ae91d1555267d922$require$Buffer !== "undefined";
// contains true if JSZip can read/generate Uint8Array, false otherwise.
$ae91d1555267d922$var$support$5.uint8array = typeof Uint8Array !== "undefined";
if (typeof ArrayBuffer === "undefined") $ae91d1555267d922$var$blob = $ae91d1555267d922$var$support$5.blob = false;
else {
    var $ae91d1555267d922$var$buffer = new ArrayBuffer(0);
    try {
        $ae91d1555267d922$var$blob = $ae91d1555267d922$var$support$5.blob = new Blob([
            $ae91d1555267d922$var$buffer
        ], {
            type: "application/zip"
        }).size === 0;
    } catch (e) {
        try {
            var $ae91d1555267d922$var$Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
            var $ae91d1555267d922$var$builder = new $ae91d1555267d922$var$Builder();
            $ae91d1555267d922$var$builder.append($ae91d1555267d922$var$buffer);
            $ae91d1555267d922$var$blob = $ae91d1555267d922$var$support$5.blob = $ae91d1555267d922$var$builder.getBlob("application/zip").size === 0;
        } catch (e) {
            $ae91d1555267d922$var$blob = $ae91d1555267d922$var$support$5.blob = false;
        }
    }
}

try {
    $ae91d1555267d922$var$nodestream = $ae91d1555267d922$var$support$5.nodestream = !!(parcelRequire("b6RFW")).Readable;
} catch (e) {
    $ae91d1555267d922$var$nodestream = $ae91d1555267d922$var$support$5.nodestream = false;
}
var $ae91d1555267d922$var$base64$1 = {};
var $ae91d1555267d922$var$utils$q = $ae91d1555267d922$var$utils$r;
var $ae91d1555267d922$var$support$4 = $ae91d1555267d922$var$support$5;
// private property
var $ae91d1555267d922$var$_keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
// public method for encoding
$ae91d1555267d922$var$base64$1.encode = function(input) {
    var output = [];
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0, len = input.length, remainingBytes = len;
    var isArray = $ae91d1555267d922$var$utils$q.getTypeOf(input) !== "string";
    while(i < input.length){
        remainingBytes = len - i;
        if (!isArray) {
            chr1 = input.charCodeAt(i++);
            chr2 = i < len ? input.charCodeAt(i++) : 0;
            chr3 = i < len ? input.charCodeAt(i++) : 0;
        } else {
            chr1 = input[i++];
            chr2 = i < len ? input[i++] : 0;
            chr3 = i < len ? input[i++] : 0;
        }
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = remainingBytes > 1 ? (chr2 & 15) << 2 | chr3 >> 6 : 64;
        enc4 = remainingBytes > 2 ? chr3 & 63 : 64;
        output.push($ae91d1555267d922$var$_keyStr.charAt(enc1) + $ae91d1555267d922$var$_keyStr.charAt(enc2) + $ae91d1555267d922$var$_keyStr.charAt(enc3) + $ae91d1555267d922$var$_keyStr.charAt(enc4));
    }
    return output.join("");
};
// public method for decoding
$ae91d1555267d922$var$base64$1.decode = function(input) {
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0, resultIndex = 0;
    var dataUrlPrefix = "data:";
    if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) // This is a common error: people give a data url
    // (data:image/png;base64,iVBOR...) with a {base64: true} and
    // wonders why things don't work.
    // We can detect that the string input looks like a data url but we
    // *can't* be sure it is one: removing everything up to the comma would
    // be too dangerous.
    throw new Error("Invalid base64 input, it looks like a data url.");
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    var totalLength = input.length * 3 / 4;
    if (input.charAt(input.length - 1) === $ae91d1555267d922$var$_keyStr.charAt(64)) totalLength--;
    if (input.charAt(input.length - 2) === $ae91d1555267d922$var$_keyStr.charAt(64)) totalLength--;
    if (totalLength % 1 !== 0) // totalLength is not an integer, the length does not match a valid
    // base64 content. That can happen if:
    // - the input is not a base64 content
    // - the input is *almost* a base64 content, with a extra chars at the
    //   beginning or at the end
    // - the input uses a base64 variant (base64url for example)
    throw new Error("Invalid base64 input, bad content length.");
    var output;
    if ($ae91d1555267d922$var$support$4.uint8array) output = new Uint8Array(totalLength | 0);
    else output = new Array(totalLength | 0);
    while(i < input.length){
        enc1 = $ae91d1555267d922$var$_keyStr.indexOf(input.charAt(i++));
        enc2 = $ae91d1555267d922$var$_keyStr.indexOf(input.charAt(i++));
        enc3 = $ae91d1555267d922$var$_keyStr.indexOf(input.charAt(i++));
        enc4 = $ae91d1555267d922$var$_keyStr.indexOf(input.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        output[resultIndex++] = chr1;
        if (enc3 !== 64) output[resultIndex++] = chr2;
        if (enc4 !== 64) output[resultIndex++] = chr3;
    }
    return output;
};
var $ae91d1555267d922$var$nodejsUtils$2 = {
    /**
     * True if this is running in Nodejs, will be undefined in a browser.
     * In a browser, browserify won't include this file and the whole module
     * will be resolved an empty object.
     */ isNode: typeof $ae91d1555267d922$require$Buffer !== "undefined",
    /**
     * Create a new nodejs Buffer from an existing content.
     * @param {Object} data the data to pass to the constructor.
     * @param {String} encoding the encoding to use.
     * @return {Buffer} a new Buffer.
     */ newBufferFrom: function(data, encoding) {
        if ($ae91d1555267d922$require$Buffer.from && $ae91d1555267d922$require$Buffer.from !== Uint8Array.from) return $ae91d1555267d922$require$Buffer.from(data, encoding);
        else {
            if (typeof data === "number") // Safeguard for old Node.js versions. On newer versions,
            // Buffer.from(number) / Buffer(number, encoding) already throw.
            throw new Error('The "data" argument must not be a number');
            return new $ae91d1555267d922$require$Buffer(data, encoding);
        }
    },
    /**
     * Create a new nodejs Buffer with the specified size.
     * @param {Integer} size the size of the buffer.
     * @return {Buffer} a new Buffer.
     */ allocBuffer: function(size) {
        if ($ae91d1555267d922$require$Buffer.alloc) return $ae91d1555267d922$require$Buffer.alloc(size);
        else {
            var buf = new $ae91d1555267d922$require$Buffer(size);
            buf.fill(0);
            return buf;
        }
    },
    /**
     * Find out if an object is a Buffer.
     * @param {Object} b the object to test.
     * @return {Boolean} true if the object is a Buffer, false otherwise.
     */ isBuffer: function(b) {
        return $ae91d1555267d922$require$Buffer.isBuffer(b);
    },
    isStream: function(obj) {
        return obj && typeof obj.on === "function" && typeof obj.pause === "function" && typeof obj.resume === "function";
    }
};
var $ae91d1555267d922$var$setImmediateShim = typeof setImmediate === "function" ? setImmediate : function setImmediate1() {
    var args = [].slice.apply(arguments);
    args.splice(1, 0, 0);
    setTimeout.apply(null, args);
};
var $ae91d1555267d922$var$Mutation = $ae91d1555267d922$var$commonjsGlobal.MutationObserver || $ae91d1555267d922$var$commonjsGlobal.WebKitMutationObserver;
var $ae91d1555267d922$var$scheduleDrain;
if ($ae91d1555267d922$var$Mutation) {
    var $ae91d1555267d922$var$called = 0;
    var $ae91d1555267d922$var$observer = new $ae91d1555267d922$var$Mutation($ae91d1555267d922$var$nextTick);
    var $ae91d1555267d922$var$element = $ae91d1555267d922$var$commonjsGlobal.document.createTextNode("");
    $ae91d1555267d922$var$observer.observe($ae91d1555267d922$var$element, {
        characterData: true
    });
    $ae91d1555267d922$var$scheduleDrain = function() {
        $ae91d1555267d922$var$element.data = $ae91d1555267d922$var$called = ++$ae91d1555267d922$var$called % 2;
    };
} else if (!$ae91d1555267d922$var$commonjsGlobal.setImmediate && typeof $ae91d1555267d922$var$commonjsGlobal.MessageChannel !== "undefined") {
    var $ae91d1555267d922$var$channel = new $ae91d1555267d922$var$commonjsGlobal.MessageChannel();
    $ae91d1555267d922$var$channel.port1.onmessage = $ae91d1555267d922$var$nextTick;
    $ae91d1555267d922$var$scheduleDrain = function() {
        $ae91d1555267d922$var$channel.port2.postMessage(0);
    };
} else if ("document" in $ae91d1555267d922$var$commonjsGlobal && "onreadystatechange" in $ae91d1555267d922$var$commonjsGlobal.document.createElement("script")) $ae91d1555267d922$var$scheduleDrain = function() {
    // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
    // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
    var scriptEl = $ae91d1555267d922$var$commonjsGlobal.document.createElement("script");
    scriptEl.onreadystatechange = function() {
        $ae91d1555267d922$var$nextTick();
        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
    };
    $ae91d1555267d922$var$commonjsGlobal.document.documentElement.appendChild(scriptEl);
};
else $ae91d1555267d922$var$scheduleDrain = function() {
    setTimeout($ae91d1555267d922$var$nextTick, 0);
};
var $ae91d1555267d922$var$draining;
var $ae91d1555267d922$var$queue = [];
//named nextTick for less confusing stack traces
function $ae91d1555267d922$var$nextTick() {
    $ae91d1555267d922$var$draining = true;
    var i, oldQueue;
    var len = $ae91d1555267d922$var$queue.length;
    while(len){
        oldQueue = $ae91d1555267d922$var$queue;
        $ae91d1555267d922$var$queue = [];
        i = -1;
        while(++i < len)oldQueue[i]();
        len = $ae91d1555267d922$var$queue.length;
    }
    $ae91d1555267d922$var$draining = false;
}
var $ae91d1555267d922$var$lib$2 = $ae91d1555267d922$var$immediate$1;
function $ae91d1555267d922$var$immediate$1(task) {
    if ($ae91d1555267d922$var$queue.push(task) === 1 && !$ae91d1555267d922$var$draining) $ae91d1555267d922$var$scheduleDrain();
}
var $ae91d1555267d922$var$immediate = $ae91d1555267d922$var$lib$2;
/* istanbul ignore next */ function $ae91d1555267d922$var$INTERNAL() {}
var $ae91d1555267d922$var$handlers = {};
var $ae91d1555267d922$var$REJECTED = [
    "REJECTED"
];
var $ae91d1555267d922$var$FULFILLED = [
    "FULFILLED"
];
var $ae91d1555267d922$var$PENDING = [
    "PENDING"
];
var $ae91d1555267d922$var$UNHANDLED;
var $ae91d1555267d922$var$lib$1 = $ae91d1555267d922$var$Promise$1;
function $ae91d1555267d922$var$Promise$1(resolver) {
    if (typeof resolver !== "function") throw new TypeError("resolver must be a function");
    this.state = $ae91d1555267d922$var$PENDING;
    this.queue = [];
    this.outcome = void 0;
    if (resolver !== $ae91d1555267d922$var$INTERNAL) $ae91d1555267d922$var$safelyResolveThenable(this, resolver);
}
$ae91d1555267d922$var$Promise$1.prototype.finally = function(callback) {
    if (typeof callback !== "function") return this;
    var p = this.constructor;
    return this.then(resolve, reject);
    function resolve(value) {
        function yes() {
            return value;
        }
        return p.resolve(callback()).then(yes);
    }
    function reject(reason) {
        function no() {
            throw reason;
        }
        return p.resolve(callback()).then(no);
    }
};
$ae91d1555267d922$var$Promise$1.prototype.catch = function(onRejected) {
    return this.then(null, onRejected);
};
$ae91d1555267d922$var$Promise$1.prototype.then = function(onFulfilled, onRejected) {
    if (typeof onFulfilled !== "function" && this.state === $ae91d1555267d922$var$FULFILLED || typeof onRejected !== "function" && this.state === $ae91d1555267d922$var$REJECTED) return this;
    var promise = new this.constructor($ae91d1555267d922$var$INTERNAL);
    if (this.state !== $ae91d1555267d922$var$PENDING) {
        var resolver = this.state === $ae91d1555267d922$var$FULFILLED ? onFulfilled : onRejected;
        $ae91d1555267d922$var$unwrap(promise, resolver, this.outcome);
    } else this.queue.push(new $ae91d1555267d922$var$QueueItem(promise, onFulfilled, onRejected));
    return promise;
};
function $ae91d1555267d922$var$QueueItem(promise, onFulfilled, onRejected) {
    this.promise = promise;
    if (typeof onFulfilled === "function") {
        this.onFulfilled = onFulfilled;
        this.callFulfilled = this.otherCallFulfilled;
    }
    if (typeof onRejected === "function") {
        this.onRejected = onRejected;
        this.callRejected = this.otherCallRejected;
    }
}
$ae91d1555267d922$var$QueueItem.prototype.callFulfilled = function(value) {
    $ae91d1555267d922$var$handlers.resolve(this.promise, value);
};
$ae91d1555267d922$var$QueueItem.prototype.otherCallFulfilled = function(value) {
    $ae91d1555267d922$var$unwrap(this.promise, this.onFulfilled, value);
};
$ae91d1555267d922$var$QueueItem.prototype.callRejected = function(value) {
    $ae91d1555267d922$var$handlers.reject(this.promise, value);
};
$ae91d1555267d922$var$QueueItem.prototype.otherCallRejected = function(value) {
    $ae91d1555267d922$var$unwrap(this.promise, this.onRejected, value);
};
function $ae91d1555267d922$var$unwrap(promise, func, value) {
    $ae91d1555267d922$var$immediate(function() {
        var returnValue;
        try {
            returnValue = func(value);
        } catch (e) {
            return $ae91d1555267d922$var$handlers.reject(promise, e);
        }
        if (returnValue === promise) $ae91d1555267d922$var$handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
        else $ae91d1555267d922$var$handlers.resolve(promise, returnValue);
    });
}
$ae91d1555267d922$var$handlers.resolve = function(self1, value) {
    var result = $ae91d1555267d922$var$tryCatch($ae91d1555267d922$var$getThen, value);
    if (result.status === "error") return $ae91d1555267d922$var$handlers.reject(self1, result.value);
    var thenable = result.value;
    if (thenable) $ae91d1555267d922$var$safelyResolveThenable(self1, thenable);
    else {
        self1.state = $ae91d1555267d922$var$FULFILLED;
        self1.outcome = value;
        var i = -1;
        var len = self1.queue.length;
        while(++i < len)self1.queue[i].callFulfilled(value);
    }
    return self1;
};
$ae91d1555267d922$var$handlers.reject = function(self1, error) {
    self1.state = $ae91d1555267d922$var$REJECTED;
    self1.outcome = error;
    var i = -1;
    var len = self1.queue.length;
    while(++i < len)self1.queue[i].callRejected(error);
    return self1;
};
function $ae91d1555267d922$var$getThen(obj) {
    // Make sure we only access the accessor once as required by the spec
    var then = obj && obj.then;
    if (obj && (typeof obj === "object" || typeof obj === "function") && typeof then === "function") return function appyThen() {
        then.apply(obj, arguments);
    };
}
function $ae91d1555267d922$var$safelyResolveThenable(self1, thenable) {
    // Either fulfill, reject or reject with error
    var called = false;
    function onError(value) {
        if (called) return;
        called = true;
        $ae91d1555267d922$var$handlers.reject(self1, value);
    }
    function onSuccess(value) {
        if (called) return;
        called = true;
        $ae91d1555267d922$var$handlers.resolve(self1, value);
    }
    function tryToUnwrap() {
        thenable(onSuccess, onError);
    }
    var result = $ae91d1555267d922$var$tryCatch(tryToUnwrap);
    if (result.status === "error") onError(result.value);
}
function $ae91d1555267d922$var$tryCatch(func, value) {
    var out = {};
    try {
        out.value = func(value);
        out.status = "success";
    } catch (e) {
        out.status = "error";
        out.value = e;
    }
    return out;
}
$ae91d1555267d922$var$Promise$1.resolve = $ae91d1555267d922$var$resolve;
function $ae91d1555267d922$var$resolve(value) {
    if (value instanceof this) return value;
    return $ae91d1555267d922$var$handlers.resolve(new this($ae91d1555267d922$var$INTERNAL), value);
}
$ae91d1555267d922$var$Promise$1.reject = $ae91d1555267d922$var$reject;
function $ae91d1555267d922$var$reject(reason) {
    var promise = new this($ae91d1555267d922$var$INTERNAL);
    return $ae91d1555267d922$var$handlers.reject(promise, reason);
}
$ae91d1555267d922$var$Promise$1.all = $ae91d1555267d922$var$all;
function $ae91d1555267d922$var$all(iterable) {
    var self1 = this;
    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
    var len = iterable.length;
    var called = false;
    if (!len) return this.resolve([]);
    var values = new Array(len);
    var resolved = 0;
    var i = -1;
    var promise = new this($ae91d1555267d922$var$INTERNAL);
    while(++i < len)allResolver(iterable[i], i);
    return promise;
    function allResolver(value, i) {
        self1.resolve(value).then(resolveFromAll, function(error) {
            if (!called) {
                called = true;
                $ae91d1555267d922$var$handlers.reject(promise, error);
            }
        });
        function resolveFromAll(outValue) {
            values[i] = outValue;
            if (++resolved === len && !called) {
                called = true;
                $ae91d1555267d922$var$handlers.resolve(promise, values);
            }
        }
    }
}
$ae91d1555267d922$var$Promise$1.race = $ae91d1555267d922$var$race;
function $ae91d1555267d922$var$race(iterable) {
    var self1 = this;
    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
    var len = iterable.length;
    var called = false;
    if (!len) return this.resolve([]);
    var i = -1;
    var promise = new this($ae91d1555267d922$var$INTERNAL);
    while(++i < len)resolver(iterable[i]);
    return promise;
    function resolver(value) {
        self1.resolve(value).then(function(response) {
            if (!called) {
                called = true;
                $ae91d1555267d922$var$handlers.resolve(promise, response);
            }
        }, function(error) {
            if (!called) {
                called = true;
                $ae91d1555267d922$var$handlers.reject(promise, error);
            }
        });
    }
}
/* global Promise */ // load the global object first:
// - it should be better integrated in the system (unhandledRejection in node)
// - the environment may have a custom Promise implementation (see zone.js)
var $ae91d1555267d922$var$ES6Promise = null;
if (typeof Promise !== "undefined") $ae91d1555267d922$var$ES6Promise = Promise;
else $ae91d1555267d922$var$ES6Promise = $ae91d1555267d922$var$lib$1;
/**
 * Let the user use/change some implementations.
 */ var $ae91d1555267d922$var$external$3 = {
    Promise: $ae91d1555267d922$var$ES6Promise
};
(function(exports1) {
    var support = $ae91d1555267d922$var$support$5;
    var base64 = $ae91d1555267d922$var$base64$1;
    var nodejsUtils = $ae91d1555267d922$var$nodejsUtils$2;
    var setImmediate1 = $ae91d1555267d922$var$setImmediateShim;
    var external = $ae91d1555267d922$var$external$3;
    /**
 * Convert a string that pass as a "binary string": it should represent a byte
 * array but may have > 255 char codes. Be sure to take only the first byte
 * and returns the byte array.
 * @param {String} str the string to transform.
 * @return {Array|Uint8Array} the string in a binary format.
 */ function string2binary(str) {
        var result = null;
        if (support.uint8array) result = new Uint8Array(str.length);
        else result = new Array(str.length);
        return stringToArrayLike(str, result);
    }
    /**
 * Create a new blob with the given content and the given type.
 * @param {String|ArrayBuffer} part the content to put in the blob. DO NOT use
 * an Uint8Array because the stock browser of android 4 won't accept it (it
 * will be silently converted to a string, "[object Uint8Array]").
 *
 * Use only ONE part to build the blob to avoid a memory leak in IE11 / Edge:
 * when a large amount of Array is used to create the Blob, the amount of
 * memory consumed is nearly 100 times the original data amount.
 *
 * @param {String} type the mime type of the blob.
 * @return {Blob} the created blob.
 */ exports1.newBlob = function(part, type) {
        exports1.checkSupport("blob");
        try {
            // Blob constructor
            return new Blob([
                part
            ], {
                type: type
            });
        } catch (e) {
            try {
                // deprecated, browser only, old way
                var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
                var builder = new Builder();
                builder.append(part);
                return builder.getBlob(type);
            } catch (e) {
                // well, fuck ?!
                throw new Error("Bug : can't construct the Blob.");
            }
        }
    };
    /**
 * The identity function.
 * @param {Object} input the input.
 * @return {Object} the same input.
 */ function identity(input) {
        return input;
    }
    /**
 * Fill in an array with a string.
 * @param {String} str the string to use.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
 */ function stringToArrayLike(str, array) {
        for(var i = 0; i < str.length; ++i)array[i] = str.charCodeAt(i) & 0xFF;
        return array;
    }
    /**
 * An helper for the function arrayLikeToString.
 * This contains static information and functions that
 * can be optimized by the browser JIT compiler.
 */ var arrayToStringHelper = {
        /**
     * Transform an array of int into a string, chunk by chunk.
     * See the performances notes on arrayLikeToString.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @param {String} type the type of the array.
     * @param {Integer} chunk the chunk size.
     * @return {String} the resulting string.
     * @throws Error if the chunk is too big for the stack.
     */ stringifyByChunk: function(array, type, chunk) {
            var result = [], k = 0, len = array.length;
            // shortcut
            if (len <= chunk) return String.fromCharCode.apply(null, array);
            while(k < len){
                if (type === "array" || type === "nodebuffer") result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
                else result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
                k += chunk;
            }
            return result.join("");
        },
        /**
     * Call String.fromCharCode on every item in the array.
     * This is the naive implementation, which generate A LOT of intermediate string.
     * This should be used when everything else fail.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @return {String} the result.
     */ stringifyByChar: function(array) {
            var resultStr = "";
            for(var i = 0; i < array.length; i++)resultStr += String.fromCharCode(array[i]);
            return resultStr;
        },
        applyCanBeUsed: {
            /**
         * true if the browser accepts to use String.fromCharCode on Uint8Array
         */ uint8array: function() {
                try {
                    return support.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
                } catch (e) {
                    return false;
                }
            }(),
            /**
         * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
         */ nodebuffer: function() {
                try {
                    return support.nodebuffer && String.fromCharCode.apply(null, nodejsUtils.allocBuffer(1)).length === 1;
                } catch (e) {
                    return false;
                }
            }()
        }
    };
    /**
 * Transform an array-like object to a string.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
 * @return {String} the result.
 */ function arrayLikeToString(array) {
        // Performances notes :
        // --------------------
        // String.fromCharCode.apply(null, array) is the fastest, see
        // see http://jsperf.com/converting-a-uint8array-to-a-string/2
        // but the stack is limited (and we can get huge arrays !).
        //
        // result += String.fromCharCode(array[i]); generate too many strings !
        //
        // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
        // TODO : we now have workers that split the work. Do we still need that ?
        var chunk = 65536, type = exports1.getTypeOf(array), canUseApply = true;
        if (type === "uint8array") canUseApply = arrayToStringHelper.applyCanBeUsed.uint8array;
        else if (type === "nodebuffer") canUseApply = arrayToStringHelper.applyCanBeUsed.nodebuffer;
        if (canUseApply) {
            while(chunk > 1)try {
                return arrayToStringHelper.stringifyByChunk(array, type, chunk);
            } catch (e) {
                chunk = Math.floor(chunk / 2);
            }
        }
        // no apply or chunk error : slow and painful algorithm
        // default browser on android 4.*
        return arrayToStringHelper.stringifyByChar(array);
    }
    exports1.applyFromCharCode = arrayLikeToString;
    /**
 * Copy the data from an array-like to an other array-like.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
 */ function arrayLikeToArrayLike(arrayFrom, arrayTo) {
        for(var i = 0; i < arrayFrom.length; i++)arrayTo[i] = arrayFrom[i];
        return arrayTo;
    }
    // a matrix containing functions to transform everything into everything.
    var transform = {};
    // string to ?
    transform["string"] = {
        "string": identity,
        "array": function(input) {
            return stringToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function(input) {
            return transform["string"]["uint8array"](input).buffer;
        },
        "uint8array": function(input) {
            return stringToArrayLike(input, new Uint8Array(input.length));
        },
        "nodebuffer": function(input) {
            return stringToArrayLike(input, nodejsUtils.allocBuffer(input.length));
        }
    };
    // array to ?
    transform["array"] = {
        "string": arrayLikeToString,
        "array": identity,
        "arraybuffer": function(input) {
            return new Uint8Array(input).buffer;
        },
        "uint8array": function(input) {
            return new Uint8Array(input);
        },
        "nodebuffer": function(input) {
            return nodejsUtils.newBufferFrom(input);
        }
    };
    // arraybuffer to ?
    transform["arraybuffer"] = {
        "string": function(input) {
            return arrayLikeToString(new Uint8Array(input));
        },
        "array": function(input) {
            return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
        },
        "arraybuffer": identity,
        "uint8array": function(input) {
            return new Uint8Array(input);
        },
        "nodebuffer": function(input) {
            return nodejsUtils.newBufferFrom(new Uint8Array(input));
        }
    };
    // uint8array to ?
    transform["uint8array"] = {
        "string": arrayLikeToString,
        "array": function(input) {
            return arrayLikeToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function(input) {
            return input.buffer;
        },
        "uint8array": identity,
        "nodebuffer": function(input) {
            return nodejsUtils.newBufferFrom(input);
        }
    };
    // nodebuffer to ?
    transform["nodebuffer"] = {
        "string": arrayLikeToString,
        "array": function(input) {
            return arrayLikeToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function(input) {
            return transform["nodebuffer"]["uint8array"](input).buffer;
        },
        "uint8array": function(input) {
            return arrayLikeToArrayLike(input, new Uint8Array(input.length));
        },
        "nodebuffer": identity
    };
    /**
 * Transform an input into any type.
 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
 * If no output type is specified, the unmodified input will be returned.
 * @param {String} outputType the output type.
 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
 * @throws {Error} an Error if the browser doesn't support the requested output type.
 */ exports1.transformTo = function(outputType, input) {
        if (!input) // undefined, null, etc
        // an empty string won't harm.
        input = "";
        if (!outputType) return input;
        exports1.checkSupport(outputType);
        var inputType = exports1.getTypeOf(input);
        var result = transform[inputType][outputType](input);
        return result;
    };
    /**
 * Return the type of the input.
 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
 * @param {Object} input the input to identify.
 * @return {String} the (lowercase) type of the input.
 */ exports1.getTypeOf = function(input) {
        if (typeof input === "string") return "string";
        if (Object.prototype.toString.call(input) === "[object Array]") return "array";
        if (support.nodebuffer && nodejsUtils.isBuffer(input)) return "nodebuffer";
        if (support.uint8array && input instanceof Uint8Array) return "uint8array";
        if (support.arraybuffer && input instanceof ArrayBuffer) return "arraybuffer";
    };
    /**
 * Throw an exception if the type is not supported.
 * @param {String} type the type to check.
 * @throws {Error} an Error if the browser doesn't support the requested type.
 */ exports1.checkSupport = function(type) {
        var supported = support[type.toLowerCase()];
        if (!supported) throw new Error(type + " is not supported by this platform");
    };
    exports1.MAX_VALUE_16BITS = 65535;
    exports1.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
    /**
 * Prettify a string read as binary.
 * @param {string} str the string to prettify.
 * @return {string} a pretty string.
 */ exports1.pretty = function(str) {
        var res = "", code, i;
        for(i = 0; i < (str || "").length; i++){
            code = str.charCodeAt(i);
            res += "\\x" + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
        }
        return res;
    };
    /**
 * Defer the call of a function.
 * @param {Function} callback the function to call asynchronously.
 * @param {Array} args the arguments to give to the callback.
 */ exports1.delay = function(callback, args, self1) {
        setImmediate1(function() {
            callback.apply(self1 || null, args || []);
        });
    };
    /**
 * Extends a prototype with an other, without calling a constructor with
 * side effects. Inspired by nodejs' `utils.inherits`
 * @param {Function} ctor the constructor to augment
 * @param {Function} superCtor the parent constructor to use
 */ exports1.inherits = function(ctor, superCtor) {
        var Obj = function() {};
        Obj.prototype = superCtor.prototype;
        ctor.prototype = new Obj();
    };
    /**
 * Merge the objects passed as parameters into a new one.
 * @private
 * @param {...Object} var_args All objects to merge.
 * @return {Object} a new object with the data of the others.
 */ exports1.extend = function() {
        var result = {}, i, attr;
        for(i = 0; i < arguments.length; i++){
            for(attr in arguments[i])if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") result[attr] = arguments[i][attr];
        }
        return result;
    };
    /**
 * Transform arbitrary content into a Promise.
 * @param {String} name a name for the content being processed.
 * @param {Object} inputData the content to process.
 * @param {Boolean} isBinary true if the content is not an unicode string
 * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
 * @param {Boolean} isBase64 true if the string content is encoded with base64.
 * @return {Promise} a promise in a format usable by JSZip.
 */ exports1.prepareContent = function(name, inputData, isBinary, isOptimizedBinaryString, isBase64) {
        // if inputData is already a promise, this flatten it.
        var promise = external.Promise.resolve(inputData).then(function(data) {
            var isBlob = support.blob && (data instanceof Blob || [
                "[object File]",
                "[object Blob]"
            ].indexOf(Object.prototype.toString.call(data)) !== -1);
            if (isBlob && typeof FileReader !== "undefined") return new external.Promise(function(resolve, reject) {
                var reader = new FileReader();
                reader.onload = function(e) {
                    resolve(e.target.result);
                };
                reader.onerror = function(e) {
                    reject(e.target.error);
                };
                reader.readAsArrayBuffer(data);
            });
            else return data;
        });
        return promise.then(function(data) {
            var dataType = exports1.getTypeOf(data);
            if (!dataType) return external.Promise.reject(new Error("Can't read the data of '" + name + "'. Is it " + "in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
            // special case : it's way easier to work with Uint8Array than with ArrayBuffer
            if (dataType === "arraybuffer") data = exports1.transformTo("uint8array", data);
            else if (dataType === "string") {
                if (isBase64) data = base64.decode(data);
                else if (isBinary) // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
                {
                    if (isOptimizedBinaryString !== true) // this is a string, not in a base64 format.
                    // Be sure that this is a correct "binary string"
                    data = string2binary(data);
                }
            }
            return data;
        });
    };
})($ae91d1555267d922$var$utils$r);
/**
 * A worker that does nothing but passing chunks to the next one. This is like
 * a nodejs stream but with some differences. On the good side :
 * - it works on IE 6-9 without any issue / polyfill
 * - it weights less than the full dependencies bundled with browserify
 * - it forwards errors (no need to declare an error handler EVERYWHERE)
 *
 * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
 * object containing anything (`percent` for example), see each worker for more
 * details. The latter is the real data (String, Uint8Array, etc).
 *
 * @constructor
 * @param {String} name the name of the stream (mainly used for debugging purposes)
 */ function $ae91d1555267d922$var$GenericWorker$b(name) {
    // the name of the worker
    this.name = name || "default";
    // an object containing metadata about the workers chain
    this.streamInfo = {};
    // an error which happened when the worker was paused
    this.generatedError = null;
    // an object containing metadata to be merged by this worker into the general metadata
    this.extraStreamInfo = {};
    // true if the stream is paused (and should not do anything), false otherwise
    this.isPaused = true;
    // true if the stream is finished (and should not do anything), false otherwise
    this.isFinished = false;
    // true if the stream is locked to prevent further structure updates (pipe), false otherwise
    this.isLocked = false;
    // the event listeners
    this._listeners = {
        "data": [],
        "end": [],
        "error": []
    };
    // the previous worker, if any
    this.previous = null;
}
$ae91d1555267d922$var$GenericWorker$b.prototype = {
    /**
     * Push a chunk to the next workers.
     * @param {Object} chunk the chunk to push
     */ push: function(chunk) {
        this.emit("data", chunk);
    },
    /**
     * End the stream.
     * @return {Boolean} true if this call ended the worker, false otherwise.
     */ end: function() {
        if (this.isFinished) return false;
        this.flush();
        try {
            this.emit("end");
            this.cleanUp();
            this.isFinished = true;
        } catch (e) {
            this.emit("error", e);
        }
        return true;
    },
    /**
     * End the stream with an error.
     * @param {Error} e the error which caused the premature end.
     * @return {Boolean} true if this call ended the worker with an error, false otherwise.
     */ error: function(e) {
        if (this.isFinished) return false;
        if (this.isPaused) this.generatedError = e;
        else {
            this.isFinished = true;
            this.emit("error", e);
            // in the workers chain exploded in the middle of the chain,
            // the error event will go downward but we also need to notify
            // workers upward that there has been an error.
            if (this.previous) this.previous.error(e);
            this.cleanUp();
        }
        return true;
    },
    /**
     * Add a callback on an event.
     * @param {String} name the name of the event (data, end, error)
     * @param {Function} listener the function to call when the event is triggered
     * @return {GenericWorker} the current object for chainability
     */ on: function(name, listener) {
        this._listeners[name].push(listener);
        return this;
    },
    /**
     * Clean any references when a worker is ending.
     */ cleanUp: function() {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null;
        this._listeners = [];
    },
    /**
     * Trigger an event. This will call registered callback with the provided arg.
     * @param {String} name the name of the event (data, end, error)
     * @param {Object} arg the argument to call the callback with.
     */ emit: function(name, arg) {
        if (this._listeners[name]) for(var i = 0; i < this._listeners[name].length; i++)this._listeners[name][i].call(this, arg);
    },
    /**
     * Chain a worker with an other.
     * @param {Worker} next the worker receiving events from the current one.
     * @return {worker} the next worker for chainability
     */ pipe: function(next) {
        return next.registerPrevious(this);
    },
    /**
     * Same as `pipe` in the other direction.
     * Using an API with `pipe(next)` is very easy.
     * Implementing the API with the point of view of the next one registering
     * a source is easier, see the ZipFileWorker.
     * @param {Worker} previous the previous worker, sending events to this one
     * @return {Worker} the current worker for chainability
     */ registerPrevious: function(previous) {
        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
        // sharing the streamInfo...
        this.streamInfo = previous.streamInfo;
        // ... and adding our own bits
        this.mergeStreamInfo();
        this.previous = previous;
        var self1 = this;
        previous.on("data", function(chunk) {
            self1.processChunk(chunk);
        });
        previous.on("end", function() {
            self1.end();
        });
        previous.on("error", function(e) {
            self1.error(e);
        });
        return this;
    },
    /**
     * Pause the stream so it doesn't send events anymore.
     * @return {Boolean} true if this call paused the worker, false otherwise.
     */ pause: function() {
        if (this.isPaused || this.isFinished) return false;
        this.isPaused = true;
        if (this.previous) this.previous.pause();
        return true;
    },
    /**
     * Resume a paused stream.
     * @return {Boolean} true if this call resumed the worker, false otherwise.
     */ resume: function() {
        if (!this.isPaused || this.isFinished) return false;
        this.isPaused = false;
        // if true, the worker tried to resume but failed
        var withError = false;
        if (this.generatedError) {
            this.error(this.generatedError);
            withError = true;
        }
        if (this.previous) this.previous.resume();
        return !withError;
    },
    /**
     * Flush any remaining bytes as the stream is ending.
     */ flush: function() {},
    /**
     * Process a chunk. This is usually the method overridden.
     * @param {Object} chunk the chunk to process.
     */ processChunk: function(chunk) {
        this.push(chunk);
    },
    /**
     * Add a key/value to be added in the workers chain streamInfo once activated.
     * @param {String} key the key to use
     * @param {Object} value the associated value
     * @return {Worker} the current worker for chainability
     */ withStreamInfo: function(key, value) {
        this.extraStreamInfo[key] = value;
        this.mergeStreamInfo();
        return this;
    },
    /**
     * Merge this worker's streamInfo into the chain's streamInfo.
     */ mergeStreamInfo: function() {
        for(var key in this.extraStreamInfo){
            if (!this.extraStreamInfo.hasOwnProperty(key)) continue;
            this.streamInfo[key] = this.extraStreamInfo[key];
        }
    },
    /**
     * Lock the stream to prevent further updates on the workers chain.
     * After calling this method, all calls to pipe will fail.
     */ lock: function() {
        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
        this.isLocked = true;
        if (this.previous) this.previous.lock();
    },
    /**
     *
     * Pretty print the workers chain.
     */ toString: function() {
        var me = "Worker " + this.name;
        if (this.previous) return this.previous + " -> " + me;
        else return me;
    }
};
var $ae91d1555267d922$var$GenericWorker_1 = $ae91d1555267d922$var$GenericWorker$b;
(function(exports1) {
    var utils = $ae91d1555267d922$var$utils$r;
    var support = $ae91d1555267d922$var$support$5;
    var nodejsUtils = $ae91d1555267d922$var$nodejsUtils$2;
    var GenericWorker = $ae91d1555267d922$var$GenericWorker_1;
    /**
 * The following functions come from pako, from pako/lib/utils/strings
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */ // Table with utf8 lengths (calculated by first byte of sequence)
    // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
    // because max possible codepoint is 0x10ffff
    var _utf8len = new Array(256);
    for(var i = 0; i < 256; i++)_utf8len[i] = i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1;
    _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
    // convert string to array (typed, when possible)
    var string2buf = function(str) {
        var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
        // count binary size
        for(m_pos = 0; m_pos < str_len; m_pos++){
            c = str.charCodeAt(m_pos);
            if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                c2 = str.charCodeAt(m_pos + 1);
                if ((c2 & 0xfc00) === 0xdc00) {
                    c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                    m_pos++;
                }
            }
            buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
        }
        // allocate buffer
        if (support.uint8array) buf = new Uint8Array(buf_len);
        else buf = new Array(buf_len);
        // convert
        for(i = 0, m_pos = 0; i < buf_len; m_pos++){
            c = str.charCodeAt(m_pos);
            if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                c2 = str.charCodeAt(m_pos + 1);
                if ((c2 & 0xfc00) === 0xdc00) {
                    c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                    m_pos++;
                }
            }
            if (c < 0x80) /* one byte */ buf[i++] = c;
            else if (c < 0x800) {
                /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
                buf[i++] = 0x80 | c & 0x3f;
            } else if (c < 0x10000) {
                /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
                buf[i++] = 0x80 | c >>> 6 & 0x3f;
                buf[i++] = 0x80 | c & 0x3f;
            } else {
                /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
                buf[i++] = 0x80 | c >>> 12 & 0x3f;
                buf[i++] = 0x80 | c >>> 6 & 0x3f;
                buf[i++] = 0x80 | c & 0x3f;
            }
        }
        return buf;
    };
    // Calculate max possible position in utf8 buffer,
    // that will not break sequence. If that's not possible
    // - (very small limits) return max size as is.
    //
    // buf[] - utf8 bytes array
    // max   - length limit (mandatory);
    var utf8border = function(buf, max) {
        var pos;
        max = max || buf.length;
        if (max > buf.length) max = buf.length;
        // go back from last position, until start of sequence found
        pos = max - 1;
        while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
        // Fuckup - very small and broken sequence,
        // return max, because we should return something anyway.
        if (pos < 0) return max;
        // If we came to start of buffer - that means vuffer is too small,
        // return max too.
        if (pos === 0) return max;
        return pos + _utf8len[buf[pos]] > max ? pos : max;
    };
    // convert array to string
    var buf2string = function(buf) {
        var i, out, c, c_len;
        var len = buf.length;
        // Reserve max possible length (2 words per char)
        // NB: by unknown reasons, Array is significantly faster for
        //     String.fromCharCode.apply than Uint16Array.
        var utf16buf = new Array(len * 2);
        for(out = 0, i = 0; i < len;){
            c = buf[i++];
            // quick process ascii
            if (c < 0x80) {
                utf16buf[out++] = c;
                continue;
            }
            c_len = _utf8len[c];
            // skip 5 & 6 byte codes
            if (c_len > 4) {
                utf16buf[out++] = 0xfffd;
                i += c_len - 1;
                continue;
            }
            // apply mask on first byte
            c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
            // join the rest
            while(c_len > 1 && i < len){
                c = c << 6 | buf[i++] & 0x3f;
                c_len--;
            }
            // terminated by end of string?
            if (c_len > 1) {
                utf16buf[out++] = 0xfffd;
                continue;
            }
            if (c < 0x10000) utf16buf[out++] = c;
            else {
                c -= 0x10000;
                utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
                utf16buf[out++] = 0xdc00 | c & 0x3ff;
            }
        }
        // shrinkBuf(utf16buf, out)
        if (utf16buf.length !== out) {
            if (utf16buf.subarray) utf16buf = utf16buf.subarray(0, out);
            else utf16buf.length = out;
        }
        // return String.fromCharCode.apply(null, utf16buf);
        return utils.applyFromCharCode(utf16buf);
    };
    // That's all for the pako functions.
    /**
 * Transform a javascript string into an array (typed if possible) of bytes,
 * UTF-8 encoded.
 * @param {String} str the string to encode
 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
 */ exports1.utf8encode = function utf8encode(str) {
        if (support.nodebuffer) return nodejsUtils.newBufferFrom(str, "utf-8");
        return string2buf(str);
    };
    /**
 * Transform a bytes array (or a representation) representing an UTF-8 encoded
 * string into a javascript string.
 * @param {Array|Uint8Array|Buffer} buf the data de decode
 * @return {String} the decoded string.
 */ exports1.utf8decode = function utf8decode(buf) {
        if (support.nodebuffer) return utils.transformTo("nodebuffer", buf).toString("utf-8");
        buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
        return buf2string(buf);
    };
    /**
 * A worker to decode utf8 encoded binary chunks into string chunks.
 * @constructor
 */ function Utf8DecodeWorker() {
        GenericWorker.call(this, "utf-8 decode");
        // the last bytes if a chunk didn't end with a complete codepoint.
        this.leftOver = null;
    }
    utils.inherits(Utf8DecodeWorker, GenericWorker);
    /**
 * @see GenericWorker.processChunk
 */ Utf8DecodeWorker.prototype.processChunk = function(chunk) {
        var data = utils.transformTo(support.uint8array ? "uint8array" : "array", chunk.data);
        // 1st step, re-use what's left of the previous chunk
        if (this.leftOver && this.leftOver.length) {
            if (support.uint8array) {
                var previousData = data;
                data = new Uint8Array(previousData.length + this.leftOver.length);
                data.set(this.leftOver, 0);
                data.set(previousData, this.leftOver.length);
            } else data = this.leftOver.concat(data);
            this.leftOver = null;
        }
        var nextBoundary = utf8border(data);
        var usableData = data;
        if (nextBoundary !== data.length) {
            if (support.uint8array) {
                usableData = data.subarray(0, nextBoundary);
                this.leftOver = data.subarray(nextBoundary, data.length);
            } else {
                usableData = data.slice(0, nextBoundary);
                this.leftOver = data.slice(nextBoundary, data.length);
            }
        }
        this.push({
            data: exports1.utf8decode(usableData),
            meta: chunk.meta
        });
    };
    /**
 * @see GenericWorker.flush
 */ Utf8DecodeWorker.prototype.flush = function() {
        if (this.leftOver && this.leftOver.length) {
            this.push({
                data: exports1.utf8decode(this.leftOver),
                meta: {}
            });
            this.leftOver = null;
        }
    };
    exports1.Utf8DecodeWorker = Utf8DecodeWorker;
    /**
 * A worker to endcode string chunks into utf8 encoded binary chunks.
 * @constructor
 */ function Utf8EncodeWorker() {
        GenericWorker.call(this, "utf-8 encode");
    }
    utils.inherits(Utf8EncodeWorker, GenericWorker);
    /**
 * @see GenericWorker.processChunk
 */ Utf8EncodeWorker.prototype.processChunk = function(chunk) {
        this.push({
            data: exports1.utf8encode(chunk.data),
            meta: chunk.meta
        });
    };
    exports1.Utf8EncodeWorker = Utf8EncodeWorker;
})($ae91d1555267d922$var$utf8$5);
var $ae91d1555267d922$var$GenericWorker$a = $ae91d1555267d922$var$GenericWorker_1;
var $ae91d1555267d922$var$utils$p = $ae91d1555267d922$var$utils$r;
/**
 * A worker which convert chunks to a specified type.
 * @constructor
 * @param {String} destType the destination type.
 */ function $ae91d1555267d922$var$ConvertWorker$1(destType) {
    $ae91d1555267d922$var$GenericWorker$a.call(this, "ConvertWorker to " + destType);
    this.destType = destType;
}
$ae91d1555267d922$var$utils$p.inherits($ae91d1555267d922$var$ConvertWorker$1, $ae91d1555267d922$var$GenericWorker$a);
/**
 * @see GenericWorker.processChunk
 */ $ae91d1555267d922$var$ConvertWorker$1.prototype.processChunk = function(chunk) {
    this.push({
        data: $ae91d1555267d922$var$utils$p.transformTo(this.destType, chunk.data),
        meta: chunk.meta
    });
};
var $ae91d1555267d922$var$ConvertWorker_1 = $ae91d1555267d922$var$ConvertWorker$1;
var $ae91d1555267d922$var$utils$o = $ae91d1555267d922$var$utils$r;
var $ae91d1555267d922$var$ConvertWorker = $ae91d1555267d922$var$ConvertWorker_1;
var $ae91d1555267d922$var$GenericWorker$9 = $ae91d1555267d922$var$GenericWorker_1;
var $ae91d1555267d922$var$base64 = $ae91d1555267d922$var$base64$1;
var $ae91d1555267d922$var$support$3 = $ae91d1555267d922$var$support$5;
var $ae91d1555267d922$var$external$2 = $ae91d1555267d922$var$external$3;
var $ae91d1555267d922$var$NodejsStreamOutputAdapter = null;

if ($ae91d1555267d922$var$support$3.nodestream) try {
    $ae91d1555267d922$var$NodejsStreamOutputAdapter = $ae91d1555267d922$import$5a97fe53753f085a;
} catch (e) {}
/**
 * Apply the final transformation of the data. If the user wants a Blob for
 * example, it's easier to work with an U8intArray and finally do the
 * ArrayBuffer/Blob conversion.
 * @param {String} type the name of the final type
 * @param {String|Uint8Array|Buffer} content the content to transform
 * @param {String} mimeType the mime type of the content, if applicable.
 * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
 */ function $ae91d1555267d922$var$transformZipOutput(type, content, mimeType) {
    switch(type){
        case "blob":
            return $ae91d1555267d922$var$utils$o.newBlob($ae91d1555267d922$var$utils$o.transformTo("arraybuffer", content), mimeType);
        case "base64":
            return $ae91d1555267d922$var$base64.encode(content);
        default:
            return $ae91d1555267d922$var$utils$o.transformTo(type, content);
    }
}
/**
 * Concatenate an array of data of the given type.
 * @param {String} type the type of the data in the given array.
 * @param {Array} dataArray the array containing the data chunks to concatenate
 * @return {String|Uint8Array|Buffer} the concatenated data
 * @throws Error if the asked type is unsupported
 */ function $ae91d1555267d922$var$concat(type, dataArray) {
    var i, index = 0, res = null, totalLength = 0;
    for(i = 0; i < dataArray.length; i++)totalLength += dataArray[i].length;
    switch(type){
        case "string":
            return dataArray.join("");
        case "array":
            return Array.prototype.concat.apply([], dataArray);
        case "uint8array":
            res = new Uint8Array(totalLength);
            for(i = 0; i < dataArray.length; i++){
                res.set(dataArray[i], index);
                index += dataArray[i].length;
            }
            return res;
        case "nodebuffer":
            return $ae91d1555267d922$require$Buffer.concat(dataArray);
        default:
            throw new Error("concat : unsupported type '" + type + "'");
    }
}
/**
 * Listen a StreamHelper, accumulate its content and concatenate it into a
 * complete block.
 * @param {StreamHelper} helper the helper to use.
 * @param {Function} updateCallback a callback called on each update. Called
 * with one arg :
 * - the metadata linked to the update received.
 * @return Promise the promise for the accumulation.
 */ function $ae91d1555267d922$var$accumulate(helper, updateCallback) {
    return new $ae91d1555267d922$var$external$2.Promise(function(resolve, reject) {
        var dataArray = [];
        var chunkType = helper._internalType, resultType = helper._outputType, mimeType = helper._mimeType;
        helper.on("data", function(data, meta) {
            dataArray.push(data);
            if (updateCallback) updateCallback(meta);
        }).on("error", function(err) {
            dataArray = [];
            reject(err);
        }).on("end", function() {
            try {
                var result = $ae91d1555267d922$var$transformZipOutput(resultType, $ae91d1555267d922$var$concat(chunkType, dataArray), mimeType);
                resolve(result);
            } catch (e) {
                reject(e);
            }
            dataArray = [];
        }).resume();
    });
}
/**
 * An helper to easily use workers outside of JSZip.
 * @constructor
 * @param {Worker} worker the worker to wrap
 * @param {String} outputType the type of data expected by the use
 * @param {String} mimeType the mime type of the content, if applicable.
 */ function $ae91d1555267d922$var$StreamHelper$2(worker, outputType, mimeType) {
    var internalType = outputType;
    switch(outputType){
        case "blob":
        case "arraybuffer":
            internalType = "uint8array";
            break;
        case "base64":
            internalType = "string";
            break;
    }
    try {
        // the type used internally
        this._internalType = internalType;
        // the type used to output results
        this._outputType = outputType;
        // the mime type
        this._mimeType = mimeType;
        $ae91d1555267d922$var$utils$o.checkSupport(internalType);
        this._worker = worker.pipe(new $ae91d1555267d922$var$ConvertWorker(internalType));
        // the last workers can be rewired without issues but we need to
        // prevent any updates on previous workers.
        worker.lock();
    } catch (e) {
        this._worker = new $ae91d1555267d922$var$GenericWorker$9("error");
        this._worker.error(e);
    }
}
$ae91d1555267d922$var$StreamHelper$2.prototype = {
    /**
     * Listen a StreamHelper, accumulate its content and concatenate it into a
     * complete block.
     * @param {Function} updateCb the update callback.
     * @return Promise the promise for the accumulation.
     */ accumulate: function(updateCb) {
        return $ae91d1555267d922$var$accumulate(this, updateCb);
    },
    /**
     * Add a listener on an event triggered on a stream.
     * @param {String} evt the name of the event
     * @param {Function} fn the listener
     * @return {StreamHelper} the current helper.
     */ on: function(evt, fn) {
        var self1 = this;
        if (evt === "data") this._worker.on(evt, function(chunk) {
            fn.call(self1, chunk.data, chunk.meta);
        });
        else this._worker.on(evt, function() {
            $ae91d1555267d922$var$utils$o.delay(fn, arguments, self1);
        });
        return this;
    },
    /**
     * Resume the flow of chunks.
     * @return {StreamHelper} the current helper.
     */ resume: function() {
        $ae91d1555267d922$var$utils$o.delay(this._worker.resume, [], this._worker);
        return this;
    },
    /**
     * Pause the flow of chunks.
     * @return {StreamHelper} the current helper.
     */ pause: function() {
        this._worker.pause();
        return this;
    },
    /**
     * Return a nodejs stream for this helper.
     * @param {Function} updateCb the update callback.
     * @return {NodejsStreamOutputAdapter} the nodejs stream.
     */ toNodejsStream: function(updateCb) {
        $ae91d1555267d922$var$utils$o.checkSupport("nodestream");
        if (this._outputType !== "nodebuffer") // an object stream containing blob/arraybuffer/uint8array/string
        // is strange and I don't know if it would be useful.
        // I you find this comment and have a good usecase, please open a
        // bug report !
        throw new Error(this._outputType + " is not supported by this method");
        return new $ae91d1555267d922$var$NodejsStreamOutputAdapter(this, {
            objectMode: this._outputType !== "nodebuffer"
        }, updateCb);
    }
};
var $ae91d1555267d922$var$StreamHelper_1 = $ae91d1555267d922$var$StreamHelper$2;
var $ae91d1555267d922$var$defaults$1 = {};
$ae91d1555267d922$var$defaults$1.base64 = false;
$ae91d1555267d922$var$defaults$1.binary = false;
$ae91d1555267d922$var$defaults$1.dir = false;
$ae91d1555267d922$var$defaults$1.createFolders = true;
$ae91d1555267d922$var$defaults$1.date = null;
$ae91d1555267d922$var$defaults$1.compression = null;
$ae91d1555267d922$var$defaults$1.compressionOptions = null;
$ae91d1555267d922$var$defaults$1.comment = null;
$ae91d1555267d922$var$defaults$1.unixPermissions = null;
$ae91d1555267d922$var$defaults$1.dosPermissions = null;
var $ae91d1555267d922$var$utils$n = $ae91d1555267d922$var$utils$r;
var $ae91d1555267d922$var$GenericWorker$8 = $ae91d1555267d922$var$GenericWorker_1;
// the size of the generated chunks
// TODO expose this as a public variable
var $ae91d1555267d922$var$DEFAULT_BLOCK_SIZE = 16384;
/**
 * A worker that reads a content and emits chunks.
 * @constructor
 * @param {Promise} dataP the promise of the data to split
 */ function $ae91d1555267d922$var$DataWorker$2(dataP) {
    $ae91d1555267d922$var$GenericWorker$8.call(this, "DataWorker");
    var self1 = this;
    this.dataIsReady = false;
    this.index = 0;
    this.max = 0;
    this.data = null;
    this.type = "";
    this._tickScheduled = false;
    dataP.then(function(data) {
        self1.dataIsReady = true;
        self1.data = data;
        self1.max = data && data.length || 0;
        self1.type = $ae91d1555267d922$var$utils$n.getTypeOf(data);
        if (!self1.isPaused) self1._tickAndRepeat();
    }, function(e) {
        self1.error(e);
    });
}
$ae91d1555267d922$var$utils$n.inherits($ae91d1555267d922$var$DataWorker$2, $ae91d1555267d922$var$GenericWorker$8);
/**
 * @see GenericWorker.cleanUp
 */ $ae91d1555267d922$var$DataWorker$2.prototype.cleanUp = function() {
    $ae91d1555267d922$var$GenericWorker$8.prototype.cleanUp.call(this);
    this.data = null;
};
/**
 * @see GenericWorker.resume
 */ $ae91d1555267d922$var$DataWorker$2.prototype.resume = function() {
    if (!$ae91d1555267d922$var$GenericWorker$8.prototype.resume.call(this)) return false;
    if (!this._tickScheduled && this.dataIsReady) {
        this._tickScheduled = true;
        $ae91d1555267d922$var$utils$n.delay(this._tickAndRepeat, [], this);
    }
    return true;
};
/**
 * Trigger a tick a schedule an other call to this function.
 */ $ae91d1555267d922$var$DataWorker$2.prototype._tickAndRepeat = function() {
    this._tickScheduled = false;
    if (this.isPaused || this.isFinished) return;
    this._tick();
    if (!this.isFinished) {
        $ae91d1555267d922$var$utils$n.delay(this._tickAndRepeat, [], this);
        this._tickScheduled = true;
    }
};
/**
 * Read and push a chunk.
 */ $ae91d1555267d922$var$DataWorker$2.prototype._tick = function() {
    if (this.isPaused || this.isFinished) return false;
    var size = $ae91d1555267d922$var$DEFAULT_BLOCK_SIZE;
    var data = null, nextIndex = Math.min(this.max, this.index + size);
    if (this.index >= this.max) // EOF
    return this.end();
    else {
        switch(this.type){
            case "string":
                data = this.data.substring(this.index, nextIndex);
                break;
            case "uint8array":
                data = this.data.subarray(this.index, nextIndex);
                break;
            case "array":
            case "nodebuffer":
                data = this.data.slice(this.index, nextIndex);
                break;
        }
        this.index = nextIndex;
        return this.push({
            data: data,
            meta: {
                percent: this.max ? this.index / this.max * 100 : 0
            }
        });
    }
};
var $ae91d1555267d922$var$DataWorker_1 = $ae91d1555267d922$var$DataWorker$2;
var $ae91d1555267d922$var$utils$m = $ae91d1555267d922$var$utils$r;
var $ae91d1555267d922$var$GenericWorker$7 = $ae91d1555267d922$var$GenericWorker_1;
/**
 * A worker which calculate the total length of the data flowing through.
 * @constructor
 * @param {String} propName the name used to expose the length
 */ function $ae91d1555267d922$var$DataLengthProbe$1(propName) {
    $ae91d1555267d922$var$GenericWorker$7.call(this, "DataLengthProbe for " + propName);
    this.propName = propName;
    this.withStreamInfo(propName, 0);
}
$ae91d1555267d922$var$utils$m.inherits($ae91d1555267d922$var$DataLengthProbe$1, $ae91d1555267d922$var$GenericWorker$7);
/**
 * @see GenericWorker.processChunk
 */ $ae91d1555267d922$var$DataLengthProbe$1.prototype.processChunk = function(chunk) {
    if (chunk) {
        var length = this.streamInfo[this.propName] || 0;
        this.streamInfo[this.propName] = length + chunk.data.length;
    }
    $ae91d1555267d922$var$GenericWorker$7.prototype.processChunk.call(this, chunk);
};
var $ae91d1555267d922$var$DataLengthProbe_1 = $ae91d1555267d922$var$DataLengthProbe$1;
var $ae91d1555267d922$var$utils$l = $ae91d1555267d922$var$utils$r;
/**
 * The following functions come from pako, from pako/lib/zlib/crc32.js
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */ // Use ordinary array, since untyped makes no boost here
function $ae91d1555267d922$var$makeTable$1() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $ae91d1555267d922$var$crcTable$1 = $ae91d1555267d922$var$makeTable$1();
function $ae91d1555267d922$var$crc32$5(crc, buf, len, pos) {
    var t = $ae91d1555267d922$var$crcTable$1, end = pos + len;
    crc = crc ^ -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
// That's all for the pako functions.
/**
 * Compute the crc32 of a string.
 * This is almost the same as the function crc32, but for strings. Using the
 * same function for the two use cases leads to horrible performances.
 * @param {Number} crc the starting value of the crc.
 * @param {String} str the string to use.
 * @param {Number} len the length of the string.
 * @param {Number} pos the starting position for the crc32 computation.
 * @return {Number} the computed crc32.
 */ function $ae91d1555267d922$var$crc32str(crc, str, len, pos) {
    var t = $ae91d1555267d922$var$crcTable$1, end = pos + len;
    crc = crc ^ -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
    return crc ^ -1; // >>> 0;
}
var $ae91d1555267d922$var$crc32_1$1 = function crc32wrapper(input, crc) {
    if (typeof input === "undefined" || !input.length) return 0;
    var isArray = $ae91d1555267d922$var$utils$l.getTypeOf(input) !== "string";
    if (isArray) return $ae91d1555267d922$var$crc32$5(crc | 0, input, input.length, 0);
    else return $ae91d1555267d922$var$crc32str(crc | 0, input, input.length, 0);
};
var $ae91d1555267d922$var$GenericWorker$6 = $ae91d1555267d922$var$GenericWorker_1;
var $ae91d1555267d922$var$crc32$4 = $ae91d1555267d922$var$crc32_1$1;
var $ae91d1555267d922$var$utils$k = $ae91d1555267d922$var$utils$r;
/**
 * A worker which calculate the crc32 of the data flowing through.
 * @constructor
 */ function $ae91d1555267d922$var$Crc32Probe$2() {
    $ae91d1555267d922$var$GenericWorker$6.call(this, "Crc32Probe");
    this.withStreamInfo("crc32", 0);
}
$ae91d1555267d922$var$utils$k.inherits($ae91d1555267d922$var$Crc32Probe$2, $ae91d1555267d922$var$GenericWorker$6);
/**
 * @see GenericWorker.processChunk
 */ $ae91d1555267d922$var$Crc32Probe$2.prototype.processChunk = function(chunk) {
    this.streamInfo.crc32 = $ae91d1555267d922$var$crc32$4(chunk.data, this.streamInfo.crc32 || 0);
    this.push(chunk);
};
var $ae91d1555267d922$var$Crc32Probe_1 = $ae91d1555267d922$var$Crc32Probe$2;
var $ae91d1555267d922$var$external$1 = $ae91d1555267d922$var$external$3;
var $ae91d1555267d922$var$DataWorker$1 = $ae91d1555267d922$var$DataWorker_1;
var $ae91d1555267d922$var$DataLengthProbe = $ae91d1555267d922$var$DataLengthProbe_1;
var $ae91d1555267d922$var$Crc32Probe$1 = $ae91d1555267d922$var$Crc32Probe_1;
var $ae91d1555267d922$var$DataLengthProbe = $ae91d1555267d922$var$DataLengthProbe_1;
/**
 * Represent a compressed object, with everything needed to decompress it.
 * @constructor
 * @param {number} compressedSize the size of the data compressed.
 * @param {number} uncompressedSize the size of the data after decompression.
 * @param {number} crc32 the crc32 of the decompressed file.
 * @param {object} compression the type of compression, see lib/compressions.js.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
 */ function $ae91d1555267d922$var$CompressedObject$3(compressedSize, uncompressedSize, crc32, compression, data) {
    this.compressedSize = compressedSize;
    this.uncompressedSize = uncompressedSize;
    this.crc32 = crc32;
    this.compression = compression;
    this.compressedContent = data;
}
$ae91d1555267d922$var$CompressedObject$3.prototype = {
    /**
     * Create a worker to get the uncompressed content.
     * @return {GenericWorker} the worker.
     */ getContentWorker: function() {
        var worker = new $ae91d1555267d922$var$DataWorker$1($ae91d1555267d922$var$external$1.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new $ae91d1555267d922$var$DataLengthProbe("data_length"));
        var that = this;
        worker.on("end", function() {
            if (this.streamInfo["data_length"] !== that.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
        });
        return worker;
    },
    /**
     * Create a worker to get the compressed content.
     * @return {GenericWorker} the worker.
     */ getCompressedWorker: function() {
        return new $ae91d1555267d922$var$DataWorker$1($ae91d1555267d922$var$external$1.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
    }
};
/**
 * Chain the given worker with other workers to compress the content with the
 * given compression.
 * @param {GenericWorker} uncompressedWorker the worker to pipe.
 * @param {Object} compression the compression object.
 * @param {Object} compressionOptions the options to use when compressing.
 * @return {GenericWorker} the new worker compressing the content.
 */ $ae91d1555267d922$var$CompressedObject$3.createWorkerFrom = function(uncompressedWorker, compression, compressionOptions) {
    return uncompressedWorker.pipe(new $ae91d1555267d922$var$Crc32Probe$1()).pipe(new $ae91d1555267d922$var$DataLengthProbe("uncompressedSize")).pipe(compression.compressWorker(compressionOptions)).pipe(new $ae91d1555267d922$var$DataLengthProbe("compressedSize")).withStreamInfo("compression", compression);
};
var $ae91d1555267d922$var$compressedObject = $ae91d1555267d922$var$CompressedObject$3;
var $ae91d1555267d922$var$StreamHelper$1 = $ae91d1555267d922$var$StreamHelper_1;
var $ae91d1555267d922$var$DataWorker = $ae91d1555267d922$var$DataWorker_1;
var $ae91d1555267d922$var$utf8$4 = $ae91d1555267d922$var$utf8$5;
var $ae91d1555267d922$var$CompressedObject$2 = $ae91d1555267d922$var$compressedObject;
var $ae91d1555267d922$var$GenericWorker$5 = $ae91d1555267d922$var$GenericWorker_1;
/**
 * A simple object representing a file in the zip file.
 * @constructor
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
 * @param {Object} options the options of the file
 */ var $ae91d1555267d922$var$ZipObject$1 = function(name, data, options) {
    this.name = name;
    this.dir = options.dir;
    this.date = options.date;
    this.comment = options.comment;
    this.unixPermissions = options.unixPermissions;
    this.dosPermissions = options.dosPermissions;
    this._data = data;
    this._dataBinary = options.binary;
    // keep only the compression
    this.options = {
        compression: options.compression,
        compressionOptions: options.compressionOptions
    };
};
$ae91d1555267d922$var$ZipObject$1.prototype = {
    /**
     * Create an internal stream for the content of this object.
     * @param {String} type the type of each chunk.
     * @return StreamHelper the stream.
     */ internalStream: function(type) {
        var result = null, outputType = "string";
        try {
            if (!type) throw new Error("No output type specified.");
            outputType = type.toLowerCase();
            var askUnicodeString = outputType === "string" || outputType === "text";
            if (outputType === "binarystring" || outputType === "text") outputType = "string";
            result = this._decompressWorker();
            var isUnicodeString = !this._dataBinary;
            if (isUnicodeString && !askUnicodeString) result = result.pipe(new $ae91d1555267d922$var$utf8$4.Utf8EncodeWorker());
            if (!isUnicodeString && askUnicodeString) result = result.pipe(new $ae91d1555267d922$var$utf8$4.Utf8DecodeWorker());
        } catch (e) {
            result = new $ae91d1555267d922$var$GenericWorker$5("error");
            result.error(e);
        }
        return new $ae91d1555267d922$var$StreamHelper$1(result, outputType, "");
    },
    /**
     * Prepare the content in the asked type.
     * @param {String} type the type of the result.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Promise the promise of the result.
     */ async: function(type, onUpdate) {
        return this.internalStream(type).accumulate(onUpdate);
    },
    /**
     * Prepare the content as a nodejs stream.
     * @param {String} type the type of each chunk.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Stream the stream.
     */ nodeStream: function(type, onUpdate) {
        return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
    },
    /**
     * Return a worker for the compressed content.
     * @private
     * @param {Object} compression the compression object to use.
     * @param {Object} compressionOptions the options to use when compressing.
     * @return Worker the worker.
     */ _compressWorker: function(compression, compressionOptions) {
        if (this._data instanceof $ae91d1555267d922$var$CompressedObject$2 && this._data.compression.magic === compression.magic) return this._data.getCompressedWorker();
        else {
            var result = this._decompressWorker();
            if (!this._dataBinary) result = result.pipe(new $ae91d1555267d922$var$utf8$4.Utf8EncodeWorker());
            return $ae91d1555267d922$var$CompressedObject$2.createWorkerFrom(result, compression, compressionOptions);
        }
    },
    /**
     * Return a worker for the decompressed content.
     * @private
     * @return Worker the worker.
     */ _decompressWorker: function() {
        if (this._data instanceof $ae91d1555267d922$var$CompressedObject$2) return this._data.getContentWorker();
        else if (this._data instanceof $ae91d1555267d922$var$GenericWorker$5) return this._data;
        else return new $ae91d1555267d922$var$DataWorker(this._data);
    }
};
var $ae91d1555267d922$var$removedMethods = [
    "asText",
    "asBinary",
    "asNodeBuffer",
    "asUint8Array",
    "asArrayBuffer"
];
var $ae91d1555267d922$var$removedFn = function() {
    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
};
for(var $ae91d1555267d922$var$i = 0; $ae91d1555267d922$var$i < $ae91d1555267d922$var$removedMethods.length; $ae91d1555267d922$var$i++)$ae91d1555267d922$var$ZipObject$1.prototype[$ae91d1555267d922$var$removedMethods[$ae91d1555267d922$var$i]] = $ae91d1555267d922$var$removedFn;
var $ae91d1555267d922$var$zipObject = $ae91d1555267d922$var$ZipObject$1;
var $ae91d1555267d922$var$generate$1 = {};
var $ae91d1555267d922$var$compressions$2 = {};
var $ae91d1555267d922$var$flate = {};
var $ae91d1555267d922$var$common = {};
(function(exports1) {
    var TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
    function _has(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
    }
    exports1.assign = function(obj /*from1, from2, from3, ...*/ ) {
        var sources = Array.prototype.slice.call(arguments, 1);
        while(sources.length){
            var source = sources.shift();
            if (!source) continue;
            if (typeof source !== "object") throw new TypeError(source + "must be non-object");
            for(var p in source)if (_has(source, p)) obj[p] = source[p];
        }
        return obj;
    };
    // reduce buffer size, avoiding mem copy
    exports1.shrinkBuf = function(buf, size) {
        if (buf.length === size) return buf;
        if (buf.subarray) return buf.subarray(0, size);
        buf.length = size;
        return buf;
    };
    var fnTyped = {
        arraySet: function(dest, src, src_offs, len, dest_offs) {
            if (src.subarray && dest.subarray) {
                dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
                return;
            }
            // Fallback to ordinary array
            for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
        },
        // Join array of chunks to single array.
        flattenChunks: function(chunks) {
            var i, l, len, pos, chunk, result;
            // calculate data length
            len = 0;
            for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
            // join chunks
            result = new Uint8Array(len);
            pos = 0;
            for(i = 0, l = chunks.length; i < l; i++){
                chunk = chunks[i];
                result.set(chunk, pos);
                pos += chunk.length;
            }
            return result;
        }
    };
    var fnUntyped = {
        arraySet: function(dest, src, src_offs, len, dest_offs) {
            for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
        },
        // Join array of chunks to single array.
        flattenChunks: function(chunks) {
            return [].concat.apply([], chunks);
        }
    };
    // Enable/Disable typed arrays use, for testing
    //
    exports1.setTyped = function(on) {
        if (on) {
            exports1.Buf8 = Uint8Array;
            exports1.Buf16 = Uint16Array;
            exports1.Buf32 = Int32Array;
            exports1.assign(exports1, fnTyped);
        } else {
            exports1.Buf8 = Array;
            exports1.Buf16 = Array;
            exports1.Buf32 = Array;
            exports1.assign(exports1, fnUntyped);
        }
    };
    exports1.setTyped(TYPED_OK);
})($ae91d1555267d922$var$common);
var $ae91d1555267d922$var$deflate$4 = {};
var $ae91d1555267d922$var$deflate$3 = {};
var $ae91d1555267d922$var$trees$1 = {};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ var $ae91d1555267d922$var$utils$j = $ae91d1555267d922$var$common;
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $ae91d1555267d922$var$Z_FIXED$1 = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $ae91d1555267d922$var$Z_BINARY = 0;
var $ae91d1555267d922$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $ae91d1555267d922$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $ae91d1555267d922$var$zero$1(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $ae91d1555267d922$var$STORED_BLOCK = 0;
var $ae91d1555267d922$var$STATIC_TREES = 1;
var $ae91d1555267d922$var$DYN_TREES = 2;
/* The three kinds of block type */ var $ae91d1555267d922$var$MIN_MATCH$1 = 3;
var $ae91d1555267d922$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $ae91d1555267d922$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $ae91d1555267d922$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ var $ae91d1555267d922$var$L_CODES$1 = $ae91d1555267d922$var$LITERALS$1 + 1 + $ae91d1555267d922$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ var $ae91d1555267d922$var$D_CODES$1 = 30;
/* number of distance codes */ var $ae91d1555267d922$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ var $ae91d1555267d922$var$HEAP_SIZE$1 = 2 * $ae91d1555267d922$var$L_CODES$1 + 1;
/* maximum heap size */ var $ae91d1555267d922$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ var $ae91d1555267d922$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $ae91d1555267d922$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $ae91d1555267d922$var$END_BLOCK = 256;
/* end of block literal code */ var $ae91d1555267d922$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $ae91d1555267d922$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $ae91d1555267d922$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $ae91d1555267d922$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $ae91d1555267d922$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $ae91d1555267d922$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $ae91d1555267d922$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $ae91d1555267d922$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $ae91d1555267d922$var$static_ltree = new Array(($ae91d1555267d922$var$L_CODES$1 + 2) * 2);
$ae91d1555267d922$var$zero$1($ae91d1555267d922$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $ae91d1555267d922$var$static_dtree = new Array($ae91d1555267d922$var$D_CODES$1 * 2);
$ae91d1555267d922$var$zero$1($ae91d1555267d922$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $ae91d1555267d922$var$_dist_code = new Array($ae91d1555267d922$var$DIST_CODE_LEN);
$ae91d1555267d922$var$zero$1($ae91d1555267d922$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $ae91d1555267d922$var$_length_code = new Array($ae91d1555267d922$var$MAX_MATCH$1 - $ae91d1555267d922$var$MIN_MATCH$1 + 1);
$ae91d1555267d922$var$zero$1($ae91d1555267d922$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $ae91d1555267d922$var$base_length = new Array($ae91d1555267d922$var$LENGTH_CODES$1);
$ae91d1555267d922$var$zero$1($ae91d1555267d922$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $ae91d1555267d922$var$base_dist = new Array($ae91d1555267d922$var$D_CODES$1);
$ae91d1555267d922$var$zero$1($ae91d1555267d922$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $ae91d1555267d922$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $ae91d1555267d922$var$static_l_desc;
var $ae91d1555267d922$var$static_d_desc;
var $ae91d1555267d922$var$static_bl_desc;
function $ae91d1555267d922$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $ae91d1555267d922$var$d_code(dist) {
    return dist < 256 ? $ae91d1555267d922$var$_dist_code[dist] : $ae91d1555267d922$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $ae91d1555267d922$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $ae91d1555267d922$var$send_bits(s, value, length) {
    if (s.bi_valid > $ae91d1555267d922$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $ae91d1555267d922$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $ae91d1555267d922$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $ae91d1555267d922$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $ae91d1555267d922$var$send_code(s, c, tree) {
    $ae91d1555267d922$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $ae91d1555267d922$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $ae91d1555267d922$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $ae91d1555267d922$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $ae91d1555267d922$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $ae91d1555267d922$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $ae91d1555267d922$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $ae91d1555267d922$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($ae91d1555267d922$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $ae91d1555267d922$var$MAX_BITS$1; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $ae91d1555267d922$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $ae91d1555267d922$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($ae91d1555267d922$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $ae91d1555267d922$var$LENGTH_CODES$1 - 1; code++){
        $ae91d1555267d922$var$base_length[code] = length;
        for(n = 0; n < 1 << $ae91d1555267d922$var$extra_lbits[code]; n++)$ae91d1555267d922$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $ae91d1555267d922$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $ae91d1555267d922$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $ae91d1555267d922$var$extra_dbits[code]; n++)$ae91d1555267d922$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $ae91d1555267d922$var$D_CODES$1; code++){
        $ae91d1555267d922$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $ae91d1555267d922$var$extra_dbits[code] - 7; n++)$ae91d1555267d922$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $ae91d1555267d922$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $ae91d1555267d922$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $ae91d1555267d922$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $ae91d1555267d922$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $ae91d1555267d922$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $ae91d1555267d922$var$gen_codes($ae91d1555267d922$var$static_ltree, $ae91d1555267d922$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $ae91d1555267d922$var$D_CODES$1; n++){
        $ae91d1555267d922$var$static_dtree[n * 2 + 1] = 5;
        $ae91d1555267d922$var$static_dtree[n * 2] = $ae91d1555267d922$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $ae91d1555267d922$var$static_l_desc = new $ae91d1555267d922$var$StaticTreeDesc($ae91d1555267d922$var$static_ltree, $ae91d1555267d922$var$extra_lbits, $ae91d1555267d922$var$LITERALS$1 + 1, $ae91d1555267d922$var$L_CODES$1, $ae91d1555267d922$var$MAX_BITS$1);
    $ae91d1555267d922$var$static_d_desc = new $ae91d1555267d922$var$StaticTreeDesc($ae91d1555267d922$var$static_dtree, $ae91d1555267d922$var$extra_dbits, 0, $ae91d1555267d922$var$D_CODES$1, $ae91d1555267d922$var$MAX_BITS$1);
    $ae91d1555267d922$var$static_bl_desc = new $ae91d1555267d922$var$StaticTreeDesc(new Array(0), $ae91d1555267d922$var$extra_blbits, 0, $ae91d1555267d922$var$BL_CODES$1, $ae91d1555267d922$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $ae91d1555267d922$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $ae91d1555267d922$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $ae91d1555267d922$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $ae91d1555267d922$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$ae91d1555267d922$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $ae91d1555267d922$var$bi_windup(s) {
    if (s.bi_valid > 8) $ae91d1555267d922$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $ae91d1555267d922$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $ae91d1555267d922$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $ae91d1555267d922$var$put_short(s, len);
        $ae91d1555267d922$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $ae91d1555267d922$var$utils$j.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $ae91d1555267d922$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $ae91d1555267d922$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $ae91d1555267d922$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($ae91d1555267d922$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $ae91d1555267d922$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $ae91d1555267d922$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $ae91d1555267d922$var$_length_code[lc];
            $ae91d1555267d922$var$send_code(s, code + $ae91d1555267d922$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $ae91d1555267d922$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $ae91d1555267d922$var$base_length[code];
                $ae91d1555267d922$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $ae91d1555267d922$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $ae91d1555267d922$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $ae91d1555267d922$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $ae91d1555267d922$var$base_dist[code];
                $ae91d1555267d922$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $ae91d1555267d922$var$send_code(s, $ae91d1555267d922$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $ae91d1555267d922$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $ae91d1555267d922$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$ae91d1555267d922$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $ae91d1555267d922$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $ae91d1555267d922$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $ae91d1555267d922$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $ae91d1555267d922$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $ae91d1555267d922$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$ae91d1555267d922$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$ae91d1555267d922$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$ae91d1555267d922$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $ae91d1555267d922$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $ae91d1555267d922$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $ae91d1555267d922$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $ae91d1555267d922$var$send_code(s, $ae91d1555267d922$var$REP_3_6, s.bl_tree);
            $ae91d1555267d922$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $ae91d1555267d922$var$send_code(s, $ae91d1555267d922$var$REPZ_3_10, s.bl_tree);
            $ae91d1555267d922$var$send_bits(s, count - 3, 3);
        } else {
            $ae91d1555267d922$var$send_code(s, $ae91d1555267d922$var$REPZ_11_138, s.bl_tree);
            $ae91d1555267d922$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $ae91d1555267d922$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $ae91d1555267d922$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $ae91d1555267d922$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $ae91d1555267d922$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $ae91d1555267d922$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$ae91d1555267d922$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $ae91d1555267d922$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $ae91d1555267d922$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $ae91d1555267d922$var$send_bits(s, dcodes - 1, 5);
    $ae91d1555267d922$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $ae91d1555267d922$var$send_bits(s, s.bl_tree[$ae91d1555267d922$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $ae91d1555267d922$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $ae91d1555267d922$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $ae91d1555267d922$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $ae91d1555267d922$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $ae91d1555267d922$var$Z_TEXT;
    for(n = 32; n < $ae91d1555267d922$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $ae91d1555267d922$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $ae91d1555267d922$var$Z_BINARY;
}
var $ae91d1555267d922$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $ae91d1555267d922$var$_tr_init(s) {
    if (!$ae91d1555267d922$var$static_init_done) {
        $ae91d1555267d922$var$tr_static_init();
        $ae91d1555267d922$var$static_init_done = true;
    }
    s.l_desc = new $ae91d1555267d922$var$TreeDesc(s.dyn_ltree, $ae91d1555267d922$var$static_l_desc);
    s.d_desc = new $ae91d1555267d922$var$TreeDesc(s.dyn_dtree, $ae91d1555267d922$var$static_d_desc);
    s.bl_desc = new $ae91d1555267d922$var$TreeDesc(s.bl_tree, $ae91d1555267d922$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $ae91d1555267d922$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $ae91d1555267d922$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $ae91d1555267d922$var$send_bits(s, ($ae91d1555267d922$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $ae91d1555267d922$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $ae91d1555267d922$var$_tr_align(s) {
    $ae91d1555267d922$var$send_bits(s, $ae91d1555267d922$var$STATIC_TREES << 1, 3);
    $ae91d1555267d922$var$send_code(s, $ae91d1555267d922$var$END_BLOCK, $ae91d1555267d922$var$static_ltree);
    $ae91d1555267d922$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $ae91d1555267d922$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $ae91d1555267d922$var$Z_UNKNOWN$1) s.strm.data_type = $ae91d1555267d922$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $ae91d1555267d922$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $ae91d1555267d922$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $ae91d1555267d922$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $ae91d1555267d922$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $ae91d1555267d922$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $ae91d1555267d922$var$send_bits(s, ($ae91d1555267d922$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $ae91d1555267d922$var$compress_block(s, $ae91d1555267d922$var$static_ltree, $ae91d1555267d922$var$static_dtree);
    } else {
        $ae91d1555267d922$var$send_bits(s, ($ae91d1555267d922$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $ae91d1555267d922$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $ae91d1555267d922$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $ae91d1555267d922$var$init_block(s);
    if (last) $ae91d1555267d922$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $ae91d1555267d922$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($ae91d1555267d922$var$_length_code[lc] + $ae91d1555267d922$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$ae91d1555267d922$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$ae91d1555267d922$var$trees$1._tr_init = $ae91d1555267d922$var$_tr_init;
$ae91d1555267d922$var$trees$1._tr_stored_block = $ae91d1555267d922$var$_tr_stored_block;
$ae91d1555267d922$var$trees$1._tr_flush_block = $ae91d1555267d922$var$_tr_flush_block;
$ae91d1555267d922$var$trees$1._tr_tally = $ae91d1555267d922$var$_tr_tally;
$ae91d1555267d922$var$trees$1._tr_align = $ae91d1555267d922$var$_tr_align;
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $ae91d1555267d922$var$adler32$2(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
var $ae91d1555267d922$var$adler32_1 = $ae91d1555267d922$var$adler32$2;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $ae91d1555267d922$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $ae91d1555267d922$var$crcTable = $ae91d1555267d922$var$makeTable();
function $ae91d1555267d922$var$crc32$3(crc, buf, len, pos) {
    var t = $ae91d1555267d922$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
var $ae91d1555267d922$var$crc32_1 = $ae91d1555267d922$var$crc32$3;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $ae91d1555267d922$var$messages$1 = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $ae91d1555267d922$var$utils$i = $ae91d1555267d922$var$common;
var $ae91d1555267d922$var$trees = $ae91d1555267d922$var$trees$1;
var $ae91d1555267d922$var$adler32$1 = $ae91d1555267d922$var$adler32_1;
var $ae91d1555267d922$var$crc32$2 = $ae91d1555267d922$var$crc32_1;
var $ae91d1555267d922$var$msg$2 = $ae91d1555267d922$var$messages$1;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $ae91d1555267d922$var$Z_NO_FLUSH$1 = 0;
var $ae91d1555267d922$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $ae91d1555267d922$var$Z_FULL_FLUSH = 3;
var $ae91d1555267d922$var$Z_FINISH$2 = 4;
var $ae91d1555267d922$var$Z_BLOCK$1 = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $ae91d1555267d922$var$Z_OK$2 = 0;
var $ae91d1555267d922$var$Z_STREAM_END$2 = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $ae91d1555267d922$var$Z_STREAM_ERROR$1 = -2;
var $ae91d1555267d922$var$Z_DATA_ERROR$1 = -3;
//var Z_MEM_ERROR     = -4;
var $ae91d1555267d922$var$Z_BUF_ERROR$1 = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $ae91d1555267d922$var$Z_DEFAULT_COMPRESSION$1 = -1;
var $ae91d1555267d922$var$Z_FILTERED = 1;
var $ae91d1555267d922$var$Z_HUFFMAN_ONLY = 2;
var $ae91d1555267d922$var$Z_RLE = 3;
var $ae91d1555267d922$var$Z_FIXED = 4;
var $ae91d1555267d922$var$Z_DEFAULT_STRATEGY$1 = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $ae91d1555267d922$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $ae91d1555267d922$var$Z_DEFLATED$2 = 8;
/*============================================================================*/ var $ae91d1555267d922$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $ae91d1555267d922$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ var $ae91d1555267d922$var$DEF_MEM_LEVEL = 8;
var $ae91d1555267d922$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $ae91d1555267d922$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $ae91d1555267d922$var$L_CODES = $ae91d1555267d922$var$LITERALS + 1 + $ae91d1555267d922$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $ae91d1555267d922$var$D_CODES = 30;
/* number of distance codes */ var $ae91d1555267d922$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $ae91d1555267d922$var$HEAP_SIZE = 2 * $ae91d1555267d922$var$L_CODES + 1;
/* maximum heap size */ var $ae91d1555267d922$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $ae91d1555267d922$var$MIN_MATCH = 3;
var $ae91d1555267d922$var$MAX_MATCH = 258;
var $ae91d1555267d922$var$MIN_LOOKAHEAD = $ae91d1555267d922$var$MAX_MATCH + $ae91d1555267d922$var$MIN_MATCH + 1;
var $ae91d1555267d922$var$PRESET_DICT = 0x20;
var $ae91d1555267d922$var$INIT_STATE = 42;
var $ae91d1555267d922$var$EXTRA_STATE = 69;
var $ae91d1555267d922$var$NAME_STATE = 73;
var $ae91d1555267d922$var$COMMENT_STATE = 91;
var $ae91d1555267d922$var$HCRC_STATE = 103;
var $ae91d1555267d922$var$BUSY_STATE = 113;
var $ae91d1555267d922$var$FINISH_STATE = 666;
var $ae91d1555267d922$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $ae91d1555267d922$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $ae91d1555267d922$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $ae91d1555267d922$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $ae91d1555267d922$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $ae91d1555267d922$var$err(strm, errorCode) {
    strm.msg = $ae91d1555267d922$var$msg$2[errorCode];
    return errorCode;
}
function $ae91d1555267d922$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $ae91d1555267d922$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $ae91d1555267d922$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $ae91d1555267d922$var$utils$i.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $ae91d1555267d922$var$flush_block_only(s, last) {
    $ae91d1555267d922$var$trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $ae91d1555267d922$var$flush_pending(s.strm);
}
function $ae91d1555267d922$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $ae91d1555267d922$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $ae91d1555267d922$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $ae91d1555267d922$var$utils$i.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $ae91d1555267d922$var$adler32$1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $ae91d1555267d922$var$crc32$2(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $ae91d1555267d922$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $ae91d1555267d922$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $ae91d1555267d922$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $ae91d1555267d922$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $ae91d1555267d922$var$MAX_MATCH - (strend - scan);
        scan = strend - $ae91d1555267d922$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $ae91d1555267d922$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $ae91d1555267d922$var$MIN_LOOKAHEAD)) {
            $ae91d1555267d922$var$utils$i.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $ae91d1555267d922$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $ae91d1555267d922$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $ae91d1555267d922$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $ae91d1555267d922$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $ae91d1555267d922$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $ae91d1555267d922$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $ae91d1555267d922$var$fill_window(s);
            if (s.lookahead === 0 && flush === $ae91d1555267d922$var$Z_NO_FLUSH$1) return $ae91d1555267d922$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $ae91d1555267d922$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $ae91d1555267d922$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $ae91d1555267d922$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $ae91d1555267d922$var$Z_FINISH$2) {
        /*** FLUSH_BLOCK(s, 1); ***/ $ae91d1555267d922$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_FINISH_STARTED;
        /***/ return $ae91d1555267d922$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $ae91d1555267d922$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_NEED_MORE;
    /***/ }
    return $ae91d1555267d922$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $ae91d1555267d922$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $ae91d1555267d922$var$MIN_LOOKAHEAD) {
            $ae91d1555267d922$var$fill_window(s);
            if (s.lookahead < $ae91d1555267d922$var$MIN_LOOKAHEAD && flush === $ae91d1555267d922$var$Z_NO_FLUSH$1) return $ae91d1555267d922$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $ae91d1555267d922$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $ae91d1555267d922$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $ae91d1555267d922$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $ae91d1555267d922$var$longest_match(s, hash_head);
        if (s.match_length >= $ae91d1555267d922$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $ae91d1555267d922$var$trees._tr_tally(s, s.strstart - s.match_start, s.match_length - $ae91d1555267d922$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $ae91d1555267d922$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $ae91d1555267d922$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ae91d1555267d922$var$trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $ae91d1555267d922$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $ae91d1555267d922$var$MIN_MATCH - 1 ? s.strstart : $ae91d1555267d922$var$MIN_MATCH - 1;
    if (flush === $ae91d1555267d922$var$Z_FINISH$2) {
        /*** FLUSH_BLOCK(s, 1); ***/ $ae91d1555267d922$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_FINISH_STARTED;
        /***/ return $ae91d1555267d922$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $ae91d1555267d922$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_NEED_MORE;
    /***/ }
    return $ae91d1555267d922$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $ae91d1555267d922$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $ae91d1555267d922$var$MIN_LOOKAHEAD) {
            $ae91d1555267d922$var$fill_window(s);
            if (s.lookahead < $ae91d1555267d922$var$MIN_LOOKAHEAD && flush === $ae91d1555267d922$var$Z_NO_FLUSH$1) return $ae91d1555267d922$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $ae91d1555267d922$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $ae91d1555267d922$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $ae91d1555267d922$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $ae91d1555267d922$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $ae91d1555267d922$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $ae91d1555267d922$var$Z_FILTERED || s.match_length === $ae91d1555267d922$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $ae91d1555267d922$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $ae91d1555267d922$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $ae91d1555267d922$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $ae91d1555267d922$var$trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $ae91d1555267d922$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $ae91d1555267d922$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $ae91d1555267d922$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $ae91d1555267d922$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $ae91d1555267d922$var$trees._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $ae91d1555267d922$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $ae91d1555267d922$var$trees._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $ae91d1555267d922$var$MIN_MATCH - 1 ? s.strstart : $ae91d1555267d922$var$MIN_MATCH - 1;
    if (flush === $ae91d1555267d922$var$Z_FINISH$2) {
        /*** FLUSH_BLOCK(s, 1); ***/ $ae91d1555267d922$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_FINISH_STARTED;
        /***/ return $ae91d1555267d922$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $ae91d1555267d922$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_NEED_MORE;
    /***/ }
    return $ae91d1555267d922$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $ae91d1555267d922$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $ae91d1555267d922$var$MAX_MATCH) {
            $ae91d1555267d922$var$fill_window(s);
            if (s.lookahead <= $ae91d1555267d922$var$MAX_MATCH && flush === $ae91d1555267d922$var$Z_NO_FLUSH$1) return $ae91d1555267d922$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $ae91d1555267d922$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $ae91d1555267d922$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $ae91d1555267d922$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $ae91d1555267d922$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $ae91d1555267d922$var$trees._tr_tally(s, 1, s.match_length - $ae91d1555267d922$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ae91d1555267d922$var$trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $ae91d1555267d922$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $ae91d1555267d922$var$Z_FINISH$2) {
        /*** FLUSH_BLOCK(s, 1); ***/ $ae91d1555267d922$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_FINISH_STARTED;
        /***/ return $ae91d1555267d922$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $ae91d1555267d922$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_NEED_MORE;
    /***/ }
    return $ae91d1555267d922$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $ae91d1555267d922$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $ae91d1555267d922$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $ae91d1555267d922$var$Z_NO_FLUSH$1) return $ae91d1555267d922$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ae91d1555267d922$var$trees._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $ae91d1555267d922$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $ae91d1555267d922$var$Z_FINISH$2) {
        /*** FLUSH_BLOCK(s, 1); ***/ $ae91d1555267d922$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_FINISH_STARTED;
        /***/ return $ae91d1555267d922$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $ae91d1555267d922$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $ae91d1555267d922$var$BS_NEED_MORE;
    /***/ }
    return $ae91d1555267d922$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $ae91d1555267d922$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $ae91d1555267d922$var$configuration_table;
$ae91d1555267d922$var$configuration_table = [
    /*      good lazy nice chain */ new $ae91d1555267d922$var$Config(0, 0, 0, 0, $ae91d1555267d922$var$deflate_stored),
    /* 0 store only */ new $ae91d1555267d922$var$Config(4, 4, 8, 4, $ae91d1555267d922$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $ae91d1555267d922$var$Config(4, 5, 16, 8, $ae91d1555267d922$var$deflate_fast),
    /* 2 */ new $ae91d1555267d922$var$Config(4, 6, 32, 32, $ae91d1555267d922$var$deflate_fast),
    /* 3 */ new $ae91d1555267d922$var$Config(4, 4, 16, 16, $ae91d1555267d922$var$deflate_slow),
    /* 4 lazy matches */ new $ae91d1555267d922$var$Config(8, 16, 32, 32, $ae91d1555267d922$var$deflate_slow),
    /* 5 */ new $ae91d1555267d922$var$Config(8, 16, 128, 128, $ae91d1555267d922$var$deflate_slow),
    /* 6 */ new $ae91d1555267d922$var$Config(8, 32, 128, 256, $ae91d1555267d922$var$deflate_slow),
    /* 7 */ new $ae91d1555267d922$var$Config(32, 128, 258, 1024, $ae91d1555267d922$var$deflate_slow),
    /* 8 */ new $ae91d1555267d922$var$Config(32, 258, 258, 4096, $ae91d1555267d922$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $ae91d1555267d922$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $ae91d1555267d922$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $ae91d1555267d922$var$configuration_table[s.level].max_lazy;
    s.good_match = $ae91d1555267d922$var$configuration_table[s.level].good_length;
    s.nice_match = $ae91d1555267d922$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $ae91d1555267d922$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $ae91d1555267d922$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $ae91d1555267d922$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $ae91d1555267d922$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $ae91d1555267d922$var$utils$i.Buf16($ae91d1555267d922$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $ae91d1555267d922$var$utils$i.Buf16((2 * $ae91d1555267d922$var$D_CODES + 1) * 2);
    this.bl_tree = new $ae91d1555267d922$var$utils$i.Buf16((2 * $ae91d1555267d922$var$BL_CODES + 1) * 2);
    $ae91d1555267d922$var$zero(this.dyn_ltree);
    $ae91d1555267d922$var$zero(this.dyn_dtree);
    $ae91d1555267d922$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $ae91d1555267d922$var$utils$i.Buf16($ae91d1555267d922$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $ae91d1555267d922$var$utils$i.Buf16(2 * $ae91d1555267d922$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $ae91d1555267d922$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $ae91d1555267d922$var$utils$i.Buf16(2 * $ae91d1555267d922$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $ae91d1555267d922$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $ae91d1555267d922$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $ae91d1555267d922$var$err(strm, $ae91d1555267d922$var$Z_STREAM_ERROR$1);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $ae91d1555267d922$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $ae91d1555267d922$var$INIT_STATE : $ae91d1555267d922$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $ae91d1555267d922$var$Z_NO_FLUSH$1;
    $ae91d1555267d922$var$trees._tr_init(s);
    return $ae91d1555267d922$var$Z_OK$2;
}
function $ae91d1555267d922$var$deflateReset(strm) {
    var ret = $ae91d1555267d922$var$deflateResetKeep(strm);
    if (ret === $ae91d1555267d922$var$Z_OK$2) $ae91d1555267d922$var$lm_init(strm.state);
    return ret;
}
function $ae91d1555267d922$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $ae91d1555267d922$var$Z_STREAM_ERROR$1;
    if (strm.state.wrap !== 2) return $ae91d1555267d922$var$Z_STREAM_ERROR$1;
    strm.state.gzhead = head;
    return $ae91d1555267d922$var$Z_OK$2;
}
function $ae91d1555267d922$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $ae91d1555267d922$var$Z_STREAM_ERROR$1;
    var wrap = 1;
    if (level === $ae91d1555267d922$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $ae91d1555267d922$var$MAX_MEM_LEVEL || method !== $ae91d1555267d922$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $ae91d1555267d922$var$Z_FIXED) return $ae91d1555267d922$var$err(strm, $ae91d1555267d922$var$Z_STREAM_ERROR$1);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $ae91d1555267d922$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $ae91d1555267d922$var$MIN_MATCH - 1) / $ae91d1555267d922$var$MIN_MATCH);
    s.window = new $ae91d1555267d922$var$utils$i.Buf8(s.w_size * 2);
    s.head = new $ae91d1555267d922$var$utils$i.Buf16(s.hash_size);
    s.prev = new $ae91d1555267d922$var$utils$i.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $ae91d1555267d922$var$utils$i.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $ae91d1555267d922$var$deflateReset(strm);
}
function $ae91d1555267d922$var$deflateInit(strm, level) {
    return $ae91d1555267d922$var$deflateInit2(strm, level, $ae91d1555267d922$var$Z_DEFLATED$2, $ae91d1555267d922$var$MAX_WBITS$1, $ae91d1555267d922$var$DEF_MEM_LEVEL, $ae91d1555267d922$var$Z_DEFAULT_STRATEGY$1);
}
function $ae91d1555267d922$var$deflate$2(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $ae91d1555267d922$var$Z_BLOCK$1 || flush < 0) return strm ? $ae91d1555267d922$var$err(strm, $ae91d1555267d922$var$Z_STREAM_ERROR$1) : $ae91d1555267d922$var$Z_STREAM_ERROR$1;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $ae91d1555267d922$var$FINISH_STATE && flush !== $ae91d1555267d922$var$Z_FINISH$2) return $ae91d1555267d922$var$err(strm, strm.avail_out === 0 ? $ae91d1555267d922$var$Z_BUF_ERROR$1 : $ae91d1555267d922$var$Z_STREAM_ERROR$1);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $ae91d1555267d922$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $ae91d1555267d922$var$put_byte(s, 31);
            $ae91d1555267d922$var$put_byte(s, 139);
            $ae91d1555267d922$var$put_byte(s, 8);
            if (!s.gzhead) {
                $ae91d1555267d922$var$put_byte(s, 0);
                $ae91d1555267d922$var$put_byte(s, 0);
                $ae91d1555267d922$var$put_byte(s, 0);
                $ae91d1555267d922$var$put_byte(s, 0);
                $ae91d1555267d922$var$put_byte(s, 0);
                $ae91d1555267d922$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $ae91d1555267d922$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $ae91d1555267d922$var$put_byte(s, $ae91d1555267d922$var$OS_CODE);
                s.status = $ae91d1555267d922$var$BUSY_STATE;
            } else {
                $ae91d1555267d922$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $ae91d1555267d922$var$put_byte(s, s.gzhead.time & 0xff);
                $ae91d1555267d922$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $ae91d1555267d922$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $ae91d1555267d922$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $ae91d1555267d922$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $ae91d1555267d922$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $ae91d1555267d922$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $ae91d1555267d922$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $ae91d1555267d922$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $ae91d1555267d922$var$crc32$2(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $ae91d1555267d922$var$EXTRA_STATE;
            }
        } else {
            var header = $ae91d1555267d922$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $ae91d1555267d922$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $ae91d1555267d922$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $ae91d1555267d922$var$BUSY_STATE;
            $ae91d1555267d922$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $ae91d1555267d922$var$putShortMSB(s, strm.adler >>> 16);
                $ae91d1555267d922$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $ae91d1555267d922$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $ae91d1555267d922$var$crc32$2(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $ae91d1555267d922$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $ae91d1555267d922$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $ae91d1555267d922$var$crc32$2(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $ae91d1555267d922$var$NAME_STATE;
            }
        } else s.status = $ae91d1555267d922$var$NAME_STATE;
    }
    if (s.status === $ae91d1555267d922$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $ae91d1555267d922$var$crc32$2(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $ae91d1555267d922$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $ae91d1555267d922$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $ae91d1555267d922$var$crc32$2(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $ae91d1555267d922$var$COMMENT_STATE;
            }
        } else s.status = $ae91d1555267d922$var$COMMENT_STATE;
    }
    if (s.status === $ae91d1555267d922$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $ae91d1555267d922$var$crc32$2(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $ae91d1555267d922$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $ae91d1555267d922$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $ae91d1555267d922$var$crc32$2(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $ae91d1555267d922$var$HCRC_STATE;
        } else s.status = $ae91d1555267d922$var$HCRC_STATE;
    }
    if (s.status === $ae91d1555267d922$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $ae91d1555267d922$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $ae91d1555267d922$var$put_byte(s, strm.adler & 0xff);
                $ae91d1555267d922$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $ae91d1555267d922$var$BUSY_STATE;
            }
        } else s.status = $ae91d1555267d922$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $ae91d1555267d922$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $ae91d1555267d922$var$Z_OK$2;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $ae91d1555267d922$var$rank(flush) <= $ae91d1555267d922$var$rank(old_flush) && flush !== $ae91d1555267d922$var$Z_FINISH$2) return $ae91d1555267d922$var$err(strm, $ae91d1555267d922$var$Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === $ae91d1555267d922$var$FINISH_STATE && strm.avail_in !== 0) return $ae91d1555267d922$var$err(strm, $ae91d1555267d922$var$Z_BUF_ERROR$1);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $ae91d1555267d922$var$Z_NO_FLUSH$1 && s.status !== $ae91d1555267d922$var$FINISH_STATE) {
        var bstate = s.strategy === $ae91d1555267d922$var$Z_HUFFMAN_ONLY ? $ae91d1555267d922$var$deflate_huff(s, flush) : s.strategy === $ae91d1555267d922$var$Z_RLE ? $ae91d1555267d922$var$deflate_rle(s, flush) : $ae91d1555267d922$var$configuration_table[s.level].func(s, flush);
        if (bstate === $ae91d1555267d922$var$BS_FINISH_STARTED || bstate === $ae91d1555267d922$var$BS_FINISH_DONE) s.status = $ae91d1555267d922$var$FINISH_STATE;
        if (bstate === $ae91d1555267d922$var$BS_NEED_MORE || bstate === $ae91d1555267d922$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $ae91d1555267d922$var$Z_OK$2;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $ae91d1555267d922$var$BS_BLOCK_DONE) {
            if (flush === $ae91d1555267d922$var$Z_PARTIAL_FLUSH) $ae91d1555267d922$var$trees._tr_align(s);
            else if (flush !== $ae91d1555267d922$var$Z_BLOCK$1) {
                $ae91d1555267d922$var$trees._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $ae91d1555267d922$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $ae91d1555267d922$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $ae91d1555267d922$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $ae91d1555267d922$var$Z_OK$2;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $ae91d1555267d922$var$Z_FINISH$2) return $ae91d1555267d922$var$Z_OK$2;
    if (s.wrap <= 0) return $ae91d1555267d922$var$Z_STREAM_END$2;
    /* Write the trailer */ if (s.wrap === 2) {
        $ae91d1555267d922$var$put_byte(s, strm.adler & 0xff);
        $ae91d1555267d922$var$put_byte(s, strm.adler >> 8 & 0xff);
        $ae91d1555267d922$var$put_byte(s, strm.adler >> 16 & 0xff);
        $ae91d1555267d922$var$put_byte(s, strm.adler >> 24 & 0xff);
        $ae91d1555267d922$var$put_byte(s, strm.total_in & 0xff);
        $ae91d1555267d922$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $ae91d1555267d922$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $ae91d1555267d922$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $ae91d1555267d922$var$putShortMSB(s, strm.adler >>> 16);
        $ae91d1555267d922$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $ae91d1555267d922$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $ae91d1555267d922$var$Z_OK$2 : $ae91d1555267d922$var$Z_STREAM_END$2;
}
function $ae91d1555267d922$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $ae91d1555267d922$var$Z_STREAM_ERROR$1;
    status = strm.state.status;
    if (status !== $ae91d1555267d922$var$INIT_STATE && status !== $ae91d1555267d922$var$EXTRA_STATE && status !== $ae91d1555267d922$var$NAME_STATE && status !== $ae91d1555267d922$var$COMMENT_STATE && status !== $ae91d1555267d922$var$HCRC_STATE && status !== $ae91d1555267d922$var$BUSY_STATE && status !== $ae91d1555267d922$var$FINISH_STATE) return $ae91d1555267d922$var$err(strm, $ae91d1555267d922$var$Z_STREAM_ERROR$1);
    strm.state = null;
    return status === $ae91d1555267d922$var$BUSY_STATE ? $ae91d1555267d922$var$err(strm, $ae91d1555267d922$var$Z_DATA_ERROR$1) : $ae91d1555267d922$var$Z_OK$2;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $ae91d1555267d922$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $ae91d1555267d922$var$Z_STREAM_ERROR$1;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $ae91d1555267d922$var$INIT_STATE || s.lookahead) return $ae91d1555267d922$var$Z_STREAM_ERROR$1;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $ae91d1555267d922$var$adler32$1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $ae91d1555267d922$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $ae91d1555267d922$var$utils$i.Buf8(s.w_size);
        $ae91d1555267d922$var$utils$i.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $ae91d1555267d922$var$fill_window(s);
    while(s.lookahead >= $ae91d1555267d922$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($ae91d1555267d922$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $ae91d1555267d922$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $ae91d1555267d922$var$MIN_MATCH - 1;
        $ae91d1555267d922$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $ae91d1555267d922$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $ae91d1555267d922$var$Z_OK$2;
}
$ae91d1555267d922$var$deflate$3.deflateInit = $ae91d1555267d922$var$deflateInit;
$ae91d1555267d922$var$deflate$3.deflateInit2 = $ae91d1555267d922$var$deflateInit2;
$ae91d1555267d922$var$deflate$3.deflateReset = $ae91d1555267d922$var$deflateReset;
$ae91d1555267d922$var$deflate$3.deflateResetKeep = $ae91d1555267d922$var$deflateResetKeep;
$ae91d1555267d922$var$deflate$3.deflateSetHeader = $ae91d1555267d922$var$deflateSetHeader;
$ae91d1555267d922$var$deflate$3.deflate = $ae91d1555267d922$var$deflate$2;
$ae91d1555267d922$var$deflate$3.deflateEnd = $ae91d1555267d922$var$deflateEnd;
$ae91d1555267d922$var$deflate$3.deflateSetDictionary = $ae91d1555267d922$var$deflateSetDictionary;
$ae91d1555267d922$var$deflate$3.deflateInfo = "pako deflate (from Nodeca project)";
var $ae91d1555267d922$var$strings$2 = {};
var $ae91d1555267d922$var$utils$h = $ae91d1555267d922$var$common;
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $ae91d1555267d922$var$STR_APPLY_OK = true;
var $ae91d1555267d922$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $ae91d1555267d922$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $ae91d1555267d922$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $ae91d1555267d922$var$_utf8len = new $ae91d1555267d922$var$utils$h.Buf8(256);
for(var $ae91d1555267d922$var$q = 0; $ae91d1555267d922$var$q < 256; $ae91d1555267d922$var$q++)$ae91d1555267d922$var$_utf8len[$ae91d1555267d922$var$q] = $ae91d1555267d922$var$q >= 252 ? 6 : $ae91d1555267d922$var$q >= 248 ? 5 : $ae91d1555267d922$var$q >= 240 ? 4 : $ae91d1555267d922$var$q >= 224 ? 3 : $ae91d1555267d922$var$q >= 192 ? 2 : 1;
$ae91d1555267d922$var$_utf8len[254] = $ae91d1555267d922$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
$ae91d1555267d922$var$strings$2.string2buf = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $ae91d1555267d922$var$utils$h.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $ae91d1555267d922$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $ae91d1555267d922$var$STR_APPLY_UIA_OK || !buf.subarray && $ae91d1555267d922$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $ae91d1555267d922$var$utils$h.shrinkBuf(buf, len));
    }
    var result = "";
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
// Convert byte array to binary string
$ae91d1555267d922$var$strings$2.buf2binstring = function(buf) {
    return $ae91d1555267d922$var$buf2binstring(buf, buf.length);
};
// Convert binary string (typed, when possible)
$ae91d1555267d922$var$strings$2.binstring2buf = function(str) {
    var buf = new $ae91d1555267d922$var$utils$h.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
// convert array to string
$ae91d1555267d922$var$strings$2.buf2string = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $ae91d1555267d922$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $ae91d1555267d922$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
$ae91d1555267d922$var$strings$2.utf8border = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $ae91d1555267d922$var$_utf8len[buf[pos]] > max ? pos : max;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $ae91d1555267d922$var$ZStream$2() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $ae91d1555267d922$var$zstream = $ae91d1555267d922$var$ZStream$2;
var $ae91d1555267d922$var$zlib_deflate = $ae91d1555267d922$var$deflate$3;
var $ae91d1555267d922$var$utils$g = $ae91d1555267d922$var$common;
var $ae91d1555267d922$var$strings$1 = $ae91d1555267d922$var$strings$2;
var $ae91d1555267d922$var$msg$1 = $ae91d1555267d922$var$messages$1;
var $ae91d1555267d922$var$ZStream$1 = $ae91d1555267d922$var$zstream;
var $ae91d1555267d922$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $ae91d1555267d922$var$Z_NO_FLUSH = 0;
var $ae91d1555267d922$var$Z_FINISH$1 = 4;
var $ae91d1555267d922$var$Z_OK$1 = 0;
var $ae91d1555267d922$var$Z_STREAM_END$1 = 1;
var $ae91d1555267d922$var$Z_SYNC_FLUSH = 2;
var $ae91d1555267d922$var$Z_DEFAULT_COMPRESSION = -1;
var $ae91d1555267d922$var$Z_DEFAULT_STRATEGY = 0;
var $ae91d1555267d922$var$Z_DEFLATED$1 = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $ae91d1555267d922$var$Deflate(options) {
    if (!(this instanceof $ae91d1555267d922$var$Deflate)) return new $ae91d1555267d922$var$Deflate(options);
    this.options = $ae91d1555267d922$var$utils$g.assign({
        level: $ae91d1555267d922$var$Z_DEFAULT_COMPRESSION,
        method: $ae91d1555267d922$var$Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $ae91d1555267d922$var$Z_DEFAULT_STRATEGY,
        to: ""
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $ae91d1555267d922$var$ZStream$1();
    this.strm.avail_out = 0;
    var status = $ae91d1555267d922$var$zlib_deflate.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $ae91d1555267d922$var$Z_OK$1) throw new Error($ae91d1555267d922$var$msg$1[status]);
    if (opt.header) $ae91d1555267d922$var$zlib_deflate.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === "string") // If we need to compress text, change encoding to utf8.
        dict = $ae91d1555267d922$var$strings$1.string2buf(opt.dictionary);
        else if ($ae91d1555267d922$var$toString$1.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $ae91d1555267d922$var$zlib_deflate.deflateSetDictionary(this.strm, dict);
        if (status !== $ae91d1555267d922$var$Z_OK$1) throw new Error($ae91d1555267d922$var$msg$1[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $ae91d1555267d922$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $ae91d1555267d922$var$Z_FINISH$1 : $ae91d1555267d922$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === "string") // If we need to compress text, change encoding to utf8.
    strm.input = $ae91d1555267d922$var$strings$1.string2buf(data);
    else if ($ae91d1555267d922$var$toString$1.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $ae91d1555267d922$var$utils$g.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $ae91d1555267d922$var$zlib_deflate.deflate(strm, _mode); /* no bad return value */ 
        if (status !== $ae91d1555267d922$var$Z_STREAM_END$1 && status !== $ae91d1555267d922$var$Z_OK$1) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $ae91d1555267d922$var$Z_FINISH$1 || _mode === $ae91d1555267d922$var$Z_SYNC_FLUSH)) {
            if (this.options.to === "string") this.onData($ae91d1555267d922$var$strings$1.buf2binstring($ae91d1555267d922$var$utils$g.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($ae91d1555267d922$var$utils$g.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $ae91d1555267d922$var$Z_STREAM_END$1);
    // Finalize on the last chunk.
    if (_mode === $ae91d1555267d922$var$Z_FINISH$1) {
        status = $ae91d1555267d922$var$zlib_deflate.deflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $ae91d1555267d922$var$Z_OK$1;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $ae91d1555267d922$var$Z_SYNC_FLUSH) {
        this.onEnd($ae91d1555267d922$var$Z_OK$1);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $ae91d1555267d922$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $ae91d1555267d922$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $ae91d1555267d922$var$Z_OK$1) {
        if (this.options.to === "string") this.result = this.chunks.join("");
        else this.result = $ae91d1555267d922$var$utils$g.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $ae91d1555267d922$var$deflate$1(input, options) {
    var deflator = new $ae91d1555267d922$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $ae91d1555267d922$var$msg$1[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $ae91d1555267d922$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $ae91d1555267d922$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $ae91d1555267d922$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $ae91d1555267d922$var$deflate$1(input, options);
}
$ae91d1555267d922$var$deflate$4.Deflate = $ae91d1555267d922$var$Deflate;
$ae91d1555267d922$var$deflate$4.deflate = $ae91d1555267d922$var$deflate$1;
$ae91d1555267d922$var$deflate$4.deflateRaw = $ae91d1555267d922$var$deflateRaw;
$ae91d1555267d922$var$deflate$4.gzip = $ae91d1555267d922$var$gzip;
var $ae91d1555267d922$var$inflate$4 = {};
var $ae91d1555267d922$var$inflate$3 = {};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $ae91d1555267d922$var$BAD$1 = 30; /* got a data error -- remain here until reset */ 
var $ae91d1555267d922$var$TYPE$1 = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $ae91d1555267d922$var$inffast = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $ae91d1555267d922$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $ae91d1555267d922$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $ae91d1555267d922$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $ae91d1555267d922$var$TYPE$1;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $ae91d1555267d922$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $ae91d1555267d922$var$utils$f = $ae91d1555267d922$var$common;
var $ae91d1555267d922$var$MAXBITS = 15;
var $ae91d1555267d922$var$ENOUGH_LENS$1 = 852;
var $ae91d1555267d922$var$ENOUGH_DISTS$1 = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $ae91d1555267d922$var$CODES$1 = 0;
var $ae91d1555267d922$var$LENS$1 = 1;
var $ae91d1555267d922$var$DISTS$1 = 2;
var $ae91d1555267d922$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $ae91d1555267d922$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $ae91d1555267d922$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $ae91d1555267d922$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
var $ae91d1555267d922$var$inftrees = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $ae91d1555267d922$var$utils$f.Buf16($ae91d1555267d922$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $ae91d1555267d922$var$utils$f.Buf16($ae91d1555267d922$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $ae91d1555267d922$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $ae91d1555267d922$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $ae91d1555267d922$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $ae91d1555267d922$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $ae91d1555267d922$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $ae91d1555267d922$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $ae91d1555267d922$var$LENS$1) {
        base = $ae91d1555267d922$var$lbase;
        base_index -= 257;
        extra = $ae91d1555267d922$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $ae91d1555267d922$var$dbase;
        extra = $ae91d1555267d922$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $ae91d1555267d922$var$LENS$1 && used > $ae91d1555267d922$var$ENOUGH_LENS$1 || type === $ae91d1555267d922$var$DISTS$1 && used > $ae91d1555267d922$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $ae91d1555267d922$var$LENS$1 && used > $ae91d1555267d922$var$ENOUGH_LENS$1 || type === $ae91d1555267d922$var$DISTS$1 && used > $ae91d1555267d922$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $ae91d1555267d922$var$utils$e = $ae91d1555267d922$var$common;
var $ae91d1555267d922$var$adler32 = $ae91d1555267d922$var$adler32_1;
var $ae91d1555267d922$var$crc32$1 = $ae91d1555267d922$var$crc32_1;
var $ae91d1555267d922$var$inflate_fast = $ae91d1555267d922$var$inffast;
var $ae91d1555267d922$var$inflate_table = $ae91d1555267d922$var$inftrees;
var $ae91d1555267d922$var$CODES = 0;
var $ae91d1555267d922$var$LENS = 1;
var $ae91d1555267d922$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $ae91d1555267d922$var$Z_FINISH = 4;
var $ae91d1555267d922$var$Z_BLOCK = 5;
var $ae91d1555267d922$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $ae91d1555267d922$var$Z_OK = 0;
var $ae91d1555267d922$var$Z_STREAM_END = 1;
var $ae91d1555267d922$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $ae91d1555267d922$var$Z_STREAM_ERROR = -2;
var $ae91d1555267d922$var$Z_DATA_ERROR = -3;
var $ae91d1555267d922$var$Z_MEM_ERROR = -4;
var $ae91d1555267d922$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $ae91d1555267d922$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $ae91d1555267d922$var$HEAD = 1; /* i: waiting for magic header */ 
var $ae91d1555267d922$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $ae91d1555267d922$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $ae91d1555267d922$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $ae91d1555267d922$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $ae91d1555267d922$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $ae91d1555267d922$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $ae91d1555267d922$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $ae91d1555267d922$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $ae91d1555267d922$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $ae91d1555267d922$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $ae91d1555267d922$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $ae91d1555267d922$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $ae91d1555267d922$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $ae91d1555267d922$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $ae91d1555267d922$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $ae91d1555267d922$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $ae91d1555267d922$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $ae91d1555267d922$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $ae91d1555267d922$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $ae91d1555267d922$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $ae91d1555267d922$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $ae91d1555267d922$var$DIST = 23; /* i: waiting for distance code */ 
var $ae91d1555267d922$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $ae91d1555267d922$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $ae91d1555267d922$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $ae91d1555267d922$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $ae91d1555267d922$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $ae91d1555267d922$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $ae91d1555267d922$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $ae91d1555267d922$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $ae91d1555267d922$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $ae91d1555267d922$var$ENOUGH_LENS = 852;
var $ae91d1555267d922$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $ae91d1555267d922$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $ae91d1555267d922$var$DEF_WBITS = $ae91d1555267d922$var$MAX_WBITS;
function $ae91d1555267d922$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $ae91d1555267d922$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $ae91d1555267d922$var$utils$e.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $ae91d1555267d922$var$utils$e.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $ae91d1555267d922$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $ae91d1555267d922$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $ae91d1555267d922$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $ae91d1555267d922$var$utils$e.Buf32($ae91d1555267d922$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $ae91d1555267d922$var$utils$e.Buf32($ae91d1555267d922$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $ae91d1555267d922$var$Z_OK;
}
function $ae91d1555267d922$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $ae91d1555267d922$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $ae91d1555267d922$var$inflateResetKeep(strm);
}
function $ae91d1555267d922$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $ae91d1555267d922$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $ae91d1555267d922$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $ae91d1555267d922$var$inflateReset(strm);
}
function $ae91d1555267d922$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $ae91d1555267d922$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $ae91d1555267d922$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $ae91d1555267d922$var$inflateReset2(strm, windowBits);
    if (ret !== $ae91d1555267d922$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $ae91d1555267d922$var$inflateInit(strm) {
    return $ae91d1555267d922$var$inflateInit2(strm, $ae91d1555267d922$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $ae91d1555267d922$var$virgin = true;
var $ae91d1555267d922$var$lenfix, $ae91d1555267d922$var$distfix; // We have no pointers in JS, so keep tables separate
function $ae91d1555267d922$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($ae91d1555267d922$var$virgin) {
        var sym;
        $ae91d1555267d922$var$lenfix = new $ae91d1555267d922$var$utils$e.Buf32(512);
        $ae91d1555267d922$var$distfix = new $ae91d1555267d922$var$utils$e.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $ae91d1555267d922$var$inflate_table($ae91d1555267d922$var$LENS, state.lens, 0, 288, $ae91d1555267d922$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $ae91d1555267d922$var$inflate_table($ae91d1555267d922$var$DISTS, state.lens, 0, 32, $ae91d1555267d922$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $ae91d1555267d922$var$virgin = false;
    }
    state.lencode = $ae91d1555267d922$var$lenfix;
    state.lenbits = 9;
    state.distcode = $ae91d1555267d922$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $ae91d1555267d922$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $ae91d1555267d922$var$utils$e.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $ae91d1555267d922$var$utils$e.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $ae91d1555267d922$var$utils$e.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $ae91d1555267d922$var$utils$e.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $ae91d1555267d922$var$inflate$2(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $ae91d1555267d922$var$utils$e.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $ae91d1555267d922$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $ae91d1555267d922$var$TYPE) state.mode = $ae91d1555267d922$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $ae91d1555267d922$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $ae91d1555267d922$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $ae91d1555267d922$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $ae91d1555267d922$var$crc32$1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $ae91d1555267d922$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $ae91d1555267d922$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $ae91d1555267d922$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $ae91d1555267d922$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $ae91d1555267d922$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $ae91d1555267d922$var$DICTID : $ae91d1555267d922$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $ae91d1555267d922$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $ae91d1555267d922$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $ae91d1555267d922$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $ae91d1555267d922$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $ae91d1555267d922$var$crc32$1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae91d1555267d922$var$TIME;
        /* falls through */ case $ae91d1555267d922$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $ae91d1555267d922$var$crc32$1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae91d1555267d922$var$OS;
        /* falls through */ case $ae91d1555267d922$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $ae91d1555267d922$var$crc32$1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae91d1555267d922$var$EXLEN;
        /* falls through */ case $ae91d1555267d922$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $ae91d1555267d922$var$crc32$1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $ae91d1555267d922$var$EXTRA;
        /* falls through */ case $ae91d1555267d922$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $ae91d1555267d922$var$utils$e.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $ae91d1555267d922$var$crc32$1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $ae91d1555267d922$var$NAME;
        /* falls through */ case $ae91d1555267d922$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $ae91d1555267d922$var$crc32$1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $ae91d1555267d922$var$COMMENT;
        /* falls through */ case $ae91d1555267d922$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $ae91d1555267d922$var$crc32$1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $ae91d1555267d922$var$HCRC;
        /* falls through */ case $ae91d1555267d922$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $ae91d1555267d922$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $ae91d1555267d922$var$TYPE;
            break;
        case $ae91d1555267d922$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $ae91d1555267d922$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae91d1555267d922$var$DICT;
        /* falls through */ case $ae91d1555267d922$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $ae91d1555267d922$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $ae91d1555267d922$var$TYPE;
        /* falls through */ case $ae91d1555267d922$var$TYPE:
            if (flush === $ae91d1555267d922$var$Z_BLOCK || flush === $ae91d1555267d922$var$Z_TREES) break inf_leave;
        /* falls through */ case $ae91d1555267d922$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $ae91d1555267d922$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $ae91d1555267d922$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $ae91d1555267d922$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $ae91d1555267d922$var$LEN_; /* decode codes */ 
                    if (flush === $ae91d1555267d922$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $ae91d1555267d922$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $ae91d1555267d922$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $ae91d1555267d922$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $ae91d1555267d922$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae91d1555267d922$var$COPY_;
            if (flush === $ae91d1555267d922$var$Z_TREES) break inf_leave;
        /* falls through */ case $ae91d1555267d922$var$COPY_:
            state.mode = $ae91d1555267d922$var$COPY;
        /* falls through */ case $ae91d1555267d922$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $ae91d1555267d922$var$utils$e.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $ae91d1555267d922$var$TYPE;
            break;
        case $ae91d1555267d922$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $ae91d1555267d922$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $ae91d1555267d922$var$LENLENS;
        /* falls through */ case $ae91d1555267d922$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $ae91d1555267d922$var$inflate_table($ae91d1555267d922$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $ae91d1555267d922$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $ae91d1555267d922$var$CODELENS;
        /* falls through */ case $ae91d1555267d922$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $ae91d1555267d922$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $ae91d1555267d922$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $ae91d1555267d922$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $ae91d1555267d922$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $ae91d1555267d922$var$inflate_table($ae91d1555267d922$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $ae91d1555267d922$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $ae91d1555267d922$var$inflate_table($ae91d1555267d922$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $ae91d1555267d922$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $ae91d1555267d922$var$LEN_;
            if (flush === $ae91d1555267d922$var$Z_TREES) break inf_leave;
        /* falls through */ case $ae91d1555267d922$var$LEN_:
            state.mode = $ae91d1555267d922$var$LEN;
        /* falls through */ case $ae91d1555267d922$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $ae91d1555267d922$var$inflate_fast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $ae91d1555267d922$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $ae91d1555267d922$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $ae91d1555267d922$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $ae91d1555267d922$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $ae91d1555267d922$var$LENEXT;
        /* falls through */ case $ae91d1555267d922$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $ae91d1555267d922$var$DIST;
        /* falls through */ case $ae91d1555267d922$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $ae91d1555267d922$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $ae91d1555267d922$var$DISTEXT;
        /* falls through */ case $ae91d1555267d922$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $ae91d1555267d922$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $ae91d1555267d922$var$MATCH;
        /* falls through */ case $ae91d1555267d922$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $ae91d1555267d922$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $ae91d1555267d922$var$LEN;
            break;
        case $ae91d1555267d922$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $ae91d1555267d922$var$LEN;
            break;
        case $ae91d1555267d922$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $ae91d1555267d922$var$crc32$1(state.check, output, _out, put - _out) : $ae91d1555267d922$var$adler32(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $ae91d1555267d922$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $ae91d1555267d922$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $ae91d1555267d922$var$LENGTH;
        /* falls through */ case $ae91d1555267d922$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $ae91d1555267d922$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $ae91d1555267d922$var$DONE;
        /* falls through */ case $ae91d1555267d922$var$DONE:
            ret = $ae91d1555267d922$var$Z_STREAM_END;
            break inf_leave;
        case $ae91d1555267d922$var$BAD:
            ret = $ae91d1555267d922$var$Z_DATA_ERROR;
            break inf_leave;
        case $ae91d1555267d922$var$MEM:
            return $ae91d1555267d922$var$Z_MEM_ERROR;
        case $ae91d1555267d922$var$SYNC:
        /* falls through */ default:
            return $ae91d1555267d922$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $ae91d1555267d922$var$BAD && (state.mode < $ae91d1555267d922$var$CHECK || flush !== $ae91d1555267d922$var$Z_FINISH)) $ae91d1555267d922$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $ae91d1555267d922$var$crc32$1(state.check, output, _out, strm.next_out - _out) : $ae91d1555267d922$var$adler32(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $ae91d1555267d922$var$TYPE ? 128 : 0) + (state.mode === $ae91d1555267d922$var$LEN_ || state.mode === $ae91d1555267d922$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $ae91d1555267d922$var$Z_FINISH) && ret === $ae91d1555267d922$var$Z_OK) ret = $ae91d1555267d922$var$Z_BUF_ERROR;
    return ret;
}
function $ae91d1555267d922$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $ae91d1555267d922$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $ae91d1555267d922$var$Z_OK;
}
function $ae91d1555267d922$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $ae91d1555267d922$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $ae91d1555267d922$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $ae91d1555267d922$var$Z_OK;
}
function $ae91d1555267d922$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $ae91d1555267d922$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $ae91d1555267d922$var$DICT) return $ae91d1555267d922$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $ae91d1555267d922$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $ae91d1555267d922$var$adler32(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $ae91d1555267d922$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $ae91d1555267d922$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $ae91d1555267d922$var$MEM;
        return $ae91d1555267d922$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $ae91d1555267d922$var$Z_OK;
}
$ae91d1555267d922$var$inflate$3.inflateReset = $ae91d1555267d922$var$inflateReset;
$ae91d1555267d922$var$inflate$3.inflateReset2 = $ae91d1555267d922$var$inflateReset2;
$ae91d1555267d922$var$inflate$3.inflateResetKeep = $ae91d1555267d922$var$inflateResetKeep;
$ae91d1555267d922$var$inflate$3.inflateInit = $ae91d1555267d922$var$inflateInit;
$ae91d1555267d922$var$inflate$3.inflateInit2 = $ae91d1555267d922$var$inflateInit2;
$ae91d1555267d922$var$inflate$3.inflate = $ae91d1555267d922$var$inflate$2;
$ae91d1555267d922$var$inflate$3.inflateEnd = $ae91d1555267d922$var$inflateEnd;
$ae91d1555267d922$var$inflate$3.inflateGetHeader = $ae91d1555267d922$var$inflateGetHeader;
$ae91d1555267d922$var$inflate$3.inflateSetDictionary = $ae91d1555267d922$var$inflateSetDictionary;
$ae91d1555267d922$var$inflate$3.inflateInfo = "pako inflate (from Nodeca project)";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $ae91d1555267d922$var$constants$1 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $ae91d1555267d922$var$GZheader$1() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = "";
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = "";
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $ae91d1555267d922$var$gzheader = $ae91d1555267d922$var$GZheader$1;
var $ae91d1555267d922$var$zlib_inflate = $ae91d1555267d922$var$inflate$3;
var $ae91d1555267d922$var$utils$d = $ae91d1555267d922$var$common;
var $ae91d1555267d922$var$strings = $ae91d1555267d922$var$strings$2;
var $ae91d1555267d922$var$c = $ae91d1555267d922$var$constants$1;
var $ae91d1555267d922$var$msg = $ae91d1555267d922$var$messages$1;
var $ae91d1555267d922$var$ZStream = $ae91d1555267d922$var$zstream;
var $ae91d1555267d922$var$GZheader = $ae91d1555267d922$var$gzheader;
var $ae91d1555267d922$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $ae91d1555267d922$var$Inflate(options) {
    if (!(this instanceof $ae91d1555267d922$var$Inflate)) return new $ae91d1555267d922$var$Inflate(options);
    this.options = $ae91d1555267d922$var$utils$d.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ""
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $ae91d1555267d922$var$ZStream();
    this.strm.avail_out = 0;
    var status = $ae91d1555267d922$var$zlib_inflate.inflateInit2(this.strm, opt.windowBits);
    if (status !== $ae91d1555267d922$var$c.Z_OK) throw new Error($ae91d1555267d922$var$msg[status]);
    this.header = new $ae91d1555267d922$var$GZheader();
    $ae91d1555267d922$var$zlib_inflate.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === "string") opt.dictionary = $ae91d1555267d922$var$strings.string2buf(opt.dictionary);
        else if ($ae91d1555267d922$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $ae91d1555267d922$var$zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $ae91d1555267d922$var$c.Z_OK) throw new Error($ae91d1555267d922$var$msg[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $ae91d1555267d922$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $ae91d1555267d922$var$c.Z_FINISH : $ae91d1555267d922$var$c.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === "string") // Only binary strings can be decompressed on practice
    strm.input = $ae91d1555267d922$var$strings.binstring2buf(data);
    else if ($ae91d1555267d922$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $ae91d1555267d922$var$utils$d.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $ae91d1555267d922$var$zlib_inflate.inflate(strm, $ae91d1555267d922$var$c.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $ae91d1555267d922$var$c.Z_NEED_DICT && dictionary) status = $ae91d1555267d922$var$zlib_inflate.inflateSetDictionary(this.strm, dictionary);
        if (status === $ae91d1555267d922$var$c.Z_BUF_ERROR && allowBufError === true) {
            status = $ae91d1555267d922$var$c.Z_OK;
            allowBufError = false;
        }
        if (status !== $ae91d1555267d922$var$c.Z_STREAM_END && status !== $ae91d1555267d922$var$c.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $ae91d1555267d922$var$c.Z_STREAM_END || strm.avail_in === 0 && (_mode === $ae91d1555267d922$var$c.Z_FINISH || _mode === $ae91d1555267d922$var$c.Z_SYNC_FLUSH)) {
                if (this.options.to === "string") {
                    next_out_utf8 = $ae91d1555267d922$var$strings.utf8border(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $ae91d1555267d922$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $ae91d1555267d922$var$utils$d.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($ae91d1555267d922$var$utils$d.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $ae91d1555267d922$var$c.Z_STREAM_END);
    if (status === $ae91d1555267d922$var$c.Z_STREAM_END) _mode = $ae91d1555267d922$var$c.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $ae91d1555267d922$var$c.Z_FINISH) {
        status = $ae91d1555267d922$var$zlib_inflate.inflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $ae91d1555267d922$var$c.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $ae91d1555267d922$var$c.Z_SYNC_FLUSH) {
        this.onEnd($ae91d1555267d922$var$c.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $ae91d1555267d922$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $ae91d1555267d922$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $ae91d1555267d922$var$c.Z_OK) {
        if (this.options.to === "string") // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join("");
        else this.result = $ae91d1555267d922$var$utils$d.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $ae91d1555267d922$var$inflate$1(input, options) {
    var inflator = new $ae91d1555267d922$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $ae91d1555267d922$var$msg[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $ae91d1555267d922$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $ae91d1555267d922$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ $ae91d1555267d922$var$inflate$4.Inflate = $ae91d1555267d922$var$Inflate;
$ae91d1555267d922$var$inflate$4.inflate = $ae91d1555267d922$var$inflate$1;
$ae91d1555267d922$var$inflate$4.inflateRaw = $ae91d1555267d922$var$inflateRaw;
$ae91d1555267d922$var$inflate$4.ungzip = $ae91d1555267d922$var$inflate$1;
var $ae91d1555267d922$var$assign = $ae91d1555267d922$var$common.assign;
var $ae91d1555267d922$var$deflate = $ae91d1555267d922$var$deflate$4;
var $ae91d1555267d922$var$inflate = $ae91d1555267d922$var$inflate$4;
var $ae91d1555267d922$var$constants = $ae91d1555267d922$var$constants$1;
var $ae91d1555267d922$var$pako$1 = {};
$ae91d1555267d922$var$assign($ae91d1555267d922$var$pako$1, $ae91d1555267d922$var$deflate, $ae91d1555267d922$var$inflate, $ae91d1555267d922$var$constants);
var $ae91d1555267d922$var$pako_1 = $ae91d1555267d922$var$pako$1;
var $ae91d1555267d922$var$USE_TYPEDARRAY = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Uint32Array !== "undefined";
var $ae91d1555267d922$var$pako = $ae91d1555267d922$var$pako_1;
var $ae91d1555267d922$var$utils$c = $ae91d1555267d922$var$utils$r;
var $ae91d1555267d922$var$GenericWorker$4 = $ae91d1555267d922$var$GenericWorker_1;
var $ae91d1555267d922$var$ARRAY_TYPE = $ae91d1555267d922$var$USE_TYPEDARRAY ? "uint8array" : "array";
$ae91d1555267d922$var$flate.magic = "\b\0";
/**
 * Create a worker that uses pako to inflate/deflate.
 * @constructor
 * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
 * @param {Object} options the options to use when (de)compressing.
 */ function $ae91d1555267d922$var$FlateWorker(action, options) {
    $ae91d1555267d922$var$GenericWorker$4.call(this, "FlateWorker/" + action);
    this._pako = null;
    this._pakoAction = action;
    this._pakoOptions = options;
    // the `meta` object from the last chunk received
    // this allow this worker to pass around metadata
    this.meta = {};
}
$ae91d1555267d922$var$utils$c.inherits($ae91d1555267d922$var$FlateWorker, $ae91d1555267d922$var$GenericWorker$4);
/**
 * @see GenericWorker.processChunk
 */ $ae91d1555267d922$var$FlateWorker.prototype.processChunk = function(chunk) {
    this.meta = chunk.meta;
    if (this._pako === null) this._createPako();
    this._pako.push($ae91d1555267d922$var$utils$c.transformTo($ae91d1555267d922$var$ARRAY_TYPE, chunk.data), false);
};
/**
 * @see GenericWorker.flush
 */ $ae91d1555267d922$var$FlateWorker.prototype.flush = function() {
    $ae91d1555267d922$var$GenericWorker$4.prototype.flush.call(this);
    if (this._pako === null) this._createPako();
    this._pako.push([], true);
};
/**
 * @see GenericWorker.cleanUp
 */ $ae91d1555267d922$var$FlateWorker.prototype.cleanUp = function() {
    $ae91d1555267d922$var$GenericWorker$4.prototype.cleanUp.call(this);
    this._pako = null;
};
/**
 * Create the _pako object.
 * TODO: lazy-loading this object isn't the best solution but it's the
 * quickest. The best solution is to lazy-load the worker list. See also the
 * issue #446.
 */ $ae91d1555267d922$var$FlateWorker.prototype._createPako = function() {
    this._pako = new $ae91d1555267d922$var$pako[this._pakoAction]({
        raw: true,
        level: this._pakoOptions.level || -1 // default compression
    });
    var self1 = this;
    this._pako.onData = function(data) {
        self1.push({
            data: data,
            meta: self1.meta
        });
    };
};
$ae91d1555267d922$var$flate.compressWorker = function(compressionOptions) {
    return new $ae91d1555267d922$var$FlateWorker("Deflate", compressionOptions);
};
$ae91d1555267d922$var$flate.uncompressWorker = function() {
    return new $ae91d1555267d922$var$FlateWorker("Inflate", {});
};
var $ae91d1555267d922$var$GenericWorker$3 = $ae91d1555267d922$var$GenericWorker_1;
$ae91d1555267d922$var$compressions$2.STORE = {
    magic: "\0\0",
    compressWorker: function(compressionOptions) {
        return new $ae91d1555267d922$var$GenericWorker$3("STORE compression");
    },
    uncompressWorker: function() {
        return new $ae91d1555267d922$var$GenericWorker$3("STORE decompression");
    }
};
$ae91d1555267d922$var$compressions$2.DEFLATE = $ae91d1555267d922$var$flate;
var $ae91d1555267d922$var$signature$1 = {};
$ae91d1555267d922$var$signature$1.LOCAL_FILE_HEADER = "PK\x03\x04";
$ae91d1555267d922$var$signature$1.CENTRAL_FILE_HEADER = "PK\x01\x02";
$ae91d1555267d922$var$signature$1.CENTRAL_DIRECTORY_END = "PK\x05\x06";
$ae91d1555267d922$var$signature$1.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
$ae91d1555267d922$var$signature$1.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
$ae91d1555267d922$var$signature$1.DATA_DESCRIPTOR = "PK\x07\b";
var $ae91d1555267d922$var$utils$b = $ae91d1555267d922$var$utils$r;
var $ae91d1555267d922$var$GenericWorker$2 = $ae91d1555267d922$var$GenericWorker_1;
var $ae91d1555267d922$var$utf8$3 = $ae91d1555267d922$var$utf8$5;
var $ae91d1555267d922$var$crc32 = $ae91d1555267d922$var$crc32_1$1;
var $ae91d1555267d922$var$signature = $ae91d1555267d922$var$signature$1;
/**
 * Transform an integer into a string in hexadecimal.
 * @private
 * @param {number} dec the number to convert.
 * @param {number} bytes the number of bytes to generate.
 * @returns {string} the result.
 */ var $ae91d1555267d922$var$decToHex = function(dec, bytes) {
    var hex = "", i;
    for(i = 0; i < bytes; i++){
        hex += String.fromCharCode(dec & 0xff);
        dec = dec >>> 8;
    }
    return hex;
};
/**
 * Generate the UNIX part of the external file attributes.
 * @param {Object} unixPermissions the unix permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
 *
 * TTTTsstrwxrwxrwx0000000000ADVSHR
 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
 *     ^^^_________________________ setuid, setgid, sticky
 *        ^^^^^^^^^________________ permissions
 *                 ^^^^^^^^^^______ not used ?
 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
 */ var $ae91d1555267d922$var$generateUnixExternalFileAttr = function(unixPermissions, isDir) {
    var result = unixPermissions;
    if (!unixPermissions) // I can't use octal values in strict mode, hence the hexa.
    //  040775 => 0x41fd
    // 0100664 => 0x81b4
    result = isDir ? 0x41fd : 0x81b4;
    return (result & 0xFFFF) << 16;
};
/**
 * Generate the DOS part of the external file attributes.
 * @param {Object} dosPermissions the dos permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * Bit 0     Read-Only
 * Bit 1     Hidden
 * Bit 2     System
 * Bit 3     Volume Label
 * Bit 4     Directory
 * Bit 5     Archive
 */ var $ae91d1555267d922$var$generateDosExternalFileAttr = function(dosPermissions, isDir) {
    // the dir flag is already set for compatibility
    return (dosPermissions || 0) & 0x3F;
};
/**
 * Generate the various parts used in the construction of the final zip file.
 * @param {Object} streamInfo the hash with information about the compressed file.
 * @param {Boolean} streamedContent is the content streamed ?
 * @param {Boolean} streamingEnded is the stream finished ?
 * @param {number} offset the current offset from the start of the zip file.
 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
 * @param {Function} encodeFileName the function to encode the file name / comment.
 * @return {Object} the zip parts.
 */ var $ae91d1555267d922$var$generateZipParts = function(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
    var file = streamInfo["file"], compression = streamInfo["compression"], useCustomEncoding = encodeFileName !== $ae91d1555267d922$var$utf8$3.utf8encode, encodedFileName = $ae91d1555267d922$var$utils$b.transformTo("string", encodeFileName(file.name)), utfEncodedFileName = $ae91d1555267d922$var$utils$b.transformTo("string", $ae91d1555267d922$var$utf8$3.utf8encode(file.name)), comment = file.comment, encodedComment = $ae91d1555267d922$var$utils$b.transformTo("string", encodeFileName(comment)), utfEncodedComment = $ae91d1555267d922$var$utils$b.transformTo("string", $ae91d1555267d922$var$utf8$3.utf8encode(comment)), useUTF8ForFileName = utfEncodedFileName.length !== file.name.length, useUTF8ForComment = utfEncodedComment.length !== comment.length, dosTime, dosDate, extraFields = "", unicodePathExtraField = "", unicodeCommentExtraField = "", dir = file.dir, date = file.date;
    var dataInfo = {
        crc32: 0,
        compressedSize: 0,
        uncompressedSize: 0
    };
    // if the content is streamed, the sizes/crc32 are only available AFTER
    // the end of the stream.
    if (!streamedContent || streamingEnded) {
        dataInfo.crc32 = streamInfo["crc32"];
        dataInfo.compressedSize = streamInfo["compressedSize"];
        dataInfo.uncompressedSize = streamInfo["uncompressedSize"];
    }
    var bitflag = 0;
    if (streamedContent) // Bit 3: the sizes/crc32 are set to zero in the local header.
    // The correct values are put in the data descriptor immediately
    // following the compressed data.
    bitflag |= 0x0008;
    if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) // Bit 11: Language encoding flag (EFS).
    bitflag |= 0x0800;
    var extFileAttr = 0;
    var versionMadeBy = 0;
    if (dir) // dos or unix, we set the dos dir flag
    extFileAttr |= 0x00010;
    if (platform === "UNIX") {
        versionMadeBy = 0x031E; // UNIX, version 3.0
        extFileAttr |= $ae91d1555267d922$var$generateUnixExternalFileAttr(file.unixPermissions, dir);
    } else {
        versionMadeBy = 0x0014; // DOS, version 2.0
        extFileAttr |= $ae91d1555267d922$var$generateDosExternalFileAttr(file.dosPermissions);
    }
    // date
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html
    dosTime = date.getUTCHours();
    dosTime = dosTime << 6;
    dosTime = dosTime | date.getUTCMinutes();
    dosTime = dosTime << 5;
    dosTime = dosTime | date.getUTCSeconds() / 2;
    dosDate = date.getUTCFullYear() - 1980;
    dosDate = dosDate << 4;
    dosDate = dosDate | date.getUTCMonth() + 1;
    dosDate = dosDate << 5;
    dosDate = dosDate | date.getUTCDate();
    if (useUTF8ForFileName) {
        // set the unicode path extra field. unzip needs at least one extra
        // field to correctly handle unicode path, so using the path is as good
        // as any other information. This could improve the situation with
        // other archive managers too.
        // This field is usually used without the utf8 flag, with a non
        // unicode path in the header (winrar, winzip). This helps (a bit)
        // with the messy Windows' default compressed folders feature but
        // breaks on p7zip which doesn't seek the unicode path extra field.
        // So for now, UTF-8 everywhere !
        unicodePathExtraField = // Version
        $ae91d1555267d922$var$decToHex(1, 1) + // NameCRC32
        $ae91d1555267d922$var$decToHex($ae91d1555267d922$var$crc32(encodedFileName), 4) + // UnicodeName
        utfEncodedFileName;
        extraFields += // Info-ZIP Unicode Path Extra Field
        "up" + // size
        $ae91d1555267d922$var$decToHex(unicodePathExtraField.length, 2) + // content
        unicodePathExtraField;
    }
    if (useUTF8ForComment) {
        unicodeCommentExtraField = // Version
        $ae91d1555267d922$var$decToHex(1, 1) + // CommentCRC32
        $ae91d1555267d922$var$decToHex($ae91d1555267d922$var$crc32(encodedComment), 4) + // UnicodeName
        utfEncodedComment;
        extraFields += // Info-ZIP Unicode Path Extra Field
        "uc" + // size
        $ae91d1555267d922$var$decToHex(unicodeCommentExtraField.length, 2) + // content
        unicodeCommentExtraField;
    }
    var header = "";
    // version needed to extract
    header += "\n\0";
    // general purpose bit flag
    header += $ae91d1555267d922$var$decToHex(bitflag, 2);
    // compression method
    header += compression.magic;
    // last mod file time
    header += $ae91d1555267d922$var$decToHex(dosTime, 2);
    // last mod file date
    header += $ae91d1555267d922$var$decToHex(dosDate, 2);
    // crc-32
    header += $ae91d1555267d922$var$decToHex(dataInfo.crc32, 4);
    // compressed size
    header += $ae91d1555267d922$var$decToHex(dataInfo.compressedSize, 4);
    // uncompressed size
    header += $ae91d1555267d922$var$decToHex(dataInfo.uncompressedSize, 4);
    // file name length
    header += $ae91d1555267d922$var$decToHex(encodedFileName.length, 2);
    // extra field length
    header += $ae91d1555267d922$var$decToHex(extraFields.length, 2);
    var fileRecord = $ae91d1555267d922$var$signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;
    var dirRecord = $ae91d1555267d922$var$signature.CENTRAL_FILE_HEADER + // version made by (00: DOS)
    $ae91d1555267d922$var$decToHex(versionMadeBy, 2) + // file header (common to file and central directory)
    header + // file comment length
    $ae91d1555267d922$var$decToHex(encodedComment.length, 2) + // disk number start
    "\0\0" + // internal file attributes TODO
    "\0\0" + // external file attributes
    $ae91d1555267d922$var$decToHex(extFileAttr, 4) + // relative offset of local header
    $ae91d1555267d922$var$decToHex(offset, 4) + // file name
    encodedFileName + // extra field
    extraFields + // file comment
    encodedComment;
    return {
        fileRecord: fileRecord,
        dirRecord: dirRecord
    };
};
/**
 * Generate the EOCD record.
 * @param {Number} entriesCount the number of entries in the zip file.
 * @param {Number} centralDirLength the length (in bytes) of the central dir.
 * @param {Number} localDirLength the length (in bytes) of the local dir.
 * @param {String} comment the zip file comment as a binary string.
 * @param {Function} encodeFileName the function to encode the comment.
 * @return {String} the EOCD record.
 */ var $ae91d1555267d922$var$generateCentralDirectoryEnd = function(entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
    var dirEnd = "";
    var encodedComment = $ae91d1555267d922$var$utils$b.transformTo("string", encodeFileName(comment));
    // end of central dir signature
    dirEnd = $ae91d1555267d922$var$signature.CENTRAL_DIRECTORY_END + // number of this disk
    "\0\0" + // number of the disk with the start of the central directory
    "\0\0" + // total number of entries in the central directory on this disk
    $ae91d1555267d922$var$decToHex(entriesCount, 2) + // total number of entries in the central directory
    $ae91d1555267d922$var$decToHex(entriesCount, 2) + // size of the central directory   4 bytes
    $ae91d1555267d922$var$decToHex(centralDirLength, 4) + // offset of start of central directory with respect to the starting disk number
    $ae91d1555267d922$var$decToHex(localDirLength, 4) + // .ZIP file comment length
    $ae91d1555267d922$var$decToHex(encodedComment.length, 2) + // .ZIP file comment
    encodedComment;
    return dirEnd;
};
/**
 * Generate data descriptors for a file entry.
 * @param {Object} streamInfo the hash generated by a worker, containing information
 * on the file entry.
 * @return {String} the data descriptors.
 */ var $ae91d1555267d922$var$generateDataDescriptors = function(streamInfo) {
    var descriptor = "";
    descriptor = $ae91d1555267d922$var$signature.DATA_DESCRIPTOR + // crc-32                          4 bytes
    $ae91d1555267d922$var$decToHex(streamInfo["crc32"], 4) + // compressed size                 4 bytes
    $ae91d1555267d922$var$decToHex(streamInfo["compressedSize"], 4) + // uncompressed size               4 bytes
    $ae91d1555267d922$var$decToHex(streamInfo["uncompressedSize"], 4);
    return descriptor;
};
/**
 * A worker to concatenate other workers to create a zip file.
 * @param {Boolean} streamFiles `true` to stream the content of the files,
 * `false` to accumulate it.
 * @param {String} comment the comment to use.
 * @param {String} platform the platform to use, "UNIX" or "DOS".
 * @param {Function} encodeFileName the function to encode file names and comments.
 */ function $ae91d1555267d922$var$ZipFileWorker$1(streamFiles, comment, platform, encodeFileName) {
    $ae91d1555267d922$var$GenericWorker$2.call(this, "ZipFileWorker");
    // The number of bytes written so far. This doesn't count accumulated chunks.
    this.bytesWritten = 0;
    // The comment of the zip file
    this.zipComment = comment;
    // The platform "generating" the zip file.
    this.zipPlatform = platform;
    // the function to encode file names and comments.
    this.encodeFileName = encodeFileName;
    // Should we stream the content of the files ?
    this.streamFiles = streamFiles;
    // If `streamFiles` is false, we will need to accumulate the content of the
    // files to calculate sizes / crc32 (and write them *before* the content).
    // This boolean indicates if we are accumulating chunks (it will change a lot
    // during the lifetime of this worker).
    this.accumulate = false;
    // The buffer receiving chunks when accumulating content.
    this.contentBuffer = [];
    // The list of generated directory records.
    this.dirRecords = [];
    // The offset (in bytes) from the beginning of the zip file for the current source.
    this.currentSourceOffset = 0;
    // The total number of entries in this zip file.
    this.entriesCount = 0;
    // the name of the file currently being added, null when handling the end of the zip file.
    // Used for the emitted metadata.
    this.currentFile = null;
    this._sources = [];
}
$ae91d1555267d922$var$utils$b.inherits($ae91d1555267d922$var$ZipFileWorker$1, $ae91d1555267d922$var$GenericWorker$2);
/**
 * @see GenericWorker.push
 */ $ae91d1555267d922$var$ZipFileWorker$1.prototype.push = function(chunk) {
    var currentFilePercent = chunk.meta.percent || 0;
    var entriesCount = this.entriesCount;
    var remainingFiles = this._sources.length;
    if (this.accumulate) this.contentBuffer.push(chunk);
    else {
        this.bytesWritten += chunk.data.length;
        $ae91d1555267d922$var$GenericWorker$2.prototype.push.call(this, {
            data: chunk.data,
            meta: {
                currentFile: this.currentFile,
                percent: entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
            }
        });
    }
};
/**
 * The worker started a new source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the new source.
 */ $ae91d1555267d922$var$ZipFileWorker$1.prototype.openedSource = function(streamInfo) {
    this.currentSourceOffset = this.bytesWritten;
    this.currentFile = streamInfo["file"].name;
    var streamedContent = this.streamFiles && !streamInfo["file"].dir;
    // don't stream folders (because they don't have any content)
    if (streamedContent) {
        var record = $ae91d1555267d922$var$generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        this.push({
            data: record.fileRecord,
            meta: {
                percent: 0
            }
        });
    } else // we need to wait for the whole file before pushing anything
    this.accumulate = true;
};
/**
 * The worker finished a source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the finished source.
 */ $ae91d1555267d922$var$ZipFileWorker$1.prototype.closedSource = function(streamInfo) {
    this.accumulate = false;
    var streamedContent = this.streamFiles && !streamInfo["file"].dir;
    var record = $ae91d1555267d922$var$generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
    this.dirRecords.push(record.dirRecord);
    if (streamedContent) // after the streamed file, we put data descriptors
    this.push({
        data: $ae91d1555267d922$var$generateDataDescriptors(streamInfo),
        meta: {
            percent: 100
        }
    });
    else {
        // the content wasn't streamed, we need to push everything now
        // first the file record, then the content
        this.push({
            data: record.fileRecord,
            meta: {
                percent: 0
            }
        });
        while(this.contentBuffer.length)this.push(this.contentBuffer.shift());
    }
    this.currentFile = null;
};
/**
 * @see GenericWorker.flush
 */ $ae91d1555267d922$var$ZipFileWorker$1.prototype.flush = function() {
    var localDirLength = this.bytesWritten;
    for(var i = 0; i < this.dirRecords.length; i++)this.push({
        data: this.dirRecords[i],
        meta: {
            percent: 100
        }
    });
    var centralDirLength = this.bytesWritten - localDirLength;
    var dirEnd = $ae91d1555267d922$var$generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);
    this.push({
        data: dirEnd,
        meta: {
            percent: 100
        }
    });
};
/**
 * Prepare the next source to be read.
 */ $ae91d1555267d922$var$ZipFileWorker$1.prototype.prepareNextSource = function() {
    this.previous = this._sources.shift();
    this.openedSource(this.previous.streamInfo);
    if (this.isPaused) this.previous.pause();
    else this.previous.resume();
};
/**
 * @see GenericWorker.registerPrevious
 */ $ae91d1555267d922$var$ZipFileWorker$1.prototype.registerPrevious = function(previous) {
    this._sources.push(previous);
    var self1 = this;
    previous.on("data", function(chunk) {
        self1.processChunk(chunk);
    });
    previous.on("end", function() {
        self1.closedSource(self1.previous.streamInfo);
        if (self1._sources.length) self1.prepareNextSource();
        else self1.end();
    });
    previous.on("error", function(e) {
        self1.error(e);
    });
    return this;
};
/**
 * @see GenericWorker.resume
 */ $ae91d1555267d922$var$ZipFileWorker$1.prototype.resume = function() {
    if (!$ae91d1555267d922$var$GenericWorker$2.prototype.resume.call(this)) return false;
    if (!this.previous && this._sources.length) {
        this.prepareNextSource();
        return true;
    }
    if (!this.previous && !this._sources.length && !this.generatedError) {
        this.end();
        return true;
    }
};
/**
 * @see GenericWorker.error
 */ $ae91d1555267d922$var$ZipFileWorker$1.prototype.error = function(e) {
    var sources = this._sources;
    if (!$ae91d1555267d922$var$GenericWorker$2.prototype.error.call(this, e)) return false;
    for(var i = 0; i < sources.length; i++)try {
        sources[i].error(e);
    } catch (e) {
    // the `error` exploded, nothing to do
    }
    return true;
};
/**
 * @see GenericWorker.lock
 */ $ae91d1555267d922$var$ZipFileWorker$1.prototype.lock = function() {
    $ae91d1555267d922$var$GenericWorker$2.prototype.lock.call(this);
    var sources = this._sources;
    for(var i = 0; i < sources.length; i++)sources[i].lock();
};
var $ae91d1555267d922$var$ZipFileWorker_1 = $ae91d1555267d922$var$ZipFileWorker$1;
var $ae91d1555267d922$var$compressions$1 = $ae91d1555267d922$var$compressions$2;
var $ae91d1555267d922$var$ZipFileWorker = $ae91d1555267d922$var$ZipFileWorker_1;
/**
 * Find the compression to use.
 * @param {String} fileCompression the compression defined at the file level, if any.
 * @param {String} zipCompression the compression defined at the load() level.
 * @return {Object} the compression object to use.
 */ var $ae91d1555267d922$var$getCompression = function(fileCompression, zipCompression) {
    var compressionName = fileCompression || zipCompression;
    var compression = $ae91d1555267d922$var$compressions$1[compressionName];
    if (!compression) throw new Error(compressionName + " is not a valid compression method !");
    return compression;
};
/**
 * Create a worker to generate a zip file.
 * @param {JSZip} zip the JSZip instance at the right root level.
 * @param {Object} options to generate the zip file.
 * @param {String} comment the comment to use.
 */ $ae91d1555267d922$var$generate$1.generateWorker = function(zip, options, comment) {
    var zipFileWorker = new $ae91d1555267d922$var$ZipFileWorker(options.streamFiles, comment, options.platform, options.encodeFileName);
    var entriesCount = 0;
    try {
        zip.forEach(function(relativePath, file) {
            entriesCount++;
            var compression = $ae91d1555267d922$var$getCompression(file.options.compression, options.compression);
            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
            var dir = file.dir, date = file.date;
            file._compressWorker(compression, compressionOptions).withStreamInfo("file", {
                name: relativePath,
                dir: dir,
                date: date,
                comment: file.comment || "",
                unixPermissions: file.unixPermissions,
                dosPermissions: file.dosPermissions
            }).pipe(zipFileWorker);
        });
        zipFileWorker.entriesCount = entriesCount;
    } catch (e) {
        zipFileWorker.error(e);
    }
    return zipFileWorker;
};
var $ae91d1555267d922$var$utils$a = $ae91d1555267d922$var$utils$r;
var $ae91d1555267d922$var$GenericWorker$1 = $ae91d1555267d922$var$GenericWorker_1;
/**
 * A worker that use a nodejs stream as source.
 * @constructor
 * @param {String} filename the name of the file entry for this stream.
 * @param {Readable} stream the nodejs stream.
 */ function $ae91d1555267d922$var$NodejsStreamInputAdapter$1(filename, stream) {
    $ae91d1555267d922$var$GenericWorker$1.call(this, "Nodejs stream input adapter for " + filename);
    this._upstreamEnded = false;
    this._bindStream(stream);
}
$ae91d1555267d922$var$utils$a.inherits($ae91d1555267d922$var$NodejsStreamInputAdapter$1, $ae91d1555267d922$var$GenericWorker$1);
/**
 * Prepare the stream and bind the callbacks on it.
 * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
 * @param {Stream} stream the nodejs stream to use.
 */ $ae91d1555267d922$var$NodejsStreamInputAdapter$1.prototype._bindStream = function(stream) {
    var self1 = this;
    this._stream = stream;
    stream.pause();
    stream.on("data", function(chunk) {
        self1.push({
            data: chunk,
            meta: {
                percent: 0
            }
        });
    }).on("error", function(e) {
        if (self1.isPaused) this.generatedError = e;
        else self1.error(e);
    }).on("end", function() {
        if (self1.isPaused) self1._upstreamEnded = true;
        else self1.end();
    });
};
$ae91d1555267d922$var$NodejsStreamInputAdapter$1.prototype.pause = function() {
    if (!$ae91d1555267d922$var$GenericWorker$1.prototype.pause.call(this)) return false;
    this._stream.pause();
    return true;
};
$ae91d1555267d922$var$NodejsStreamInputAdapter$1.prototype.resume = function() {
    if (!$ae91d1555267d922$var$GenericWorker$1.prototype.resume.call(this)) return false;
    if (this._upstreamEnded) this.end();
    else this._stream.resume();
    return true;
};
var $ae91d1555267d922$var$NodejsStreamInputAdapter_1 = $ae91d1555267d922$var$NodejsStreamInputAdapter$1;
var $ae91d1555267d922$var$utf8$2 = $ae91d1555267d922$var$utf8$5;
var $ae91d1555267d922$var$utils$9 = $ae91d1555267d922$var$utils$r;
var $ae91d1555267d922$var$GenericWorker = $ae91d1555267d922$var$GenericWorker_1;
var $ae91d1555267d922$var$StreamHelper = $ae91d1555267d922$var$StreamHelper_1;
var $ae91d1555267d922$var$defaults = $ae91d1555267d922$var$defaults$1;
var $ae91d1555267d922$var$CompressedObject$1 = $ae91d1555267d922$var$compressedObject;
var $ae91d1555267d922$var$ZipObject = $ae91d1555267d922$var$zipObject;
var $ae91d1555267d922$var$generate = $ae91d1555267d922$var$generate$1;
var $ae91d1555267d922$var$nodejsUtils$1 = $ae91d1555267d922$var$nodejsUtils$2;
var $ae91d1555267d922$var$NodejsStreamInputAdapter = $ae91d1555267d922$var$NodejsStreamInputAdapter_1;
/**
 * Add a file in the current folder.
 * @private
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
 * @param {Object} originalOptions the options of the file
 * @return {Object} the new file.
 */ var $ae91d1555267d922$var$fileAdd = function(name, data, originalOptions) {
    // be sure sub folders exist
    var dataType = $ae91d1555267d922$var$utils$9.getTypeOf(data), parent;
    /*
     * Correct options.
     */ var o = $ae91d1555267d922$var$utils$9.extend(originalOptions || {}, $ae91d1555267d922$var$defaults);
    o.date = o.date || new Date();
    if (o.compression !== null) o.compression = o.compression.toUpperCase();
    if (typeof o.unixPermissions === "string") o.unixPermissions = parseInt(o.unixPermissions, 8);
    // UNX_IFDIR  0040000 see zipinfo.c
    if (o.unixPermissions && o.unixPermissions & 0x4000) o.dir = true;
    // Bit 4    Directory
    if (o.dosPermissions && o.dosPermissions & 0x0010) o.dir = true;
    if (o.dir) name = $ae91d1555267d922$var$forceTrailingSlash(name);
    if (o.createFolders && (parent = $ae91d1555267d922$var$parentFolder(name))) $ae91d1555267d922$var$folderAdd.call(this, parent, true);
    var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
    if (!originalOptions || typeof originalOptions.binary === "undefined") o.binary = !isUnicodeString;
    var isCompressedEmpty = data instanceof $ae91d1555267d922$var$CompressedObject$1 && data.uncompressedSize === 0;
    if (isCompressedEmpty || o.dir || !data || data.length === 0) {
        o.base64 = false;
        o.binary = true;
        data = "";
        o.compression = "STORE";
        dataType = "string";
    }
    /*
     * Convert content to fit.
     */ var zipObjectContent = null;
    if (data instanceof $ae91d1555267d922$var$CompressedObject$1 || data instanceof $ae91d1555267d922$var$GenericWorker) zipObjectContent = data;
    else if ($ae91d1555267d922$var$nodejsUtils$1.isNode && $ae91d1555267d922$var$nodejsUtils$1.isStream(data)) zipObjectContent = new $ae91d1555267d922$var$NodejsStreamInputAdapter(name, data);
    else zipObjectContent = $ae91d1555267d922$var$utils$9.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
    var object = new $ae91d1555267d922$var$ZipObject(name, zipObjectContent, o);
    this.files[name] = object;
/*
    TODO: we can't throw an exception because we have async promises
    (we can have a promise of a Date() for example) but returning a
    promise is useless because file(name, data) returns the JSZip
    object for chaining. Should we break that to allow the user
    to catch the error ?

    return external.Promise.resolve(zipObjectContent)
    .then(function () {
        return object;
    });
    */ };
/**
 * Find the parent folder of the path.
 * @private
 * @param {string} path the path to use
 * @return {string} the parent folder, or ""
 */ var $ae91d1555267d922$var$parentFolder = function(path) {
    if (path.slice(-1) === "/") path = path.substring(0, path.length - 1);
    var lastSlash = path.lastIndexOf("/");
    return lastSlash > 0 ? path.substring(0, lastSlash) : "";
};
/**
 * Returns the path with a slash at the end.
 * @private
 * @param {String} path the path to check.
 * @return {String} the path with a trailing slash.
 */ var $ae91d1555267d922$var$forceTrailingSlash = function(path) {
    // Check the name ends with a /
    if (path.slice(-1) !== "/") path += "/"; // IE doesn't like substr(-1)
    return path;
};
/**
 * Add a (sub) folder in the current folder.
 * @private
 * @param {string} name the folder's name
 * @param {boolean=} [createFolders] If true, automatically create sub
 *  folders. Defaults to false.
 * @return {Object} the new folder.
 */ var $ae91d1555267d922$var$folderAdd = function(name, createFolders) {
    createFolders = typeof createFolders !== "undefined" ? createFolders : $ae91d1555267d922$var$defaults.createFolders;
    name = $ae91d1555267d922$var$forceTrailingSlash(name);
    // Does this folder already exist?
    if (!this.files[name]) $ae91d1555267d922$var$fileAdd.call(this, name, null, {
        dir: true,
        createFolders: createFolders
    });
    return this.files[name];
};
/**
* Cross-window, cross-Node-context regular expression detection
* @param  {Object}  object Anything
* @return {Boolean}        true if the object is a regular expression,
* false otherwise
*/ function $ae91d1555267d922$var$isRegExp(object) {
    return Object.prototype.toString.call(object) === "[object RegExp]";
}
// return the actual prototype of JSZip
var $ae91d1555267d922$var$out = {
    /**
     * @see loadAsync
     */ load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },
    /**
     * Call a callback function for each entry at this folder level.
     * @param {Function} cb the callback function:
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     */ forEach: function(cb) {
        var filename, relativePath, file;
        for(filename in this.files){
            if (!this.files.hasOwnProperty(filename)) continue;
            file = this.files[filename];
            relativePath = filename.slice(this.root.length, filename.length);
            if (relativePath && filename.slice(0, this.root.length) === this.root) cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
        }
    },
    /**
     * Filter nested files/folders with the specified function.
     * @param {Function} search the predicate to use :
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     * @return {Array} An array of matching elements.
     */ filter: function(search) {
        var result = [];
        this.forEach(function(relativePath, entry) {
            if (search(relativePath, entry)) result.push(entry);
        });
        return result;
    },
    /**
     * Add a file to the zip file, or search a file.
     * @param   {string|RegExp} name The name of the file to add (if data is defined),
     * the name of the file to find (if no data) or a regex to match files.
     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
     * @param   {Object} o     File options
     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
     * a file (when searching by string) or an array of files (when searching by regex).
     */ file: function(name, data, o) {
        if (arguments.length === 1) {
            if ($ae91d1555267d922$var$isRegExp(name)) {
                var regexp = name;
                return this.filter(function(relativePath, file) {
                    return !file.dir && regexp.test(relativePath);
                });
            } else {
                var obj = this.files[this.root + name];
                if (obj && !obj.dir) return obj;
                else return null;
            }
        } else {
            name = this.root + name;
            $ae91d1555267d922$var$fileAdd.call(this, name, data, o);
        }
        return this;
    },
    /**
     * Add a directory to the zip file, or search.
     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
     */ folder: function(arg) {
        if (!arg) return this;
        if ($ae91d1555267d922$var$isRegExp(arg)) return this.filter(function(relativePath, file) {
            return file.dir && arg.test(relativePath);
        });
        // else, name is a new folder
        var name = this.root + arg;
        var newFolder = $ae91d1555267d922$var$folderAdd.call(this, name);
        // Allow chaining by returning a new object with this folder as the root
        var ret = this.clone();
        ret.root = newFolder.name;
        return ret;
    },
    /**
     * Delete a file, or a directory and all sub-files, from the zip
     * @param {string} name the name of the file to delete
     * @return {JSZip} this JSZip object
     */ remove: function(name) {
        name = this.root + name;
        var file = this.files[name];
        if (!file) {
            // Look for any folders
            if (name.slice(-1) !== "/") name += "/";
            file = this.files[name];
        }
        if (file && !file.dir) // file
        delete this.files[name];
        else {
            // maybe a folder, delete recursively
            var kids = this.filter(function(relativePath, file) {
                return file.name.slice(0, name.length) === name;
            });
            for(var i = 0; i < kids.length; i++)delete this.files[kids[i].name];
        }
        return this;
    },
    /**
     * Generate the complete zip file
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
     */ generate: function(options) {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },
    /**
     * Generate the complete zip file as an internal stream.
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {StreamHelper} the streamed zip file.
     */ generateInternalStream: function(options) {
        var worker, opts = {};
        try {
            opts = $ae91d1555267d922$var$utils$9.extend(options || {}, {
                streamFiles: false,
                compression: "STORE",
                compressionOptions: null,
                type: "",
                platform: "DOS",
                comment: null,
                mimeType: "application/zip",
                encodeFileName: $ae91d1555267d922$var$utf8$2.utf8encode
            });
            opts.type = opts.type.toLowerCase();
            opts.compression = opts.compression.toUpperCase();
            // "binarystring" is preferred but the internals use "string".
            if (opts.type === "binarystring") opts.type = "string";
            if (!opts.type) throw new Error("No output type specified.");
            $ae91d1555267d922$var$utils$9.checkSupport(opts.type);
            // accept nodejs `process.platform`
            if (opts.platform === "darwin" || opts.platform === "freebsd" || opts.platform === "linux" || opts.platform === "sunos") opts.platform = "UNIX";
            if (opts.platform === "win32") opts.platform = "DOS";
            var comment = opts.comment || this.comment || "";
            worker = $ae91d1555267d922$var$generate.generateWorker(this, opts, comment);
        } catch (e) {
            worker = new $ae91d1555267d922$var$GenericWorker("error");
            worker.error(e);
        }
        return new $ae91d1555267d922$var$StreamHelper(worker, opts.type || "string", opts.mimeType);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */ generateAsync: function(options, onUpdate) {
        return this.generateInternalStream(options).accumulate(onUpdate);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */ generateNodeStream: function(options, onUpdate) {
        options = options || {};
        if (!options.type) options.type = "nodebuffer";
        return this.generateInternalStream(options).toNodejsStream(onUpdate);
    }
};
var $ae91d1555267d922$var$object = $ae91d1555267d922$var$out;
var $ae91d1555267d922$var$utils$8 = $ae91d1555267d922$var$utils$r;
function $ae91d1555267d922$var$DataReader$2(data) {
    this.data = data; // type : see implementation
    this.length = data.length;
    this.index = 0;
    this.zero = 0;
}
$ae91d1555267d922$var$DataReader$2.prototype = {
    /**
     * Check that the offset will not go too far.
     * @param {string} offset the additional offset to check.
     * @throws {Error} an Error if the offset is out of bounds.
     */ checkOffset: function(offset) {
        this.checkIndex(this.index + offset);
    },
    /**
     * Check that the specified index will not be too far.
     * @param {string} newIndex the index to check.
     * @throws {Error} an Error if the index is out of bounds.
     */ checkIndex: function(newIndex) {
        if (this.length < this.zero + newIndex || newIndex < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + newIndex + "). Corrupted zip ?");
    },
    /**
     * Change the index.
     * @param {number} newIndex The new index.
     * @throws {Error} if the new index is out of the data.
     */ setIndex: function(newIndex) {
        this.checkIndex(newIndex);
        this.index = newIndex;
    },
    /**
     * Skip the next n bytes.
     * @param {number} n the number of bytes to skip.
     * @throws {Error} if the new index is out of the data.
     */ skip: function(n) {
        this.setIndex(this.index + n);
    },
    /**
     * Get the byte at the specified index.
     * @param {number} i the index to use.
     * @return {number} a byte.
     */ byteAt: function(i) {
    // see implementations
    },
    /**
     * Get the next number with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {number} the corresponding number.
     */ readInt: function(size) {
        var result = 0, i;
        this.checkOffset(size);
        for(i = this.index + size - 1; i >= this.index; i--)result = (result << 8) + this.byteAt(i);
        this.index += size;
        return result;
    },
    /**
     * Get the next string with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {string} the corresponding string.
     */ readString: function(size) {
        return $ae91d1555267d922$var$utils$8.transformTo("string", this.readData(size));
    },
    /**
     * Get raw data without conversion, <size> bytes.
     * @param {number} size the number of bytes to read.
     * @return {Object} the raw data, implementation specific.
     */ readData: function(size) {
    // see implementations
    },
    /**
     * Find the last occurrence of a zip signature (4 bytes).
     * @param {string} sig the signature to find.
     * @return {number} the index of the last occurrence, -1 if not found.
     */ lastIndexOfSignature: function(sig) {
    // see implementations
    },
    /**
     * Read the signature (4 bytes) at the current position and compare it with sig.
     * @param {string} sig the expected signature
     * @return {boolean} true if the signature matches, false otherwise.
     */ readAndCheckSignature: function(sig) {
    // see implementations
    },
    /**
     * Get the next date.
     * @return {Date} the date.
     */ readDate: function() {
        var dostime = this.readInt(4);
        return new Date(Date.UTC((dostime >> 25 & 0x7f) + 1980, (dostime >> 21 & 0x0f) - 1, dostime >> 16 & 0x1f, dostime >> 11 & 0x1f, dostime >> 5 & 0x3f, (dostime & 0x1f) << 1)); // second
    }
};
var $ae91d1555267d922$var$DataReader_1 = $ae91d1555267d922$var$DataReader$2;
var $ae91d1555267d922$var$DataReader$1 = $ae91d1555267d922$var$DataReader_1;
var $ae91d1555267d922$var$utils$7 = $ae91d1555267d922$var$utils$r;
function $ae91d1555267d922$var$ArrayReader$2(data) {
    $ae91d1555267d922$var$DataReader$1.call(this, data);
    for(var i = 0; i < this.data.length; i++)data[i] = data[i] & 0xFF;
}
$ae91d1555267d922$var$utils$7.inherits($ae91d1555267d922$var$ArrayReader$2, $ae91d1555267d922$var$DataReader$1);
/**
 * @see DataReader.byteAt
 */ $ae91d1555267d922$var$ArrayReader$2.prototype.byteAt = function(i) {
    return this.data[this.zero + i];
};
/**
 * @see DataReader.lastIndexOfSignature
 */ $ae91d1555267d922$var$ArrayReader$2.prototype.lastIndexOfSignature = function(sig) {
    var sig0 = sig.charCodeAt(0), sig1 = sig.charCodeAt(1), sig2 = sig.charCodeAt(2), sig3 = sig.charCodeAt(3);
    for(var i = this.length - 4; i >= 0; --i){
        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) return i - this.zero;
    }
    return -1;
};
/**
 * @see DataReader.readAndCheckSignature
 */ $ae91d1555267d922$var$ArrayReader$2.prototype.readAndCheckSignature = function(sig) {
    var sig0 = sig.charCodeAt(0), sig1 = sig.charCodeAt(1), sig2 = sig.charCodeAt(2), sig3 = sig.charCodeAt(3), data = this.readData(4);
    return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
};
/**
 * @see DataReader.readData
 */ $ae91d1555267d922$var$ArrayReader$2.prototype.readData = function(size) {
    this.checkOffset(size);
    if (size === 0) return [];
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
var $ae91d1555267d922$var$ArrayReader_1 = $ae91d1555267d922$var$ArrayReader$2;
var $ae91d1555267d922$var$DataReader = $ae91d1555267d922$var$DataReader_1;
var $ae91d1555267d922$var$utils$6 = $ae91d1555267d922$var$utils$r;
function $ae91d1555267d922$var$StringReader$1(data) {
    $ae91d1555267d922$var$DataReader.call(this, data);
}
$ae91d1555267d922$var$utils$6.inherits($ae91d1555267d922$var$StringReader$1, $ae91d1555267d922$var$DataReader);
/**
 * @see DataReader.byteAt
 */ $ae91d1555267d922$var$StringReader$1.prototype.byteAt = function(i) {
    return this.data.charCodeAt(this.zero + i);
};
/**
 * @see DataReader.lastIndexOfSignature
 */ $ae91d1555267d922$var$StringReader$1.prototype.lastIndexOfSignature = function(sig) {
    return this.data.lastIndexOf(sig) - this.zero;
};
/**
 * @see DataReader.readAndCheckSignature
 */ $ae91d1555267d922$var$StringReader$1.prototype.readAndCheckSignature = function(sig) {
    var data = this.readData(4);
    return sig === data;
};
/**
 * @see DataReader.readData
 */ $ae91d1555267d922$var$StringReader$1.prototype.readData = function(size) {
    this.checkOffset(size);
    // this will work because the constructor applied the "& 0xff" mask.
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
var $ae91d1555267d922$var$StringReader_1 = $ae91d1555267d922$var$StringReader$1;
var $ae91d1555267d922$var$ArrayReader$1 = $ae91d1555267d922$var$ArrayReader_1;
var $ae91d1555267d922$var$utils$5 = $ae91d1555267d922$var$utils$r;
function $ae91d1555267d922$var$Uint8ArrayReader$2(data) {
    $ae91d1555267d922$var$ArrayReader$1.call(this, data);
}
$ae91d1555267d922$var$utils$5.inherits($ae91d1555267d922$var$Uint8ArrayReader$2, $ae91d1555267d922$var$ArrayReader$1);
/**
 * @see DataReader.readData
 */ $ae91d1555267d922$var$Uint8ArrayReader$2.prototype.readData = function(size) {
    this.checkOffset(size);
    if (size === 0) // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
    return new Uint8Array(0);
    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
var $ae91d1555267d922$var$Uint8ArrayReader_1 = $ae91d1555267d922$var$Uint8ArrayReader$2;
var $ae91d1555267d922$var$Uint8ArrayReader$1 = $ae91d1555267d922$var$Uint8ArrayReader_1;
var $ae91d1555267d922$var$utils$4 = $ae91d1555267d922$var$utils$r;
function $ae91d1555267d922$var$NodeBufferReader$1(data) {
    $ae91d1555267d922$var$Uint8ArrayReader$1.call(this, data);
}
$ae91d1555267d922$var$utils$4.inherits($ae91d1555267d922$var$NodeBufferReader$1, $ae91d1555267d922$var$Uint8ArrayReader$1);
/**
 * @see DataReader.readData
 */ $ae91d1555267d922$var$NodeBufferReader$1.prototype.readData = function(size) {
    this.checkOffset(size);
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
var $ae91d1555267d922$var$NodeBufferReader_1 = $ae91d1555267d922$var$NodeBufferReader$1;
var $ae91d1555267d922$var$utils$3 = $ae91d1555267d922$var$utils$r;
var $ae91d1555267d922$var$support$2 = $ae91d1555267d922$var$support$5;
var $ae91d1555267d922$var$ArrayReader = $ae91d1555267d922$var$ArrayReader_1;
var $ae91d1555267d922$var$StringReader = $ae91d1555267d922$var$StringReader_1;
var $ae91d1555267d922$var$NodeBufferReader = $ae91d1555267d922$var$NodeBufferReader_1;
var $ae91d1555267d922$var$Uint8ArrayReader = $ae91d1555267d922$var$Uint8ArrayReader_1;
/**
 * Create a reader adapted to the data.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
 * @return {DataReader} the data reader.
 */ var $ae91d1555267d922$var$readerFor$2 = function(data) {
    var type = $ae91d1555267d922$var$utils$3.getTypeOf(data);
    $ae91d1555267d922$var$utils$3.checkSupport(type);
    if (type === "string" && !$ae91d1555267d922$var$support$2.uint8array) return new $ae91d1555267d922$var$StringReader(data);
    if (type === "nodebuffer") return new $ae91d1555267d922$var$NodeBufferReader(data);
    if ($ae91d1555267d922$var$support$2.uint8array) return new $ae91d1555267d922$var$Uint8ArrayReader($ae91d1555267d922$var$utils$3.transformTo("uint8array", data));
    return new $ae91d1555267d922$var$ArrayReader($ae91d1555267d922$var$utils$3.transformTo("array", data));
};
var $ae91d1555267d922$var$readerFor$1 = $ae91d1555267d922$var$readerFor$2;
var $ae91d1555267d922$var$utils$2 = $ae91d1555267d922$var$utils$r;
var $ae91d1555267d922$var$CompressedObject = $ae91d1555267d922$var$compressedObject;
var $ae91d1555267d922$var$crc32fn = $ae91d1555267d922$var$crc32_1$1;
var $ae91d1555267d922$var$utf8$1 = $ae91d1555267d922$var$utf8$5;
var $ae91d1555267d922$var$compressions = $ae91d1555267d922$var$compressions$2;
var $ae91d1555267d922$var$support$1 = $ae91d1555267d922$var$support$5;
var $ae91d1555267d922$var$MADE_BY_DOS = 0x00;
var $ae91d1555267d922$var$MADE_BY_UNIX = 0x03;
/**
 * Find a compression registered in JSZip.
 * @param {string} compressionMethod the method magic to find.
 * @return {Object|null} the JSZip compression object, null if none found.
 */ var $ae91d1555267d922$var$findCompression = function(compressionMethod) {
    for(var method in $ae91d1555267d922$var$compressions){
        if (!$ae91d1555267d922$var$compressions.hasOwnProperty(method)) continue;
        if ($ae91d1555267d922$var$compressions[method].magic === compressionMethod) return $ae91d1555267d922$var$compressions[method];
    }
    return null;
};
// class ZipEntry {{{
/**
 * An entry in the zip file.
 * @constructor
 * @param {Object} options Options of the current file.
 * @param {Object} loadOptions Options for loading the stream.
 */ function $ae91d1555267d922$var$ZipEntry$1(options, loadOptions) {
    this.options = options;
    this.loadOptions = loadOptions;
}
$ae91d1555267d922$var$ZipEntry$1.prototype = {
    /**
     * say if the file is encrypted.
     * @return {boolean} true if the file is encrypted, false otherwise.
     */ isEncrypted: function() {
        // bit 1 is set
        return (this.bitFlag & 0x0001) === 0x0001;
    },
    /**
     * say if the file has utf-8 filename/comment.
     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
     */ useUTF8: function() {
        // bit 11 is set
        return (this.bitFlag & 0x0800) === 0x0800;
    },
    /**
     * Read the local part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */ readLocalPart: function(reader) {
        var compression, localExtraFieldsLength;
        // we already know everything from the central dir !
        // If the central dir data are false, we are doomed.
        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
        // The less data we get here, the more reliable this should be.
        // Let's skip the whole header and dash to the data !
        reader.skip(22);
        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
        // Strangely, the filename here is OK.
        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
        // the internet.
        //
        // I think I see the logic here : the central directory is used to display
        // content and the local directory is used to extract the files. Mixing / and \
        // may be used to display \ to windows users and use / when extracting the files.
        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
        this.fileNameLength = reader.readInt(2);
        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
        // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
        this.fileName = reader.readData(this.fileNameLength);
        reader.skip(localExtraFieldsLength);
        if (this.compressedSize === -1 || this.uncompressedSize === -1) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
        compression = $ae91d1555267d922$var$findCompression(this.compressionMethod);
        if (compression === null) throw new Error("Corrupted zip : compression " + $ae91d1555267d922$var$utils$2.pretty(this.compressionMethod) + " unknown (inner file : " + $ae91d1555267d922$var$utils$2.transformTo("string", this.fileName) + ")");
        this.decompressed = new $ae91d1555267d922$var$CompressedObject(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */ readCentralPart: function(reader) {
        this.versionMadeBy = reader.readInt(2);
        reader.skip(2);
        // this.versionNeeded = reader.readInt(2);
        this.bitFlag = reader.readInt(2);
        this.compressionMethod = reader.readString(2);
        this.date = reader.readDate();
        this.crc32 = reader.readInt(4);
        this.compressedSize = reader.readInt(4);
        this.uncompressedSize = reader.readInt(4);
        var fileNameLength = reader.readInt(2);
        this.extraFieldsLength = reader.readInt(2);
        this.fileCommentLength = reader.readInt(2);
        this.diskNumberStart = reader.readInt(2);
        this.internalFileAttributes = reader.readInt(2);
        this.externalFileAttributes = reader.readInt(4);
        this.localHeaderOffset = reader.readInt(4);
        if (this.isEncrypted()) throw new Error("Encrypted zip are not supported");
        // will be read in the local part, see the comments there
        reader.skip(fileNameLength);
        this.readExtraFields(reader);
        this.parseZIP64ExtraField(reader);
        this.fileComment = reader.readData(this.fileCommentLength);
    },
    /**
     * Parse the external file attributes and get the unix/dos permissions.
     */ processAttributes: function() {
        this.unixPermissions = null;
        this.dosPermissions = null;
        var madeBy = this.versionMadeBy >> 8;
        // Check if we have the DOS directory flag set.
        // We look for it in the DOS and UNIX permissions
        // but some unknown platform could set it as a compatibility flag.
        this.dir = this.externalFileAttributes & 0x0010 ? true : false;
        if (madeBy === $ae91d1555267d922$var$MADE_BY_DOS) // first 6 bits (0 to 5)
        this.dosPermissions = this.externalFileAttributes & 0x3F;
        if (madeBy === $ae91d1555267d922$var$MADE_BY_UNIX) this.unixPermissions = this.externalFileAttributes >> 16 & 0xFFFF;
        // fail safe : if the name ends with a / it probably means a folder
        if (!this.dir && this.fileNameStr.slice(-1) === "/") this.dir = true;
    },
    /**
     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
     * @param {DataReader} reader the reader to use.
     */ parseZIP64ExtraField: function(reader) {
        if (!this.extraFields[0x0001]) return;
        // should be something, preparing the extra reader
        var extraReader = $ae91d1555267d922$var$readerFor$1(this.extraFields[0x0001].value);
        // I really hope that these 64bits integer can fit in 32 bits integer, because js
        // won't let us have more.
        if (this.uncompressedSize === $ae91d1555267d922$var$utils$2.MAX_VALUE_32BITS) this.uncompressedSize = extraReader.readInt(8);
        if (this.compressedSize === $ae91d1555267d922$var$utils$2.MAX_VALUE_32BITS) this.compressedSize = extraReader.readInt(8);
        if (this.localHeaderOffset === $ae91d1555267d922$var$utils$2.MAX_VALUE_32BITS) this.localHeaderOffset = extraReader.readInt(8);
        if (this.diskNumberStart === $ae91d1555267d922$var$utils$2.MAX_VALUE_32BITS) this.diskNumberStart = extraReader.readInt(4);
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */ readExtraFields: function(reader) {
        var end = reader.index + this.extraFieldsLength, extraFieldId, extraFieldLength, extraFieldValue;
        if (!this.extraFields) this.extraFields = {};
        while(reader.index + 4 < end){
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readData(extraFieldLength);
            this.extraFields[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
        reader.setIndex(end);
    },
    /**
     * Apply an UTF8 transformation if needed.
     */ handleUTF8: function() {
        var decodeParamType = $ae91d1555267d922$var$support$1.uint8array ? "uint8array" : "array";
        if (this.useUTF8()) {
            this.fileNameStr = $ae91d1555267d922$var$utf8$1.utf8decode(this.fileName);
            this.fileCommentStr = $ae91d1555267d922$var$utf8$1.utf8decode(this.fileComment);
        } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) this.fileNameStr = upath;
            else {
                // ASCII text or unsupported code page
                var fileNameByteArray = $ae91d1555267d922$var$utils$2.transformTo(decodeParamType, this.fileName);
                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
            }
            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) this.fileCommentStr = ucomment;
            else {
                // ASCII text or unsupported code page
                var commentByteArray = $ae91d1555267d922$var$utils$2.transformTo(decodeParamType, this.fileComment);
                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
            }
        }
    },
    /**
     * Find the unicode path declared in the extra field, if any.
     * @return {String} the unicode path, null otherwise.
     */ findExtraFieldUnicodePath: function() {
        var upathField = this.extraFields[0x7075];
        if (upathField) {
            var extraReader = $ae91d1555267d922$var$readerFor$1(upathField.value);
            // wrong version
            if (extraReader.readInt(1) !== 1) return null;
            // the crc of the filename changed, this field is out of date.
            if ($ae91d1555267d922$var$crc32fn(this.fileName) !== extraReader.readInt(4)) return null;
            return $ae91d1555267d922$var$utf8$1.utf8decode(extraReader.readData(upathField.length - 5));
        }
        return null;
    },
    /**
     * Find the unicode comment declared in the extra field, if any.
     * @return {String} the unicode comment, null otherwise.
     */ findExtraFieldUnicodeComment: function() {
        var ucommentField = this.extraFields[0x6375];
        if (ucommentField) {
            var extraReader = $ae91d1555267d922$var$readerFor$1(ucommentField.value);
            // wrong version
            if (extraReader.readInt(1) !== 1) return null;
            // the crc of the comment changed, this field is out of date.
            if ($ae91d1555267d922$var$crc32fn(this.fileComment) !== extraReader.readInt(4)) return null;
            return $ae91d1555267d922$var$utf8$1.utf8decode(extraReader.readData(ucommentField.length - 5));
        }
        return null;
    }
};
var $ae91d1555267d922$var$zipEntry = $ae91d1555267d922$var$ZipEntry$1;
var $ae91d1555267d922$var$readerFor = $ae91d1555267d922$var$readerFor$2;
var $ae91d1555267d922$var$utils$1 = $ae91d1555267d922$var$utils$r;
var $ae91d1555267d922$var$sig = $ae91d1555267d922$var$signature$1;
var $ae91d1555267d922$var$ZipEntry = $ae91d1555267d922$var$zipEntry;
var $ae91d1555267d922$var$support = $ae91d1555267d922$var$support$5;
//  class ZipEntries {{{
/**
 * All the entries in the zip file.
 * @constructor
 * @param {Object} loadOptions Options for loading the stream.
 */ function $ae91d1555267d922$var$ZipEntries$1(loadOptions) {
    this.files = [];
    this.loadOptions = loadOptions;
}
$ae91d1555267d922$var$ZipEntries$1.prototype = {
    /**
     * Check that the reader is on the specified signature.
     * @param {string} expectedSignature the expected signature.
     * @throws {Error} if it is an other signature.
     */ checkSignature: function(expectedSignature) {
        if (!this.reader.readAndCheckSignature(expectedSignature)) {
            this.reader.index -= 4;
            var signature = this.reader.readString(4);
            throw new Error("Corrupted zip or bug: unexpected signature (" + $ae91d1555267d922$var$utils$1.pretty(signature) + ", expected " + $ae91d1555267d922$var$utils$1.pretty(expectedSignature) + ")");
        }
    },
    /**
     * Check if the given signature is at the given index.
     * @param {number} askedIndex the index to check.
     * @param {string} expectedSignature the signature to expect.
     * @return {boolean} true if the signature is here, false otherwise.
     */ isSignature: function(askedIndex, expectedSignature) {
        var currentIndex = this.reader.index;
        this.reader.setIndex(askedIndex);
        var signature = this.reader.readString(4);
        var result = signature === expectedSignature;
        this.reader.setIndex(currentIndex);
        return result;
    },
    /**
     * Read the end of the central directory.
     */ readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2);
        this.diskWithCentralDirStart = this.reader.readInt(2);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
        this.centralDirRecords = this.reader.readInt(2);
        this.centralDirSize = this.reader.readInt(4);
        this.centralDirOffset = this.reader.readInt(4);
        this.zipCommentLength = this.reader.readInt(2);
        // warning : the encoding depends of the system locale
        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
        // On a windows machine, this field is encoded with the localized windows code page.
        var zipComment = this.reader.readData(this.zipCommentLength);
        var decodeParamType = $ae91d1555267d922$var$support.uint8array ? "uint8array" : "array";
        // To get consistent behavior with the generation part, we will assume that
        // this is utf8 encoded unless specified otherwise.
        var decodeContent = $ae91d1555267d922$var$utils$1.transformTo(decodeParamType, zipComment);
        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
    },
    /**
     * Read the end of the Zip 64 central directory.
     * Not merged with the method readEndOfCentral :
     * The end of central can coexist with its Zip64 brother,
     * I don't want to read the wrong number of bytes !
     */ readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8);
        this.reader.skip(4);
        // this.versionMadeBy = this.reader.readString(2);
        // this.versionNeeded = this.reader.readInt(2);
        this.diskNumber = this.reader.readInt(4);
        this.diskWithCentralDirStart = this.reader.readInt(4);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
        this.centralDirRecords = this.reader.readInt(8);
        this.centralDirSize = this.reader.readInt(8);
        this.centralDirOffset = this.reader.readInt(8);
        this.zip64ExtensibleData = {};
        var extraDataSize = this.zip64EndOfCentralSize - 44, index = 0, extraFieldId, extraFieldLength, extraFieldValue;
        while(index < extraDataSize){
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readData(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Read the end of the Zip 64 central directory locator.
     */ readBlockZip64EndOfCentralLocator: function() {
        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
        this.disksCount = this.reader.readInt(4);
        if (this.disksCount > 1) throw new Error("Multi-volumes zip are not supported");
    },
    /**
     * Read the local files, based on the offset read in the central part.
     */ readLocalFiles: function() {
        var i, file;
        for(i = 0; i < this.files.length; i++){
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature($ae91d1555267d922$var$sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
            file.processAttributes();
        }
    },
    /**
     * Read the central directory.
     */ readCentralDir: function() {
        var file;
        this.reader.setIndex(this.centralDirOffset);
        while(this.reader.readAndCheckSignature($ae91d1555267d922$var$sig.CENTRAL_FILE_HEADER)){
            file = new $ae91d1555267d922$var$ZipEntry({
                zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
        }
        if (this.centralDirRecords !== this.files.length) {
            if (this.centralDirRecords !== 0 && this.files.length === 0) // We expected some records but couldn't find ANY.
            // This is really suspicious, as if something went wrong.
            throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
        }
    },
    /**
     * Read the end of central directory.
     */ readEndOfCentral: function() {
        var offset = this.reader.lastIndexOfSignature($ae91d1555267d922$var$sig.CENTRAL_DIRECTORY_END);
        if (offset < 0) {
            // Check if the content is a truncated zip or complete garbage.
            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
            // extractible zip for example) but it can give a good hint.
            // If an ajax request was used without responseType, we will also
            // get unreadable data.
            var isGarbage = !this.isSignature(0, $ae91d1555267d922$var$sig.LOCAL_FILE_HEADER);
            if (isGarbage) throw new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
            else throw new Error("Corrupted zip: can't find end of central directory");
        }
        this.reader.setIndex(offset);
        var endOfCentralDirOffset = offset;
        this.checkSignature($ae91d1555267d922$var$sig.CENTRAL_DIRECTORY_END);
        this.readBlockEndOfCentral();
        /* extract from the zip spec :
            4)  If one of the fields in the end of central directory
                record is too small to hold required data, the field
                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                ZIP64 format record should be created.
            5)  The end of central directory record and the
                Zip64 end of central directory locator record must
                reside on the same disk when splitting or spanning
                an archive.
         */ if (this.diskNumber === $ae91d1555267d922$var$utils$1.MAX_VALUE_16BITS || this.diskWithCentralDirStart === $ae91d1555267d922$var$utils$1.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === $ae91d1555267d922$var$utils$1.MAX_VALUE_16BITS || this.centralDirRecords === $ae91d1555267d922$var$utils$1.MAX_VALUE_16BITS || this.centralDirSize === $ae91d1555267d922$var$utils$1.MAX_VALUE_32BITS || this.centralDirOffset === $ae91d1555267d922$var$utils$1.MAX_VALUE_32BITS) {
            this.zip64 = true;
            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : JavaScript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */ // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature($ae91d1555267d922$var$sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
            this.reader.setIndex(offset);
            this.checkSignature($ae91d1555267d922$var$sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();
            // now the zip64 EOCD record
            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, $ae91d1555267d922$var$sig.ZIP64_CENTRAL_DIRECTORY_END)) {
                // console.warn("ZIP64 end of central directory not where expected.");
                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature($ae91d1555267d922$var$sig.ZIP64_CENTRAL_DIRECTORY_END);
                if (this.relativeOffsetEndOfZip64CentralDir < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
            }
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature($ae91d1555267d922$var$sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
        }
        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
        if (this.zip64) {
            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */  + this.zip64EndOfCentralSize;
        }
        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;
        if (extraBytes > 0) {
            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
            if (this.isSignature(endOfCentralDirOffset, $ae91d1555267d922$var$sig.CENTRAL_FILE_HEADER)) ;
            else // the offset is wrong, update the "zero" of the reader
            // this happens if data has been prepended (crx files for example)
            this.reader.zero = extraBytes;
        } else if (extraBytes < 0) throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
    },
    prepareReader: function(data) {
        this.reader = $ae91d1555267d922$var$readerFor(data);
    },
    /**
     * Read a zip file and create ZipEntries.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
     */ load: function(data) {
        this.prepareReader(data);
        this.readEndOfCentral();
        this.readCentralDir();
        this.readLocalFiles();
    }
};
// }}} end of ZipEntries
var $ae91d1555267d922$var$zipEntries = $ae91d1555267d922$var$ZipEntries$1;
var $ae91d1555267d922$var$utils = $ae91d1555267d922$var$utils$r;
var $ae91d1555267d922$var$external = $ae91d1555267d922$var$external$3;
var $ae91d1555267d922$var$utf8 = $ae91d1555267d922$var$utf8$5;
var $ae91d1555267d922$var$utils = $ae91d1555267d922$var$utils$r;
var $ae91d1555267d922$var$ZipEntries = $ae91d1555267d922$var$zipEntries;
var $ae91d1555267d922$var$Crc32Probe = $ae91d1555267d922$var$Crc32Probe_1;
var $ae91d1555267d922$var$nodejsUtils = $ae91d1555267d922$var$nodejsUtils$2;
/**
 * Check the CRC32 of an entry.
 * @param {ZipEntry} zipEntry the zip entry to check.
 * @return {Promise} the result.
 */ function $ae91d1555267d922$var$checkEntryCRC32(zipEntry) {
    return new $ae91d1555267d922$var$external.Promise(function(resolve, reject) {
        var worker = zipEntry.decompressed.getContentWorker().pipe(new $ae91d1555267d922$var$Crc32Probe());
        worker.on("error", function(e) {
            reject(e);
        }).on("end", function() {
            if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) reject(new Error("Corrupted zip : CRC32 mismatch"));
            else resolve();
        }).resume();
    });
}
var $ae91d1555267d922$var$load = function(data, options) {
    var zip = this;
    options = $ae91d1555267d922$var$utils.extend(options || {}, {
        base64: false,
        checkCRC32: false,
        optimizedBinaryString: false,
        createFolders: false,
        decodeFileName: $ae91d1555267d922$var$utf8.utf8decode
    });
    if ($ae91d1555267d922$var$nodejsUtils.isNode && $ae91d1555267d922$var$nodejsUtils.isStream(data)) return $ae91d1555267d922$var$external.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
    return $ae91d1555267d922$var$utils.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64).then(function(data) {
        var zipEntries = new $ae91d1555267d922$var$ZipEntries(options);
        zipEntries.load(data);
        return zipEntries;
    }).then(function checkCRC32(zipEntries) {
        var promises = [
            $ae91d1555267d922$var$external.Promise.resolve(zipEntries)
        ];
        var files = zipEntries.files;
        if (options.checkCRC32) for(var i = 0; i < files.length; i++)promises.push($ae91d1555267d922$var$checkEntryCRC32(files[i]));
        return $ae91d1555267d922$var$external.Promise.all(promises);
    }).then(function addFiles(results) {
        var zipEntries = results.shift();
        var files = zipEntries.files;
        for(var i = 0; i < files.length; i++){
            var input = files[i];
            zip.file(input.fileNameStr, input.decompressed, {
                binary: true,
                optimizedBinaryString: true,
                date: input.date,
                dir: input.dir,
                comment: input.fileCommentStr.length ? input.fileCommentStr : null,
                unixPermissions: input.unixPermissions,
                dosPermissions: input.dosPermissions,
                createFolders: options.createFolders
            });
        }
        if (zipEntries.zipComment.length) zip.comment = zipEntries.zipComment;
        return zip;
    });
};
/**
 * Representation a of zip file in js
 * @constructor
 */ function $ae91d1555267d922$var$JSZip() {
    // if this constructor is used without `new`, it adds `new` before itself:
    if (!(this instanceof $ae91d1555267d922$var$JSZip)) return new $ae91d1555267d922$var$JSZip();
    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
    // object containing the files :
    // {
    //   "folder/" : {...},
    //   "folder/data.txt" : {...}
    // }
    this.files = {};
    this.comment = null;
    // Where we are in the hierarchy
    this.root = "";
    this.clone = function() {
        var newObj = new $ae91d1555267d922$var$JSZip();
        for(var i in this)if (typeof this[i] !== "function") newObj[i] = this[i];
        return newObj;
    };
}
$ae91d1555267d922$var$JSZip.prototype = $ae91d1555267d922$var$object;
$ae91d1555267d922$var$JSZip.prototype.loadAsync = $ae91d1555267d922$var$load;
$ae91d1555267d922$var$JSZip.support = $ae91d1555267d922$var$support$5;
$ae91d1555267d922$var$JSZip.defaults = $ae91d1555267d922$var$defaults$1;
// TODO find a better way to handle this version,
// a require('package.json').version doesn't work with webpack, see #327
$ae91d1555267d922$var$JSZip.version = "3.5.0";
$ae91d1555267d922$var$JSZip.loadAsync = function(content, options) {
    return new $ae91d1555267d922$var$JSZip().loadAsync(content, options);
};
$ae91d1555267d922$var$JSZip.external = $ae91d1555267d922$var$external$3;
var $ae91d1555267d922$var$lib = $ae91d1555267d922$var$JSZip;
/*! FileSaver.js
 *  A saveAs() FileSaver implementation.
 *  2014-01-24
 *
 *  By Eli Grey, http://eligrey.com
 *  License: X11/MIT
 *    See LICENSE.md
 */ /*global self */ /*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */ /*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */ function $ae91d1555267d922$var$FileSaver() {
    var saveAs = saveAs || typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob && navigator.msSaveOrOpenBlob.bind(navigator) || function(view) {
        // IE <10 is explicitly unsupported
        if (typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) return;
        var doc = view.document, get_URL = function() {
            return view.URL || view.webkitURL || view;
        }, URL = view.URL || view.webkitURL || view, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"), can_use_save_link = !view.externalHost && "download" in save_link, webkit_req_fs = view.webkitRequestFileSystem, req_fs = view.requestFileSystem || webkit_req_fs || view.mozRequestFileSystem, throw_outside = function(ex) {
            (view.setImmediate || view.setTimeout)(function() {
                throw ex;
            }, 0);
        }, force_saveable_type = "application/octet-stream", fs_min_size = 0, deletion_queue = [], process_deletion_queue = function() {
            var i = deletion_queue.length;
            while(i--){
                var file = deletion_queue[i];
                if (typeof file === "string") URL.revokeObjectURL(file);
                else file.remove();
            }
            deletion_queue.length = 0; // clear queue
        }, dispatch = function(filesaver, event_types, event) {
            event_types = [].concat(event_types);
            var i = event_types.length;
            while(i--){
                var listener = filesaver["on" + event_types[i]];
                if (typeof listener === "function") try {
                    listener.call(filesaver, event || filesaver);
                } catch (ex) {
                    throw_outside(ex);
                }
            }
        }, FileSaver = function(blob, name) {
            // First try a.download, then web filesystem, then object URLs
            var filesaver = this, type = blob.type, blob_changed = false, object_url, target_view, get_object_url = function() {
                var object_url = get_URL().createObjectURL(blob);
                deletion_queue.push(object_url);
                return object_url;
            }, dispatch_all = function() {
                dispatch(filesaver, "writestart progress write writeend".split(" "));
            }, fs_error = function() {
                // don't create more object URLs than needed
                if (blob_changed || !object_url) object_url = get_object_url();
                if (target_view) target_view.location.href = object_url;
                else window.open(object_url, "_blank");
                filesaver.readyState = filesaver.DONE;
                dispatch_all();
            }, abortable = function(func) {
                return function() {
                    if (filesaver.readyState !== filesaver.DONE) return func.apply(this, arguments);
                };
            }, create_if_not_found = {
                create: true,
                exclusive: false
            }, slice;
            filesaver.readyState = filesaver.INIT;
            if (!name) name = "download";
            if (can_use_save_link) {
                object_url = get_object_url();
                // FF for Android has a nasty garbage collection mechanism
                // that turns all objects that are not pure javascript into 'deadObject'
                // this means `doc` and `save_link` are unusable and need to be recreated
                // `view` is usable though:
                doc = view.document;
                save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a");
                save_link.href = object_url;
                save_link.download = name;
                var event = doc.createEvent("MouseEvents");
                event.initMouseEvent("click", true, false, view, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                save_link.dispatchEvent(event);
                filesaver.readyState = filesaver.DONE;
                dispatch_all();
                return;
            }
            // Object and web filesystem URLs have a problem saving in Google Chrome when
            // viewed in a tab, so I force save with application/octet-stream
            // http://code.google.com/p/chromium/issues/detail?id=91158
            if (view.chrome && type && type !== force_saveable_type) {
                slice = blob.slice || blob.webkitSlice;
                blob = slice.call(blob, 0, blob.size, force_saveable_type);
                blob_changed = true;
            }
            // Since I can't be sure that the guessed media type will trigger a download
            // in WebKit, I append .download to the filename.
            // https://bugs.webkit.org/show_bug.cgi?id=65440
            if (webkit_req_fs && name !== "download") name += ".download";
            if (type === force_saveable_type || webkit_req_fs) target_view = view;
            if (!req_fs) {
                fs_error();
                return;
            }
            fs_min_size += blob.size;
            req_fs(view.TEMPORARY, fs_min_size, abortable(function(fs) {
                fs.root.getDirectory("saved", create_if_not_found, abortable(function(dir) {
                    var save = function() {
                        dir.getFile(name, create_if_not_found, abortable(function(file) {
                            file.createWriter(abortable(function(writer) {
                                writer.onwriteend = function(event) {
                                    target_view.location.href = file.toURL();
                                    deletion_queue.push(file);
                                    filesaver.readyState = filesaver.DONE;
                                    dispatch(filesaver, "writeend", event);
                                };
                                writer.onerror = function() {
                                    var error = writer.error;
                                    if (error.code !== error.ABORT_ERR) fs_error();
                                };
                                "writestart progress write abort".split(" ").forEach(function(event) {
                                    writer["on" + event] = filesaver["on" + event];
                                });
                                writer.write(blob);
                                filesaver.abort = function() {
                                    writer.abort();
                                    filesaver.readyState = filesaver.DONE;
                                };
                                filesaver.readyState = filesaver.WRITING;
                            }), fs_error);
                        }), fs_error);
                    };
                    dir.getFile(name, {
                        create: false
                    }, abortable(function(file) {
                        // delete file if it already exists
                        file.remove();
                        save();
                    }), abortable(function(ex) {
                        if (ex.code === ex.NOT_FOUND_ERR) save();
                        else fs_error();
                    }));
                }), fs_error);
            }), fs_error);
        }, FS_proto = FileSaver.prototype, saveAs = function(blob, name) {
            return new FileSaver(blob, name);
        };
        FS_proto.abort = function() {
            var filesaver = this;
            filesaver.readyState = filesaver.DONE;
            dispatch(filesaver, "abort");
        };
        FS_proto.readyState = FS_proto.INIT = 0;
        FS_proto.WRITING = 1;
        FS_proto.DONE = 2;
        FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;
        view.addEventListener("unload", process_deletion_queue, false);
        saveAs.unload = function() {
            process_deletion_queue();
            view.removeEventListener("unload", process_deletion_queue, false);
        };
        return saveAs;
    }(typeof self !== "undefined" && self || typeof window !== "undefined" && window || this.content);
    // `self` is undefined in Firefox for Android content script context
    // while `this` is nsIContentFrameMessageManager
    // with an attribute `content` that corresponds to the window
    return saveAs;
}
const $ae91d1555267d922$var$DEFAULT_FEATURES = {
    normalize: true,
    elements: true,
    "content-tables": true,
    "content-links": true,
    "content-media": true,
    "content-links-external": false,
    "interface-message-box": true,
    "interface-category": true,
    toc: true
};
function $ae91d1555267d922$var$getFeaturesFromStyles(styles) {
    const match = styles.match(/\/\*+ +ResourceLoaderSkinModule: ([^*]*) *[*]+/);
    const result = {};
    if (match && match[1]) {
        Object.keys($ae91d1555267d922$var$DEFAULT_FEATURES).forEach((key)=>{
            result[key] = false;
        });
        match[1].split(",").map((a)=>a.trim()).forEach((key)=>{
            if ($ae91d1555267d922$var$DEFAULT_FEATURES[key] !== undefined) result[key] = true;
        });
        return result;
    } else return $ae91d1555267d922$var$DEFAULT_FEATURES;
}
/**
 * @param {string} template
 * @param {string} skinKey
 * @return {string}
 */ function $ae91d1555267d922$var$localizeTemplate(template, skinKey) {
    return template.replace(/msg-skinname-/g, `msg-${skinKey}-`);
}
function $ae91d1555267d922$var$getTemplatesFromSourceCode(partials, sourceCode, skinKey, templateName = "s") {
    const usedPartials = {};
    Object.keys(partials).filter((name)=>{
        // Is the partial in the sourceCode?
        const re = new RegExp(`{{> *${name} *}}`);
        return !!sourceCode.match(re) && // avoid recursion.
        templateName !== name;
    }).forEach((key)=>{
        const others = Object.keys($ae91d1555267d922$var$getTemplatesFromSourceCode(partials, partials[key], skinKey, key));
        usedPartials[key] = $ae91d1555267d922$var$localizeTemplate(partials[key], skinKey);
        others.forEach((otherKey)=>{
            if (otherKey === "skin") return; // not a partial.
            const standardTemplate = partials[otherKey];
            const localizedTemplate = skinKey ? $ae91d1555267d922$var$localizeTemplate(standardTemplate, skinKey) : standardTemplate;
            usedPartials[otherKey] = localizedTemplate;
        });
    });
    return Object.assign(usedPartials, {
        skin: sourceCode
    });
}
var $ae91d1555267d922$var$scripts = {
    test: "npm -s run lint",
    lint: "npm -s run lint:js && npm -s run lint:styles && npm -s run lint:i18n",
    "lint:fix:js": "npm -s run lint:js -- --fix",
    "lint:fix:styles": "npm -s run lint:styles -- --fix",
    "lint:js": "eslint --cache .",
    "lint:styles": 'stylelint "**/*.{less,css}"',
    "lint:i18n": "banana-checker i18n/"
};
var $ae91d1555267d922$var$devDependencies = {
    "eslint-config-wikimedia": "0.25.1",
    "grunt-banana-checker": "0.11.0",
    "stylelint-config-wikimedia": "0.15.0"
};
var $ae91d1555267d922$var$packageJSON = {
    "private": true,
    scripts: $ae91d1555267d922$var$scripts,
    devDependencies: $ae91d1555267d922$var$devDependencies
};
var $ae91d1555267d922$var$root = true;
var $ae91d1555267d922$var$rules$1 = {
    "compat/compat": "off",
    "vue/no-v-html": "off"
};
var $ae91d1555267d922$var$eslintJSON = {
    root: $ae91d1555267d922$var$root,
    "extends": [
        "wikimedia/client-es6",
        "wikimedia/jquery",
        "wikimedia/mediawiki"
    ],
    rules: $ae91d1555267d922$var$rules$1
};
var $ae91d1555267d922$var$rules = {
    "selector-max-id": null,
    "no-descending-specificity": null
};
var $ae91d1555267d922$var$stylelintJSON = {
    "extends": "stylelint-config-wikimedia",
    rules: $ae91d1555267d922$var$rules
};
function $ae91d1555267d922$var$camelcase(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word) {
        return word.toUpperCase();
    }).replace(/\s+/g, "");
}
function $ae91d1555267d922$var$stringifyjson(json) {
    return `${JSON.stringify(json, null, "	")}
`;
}
function $ae91d1555267d922$var$getFolderNameFromName(name) {
    return $ae91d1555267d922$var$camelcase(name);
}
function $ae91d1555267d922$var$getSkinKeyFromName(name) {
    return $ae91d1555267d922$var$getFolderNameFromName(name).toLowerCase();
}
function $ae91d1555267d922$var$addDevTools(name, rootfolder) {
    rootfolder.file("package.json", $ae91d1555267d922$var$stringifyjson(Object.assign({
        name: name
    }, $ae91d1555267d922$var$packageJSON)));
    rootfolder.file(".eslintrc.json", $ae91d1555267d922$var$stringifyjson($ae91d1555267d922$var$eslintJSON));
    rootfolder.file(".stylelintrc.json", $ae91d1555267d922$var$stringifyjson($ae91d1555267d922$var$stylelintJSON));
    rootfolder.file(".gitignore", `.eslintcache
node_modules/
`);
}
const $ae91d1555267d922$var$SKINS_LAB_VERSION = "3.0";
const $ae91d1555267d922$var$MW_MIN_VERSION = "1.41.0";
$ae91d1555267d922$var$lib.support.blob = true;
/**
 * @typedef {Object} Folder
 * @property {Function} file
 */ /**
 *
 * @param {string} name
 * @param {Folder} rootfolder
 * @param {Object} messages
 * @param {Array} authors
 */ function $ae91d1555267d922$var$addi18n$1(name, rootfolder, messages = {}, authors = []) {
    const TOOL_LINK = `[https://skins.wmflabs.org skins.wmflabs.org v.${$ae91d1555267d922$var$SKINS_LAB_VERSION}]`;
    const skinKey = $ae91d1555267d922$var$getSkinKeyFromName(name);
    const i18nfolder = rootfolder.folder("i18n");
    const metadata = {
        authors: authors
    };
    const en = Object.assign({
        "@metadata": metadata,
        [`skinname-${skinKey}`]: name,
        [`${skinKey}-skin-desc`]: `A skin created by ${TOOL_LINK}`
    }, messages.en || {});
    const qqq = Object.assign({
        "@metadata": metadata,
        [`skinname-${skinKey}`]: "{{optional}}",
        [`${skinKey}-skin-desc`]: `{{desc|what=skin|name=${name}|url=https://www.mediawiki.org/wiki/Skin:${name}}}`
    }, messages.qqq || {});
    i18nfolder.file("en.json", $ae91d1555267d922$var$stringifyjson(en));
    i18nfolder.file("qqq.json", $ae91d1555267d922$var$stringifyjson(qqq));
}
/**
 *
 * @param {string} name  e.g. Vector
 * @param {string[]} styles paths
 * @param {string[]} packageFiles path
 * @param {string[]} messages keys used by skin
 * @param {string[]} skinFeatures feature keys used by skin
 * @param {Object} skinOptions for populating ValidSkinNames args
 * @param {string} license of skin
 * @param {Array} authors of skin
 * @param {Object} skinStyles
 * @param {boolean} toc whether to include in article.
 * @return {Object}
 */ function $ae91d1555267d922$var$skinjson(name, styles, packageFiles, messages, skinFeatures, skinOptions, license, authors, skinStyles, toc) {
    const folderName = $ae91d1555267d922$var$getFolderNameFromName(name);
    const skinKey = $ae91d1555267d922$var$getSkinKeyFromName(name);
    const TOOL_LINK = `[https://skins.wmflabs.org skins.wmflabs.org v.${$ae91d1555267d922$var$SKINS_LAB_VERSION}]`;
    const author = authors || [
        `${TOOL_LINK}`
    ];
    return {
        name: name,
        version: "1.0.0",
        author: author,
        url: `https://www.mediawiki.org/wiki/Skin:${folderName}`,
        descriptionmsg: `${skinKey}-skin-desc`,
        namemsg: `skinname-${skinKey}`,
        "license-name": license,
        type: "skin",
        requires: {
            MediaWiki: `>= ${$ae91d1555267d922$var$MW_MIN_VERSION}`
        },
        ValidSkinNames: {
            [skinKey]: {
                class: "SkinMustache",
                args: [
                    Object.assign({
                        name: skinKey,
                        responsive: true,
                        toc: toc,
                        messages: messages,
                        styles: [
                            "codex-styles",
                            `skins.${skinKey}.styles`
                        ],
                        scripts: packageFiles.length ? [
                            `skins.${skinKey}`
                        ] : []
                    }, skinOptions)
                ]
            }
        },
        MessagesDirs: {
            [folderName]: [
                "i18n"
            ]
        },
        ResourceModules: {
            [`skins.${skinKey}.styles`]: {
                class: "MediaWiki\\ResourceLoader\\SkinModule",
                features: skinFeatures,
                targets: [
                    "desktop",
                    "mobile"
                ],
                styles: styles
            },
            [`skins.${skinKey}`]: packageFiles.length ? {
                targets: [
                    "desktop",
                    "mobile"
                ],
                packageFiles: packageFiles
            } : undefined
        },
        ResourceFileModulePaths: {
            localBasePath: "",
            remoteSkinPath: folderName
        },
        ResourceModuleSkinStyles: {
            [skinKey]: skinStyles
        },
        // eslint-disable-next-line camelcase
        manifest_version: 2
    };
}
/**
 *
 * @param {string} name (uppercase) of skin e.g. SkinVector
 * @param {Object} styles key is the name of the stylesheet
 *  and the text is its content. the key `skin.less` will be rendered last
 * @param {Object} templates key is the name of the template minus
 * the mustache suffix and the text is its content
 * @param {Object} scripts key is the name of the script file e.g. `skin.js` and the text is its content
 * @param {Array} messages (keys) used by template
 * @param {Object} options
 * @return {Promise}
 */ function $ae91d1555267d922$var$build(name, styles, templates, scripts = {}, messages = [], options = {}) {
    const Zipper = options.Zipper || $ae91d1555267d922$var$lib;
    const myFileSaver = options.CustomFileSaver || $ae91d1555267d922$var$FileSaver;
    const skinOptions = options.skinOptions || {};
    const license = options.license;
    const messageObj = options.messages || {};
    const authors = options.authors;
    const zip = new Zipper();
    const folderName = $ae91d1555267d922$var$getFolderNameFromName(name);
    const rootfolder = zip.folder(folderName);
    const resourcesFolder = rootfolder.folder("resources");
    const templatefolder = rootfolder.folder("templates");
    if (!styles["skin.less"]) throw new Error("skin.less must be defined in styles.");
    if (!templates.skin) throw new Error("`skin` must be defined in templates.");
    const skinFeatures = $ae91d1555267d922$var$getFeaturesFromStyles(styles["skin.less"]);
    // Create the files in the root folder
    const jsfiles = (scripts["skin.js"] ? [
        "resources/skin.js"
    ] : []).concat(Object.keys(scripts).filter((scriptFileName)=>scriptFileName !== "skin.js").map((scriptFileName)=>`resources/${scriptFileName}`));
    const skinKey = $ae91d1555267d922$var$getSkinKeyFromName(name);
    const skinMessages = Array.from(new Set(messages.map((msg)=>msg.replace("skinname-", `${skinKey}-`))));
    const skinJSON = $ae91d1555267d922$var$skinjson(name, // only `css` files need to be listed in manifest
    // not LESS.
    Object.keys(styles).filter((styleFileName)=>styleFileName.indexOf(".less") === -1 && styleFileName !== "skin.less")// its in the src folder.
    .map((styleFileName)=>`resources/${styleFileName}`).concat([
        "resources/skin.less"
    ]), jsfiles, skinMessages, skinFeatures, skinOptions, license, authors, options.skinStyles, // If no reference to data-toc in master template,
    // assume toc should be included.
    templates.skin.indexOf("#data-toc") === -1);
    rootfolder.file("skin.json", $ae91d1555267d922$var$stringifyjson(skinJSON));
    $ae91d1555267d922$var$addDevTools(name, rootfolder);
    // create styles and script files in `resources` folder
    Object.keys(styles).forEach((filename)=>{
        resourcesFolder.file(filename, styles[filename]);
    });
    Object.keys(scripts).forEach((filename)=>{
        resourcesFolder.file(filename, scripts[filename]);
    });
    // setup templates
    Object.keys(templates).forEach((template)=>{
        templatefolder.file(`${template}.mustache`, templates[template]);
    });
    // setup i18n
    messageObj.en = messageObj.en || {};
    messageObj.qqq = messageObj.qqq || {};
    const ourMessages = {
        "no-categories": "No categories."
    };
    const ourMessagesQQQ = {
        "no-categories": "Message to show when no categories available"
    };
    skinMessages.forEach((key)=>{
        const lookup = key.split("-").slice(1).join("-");
        const ours = ourMessages[lookup];
        if (ours) {
            messageObj.en[key] = ourMessages[lookup];
            messageObj.qqq[key] = ourMessagesQQQ[lookup];
        }
    });
    $ae91d1555267d922$var$addi18n$1(name, rootfolder, messageObj, authors || [
        "..."
    ]);
    /* images.forEach((image) => {
        imagesfolder.file(image.name, image.text);
    }) */ // build!
    return zip.generateAsync({
        type: "blob"
    }).then((content)=>{
        const saver = myFileSaver();
        return saver(content, `${folderName}.zip`);
    }).then((saveResult)=>{
        return {
            zip: zip,
            saveResult: saveResult
        };
    });
}
const $ae91d1555267d922$var$POLYFILLS = {};
const $ae91d1555267d922$var$POLYFILLS_MATCH = {
    "?action=history": `mw.requestIdleCallback( function () {
	// History URL
	$('[href="?action=history"]').prop('href', mw.util.getUrl( mw.config.get('wgTitle'), { action: 'history' } ) );
} );`
};
const $ae91d1555267d922$var$polyfill = (js, templates)=>{
    Object.keys(templates).forEach((template)=>{
        if ($ae91d1555267d922$var$POLYFILLS[template]) js = $ae91d1555267d922$var$POLYFILLS[template] + js;
        const text = templates[template];
        Object.keys($ae91d1555267d922$var$POLYFILLS_MATCH).forEach((key)=>{
            if (text.indexOf(key) > -1) js = $ae91d1555267d922$var$POLYFILLS_MATCH[key] + js;
        });
    });
    return js;
};
var $ae91d1555267d922$var$FooterList = '<ul id="{{id}}">\n{{#array-items}}\n<li id="{{id}}">{{{html}}}</li>\n{{/array-items}}\n</ul>\n';
var $ae91d1555267d922$var$CategoryLinks = '<span class="skin-category-links mw-portlet mw-portlet-category-normal">{{#data-portlets.data-category-normal.array-items}}{{{html}}} {{/data-portlets.data-category-normal.array-items}}</span></span>\n';
var $ae91d1555267d922$var$CategoryPlain = '{{#data-portlets}}<span\n	class="catlinks mw-skin-category-plain"\n	data-mw="interface">\n    {{^data-category-normal}}{{msg-skinname-no-categories}}{{/data-category-normal}}\n    {{#data-category-normal}}\n	<ul class="{{class}}">\n	{{#array-items}}{{>ListItem}}{{/array-items}}\n	{{/data-category-normal}}\n	{{#data-category-hidden}}\n	<li class="{{class}}">\n		<ul>{{#array-items}}{{>ListItem}}{{/array-items}}</ul>\n	</li>\n	{{/data-category-hidden}}\n	</ul>\n</span>{{/data-portlets}}\n';
var $ae91d1555267d922$var$CopyrightLine = '<span class="skin-copyright-line footer-info-copyright">\n    {{#data-copyright}}{{{html}}}{{/data-copyright}}\n</span>\n';
var $ae91d1555267d922$var$Content = '<main id="content" class="mw-body">\n	<header class="content__header">\n		{{>ContentIndicators}}\n		{{>ContentHeading}}\n		{{>ContentTagline}}\n		{{>ContentNamespaces}}\n		{{>ContentActions}}\n	</header>\n	{{>ContentBody}}\n	{{#data-toc}}{{>TableOfContents}}{{/data-toc}}\n</main>\n';
var $ae91d1555267d922$var$LastModifiedLine = '<span class="skin-last-modified" data-time="{{time}}">{{text}}</span>\n';
var $ae91d1555267d922$var$CompactFooter = '{{#data-footer.data-icons}}\n<p class="{{id}} {{className}}">\n{{#array-items}}{{{html}}}&nbsp;{{/array-items}}\n</p>\n{{/data-footer.data-icons}}\n{{#data-footer.data-info.array-items}}<div class="{{id}}">{{{html}}}</div>{{/data-footer.data-info.array-items}}\n<div>\n{{#data-footer.data-places.array-items}}<span class="{{id}}">{{{html}}}</span>&nbsp;&nbsp;{{/data-footer.data-places.array-items}}\n</div>\n';
var $ae91d1555267d922$var$Portlet = '<div role="navigation" id="{{id}}" class="{{class}}" title="{{html-tooltip}}"\n    aria-labelledby="{{id}}-label">\n    <input type="checkbox" aria-labelledby="{{id}}-label" />\n    <h3 id="{{id}}-label" {{{html-user-language-attributes}}}>{{label}}</h3>\n    <div class="mw-portlet-body">\n        <ul {{{html-user-language-attributes}}}>\n            {{#array-items}}{{>ListItem}}{{/array-items}}\n        </ul>\n        {{{html-after-portal}}}\n    </div>\n</div>\n';
var $ae91d1555267d922$var$ContentIndicators = '<div class="content__indicators mw-indicators mw-body-content">\n    {{#array-indicators}}\n    <div id="{{id}}" class="{{class}}">{{{html}}}</div>\n    {{/array-indicators}}\n</div>\n';
var $ae91d1555267d922$var$Notices = '<div id="siteNotice">{{{html-site-notice}}}</div>\n{{{html-user-message}}}\n';
var $ae91d1555267d922$var$ContentHeading = '{{{html-title-heading}}}\n{{#data-portlets.data-languages}}\n<a href="#p-lang" class="mw-interlanguage-selector">\n	<button class="cdx-button cdx-button--action-default content__language-btn">{{msg-otherlanguages}}</button>\n</a>\n{{/data-portlets.data-languages}}\n';
var $ae91d1555267d922$var$ContentActions = '<div class="content__actions">\n{{#data-portlets.data-views}}{{>Portlet}}{{/data-portlets.data-views}}\n{{>Dropdown}}{{#data-portlets.data-actions}}{{>Portlet}}{{/data-portlets.data-actions}}\n</div>\n';
var $ae91d1555267d922$var$ContentNamespaces = "{{#data-portlets.data-namespaces}}{{>Portlet}}{{/data-portlets.data-namespaces}}\n";
var $ae91d1555267d922$var$ContentBody = "{{{html-body-content}}}\n{{#data-portlets}}\n{{>CategoryPortlet}}\n{{/data-portlets}}\n{{{html-after-content}}}\n";
var $ae91d1555267d922$var$ContentTagline = '<div class="content__tagline">\n    <span>{{msg-tagline}}</span>\n    <span>{{{html-subtitle}}}</span>\n    <span>{{{html-undelete-link}}}</span>\n</div>\n';
var $ae91d1555267d922$var$Footer = '{{! `role` is unnecessary but kept to support selectors in any gadgets or user styles and\n	to mitigate a VoiceOver bug. }}\n<footer id="footer" class="mw-footer" role="contentinfo" {{{html-user-language-attributes}}}>\n	{{#data-footer}}\n	{{!}}{{#data-icons}}{{>FooterList}}{{/data-icons}}\n	{{!}}<div id="footer-list">\n	{{#data-last-modified}}{{>LastModifiedLine}}{{/data-last-modified}}\n	<div id="copyright">{{#data-copyright}}{{{html}}}{{/data-copyright}}</div>\n	{{!}}{{#data-places}}{{>FooterList}}{{/data-places}}\n	{{!}}</div>\n	{{/data-footer}}\n</footer>\n';
var $ae91d1555267d922$var$Logo = '<div id="p-logo" class="mw-portlet" role="banner">\n    <a href="{{link-mainpage}}">\n    {{#data-logos}}\n        {{#icon}}<img class="icon" src="{{.}}" width="40" height="40">{{/icon}}\n        {{#wordmark}}<img src="{{src}}" width="{{width}}" height="{{height}}">{{/wordmark}}\n        {{^wordmark}}<h1>{{msg-sitetitle}}</h1>{{/wordmark}}\n    {{/data-logos}}\n    </a>\n</div>';
var $ae91d1555267d922$var$LanguageButton = '{{#data-portlets.data-languages}}\n<nav class="language-button {{class}}" id="{{id}}">\n    <input type="checkbox" class="mw-interlanguage-selector">\n    <div class="cdx-button cdx-button--action-progressive">\n        {{msg-otherlanguages}}\n    </div>\n    <div class="language-button-dropdown">\n        <ul>{{#array-items}}{{>ListItem}}{{/array-items}}</ul>\n    </div>\n</nav>\n{{/data-portlets.data-languages}}\n';
var $ae91d1555267d922$var$ListItem = '<li id="{{id}}" class="{{class}}">{{#array-links}}{{>ListItemLink}}{{/array-links}}</li>\n';
var $ae91d1555267d922$var$ListItemLink = '<a {{#array-attributes}}{{key}}="{{value}}"{{/array-attributes}}>\n<span class="list-item-{{icon}}"></span>{{ text }}</a>\n';
var $ae91d1555267d922$var$Search = '{{#data-search-box}}\n<form action="{{form-action}}" role="search" class="mw-portlet" id="p-search">\n    <input type="hidden" name="title" value="{{page-title}}">\n    <h3>\n        <label for="searchInput">{{msg-search}}</label>\n    </h3>\n    {{{html-input}}}\n    {{{html-button-search}}}\n</form>\n{{/data-search-box}}';
var $ae91d1555267d922$var$WPSearch = '{{#data-search-box}}\n<form action="{{form-action}}" role="search" class="mw-portlet search-form" id="p-search">\n    <input type="hidden" name="title" value="{{page-title}}">\n    <label>\n        <span class="screen-reader-text" for="searchInput">{{msg-search}}</span>\n        {{{html-input}}}\n    </label>\n    {{{html-button-search}}}\n</form>\n{{/data-search-box}}';
var $ae91d1555267d922$var$Sidebar = '<div class="toggle-list">\n	<input type="checkbox" id="sidebar-input" class="toggle-list__checkbox" role="button">\n	<label for="sidebar-input"\n		class="toggle-list__toggle sidebar__icon" title="Open main menu">Open main menu</label>\n	<div class="toggle-list__list">\n		{{#data-portlets-sidebar}}\n		{{#data-portlets-first}}{{>Portlet}}{{/data-portlets-first}}\n		{{#array-portlets-rest}}{{>Portlet}}{{/array-portlets-rest}}\n		{{/data-portlets-sidebar}}\n	</div>\n	<label class="toggle-list__mask" for="sidebar-input"></label>\n</div>';
var $ae91d1555267d922$var$Notifications = "{{#data-portlets.data-notifications}}{{>Portlet}}{{/data-portlets.data-notifications}}\n";
var $ae91d1555267d922$var$PersonalMenu = "{{#data-portlets.data-user-menu}}{{>Portlet}}{{/data-portlets.data-user-menu}}\n";
var $ae91d1555267d922$var$Languages = '<nav class="skin-languages">\n{{#data-portlets.data-variants}}{{>Portlet}}{{/data-portlets.data-variants}}\n{{#data-portlets.data-languages}}{{>Portlet}}{{/data-portlets.data-languages}}\n</nav>\n';
var $ae91d1555267d922$var$Dropdown = '<div class="mw-portlet-dropdown">\n<!-- will turn next child portlet into a dropdown -->\n</div>\n';
var $ae91d1555267d922$var$Header = '<header class="mw-header">\n	{{>Logo}}\n	{{>Notifications}}\n	{{>Dropdown}}{{>PersonalMenu}}\n	{{>Search}}\n	{{>Sidebar}}\n</header>\n';
var $ae91d1555267d922$var$AdminBar = '<div class="mw-adminbar {{#is-anon}}mw-adminbar--anon{{/is-anon}}">\n    <div class="mw-adminbar-start">\n        {{>AdminBarHome}}\n    </div>\n    <div class="mw-adminbar-end" {{{html-user-language-attributes}}}>\n        {{>AdminBarUser}}\n    </div>\n</div>\n';
var $ae91d1555267d922$var$AdminBarHome = '<ul>\n    <li class="mw-adminbar-logo">\n        <a href="{{link-mainpage}}">\n            Home\n        </a>\n    </li>\n    <li class="mw-adminbar-search">\n        {{#data-search-box}}\n        <form action="{{form-action}}">\n        <input type="checkbox" class="mw-adminbar-search__toggle">\n        <input type="search" class="mw-adminbar-search__input mw-searchInput"\n            {{{html-input-attributes}}}>\n        <input type="submit" {{{html-button-fulltext-attributes}}}>\n        </form>\n        {{/data-search-box}}\n    </li>\n</ul>';
var $ae91d1555267d922$var$AdminBarUser = '{{#data-portlets.data-user-menu}}\n<div role="navigation" id="{{id}}" class="{{class}}" title="{{html-tooltip}}"\n    aria-labelledby="{{id}}-label">\n    <input type="checkbox" aria-labelledby="{{id}}-label" />\n    <h3 id="{{id}}-label" class="mw-adminbar-icon-user">{{label}}</h3>\n    <div class="mw-portlet-body">\n        <ul>\n            {{#array-items}}{{>ListItem}}{{/array-items}}\n        </ul>\n        {{{html-after-portal}}}\n    </div>\n</div>{{!\n}}{{/data-portlets.data-user-menu}}{{!\n}}{{#data-portlets.data-notifications}}{{!\n}}<ul class="mw-adminbar-notifications">\n    {{#array-items}}{{>ListItem}}{{/array-items}}\n</ul>\n{{/data-portlets.data-notifications}}\n';
var $ae91d1555267d922$var$AdminBarWithEdit = '<div class="mw-adminbar" {{#is-anon}}mw-adminbar--anon{{/is-anon}}>\n    <div class="mw-adminbar-start">\n        {{>AdminBarHome}}\n    </div>\n    <div class="mw-adminbar-end" {{{html-user-language-attributes}}}>\n        {{>EditBar}}\n        {{>AdminBarUser}}\n    </div>\n</div>\n';
var $ae91d1555267d922$var$EditBar = '<ul class="mw-edit-bar">\n    {{#data-portlets.data-views}}\n    {{#array-items}}{{>ListItem}}{{/array-items}}\n    {{/data-portlets.data-views}}\n    {{#data-portlets.data-namespaces}}\n    {{#array-items}}{{>ListItem}}{{/array-items}}\n    {{/data-portlets.data-namespaces}}\n</ul>\n';
var $ae91d1555267d922$var$CategoryPortlet = '{{#is-article}}\n<div id="catlinks" class="catlinks" data-mw="interface">\n	{{#data-category-normal}}\n	<div id="{{id}}" class="{{class}}">\n		<ul>{{#array-items}}{{>ListItem}}{{/array-items}}</ul>\n		{{{html-after-portal}}}\n	</div>\n	{{/data-category-normal}}\n	{{^data-category-normal}}\n	<p>{{msg-skinname-no-categories}}</p>\n	{{/data-category-normal}}\n	{{#data-category-hidden}}\n	<div id="{{id}}" class="{{class}}">\n		<ul>{{#array-items}}{{>ListItem}}{{/array-items}}</ul>\n		{{{html-after-portal}}}\n	</div>\n	{{/data-category-hidden}}\n</div>\n{{/is-article}}';
var $ae91d1555267d922$var$TableOfContents = '<div id="toc-sticky">\n    <h1>Table Of Contents</h1>\n    <input type="checkbox" checked>\n    <div>\n        <ul>\n        {{#array-sections}}\n        {{>TableOfContents__line}}\n        {{/array-sections}}\n        </ul>\n    </div>\n</div>\n';
var $ae91d1555267d922$var$TableOfContentsLine = '<li>\n    {{number}}.{{index}} <a href="#{{anchor}}">{{line}}</a>\n    <ul>\n    {{#array-sections}}\n    {{>TableOfContents__line}}\n    {{/array-sections}}\n    </ul>\n</li>\n';
var $ae91d1555267d922$var$skin = "{{>Header}}\n{{>Notices}}\n{{>Content}}\n{{>Languages}}\n{{>Footer}}\n";
var $ae91d1555267d922$var$skinLESS = "/** ResourceLoaderSkinModule: normalize,elements,content-tables,content-links,content-media,interface-message-box,interface-category,toc */\n@media print {\n	@import './print.less';\n}\n\nhtml {\n	margin: 0;\n	padding: 0 0 20px;\n}\n\nbody {\n	max-width: 800px;\n	margin: 0 auto;\n	font-family: @font-family;\n}\n\nmain {\n	padding: 1em;\n\n	& ~ nav,\n	& ~ footer {\n		padding: 1em;\n	}\n}\n\n@media screen {\n	html {\n		background: @background-color-base;\n	}\n\n	body {\n		background: @background-color-article;\n	}\n\n	body,\n	h1,\n	h2,\n	h3,\n	h4,\n	h5,\n	h6 {\n		color: @color-base;\n	}\n\n	a {\n		color: @color-link;\n\n		&:visited {\n			color: @color-link--visited;\n		}\n	}\n\n	main {\n		border-bottom: solid 20px @background-color-base;\n	}\n}\n";
var $ae91d1555267d922$var$printLESS = "/* Styles for print view and printing. */\n/* You can use CSS files or Less files depending on your preference. */\n\n/* Hide some extra stuff from print view (some of the navigation is already hidden automatically,\nbut not all). */\n.mw-indicators,\n.mw-portlet-personal,\n.mw-portlet-views,\n.mw-portlet-namespaces,\n.mw-portlet-cactions,\n.mw-portlet-notifications,\n.mw-interlanguage-selector,\n.mw-portlet-lang,\n.toggle-list,\n.catlinks,\n.mw-footer,\n.mw-portlet-variants,\nform.mw-portlet,\n#toc-sticky {\n	display: none;\n}\n\n#p-logo a {\n	display: flex;\n	align-items: center;\n	column-gap: 10px;\n}\n";
var $ae91d1555267d922$var$AdminBarHomeLESS = "// stylelint-disable function-url-quotes\n// Icons from https://doc.wikimedia.org/oojs-ui/master/demos/?page=icons&theme=wikimediaui&direction=ltr&platform=desktop\n// Converted to data uri using https://yoksel.github.io/url-encoder/\n.mw-adminbar-logo {\n	background-image: url( \"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='%23fff'%3E%3Ctitle%3E home %3C/title%3E%3Cpath d='M10 1L0 10h3v9h4v-4.6c0-1.47 1.31-2.66 3-2.66s3 1.19 3 2.66V19h4v-9h3L10 1z'/%3E%3C/svg%3E%0A\" );\n}\n\n.mw-adminbar-start ul li.mw-adminbar-search {\n	width: auto;\n\n	form {\n		display: flex;\n		height: 32px;\n		position: relative;\n	}\n\n	.mw-adminbar-search__toggle {\n		position: absolute;\n		right: 0;\n		width: 40px;\n		height: 100%;\n	}\n\n	.mw-adminbar-search__input {\n		color: #fff;\n		background: #000;\n		opacity: 1;\n	}\n\n	.searchButton {\n		background-color: transparent;\n		border: 0;\n		background-image: url( \"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='white'%3E%3Ctitle%3E search %3C/title%3E%3Cpath fill-rule='evenodd' d='M12.2 13.6a7 7 0 111.4-1.4l5.4 5.4-1.4 1.4-5.4-5.4zM13 8A5 5 0 113 8a5 5 0 0110 0z'/%3E%3C/svg%3E%0A\" );\n		width: 40px;\n		background-position: center center;\n		opacity: 1;\n		background-repeat: no-repeat;\n		color: transparent !important;\n		padding: 0;\n		min-height: auto;\n	}\n}\n\n.mw-adminbar-search__toggle {\n	& + .mw-adminbar-search__input {\n		display: none;\n	}\n\n	&:checked + .mw-adminbar-search__input {\n		display: block;\n	}\n}\n\n.mw-adminbar-search__input {\n	min-width: 150px;\n}\n";
var $ae91d1555267d922$var$AdminBarUserLESS = "// stylelint-disable function-url-quotes\n@height-adminbar: 32px;\n@bg-adminbar: #1d2327;\n\n// userAvatarOutline\n.mw-adminbar-icon-user:before {\n	background-image: url( \"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'%3E%3Ctitle%3E user avatar %3C/title%3E%3Cpath d='M10 8c1.7 0 3.06-1.35 3.06-3S11.7 2 10 2 6.94 3.35 6.94 5 8.3 8 10 8zm0 2c-2.8 0-5.06-2.24-5.06-5S7.2 0 10 0s5.06 2.24 5.06 5-2.26 5-5.06 5zm-7 8h14v-1.33c0-1.75-2.31-3.56-7-3.56s-7 1.81-7 3.56V18zm7-6.89c6.66 0 9 3.33 9 5.56V20H1v-3.33c0-2.23 2.34-5.56 9-5.56z'/%3E%3C/svg%3E%0A\" );\n}\n\n#pt-notifications-notice,\n#pt-talk-alert {\n	display: none;\n}\n\n.mw-adminbar-notifications li {\n	filter: invert( 1 );\n\n	// Some Wordpress themes override pseudo elements.\n	// e.g. twentytwenty\n	//  Don't let them!\n	a:before,\n	a:after {\n		word-break: normal;\n		word-wrap: normal;\n	}\n}\n\n#pt-notifications-alert {\n	padding-top: 5px;\n	width: 40px;\n	display: block;\n	height: 100%;\n	box-sizing: border-box;\n	margin: 0;\n	line-height: normal;\n\n	a {\n		// stylelint-disable-next-line declaration-no-important\n		height: 100% !important;\n		margin: auto !important;\n		opacity: 1 !important;\n		background-repeat: no-repeat;\n	}\n}\n\n#p-personal {\n	position: relative;\n	align-self: center;\n\n	input {\n		opacity: 0;\n		position: absolute;\n		width: 100%;\n		height: @height-adminbar;\n		z-index: 2;\n\n		~ .mw-portlet-body {\n			display: none;\n		}\n\n		&:checked ~ .mw-portlet-body {\n			display: block;\n		}\n	}\n\n	h3 {\n		margin: 0;\n		padding: 0;\n		width: @height-adminbar;\n		height: @height-adminbar;\n		text-indent: 999px;\n		overflow: hidden;\n		float: right;\n		cursor: pointer;\n\n		&:before {\n			content: '';\n			width: 100%;\n			height: @height-adminbar;\n			display: block;\n			background-repeat: no-repeat;\n			background-position: center;\n			filter: invert( 1 );\n		}\n	}\n\n	@arrow-size: 10px;\n	@arrow-size-2x: @arrow-size * 2;\n\n	ul {\n		position: absolute;\n		right: 0;\n		top: @arrow-size;\n		margin: @height-adminbar 0 0;\n		padding: 0 20px 20px;\n		list-style: none;\n		background: @bg-adminbar;\n		min-width: 150px;\n\n		&:before {\n			content: '';\n			display: block;\n			position: absolute;\n			top: -@arrow-size-2x;\n			right: @arrow-size / 2;\n			height: @arrow-size-2x;\n			width: @arrow-size-2x;\n			border-left: @arrow-size solid transparent;\n			border-right: @arrow-size solid transparent;\n			border-bottom: @arrow-size solid @bg-adminbar;\n		}\n	}\n\n	a {\n		color: #fff;\n	}\n}\n";
var $ae91d1555267d922$var$AdminBarLESS = "@height-adminbar: 32px;\n@bg-adminbar: #1d2327;\n\nhtml {\n	// stylelint-disable-next-line declaration-no-important\n	margin-top: 32px !important;\n}\n\n.mw-adminbar {\n	direction: ltr;\n	color: #c3c4c7;\n	// stylelint-disable-next-line declaration-property-unit-disallowed-list\n	font-size: 13px;\n	font-weight: bold;\n	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen-Sans', 'Ubuntu', 'Cantarell', 'Helvetica Neue', sans-serif;\n	line-height: 2.46153846;\n	height: @height-adminbar;\n	position: fixed;\n	top: 0;\n	left: 0;\n	width: 100%;\n	min-width: 600px;\n	z-index: 99999;\n	display: flex;\n	background: @bg-adminbar;\n	align-items: center;\n\n	ul {\n		margin: 0;\n		padding: 0;\n	}\n\n	li {\n		display: block;\n	}\n\n	input {\n		opacity: 0;\n	}\n\n	li:hover,\n	input:hover ~ h3 {\n		cursor: pointer;\n		background-color: #333;\n	}\n\n	.mw-edit-bar {\n		background-color: transparent;\n	}\n}\n\n.mw-adminbar-start {\n	display: flex;\n	flex-grow: 1;\n	margin-left: 8px;\n	overflow: hidden;\n}\n\n.mw-adminbar-end {\n	display: flex;\n	justify-content: flex-end;\n	height: 100%;\n	padding-right: 50px;\n\n	> a {\n		display: block;\n		width: 40px;\n		overflow: hidden;\n\n		&:before {\n			content: '';\n			height: 100%;\n			display: block;\n			background-repeat: no-repeat;\n			filter: invert( 1 );\n			background-size: 20px 20px;\n			background-position: center;\n		}\n	}\n}\n\n.mw-adminbar-start li,\n.mw-adminbar-ns li,\n.mw-adminbar-views li {\n	width: 40px;\n	filter: invert( 0 );\n	background-repeat: no-repeat;\n	height: 100%;\n	background-position: center;\n	margin: 0;\n\n	a {\n		color: transparent;\n	}\n}\n\n.mw-adminbar-start ul,\n.mw-adminbar-views,\n.mw-adminbar-ns {\n	height: 32px;\n	margin: 0;\n	padding: 0;\n	display: flex;\n\n	li {\n		width: 40px;\n		height: 100%;\n		overflow: hidden;\n		margin-right: 4px;\n		display: inline-block;\n\n		a {\n			position: absolute;\n			top: 0;\n			bottom: 0;\n		}\n	}\n}\n";
var $ae91d1555267d922$var$EditBarLESS = "// Icons from https://doc.wikimedia.org/oojs-ui/master/demos/?page=icons&theme=wikimediaui&direction=ltr&platform=desktop\n// Converted to data uri using https://yoksel.github.io/url-encoder/\n// stylelint-disable function-url-quotes\n\n.mw-edit-bar {\n	list-style: none;\n	margin: 20px 0 0;\n	background: transparent;\n	display: flex;\n	padding: 10px;\n	align-items: center;\n	background-color: #777;\n\n	li {\n		width: 40px;\n		height: 100%;\n		background-repeat: no-repeat;\n		background-position: center;\n\n		a {\n			// stylelint-disable-next-line declaration-no-important\n			color: transparent !important;\n		}\n	}\n\n	#ca-viewsource {\n		background-image: url( \"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'%3E%3Ctitle%3E edit lock %3C/title%3E%3Cpath fill='white' d='M12 12a2 2 0 01-2-2V5.25l-9 9V19h4.75l7-7zm7-8h-.5V2.5a2.5 2.5 0 00-5 0V4H13a1 1 0 00-1 1v4a1 1 0 001 1h6a1 1 0 001-1V5a1 1 0 00-1-1zm-3 4a1 1 0 111-1 1 1 0 01-1 1zm1.5-4h-3V2.75C14.5 2 14.5 1 16 1s1.5 1 1.5 1.75z'/%3E%3C/svg%3E%0A\" );\n	}\n\n	#ca-edit {\n		background-image: url( \"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' %3E%3Ctitle%3E edit %3C/title%3E%3Cpath fill='white' d='M16.77 8l1.94-2a1 1 0 000-1.41l-3.34-3.3a1 1 0 00-1.41 0L12 3.23zM1 14.25V19h4.75l9.96-9.96-4.75-4.75z'/%3E%3C/svg%3E%0A\" );\n	}\n\n	#ca-talk {\n		background-image: url( \"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='%23fff'%3E%3Ctitle%3E speech bubble %3C/title%3E%3Cpath d='M6 14H0v6z'/%3E%3Crect width='20' height='16' rx='2'/%3E%3C/svg%3E%0A\" );\n		background-size: 15px;\n	}\n\n	#ca-history {\n		background-image: url( \"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='white'%3E%3Ctitle%3E history %3C/title%3E%3Cpath d='M9 6v5h.06l2.48 2.47 1.41-1.41L11 10.11V6z'/%3E%3Cpath d='M10 1a9 9 0 00-7.85 13.35L.5 16H6v-5.5l-2.38 2.38A7 7 0 1110 17v2a9 9 0 000-18z'/%3E%3C/svg%3E%0A\" );\n	}\n\n	#ca-nstab-main,\n	#ca-nstab-help,\n	#ca-ve-edit,\n	#ca-view {\n		display: none;\n	}\n}\n";
var $ae91d1555267d922$var$PersonalMenuLESS = ".mw-portlet-personal {\n	margin: 0 0 0 12px;\n	padding: 10px 12px 10px 0;\n	height: 20px;\n	width: 20px;\n}\n\n.mw-portlet-personal.mw-portlet {\n	h3 {\n		background-image: url( data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAx0lEQVQ4jdXSzQmEQAwFYEuYUixhSwgkA8mQgKXYgS3YgXZgCZagHWgHuxf14t8osssGcv145CVJvjk+hBRFK2TrkK1D0cqHkN7CUBRI7L21KAqXMIDModiwD9oAkLlH0i3L+ooGiTWPAPPfJQTIHLGOB9h46YZnKS+3PI8PISW2GkV7FO2Jrb79h4+ODyElsYJYm437NSRWRCWdylgj++U0u+UAZI5E22hsWW03UWQtr2NT66zlCjz8uzNQbFiDN7F5/xB8aj57Ynp2FKI0bAAAAABJRU5ErkJggg== );\n		text-indent: -999px;\n		background-repeat: no-repeat;\n		height: 100%;\n		width: 40px;\n		margin: 0;\n		padding: 0;\n		background-position: center center;\n		overflow: hidden;\n		display: flex;\n		filter: @icon-filter;\n	}\n\n	li {\n		display: block;\n	}\n}\n";
var $ae91d1555267d922$var$ContentLESS = ".content {\n	&__header {\n		position: relative;\n	}\n\n	&__heading {\n		padding: 0 50px 0 0;\n		margin: 0;\n		border-bottom: 0;\n		float: left;\n	}\n\n	&__language-btn {\n		float: right;\n		align-items: center;\n	}\n\n	&__indicators {\n		position: absolute;\n		top: 10px;\n		right: 0;\n	}\n\n	&__tagline {\n		clear: both;\n		color: @color-base;\n		font-size: 0.85em;\n		margin-bottom: 12px;\n		line-height: 1;\n\n		&:empty {\n			display: none;\n		}\n	}\n\n	&__actions {\n		display: flex;\n	}\n\n	/* The following rules will not be needed in future */\n	.mw-editsection {\n		font-size: 0.85em;\n		margin-left: 8px;\n	}\n\n	.thumbimage {\n		background: transparent;\n		border: 0;\n	}\n\n	.toc,\n	div.thumbinner {\n		border-color: @color-gray;\n		background-color: @background-color-thumb;\n		color: @color-thumb;\n\n		.toctogglelabel,\n		a {\n			color: @color-thumb;\n		}\n	}\n}\n";
var $ae91d1555267d922$var$ContentActionsLESS = ".mw-portlet-views {\n	flex-grow: 1;\n\n	ul {\n		display: flex;\n		height: 3em;\n		justify-content: space-between;\n	}\n}\n\n.mw-portlet-cactions h3,\n.mw-portlet-views li {\n	display: flex;\n	justify-content: flex-end;\n	align-items: center;\n	min-width: 0;\n	overflow: hidden;\n	flex-basis: auto;\n	font-weight: normal;\n	font-size: 100%;\n	padding: 0;\n\n	&first-child {\n		justify-content: flex-start;\n	}\n\n	&:hover {\n		background-color: rgba( 0, 0, 0, 0.03 );\n	}\n}\n\n// stylelint-disable-next-line no-descending-specificity\n.mw-portlet-cactions h3,\n.mw-portlet-cactions li a,\n.mw-portlet-views li a {\n	color: @color-base;\n	text-decoration: none;\n}\n\n#ca-view {\n	display: none;\n}\n\n.mw-portlet-cactions.mw-portlet {\n	margin-left: 40px;\n\n	h3 {\n		display: flex;\n		height: 3em;\n	}\n}\n";
var $ae91d1555267d922$var$DropdownLESS = "/* Checkbox hack dropdown */\n.mw-portlet-dropdown ~ .mw-portlet {\n	li {\n		display: block;\n		padding: 0.75em 0.875em;\n	}\n\n	.mw-portlet-body {\n		display: none;\n\n		ul {\n			background: @background-color-article;\n			position: absolute;\n			overflow-y: auto;\n			z-index: 2;\n			box-shadow: 0 5px 17px 0 rgba( 0, 0, 0, 0.24 ), 0 0 1px @color-gray;\n			right: 0;\n			min-width: 200px;\n		}\n	}\n\n	input:checked {\n		~ .mw-portlet-body ul {\n			opacity: 1;\n			visibility: visible;\n		}\n\n		~ .mw-portlet-body {\n			display: block;\n			opacity: 1;\n		}\n	}\n}\n";
var $ae91d1555267d922$var$HeaderLESS = ".mw-header {\n	min-height: 50px;\n	margin: 0 10px 8px;\n	padding: 1em 0 1em 50px;\n	display: flex;\n	flex-wrap: wrap;\n	align-items: center;\n	position: relative;\n	z-index: 3;\n\n	@media ( max-width: @max-width-breakpoint-tablet ) {\n		padding: 1em 8px;\n		margin: 0;\n	}\n}\n";
var $ae91d1555267d922$var$CategoryPlainLESS = ".mw-skin-category-plain {\n	ul {\n		margin: 0;\n	}\n\n	ul,\n	li {\n		display: inline;\n		margin-right: 8px;\n	}\n\n	.mw-hidden-cats-hidden {\n		display: none;\n	}\n}\n";
var $ae91d1555267d922$var$CategoryLinksLESS = ".skin-category-links a:after {\n	content: ',';\n}\n\n.skin-category-list a:last-child:after {\n	content: none;\n}\n";
var $ae91d1555267d922$var$ContentNamespacesLESS = ".mw-portlet-namespaces {\n	margin-top: 10px;\n	border-bottom: 1px solid @color-gray-2;\n\n	a {\n		font-size: 0.85em;\n		margin: 0 10px 0 0;\n		color: @color-base;\n		font-weight: bold;\n		padding-bottom: 6px;\n		display: inline-block;\n	}\n\n	li.selected {\n		border-bottom: 2px solid @color-base;\n		margin-bottom: -1px;\n	}\n}\n";
var $ae91d1555267d922$var$LanguagesLESS = ".skin-languages {\n\n	#p-lang-label {\n		display: block;\n	}\n}\n";
var $ae91d1555267d922$var$PortletLESS = ".mw-portlet {\n	position: relative;\n\n	ul {\n		margin: 0;\n	}\n\n	h3 {\n		display: none;\n	}\n\n	li {\n		display: inline-block;\n		margin-right: 10px;\n	}\n\n	input[ type='checkbox' ] {\n		display: block;\n		position: absolute;\n		opacity: 0;\n		cursor: pointer;\n		top: 0;\n		left: 0;\n		z-index: @z-index-stacking-1;\n		width: 100%;\n		height: 100%;\n		margin: 0;\n		padding: 0;\n	}\n}\n";
var $ae91d1555267d922$var$NotificationsLESS = "/* stylelint-disable declaration-no-important */\n.mw-portlet-notifications {\n	input[ type='checkbox' ] {\n		display: none;\n	}\n\n	li {\n		width: 20px;\n		height: 20px;\n\n		@media ( max-width: @max-width-breakpoint-tablet ) {\n			width: 100%;\n			height: 40px;\n		}\n	}\n\n	#pt-notifications-alert {\n		margin-right: 20px;\n\n		@media ( max-width: @max-width-breakpoint-tablet ) {\n			margin-right: 0;\n		}\n	}\n\n	@media ( max-width: @max-width-breakpoint-tablet ) {\n		margin-top: 0;\n		width: 40px;\n		height: 40px;\n		position: relative;\n\n		* {\n			width: 100%;\n			height: 100%;\n		}\n\n		#pt-notifications-notice {\n			display: none;\n		}\n	}\n\n	a {\n		background-repeat: no-repeat;\n		color: transparent;\n		background-position: center center;\n		width: 100% !important;\n		height: 100% !important;\n		display: block;\n	}\n}\n\n#pt-talk-alert {\n	display: none;\n}\n";
var $ae91d1555267d922$var$SidebarLESS = ".toggle-list__list {\n	position: fixed;\n	left: 0;\n	top: 0;\n	min-width: 70%;\n	max-width: 320px;\n	bottom: 0;\n	background: #fff;\n	z-index: 4;\n	display: none;\n\n	h3 {\n		display: none;\n	}\n\n	a {\n		display: block;\n	}\n\n	.mw-portlet-body li {\n		display: block;\n		padding: 8px;\n	}\n}\n\n.toggle-list__checkbox:checked ~ .toggle-list__list {\n	display: block;\n}\n\n/* Icons */\n.sidebar__icon {\n	cursor: pointer;\n	width: 20px;\n	height: 20px;\n	position: absolute;\n	top: 40px;\n	overflow: hidden;\n	color: transparent;\n	left: 20px;\n	z-index: 3;\n	filter: @icon-filter;\n}\n\n.sidebar__icon::before {\n	content: '';\n	width: 20px;\n	display: block;\n	height: 20px;\n	// stylelint-disable-next-line function-url-quotes\n	background-image: url( 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2220%22 height=%2220%22 viewBox=%220 0 20 20%22%3E %3Ctitle%3E menu %3C/title%3E %3Cpath d=%22M1 3v2h18V3zm0 8h18V9H1zm0 6h18v-2H1z%22/%3E %3C/svg%3E' );\n}\n\n/* checkbox hack */\n.toggle-list__checkbox {\n	position: absolute;\n	z-index: -1;\n	opacity: 0;\n}\n\n.toggle-list__checkbox ~ .toggle-list__mask {\n	position: fixed;\n	top: 0;\n	left: 0;\n	right: 0;\n	opacity: 0;\n	bottom: 0;\n	background: rgba( 0, 0, 0, 0.8 );\n	z-index: 3;\n	visibility: hidden;\n}\n\n.toggle-list__checkbox:checked ~ .toggle-list__mask {\n	visibility: visible;\n	opacity: 1;\n}\n";
var $ae91d1555267d922$var$FooterLESS = ".mw-footer {\n	border-top: solid 20px @background-color-base;\n	padding: 20px 0;\n\n	> div,\n	> ul {\n		margin: 1em;\n\n		ul {\n			margin: 0;\n		}\n	}\n\n	li {\n		display: inline-block;\n		margin-right: 20px;\n	}\n}\n";
var $ae91d1555267d922$var$LogoLESS = "/* stylelint-disable unit-disallowed-list */\n#p-logo {\n	min-height: 70px;\n	flex-grow: 1;\n\n	h1 {\n		font-size: 1rem;\n		margin: 0;\n		border: 0;\n		padding: 0 0 0 10px;\n	}\n\n	img {\n		max-width: none;\n	}\n\n	a {\n		display: flex;\n		align-content: center;\n		height: 70px;\n		align-items: center;\n	}\n\n	@media ( max-width: @max-width-breakpoint-tablet ) {\n		min-width: 170px;\n		max-width: none;\n		font-size: 0.75em;\n\n		.icon {\n			display: none;\n		}\n	}\n}\n";
var $ae91d1555267d922$var$LanguageButtonLESS = ".language-button {\n	position: relative;\n	display: inline-block;\n\n	input {\n		width: 100%;\n		position: absolute;\n		height: 100%;\n		opacity: 0;\n	}\n}\n\n.language-button-dropdown {\n	display: none;\n}\n";
var $ae91d1555267d922$var$SearchLESS = "#p-search {\n	width: 100%;\n	padding: 0 8px;\n\n	#searchInput {\n		background-image: url( data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%3E%3Ctitle%3Esearch%3C%2Ftitle%3E%3Cg%20fill%3D%22%2354595d%22%3E%3Cpath%20d%3D%22M7.5%2013a5.5%205.5%200%20100-11%205.5%205.5%200%20000%2011zm4.55.46A7.43%207.43%200%20017.5%2015a7.5%207.5%200%20115.96-2.95l6.49%206.49-1.41%201.41-6.49-6.49z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E );\n		background-color: #fff;\n		-webkit-appearance: none;\n		max-width: 450px;\n		margin-top: 0;\n		height: 2.25em;\n		border: solid 1px @color-gray-2;\n		border-radius: 2px;\n		padding: 7px 0 7px 29px;\n		box-shadow: 0 1px 1px rgba( 0, 0, 0, 0.05 );\n		outline: 0;\n		background-position: left 6px center;\n		background-repeat: no-repeat;\n		background-size: 18px;\n\n		@media ( max-width: @max-width-breakpoint-tablet ) {\n			width: 100%;\n		}\n	}\n\n	#searchButton {\n		.client-js & {\n			display: none;\n		}\n	}\n\n	h3 {\n		display: none;\n	}\n}\n";
var $ae91d1555267d922$var$TableOfContentsLESS = "#toc-sticky {\n	position: fixed;\n	padding: 8px;\n	top: 0;\n	right: 0;\n	display: none;\n	width: 300px;\n	height: 50vh;\n	overflow: hidden;\n	flex-direction: column;\n\n	> div {\n		overflow: scroll;\n	}\n\n	h1 {\n		text-transform: uppercase;\n		height: 50px;\n		font-size: 1em;\n		cursor: pointer;\n		background: @background-color-article;\n		text-align: center;\n		padding: 10px;\n		margin: 0;\n	}\n\n	input {\n		position: absolute;\n		left: 0;\n		top: 0;\n		width: 100%;\n		height: 50px;\n		margin-top: 8px;\n		opacity: 0;\n	}\n\n	input ~ div {\n		display: none;\n	}\n\n	input:checked ~ div {\n		display: block;\n		background: @background-color-article;\n	}\n\n	@media ( min-width: @min-width-breakpoint-desktop ) {\n		display: flex;\n	}\n}\n";
var $ae91d1555267d922$var$normalize = "body{margin:0}main{display:block}hr{box-sizing:content-box;height:0;overflow:visible}abbr[title]{border-bottom:1px dotted;cursor:help}@supports (text-decoration:underline dotted){abbr[title]{border-bottom:0;text-decoration:underline dotted}}pre,code,tt,kbd,samp{font-family:monospace,monospace}sub,sup{line-height:1}img{border:0}button,input,optgroup,select,textarea{margin:0}button::-moz-focus-inner,[type='button']::-moz-focus-inner,[type='reset']::-moz-focus-inner,[type='submit']::-moz-focus-inner{border-style:none;padding:0}legend{color:inherit;padding:0}\n";
var $ae91d1555267d922$var$elements = "@media screen{a{text-decoration:none;color:#0645ad;background:none}a:not([href]){cursor:pointer}a:visited{color:#0b0080}a:active{color:#faa700}a:hover,a:focus{text-decoration:underline}a:lang(ar),a:lang(kk-arab),a:lang(mzn),a:lang(ps),a:lang(ur){text-decoration:none}img{border:0;vertical-align:middle}hr{height:1px;background-color:#a2a9b1;border:0;margin:0.2em 0}h1,h2,h3,h4,h5,h6{color:#000;margin:0;padding-top:0.5em;padding-bottom:0.17em;overflow:hidden}h1,h2{margin-bottom:0.6em;border-bottom:1px solid #a2a9b1}h3,h4,h5{margin-bottom:0.3em}h1{font-size:188%;font-weight:normal}h2{font-size:150%;font-weight:normal}h3{font-size:128%}h4{font-size:116%}h5{font-size:108%}h6{font-size:100%}p{margin:0.4em 0 0.5em 0}p img{margin:0}ul{margin:0.3em 0 0 1.6em;padding:0}ol{margin:0.3em 0 0 3.2em;padding:0;list-style-image:none}li{margin-bottom:0.1em}dt{font-weight:bold;margin-bottom:0.1em}dl{margin-top:0.2em;margin-bottom:0.5em}dd{margin-left:1.6em;margin-bottom:0.1em}pre,code,tt,kbd,samp,.mw-code{font-family:monospace,monospace}pre,code,.mw-code{background-color:#f8f9fa;color:#000;border:1px solid #eaecf0}code{border-radius:2px;padding:1px 4px}pre,.mw-code{padding:1em;white-space:pre-wrap;overflow-x:hidden;word-wrap:break-word}table{font-size:100%}fieldset{border:1px solid #2a4b8d;margin:1em 0 1em 0;padding:0 1em 1em}legend{padding:0.5em;font-size:95%}form{border:0;margin:0}textarea{display:block;-moz-box-sizing:border-box;box-sizing:border-box;width:100%;border:1px solid #c8ccd1;padding:0.1em}.center{width:100%;text-align:center}*.center *{margin-left:auto;margin-right:auto}.small{font-size:94%}table.small{font-size:100%}}@media print{.center{text-align:center}a{background:none !important;padding:0 !important}a,a.external,a.new,a.stub{color:inherit !important;text-decoration:inherit !important}dt{font-weight:bold}h1,h2,h3,h4,h5,h6{font-weight:bold;page-break-after:avoid;page-break-before:avoid}p{margin:1em 0;line-height:1.2;orphans:3;widows:3}img,figure{page-break-inside:avoid}img{border:0;vertical-align:middle}pre,.mw-code{background:#fff;color:#000;border:1pt dashed #000;padding:1em;font-size:8pt;white-space:pre-wrap;overflow-x:hidden;word-wrap:break-word}ul{list-style-type:square}}";
var $ae91d1555267d922$var$CONTENT_TABLES = "@media screen{.wikitable{background-color:#f8f9fa;color:#202122;margin:1em 0;border:1px solid #a2a9b1;border-collapse:collapse}.wikitable > tr > th,.wikitable > tr > td,.wikitable > * > tr > th,.wikitable > * > tr > td{border:1px solid #a2a9b1;padding:0.2em 0.4em}.wikitable > tr > th,.wikitable > * > tr > th{background-color:#eaecf0;text-align:center}.wikitable > caption{font-weight:bold}}@media print{.wikitable{background:#fff;margin:1em 0;border:1pt solid #aaa;border-collapse:collapse;font-size:10pt;page-break-inside:avoid}.wikitable > caption{padding:5px;font-size:10pt}.wikitable > tr > th,.wikitable > tr > td,.wikitable > * > tr > th,.wikitable > * > tr > td{background:#fff !important;color:#000 !important;border:1pt solid #aaa;padding:0.4em 0.6em}.wikitable > tr > th,.wikitable > * > tr > th{text-align:center}table.listing,table.listing td{border:1pt solid #000;border-collapse:collapse}}";
var $ae91d1555267d922$var$CONTENT_LINKS = "@media screen{a.stub{color:#723}a.new{color:#d33}a.mw-selflink{color:inherit;font-weight:bold;text-decoration:inherit}a.mw-selflink:hover{cursor:inherit;text-decoration:inherit}a.mw-selflink:active,a.mw-selflink:visited{color:inherit}a.new:visited{color:#a55858}.mw-parser-output a.extiw,.mw-parser-output a.external{color:#36b}.mw-parser-output a.extiw:visited,.mw-parser-output a.external:visited{color:#636}.mw-parser-output a.extiw:active,.mw-parser-output a.external:active{color:#b63}.mw-underline-always a{text-decoration:underline}.mw-underline-never a{text-decoration:none}.plainlinks a.external{background:none !important;padding:0 !important}.mw-parser-output a.external,.link-https{background-image:url(/w/resources/src/mediawiki.skinning/images/external-ltr.svg?59558);background-position:center right;background-repeat:no-repeat;padding-right:13px}.mw-parser-output a.external[href^='mailto:'],.link-mailto{background-image:url(/w/resources/src/mediawiki.skinning/images/mail.svg?8a79c);background-position:center right;background-repeat:no-repeat;padding-right:13px}.mw-parser-output a.external[href^='ftp://'],.link-ftp{background-image:url(/w/resources/src/mediawiki.skinning/images/ftp-ltr.svg?c5643);background-position:center right;background-repeat:no-repeat;padding-right:13px}.mw-parser-output a.external[href^='irc://'],.mw-parser-output a.external[href^='ircs://'],.link-irc{background-image:url(/w/resources/src/mediawiki.skinning/images/chat-ltr.svg?e0649);background-position:center right;background-repeat:no-repeat;padding-right:13px}.mw-parser-output a.external[href$='.ogg'],.mw-parser-output a.external[href$='.OGG'],.mw-parser-output a.external[href$='.mid'],.mw-parser-output a.external[href$='.MID'],.mw-parser-output a.external[href$='.midi'],.mw-parser-output a.external[href$='.MIDI'],.mw-parser-output a.external[href$='.mp3'],.mw-parser-output a.external[href$='.MP3'],.mw-parser-output a.external[href$='.wav'],.mw-parser-output a.external[href$='.WAV'],.mw-parser-output a.external[href$='.wma'],.mw-parser-output a.external[href$='.WMA'],.link-audio{background-image:url(/w/resources/src/mediawiki.skinning/images/audio-ltr.svg?74d04);background-position:center right;background-repeat:no-repeat;padding-right:13px}.mw-parser-output a.external[href$='.ogm'],.mw-parser-output a.external[href$='.OGM'],.mw-parser-output a.external[href$='.avi'],.mw-parser-output a.external[href$='.AVI'],.mw-parser-output a.external[href$='.mpeg'],.mw-parser-output a.external[href$='.MPEG'],.mw-parser-output a.external[href$='.mpg'],.mw-parser-output a.external[href$='.MPG'],.link-video{background-image:url(/w/resources/src/mediawiki.skinning/images/video.svg?a3758);background-position:center right;background-repeat:no-repeat;padding-right:13px}.mw-parser-output a.external[href$='.pdf'],.mw-parser-output a.external[href$='.PDF'],.mw-parser-output a.external[href*='.pdf#'],.mw-parser-output a.external[href*='.PDF#'],.mw-parser-output a.external[href*='.pdf?'],.mw-parser-output a.external[href*='.PDF?'],.link-document{background-image:url(/w/resources/src/mediawiki.skinning/images/document-ltr.svg?0bf90);background-position:center right;background-repeat:no-repeat;padding-right:13px}.mw-parser-output a.extiw,.mw-parser-output a.extiw:active{color:#36b}.mw-parser-output a.external{color:#36b}}";
var $ae91d1555267d922$var$CONTENT_MEDIA = "@media screen{div.tright,div.floatright,table.floatright{clear:right;float:right}div.tleft,div.floatleft,table.floatleft{float:left;clear:left}.mw-content-ltr .thumbcaption{text-align:left}.mw-content-ltr .magnify{float:right}.mw-content-rtl .thumbcaption{text-align:right}.mw-content-rtl .magnify{float:left}div.floatright,table.floatright{margin:0 0 0.5em 0.5em}div.floatleft,table.floatleft{margin:0 0.5em 0.5em 0}div.thumb{margin-bottom:0.5em;width:auto;background-color:transparent}div.thumbinner{border:1px solid #c8ccd1;padding:3px;background-color:#f8f9fa;font-size:94%;text-align:center;overflow:hidden}.thumbimage{background-color:#ffffff;border:1px solid #c8ccd1}.thumbcaption{border:0;line-height:1.4em;padding:3px;font-size:94%;text-align:left}.magnify{float:right;margin-left:3px}.magnify a{display:block;text-indent:15px;white-space:nowrap;overflow:hidden;width:15px;height:11px;background-image:url(/w/resources/src/mediawiki.skinning/images/magnify-clip-ltr.svg?8330e);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.thumbborder{border:1px solid #eaecf0}.mw-content-ltr .magnify{margin-left:3px;margin-right:0}.mw-content-ltr .magnify a{background-image:url(/w/resources/src/mediawiki.skinning/images/magnify-clip-ltr.svg?8330e)}.mw-content-rtl .magnify{margin-left:0;margin-right:3px}.mw-content-rtl .magnify a{background-image:url(/w/resources/src/mediawiki.skinning/images/magnify-clip-rtl.svg?38fd5)}div.tright{margin:0.5em 0 1.3em 1.4em}div.tleft{margin:0.5em 1.4em 1.3em 0}}@media print{table.floatright,div.floatright,div.tright{float:right;clear:right}table.floatleft,div.floatleft,div.tleft{float:left;clear:left}div.tleft{margin:0.5em 1.4em 1.3em 0}div.tright{margin:0.5em 0 1.3em 1.4em}table.floatright,div.floatright{margin:0 0 0.5em 0.5em;border:0}table.floatleft,div.floatleft{margin:0 0.5em 0.5em 0;border:0}div.thumb{background-color:transparent;width:auto}div.thumb a{border-bottom:0}div.thumbinner{background-color:#fff;border:0;border-radius:2px;padding:5px;font-size:10pt;color:#666;text-align:center;overflow:hidden;min-width:100px}.thumbcaption{text-align:left;line-height:1.4;padding:3px}.thumbborder{border:1pt solid #ddd}.thumb{page-break-inside:avoid}.magnify{display:none}}";
var $ae91d1555267d922$var$INTERFACE_MESSAGE_BOX = ".messagebox,.errorbox,.warningbox,.successbox{color:#000;-moz-box-sizing:border-box;box-sizing:border-box;margin-bottom:16px;border:1px solid;padding:12px 24px;word-wrap:break-word;overflow-wrap:break-word;overflow:hidden}.messagebox :only-child,.errorbox :only-child,.warningbox :only-child,.successbox :only-child{margin:0}.messagebox h2,.errorbox h2,.warningbox h2,.successbox h2{color:inherit;display:inline;margin:0 0.5em 0 0;border:0;font-size:1em;font-weight:bold}.messagebox .mw-logevent-loglines li,.errorbox .mw-logevent-loglines li,.warningbox .mw-logevent-loglines li,.successbox .mw-logevent-loglines li{font-size:90%}.messagebox{background-color:#eaecf0;border-color:#a2a9b1}.errorbox{background-color:#fee7e6;border-color:#d33}.warningbox{background-color:#fef6e7;border-color:#fc3}.successbox{background-color:#d5fdf4;border-color:#14866d}\n";
var $ae91d1555267d922$var$INTERFACE_CATEGORY = "@media screen{#catlinks{text-align:left}.catlinks{border:1px solid #a2a9b1;background-color:#f8f9fa;padding:5px;margin-top:1em;clear:both}.catlinks ul{display:inline;margin:0;padding:0;list-style:none}.catlinks li{display:inline-block;line-height:1.25em;border-left:1px solid #a2a9b1;margin:0.125em 0;padding:0 0.5em}.catlinks li:first-child{padding-left:0.25em;border-left:0}.catlinks li a.mw-redirect{font-style:italic}.mw-hidden-cats-hidden,.catlinks-allhidden{display:none}}@media print{.catlinks ul{display:inline;padding:0;list-style:none}.catlinks li{display:inline-block;line-height:1.15;margin:0.1em 0;border-left:1pt solid #aaa;padding:0 0.4em}.catlinks li:first-child{border-left:0;padding-left:0.2em}.mw-hidden-catlinks,.catlinks{display:none}}\n";
var $ae91d1555267d922$var$INTERFACE_TOC = ".toctogglecheckbox:checked ~ ul{display:none}@media screen{.toc,.toccolours{border:1px solid #a2a9b1;background-color:#f8f9fa;padding:5px;font-size:95%}.toc{display:table;padding:7px}.toc h2{display:inline;border:0;padding:0;font-size:100%;font-weight:bold}.toc .toctitle{text-align:center}.toc ul{list-style:none;margin:0.3em 0;padding:0;text-align:left}.toc ul ul{margin:0 0 0 2em}table.toc{border-collapse:collapse}table.toc td{padding:0}.tocnumber,.toctext{display:table-cell;text-decoration:inherit}.tocnumber{color:#202122;padding-left:0;padding-right:0.5em}.mw-content-ltr .tocnumber{padding-left:0;padding-right:0.5em}.mw-content-rtl .tocnumber{padding-left:0.5em;padding-right:0}.toctogglecheckbox{display:inline !important;position:absolute;opacity:0;z-index:-1}.toctogglespan{font-size:94%}.toctogglespan:before{content:' ['}.toctogglespan:after{content:']'}.toctogglelabel{cursor:pointer;color:#0645ad}.toctogglelabel:hover{text-decoration:underline}.toctogglecheckbox:focus + .toctitle .toctogglelabel{text-decoration:underline;outline:dotted 1px;outline:auto -webkit-focus-ring-color}.toctogglecheckbox:checked + .toctitle .toctogglelabel:after{content:'(showtoc)'}.toctogglecheckbox:not(:checked) + .toctitle .toctogglelabel:after{content:'(hidetoc)'}.toc .toctitle{direction:ltr}.mw-content-ltr .toc ul,.mw-content-rtl .mw-content-ltr .toc ul{text-align:left}.mw-content-rtl .toc ul,.mw-content-ltr .mw-content-rtl .toc ul{text-align:right}.mw-content-ltr .toc ul ul,.mw-content-rtl .mw-content-ltr .toc ul ul{margin:0 0 0 2em}.mw-content-rtl .toc ul ul,.mw-content-ltr .mw-content-rtl .toc ul ul{margin:0 2em 0 0}}@media print{.toctogglecheckbox:checked + .toctitle{display:none}.toc{background-color:#f9f9f9;border:1pt solid #aaa;padding:5px;display:table}.tocnumber,.toctext{display:table-cell}.tocnumber{padding-left:0;padding-right:0.5em}.mw-content-ltr .tocnumber{padding-left:0;padding-right:0.5em}.mw-content-rtl .tocnumber{padding-left:0.5em;padding-right:0}}\n";
function $ae91d1555267d922$var$aliasFileName(folderName) {
    return `${folderName}.alias.php`;
}
function $ae91d1555267d922$var$makeServiceWiring(folderName) {
    return `<?php
use MediaWiki\\MediaWikiServices;

return [
	'${folderName}.Config' => static function ( MediaWikiServices $services ) {
		return $services->getService( 'ConfigFactory' )
				->makeConfig( ${folderName.toLowerCase()} );
	},
];
`;
}
function $ae91d1555267d922$var$makeAliasFile(folderName, specialPages) {
    const aliases = {};
    specialPages.forEach((name)=>{
        aliases[name] = [
            name
        ];
    });
    return `<?php
/**
 * Aliases for ${folderName} extension
 *
 * @file
 * @ingroup Extensions
 */

$specialPageAliases = [];

/** English (English) */
$specialPageAliases['en'] = [
	${Object.keys(aliases).map((specialName)=>{
        return `'${specialName}' => ${JSON.stringify(aliases[specialName])},`;
    }).join("\n")}
];
`;
}
function $ae91d1555267d922$var$capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function $ae91d1555267d922$var$getHookMethod(hookName) {
    return `on${$ae91d1555267d922$var$capitalize(hookName)}`;
}
/**
 * @param {string} camelCaseName
 * @param {Object} hooks
 * @return {Object}
 */ function $ae91d1555267d922$var$generateHooksDefinition(camelCaseName, hooks) {
    const Hooks = {};
    const namespace = `${camelCaseName}\\`;
    Object.keys(hooks).forEach((hookName)=>{
        Hooks[hookName] = `${namespace}Hooks::${$ae91d1555267d922$var$getHookMethod(hookName)}`;
    });
    return Hooks;
}
function $ae91d1555267d922$var$extjson(folderName, options) {
    const extensionKey = $ae91d1555267d922$var$getSkinKeyFromName(folderName);
    const Hooks = $ae91d1555267d922$var$generateHooksDefinition(folderName, options.hooks || {});
    return $ae91d1555267d922$var$stringifyjson({
        name: folderName,
        author: [],
        url: `https://www.mediawiki.org/wiki/Extension:${folderName}`,
        descriptionmsg: `${extensionKey}-desc`,
        "license-name": options.license || "GPL-2.0-or-later",
        requires: {
            MediaWiki: ">= 1.38.0"
        },
        ConfigRegistry: {
            [extensionKey]: "GlobalVarConfig::newInstance"
        },
        SpecialPages: {
        },
        APIModules: {
        },
        MessagesDirs: {
            [extensionKey]: [
                "i18n"
            ]
        },
        ExtensionMessagesFiles: {
            [`${folderName}Alias`]: `${$ae91d1555267d922$var$aliasFileName(folderName)}`
        },
        AutoloadNamespaces: {
            [`${folderName}\\`]: "includes/"
        },
        ResourceModules: {},
        ResourceFileModulePaths: {
            localBasePath: "",
            remoteExtPath: `${folderName}`
        },
        Hooks: Hooks,
        config: {},
        DefaultUserOptions: {},
        ServiceWiringFiles: [
            "includes/ServiceWiring.php"
        ],
        // eslint-disable-next-line camelcase
        manifest_version: 2
    });
}
function $ae91d1555267d922$var$addi18n(rootfolder, name) {
    const i18nfolder = rootfolder.folder("i18n");
    const en = {
        [`${name.toLowerCase()}-desc`]: "A new extension."
    };
    const qqq = {};
    i18nfolder.file("en.json", $ae91d1555267d922$var$stringifyjson(en));
    i18nfolder.file("qqq.json", $ae91d1555267d922$var$stringifyjson(qqq));
}
/**
 * @param {string} name of namespace
 * @param {Object} hooks where key is hook name and that maps
 *  to boolean (generated method body) OR string (predefined message body)
 * @return {string}
 */ function $ae91d1555267d922$var$makeHooksFile(name, hooks) {
    /* eslint-disable no-tabs */ const predefined = {
        SkinAfterPortlet: `	/**
	* @see https://www.mediawiki.org/wiki/Manual:Hooks/SkinAfterPortlet
	* @param Skin $skin
	* @param string $portlet
	* @param string $html
	*/
	public static function ${$ae91d1555267d922$var$getHookMethod("SkinAfterPortlet")}( $skin, $portlet, &$html ) {
		// Code goes here.
		$html .= '${name} custom HTML for ' . $portlet;
	}`
    };
    /* eslint-enable no-tabs */ const methods = Object.keys(hooks).map((key)=>{
        const body = hooks[key];
        if (typeof body === "boolean") // eslint-disable-next-line no-tabs
        return predefined[body] || `	public static function ${$ae91d1555267d922$var$getHookMethod(key)}() {}`;
        else {
            const method = body();
            // eslint-disable-next-line no-tabs
            return `	/**
	* @see https://www.mediawiki.org/wiki/Manual:Hooks/${key}
	*/
	public static function ${$ae91d1555267d922$var$getHookMethod(key)}( ${method.args.join(", ")}) {
		${method.body}
	}`;
        }
    });
    return `<?php
namespace ${name};

class Hooks {
${methods}
}`;
}
/**
 *
 * @param {string} name
 * @param {Object} options
 * @param {string} options.license name of license
 * @param {Object} options.hooks to register. Keys are valid hooks. Values
 *   are booleans about whether they are enabled.
 * @return {Promise}
 */ function $ae91d1555267d922$var$buildExtension(name, options = {}) {
    const Zipper = options.Zipper || $ae91d1555267d922$var$lib;
    const myFileSaver = options.FileSaver || $ae91d1555267d922$var$FileSaver;
    const zip = new Zipper();
    const folderName = $ae91d1555267d922$var$getFolderNameFromName(name);
    const rootfolder = zip.folder(folderName);
    rootfolder.file("extension.json", $ae91d1555267d922$var$extjson(folderName, options));
    $ae91d1555267d922$var$addi18n(rootfolder, name);
    $ae91d1555267d922$var$addDevTools(name, rootfolder);
    /* const resourcesFolder = */ rootfolder.folder("resources");
    const includesFolder = rootfolder.folder("includes");
    rootfolder.file($ae91d1555267d922$var$aliasFileName(name), $ae91d1555267d922$var$makeAliasFile(name, []));
    includesFolder.file("ServiceWiring.php", $ae91d1555267d922$var$makeServiceWiring(name));
    if (options.hooks) includesFolder.file("Hooks.php", $ae91d1555267d922$var$makeHooksFile(name, options.hooks));
    return zip.generateAsync({
        type: "blob"
    }).then((content)=>{
        const saver = myFileSaver();
        return saver(content, `${folderName}.zip`);
    }).then((saveResult)=>{
        return {
            zip: zip,
            saveResult: saveResult
        };
    });
}
const $ae91d1555267d922$var$COMPONENT_STYLES = {
    AdminBarHome: $ae91d1555267d922$var$AdminBarHomeLESS,
    AdminBarUser: $ae91d1555267d922$var$AdminBarUserLESS,
    AdminBarWithEdit: $ae91d1555267d922$var$AdminBarLESS,
    AdminBar: $ae91d1555267d922$var$AdminBarLESS,
    CategoryLinks: $ae91d1555267d922$var$CategoryLinksLESS,
    CategoryPlain: $ae91d1555267d922$var$CategoryPlainLESS,
    Content: $ae91d1555267d922$var$ContentLESS,
    EditBar: $ae91d1555267d922$var$EditBarLESS,
    PersonalMenu: $ae91d1555267d922$var$PersonalMenuLESS,
    ContentActions: $ae91d1555267d922$var$ContentActionsLESS,
    Dropdown: $ae91d1555267d922$var$DropdownLESS,
    Header: $ae91d1555267d922$var$HeaderLESS,
    Language: $ae91d1555267d922$var$LanguagesLESS,
    ContentNamespaces: $ae91d1555267d922$var$ContentNamespacesLESS,
    Portlet: $ae91d1555267d922$var$PortletLESS,
    Notifications: $ae91d1555267d922$var$NotificationsLESS,
    Sidebar: $ae91d1555267d922$var$SidebarLESS,
    Footer: $ae91d1555267d922$var$FooterLESS,
    Logo: $ae91d1555267d922$var$LogoLESS,
    Search: $ae91d1555267d922$var$SearchLESS,
    TableOfContents: $ae91d1555267d922$var$TableOfContentsLESS,
    LanguageButton: $ae91d1555267d922$var$LanguageButtonLESS
};
const $ae91d1555267d922$var$FEATURE_STYLES = {
    normalize: $ae91d1555267d922$var$normalize,
    elements: $ae91d1555267d922$var$elements,
    "content-tables": $ae91d1555267d922$var$CONTENT_TABLES,
    "content-links": $ae91d1555267d922$var$CONTENT_LINKS,
    "content-media": $ae91d1555267d922$var$CONTENT_MEDIA,
    "interface-message-box": $ae91d1555267d922$var$INTERFACE_MESSAGE_BOX,
    "interface-category": $ae91d1555267d922$var$INTERFACE_CATEGORY,
    toc: $ae91d1555267d922$var$INTERFACE_TOC
};
const $ae91d1555267d922$var$PARTIALS = {
    // eslint-disable-next-line camelcase
    TableOfContents__line: $ae91d1555267d922$var$TableOfContentsLine,
    TableOfContents: $ae91d1555267d922$var$TableOfContents,
    CategoryPlain: $ae91d1555267d922$var$CategoryPlain,
    CategoryLinks: $ae91d1555267d922$var$CategoryLinks,
    EditBar: $ae91d1555267d922$var$EditBar,
    LanguageButton: $ae91d1555267d922$var$LanguageButton,
    ListItem: $ae91d1555267d922$var$ListItem,
    ListItemLink: $ae91d1555267d922$var$ListItemLink,
    CategoryPortlet: $ae91d1555267d922$var$CategoryPortlet,
    AdminBar: $ae91d1555267d922$var$AdminBar,
    AdminBarWithEdit: $ae91d1555267d922$var$AdminBarWithEdit,
    AdminBarUser: $ae91d1555267d922$var$AdminBarUser,
    AdminBarHome: $ae91d1555267d922$var$AdminBarHome,
    CompactFooter: $ae91d1555267d922$var$CompactFooter,
    Languages: $ae91d1555267d922$var$Languages,
    LastModifiedLine: $ae91d1555267d922$var$LastModifiedLine,
    CopyrightLine: $ae91d1555267d922$var$CopyrightLine,
    Dropdown: $ae91d1555267d922$var$Dropdown,
    Notifications: $ae91d1555267d922$var$Notifications,
    PersonalMenu: $ae91d1555267d922$var$PersonalMenu,
    Header: $ae91d1555267d922$var$Header,
    Content: $ae91d1555267d922$var$Content,
    Footer: $ae91d1555267d922$var$Footer,
    Logo: $ae91d1555267d922$var$Logo,
    Search: $ae91d1555267d922$var$Search,
    Sidebar: $ae91d1555267d922$var$Sidebar,
    FooterList: $ae91d1555267d922$var$FooterList,
    ContentHeading: $ae91d1555267d922$var$ContentHeading,
    ContentActions: $ae91d1555267d922$var$ContentActions,
    ContentNamespaces: $ae91d1555267d922$var$ContentNamespaces,
    ContentTagline: $ae91d1555267d922$var$ContentTagline,
    ContentBody: $ae91d1555267d922$var$ContentBody,
    Notices: $ae91d1555267d922$var$Notices,
    ContentIndicators: $ae91d1555267d922$var$ContentIndicators,
    Portlet: $ae91d1555267d922$var$Portlet,
    WPSearch: $ae91d1555267d922$var$WPSearch
};
const $ae91d1555267d922$var$messages = (templates)=>{
    const msgs = [];
    const extractMessages = (text)=>{
        const match = text.match(/{{msg-[^}]*}}/g);
        if (match) match.forEach((result)=>{
            msgs.push(result.replace("{{msg-", "").replace("}}", ""));
        });
    };
    Object.keys($ae91d1555267d922$var$PARTIALS).forEach((key)=>extractMessages($ae91d1555267d922$var$PARTIALS[key]));
    Object.keys(templates).forEach((key)=>extractMessages(templates[key]));
    return msgs;
};
/**
 * @param {number} c
 * @return {string} hex
 */ function $ae91d1555267d922$var$componentToHex(c) {
    const hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
/**
 *
 * @param {Object} rgb
 * @return {string} hexcode.
 */ function $ae91d1555267d922$var$rgbToHex(rgb) {
    return "#" + $ae91d1555267d922$var$componentToHex(rgb.r) + $ae91d1555267d922$var$componentToHex(rgb.g) + $ae91d1555267d922$var$componentToHex(rgb.b);
}
const $ae91d1555267d922$var$randomColor = ()=>{
    return $ae91d1555267d922$var$rgbToHex({
        r: Math.floor(Math.random() * 255),
        g: Math.floor(Math.random() * 255),
        b: Math.floor(Math.random() * 255)
    });
};
/**
 * @param {number} h hue 0-360
 * @param {number} s saturation between 0 and 1
 * @param {number} l lightness between 0 and 1
 * @return {Object} rgb
 */ function $ae91d1555267d922$var$hslToRgb(h, s, l) {
    // h (hue) between 0 and 360, s (saturation) & l (lightness) between 0 and 1
    const c = l <= 0.5 ? 2 * l * s : (2 - 2 * l) * s;
    const h1 = h / 60;
    const x = c * (1 - Math.abs(h1 % 2 - 1));
    let r, g, b;
    if (h1 >= 0 && h1 < 1) {
        r = c;
        g = x;
        b = 0;
    } else if (h1 >= 1 && h1 < 2) {
        r = x;
        g = c;
        b = 0;
    } else if (h1 >= 2 && h1 < 3) {
        r = 0;
        g = c;
        b = x;
    } else if (h1 >= 3 && h1 < 4) {
        r = 0;
        g = x;
        b = c;
    } else if (h1 >= 4 && h1 < 5) {
        r = x;
        g = 0;
        b = c;
    } else if (h1 >= 5 && h1 < 6) {
        r = c;
        g = 0;
        b = x;
    }
    const m = l - 0.5 * c;
    return {
        r: parseInt((r + m) * 255, 10),
        g: parseInt((g + m) * 255, 10),
        b: parseInt((b + m) * 255, 10)
    };
}
/**
 * Return random number between min and max.
 *
 * @param {number} min
 * @param {number} max
 * @return {number}
 */ function $ae91d1555267d922$var$generateRandomNumber(min, max) {
    return Math.random() * (max - min) + min;
}
/**
 * Returns object of RGB keys to hex
 *
 * @param {Object} obj
 * @return {Object}
 */ const $ae91d1555267d922$var$rgbVarsToHex = (obj)=>{
    const newObj = {};
    Object.keys(obj).forEach((key)=>{
        newObj[key] = $ae91d1555267d922$var$rgbToHex(obj[key]);
    });
    return newObj;
};
const $ae91d1555267d922$var$getLessVarsRaw = ()=>{
    const isDarkMode = Math.round(Math.random()) === 0;
    const primary = Math.floor(Math.random() * 359);
    const saturation = $ae91d1555267d922$var$generateRandomNumber(0.3, 0.7);
    const dark = $ae91d1555267d922$var$generateRandomNumber(0, 0.15);
    const pale = $ae91d1555267d922$var$generateRandomNumber(0.85, 1);
    const delta = (pale - dark) / 4;
    const mid = dark + delta;
    const light = dark + delta * 2;
    const complementaryHue = (primary + 180) % 360;
    const seed = Math.floor(85 * Math.random() + 5); // we want it to be at least 5 degrees
    let secondary = (complementaryHue + seed) % 360;
    let tertiary = (complementaryHue - seed) % 360;
    if (secondary < 0) secondary = 360 + secondary;
    if (tertiary < 0) tertiary = 360 + tertiary;
    const colorLinkLightness = isDarkMode ? 0.7 : 0.4;
    const colorLinkLightnessStep = isDarkMode ? -0.05 : 0.05;
    const vars = {
        "background-color-warning": $ae91d1555267d922$var$hslToRgb(tertiary, saturation, isDarkMode ? dark : pale),
        "background-color-base": $ae91d1555267d922$var$hslToRgb(tertiary, saturation, isDarkMode ? mid : light),
        "background-color-article": $ae91d1555267d922$var$hslToRgb(secondary, saturation, isDarkMode ? dark : pale),
        "background-color-thumb": $ae91d1555267d922$var$hslToRgb(tertiary, saturation, isDarkMode ? dark : pale),
        "color-thumb": $ae91d1555267d922$var$hslToRgb(tertiary, saturation, isDarkMode ? pale : dark),
        "color-base": $ae91d1555267d922$var$hslToRgb(primary, saturation, isDarkMode ? pale : dark),
        "color-gray": $ae91d1555267d922$var$hslToRgb(primary, saturation, isDarkMode ? light : mid),
        "color-gray-2": $ae91d1555267d922$var$hslToRgb(primary, saturation, isDarkMode ? mid : light),
        "color-link": $ae91d1555267d922$var$hslToRgb(secondary, saturation, colorLinkLightness),
        "color-link--active": $ae91d1555267d922$var$hslToRgb(secondary, saturation, colorLinkLightness + colorLinkLightnessStep),
        "color-link--visited": $ae91d1555267d922$var$hslToRgb(secondary, saturation, colorLinkLightness + colorLinkLightnessStep / 2)
    };
    return Object.assign($ae91d1555267d922$var$rgbVarsToHex(vars), {
        "font-family": "'Roboto',-apple-system,BlinkMacSystemFont,'Segoe UI','Oxygen','Ubuntu','Cantarell','Helvetica Neue',sans-serif",
        "icon-filter": isDarkMode ? "invert(1)" : "none",
        "color-link-new": "@color-link",
        "color-link-stub": "@color-link",
        "color-link-external": "@color-link",
        "color-link-new--visited": "@color-link--visited"
    });
};
const $ae91d1555267d922$var$getLessVarsCode = (vars)=>{
    return Object.keys(vars).map((key)=>{
        return `@${key}: ${vars[key]};`;
    }).join("\n");
};
const $ae91d1555267d922$var$JQUERY = `
<script src="https://en.wikipedia.org//w/resources/lib/jquery/jquery.js"></script>
`;
const $ae91d1555267d922$var$SCRIPTS = `
<script>
document.body.addEventListener('click', function (ev) {
    var parent = ev.target;
    while(parent !== ev.currentTarget) {
        if(parent.tagName === 'A' && parent.getAttribute('href')) {
            ev.preventDefault();
            return;
        }
        parent = parent.parentNode;
    }
});
window.dispatchEvent(new Event('load'));
</script>
`;
/**
 *
 * @param {string[]} componentNames name array
 * @return {Array} of components with styles.
 */ function $ae91d1555267d922$var$getComponentLESSFileNames(componentNames) {
    return componentNames.filter(// Only if one was declared.
    (key)=>!!$ae91d1555267d922$var$COMPONENT_STYLES[key]);
}
/**
 *
 * @param {string[]} componentNames name array
 * @param {string[]} imports (e.g. ['variables.less'])
 * @return {Object} of components with styles.
 */ function $ae91d1555267d922$var$getComponentLESSFiles(componentNames, imports) {
    const mapping = {};
    $ae91d1555267d922$var$getComponentLESSFileNames(componentNames).forEach((name)=>{
        const importStatements = imports.map((lessFile)=>{
            return `@import '${lessFile}';`;
        }).join("\n");
        mapping[`${name}.less`] = `${importStatements}

${$ae91d1555267d922$var$COMPONENT_STYLES[name]}`;
    });
    return mapping;
}
/**
 * Generate a ZIP file for a given skin.
 *
 * @param {string} name
 * @param {string} mustache
 * @param {string|Object} less
 * @param {string|Object} js
 * @param {Object} variables
 * @param {Object} options
 * @param {boolean} options.isCSS
 * @param {Object|null} options.skinFeatures
 * @param {Object|null} options.skinOptions to be passed directly to ValidSkinName args
 * @param {Object|null} options.messages
 * @param {Array|null} options.authors
 * @param {Object} options.skinStyles
 * @param {string} options.license License of skin
 * @param {Object} options.CustomFileSaver
 * @param {Object} options.Zipper
 * @return {Promise}
 */ function $ae91d1555267d922$var$buildSkin(name, mustache, less, js = "", variables = {}, options = {}) {
    const skinKey = $ae91d1555267d922$var$getSkinKeyFromName(name);
    const templates = $ae91d1555267d922$var$getTemplatesFromSourceCode($ae91d1555267d922$var$PARTIALS, mustache, skinKey);
    const styles = $ae91d1555267d922$var$getComponentLESSFiles(Object.keys(templates), [
        "mediawiki.skin.variables.less"
    ]);
    const isStringModeLESS = typeof less === "string";
    const isStringModeJS = typeof js === "string";
    let importStatements = `// Import specific module style rules.
@media screen {
${Object.keys(styles).map((key)=>`	@import '${key}';`).join("\n")}
}
`;
    if (!options.isCSS) importStatements = `// Import common skin style rules.
@import 'common.less';
${importStatements}`;
    const mainCss = options.isCSS ? "common.css" : "common.less";
    let skinFeatures = `/** ${name} */
`;
    if (options.skinFeatures) {
        const features = Object.keys(options.skinFeatures)// Filter out any that are disabled.
        .filter((key)=>options.skinFeatures[key]).join(",");
        skinFeatures += `/** ResourceLoaderSkinModule: ${features} */
`;
    }
    let jsFiles;
    if (isStringModeJS) jsFiles = {
        "skin.js": $ae91d1555267d922$var$polyfill(js, templates)
    };
    else {
        js["skin.js"] = $ae91d1555267d922$var$polyfill(js["skin.js"], templates);
        jsFiles = js;
    }
    return $ae91d1555267d922$var$build(name, Object.assign(styles, isStringModeLESS ? {
        [mainCss]: less
    } : less, {
        "print.less": $ae91d1555267d922$var$printLESS,
        "mediawiki.skin.variables.less": `@import 'mediawiki.skin.defaults.less';
${$ae91d1555267d922$var$getLessVarsCode(variables)}
`,
        "skin.less": `${skinFeatures}
// Import MediaWiki skin variables for general fundamental styling.
@import 'mediawiki.skin.variables.less';

${importStatements}`
    }), templates, jsFiles, $ae91d1555267d922$var$messages(templates), options);
}
/**
 *
 * @param {string[]} componentNames name array
 * @return {Array} of components with styles.
 */ function $ae91d1555267d922$var$getComponentLESSRaw(componentNames) {
    return $ae91d1555267d922$var$getComponentLESSFileNames(componentNames).map((key)=>$ae91d1555267d922$var$COMPONENT_STYLES[key]).join("\n");
}
function $ae91d1555267d922$var$getLESSFromTemplate(mustache) {
    return $ae91d1555267d922$var$getComponentLESSRaw(Object.keys($ae91d1555267d922$var$getTemplatesFromSourceCode($ae91d1555267d922$var$PARTIALS, mustache)));
}
function $ae91d1555267d922$var$getFeatureStylesheet(key) {
    return $ae91d1555267d922$var$FEATURE_STYLES[key] || "";
}
function $ae91d1555267d922$var$getResourceLoaderSkinModuleStylesFromStylesheet(styles) {
    return Object.keys($ae91d1555267d922$var$getFeaturesFromStyles(styles)).map((key)=>$ae91d1555267d922$var$getFeatureStylesheet(key)).join("\n");
}
function $ae91d1555267d922$var$buildDefaultAssets() {
    return {
        mustache: $ae91d1555267d922$var$skin,
        less: $ae91d1555267d922$var$skinLESS
    };
}
function $ae91d1555267d922$var$buildSkinBoilerplate(name, options) {
    return $ae91d1555267d922$var$buildSkin(name, $ae91d1555267d922$var$skin, $ae91d1555267d922$var$skinLESS, `/* JavaScript for the ${name} skin */
`, $ae91d1555267d922$var$getLessVarsRaw(), options).then((result)=>{
        console.log(`Successfully built ${name}`);
    });
}
module.exports.COMPONENT_STYLES = $ae91d1555267d922$var$COMPONENT_STYLES;
module.exports.FEATURE_STYLES = $ae91d1555267d922$var$FEATURE_STYLES;
module.exports.JQUERY = $ae91d1555267d922$var$JQUERY;
module.exports.PARTIALS = $ae91d1555267d922$var$PARTIALS;
module.exports.SCRIPTS = $ae91d1555267d922$var$SCRIPTS;
module.exports.build = $ae91d1555267d922$var$build;
module.exports.buildDefaultAssets = $ae91d1555267d922$var$buildDefaultAssets;
module.exports.buildExtension = $ae91d1555267d922$var$buildExtension;
module.exports.buildSkin = $ae91d1555267d922$var$buildSkin;
module.exports.buildSkinBoilerplate = $ae91d1555267d922$var$buildSkinBoilerplate;
module.exports.getComponentLESSFiles = $ae91d1555267d922$var$getComponentLESSFiles;
module.exports.getLESSFromTemplate = $ae91d1555267d922$var$getLESSFromTemplate;
module.exports.getLessVarsCode = $ae91d1555267d922$var$getLessVarsCode;
module.exports.getLessVarsRaw = $ae91d1555267d922$var$getLessVarsRaw;
module.exports.getResourceLoaderSkinModuleStylesFromStylesheet = $ae91d1555267d922$var$getResourceLoaderSkinModuleStylesFromStylesheet;
module.exports.messages = $ae91d1555267d922$var$messages;
module.exports.randomColor = $ae91d1555267d922$var$randomColor;

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("b6RFW", function(module, exports) {

exports = module.exports = (parcelRequire("d4xg3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3LwY7"));

exports.Duplex = (parcelRequire("DwJuQ"));

exports.Transform = (parcelRequire("b7kl8"));

exports.PassThrough = (parcelRequire("4wWcs"));

exports.finished = (parcelRequire("fiCvv"));

exports.pipeline = (parcelRequire("aGSwO"));

});
parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $9845726cca5dc7eb$var$Readable;
/*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $9845726cca5dc7eb$require$Buffer = $6ZWSX.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog("stream");
else $9845726cca5dc7eb$var$debug = function debug() {};

var $bF5dL = parcelRequire("bF5dL");

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $9845726cca5dc7eb$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $9845726cca5dc7eb$require$_require$codes = $6JySE.codes;
var $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE = $9845726cca5dc7eb$require$_require$codes.ERR_INVALID_ARG_TYPE, $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED = $9845726cca5dc7eb$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $9845726cca5dc7eb$var$StringDecoder;
var $9845726cca5dc7eb$var$createReadableStreamAsyncIterator;
var $9845726cca5dc7eb$var$from;

(parcelRequire("dlqwk"))($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$errorOrDestroy = $fMCbt.errorOrDestroy;
var $9845726cca5dc7eb$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream, isDuplex) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $9845726cca5dc7eb$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bF5dL();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $9845726cca5dc7eb$var$Duplex;
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $9845726cca5dc7eb$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) $9845726cca5dc7eb$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $9845726cca5dc7eb$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $9845726cca5dc7eb$var$MAX_HWM = 0x40000000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9845726cca5dc7eb$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    $9845726cca5dc7eb$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $9845726cca5dc7eb$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $9845726cca5dc7eb$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $9845726cca5dc7eb$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    $9845726cca5dc7eb$var$errorOrDestroy(this, new $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug("ondata");
        var ret = dest.write(chunk);
        $9845726cca5dc7eb$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, "error") === 0) $9845726cca5dc7eb$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9845726cca5dc7eb$var$debug("on readable", state.length, state.reading);
            if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
$9845726cca5dc7eb$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jfAlf.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jfAlf.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
function $9845726cca5dc7eb$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    $9845726cca5dc7eb$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9845726cca5dc7eb$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $9845726cca5dc7eb$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $9845726cca5dc7eb$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($9845726cca5dc7eb$var$createReadableStreamAsyncIterator === undefined) $9845726cca5dc7eb$var$createReadableStreamAsyncIterator = (parcelRequire("2UdT6"));
    return $9845726cca5dc7eb$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    $9845726cca5dc7eb$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.from = function(iterable, opts) {
    if ($9845726cca5dc7eb$var$from === undefined) $9845726cca5dc7eb$var$from = (parcelRequire("e6P81"));
    return $9845726cca5dc7eb$var$from($9845726cca5dc7eb$var$Readable, iterable, opts);
};
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("bF5dL", function(module, exports) {
"use strict";
function $87d792cd1b95f90e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87d792cd1b95f90e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $87d792cd1b95f90e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $87d792cd1b95f90e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $87d792cd1b95f90e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87d792cd1b95f90e$var$_defineProperty(obj, key, value) {
    key = $87d792cd1b95f90e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87d792cd1b95f90e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87d792cd1b95f90e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $87d792cd1b95f90e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $87d792cd1b95f90e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87d792cd1b95f90e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87d792cd1b95f90e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $87d792cd1b95f90e$var$_toPropertyKey(arg) {
    var key = $87d792cd1b95f90e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $87d792cd1b95f90e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $87d792cd1b95f90e$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $87d792cd1b95f90e$var$inspect = $kjyEk.inspect;
var $87d792cd1b95f90e$var$custom = $87d792cd1b95f90e$var$inspect && $87d792cd1b95f90e$var$inspect.custom || "inspect";
function $87d792cd1b95f90e$var$copyBuffer(src, target, offset) {
    $87d792cd1b95f90e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $87d792cd1b95f90e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $87d792cd1b95f90e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $87d792cd1b95f90e$var$Buffer.alloc(0);
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $87d792cd1b95f90e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $87d792cd1b95f90e$var$custom,
            value: function value(_, options) {
                return $87d792cd1b95f90e$var$inspect(this, $87d792cd1b95f90e$var$_objectSpread($87d792cd1b95f90e$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fMCbt", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$emitErrorAndCloseNT(self, err) {
    $b7d8f541ca4a3ff5$var$emitErrorNT(self, err);
    $b7d8f541ca4a3ff5$var$emitCloseNT(self);
}
function $b7d8f541ca4a3ff5$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b7d8f541ca4a3ff5$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy,
    errorOrDestroy: $b7d8f541ca4a3ff5$var$errorOrDestroy
};

});

parcelRegister("04a3B", function(module, exports) {
"use strict";

var $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE = (parcelRequire("6JySE")).codes.ERR_INVALID_OPT_VALUE;
function $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $00c82cf8dac417cf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $00c82cf8dac417cf$var$getHighWaterMark
};

});
parcelRegister("6JySE", function(module, exports) {

$parcel$export(module.exports, "codes", () => $4e720097bc0bc9d8$export$e45cb6485273080e, (v) => $4e720097bc0bc9d8$export$e45cb6485273080e = v);
var $4e720097bc0bc9d8$export$e45cb6485273080e;
"use strict";
function $4e720097bc0bc9d8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e720097bc0bc9d8$var$codes = {};
function $4e720097bc0bc9d8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $4e720097bc0bc9d8$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $4e720097bc0bc9d8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $4e720097bc0bc9d8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $4e720097bc0bc9d8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4e720097bc0bc9d8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $4e720097bc0bc9d8$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $4e720097bc0bc9d8$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($4e720097bc0bc9d8$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    else {
        var type = $4e720097bc0bc9d8$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$4e720097bc0bc9d8$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$4e720097bc0bc9d8$export$e45cb6485273080e = $4e720097bc0bc9d8$var$codes;

});


parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");

(parcelRequire("dlqwk"))($076d08b0309449dc$var$Duplex, $d4xg3);
// Allow the keys array to be GC'ed.
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $076d08b0309449dc$var$onend);
        }
    }
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $2bdf55c2c4f390d3$require$Buffer = $6ZWSX.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $2bdf55c2c4f390d3$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $2bdf55c2c4f390d3$require$_require$codes = $6JySE.codes;
var $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_INVALID_ARG_TYPE, $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED = $2bdf55c2c4f390d3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK = $2bdf55c2c4f390d3$require$_require$codes.ERR_MULTIPLE_CALLBACK, $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_DESTROYED, $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_NULL_VALUES, $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING = $2bdf55c2c4f390d3$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $2bdf55c2c4f390d3$var$errorOrDestroy = $fMCbt.errorOrDestroy;

(parcelRequire("dlqwk"))($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream, isDuplex) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $2bdf55c2c4f390d3$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, "buffer", {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $2bdf55c2c4f390d3$var$Duplex;
    if (!isDuplex && !$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    $2bdf55c2c4f390d3$var$errorOrDestroy(this, new $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE());
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ending) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK();
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $2bdf55c2c4f390d3$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});


parcelRegister("2UdT6", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $21db958e3a099d7d$var$_Object$setPrototypeO;
function $21db958e3a099d7d$var$_defineProperty(obj, key, value) {
    key = $21db958e3a099d7d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21db958e3a099d7d$var$_toPropertyKey(arg) {
    var key = $21db958e3a099d7d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $21db958e3a099d7d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $fiCvv = parcelRequire("fiCvv");
var $21db958e3a099d7d$var$kLastResolve = Symbol("lastResolve");
var $21db958e3a099d7d$var$kLastReject = Symbol("lastReject");
var $21db958e3a099d7d$var$kError = Symbol("error");
var $21db958e3a099d7d$var$kEnded = Symbol("ended");
var $21db958e3a099d7d$var$kLastPromise = Symbol("lastPromise");
var $21db958e3a099d7d$var$kHandlePromise = Symbol("handlePromise");
var $21db958e3a099d7d$var$kStream = Symbol("stream");
function $21db958e3a099d7d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $21db958e3a099d7d$var$readAndResolve(iter) {
    var resolve = iter[$21db958e3a099d7d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$21db958e3a099d7d$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$21db958e3a099d7d$var$kLastPromise] = null;
            iter[$21db958e3a099d7d$var$kLastResolve] = null;
            iter[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(data, false));
        }
    }
}
function $21db958e3a099d7d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($21db958e3a099d7d$var$readAndResolve, iter);
}
function $21db958e3a099d7d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$21db958e3a099d7d$var$kEnded]) {
                resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
                return;
            }
            iter[$21db958e3a099d7d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $21db958e3a099d7d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($21db958e3a099d7d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$21db958e3a099d7d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$21db958e3a099d7d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$21db958e3a099d7d$var$kEnded]) return Promise.resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        if (this[$21db958e3a099d7d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$21db958e3a099d7d$var$kError]) reject(_this[$21db958e3a099d7d$var$kError]);
                else resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$21db958e3a099d7d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($21db958e3a099d7d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$21db958e3a099d7d$var$kStream].read();
            if (data !== null) return Promise.resolve($21db958e3a099d7d$var$createIterResult(data, false));
            promise = new Promise(this[$21db958e3a099d7d$var$kHandlePromise]);
        }
        this[$21db958e3a099d7d$var$kLastPromise] = promise;
        return promise;
    }
}, $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$21db958e3a099d7d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        });
    });
}), $21db958e3a099d7d$var$_Object$setPrototypeO), $21db958e3a099d7d$var$AsyncIteratorPrototype);
var $21db958e3a099d7d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kStream, {
        value: stream,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastResolve, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastReject, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kError, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$21db958e3a099d7d$var$kStream].read();
            if (data) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                resolve($21db958e3a099d7d$var$createIterResult(data, false));
            } else {
                iterator[$21db958e3a099d7d$var$kLastResolve] = resolve;
                iterator[$21db958e3a099d7d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$21db958e3a099d7d$var$kLastPromise] = null;
    $fiCvv(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$21db958e3a099d7d$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$21db958e3a099d7d$var$kError] = err;
            return;
        }
        var resolve = iterator[$21db958e3a099d7d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$21db958e3a099d7d$var$kLastPromise] = null;
            iterator[$21db958e3a099d7d$var$kLastResolve] = null;
            iterator[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        }
        iterator[$21db958e3a099d7d$var$kEnded] = true;
    });
    stream.on("readable", $21db958e3a099d7d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $21db958e3a099d7d$var$createReadableStreamAsyncIterator;

});
parcelRegister("fiCvv", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("6JySE")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $b236683171fcb6ee$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b236683171fcb6ee$var$noop() {}
function $b236683171fcb6ee$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $b236683171fcb6ee$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $b236683171fcb6ee$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b236683171fcb6ee$var$once(callback || $b236683171fcb6ee$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($b236683171fcb6ee$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $b236683171fcb6ee$var$eos;

});


parcelRegister("e6P81", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $8180203f7f0d3074$var$Transform;

var $6JySE = parcelRequire("6JySE");
var $8180203f7f0d3074$require$_require$codes = $6JySE.codes;
var $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED = $8180203f7f0d3074$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK = $8180203f7f0d3074$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0 = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $DwJuQ = parcelRequire("DwJuQ");

(parcelRequire("dlqwk"))($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

(parcelRequire("dlqwk"))($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("aGSwO", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $7c881fce7a4fadf1$var$eos;
function $7c881fce7a4fadf1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $6JySE = parcelRequire("6JySE");
var $7c881fce7a4fadf1$require$_require$codes = $6JySE.codes;
var $7c881fce7a4fadf1$var$ERR_MISSING_ARGS = $7c881fce7a4fadf1$require$_require$codes.ERR_MISSING_ARGS, $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED = $7c881fce7a4fadf1$require$_require$codes.ERR_STREAM_DESTROYED;
function $7c881fce7a4fadf1$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $7c881fce7a4fadf1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, callback) {
    callback = $7c881fce7a4fadf1$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($7c881fce7a4fadf1$var$eos === undefined) $7c881fce7a4fadf1$var$eos = (parcelRequire("fiCvv"));
    $7c881fce7a4fadf1$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($7c881fce7a4fadf1$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $7c881fce7a4fadf1$var$call(fn) {
    fn();
}
function $7c881fce7a4fadf1$var$pipe(from, to) {
    return from.pipe(to);
}
function $7c881fce7a4fadf1$var$popCallback(streams) {
    if (!streams.length) return $7c881fce7a4fadf1$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $7c881fce7a4fadf1$var$noop;
    return streams.pop();
}
function $7c881fce7a4fadf1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $7c881fce7a4fadf1$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7c881fce7a4fadf1$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($7c881fce7a4fadf1$var$call);
            if (reading) return;
            destroys.forEach($7c881fce7a4fadf1$var$call);
            callback(error);
        });
    });
    return streams.reduce($7c881fce7a4fadf1$var$pipe);
}
module.exports = $7c881fce7a4fadf1$var$pipeline;

});



parcelRegister("ifgZ7", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === "[object Array]";
    };
    function isFunction(object) {
        return typeof object === "function";
    }
    /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? "array" : typeof obj;
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
    }
    /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === "object" && propName in obj;
    }
    /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== "object" && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    }
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
        "`": "&#x60;",
        "=": "&#x3D;"
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ""; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === "string") tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error("Invalid tags: " + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + "\\s*");
            closingTagRe = new RegExp("\\s*" + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp("\\s*" + escapeRegExp("}" + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += " ";
                }
                tokens.push([
                    "text",
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === "\n") {
                    stripSpace();
                    indentation = "";
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || "name";
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === "=") {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === "{") {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = "&";
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error("Unclosed tag at " + scanner.pos);
            if (type == ">") token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === "#" || type === "^") sections.push(token);
            else if (type === "/") {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === "name" || type === "{" || type === "&") nonSpace = true;
            else if (type === "=") // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === "text" && lastToken && lastToken[0] === "text") {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case "#":
                case "^":
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case "/":
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === "";
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return "";
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = "";
                break;
            case 0:
                match = "";
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            ".": this.view
        };
        this.parent = parentContext;
    }
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var cache1 = this.cache;
        var value;
        if (cache1.hasOwnProperty(name)) value = cache1[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf(".") > 0) {
                    intermediateValue = context.view;
                    names = name.split(".");
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            cache1[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    }
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== "undefined") this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var cache1 = this.templateCache;
        var cacheKey = template + ":" + (tags || mustache.tags).join(":");
        var isCacheEnabled = typeof cache1 !== "undefined";
        var tokens = isCacheEnabled ? cache1.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && cache1.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `config` argument is given here, then it should be an
   * object with a `tags` attribute or an `escape` attribute or both.
   * If an array is passed, then it will be interpreted the same way as
   * a `tags` attribute on a `config` object.
   *
   * The `tags` attribute of a `config` object must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   *
   * The `escape` attribute of a `config` object must be a function which
   * accepts a string as input and outputs a safely escaped string.
   * If an `escape` function is not provided, then an HTML-safe string
   * escaping function is used as the default.
   */ Writer.prototype.render = function render(template, view, partials, config) {
        var tags = this.getConfigTags(config);
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, config);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
        var buffer = "";
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === "#") value = this.renderSection(token, context, partials, originalTemplate, config);
            else if (symbol === "^") value = this.renderInverted(token, context, partials, originalTemplate, config);
            else if (symbol === ">") value = this.renderPartial(token, context, partials, config);
            else if (symbol === "&") value = this.unescapedValue(token, context);
            else if (symbol === "name") value = this.escapedValue(token, context, config);
            else if (symbol === "text") value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
        var self = this;
        var buffer = "";
        var value = context.lookup(token[1]);
        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials, config);
        }
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        else if (typeof value === "object" || typeof value === "string" || typeof value === "number") buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== "string") throw new Error("Cannot use higher-order sections without the original template");
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, "");
        var partialByNl = partial.split("\n");
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join("\n");
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
        if (!partials) return;
        var tags = this.getConfigTags(config);
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            var tokens = this.parse(indentedValue, tags);
            return this.renderTokens(tokens, context, partials, indentedValue, config);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
        var escape = this.getConfigEscape(config) || mustache.escape;
        var value = context.lookup(token[1]);
        if (value != null) return typeof value === "number" && escape === mustache.escape ? String(value) : escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    Writer.prototype.getConfigTags = function getConfigTags(config) {
        if (isArray(config)) return config;
        else if (config && typeof config === "object") return config.tags;
        else return undefined;
    };
    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
        if (config && typeof config === "object" && !isArray(config)) return config.escape;
        else return undefined;
    };
    var mustache = {
        name: "mustache.js",
        version: "4.2.0",
        tags: [
            "{{",
            "}}"
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view`, `partials`, and `config`
   * using the default writer.
   */ mustache.render = function render(template, view, partials, config) {
        if (typeof template !== "string") throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + "argument for mustache#render(template, view, partials)");
        return defaultWriter.render(template, view, partials, config);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});

});

parcelRegister("9yj3W", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f46137913cfce8d$export$2e2bcd8739ae039);
let $6f46137913cfce8d$var$script;




let $6f46137913cfce8d$var$initialize = ()=>{
    $6f46137913cfce8d$var$script = (parcelRequire("hLRik"));
    if ($6f46137913cfce8d$var$script.__esModule) $6f46137913cfce8d$var$script = $6f46137913cfce8d$var$script.default;
    $6f46137913cfce8d$var$script.render = (parcelRequire("8oLeh")).render;
    $6f46137913cfce8d$var$script.__cssModules = {};
    (parcelRequire("j4VpY")).default($6f46137913cfce8d$var$script);
    $6f46137913cfce8d$var$script.__scopeId = "data-v-a33880";
    $6f46137913cfce8d$var$script.__file = "ColorChart.vue";
};
$6f46137913cfce8d$var$initialize();
var $6f46137913cfce8d$export$2e2bcd8739ae039 = $6f46137913cfce8d$var$script;

});
parcelRegister("hLRik", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cf002aa7832c9183$export$2e2bcd8739ae039);
var $cf002aa7832c9183$export$2e2bcd8739ae039 = {
    name: "ColorChart",
    components: {},
    props: {
        colors: {
            type: Array,
            required: true
        }
    }
};

});

parcelRegister("8oLeh", function(module, exports) {

$parcel$export(module.exports, "render", () => $61d533646e1c8c8a$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
const $61d533646e1c8c8a$var$_hoisted_1 = {
    class: "color-chart"
};
const $61d533646e1c8c8a$var$_hoisted_2 = [
    "title",
    "onClick"
];
function $61d533646e1c8c8a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $61d533646e1c8c8a$var$_hoisted_1, [
        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($props.colors, (c, i)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", {
                key: "color" + i,
                class: "color-chart__blot",
                style: (0, $8XWQX.normalizeStyle)("background: " + c.color + ";"),
                title: c.key + " : " + c.color,
                onClick: ($event)=>_ctx.$emit("toggleColor", c.key)
            }, " \xa0 ", 12, $61d533646e1c8c8a$var$_hoisted_2);
        }), 128))
    ]);
}

});

parcelRegister("j4VpY", function(module, exports) {

$parcel$export(module.exports, "default", () => $de3aee0ae27ff8c9$export$2e2bcd8739ae039);
let $de3aee0ae27ff8c9$var$NOOP = ()=>{};
var $de3aee0ae27ff8c9$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("2s757", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c93b089c8bf5e6a$export$2e2bcd8739ae039);
let $1c93b089c8bf5e6a$var$script;




let $1c93b089c8bf5e6a$var$initialize = ()=>{
    $1c93b089c8bf5e6a$var$script = (parcelRequire("9O3jp"));
    if ($1c93b089c8bf5e6a$var$script.__esModule) $1c93b089c8bf5e6a$var$script = $1c93b089c8bf5e6a$var$script.default;
    $1c93b089c8bf5e6a$var$script.render = (parcelRequire("3j0Sj")).render;
    $1c93b089c8bf5e6a$var$script.__cssModules = {};
    (parcelRequire("bfwuE")).default($1c93b089c8bf5e6a$var$script);
    $1c93b089c8bf5e6a$var$script.__scopeId = "data-v-715dbd";
    $1c93b089c8bf5e6a$var$script.__file = "Btn.vue";
};
$1c93b089c8bf5e6a$var$initialize();
var $1c93b089c8bf5e6a$export$2e2bcd8739ae039 = $1c93b089c8bf5e6a$var$script;

});
parcelRegister("9O3jp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $723b5a434bdfc5ed$export$2e2bcd8739ae039);
var $723b5a434bdfc5ed$export$2e2bcd8739ae039 = {
    name: "Btn",
    components: {},
    props: {
        destructive: {
            type: Boolean
        }
    },
    computed: {
        classList () {
            return {
                btn: true,
                "btn--destructive": this.destructive
            };
        }
    }
};

});

parcelRegister("3j0Sj", function(module, exports) {

$parcel$export(module.exports, "render", () => $2683d3322c3602b9$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
function $2683d3322c3602b9$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("button", {
        class: (0, $8XWQX.normalizeClass)($options.classList),
        onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("click"))
    }, [
        (0, $TusQn.renderSlot)(_ctx.$slots, "default")
    ], 2);
}

});

parcelRegister("bfwuE", function(module, exports) {

$parcel$export(module.exports, "default", () => $830a4cedc9799bb6$export$2e2bcd8739ae039);
let $830a4cedc9799bb6$var$NOOP = ()=>{};
var $830a4cedc9799bb6$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("iNhHq", function(module, exports) {

$parcel$export(module.exports, "default", () => $daea8857587ede6a$export$2e2bcd8739ae039);
const $daea8857587ede6a$var$ADJECTIVES = [
    "Naturally",
    "spotted",
    "New",
    "Delicious",
    "Winged",
    "checkered",
    "Ablaze",
    "Abrupt",
    "Accomplished",
    "Active",
    "Adored",
    "Adulated",
    "Adventurous",
    "Affectionate",
    "Amused",
    "Amusing",
    "Animal",
    "Antique",
    "Appreciated",
    "Archaic",
    "Ardent",
    "Arrogant",
    "Astonished",
    "Audacious",
    "Authoritative",
    "Awestruck",
    "Beaming",
    "Bewildered",
    "Bewitching",
    "Blissful",
    "Boisterous",
    "Booming",
    "Bouncy",
    "Breathtaking",
    "Bright",
    "Brilliant",
    "Bubbling",
    "Calm",
    "Calming",
    "Capricious",
    "Celestial",
    "Charming",
    "Cheerful",
    "Cherished",
    "Chiaroscuro",
    "Chilled",
    "Comical",
    "Commanding",
    "Companionable",
    "Confident",
    "Contentment",
    "Courage",
    "Crazy",
    "Creepy",
    "Dancing",
    "Dazzling",
    "Delicate",
    "Delightful",
    "Demented",
    "Desirable",
    "Determined",
    "Devoted",
    "Dominant",
    "Dramatic",
    "Drawn out",
    "Dripping",
    "Dumbstruck",
    "Ebullient",
    "Elated",
    "Elegant",
    "Enchanted",
    "Energetic",
    "Enthusiastic",
    "Ethereal",
    "Exaggerated",
    "Exalted",
    "Expectant",
    "Expressive",
    "Exuberant",
    "Faint",
    "Fantastical",
    "Favorable",
    "Febrile",
    "Feral",
    "Feverish",
    "Fiery",
    "Floating",
    "Flying",
    "Folksy",
    "Fond",
    "Forgiven",
    "Forgiving",
    "Freakin' awesome",
    "Frenetic",
    "Frenzied",
    "Friendly",
    "amorous",
    "Frosted",
    "Funny",
    "Furry",
    "Galloping",
    "Gaping",
    "Gentle",
    "Giddy",
    "Glacial",
    "Gladness",
    "Gleaming",
    "Gleeful",
    "Gorgeous",
    "Graceful",
    "Grateful",
    "Halting",
    "Happy",
    "Haunting",
    "Heavenly",
    "Hidden",
    "spirited",
    "Honor",
    "Hopeful",
    "Hopping",
    "Humble",
    "Hushed",
    "Hypnotic",
    "Illuminated",
    "Immense",
    "Imperious",
    "Impudent",
    "Charged",
    "Inflated",
    "Innocent",
    "Inspired",
    "Intimate",
    "Intrepid",
    "Jagged",
    "Joking",
    "Joyful",
    "Jubilant",
    "Kindly",
    "Languid",
    "Larger than life",
    "Laughable",
    "Lickety",
    "Lighthearted",
    "Limping",
    "Linear",
    "Lively",
    "Lofty",
    "Loved",
    "Lovely",
    "Lulling",
    "Luminescent",
    "Lush",
    "Luxurious",
    "Magical",
    "Maniacal",
    "Manliness",
    "March",
    "Masterful",
    "Merciful",
    "Merry",
    "Mischievous",
    "Misty",
    "Modest",
    "Moonlit",
    "Mysterious",
    "Mystical",
    "Mythological",
    "Nebulous",
    "Nostalgic",
    "On fire",
    "Overstated",
    "Paganish",
    "Partying",
    "Perfunctory",
    "Perky",
    "Perplexed",
    "Persevering",
    "Pious",
    "Playful",
    "Pleasurable",
    "Poignant",
    "Portentous",
    "Posh",
    "Powerful",
    "Pretty",
    "Prickly",
    "Prideful",
    "Princesslike",
    "Proud",
    "Puzzled",
    "Queenly",
    "Questing",
    "Quiet",
    "Racy",
    "Ragged",
    "Regal",
    "Rejoicing",
    "Relaxed",
    "Reminiscent",
    "Repentant",
    "Reserved",
    "Resolute",
    "Ridiculous",
    "Ritualistic",
    "Robust",
    "Running",
    "Sarcastic",
    "Scampering",
    "Scoffing",
    "Scurrying",
    "Sensitive",
    "Serene",
    "Shaking",
    "Shining",
    "Silky",
    "Silly",
    "Simple",
    "Singing",
    "Skipping",
    "Smooth",
    "Sneaky",
    "Soaring",
    "Sophisticated",
    "Sparkling",
    "Spell",
    "Spherical",
    "Spidery",
    "Splashing",
    "Splendid",
    "Spooky",
    "Sprinting",
    "Starlit",
    "Starry",
    "Startling",
    "Successful",
    "Summery",
    "Surprised",
    "Sympathetic",
    "Tapping",
    "Teasing",
    "Tender",
    "Thoughtful",
    "Thrilling",
    "Tingling",
    "Tinkling",
    "Totemic",
    "Touching",
    "Tranquil",
    "Treasured",
    "Trembling",
    "Triumphant",
    "Twinkling",
    "Undulating",
    "Unruly",
    "Urgent",
    "Veiled",
    "Velvety",
    "Victorious",
    "Vigorous",
    "Virile",
    "Walking",
    "Wild",
    "Witty",
    "Wondering",
    "Zealous",
    "Zestful"
];
const $daea8857587ede6a$var$NOUNS = [
    "American",
    "yellow",
    "warbler",
    "Yellow",
    "Common",
    "yellowthroat",
    "Hooded",
    "Prothonotary",
    "Cerulean",
    "Blackburnian",
    "redstart",
    "Wilson",
    "Kirtland",
    "Black-and-white",
    "Magnolia",
    "Blackpoll",
    "Palm",
    "Chestnut",
    "Pine",
    "Golden",
    "Blue",
    "Ovenbird",
    "Black",
    "blue",
    "green",
    "Nashville",
    "Cape",
    "May",
    "Canada",
    "Bay",
    "Worm",
    "Prairie",
    "Kentucky",
    "Yellow",
    "Northern",
    "parula",
    "Townsend",
    "Tennessee",
    "Orange-crowned",
    "Louisiana",
    "waterthrush",
    "Connecticut",
    "Hermit",
    "gray",
    "Mourning",
    "Golden",
    "Swainson",
    "MacGillivray",
    "Wood",
    "Lucy",
    "Damask",
    "rose",
    "China",
    "Multiflora",
    "Mr.",
    "Lincoln",
    "Beach",
    "Rosa",
    "Peace",
    "Corymb",
    "French",
    "White",
    "of",
    "york",
    "Double",
    "Guinea",
    "Ireland",
    "Borneo",
    "Majorca",
    "Vancouver",
    "Island",
    "O\u2018ahu",
    "Long",
    "Hispaniola",
    "Crete",
    "Te",
    "Waipounamu",
    "South",
    "Cape",
    "Breton",
    "Hawaiian",
    "Islands",
    "Honshu",
    "Sulawesi",
    "Ika-a-M\u0101ui",
    "North",
    "Mindanao",
    "Luzon",
    "Bioko",
    "Bali",
    "Kyushu",
    "Guadalcanal",
    "Tenerife",
    "Gran",
    "Canaria",
    "Maui",
    "Malaita",
    "Baffin",
    "Rhodes",
    "Shikoku",
    "Sumatra",
    "Okinawa",
    "Bora",
    "Saint",
    "Martin",
    "Kauai",
    "Upolu",
    "Timor",
    "Ellesmere",
    "Viti",
    "Levu",
    "Euboea",
    "Espiritu",
    "Santo",
    "Sakhalin",
    "Ascension",
    "Hawai'i",
    "Bougainville",
    "Grand",
    "Bahama",
    "San",
    "Cristobal",
    "Victoria",
    "Fuerteventura",
    "Newfoundland",
    "Java",
    "Tahiti",
    "Delight",
    "KORbin",
    "Memorial",
    "Cabbage",
    "Lady",
    "Banks",
    "Austrian",
    "briar",
    "Dog",
    "Common",
    "Purslane",
    "Ausmas",
    "Bourbon",
    "Rose",
    "moschata",
    "Moss",
    "purslane",
    "Sweet-Brier",
    "glauca",
    "Burnet",
    "laevigata",
    "heleniae",
    "Manchu",
    "villosa",
    "majalis",
    "Glaucous",
    "dog",
    "Carolina",
    "Swamp",
    "Prickly",
    "wild",
    "Field",
    "Pink",
    "Evergreen",
    "Woods",
    "Nootka",
    "moyesii",
    "Alpine",
    "Robusta",
    "Liberica",
    "Excelsa",
    "Arabica",
    "Parsley",
    "Mint",
    "Dill",
    "Basil",
    "Sage",
    "Rosemary",
    "Thyme",
    "Cilantro",
    "Coriander",
    "Fennel",
    "Chamomile",
    "Tarragon",
    "Lavender",
    "Chives",
    "Bay",
    "Leaves",
    "Culantro",
    "Chervil",
    "Winter",
    "Savory",
    "Peppermint",
    "Stevia",
    "Lemongrass",
    "Oregano",
    "Marjoram",
    "Lemon",
    "Balm",
    "Aloe",
    "Myrtle",
    "Verbena",
    "Aloe",
    "vera",
    "Candelabra",
    "aloe",
    "Cape",
    "Tiger",
    "tooth",
    "Hedgehog",
    "Soap",
    "Short",
    "viridiflora",
    "Mountain",
    "Spiral",
    "Aloiampelos",
    "striatula",
    "Coral",
    "perryi",
    "succotrina",
    "ruspoliana",
    "harlana",
    "Snake",
    "massawana",
    "squarrosa",
    "peglerae",
    "erinacea",
    "jucunda",
    "vaombe",
    "rauhii",
    "camperi",
    "ballyi",
    "cryptopoda",
    "corallina",
    "comosa",
    "suzannae",
    "excelsa",
    "helenae",
    "hereroensis",
    "sinkatana",
    "khamiesensis",
    "reynoldsii",
    "nyeriensis",
    "scobinifolia",
    "forbesii",
    "ammophila",
    "dewinteri",
    "ballii",
    "vacillans",
    "jawiyon",
    "christianii",
    "inermis",
    "argenticauda",
    "Mitriformes",
    "Cicely",
    "Spearmint",
    "Wingpod",
    "Virginia",
    "Shining",
    "Smooth",
    "persica",
    "California",
    "Wild",
    "Climbing",
    "Tea",
    "Hybrid",
    "Rugosa",
    "Prairie",
    "Portulaca",
    "molokiniensis",
    "Virginia",
    "Painted",
    "Grace",
    "Red",
    "Yellow",
    "chat",
    "Olive",
    "Eurasian",
    "reed",
    "Scarlet",
    "tanager",
    "Summer",
    "Western",
    "Hepatic",
    "Flame",
    "Blue-gray",
    "Black-and-yellow",
    "Paradise",
    "Swallow",
    "Orange",
    "Magpie",
    "Hooded",
    "mountain",
    "White-capped",
    "Grass-green",
    "Grey",
    "Green",
    "Variable",
    "seedeater",
    "Shrike",
    "Short",
    "honeycreeper",
    "White",
    "shrike",
    "Rosy",
    "thrush",
    "Purple",
    "Bananaquit",
    "Multicoloured",
    "Seven",
    "Brazilian",
    "Brown",
    "White",
    "Scarlet",
    "Silver",
    "Common",
    "bush",
    "Plushcap",
    "Rufous",
    "Glistening-green",
    "Fawn",
    "Mourning",
    "sierra",
    "finch",
    "Blue",
    "winged",
    "White",
    "Blue",
    "Crimson",
    "Olive-green",
    "hooded",
    "Grey",
    "Palm",
    "Black",
    "Orange",
    "Pardusco",
    "Blue-black",
    "grassquit",
    "Masked",
    "crimson",
    "Yellow",
    "White",
    "Golden",
    "Bald",
    "eagle",
    "Golden",
    "Peregrine",
    "falcon",
    "Sandhill",
    "crane",
    "Osprey",
    "Common",
    "raven",
    "American",
    "robin",
    "Northern",
    "cardinal",
    "Canada",
    "goose",
    "Mourning",
    "dove",
    "House",
    "finch",
    "starling",
    "sparrow",
    "Goldfinch",
    "Mallard",
    "Blue",
    "jay",
    "pintail",
    "wigeon",
    "Dark",
    "junco",
    "Downy",
    "woodpecker",
    "Great",
    "horned",
    "owl",
    "blue",
    "heron",
    "kestrel",
    "Blue",
    "teal",
    "Piping",
    "plover",
    "Wood",
    "duck",
    "Hairy",
    "Black-capped",
    "chickadee",
    "Caspian",
    "tern",
    "Baltimore",
    "oriole",
    "Lesser",
    "scaup",
    "Bufflehead",
    "Greater",
    "Trumpeter",
    "swan",
    "shoveler",
    "Ring",
    "Red",
    "hawk",
    "Evening",
    "grosbeak",
    "black",
    "Red",
    "blackbird",
    "woodcock",
    "White",
    "Barn",
    "swallow",
    "Wild",
    "turkey",
    "Brown",
    "cowbird",
    "Eastern",
    "bluebird",
    "flicker",
    "loon",
    "Gadwall",
    "white-fronted",
    "Monarch",
    "butterfly",
    "Painted",
    "lady",
    "Cabbage",
    "white",
    "Red",
    "admiral",
    "Gulf",
    "fritillary",
    "Eastern",
    "tiger",
    "swallowtail",
    "Mourning",
    "cloak",
    "Viceroy",
    "Black",
    "Common",
    "buckeye",
    "Cloudless",
    "sulphur",
    "Giant",
    "Swallowtail",
    "Great",
    "spangled",
    "Pipevine",
    "Spicebush",
    "American",
    "Gray",
    "hairstreak",
    "Orange",
    "Zebra",
    "Small",
    "copper",
    "wood",
    "nymph",
    "Domestic",
    "silk",
    "moth",
    "Aphrodite",
    "Apollo",
    "Ares",
    "Artemis",
    "Athena",
    "Demeter",
    "Dionysus",
    "Hades",
    "Pluto",
    "Hephaestus",
    "Hera",
    "Hermes",
    "Hestia",
    "Poseidon",
    "Zeus",
    "Limenitis",
    "arthemis",
    "Butterfly",
    "weed",
    "blue",
    "tailed",
    "Clouded",
    "comma",
    "Variegated",
    "Edith",
    "checkerspot",
    "Pearl",
    "crescent",
    "milkweed",
    "Silver",
    "skipper",
    "Silvery",
    "blue",
    "Longwing",
    "Large",
    "heath",
    "Zerene",
    "Spring",
    "azure",
    "Question",
    "mark",
    "Baltimore",
    "Essex",
    "Swamp",
    "Boisduval",
    "Dreamy",
    "duskywing",
    "Tawny",
    "emperor",
    "Laurel",
    "pearl-bordered",
    "Green-veined",
    "Gypsy",
    "Moth",
    "Banded",
    "Melissa",
    "Sulphur",
    "Nostalgia",
    "Crocodile",
    "Aniseed",
    "Clover",
    "Urchin",
    "Strawberry",
    "Unicorn",
    "TropicBird",
    "frantic",
    "YellowRattle",
    "fishy",
    "tragic",
    "residence",
    "McGovernism",
    "wheelwrights",
    "PotHelmet",
    "torridness",
    "sarau",
    "mutism",
    "hogans",
    "shrublet",
    "libertines",
    "House",
    "bacons",
    "pasterns",
    "kutum",
    "luger",
    "wingnut",
    "screw",
    "tank",
    "steamer",
    "BenchScrew",
    "advancing",
    "addressability",
    "Tamashek",
    "tibicen",
    "pawnbroking",
    "TankSteamer",
    "gelidity",
    "premier",
    "bookshelves",
    "seiner",
    "gametocytes",
    "hair-raiser",
    "fairways",
    "Gielgud",
    "springbuck",
    "Walesa",
    "numerology",
    "J-pop",
    "swallowtails",
    "field",
    "fallow",
    "reclination",
    "parturience",
    "drudge",
    "sheikdom",
    "poker",
    "staithe",
    "viciosity",
    "challah",
    "ochlocracies",
    "thumbkin",
    "trichome",
    "usualness",
    "atelocollagen",
    "snake",
    "lizard",
    "redistillation",
    "designs",
    "guardant",
    "craniopagus",
    "txtspk",
    "chymistry",
    "rheotomes",
    "formene",
    "journeyman",
    "cow",
    "killer",
    "permanency",
    "Barthelme",
    "tortoise",
    "shell",
    "conpersons",
    "Hudson River",
    "leaven",
    "sennit",
    "vinasse",
    "bucky",
    "monger",
    "species",
    "station",
    "deathblows",
    "zingers",
    "arrondissement",
    "steroids",
    "tuyere",
    "tusks",
    "discussion",
    "derri\xe8re",
    "speed",
    "squaloids",
    "slapdash",
    "buckthorn",
    "infotainment",
    "annexes",
    "ursidae",
    "drypoints",
    "antithetic",
    "punto",
    "permissivity",
    "labrum",
    "geezer",
    "pellicularia",
    "beguinage",
    "consonant",
    "compositing",
    "fifties",
    "selectwoman",
    "shroud",
    "accouchement",
    "wastepaper",
    "marrot",
    "baddeleyite",
    "aidance",
    "testing",
    "mouflon",
    "Polynesians",
    "uninitiated",
    "nucleole",
    "halesia",
    "Descartes",
    "relentlessness",
    "calycle",
    "merit",
    "abreaction",
    "willing",
    "cocagne",
    "bitches",
    "yardman",
    "zymogen",
    "torchlight",
    "fashioning",
    "ephemera",
    "flutterer",
    "banjax",
    "acquaintedness",
    "ratting",
    "Esther",
    "decypher",
    "comfortlessness",
    "fourteen",
    "generatrix",
    "speaking",
    "provection",
    "hired",
    "demarch",
    "cajolery",
    "confects",
    "vaccinia",
    "rethor",
    "28",
    "quillon",
    "Baffin",
    "Island",
    "solidarit\xe9",
    "mandibulate",
    "wainscots",
    "adytum",
    "chati",
    "murex",
    "tracksuit",
    "favorability",
    "lament",
    "abluent",
    "dining",
    "mofussil",
    "william cowper",
    "records",
    "annamite",
    "distinguishment",
    "compeer",
    "jaundice",
    "nervus",
    "taker",
    "salaams",
    "cut",
    "Southdown",
    "trainbearer",
    "cultivator",
    "Skraeling",
    "fortunes",
    "major",
    "switches",
    "gecko",
    "trigonal",
    "Benedictus",
    "sentences",
    "coruscation",
    "organist",
    "conveyance",
    "thana",
    "misclaim",
    "wainscot",
    "saltern",
    "palkee",
    "anabiosis",
    "rotunda",
    "cetacean",
    "pearl",
    "catholicon",
    "sircar",
    "alimony",
    "empery",
    "russet",
    "nonlending",
    "wolverene",
    "reindeer",
    "unemployed",
    "turbine",
    "bragget",
    "subduedness",
    "vitelline",
    "nephridium",
    "convoy",
    "bulldust",
    "vulcano",
    "Judea",
    "zygapophysis",
    "troglodytes",
    "drugger",
    "daily",
    "trolly",
    "assegai",
    "cornetcy",
    "trophallaxis",
    "recreant",
    "Ellison",
    "Cameroun",
    "jabberwocky",
    "cornhole",
    "stocker",
    "familist",
    "renitence",
    "rheotaxis",
    "underlie",
    "virago",
    "hybridizer",
    "trifler",
    "obliviousness",
    "tow",
    "shears",
    "nappy",
    "polyphosphate",
    "immense",
    "ditty",
    "programme",
    "recoat",
    "pompholyx",
    "pneuma",
    "asperser",
    "phycis",
    "hydrocyanide",
    "octogenarian",
    "etesian",
    "distractor",
    "ineptitude",
    "milkshake",
    "visite",
    "leishmaniasis",
    "clomipramine",
    "breadstick",
    "pinole",
    "incivility",
    "parascenium",
    "broomstaff",
    "aichmophobia",
    "piggery",
    "Muscovian",
    "conjecturally",
    "fumage",
    "weasel",
    "sorts",
    "house",
    "customs",
    "hippopus",
    "jackdaw",
    "perversity",
    "premier",
    "Dutchman",
    "imperf",
    "jumpiness",
    "hook",
    "maomao",
    "unceasingly",
    "pickerel",
    "weed",
    "melodist",
    "Austria",
    "supawn",
    "zechin",
    "valerianella",
    "ladder",
    "scarab\xe6us",
    "slime",
    "triplicate",
    "nattiness",
    "guy",
    "winter",
    "summer",
    "autumn",
    "spring",
    "fall",
    "Albion",
    "liquidity",
    "snail",
    "psychodynamics",
    "halothane",
    "trader",
    "gruff",
    "tidesman",
    "firestone",
    "prosoma",
    "goat"
];
const $daea8857587ede6a$var$randomItem = (arr)=>{
    const item = arr[Math.floor(Math.random() * arr.length)];
    return item.slice(0, 1).toUpperCase() + item.slice(1);
};
function $daea8857587ede6a$export$2e2bcd8739ae039() {
    const seed = Math.random();
    if (seed <= 0.25) return `${$daea8857587ede6a$var$randomItem($daea8857587ede6a$var$ADJECTIVES)}${$daea8857587ede6a$var$randomItem($daea8857587ede6a$var$NOUNS)}`;
    else if (seed <= 0.5) return `${$daea8857587ede6a$var$randomItem($daea8857587ede6a$var$NOUNS)}${$daea8857587ede6a$var$randomItem($daea8857587ede6a$var$NOUNS)}`;
    else if (seed <= 0.75) return `${$daea8857587ede6a$var$randomItem($daea8857587ede6a$var$NOUNS)}`;
    else return `${$daea8857587ede6a$var$randomItem($daea8857587ede6a$var$ADJECTIVES)}`;
}

});

parcelRegister("jn472", function(module, exports) {


!function(e, t) {
    module.exports = t((parcelRequire("ecd4d")), (parcelRequire("5zOsi")));
}(module.exports, function(n, o) {
    var i, a;
    return a = {}, r.m = i = [
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.default = (e, t)=>{
                const n = e.__vccOpts || e;
                for (var [o, r] of t)n[o] = r;
                return n;
            };
        },
        function(e, t) {
            e.exports = n;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            a(n(1));
            var o = a(n(22)), r = a(n(42)), i = n(43);
            function a(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            t.default = {
                name: "JsonViewer",
                components: {
                    JsonBox: o.default
                },
                props: {
                    value: {
                        type: [
                            Object,
                            Array,
                            String,
                            Number,
                            Boolean,
                            Function
                        ],
                        required: !0
                    },
                    expanded: {
                        type: Boolean,
                        default: !1
                    },
                    expandDepth: {
                        type: Number,
                        default: 1
                    },
                    copyable: {
                        type: [
                            Boolean,
                            Object
                        ],
                        default: !1
                    },
                    sort: {
                        type: Boolean,
                        default: !1
                    },
                    boxed: {
                        type: Boolean,
                        default: !1
                    },
                    theme: {
                        type: String,
                        default: "jv-light"
                    },
                    timeformat: {
                        type: Function,
                        default: function(e) {
                            return e.toLocaleString();
                        }
                    },
                    previewMode: {
                        type: Boolean,
                        default: !1
                    },
                    showArrayIndex: {
                        type: Boolean,
                        default: !0
                    },
                    showDoubleQuotes: {
                        type: Boolean,
                        default: !1
                    }
                },
                provide: function() {
                    return {
                        expandDepth: this.expandDepth,
                        timeformat: this.timeformat,
                        onKeyclick: this.onKeyclick
                    };
                },
                data: function() {
                    return {
                        copied: !1,
                        expandableCode: !1,
                        expandCode: this.expanded
                    };
                },
                computed: {
                    jvClass: function() {
                        return "jv-container " + this.theme + (this.boxed ? " boxed" : "");
                    },
                    copyText: function() {
                        var e = this.copyable;
                        return {
                            copyText: e.copyText || "copy",
                            copiedText: e.copiedText || "copied!",
                            timeout: e.timeout || 2e3,
                            align: e.align
                        };
                    }
                },
                watch: {
                    value: function() {
                        this.onResized();
                    }
                },
                mounted: function() {
                    var t = this;
                    this.debounceResized = (0, i.debounce)(this.debResized.bind(this), 200), this.boxed && this.$refs.jsonBox && (this.onResized(), this.$refs.jsonBox.$el.addEventListener("resized", this.onResized, !0)), this.copyable && new r.default(this.$refs.clip, {
                        container: this.$refs.viewer,
                        text: function() {
                            return JSON.stringify(t.value, null, 2);
                        }
                    }).on("success", function(e) {
                        t.onCopied(e);
                    });
                },
                methods: {
                    onResized: function() {
                        this.debounceResized();
                    },
                    debResized: function() {
                        var e = this;
                        this.$nextTick(function() {
                            e.$refs.jsonBox && (250 <= e.$refs.jsonBox.$el.clientHeight ? e.expandableCode = !0 : e.expandableCode = !1);
                        });
                    },
                    onCopied: function(e) {
                        var t = this;
                        this.copied || (this.copied = !0, setTimeout(function() {
                            t.copied = !1;
                        }, this.copyText.timeout), this.$emit("copied", e));
                    },
                    toggleExpandCode: function() {
                        this.expandCode = !this.expandCode;
                    },
                    onKeyclick: function(e) {
                        this.$emit("keyclick", e);
                    }
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, i = n(1), a = o(n(31)), s = o(n(32)), u = o(n(33)), l = o(n(34)), c = o(n(35)), d = o(n(36)), f = o(n(37)), p = o(n(38));
            function o(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            t.default = {
                name: "JsonBox",
                inject: [
                    "expandDepth",
                    "onKeyclick"
                ],
                props: {
                    value: {
                        type: [
                            Object,
                            Array,
                            String,
                            Number,
                            Boolean,
                            Function,
                            Date
                        ],
                        default: null
                    },
                    keyName: {
                        type: String,
                        default: ""
                    },
                    sort: Boolean,
                    depth: {
                        type: Number,
                        default: 0
                    },
                    previewMode: Boolean,
                    forceExpand: Boolean,
                    showArrayIndex: Boolean,
                    showDoubleQuotes: Boolean,
                    path: {
                        type: String,
                        default: "$"
                    }
                },
                data: function() {
                    return {
                        expand: !0,
                        forceExpandMe: this.forceExpand
                    };
                },
                mounted: function() {
                    this.expand = this.previewMode || !(this.depth >= this.expandDepth) || this.forceExpandMe;
                },
                methods: {
                    toggle: function() {
                        this.expand = !this.expand, this.dispatchEvent();
                    },
                    toggleAll: function() {
                        this.expand = !this.expand, this.forceExpandMe = this.expand, this.dispatchEvent();
                    },
                    dispatchEvent: function() {
                        try {
                            this.$el.dispatchEvent(new Event("resized"));
                        } catch (e) {
                            var t = document.createEvent("Event");
                            t.initEvent("resized", !0, !1), this.$el.dispatchEvent(t);
                        }
                    },
                    getPath: function() {
                        for(var e = [
                            this.keyName
                        ], t = this.$parent; t.depth;)t.$el.classList.contains("jv-node") && e.push(t.keyName), t = t.$parent;
                        return e.reverse();
                    }
                },
                render: function() {
                    var t = this, e = [], n = void 0;
                    null === this.value || void 0 === this.value ? n = s.default : Array.isArray(this.value) ? n = d.default : "[object Date]" === Object.prototype.toString.call(this.value) ? n = p.default : "object" === r(this.value) ? n = c.default : "number" == typeof this.value ? n = u.default : "string" == typeof this.value ? n = a.default : "boolean" == typeof this.value ? n = l.default : "function" == typeof this.value && (n = f.default);
                    var o = this.keyName && this.value && (Array.isArray(this.value) || "object" === r(this.value) && "[object Date]" !== Object.prototype.toString.call(this.value));
                    return !this.previewMode && o && e.push((0, i.h)("span", {
                        class: {
                            "jv-toggle": !0,
                            open: !!this.expand
                        },
                        onClick: function(e) {
                            e.altKey ? t.toggleAll() : t.toggle();
                        }
                    })), this.keyName && e.push((0, i.h)("span", {
                        class: {
                            "jv-key": !0
                        },
                        innerText: this.showDoubleQuotes ? '"' + this.keyName + '":' : this.keyName + ":",
                        onClick: function() {
                            t.onKeyclick(t.path);
                        }
                    })), e.push((0, i.h)(n, {
                        class: {
                            "jv-push": !0
                        },
                        jsonValue: this.value,
                        keyName: this.keyName,
                        sort: this.sort,
                        depth: this.depth,
                        expand: this.expand,
                        previewMode: this.previewMode,
                        forceExpand: this.forceExpandMe,
                        showArrayIndex: this.showArrayIndex,
                        showDoubleQuotes: this.showDoubleQuotes,
                        path: this.path,
                        "onUpdate:expand": function(e) {
                            t.expand = e;
                        },
                        "onUpdate:expandAll": function(e) {
                            t.expand = e, t.forceExpandMe = t.expand;
                        }
                    })), (0, i.h)("div", {
                        class: {
                            "jv-node": !0,
                            "jv-key-node": Boolean(this.keyName) && !o,
                            toggle: !this.previewMode && o
                        }
                    }, e);
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = n(1), r = /^\w+:\/\//;
            t.default = {
                name: "JsonString",
                props: {
                    jsonValue: {
                        type: String,
                        required: !0
                    }
                },
                data: function() {
                    return {
                        expand: !0,
                        canExtend: !1
                    };
                },
                mounted: function() {
                    this.$refs.itemRef.offsetHeight > this.$refs.holderRef.offsetHeight && (this.canExtend = !0);
                },
                methods: {
                    toggle: function() {
                        this.expand = !this.expand;
                    }
                },
                render: function() {
                    var e = this.jsonValue, t = r.test(e), n = void 0;
                    return this.expand ? (n = {
                        class: {
                            "jv-item": !0,
                            "jv-string": !0
                        },
                        ref: "itemRef"
                    }, t ? n.innerHTML = '"' + (e = '<a href="' + e + '" target="_blank" class="jv-link">' + e + "</a>").toString() + '"' : n.innerText = '"' + e.toString() + '"') : n = {
                        class: {
                            "jv-ellipsis": !0
                        },
                        onClick: this.toggle,
                        innerText: "..."
                    }, (0, o.h)("span", {}, [
                        this.canExtend && (0, o.h)("span", {
                            class: {
                                "jv-toggle": !0,
                                open: this.expand
                            },
                            onClick: this.toggle
                        }),
                        (0, o.h)("span", {
                            class: {
                                "jv-holder-node": !0
                            },
                            ref: "holderRef"
                        }),
                        (0, o.h)("span", n)
                    ]);
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = n(1);
            t.default = {
                name: "JsonUndefined",
                functional: !0,
                props: {
                    jsonValue: {
                        type: Object,
                        default: null
                    }
                },
                render: function() {
                    return (0, o.h)("span", {
                        class: {
                            "jv-item": !0,
                            "jv-undefined": !0
                        },
                        innerText: null === this.jsonValue ? "null" : "undefined"
                    });
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = n(1);
            t.default = {
                name: "JsonNumber",
                functional: !0,
                props: {
                    jsonValue: {
                        type: Number,
                        required: !0
                    }
                },
                render: function() {
                    var e = Number.isInteger(this.jsonValue);
                    return (0, o.h)("span", {
                        class: {
                            "jv-item": !0,
                            "jv-number": !0,
                            "jv-number-integer": e,
                            "jv-number-float": !e
                        },
                        innerText: this.jsonValue.toString()
                    });
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = n(1);
            t.default = {
                name: "JsonBoolean",
                functional: !0,
                props: {
                    jsonValue: Boolean
                },
                render: function() {
                    return (0, o.h)("span", {
                        class: {
                            "jv-item": !0,
                            "jv-boolean": !0
                        },
                        innerText: this.jsonValue.toString()
                    });
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var r = n(1), n = n(22), i = n && n.__esModule ? n : {
                default: n
            };
            t.default = {
                name: "JsonObject",
                props: {
                    jsonValue: {
                        type: Object,
                        required: !0
                    },
                    keyName: {
                        type: String,
                        default: ""
                    },
                    depth: {
                        type: Number,
                        default: 0
                    },
                    expand: Boolean,
                    forceExpand: Boolean,
                    sort: Boolean,
                    previewMode: Boolean,
                    showArrayIndex: Boolean,
                    showDoubleQuotes: Boolean,
                    path: String
                },
                data: function() {
                    return {
                        value: {}
                    };
                },
                computed: {
                    ordered: function() {
                        var t = this;
                        if (!this.sort) return this.value;
                        var n = {};
                        return Object.keys(this.value).sort().forEach(function(e) {
                            n[e] = t.value[e];
                        }), n;
                    }
                },
                watch: {
                    jsonValue: function(e) {
                        this.setValue(e);
                    }
                },
                mounted: function() {
                    this.setValue(this.jsonValue);
                },
                methods: {
                    setValue: function(e) {
                        var t = this;
                        setTimeout(function() {
                            t.value = e;
                        }, 0);
                    },
                    toggle: function() {
                        this.$emit("update:expand", !this.expand), this.dispatchEvent();
                    },
                    toggleAll: function() {
                        this.$emit("update:expandAll", !this.expand), this.dispatchEvent();
                    },
                    dispatchEvent: function() {
                        try {
                            this.$el.dispatchEvent(new Event("resized"));
                        } catch (e) {
                            var t = document.createEvent("Event");
                            t.initEvent("resized", !0, !1), this.$el.dispatchEvent(t);
                        }
                    }
                },
                render: function() {
                    var e, t = this, n = [];
                    if (this.previewMode || this.keyName || n.push((0, r.h)("span", {
                        class: {
                            "jv-toggle": !0,
                            open: !!this.expand
                        },
                        onClick: function(e) {
                            e.altKey ? t.toggleAll() : t.toggle();
                        }
                    })), n.push((0, r.h)("span", {
                        class: {
                            "jv-item": !0,
                            "jv-object": !0
                        },
                        innerText: "{"
                    })), this.expand) for(var o in this.ordered)this.ordered.hasOwnProperty(o) && (e = this.ordered[o], n.push((0, r.h)(i.default, {
                        key: o,
                        style: {
                            display: this.expand ? void 0 : "none"
                        },
                        sort: this.sort,
                        keyName: o,
                        depth: this.depth + 1,
                        value: e,
                        previewMode: this.previewMode,
                        forceExpand: this.forceExpand,
                        showArrayIndex: this.showArrayIndex,
                        showDoubleQuotes: this.showDoubleQuotes,
                        path: this.path + "." + o
                    })));
                    return !this.expand && Object.keys(this.value).length && n.push((0, r.h)("span", {
                        class: {
                            "jv-ellipsis": !0
                        },
                        onClick: function(e) {
                            e.altKey ? t.toggleAll() : t.toggle();
                        },
                        title: "click to reveal object content (keys: " + Object.keys(this.ordered).join(", ") + ")",
                        innerText: "..."
                    })), n.push((0, r.h)("span", {
                        class: {
                            "jv-item": !0,
                            "jv-object": !0
                        },
                        innerText: "}"
                    })), (0, r.h)("span", n);
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var r = n(1), n = n(22), i = n && n.__esModule ? n : {
                default: n
            };
            t.default = {
                name: "JsonArray",
                props: {
                    jsonValue: {
                        type: Array,
                        required: !0
                    },
                    keyName: {
                        type: String,
                        default: ""
                    },
                    depth: {
                        type: Number,
                        default: 0
                    },
                    sort: Boolean,
                    expand: Boolean,
                    forceExpand: Boolean,
                    previewMode: Boolean,
                    showArrayIndex: Boolean,
                    showDoubleQuotes: Boolean,
                    path: String
                },
                data: function() {
                    return {
                        value: []
                    };
                },
                watch: {
                    jsonValue: function(e) {
                        this.setValue(e);
                    }
                },
                mounted: function() {
                    this.setValue(this.jsonValue);
                },
                methods: {
                    setValue: function(e) {
                        var t = this, n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0;
                        0 === n && (this.value = []), setTimeout(function() {
                            e.length > n && (t.value.push(e[n]), t.setValue(e, n + 1));
                        }, 0);
                    },
                    toggle: function() {
                        this.$emit("update:expand", !this.expand), this.dispatchEvent();
                    },
                    toggleAll: function() {
                        this.$emit("update:expandAll", !this.expand), this.dispatchEvent();
                    },
                    dispatchEvent: function() {
                        try {
                            this.$el.dispatchEvent(new Event("resized"));
                        } catch (e) {
                            var t = document.createEvent("Event");
                            t.initEvent("resized", !0, !1), this.$el.dispatchEvent(t);
                        }
                    }
                },
                render: function() {
                    var n = this, o = [];
                    return this.previewMode || this.keyName || o.push((0, r.h)("span", {
                        class: {
                            "jv-toggle": !0,
                            open: !!this.expand
                        },
                        onClick: function(e) {
                            e.altKey ? n.toggleAll() : n.toggle();
                        }
                    })), o.push((0, r.h)("span", {
                        class: {
                            "jv-item": !0,
                            "jv-array": !0
                        },
                        innerText: "["
                    })), this.expand && this.value.forEach(function(e, t) {
                        o.push((0, r.h)(i.default, {
                            key: t,
                            style: {
                                display: n.expand ? void 0 : "none"
                            },
                            sort: n.sort,
                            keyName: n.showArrayIndex ? "" + t : "",
                            depth: n.depth + 1,
                            value: e,
                            previewMode: n.previewMode,
                            forceExpand: n.forceExpand,
                            showArrayIndex: n.showArrayIndex,
                            showDoubleQuotes: n.showDoubleQuotes,
                            path: n.path + "." + t
                        }));
                    }), !this.expand && this.value.length && o.push((0, r.h)("span", {
                        class: {
                            "jv-ellipsis": !0
                        },
                        onClick: function(e) {
                            e.altKey ? n.toggleAll() : n.toggle();
                        },
                        title: "click to reveal " + this.value.length + " hidden items",
                        innerText: "..."
                    })), o.push((0, r.h)("span", {
                        class: {
                            "jv-item": !0,
                            "jv-array": !0
                        },
                        innerText: "]"
                    })), (0, r.h)("span", o);
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = n(1);
            t.default = {
                name: "JsonFunction",
                functional: !0,
                props: {
                    jsonValue: {
                        type: Function,
                        required: !0
                    }
                },
                render: function() {
                    return (0, o.h)("span", {
                        class: {
                            "jv-item": !0,
                            "jv-function": !0
                        },
                        attrs: {
                            title: this.jsonValue.toString()
                        },
                        innerHTML: "&lt;function&gt;"
                    });
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = n(1);
            t.default = {
                name: "JsonDate",
                inject: [
                    "timeformat"
                ],
                functional: !0,
                props: {
                    jsonValue: {
                        type: Date,
                        required: !0
                    }
                },
                render: function() {
                    var e = this.jsonValue, t = this.timeformat;
                    return (0, o.h)("span", {
                        class: {
                            "jv-item": !0,
                            "jv-string": !0
                        },
                        innerText: '"' + t(e) + '"'
                    });
                }
            };
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(2), i = n.n(r);
            for(o in n.d(t, "default", function() {
                return i.a;
            }), r)[
                "default",
                "default"
            ].indexOf(o) < 0 && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(3), i = n.n(r);
            for(o in n.d(t, "default", function() {
                return i.a;
            }), r)[
                "default",
                "default"
            ].indexOf(o) < 0 && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(4), i = n.n(r);
            for(o in n.d(t, "default", function() {
                return i.a;
            }), r)[
                "default",
                "default"
            ].indexOf(o) < 0 && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(5), i = n.n(r);
            for(o in n.d(t, "default", function() {
                return i.a;
            }), r)[
                "default",
                "default"
            ].indexOf(o) < 0 && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(6), i = n.n(r);
            for(o in n.d(t, "default", function() {
                return i.a;
            }), r)[
                "default",
                "default"
            ].indexOf(o) < 0 && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(7), i = n.n(r);
            for(o in n.d(t, "default", function() {
                return i.a;
            }), r)[
                "default",
                "default"
            ].indexOf(o) < 0 && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(8), i = n.n(r);
            for(o in n.d(t, "default", function() {
                return i.a;
            }), r)[
                "default",
                "default"
            ].indexOf(o) < 0 && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(9), i = n.n(r);
            for(o in n.d(t, "default", function() {
                return i.a;
            }), r)[
                "default",
                "default"
            ].indexOf(o) < 0 && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(10), i = n.n(r);
            for(o in n.d(t, "default", function() {
                return i.a;
            }), r)[
                "default",
                "default"
            ].indexOf(o) < 0 && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(11), i = n.n(r);
            for(o in n.d(t, "default", function() {
                return i.a;
            }), r)[
                "default",
                "default"
            ].indexOf(o) < 0 && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(13);
            for(o in r)"default" !== o && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
            n(39);
            var i = n(0), i = n.n(i)()(r.default, [
                [
                    "__file",
                    "lib/json-box.vue"
                ]
            ]);
            t.default = i;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.render = function(e, t, n, o, r, i) {
                var a = (0, s.resolveComponent)("json-box");
                return (0, s.openBlock)(), (0, s.createElementBlock)("div", {
                    ref: "viewer",
                    class: (0, s.normalizeClass)(i.jvClass)
                }, [
                    n.copyable ? ((0, s.openBlock)(), (0, s.createElementBlock)("div", {
                        key: 0,
                        class: (0, s.normalizeClass)("jv-tooltip " + (i.copyText.align || "right"))
                    }, [
                        (0, s.createElementVNode)("span", {
                            ref: "clip",
                            class: (0, s.normalizeClass)([
                                "jv-button",
                                {
                                    copied: r.copied
                                }
                            ])
                        }, [
                            (0, s.renderSlot)(e.$slots, "copy", {
                                copied: r.copied
                            }, function() {
                                return [
                                    (0, s.createTextVNode)((0, s.toDisplayString)(r.copied ? i.copyText.copiedText : i.copyText.copyText), 1)
                                ];
                            })
                        ], 2)
                    ], 2)) : (0, s.createCommentVNode)("v-if", !0),
                    (0, s.createElementVNode)("div", {
                        class: (0, s.normalizeClass)([
                            "jv-code",
                            {
                                open: r.expandCode,
                                boxed: n.boxed
                            }
                        ])
                    }, [
                        (0, s.createVNode)(a, {
                            ref: "jsonBox",
                            value: n.value,
                            sort: n.sort,
                            "preview-mode": n.previewMode,
                            "show-array-index": n.showArrayIndex,
                            "show-double-quotes": n.showDoubleQuotes,
                            onKeyclick: i.onKeyclick
                        }, null, 8, [
                            "value",
                            "sort",
                            "preview-mode",
                            "show-array-index",
                            "show-double-quotes",
                            "onKeyclick"
                        ])
                    ], 2),
                    r.expandableCode && n.boxed ? ((0, s.openBlock)(), (0, s.createElementBlock)("div", {
                        key: 1,
                        class: "jv-more",
                        onClick: t[0] || (t[0] = function() {
                            return i.toggleExpandCode && i.toggleExpandCode.apply(i, arguments);
                        })
                    }, [
                        (0, s.createElementVNode)("span", {
                            class: (0, s.normalizeClass)([
                                "jv-toggle",
                                {
                                    open: !!r.expandCode
                                }
                            ])
                        }, null, 2)
                    ])) : (0, s.createCommentVNode)("v-if", !0)
                ], 2);
            };
            var s = n(1);
        },
        function(e, t, n) {
            var o = n(40);
            "string" == typeof o && (o = [
                [
                    e.i,
                    o,
                    ""
                ]
            ]);
            var r = {
                hmr: !0,
                transform: void 0
            };
            n(26)(o, r);
            o.locals && (e.exports = o.locals);
        },
        function(e, t, n) {
            "use strict";
            e.exports = function(n) {
                var u = [];
                return u.toString = function() {
                    return this.map(function(e) {
                        var t = function(e, t) {
                            var n = e[1] || "", o = e[3];
                            if (!o) return n;
                            if (t && "function" == typeof btoa) {
                                e = function(e) {
                                    e = btoa(unescape(encodeURIComponent(JSON.stringify(e)))), e = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(e);
                                    return "/*# ".concat(e, " */");
                                }(o), t = o.sources.map(function(e) {
                                    return "/*# sourceURL=".concat(o.sourceRoot || "").concat(e, " */");
                                });
                                return [
                                    n
                                ].concat(t).concat([
                                    e
                                ]).join("\n");
                            }
                            return [
                                n
                            ].join("\n");
                        }(e, n);
                        return e[2] ? "@media ".concat(e[2], " {").concat(t, "}") : t;
                    }).join("");
                }, u.i = function(e, t, n) {
                    "string" == typeof e && (e = [
                        [
                            null,
                            e,
                            ""
                        ]
                    ]);
                    var o = {};
                    if (n) for(var r = 0; r < this.length; r++){
                        var i = this[r][0];
                        null != i && (o[i] = !0);
                    }
                    for(var a = 0; a < e.length; a++){
                        var s = [].concat(e[a]);
                        n && o[s[0]] || (t && (s[2] ? s[2] = "".concat(t, " and ").concat(s[2]) : s[2] = t), u.push(s));
                    }
                }, u;
            };
        },
        function(e, t, n) {
            var o, r, i, u = {}, l = (o = function() {
                return window && document && document.all && !window.atob;
            }, function() {
                return r = void 0 === r ? o.apply(this, arguments) : r;
            }), a = (i = {}, function(e) {
                if (void 0 === i[e]) {
                    var t = (function(e) {
                        return document.querySelector(e);
                    }).call(this, e);
                    if (t instanceof window.HTMLIFrameElement) try {
                        t = t.contentDocument.head;
                    } catch (e) {
                        t = null;
                    }
                    i[e] = t;
                }
                return i[e];
            }), s = null, c = 0, d = [], f = n(41);
            function p(e, t) {
                for(var n = 0; n < e.length; n++){
                    var o = e[n], r = u[o.id];
                    if (r) {
                        r.refs++;
                        for(var i = 0; i < r.parts.length; i++)r.parts[i](o.parts[i]);
                        for(; i < o.parts.length; i++)r.parts.push(y(o.parts[i], t));
                    } else {
                        for(var a = [], i = 0; i < o.parts.length; i++)a.push(y(o.parts[i], t));
                        u[o.id] = {
                            id: o.id,
                            refs: 1,
                            parts: a
                        };
                    }
                }
            }
            function v(e, t) {
                for(var n = [], o = {}, r = 0; r < e.length; r++){
                    var i = e[r], a = t.base ? i[0] + t.base : i[0], i = {
                        css: i[1],
                        media: i[2],
                        sourceMap: i[3]
                    };
                    o[a] ? o[a].parts.push(i) : n.push(o[a] = {
                        id: a,
                        parts: [
                            i
                        ]
                    });
                }
                return n;
            }
            function h(e, t) {
                var n = a(e.insertInto);
                if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
                var o = d[d.length - 1];
                if ("top" === e.insertAt) o ? o.nextSibling ? n.insertBefore(t, o.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), d.push(t);
                else if ("bottom" === e.insertAt) n.appendChild(t);
                else {
                    if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
                    e = a(e.insertInto + " " + e.insertAt.before);
                    n.insertBefore(t, e);
                }
            }
            function b(e) {
                null !== e.parentNode && (e.parentNode.removeChild(e), 0 <= (e = d.indexOf(e)) && d.splice(e, 1));
            }
            function j(e) {
                var t = document.createElement("style");
                return e.attrs.type = "text/css", g(t, e.attrs), h(e, t), t;
            }
            function g(t, n) {
                Object.keys(n).forEach(function(e) {
                    t.setAttribute(e, n[e]);
                });
            }
            function y(t, e) {
                var n, o, r, i, a;
                if (e.transform && t.css) {
                    if (!(i = e.transform(t.css))) return function() {};
                    t.css = i;
                }
                return r = e.singleton ? (a = c++, n = s = s || j(e), o = w.bind(null, n, a, !1), w.bind(null, n, a, !0)) : t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (i = e, a = document.createElement("link"), i.attrs.type = "text/css", i.attrs.rel = "stylesheet", g(a, i.attrs), h(i, a), n = a, o = (function(e, t, n) {
                    var o = n.css, r = n.sourceMap, n = void 0 === t.convertToAbsoluteUrls && r;
                    (t.convertToAbsoluteUrls || n) && (o = f(o));
                    r && (o += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */");
                    r = new Blob([
                        o
                    ], {
                        type: "text/css"
                    }), o = e.href;
                    e.href = URL.createObjectURL(r), o && URL.revokeObjectURL(o);
                }).bind(null, n, e), function() {
                    b(n), n.href && URL.revokeObjectURL(n.href);
                }) : (n = j(e), o = (function(e, t) {
                    var n = t.css, t = t.media;
                    t && e.setAttribute("media", t);
                    if (e.styleSheet) e.styleSheet.cssText = n;
                    else {
                        for(; e.firstChild;)e.removeChild(e.firstChild);
                        e.appendChild(document.createTextNode(n));
                    }
                }).bind(null, n), function() {
                    b(n);
                }), o(t), function(e) {
                    e ? e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap || o(t = e) : r();
                };
            }
            e.exports = function(e, a) {
                if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
                (a = a || {}).attrs = "object" == typeof a.attrs ? a.attrs : {}, a.singleton || "boolean" == typeof a.singleton || (a.singleton = l()), a.insertInto || (a.insertInto = "head"), a.insertAt || (a.insertAt = "bottom");
                var s = v(e, a);
                return p(s, a), function(e) {
                    for(var t = [], n = 0; n < s.length; n++){
                        var o = s[n];
                        (r = u[o.id]).refs--, t.push(r);
                    }
                    e && p(v(e, a), a);
                    for(var r, n = 0; n < t.length; n++)if (0 === (r = t[n]).refs) {
                        for(var i = 0; i < r.parts.length; i++)r.parts[i]();
                        delete u[r.id];
                    }
                };
            };
            var m, x = (m = [], function(e, t) {
                return m[e] = t, m.filter(Boolean).join("\n");
            });
            function w(e, t, n, o) {
                var n = n ? "" : o.css;
                e.styleSheet ? e.styleSheet.cssText = x(t, n) : (o = document.createTextNode(n), (n = e.childNodes)[t] && e.removeChild(n[t]), n.length ? e.insertBefore(o, n[t]) : e.appendChild(o));
            }
        },
        function(e, t, n) {
            var o = n(45);
            "string" == typeof o && (o = [
                [
                    e.i,
                    o,
                    ""
                ]
            ]);
            var r = {
                hmr: !0,
                transform: void 0
            };
            n(26)(o, r);
            o.locals && (e.exports = o.locals);
        },
        function(e, t, n) {
            "use strict";
            var o = n(23);
            n.o(o, "render") && n.d(t, "render", function() {
                return o.render;
            });
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = n(30), o = n && n.__esModule ? n : {
                default: n
            };
            t.default = Object.assign(o.default, {
                install: function(e) {
                    e.component("JsonViewer", o.default);
                }
            });
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(28), i = n(12);
            for(o in i)"default" !== o && function(e) {
                n.d(t, e, function() {
                    return i[e];
                });
            }(o);
            n(44);
            var a = n(0), r = n.n(a)()(i.default, [
                [
                    "render",
                    r.render
                ],
                [
                    "__file",
                    "lib/json-viewer.vue"
                ]
            ]);
            t.default = r;
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(14);
            for(o in r)"default" !== o && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
            var i = n(0), i = n.n(i)()(r.default, [
                [
                    "__file",
                    "lib/types/json-string.vue"
                ]
            ]);
            t.default = i;
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(15);
            for(o in r)"default" !== o && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
            var i = n(0), i = n.n(i)()(r.default, [
                [
                    "__file",
                    "lib/types/json-undefined.vue"
                ]
            ]);
            t.default = i;
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(16);
            for(o in r)"default" !== o && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
            var i = n(0), i = n.n(i)()(r.default, [
                [
                    "__file",
                    "lib/types/json-number.vue"
                ]
            ]);
            t.default = i;
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(17);
            for(o in r)"default" !== o && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
            var i = n(0), i = n.n(i)()(r.default, [
                [
                    "__file",
                    "lib/types/json-boolean.vue"
                ]
            ]);
            t.default = i;
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(18);
            for(o in r)"default" !== o && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
            var i = n(0), i = n.n(i)()(r.default, [
                [
                    "__file",
                    "lib/types/json-object.vue"
                ]
            ]);
            t.default = i;
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(19);
            for(o in r)"default" !== o && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
            var i = n(0), i = n.n(i)()(r.default, [
                [
                    "__file",
                    "lib/types/json-array.vue"
                ]
            ]);
            t.default = i;
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(20);
            for(o in r)"default" !== o && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
            var i = n(0), i = n.n(i)()(r.default, [
                [
                    "__file",
                    "lib/types/json-function.vue"
                ]
            ]);
            t.default = i;
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, r = n(21);
            for(o in r)"default" !== o && function(e) {
                n.d(t, e, function() {
                    return r[e];
                });
            }(o);
            var i = n(0), i = n.n(i)()(r.default, [
                [
                    "__file",
                    "lib/types/json-date.vue"
                ]
            ]);
            t.default = i;
        },
        function(e, t, n) {
            "use strict";
            n(24);
        },
        function(e, t, n) {
            (t = n(25)(!1)).push([
                e.i,
                ".jv-node{position:relative}.jv-node:after{content:','}.jv-node:last-of-type:after{content:''}.jv-node.toggle{margin-left:13px !important}.jv-node .jv-node{margin-left:25px}\n",
                ""
            ]), e.exports = t;
        },
        function(e, t) {
            e.exports = function(e) {
                var t = "undefined" != typeof window && window.location;
                if (!t) throw new Error("fixUrls requires window.location");
                if (!e || "string" != typeof e) return e;
                var n = t.protocol + "//" + t.host, o = n + t.pathname.replace(/\/[^\/]*$/, "/");
                return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(e, t) {
                    var t = t.trim().replace(/^"(.*)"$/, function(e, t) {
                        return t;
                    }).replace(/^'(.*)'$/, function(e, t) {
                        return t;
                    });
                    return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(t) ? e : (t = 0 === t.indexOf("//") ? t : 0 === t.indexOf("/") ? n + t : o + t.replace(/^\.\//, ""), "url(" + JSON.stringify(t) + ")");
                });
            };
        },
        function(e, t) {
            e.exports = o;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            t.debounce = function(o, r) {
                var i = Date.now(), a = void 0;
                return function() {
                    for(var e = arguments.length, t = Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                    Date.now() - i < r && a && clearTimeout(a), a = setTimeout(function() {
                        o.apply(void 0, t);
                    }, r), i = Date.now();
                };
            };
        },
        function(e, t, n) {
            "use strict";
            n(27);
        },
        function(e, t, n) {
            var o = n(25), r = n(46), n = n(47);
            t = o(!1);
            n = r(n);
            t.push([
                e.i,
                ".jv-container{box-sizing:border-box;position:relative}.jv-container.boxed{border:1px solid #eee;border-radius:6px}.jv-container.boxed:hover{box-shadow:0 2px 7px rgba(0,0,0,0.15);border-color:transparent;position:relative}.jv-container.jv-light{background:#fff;white-space:nowrap;color:#525252;font-size:14px;font-family:Consolas, Menlo, Courier, monospace}.jv-container.jv-light .jv-ellipsis{color:#999;background-color:#eee;display:inline-block;line-height:0.9;font-size:0.9em;padding:0px 4px 2px 4px;margin:0 4px;border-radius:3px;vertical-align:2px;cursor:pointer;-webkit-user-select:none;user-select:none}.jv-container.jv-light .jv-button{color:#49b3ff}.jv-container.jv-light .jv-key{color:#111111;margin-right:4px}.jv-container.jv-light .jv-item.jv-array{color:#111111}.jv-container.jv-light .jv-item.jv-boolean{color:#fc1e70}.jv-container.jv-light .jv-item.jv-function{color:#067bca}.jv-container.jv-light .jv-item.jv-number{color:#fc1e70}.jv-container.jv-light .jv-item.jv-object{color:#111111}.jv-container.jv-light .jv-item.jv-undefined{color:#e08331}.jv-container.jv-light .jv-item.jv-string{color:#42b983;word-break:break-word;white-space:normal}.jv-container.jv-light .jv-item.jv-string .jv-link{color:#0366d6}.jv-container.jv-light .jv-code .jv-toggle:before{padding:0px 2px;border-radius:2px}.jv-container.jv-light .jv-code .jv-toggle:hover:before{background:#eee}.jv-container .jv-code{overflow:hidden;padding:30px 20px}.jv-container .jv-code.boxed{max-height:300px}.jv-container .jv-code.open{max-height:initial !important;overflow:visible;overflow-x:auto;padding-bottom:45px}.jv-container .jv-toggle{background-image:url(" + n + ');background-repeat:no-repeat;background-size:contain;background-position:center center;cursor:pointer;width:10px;height:10px;margin-right:2px;display:inline-block;-webkit-transition:-webkit-transform 0.1s;transition:-webkit-transform 0.1s;transition:transform 0.1s;transition:transform 0.1s, -webkit-transform 0.1s}.jv-container .jv-toggle.open{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.jv-container .jv-more{position:absolute;z-index:1;bottom:0;left:0;right:0;height:40px;width:100%;text-align:center;cursor:pointer}.jv-container .jv-more .jv-toggle{position:relative;top:40%;z-index:2;color:#888;-webkit-transition:all 0.1s;transition:all 0.1s;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.jv-container .jv-more .jv-toggle.open{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.jv-container .jv-more:after{content:"";width:100%;height:100%;position:absolute;bottom:0;left:0;z-index:1;background:-webkit-linear-gradient(top, rgba(0,0,0,0) 20%, rgba(230,230,230,0.3) 100%);background:linear-gradient(to bottom, rgba(0,0,0,0) 20%, rgba(230,230,230,0.3) 100%);-webkit-transition:all 0.1s;transition:all 0.1s}.jv-container .jv-more:hover .jv-toggle{top:50%;color:#111}.jv-container .jv-more:hover:after{background:-webkit-linear-gradient(top, rgba(0,0,0,0) 20%, rgba(230,230,230,0.3) 100%);background:linear-gradient(to bottom, rgba(0,0,0,0) 20%, rgba(230,230,230,0.3) 100%)}.jv-container .jv-button{position:relative;cursor:pointer;display:inline-block;padding:5px;z-index:5}.jv-container .jv-button.copied{opacity:0.4;cursor:default}.jv-container .jv-tooltip{position:absolute}.jv-container .jv-tooltip.right{right:15px}.jv-container .jv-tooltip.left{left:15px}.jv-container .j-icon{font-size:12px}\n',
                ""
            ]), e.exports = t;
        },
        function(e, t, n) {
            "use strict";
            e.exports = function(e, t) {
                return t = t || {}, "string" != typeof (e = e && e.__esModule ? e.default : e) ? e : (/^['"].*['"]$/.test(e) && (e = e.slice(1, -1)), t.hash && (e += t.hash), /["'() \t\n]/.test(e) || t.needQuotes ? '"'.concat(e.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : e);
            };
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjE2IiB3aWR0aD0iOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KIAo8cG9seWdvbiBwb2ludHM9IjAsMCA4LDggMCwxNiIKc3R5bGU9ImZpbGw6IzY2NjtzdHJva2U6cHVycGxlO3N0cm9rZS13aWR0aDowIiAvPgo8L3N2Zz4=";
        }
    ], r.c = a, r.d = function(e, t, n) {
        r.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: n
        });
    }, r.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, r.t = function(t, e) {
        if (1 & e && (t = r(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: t
        }), 2 & e && "string" != typeof t) for(var o in t)r.d(n, o, (function(e) {
            return t[e];
        }).bind(null, o));
        return n;
    }, r.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return r.d(t, "a", t), t;
    }, r.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 29);
    function r(e) {
        if (a[e]) return a[e].exports;
        var t = a[e] = {
            i: e,
            l: !1,
            exports: {}
        };
        return i[e].call(t.exports, t, t.exports, r), t.l = !0, t.exports;
    }
});

});
parcelRegister("5zOsi", function(module, exports) {
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 686: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "default": function() {
                        return /* binding */ clipboard;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
                var tiny_emitter = __webpack_require__(279);
                var tiny_emitter_default = /*#__PURE__*/ __webpack_require__.n(tiny_emitter);
                // EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
                var listen = __webpack_require__(370);
                var listen_default = /*#__PURE__*/ __webpack_require__.n(listen);
                // EXTERNAL MODULE: ./node_modules/select/src/select.js
                var src_select = __webpack_require__(817);
                var select_default = /*#__PURE__*/ __webpack_require__.n(src_select);
                /**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */ function command(type) {
                    try {
                        return document.execCommand(type);
                    } catch (err) {
                        return false;
                    }
                }
                /**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */ var ClipboardActionCut = function ClipboardActionCut(target) {
                    var selectedText = select_default()(target);
                    command("cut");
                    return selectedText;
                };
                /* harmony default export */ var actions_cut = ClipboardActionCut;
                /**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */ function createFakeElement(value) {
                    var isRTL = document.documentElement.getAttribute("dir") === "rtl";
                    var fakeElement = document.createElement("textarea"); // Prevent zooming on iOS
                    fakeElement.style.fontSize = "12pt"; // Reset box model
                    fakeElement.style.border = "0";
                    fakeElement.style.padding = "0";
                    fakeElement.style.margin = "0"; // Move element out of screen horizontally
                    fakeElement.style.position = "absolute";
                    fakeElement.style[isRTL ? "right" : "left"] = "-9999px"; // Move element to the same position vertically
                    var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                    fakeElement.style.top = "".concat(yPosition, "px");
                    fakeElement.setAttribute("readonly", "");
                    fakeElement.value = value;
                    return fakeElement;
                }
                /**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */ var fakeCopyAction = function fakeCopyAction(value, options) {
                    var fakeElement = createFakeElement(value);
                    options.container.appendChild(fakeElement);
                    var selectedText = select_default()(fakeElement);
                    command("copy");
                    fakeElement.remove();
                    return selectedText;
                };
                /**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */ var ClipboardActionCopy = function ClipboardActionCopy(target) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        container: document.body
                    };
                    var selectedText = "";
                    if (typeof target === "string") selectedText = fakeCopyAction(target, options);
                    else if (target instanceof HTMLInputElement && ![
                        "text",
                        "search",
                        "url",
                        "tel",
                        "password"
                    ].includes(target === null || target === void 0 ? void 0 : target.type)) // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
                    selectedText = fakeCopyAction(target.value, options);
                    else {
                        selectedText = select_default()(target);
                        command("copy");
                    }
                    return selectedText;
                };
                /* harmony default export */ var actions_copy = ClipboardActionCopy;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                /**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */ var ClipboardActionDefault = function ClipboardActionDefault() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    // Defines base properties passed from constructor.
                    var _options$action = options.action, action = _options$action === void 0 ? "copy" : _options$action, container = options.container, target = options.target, text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.
                    if (action !== "copy" && action !== "cut") throw new Error('Invalid "action" value, use either "copy" or "cut"');
                     // Sets the `target` property using an element that will be have its content copied.
                    if (target !== undefined) {
                        if (target && _typeof(target) === "object" && target.nodeType === 1) {
                            if (action === "copy" && target.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                            if (action === "cut" && (target.hasAttribute("readonly") || target.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        } else throw new Error('Invalid "target" value, use a valid Element');
                    } // Define selection strategy based on `text` property.
                    if (text) return actions_copy(text, {
                        container: container
                    });
                     // Defines which selection strategy based on `target` property.
                    if (target) return action === "cut" ? actions_cut(target) : actions_copy(target, {
                        container: container
                    });
                };
                /* harmony default export */ var actions_default = ClipboardActionDefault;
                function clipboard_typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") clipboard_typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else clipboard_typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return clipboard_typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */ function getAttributeValue(suffix, element) {
                    var attribute = "data-clipboard-".concat(suffix);
                    if (!element.hasAttribute(attribute)) return;
                    return element.getAttribute(attribute);
                }
                /**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */ var Clipboard = /*#__PURE__*/ function(_Emitter) {
                    _inherits(Clipboard, _Emitter);
                    var _super = _createSuper(Clipboard);
                    /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */ function Clipboard(trigger, options) {
                        var _this;
                        _classCallCheck(this, Clipboard);
                        _this = _super.call(this);
                        _this.resolveOptions(options);
                        _this.listenClick(trigger);
                        return _this;
                    }
                    /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */ _createClass(Clipboard, [
                        {
                            key: "resolveOptions",
                            value: function resolveOptions() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                this.action = typeof options.action === "function" ? options.action : this.defaultAction;
                                this.target = typeof options.target === "function" ? options.target : this.defaultTarget;
                                this.text = typeof options.text === "function" ? options.text : this.defaultText;
                                this.container = clipboard_typeof(options.container) === "object" ? options.container : document.body;
                            }
                        },
                        {
                            key: "listenClick",
                            value: function listenClick(trigger) {
                                var _this2 = this;
                                this.listener = listen_default()(trigger, "click", function(e) {
                                    return _this2.onClick(e);
                                });
                            }
                        },
                        {
                            key: "onClick",
                            value: function onClick(e) {
                                var trigger = e.delegateTarget || e.currentTarget;
                                var action = this.action(trigger) || "copy";
                                var text = actions_default({
                                    action: action,
                                    container: this.container,
                                    target: this.target(trigger),
                                    text: this.text(trigger)
                                }); // Fires an event based on the copy operation result.
                                this.emit(text ? "success" : "error", {
                                    action: action,
                                    text: text,
                                    trigger: trigger,
                                    clearSelection: function clearSelection() {
                                        if (trigger) trigger.focus();
                                        window.getSelection().removeAllRanges();
                                    }
                                });
                            }
                        },
                        {
                            key: "defaultAction",
                            value: function defaultAction(trigger) {
                                return getAttributeValue("action", trigger);
                            }
                        },
                        {
                            key: "defaultTarget",
                            value: function defaultTarget(trigger) {
                                var selector = getAttributeValue("target", trigger);
                                if (selector) return document.querySelector(selector);
                            }
                        },
                        {
                            key: "defaultText",
                            /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */ value: function defaultText(trigger) {
                                return getAttributeValue("text", trigger);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.listener.destroy();
                            }
                        }
                    ], [
                        {
                            key: "copy",
                            value: function copy(target) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                                    container: document.body
                                };
                                return actions_copy(target, options);
                            }
                        },
                        {
                            key: "cut",
                            value: function cut(target) {
                                return actions_cut(target);
                            }
                        },
                        {
                            key: "isSupported",
                            value: function isSupported() {
                                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                                    "copy",
                                    "cut"
                                ];
                                var actions = typeof action === "string" ? [
                                    action
                                ] : action;
                                var support = !!document.queryCommandSupported;
                                actions.forEach(function(action) {
                                    support = support && !!document.queryCommandSupported(action);
                                });
                                return support;
                            }
                        }
                    ]);
                    return Clipboard;
                }(tiny_emitter_default());
                /* harmony default export */ var clipboard = Clipboard;
            /***/ },
            /***/ 828: /***/ function(module1) {
                var DOCUMENT_NODE_TYPE = 9;
                /**
 * A polyfill for Element.matches()
 */ if (typeof Element !== "undefined" && !Element.prototype.matches) {
                    var proto = Element.prototype;
                    proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
                }
                /**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function closest(element, selector) {
                    while(element && element.nodeType !== DOCUMENT_NODE_TYPE){
                        if (typeof element.matches === "function" && element.matches(selector)) return element;
                        element = element.parentNode;
                    }
                }
                module1.exports = closest;
            /***/ },
            /***/ 438: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var closest = __webpack_require__(828);
                /**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function _delegate(element, selector, type, callback, useCapture) {
                    var listenerFn = listener.apply(this, arguments);
                    element.addEventListener(type, listenerFn, useCapture);
                    return {
                        destroy: function() {
                            element.removeEventListener(type, listenerFn, useCapture);
                        }
                    };
                }
                /**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function delegate(elements, selector, type, callback, useCapture) {
                    // Handle the regular Element usage
                    if (typeof elements.addEventListener === "function") return _delegate.apply(null, arguments);
                    // Handle Element-less usage, it defaults to global delegation
                    if (typeof type === "function") // Use `document` as the first parameter, then apply arguments
                    // This is a short way to .unshift `arguments` without running into deoptimizations
                    return _delegate.bind(null, document).apply(null, arguments);
                    // Handle Selector-based usage
                    if (typeof elements === "string") elements = document.querySelectorAll(elements);
                    // Handle Array-like based usage
                    return Array.prototype.map.call(elements, function(element) {
                        return _delegate(element, selector, type, callback, useCapture);
                    });
                }
                /**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function listener(element, selector, type, callback) {
                    return function(e) {
                        e.delegateTarget = closest(e.target, selector);
                        if (e.delegateTarget) callback.call(element, e);
                    };
                }
                module1.exports = delegate;
            /***/ },
            /***/ 879: /***/ function(__unused_webpack_module, exports) {
                /**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.node = function(value) {
                    return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
                };
                /**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.nodeList = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return value !== undefined && (type === "[object NodeList]" || type === "[object HTMLCollection]") && "length" in value && (value.length === 0 || exports.node(value[0]));
                };
                /**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.string = function(value) {
                    return typeof value === "string" || value instanceof String;
                };
                /**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.fn = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return type === "[object Function]";
                };
            /***/ },
            /***/ 370: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var is = __webpack_require__(879);
                var delegate = __webpack_require__(438);
                /**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listen(target, type, callback) {
                    if (!target && !type && !callback) throw new Error("Missing required arguments");
                    if (!is.string(type)) throw new TypeError("Second argument must be a String");
                    if (!is.fn(callback)) throw new TypeError("Third argument must be a Function");
                    if (is.node(target)) return listenNode(target, type, callback);
                    else if (is.nodeList(target)) return listenNodeList(target, type, callback);
                    else if (is.string(target)) return listenSelector(target, type, callback);
                    else throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
                }
                /**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNode(node, type, callback) {
                    node.addEventListener(type, callback);
                    return {
                        destroy: function() {
                            node.removeEventListener(type, callback);
                        }
                    };
                }
                /**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNodeList(nodeList, type, callback) {
                    Array.prototype.forEach.call(nodeList, function(node) {
                        node.addEventListener(type, callback);
                    });
                    return {
                        destroy: function() {
                            Array.prototype.forEach.call(nodeList, function(node) {
                                node.removeEventListener(type, callback);
                            });
                        }
                    };
                }
                /**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenSelector(selector, type, callback) {
                    return delegate(document.body, selector, type, callback);
                }
                module1.exports = listen;
            /***/ },
            /***/ 817: /***/ function(module1) {
                function select(element) {
                    var selectedText;
                    if (element.nodeName === "SELECT") {
                        element.focus();
                        selectedText = element.value;
                    } else if (element.nodeName === "INPUT" || element.nodeName === "TEXTAREA") {
                        var isReadOnly = element.hasAttribute("readonly");
                        if (!isReadOnly) element.setAttribute("readonly", "");
                        element.select();
                        element.setSelectionRange(0, element.value.length);
                        if (!isReadOnly) element.removeAttribute("readonly");
                        selectedText = element.value;
                    } else {
                        if (element.hasAttribute("contenteditable")) element.focus();
                        var selection = window.getSelection();
                        var range = document.createRange();
                        range.selectNodeContents(element);
                        selection.removeAllRanges();
                        selection.addRange(range);
                        selectedText = selection.toString();
                    }
                    return selectedText;
                }
                module1.exports = select;
            /***/ },
            /***/ 279: /***/ function(module1) {
                function E() {
                // Keep this empty so it's easier to inherit from
                // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
                }
                E.prototype = {
                    on: function(name, callback, ctx) {
                        var e = this.e || (this.e = {});
                        (e[name] || (e[name] = [])).push({
                            fn: callback,
                            ctx: ctx
                        });
                        return this;
                    },
                    once: function(name, callback, ctx) {
                        var self = this;
                        function listener() {
                            self.off(name, listener);
                            callback.apply(ctx, arguments);
                        }
                        listener._ = callback;
                        return this.on(name, listener, ctx);
                    },
                    emit: function(name) {
                        var data = [].slice.call(arguments, 1);
                        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
                        var i = 0;
                        var len = evtArr.length;
                        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
                        return this;
                    },
                    off: function(name, callback) {
                        var e = this.e || (this.e = {});
                        var evts = e[name];
                        var liveEvents = [];
                        if (evts && callback) {
                            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
                        }
                        // Remove event from queue to prevent memory leak
                        // Suggested by https://github.com/lazd
                        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
                        liveEvents.length ? e[name] = liveEvents : delete e[name];
                        return this;
                    }
                };
                module1.exports = E;
                module1.exports.TinyEmitter = E;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1["default"];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(686);
    /******/ }().default;
});

});



parcelRegister("igs1Y", function(module, exports) {

$parcel$export(module.exports, "render", () => $d4bf76f874d8ee4b$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
const $d4bf76f874d8ee4b$var$_hoisted_1 = {
    class: "preview-header"
};
const $d4bf76f874d8ee4b$var$_hoisted_2 = {
    class: "preview-header__name"
};
const $d4bf76f874d8ee4b$var$_hoisted_3 = [
    "value"
];
const $d4bf76f874d8ee4b$var$_hoisted_4 = {
    class: "page__edit-area"
};
const $d4bf76f874d8ee4b$var$_hoisted_5 = [
    "value"
];
const $d4bf76f874d8ee4b$var$_hoisted_6 = [
    "value"
];
const $d4bf76f874d8ee4b$var$_hoisted_7 = [
    "value"
];
const $d4bf76f874d8ee4b$var$_hoisted_8 = {
    class: "data-explorer"
};
function $d4bf76f874d8ee4b$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Btn = (0, $TusQn.resolveComponent)("Btn");
    const _component_Preview = (0, $TusQn.resolveComponent)("Preview");
    const _component_ColorChart = (0, $TusQn.resolveComponent)("ColorChart");
    const _component_CdxTab = (0, $TusQn.resolveComponent)("CdxTab");
    const _component_CdxTabs = (0, $TusQn.resolveComponent)("CdxTabs");
    const _component_JsonViewer = (0, $TusQn.resolveComponent)("JsonViewer");
    const _component_router_link = (0, $TusQn.resolveComponent)("router-link");
    const _component_Page = (0, $TusQn.resolveComponent)("Page");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_Page, {
        class: "page--new"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", null, [
                    (0, $TusQn.createElementVNode)("div", $d4bf76f874d8ee4b$var$_hoisted_1, [
                        _cache[6] || (_cache[6] = (0, $TusQn.createElementVNode)("label", null, "Preview of:", -1)),
                        (0, $TusQn.createElementVNode)("div", $d4bf76f874d8ee4b$var$_hoisted_2, [
                            (0, $TusQn.createElementVNode)("input", {
                                type: "text",
                                placeholder: "ENTER NAME OR CLICK THE DICE",
                                value: _ctx.skinname,
                                onInput: _cache[0] || (_cache[0] = (...args)=>$options.updateName && $options.updateName(...args))
                            }, null, 40, $d4bf76f874d8ee4b$var$_hoisted_3),
                            (0, $TusQn.createElementVNode)("button", {
                                class: "preview-header__name__random",
                                title: "Generate random name",
                                onClick: _cache[1] || (_cache[1] = (...args)=>$options.newName && $options.newName(...args))
                            }, " Change name ")
                        ]),
                        _cache[7] || (_cache[7] = (0, $TusQn.createElementVNode)("div", {
                            class: "preview-header__version-area"
                        }, [
                            (0, $TusQn.createElementVNode)("label", null, "Target version"),
                            (0, $TusQn.createTextVNode)(" 1.43 ")
                        ], -1)),
                        (0, $TusQn.createVNode)(_component_Btn, {
                            disabled: _ctx.skinname === "",
                            onClick: $options.download
                        }, {
                            default: (0, $TusQn.withCtx)(()=>_cache[5] || (_cache[5] = [
                                    (0, $TusQn.createTextVNode)(" Download ")
                                ])),
                            _: 1
                        }, 8, [
                            "disabled",
                            "onClick"
                        ])
                    ]),
                    (0, $TusQn.createVNode)(_component_Preview, {
                        html: _ctx.html,
                        name: _ctx.skinname,
                        "anon-default": _ctx.anon,
                        "show-anon": true,
                        onChangeArticle: $options.changeArticle,
                        onChangeAnon: $options.changeAnon
                    }, null, 8, [
                        "html",
                        "name",
                        "anon-default",
                        "onChangeArticle",
                        "onChangeAnon"
                    ]),
                    (0, $TusQn.createElementVNode)("div", $d4bf76f874d8ee4b$var$_hoisted_4, [
                        (0, $TusQn.createVNode)(_component_CdxTabs, null, {
                            default: (0, $TusQn.withCtx)(()=>[
                                    ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)(_ctx.tabsData, (tab, index)=>{
                                        return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_CdxTab, {
                                            key: index,
                                            name: tab.name,
                                            label: tab.label
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    tab.name === "html" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("textarea", {
                                                        key: 0,
                                                        class: "editor-textarea",
                                                        value: _ctx.mustache,
                                                        onInput: _cache[2] || (_cache[2] = (...args)=>$options.updateMustache && $options.updateMustache(...args))
                                                    }, null, 40, $d4bf76f874d8ee4b$var$_hoisted_5)) : (0, $TusQn.createCommentVNode)("", true),
                                                    tab.name === "css" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                                        key: 1
                                                    }, [
                                                        (0, $TusQn.createElementVNode)("textarea", {
                                                            class: "editor-textarea",
                                                            value: _ctx.less,
                                                            onInput: _cache[3] || (_cache[3] = (...args)=>$options.updateCSS && $options.updateCSS(...args))
                                                        }, null, 40, $d4bf76f874d8ee4b$var$_hoisted_6),
                                                        (0, $TusQn.createVNode)(_component_Btn, {
                                                            class: "css-theme-changer",
                                                            onClick: $options.newTheme
                                                        }, {
                                                            default: (0, $TusQn.withCtx)(()=>_cache[8] || (_cache[8] = [
                                                                    (0, $TusQn.createTextVNode)(" Change theme ")
                                                                ])),
                                                            _: 1
                                                        }, 8, [
                                                            "onClick"
                                                        ]),
                                                        (0, $TusQn.createVNode)(_component_ColorChart, {
                                                            colors: $options.colorChart,
                                                            onToggleColor: $options.toggleColor
                                                        }, null, 8, [
                                                            "colors",
                                                            "onToggleColor"
                                                        ])
                                                    ], 64)) : (0, $TusQn.createCommentVNode)("", true),
                                                    tab.name === "js" ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("textarea", {
                                                        key: 2,
                                                        class: "editor-textarea",
                                                        value: _ctx.js,
                                                        onInput: _cache[4] || (_cache[4] = (...args)=>$options.updateJS && $options.updateJS(...args))
                                                    }, null, 40, $d4bf76f874d8ee4b$var$_hoisted_7)) : (0, $TusQn.createCommentVNode)("", true)
                                                ]),
                                            _: 2
                                        }, 1032, [
                                            "name",
                                            "label"
                                        ]);
                                    }), 128))
                                ]),
                            _: 1
                        }),
                        (0, $TusQn.createVNode)(_component_Btn, {
                            class: "reset-btn",
                            destructive: true,
                            onClick: $options.reset
                        }, {
                            default: (0, $TusQn.withCtx)(()=>_cache[9] || (_cache[9] = [
                                    (0, $TusQn.createTextVNode)(" Reset ")
                                ])),
                            _: 1
                        }, 8, [
                            "onClick"
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("div", $d4bf76f874d8ee4b$var$_hoisted_8, [
                        _cache[10] || (_cache[10] = (0, $TusQn.createElementVNode)("h2", null, "Template data", -1)),
                        _cache[11] || (_cache[11] = (0, $TusQn.createElementVNode)("p", null, "Explore the data you can render in your skin here.", -1)),
                        (0, $TusQn.createVNode)(_component_JsonViewer, {
                            value: _ctx.json,
                            boxed: true,
                            expanded: false,
                            sort: true,
                            copyable: true
                        }, null, 8, [
                            "value"
                        ])
                    ]),
                    (0, $TusQn.createElementVNode)("p", null, [
                        _cache[13] || (_cache[13] = (0, $TusQn.createTextVNode)(" Making an extension? Try the ")),
                        (0, $TusQn.createVNode)(_component_router_link, {
                            to: "build/extension"
                        }, {
                            default: (0, $TusQn.withCtx)(()=>_cache[12] || (_cache[12] = [
                                    (0, $TusQn.createTextVNode)(" extension builder ")
                                ])),
                            _: 1
                        }),
                        _cache[14] || (_cache[14] = (0, $TusQn.createTextVNode)("! "))
                    ]),
                    _cache[15] || (_cache[15] = (0, $TusQn.createElementVNode)("p", null, [
                        (0, $TusQn.createTextVNode)(" You can now also create skins from the "),
                        (0, $TusQn.createElementVNode)("a", {
                            href: "https://github.com/wikimedia/mediawiki-skins-cli#readme"
                        }, "command line")
                    ], -1))
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("k983i", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaaae4e4d4a51418$export$2e2bcd8739ae039);
let $eaaae4e4d4a51418$var$NOOP = ()=>{};
var $eaaae4e4d4a51418$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("cZF80", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $975b15b717bffc10$export$2e2bcd8739ae039);
/* eslint-disable vue/no-undef-properties */ 
var $ajjle = parcelRequire("ajjle");

var $2s757 = parcelRequire("2s757");

var $eZefG = parcelRequire("eZefG");

var $cPwQq = parcelRequire("cPwQq");
const $975b15b717bffc10$var$LS_NAMESPACE = "ext-builder";
const $975b15b717bffc10$var$DEFAULTS = {
    hookSkinAfterPortlet: false,
    name: ""
};
var $975b15b717bffc10$export$2e2bcd8739ae039 = {
    name: "BuildExtensions",
    components: {
        Page: $ajjle.default,
        Btn: $2s757.default
    },
    data () {
        return (0, $cPwQq.getCachedProperties)("ext-builder", $975b15b717bffc10$var$DEFAULTS);
    },
    methods: {
        newExtension () {
            (0, $eZefG.buildExtension)(this.name, {
                hooks: {
                    SkinAfterPortlet: this.hookSkinAfterPortlet
                }
            });
        }
    },
    updated () {
        Object.keys($975b15b717bffc10$var$DEFAULTS).forEach((key)=>{
            (0, $cPwQq.setCachedProperty)($975b15b717bffc10$var$LS_NAMESPACE, key, this[key]);
        });
    }
};

});
parcelRegister("cPwQq", function(module, exports) {

$parcel$export(module.exports, "getCachedProperties", () => $9573b9b960bba1e1$export$484b1bb775b81d4e);
$parcel$export(module.exports, "setCachedProperty", () => $9573b9b960bba1e1$export$c51961a7aea6c211);
/**
 * @param {string} namespace
 * @param {Object} defaults
 * @return {Object}
 */ function $9573b9b960bba1e1$export$484b1bb775b81d4e(namespace, defaults) {
    const props = {};
    Object.keys(defaults).forEach((key)=>{
        let val = localStorage.getItem(`${namespace}-${key}`);
        if (val === "true") val = true;
        else if (val === "false") val = false;
        else if (val !== null) {
            if (val.indexOf("{") === 0) try {
                val = JSON.parse(val);
            } catch (e) {
                val = defaults[key];
            }
        } else val = defaults[key];
        props[key] = val;
    });
    return props;
}
/**
 * @param {string} namespace
 * @param {Object} defaults
 * @param {Function} callback
 */ function $9573b9b960bba1e1$export$10ca6f513874bdda(namespace, defaults, callback) {
    Object.keys(defaults).forEach((key)=>{
        localStorage.removeItem(`${namespace}-${key}`);
        callback(key);
    });
}
/**
 * @param {string} namespace
 * @param {string} key
 * @param {string|Object} value
 */ function $9573b9b960bba1e1$export$c51961a7aea6c211(namespace, key, value) {
    const valueToSave = typeof value === "object" ? JSON.stringify(value) : value;
    localStorage.setItem(`${namespace}-${key}`, valueToSave);
}

});


parcelRegister("jpnZB", function(module, exports) {

$parcel$export(module.exports, "render", () => $e212f68a9676f160$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
function $e212f68a9676f160$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Btn = (0, $TusQn.resolveComponent)("Btn");
    const _component_Page = (0, $TusQn.resolveComponent)("Page");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_Page, {
        class: "page--new"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                _cache[5] || (_cache[5] = (0, $TusQn.createElementVNode)("h1", null, "Extension builder", -1)),
                _cache[6] || (_cache[6] = (0, $TusQn.createElementVNode)("p", null, "Let's build an extension!", -1)),
                (0, $TusQn.createElementVNode)("form", null, [
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.name = $event),
                        placeholder: "Extension name"
                    }, null, 512), [
                        [
                            (0, $eeJ70.vModelText),
                            _ctx.name
                        ]
                    ]),
                    _cache[4] || (_cache[4] = (0, $TusQn.createElementVNode)("h2", null, "Hooks", -1)),
                    (0, $TusQn.createElementVNode)("p", null, [
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>_ctx.hookSkinAfterPortlet = $event),
                            type: "checkbox",
                            name: "hookSkinAfterPortlet"
                        }, null, 512), [
                            [
                                (0, $eeJ70.vModelCheckbox),
                                _ctx.hookSkinAfterPortlet
                            ]
                        ]),
                        _cache[2] || (_cache[2] = (0, $TusQn.createElementVNode)("label", null, "SkinAfterPortlet: Add HTML after a portlet.", -1))
                    ]),
                    (0, $TusQn.createVNode)(_component_Btn, {
                        disabled: !_ctx.name,
                        onClick: $options.newExtension
                    }, {
                        default: (0, $TusQn.withCtx)(()=>_cache[3] || (_cache[3] = [
                                (0, $TusQn.createTextVNode)(" Build ")
                            ])),
                        _: 1
                    }, 8, [
                        "disabled",
                        "onClick"
                    ])
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("84mSi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e0070eac9136db8$export$2e2bcd8739ae039);
let $5e0070eac9136db8$var$NOOP = ()=>{};
var $5e0070eac9136db8$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("ecd4d");
var $eeJ70 = parcelRequire("eeJ70");

var $73mM4 = parcelRequire("73mM4");
let $ae3de8900c09c2f9$var$script;




let $ae3de8900c09c2f9$var$initialize = ()=>{
    $ae3de8900c09c2f9$var$script = (parcelRequire("boZNq"));
    if ($ae3de8900c09c2f9$var$script.__esModule) $ae3de8900c09c2f9$var$script = $ae3de8900c09c2f9$var$script.default;
    $ae3de8900c09c2f9$var$script.render = (parcelRequire("3NNX1")).render;
    $ae3de8900c09c2f9$var$script.__cssModules = {};
    (parcelRequire("1rrBo")).default($ae3de8900c09c2f9$var$script);
    $ae3de8900c09c2f9$var$script.__scopeId = "data-v-dc6221";
    $ae3de8900c09c2f9$var$script.__file = "App.vue";
};
$ae3de8900c09c2f9$var$initialize();
var $ae3de8900c09c2f9$export$2e2bcd8739ae039 = $ae3de8900c09c2f9$var$script;


let $83687545834d8a2c$var$script;




let $83687545834d8a2c$var$initialize = ()=>{
    $83687545834d8a2c$var$script = (parcelRequire("96vUA"));
    if ($83687545834d8a2c$var$script.__esModule) $83687545834d8a2c$var$script = $83687545834d8a2c$var$script.default;
    $83687545834d8a2c$var$script.render = (parcelRequire("dYItq")).render;
    $83687545834d8a2c$var$script.__cssModules = {};
    (parcelRequire("577Tp")).default($83687545834d8a2c$var$script);
    $83687545834d8a2c$var$script.__scopeId = "data-v-d475ff";
    $83687545834d8a2c$var$script.__file = "HomePage.vue";
};
$83687545834d8a2c$var$initialize();
var $83687545834d8a2c$export$2e2bcd8739ae039 = $83687545834d8a2c$var$script;


let $9454dc0ee72066b7$var$script;




let $9454dc0ee72066b7$var$initialize = ()=>{
    $9454dc0ee72066b7$var$script = (parcelRequire("1BvCm"));
    if ($9454dc0ee72066b7$var$script.__esModule) $9454dc0ee72066b7$var$script = $9454dc0ee72066b7$var$script.default;
    $9454dc0ee72066b7$var$script.render = (parcelRequire("jA4pj")).render;
    $9454dc0ee72066b7$var$script.__cssModules = {};
    (parcelRequire("c1JPG")).default($9454dc0ee72066b7$var$script);
    $9454dc0ee72066b7$var$script.__scopeId = "data-v-f02c62";
    $9454dc0ee72066b7$var$script.__file = "Explore.vue";
};
$9454dc0ee72066b7$var$initialize();
var $9454dc0ee72066b7$export$2e2bcd8739ae039 = $9454dc0ee72066b7$var$script;


let $fed6b6a6412385d9$var$script;




let $fed6b6a6412385d9$var$initialize = ()=>{
    $fed6b6a6412385d9$var$script = (parcelRequire("brdT8"));
    if ($fed6b6a6412385d9$var$script.__esModule) $fed6b6a6412385d9$var$script = $fed6b6a6412385d9$var$script.default;
    $fed6b6a6412385d9$var$script.render = (parcelRequire("jr1Yt")).render;
    $fed6b6a6412385d9$var$script.__cssModules = {};
    (parcelRequire("gMD6i")).default($fed6b6a6412385d9$var$script);
    $fed6b6a6412385d9$var$script.__scopeId = "data-v-99d1e9";
    $fed6b6a6412385d9$var$script.__file = "Skin.vue";
};
$fed6b6a6412385d9$var$initialize();
var $fed6b6a6412385d9$export$2e2bcd8739ae039 = $fed6b6a6412385d9$var$script;


let $ff75756085a18a57$var$script;




let $ff75756085a18a57$var$initialize = ()=>{
    $ff75756085a18a57$var$script = (parcelRequire("a5F10"));
    if ($ff75756085a18a57$var$script.__esModule) $ff75756085a18a57$var$script = $ff75756085a18a57$var$script.default;
    $ff75756085a18a57$var$script.render = (parcelRequire("at2xZ")).render;
    $ff75756085a18a57$var$script.__cssModules = {};
    (parcelRequire("iFUMc")).default($ff75756085a18a57$var$script);
    $ff75756085a18a57$var$script.__scopeId = "data-v-9c05c5";
    $ff75756085a18a57$var$script.__file = "NotFound.vue";
};
$ff75756085a18a57$var$initialize();
var $ff75756085a18a57$export$2e2bcd8739ae039 = $ff75756085a18a57$var$script;


let $aa6e4ba8e1aec433$var$script;




let $aa6e4ba8e1aec433$var$initialize = ()=>{
    $aa6e4ba8e1aec433$var$script = (parcelRequire("aTkuF"));
    if ($aa6e4ba8e1aec433$var$script.__esModule) $aa6e4ba8e1aec433$var$script = $aa6e4ba8e1aec433$var$script.default;
    $aa6e4ba8e1aec433$var$script.render = (parcelRequire("igs1Y")).render;
    $aa6e4ba8e1aec433$var$script.__cssModules = {};
    (parcelRequire("k983i")).default($aa6e4ba8e1aec433$var$script);
    $aa6e4ba8e1aec433$var$script.__scopeId = "data-v-da576d";
    $aa6e4ba8e1aec433$var$script.__file = "Add.vue";
};
$aa6e4ba8e1aec433$var$initialize();
var $aa6e4ba8e1aec433$export$2e2bcd8739ae039 = $aa6e4ba8e1aec433$var$script;


let $285428db371463a0$var$script;



let $285428db371463a0$var$initialize = ()=>{
    $285428db371463a0$var$script = (parcelRequire("cZF80"));
    if ($285428db371463a0$var$script.__esModule) $285428db371463a0$var$script = $285428db371463a0$var$script.default;
    $285428db371463a0$var$script.render = (parcelRequire("jpnZB")).render;
    (parcelRequire("84mSi")).default($285428db371463a0$var$script);
    $285428db371463a0$var$script.__scopeId = "data-v-61c7ed";
    $285428db371463a0$var$script.__file = "BuildExtension.vue";
};
$285428db371463a0$var$initialize();
var $285428db371463a0$export$2e2bcd8739ae039 = $285428db371463a0$var$script;


var $8b488dbcce1c14ef$export$2e2bcd8739ae039 = [
    {
        path: "/",
        name: "home",
        component: (0, $83687545834d8a2c$export$2e2bcd8739ae039)
    },
    {
        path: "/build/extension",
        name: "build-extension",
        component: (0, $285428db371463a0$export$2e2bcd8739ae039)
    },
    {
        path: "/explore/:filter?",
        name: "explore",
        component: (0, $9454dc0ee72066b7$export$2e2bcd8739ae039)
    },
    {
        path: "/add",
        name: "build-skin",
        component: (0, $aa6e4ba8e1aec433$export$2e2bcd8739ae039)
    },
    {
        path: "/skin/:key",
        name: "view-skin",
        component: (0, $fed6b6a6412385d9$export$2e2bcd8739ae039)
    },
    {
        path: "/:pathMatch(.*)",
        name: "bad-not-found",
        component: (0, $ff75756085a18a57$export$2e2bcd8739ae039)
    }
];


const $2b6e161c9edcf319$var$router = (0, $73mM4.createRouter)({
    history: (0, $73mM4.createWebHashHistory)(),
    routes: $8b488dbcce1c14ef$export$2e2bcd8739ae039
});
const $2b6e161c9edcf319$var$app = (0, $eeJ70.createApp)((0, $ae3de8900c09c2f9$export$2e2bcd8739ae039));
$2b6e161c9edcf319$var$app.use($2b6e161c9edcf319$var$router);
$2b6e161c9edcf319$var$app.directive("focus", {
    // When the bound element is inserted into the DOM...
    inserted: function(el) {
        // Focus the element
        el.focus();
    }
});
const $2b6e161c9edcf319$var$fragment = document.createDocumentFragment();
$2b6e161c9edcf319$var$app.mount($2b6e161c9edcf319$var$fragment);
const $2b6e161c9edcf319$var$appNode = document.querySelector("#app");
$2b6e161c9edcf319$var$appNode.parentNode.replaceChild($2b6e161c9edcf319$var$fragment, $2b6e161c9edcf319$var$appNode);


//# sourceMappingURL=index.e2ccdae6.js.map
